var Sq = Object.defineProperty;
var Cq = (e, t, n) => t in e ? Sq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var FP = (e, t, n) => Cq(e, typeof t != "symbol" ? t + "" : t, n);
import wq, { jsx as I, jsxs as qe, Fragment as Po } from "react/jsx-runtime";
import * as D from "react";
import oe, { createContext as GV, forwardRef as ft, useContext as xw, createElement as KV, useRef as l0, useLayoutEffect as Gf, Children as Tq, isValidElement as Cb, cloneElement as w1, useMemo as ud, useState as Kf, useEffect as Lb, useCallback as Z2, PureComponent as c0, Component as gv, createRef as Eq } from "react";
function Pa(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function O() {
  return O = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, O.apply(null, arguments);
}
const Rq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get default() {
    return O;
  }
}, Symbol.toStringTag, { value: "Module" }));
function od(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function XV(e) {
  if (!od(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = XV(e[n]);
  }), t;
}
function ai(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? O({}, e) : e;
  return od(e) && od(t) && Object.keys(t).forEach((s) => {
    od(t[s]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, s) && od(e[s]) ? o[s] = ai(e[s], t[s], n) : n.clone ? o[s] = od(t[s]) ? XV(t[s]) : t[s] : o[s] = t[s];
  }), o;
}
var Ll = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vd(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function o() {
      return this instanceof o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var s = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(n, o, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), n;
}
var D$ = { exports: {} }, ZC = { exports: {} }, Fn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eA;
function Oq() {
  if (eA) return Fn;
  eA = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function L(N) {
    if (typeof N == "object" && N !== null) {
      var V = N.$$typeof;
      switch (V) {
        case t:
          switch (N = N.type, N) {
            case h:
            case m:
            case o:
            case l:
            case s:
            case x:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case p:
                case b:
                case T:
                case R:
                case u:
                  return N;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function F(N) {
    return L(N) === m;
  }
  return Fn.AsyncMode = h, Fn.ConcurrentMode = m, Fn.ContextConsumer = p, Fn.ContextProvider = u, Fn.Element = t, Fn.ForwardRef = b, Fn.Fragment = o, Fn.Lazy = T, Fn.Memo = R, Fn.Portal = n, Fn.Profiler = l, Fn.StrictMode = s, Fn.Suspense = x, Fn.isAsyncMode = function(N) {
    return F(N) || L(N) === h;
  }, Fn.isConcurrentMode = F, Fn.isContextConsumer = function(N) {
    return L(N) === p;
  }, Fn.isContextProvider = function(N) {
    return L(N) === u;
  }, Fn.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === t;
  }, Fn.isForwardRef = function(N) {
    return L(N) === b;
  }, Fn.isFragment = function(N) {
    return L(N) === o;
  }, Fn.isLazy = function(N) {
    return L(N) === T;
  }, Fn.isMemo = function(N) {
    return L(N) === R;
  }, Fn.isPortal = function(N) {
    return L(N) === n;
  }, Fn.isProfiler = function(N) {
    return L(N) === l;
  }, Fn.isStrictMode = function(N) {
    return L(N) === s;
  }, Fn.isSuspense = function(N) {
    return L(N) === x;
  }, Fn.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === o || N === m || N === l || N === s || N === x || N === S || typeof N == "object" && N !== null && (N.$$typeof === T || N.$$typeof === R || N.$$typeof === u || N.$$typeof === p || N.$$typeof === b || N.$$typeof === P || N.$$typeof === k || N.$$typeof === _ || N.$$typeof === E);
  }, Fn.typeOf = L, Fn;
}
var jn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tA;
function Pq() {
  return tA || (tA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function L(ie) {
      return typeof ie == "string" || typeof ie == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ie === o || ie === m || ie === l || ie === s || ie === x || ie === S || typeof ie == "object" && ie !== null && (ie.$$typeof === T || ie.$$typeof === R || ie.$$typeof === u || ie.$$typeof === p || ie.$$typeof === b || ie.$$typeof === P || ie.$$typeof === k || ie.$$typeof === _ || ie.$$typeof === E);
    }
    function F(ie) {
      if (typeof ie == "object" && ie !== null) {
        var fe = ie.$$typeof;
        switch (fe) {
          case t:
            var ye = ie.type;
            switch (ye) {
              case h:
              case m:
              case o:
              case l:
              case s:
              case x:
                return ye;
              default:
                var Ee = ye && ye.$$typeof;
                switch (Ee) {
                  case p:
                  case b:
                  case T:
                  case R:
                  case u:
                    return Ee;
                  default:
                    return fe;
                }
            }
          case n:
            return fe;
        }
      }
    }
    var N = h, V = m, z = p, H = u, ee = t, K = b, X = o, ne = T, Y = R, J = n, te = l, Z = s, ae = x, U = !1;
    function G(ie) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(ie) || F(ie) === h;
    }
    function W(ie) {
      return F(ie) === m;
    }
    function le(ie) {
      return F(ie) === p;
    }
    function pe(ie) {
      return F(ie) === u;
    }
    function ge(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === t;
    }
    function we(ie) {
      return F(ie) === b;
    }
    function de(ie) {
      return F(ie) === o;
    }
    function se(ie) {
      return F(ie) === T;
    }
    function ve(ie) {
      return F(ie) === R;
    }
    function me(ie) {
      return F(ie) === n;
    }
    function Oe(ie) {
      return F(ie) === l;
    }
    function be(ie) {
      return F(ie) === s;
    }
    function De(ie) {
      return F(ie) === x;
    }
    jn.AsyncMode = N, jn.ConcurrentMode = V, jn.ContextConsumer = z, jn.ContextProvider = H, jn.Element = ee, jn.ForwardRef = K, jn.Fragment = X, jn.Lazy = ne, jn.Memo = Y, jn.Portal = J, jn.Profiler = te, jn.StrictMode = Z, jn.Suspense = ae, jn.isAsyncMode = G, jn.isConcurrentMode = W, jn.isContextConsumer = le, jn.isContextProvider = pe, jn.isElement = ge, jn.isForwardRef = we, jn.isFragment = de, jn.isLazy = se, jn.isMemo = ve, jn.isPortal = me, jn.isProfiler = Oe, jn.isStrictMode = be, jn.isSuspense = De, jn.isValidElementType = L, jn.typeOf = F;
  }()), jn;
}
var nA;
function QV() {
  return nA || (nA = 1, process.env.NODE_ENV === "production" ? ZC.exports = Oq() : ZC.exports = Pq()), ZC.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var jP, rA;
function $q() {
  if (rA) return jP;
  rA = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var u = {}, p = 0; p < 10; p++)
        u["_" + String.fromCharCode(p)] = p;
      var h = Object.getOwnPropertyNames(u).map(function(b) {
        return u[b];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        m[b] = b;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return jP = s() ? Object.assign : function(l, u) {
    for (var p, h = o(l), m, b = 1; b < arguments.length; b++) {
      p = Object(arguments[b]);
      for (var x in p)
        t.call(p, x) && (h[x] = p[x]);
      if (e) {
        m = e(p);
        for (var S = 0; S < m.length; S++)
          n.call(p, m[S]) && (h[m[S]] = p[m[S]]);
      }
    }
    return h;
  }, jP;
}
var VP, oA;
function xD() {
  if (oA) return VP;
  oA = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return VP = e, VP;
}
var BP, aA;
function JV() {
  return aA || (aA = 1, BP = Function.call.bind(Object.prototype.hasOwnProperty)), BP;
}
var zP, iA;
function Dq() {
  if (iA) return zP;
  iA = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = xD(), n = {}, o = JV();
    e = function(l) {
      var u = "Warning: " + l;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function s(l, u, p, h, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in l)
        if (o(l, b)) {
          var x;
          try {
            if (typeof l[b] != "function") {
              var S = Error(
                (h || "React class") + ": " + p + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            x = l[b](u, b, h, p, null, t);
          } catch (T) {
            x = T;
          }
          if (x && !(x instanceof Error) && e(
            (h || "React class") + ": type specification of " + p + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in n)) {
            n[x.message] = !0;
            var R = m ? m() : "";
            e(
              "Failed " + p + " type: " + x.message + (R ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, zP = s, zP;
}
var UP, sA;
function kq() {
  if (sA) return UP;
  sA = 1;
  var e = QV(), t = $q(), n = xD(), o = JV(), s = Dq(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(p) {
    var h = "Warning: " + p;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return UP = function(p, h) {
    var m = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function x(W) {
      var le = W && (m && W[m] || W[b]);
      if (typeof le == "function")
        return le;
    }
    var S = "<<anonymous>>", R = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: _(),
      arrayOf: L,
      element: F(),
      elementType: N(),
      instanceOf: V,
      node: K(),
      objectOf: H,
      oneOf: z,
      oneOfType: ee,
      shape: ne,
      exact: Y
    };
    function T(W, le) {
      return W === le ? W !== 0 || 1 / W === 1 / le : W !== W && le !== le;
    }
    function E(W, le) {
      this.message = W, this.data = le && typeof le == "object" ? le : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function P(W) {
      if (process.env.NODE_ENV !== "production")
        var le = {}, pe = 0;
      function ge(de, se, ve, me, Oe, be, De) {
        if (me = me || S, be = be || ve, De !== n) {
          if (h) {
            var ie = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ie.name = "Invariant Violation", ie;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = me + ":" + ve;
            !le[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            pe < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + be + "` prop on `" + me + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), le[fe] = !0, pe++);
          }
        }
        return se[ve] == null ? de ? se[ve] === null ? new E("The " + Oe + " `" + be + "` is marked as required " + ("in `" + me + "`, but its value is `null`.")) : new E("The " + Oe + " `" + be + "` is marked as required in " + ("`" + me + "`, but its value is `undefined`.")) : null : W(se, ve, me, Oe, be);
      }
      var we = ge.bind(null, !1);
      return we.isRequired = ge.bind(null, !0), we;
    }
    function k(W) {
      function le(pe, ge, we, de, se, ve) {
        var me = pe[ge], Oe = Z(me);
        if (Oe !== W) {
          var be = ae(me);
          return new E(
            "Invalid " + de + " `" + se + "` of type " + ("`" + be + "` supplied to `" + we + "`, expected ") + ("`" + W + "`."),
            { expectedType: W }
          );
        }
        return null;
      }
      return P(le);
    }
    function _() {
      return P(u);
    }
    function L(W) {
      function le(pe, ge, we, de, se) {
        if (typeof W != "function")
          return new E("Property `" + se + "` of component `" + we + "` has invalid PropType notation inside arrayOf.");
        var ve = pe[ge];
        if (!Array.isArray(ve)) {
          var me = Z(ve);
          return new E("Invalid " + de + " `" + se + "` of type " + ("`" + me + "` supplied to `" + we + "`, expected an array."));
        }
        for (var Oe = 0; Oe < ve.length; Oe++) {
          var be = W(ve, Oe, we, de, se + "[" + Oe + "]", n);
          if (be instanceof Error)
            return be;
        }
        return null;
      }
      return P(le);
    }
    function F() {
      function W(le, pe, ge, we, de) {
        var se = le[pe];
        if (!p(se)) {
          var ve = Z(se);
          return new E("Invalid " + we + " `" + de + "` of type " + ("`" + ve + "` supplied to `" + ge + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(W);
    }
    function N() {
      function W(le, pe, ge, we, de) {
        var se = le[pe];
        if (!e.isValidElementType(se)) {
          var ve = Z(se);
          return new E("Invalid " + we + " `" + de + "` of type " + ("`" + ve + "` supplied to `" + ge + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(W);
    }
    function V(W) {
      function le(pe, ge, we, de, se) {
        if (!(pe[ge] instanceof W)) {
          var ve = W.name || S, me = G(pe[ge]);
          return new E("Invalid " + de + " `" + se + "` of type " + ("`" + me + "` supplied to `" + we + "`, expected ") + ("instance of `" + ve + "`."));
        }
        return null;
      }
      return P(le);
    }
    function z(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), u;
      function le(pe, ge, we, de, se) {
        for (var ve = pe[ge], me = 0; me < W.length; me++)
          if (T(ve, W[me]))
            return null;
        var Oe = JSON.stringify(W, function(De, ie) {
          var fe = ae(ie);
          return fe === "symbol" ? String(ie) : ie;
        });
        return new E("Invalid " + de + " `" + se + "` of value `" + String(ve) + "` " + ("supplied to `" + we + "`, expected one of " + Oe + "."));
      }
      return P(le);
    }
    function H(W) {
      function le(pe, ge, we, de, se) {
        if (typeof W != "function")
          return new E("Property `" + se + "` of component `" + we + "` has invalid PropType notation inside objectOf.");
        var ve = pe[ge], me = Z(ve);
        if (me !== "object")
          return new E("Invalid " + de + " `" + se + "` of type " + ("`" + me + "` supplied to `" + we + "`, expected an object."));
        for (var Oe in ve)
          if (o(ve, Oe)) {
            var be = W(ve, Oe, we, de, se + "." + Oe, n);
            if (be instanceof Error)
              return be;
          }
        return null;
      }
      return P(le);
    }
    function ee(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var le = 0; le < W.length; le++) {
        var pe = W[le];
        if (typeof pe != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + U(pe) + " at index " + le + "."
          ), u;
      }
      function ge(we, de, se, ve, me) {
        for (var Oe = [], be = 0; be < W.length; be++) {
          var De = W[be], ie = De(we, de, se, ve, me, n);
          if (ie == null)
            return null;
          ie.data && o(ie.data, "expectedType") && Oe.push(ie.data.expectedType);
        }
        var fe = Oe.length > 0 ? ", expected one of type [" + Oe.join(", ") + "]" : "";
        return new E("Invalid " + ve + " `" + me + "` supplied to " + ("`" + se + "`" + fe + "."));
      }
      return P(ge);
    }
    function K() {
      function W(le, pe, ge, we, de) {
        return J(le[pe]) ? null : new E("Invalid " + we + " `" + de + "` supplied to " + ("`" + ge + "`, expected a ReactNode."));
      }
      return P(W);
    }
    function X(W, le, pe, ge, we) {
      return new E(
        (W || "React class") + ": " + le + " type `" + pe + "." + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + we + "`."
      );
    }
    function ne(W) {
      function le(pe, ge, we, de, se) {
        var ve = pe[ge], me = Z(ve);
        if (me !== "object")
          return new E("Invalid " + de + " `" + se + "` of type `" + me + "` " + ("supplied to `" + we + "`, expected `object`."));
        for (var Oe in W) {
          var be = W[Oe];
          if (typeof be != "function")
            return X(we, de, se, Oe, ae(be));
          var De = be(ve, Oe, we, de, se + "." + Oe, n);
          if (De)
            return De;
        }
        return null;
      }
      return P(le);
    }
    function Y(W) {
      function le(pe, ge, we, de, se) {
        var ve = pe[ge], me = Z(ve);
        if (me !== "object")
          return new E("Invalid " + de + " `" + se + "` of type `" + me + "` " + ("supplied to `" + we + "`, expected `object`."));
        var Oe = t({}, pe[ge], W);
        for (var be in Oe) {
          var De = W[be];
          if (o(W, be) && typeof De != "function")
            return X(we, de, se, be, ae(De));
          if (!De)
            return new E(
              "Invalid " + de + " `" + se + "` key `" + be + "` supplied to `" + we + "`.\nBad object: " + JSON.stringify(pe[ge], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(W), null, "  ")
            );
          var ie = De(ve, be, we, de, se + "." + be, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return P(le);
    }
    function J(W) {
      switch (typeof W) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !W;
        case "object":
          if (Array.isArray(W))
            return W.every(J);
          if (W === null || p(W))
            return !0;
          var le = x(W);
          if (le) {
            var pe = le.call(W), ge;
            if (le !== W.entries) {
              for (; !(ge = pe.next()).done; )
                if (!J(ge.value))
                  return !1;
            } else
              for (; !(ge = pe.next()).done; ) {
                var we = ge.value;
                if (we && !J(we[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function te(W, le) {
      return W === "symbol" ? !0 : le ? le["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && le instanceof Symbol : !1;
    }
    function Z(W) {
      var le = typeof W;
      return Array.isArray(W) ? "array" : W instanceof RegExp ? "object" : te(le, W) ? "symbol" : le;
    }
    function ae(W) {
      if (typeof W > "u" || W === null)
        return "" + W;
      var le = Z(W);
      if (le === "object") {
        if (W instanceof Date)
          return "date";
        if (W instanceof RegExp)
          return "regexp";
      }
      return le;
    }
    function U(W) {
      var le = ae(W);
      switch (le) {
        case "array":
        case "object":
          return "an " + le;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + le;
        default:
          return le;
      }
    }
    function G(W) {
      return !W.constructor || !W.constructor.name ? S : W.constructor.name;
    }
    return R.checkPropTypes = s, R.resetWarningCache = s.resetWarningCache, R.PropTypes = R, R;
  }, UP;
}
var HP, lA;
function Mq() {
  if (lA) return HP;
  lA = 1;
  var e = xD();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, HP = function() {
    function o(u, p, h, m, b, x) {
      if (x !== e) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    o.isRequired = o;
    function s() {
      return o;
    }
    var l = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: s,
      element: o,
      elementType: o,
      instanceOf: s,
      node: o,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return l.PropTypes = l, l;
  }, HP;
}
if (process.env.NODE_ENV !== "production") {
  var Nq = QV(), Iq = !0;
  D$.exports = kq()(Nq.isElement, Iq);
} else
  D$.exports = Mq()();
var _q = D$.exports;
const r = /* @__PURE__ */ qc(_q);
function Aq(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function ZV(e, t, n, o, s) {
  const l = e[t], u = s || t;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let p;
  const h = l.type;
  return typeof h == "function" && !Aq(h) && (p = "Did you accidentally use a plain function component for an element instead?"), p !== void 0 ? new Error(`Invalid ${o} \`${u}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const gd = Pa(r.element, ZV);
gd.isRequired = Pa(r.element.isRequired, ZV);
function Lq(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Fq(e, t, n, o, s) {
  const l = e[t], u = s || t;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let p;
  return typeof l == "function" && !Lq(l) && (p = "Did you accidentally provide a plain function component instead?"), p !== void 0 ? new Error(`Invalid ${o} \`${u}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const yv = Pa(r.elementType, Fq), jq = "exact-prop: ​";
function u0(e) {
  return process.env.NODE_ENV === "production" ? e : O({}, e, {
    [jq]: (t) => {
      const n = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function dd(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var k$ = { exports: {} }, Vn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cA;
function Vq() {
  if (cA) return Vn;
  cA = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), T;
  T = Symbol.for("react.module.reference");
  function E(P) {
    if (typeof P == "object" && P !== null) {
      var k = P.$$typeof;
      switch (k) {
        case e:
          switch (P = P.type, P) {
            case n:
            case s:
            case o:
            case m:
            case b:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case p:
                case u:
                case h:
                case S:
                case x:
                case l:
                  return P;
                default:
                  return k;
              }
          }
        case t:
          return k;
      }
    }
  }
  return Vn.ContextConsumer = u, Vn.ContextProvider = l, Vn.Element = e, Vn.ForwardRef = h, Vn.Fragment = n, Vn.Lazy = S, Vn.Memo = x, Vn.Portal = t, Vn.Profiler = s, Vn.StrictMode = o, Vn.Suspense = m, Vn.SuspenseList = b, Vn.isAsyncMode = function() {
    return !1;
  }, Vn.isConcurrentMode = function() {
    return !1;
  }, Vn.isContextConsumer = function(P) {
    return E(P) === u;
  }, Vn.isContextProvider = function(P) {
    return E(P) === l;
  }, Vn.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === e;
  }, Vn.isForwardRef = function(P) {
    return E(P) === h;
  }, Vn.isFragment = function(P) {
    return E(P) === n;
  }, Vn.isLazy = function(P) {
    return E(P) === S;
  }, Vn.isMemo = function(P) {
    return E(P) === x;
  }, Vn.isPortal = function(P) {
    return E(P) === t;
  }, Vn.isProfiler = function(P) {
    return E(P) === s;
  }, Vn.isStrictMode = function(P) {
    return E(P) === o;
  }, Vn.isSuspense = function(P) {
    return E(P) === m;
  }, Vn.isSuspenseList = function(P) {
    return E(P) === b;
  }, Vn.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === n || P === s || P === o || P === m || P === b || P === R || typeof P == "object" && P !== null && (P.$$typeof === S || P.$$typeof === x || P.$$typeof === l || P.$$typeof === u || P.$$typeof === h || P.$$typeof === T || P.getModuleId !== void 0);
  }, Vn.typeOf = E, Vn;
}
var Bn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uA;
function Bq() {
  return uA || (uA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), T = !1, E = !1, P = !1, k = !1, _ = !1, L;
    L = Symbol.for("react.module.reference");
    function F(ye) {
      return !!(typeof ye == "string" || typeof ye == "function" || ye === n || ye === s || _ || ye === o || ye === m || ye === b || k || ye === R || T || E || P || typeof ye == "object" && ye !== null && (ye.$$typeof === S || ye.$$typeof === x || ye.$$typeof === l || ye.$$typeof === u || ye.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ye.$$typeof === L || ye.getModuleId !== void 0));
    }
    function N(ye) {
      if (typeof ye == "object" && ye !== null) {
        var Ee = ye.$$typeof;
        switch (Ee) {
          case e:
            var _e = ye.type;
            switch (_e) {
              case n:
              case s:
              case o:
              case m:
              case b:
                return _e;
              default:
                var Ve = _e && _e.$$typeof;
                switch (Ve) {
                  case p:
                  case u:
                  case h:
                  case S:
                  case x:
                  case l:
                    return Ve;
                  default:
                    return Ee;
                }
            }
          case t:
            return Ee;
        }
      }
    }
    var V = u, z = l, H = e, ee = h, K = n, X = S, ne = x, Y = t, J = s, te = o, Z = m, ae = b, U = !1, G = !1;
    function W(ye) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function le(ye) {
      return G || (G = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function pe(ye) {
      return N(ye) === u;
    }
    function ge(ye) {
      return N(ye) === l;
    }
    function we(ye) {
      return typeof ye == "object" && ye !== null && ye.$$typeof === e;
    }
    function de(ye) {
      return N(ye) === h;
    }
    function se(ye) {
      return N(ye) === n;
    }
    function ve(ye) {
      return N(ye) === S;
    }
    function me(ye) {
      return N(ye) === x;
    }
    function Oe(ye) {
      return N(ye) === t;
    }
    function be(ye) {
      return N(ye) === s;
    }
    function De(ye) {
      return N(ye) === o;
    }
    function ie(ye) {
      return N(ye) === m;
    }
    function fe(ye) {
      return N(ye) === b;
    }
    Bn.ContextConsumer = V, Bn.ContextProvider = z, Bn.Element = H, Bn.ForwardRef = ee, Bn.Fragment = K, Bn.Lazy = X, Bn.Memo = ne, Bn.Portal = Y, Bn.Profiler = J, Bn.StrictMode = te, Bn.Suspense = Z, Bn.SuspenseList = ae, Bn.isAsyncMode = W, Bn.isConcurrentMode = le, Bn.isContextConsumer = pe, Bn.isContextProvider = ge, Bn.isElement = we, Bn.isForwardRef = de, Bn.isFragment = se, Bn.isLazy = ve, Bn.isMemo = me, Bn.isPortal = Oe, Bn.isProfiler = be, Bn.isStrictMode = De, Bn.isSuspense = ie, Bn.isSuspenseList = fe, Bn.isValidElementType = F, Bn.typeOf = N;
  }()), Bn;
}
process.env.NODE_ENV === "production" ? k$.exports = Vq() : k$.exports = Bq();
var jc = k$.exports;
const zq = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Uq(e) {
  const t = `${e}`.match(zq);
  return t && t[1] || "";
}
function eB(e, t = "") {
  return e.displayName || e.name || Uq(e) || t;
}
function dA(e, t, n) {
  const o = eB(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
function Hq(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return eB(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case jc.ForwardRef:
          return dA(e, e.render, "ForwardRef");
        case jc.Memo:
          return dA(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Hl(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = e[t], u = s || t;
  return l == null ? null : l && l.nodeType !== 1 ? new Error(`Invalid ${o} \`${u}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const Yo = r.oneOfType([r.func, r.object]);
function Ae(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : dd(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function F1(...e) {
  return e.reduce((t, n) => n == null ? t : function(...s) {
    t.apply(this, s), n.apply(this, s);
  }, () => {
  });
}
function bv(e, t = 166) {
  let n;
  function o(...s) {
    const l = () => {
      e.apply(this, s);
    };
    clearTimeout(n), n = setTimeout(l, t);
  }
  return o.clear = () => {
    clearTimeout(n);
  }, o;
}
function Wq(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (n, o, s, l, u) => {
    const p = s || "<<anonymous>>", h = u || o;
    return typeof n[o] < "u" ? new Error(`The ${l} \`${h}\` of \`${p}\` is deprecated. ${t}`) : null;
  };
}
function Jm(e, t) {
  var n, o;
  return /* @__PURE__ */ D.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (o = e.type) == null || (o = o._payload) == null || (o = o.value) == null ? void 0 : o.muiName
  ) !== -1;
}
function no(e) {
  return e && e.ownerDocument || document;
}
function us(e) {
  return no(e).defaultView || window;
}
function tB(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? O({}, t.propTypes) : null;
  return (s) => (l, u, p, h, m, ...b) => {
    const x = m || u, S = n == null ? void 0 : n[x];
    if (S) {
      const R = S(l, u, p, h, m, ...b);
      if (R)
        return R;
    }
    return typeof l[u] < "u" && !l[s] ? new Error(`The prop \`${x}\` of \`${e}\` can only be used together with the \`${s}\` prop.`) : null;
  };
}
function Fb(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const $a = typeof window < "u" ? D.useLayoutEffect : D.useEffect;
let fA = 0;
function qq(e) {
  const [t, n] = D.useState(e), o = e || t;
  return D.useEffect(() => {
    t == null && (fA += 1, n(`mui-${fA}`));
  }, [t]), o;
}
const pA = D.useId;
function Vc(e) {
  if (pA !== void 0) {
    const t = pA();
    return e ?? t;
  }
  return qq(e);
}
function SD(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${l}\` is not supported. Please remove it.`) : null;
}
function jl({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: s
  } = D.useRef(e !== void 0), [l, u] = D.useState(t), p = s ? e : l;
  if (process.env.NODE_ENV !== "production") {
    D.useEffect(() => {
      s !== (e !== void 0) && console.error([`MUI: A component is changing the ${s ? "" : "un"}controlled ${o} state of ${n} to be ${s ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: m
    } = D.useRef(t);
    D.useEffect(() => {
      !s && !Object.is(m, t) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const h = D.useCallback((m) => {
    s || u(m);
  }, []);
  return [p, h];
}
function qo(e) {
  const t = D.useRef(e);
  return $a(() => {
    t.current = e;
  }), D.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Gn(...e) {
  return D.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Fb(n, t);
    });
  }, e);
}
const hA = {};
function Yq(e, t) {
  const n = D.useRef(hA);
  return n.current === hA && (n.current = e(t)), n;
}
const Gq = [];
function Kq(e) {
  D.useEffect(e, Gq);
}
class d0 {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new d0();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Hf() {
  const e = Yq(d0.create).current;
  return Kq(e.disposeEffect), e;
}
let Sw = !0, M$ = !1;
const Xq = new d0(), Qq = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Jq(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && Qq[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Zq(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Sw = !0);
}
function WP() {
  Sw = !1;
}
function eY() {
  this.visibilityState === "hidden" && M$ && (Sw = !0);
}
function tY(e) {
  e.addEventListener("keydown", Zq, !0), e.addEventListener("mousedown", WP, !0), e.addEventListener("pointerdown", WP, !0), e.addEventListener("touchstart", WP, !0), e.addEventListener("visibilitychange", eY, !0);
}
function nY(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Sw || Jq(t);
}
function Cw() {
  const e = D.useCallback((s) => {
    s != null && tY(s.ownerDocument);
  }, []), t = D.useRef(!1);
  function n() {
    return t.current ? (M$ = !0, Xq.start(100, () => {
      M$ = !1;
    }), t.current = !1, !0) : !1;
  }
  function o(s) {
    return nY(s) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: o,
    onBlur: n,
    ref: e
  };
}
function nB(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let bm;
function rB() {
  if (bm)
    return bm;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), bm = "reverse", e.scrollLeft > 0 ? bm = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (bm = "negative")), document.body.removeChild(e), bm;
}
function rY(e, t) {
  const n = e.scrollLeft;
  if (t !== "rtl")
    return n;
  switch (rB()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + n;
    case "reverse":
      return e.scrollWidth - e.clientWidth - n;
    default:
      return n;
  }
}
const CD = (e) => {
  const t = D.useRef({});
  return D.useEffect(() => {
    t.current = e;
  }), t.current;
};
function oY(e) {
  return D.Children.toArray(e).filter((t) => /* @__PURE__ */ D.isValidElement(t));
}
function aY(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function iY(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const sY = Number.isInteger || iY;
function oB(e, t, n, o) {
  const s = e[t];
  if (s == null || !sY(s)) {
    const l = aY(s);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${l}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function aB(e, t, ...n) {
  return e[t] === void 0 ? null : oB(e, t, ...n);
}
function N$() {
  return null;
}
aB.isRequired = oB;
N$.isRequired = N$;
const Lc = process.env.NODE_ENV === "production" ? N$ : aB;
function wD(e, t) {
  const n = O({}, t);
  return Object.keys(e).forEach((o) => {
    if (o.toString().match(/^(components|slots)$/))
      n[o] = O({}, e[o], n[o]);
    else if (o.toString().match(/^(componentsProps|slotProps)$/)) {
      const s = e[o] || {}, l = t[o];
      n[o] = {}, !l || !Object.keys(l) ? n[o] = s : !s || !Object.keys(s) ? n[o] = l : (n[o] = O({}, l), Object.keys(s).forEach((u) => {
        n[o][u] = wD(s[u], l[u]);
      }));
    } else n[o] === void 0 && (n[o] = e[o]);
  }), n;
}
function vt(e, t, n = void 0) {
  const o = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      o[s] = e[s].reduce((l, u) => {
        if (u) {
          const p = t(u);
          p !== "" && l.push(p), n && n[u] && l.push(n[u]);
        }
        return l;
      }, []).join(" ");
    }
  ), o;
}
const mA = (e) => e, lY = () => {
  let e = mA;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = mA;
    }
  };
}, ww = lY(), iB = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function pt(e, t, n = "Mui") {
  const o = iB[t];
  return o ? `${n}-${o}` : `${ww.generate(e)}-${t}`;
}
function ht(e, t, n = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = pt(e, s, n);
  }), o;
}
function cY(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function Te(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) >= 0) continue;
    n[o] = e[o];
  }
  return n;
}
function sB(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (n = sB(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Ne() {
  for (var e, t, n = 0, o = "", s = arguments.length; n < s; n++) (e = arguments[n]) && (t = sB(e)) && (o && (o += " "), o += t);
  return o;
}
ww.configure((e) => `jv-${e}`);
const Xf = "$$material";
function lB(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var uY = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, dY = /* @__PURE__ */ lB(
  function(e) {
    return uY.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function fY(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function pY(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var cB = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(s) {
      var l;
      o.tags.length === 0 ? o.insertionPoint ? l = o.insertionPoint.nextSibling : o.prepend ? l = o.container.firstChild : l = o.before : l = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(s, l), o.tags.push(s);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(pY(this));
    var s = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var l = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      l && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !l;
    }
    if (this.isSpeedy) {
      var u = fY(s);
      try {
        u.insertRule(o, u.cssRules.length);
      } catch (p) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', p);
      }
    } else
      s.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), fa = "-ms-", j1 = "-moz-", Nn = "-webkit-", TD = "comm", ED = "rule", RD = "decl", hY = "@import", uB = "@keyframes", mY = "@layer", vY = Math.abs, Tw = String.fromCharCode, gY = Object.assign;
function yY(e, t) {
  return Wo(e, 0) ^ 45 ? (((t << 2 ^ Wo(e, 0)) << 2 ^ Wo(e, 1)) << 2 ^ Wo(e, 2)) << 2 ^ Wo(e, 3) : 0;
}
function dB(e) {
  return e.trim();
}
function bY(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function In(e, t, n) {
  return e.replace(t, n);
}
function I$(e, t) {
  return e.indexOf(t);
}
function Wo(e, t) {
  return e.charCodeAt(t) | 0;
}
function jb(e, t, n) {
  return e.slice(t, n);
}
function _l(e) {
  return e.length;
}
function OD(e) {
  return e.length;
}
function e1(e, t) {
  return t.push(e), e;
}
function xY(e, t) {
  return e.map(t).join("");
}
var Ew = 1, iv = 1, fB = 0, li = 0, to = 0, xv = "";
function Rw(e, t, n, o, s, l, u) {
  return { value: e, root: t, parent: n, type: o, props: s, children: l, line: Ew, column: iv, length: u, return: "" };
}
function Zy(e, t) {
  return gY(Rw("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function SY() {
  return to;
}
function CY() {
  return to = li > 0 ? Wo(xv, --li) : 0, iv--, to === 10 && (iv = 1, Ew--), to;
}
function Ai() {
  return to = li < fB ? Wo(xv, li++) : 0, iv++, to === 10 && (iv = 1, Ew++), to;
}
function Vl() {
  return Wo(xv, li);
}
function T1() {
  return li;
}
function f0(e, t) {
  return jb(xv, e, t);
}
function Vb(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function pB(e) {
  return Ew = iv = 1, fB = _l(xv = e), li = 0, [];
}
function hB(e) {
  return xv = "", e;
}
function E1(e) {
  return dB(f0(li - 1, _$(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function wY(e) {
  for (; (to = Vl()) && to < 33; )
    Ai();
  return Vb(e) > 2 || Vb(to) > 3 ? "" : " ";
}
function TY(e, t) {
  for (; --t && Ai() && !(to < 48 || to > 102 || to > 57 && to < 65 || to > 70 && to < 97); )
    ;
  return f0(e, T1() + (t < 6 && Vl() == 32 && Ai() == 32));
}
function _$(e) {
  for (; Ai(); )
    switch (to) {
      case e:
        return li;
      case 34:
      case 39:
        e !== 34 && e !== 39 && _$(to);
        break;
      case 40:
        e === 41 && _$(e);
        break;
      case 92:
        Ai();
        break;
    }
  return li;
}
function EY(e, t) {
  for (; Ai() && e + to !== 57; )
    if (e + to === 84 && Vl() === 47)
      break;
  return "/*" + f0(t, li - 1) + "*" + Tw(e === 47 ? e : Ai());
}
function RY(e) {
  for (; !Vb(Vl()); )
    Ai();
  return f0(e, li);
}
function OY(e) {
  return hB(R1("", null, null, null, [""], e = pB(e), 0, [0], e));
}
function R1(e, t, n, o, s, l, u, p, h) {
  for (var m = 0, b = 0, x = u, S = 0, R = 0, T = 0, E = 1, P = 1, k = 1, _ = 0, L = "", F = s, N = l, V = o, z = L; P; )
    switch (T = _, _ = Ai()) {
      case 40:
        if (T != 108 && Wo(z, x - 1) == 58) {
          I$(z += In(E1(_), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        z += E1(_);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        z += wY(T);
        break;
      case 92:
        z += TY(T1() - 1, 7);
        continue;
      case 47:
        switch (Vl()) {
          case 42:
          case 47:
            e1(PY(EY(Ai(), T1()), t, n), h);
            break;
          default:
            z += "/";
        }
        break;
      case 123 * E:
        p[m++] = _l(z) * k;
      case 125 * E:
      case 59:
      case 0:
        switch (_) {
          case 0:
          case 125:
            P = 0;
          case 59 + b:
            k == -1 && (z = In(z, /\f/g, "")), R > 0 && _l(z) - x && e1(R > 32 ? gA(z + ";", o, n, x - 1) : gA(In(z, " ", "") + ";", o, n, x - 2), h);
            break;
          case 59:
            z += ";";
          default:
            if (e1(V = vA(z, t, n, m, b, s, p, L, F = [], N = [], x), l), _ === 123)
              if (b === 0)
                R1(z, t, V, V, F, l, x, p, N);
              else
                switch (S === 99 && Wo(z, 3) === 110 ? 100 : S) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    R1(e, V, V, o && e1(vA(e, V, V, 0, 0, s, p, L, s, F = [], x), N), s, N, x, p, o ? F : N);
                    break;
                  default:
                    R1(z, V, V, V, [""], N, 0, p, N);
                }
        }
        m = b = R = 0, E = k = 1, L = z = "", x = u;
        break;
      case 58:
        x = 1 + _l(z), R = T;
      default:
        if (E < 1) {
          if (_ == 123)
            --E;
          else if (_ == 125 && E++ == 0 && CY() == 125)
            continue;
        }
        switch (z += Tw(_), _ * E) {
          case 38:
            k = b > 0 ? 1 : (z += "\f", -1);
            break;
          case 44:
            p[m++] = (_l(z) - 1) * k, k = 1;
            break;
          case 64:
            Vl() === 45 && (z += E1(Ai())), S = Vl(), b = x = _l(L = z += RY(T1())), _++;
            break;
          case 45:
            T === 45 && _l(z) == 2 && (E = 0);
        }
    }
  return l;
}
function vA(e, t, n, o, s, l, u, p, h, m, b) {
  for (var x = s - 1, S = s === 0 ? l : [""], R = OD(S), T = 0, E = 0, P = 0; T < o; ++T)
    for (var k = 0, _ = jb(e, x + 1, x = vY(E = u[T])), L = e; k < R; ++k)
      (L = dB(E > 0 ? S[k] + " " + _ : In(_, /&\f/g, S[k]))) && (h[P++] = L);
  return Rw(e, t, n, s === 0 ? ED : p, h, m, b);
}
function PY(e, t, n) {
  return Rw(e, t, n, TD, Tw(SY()), jb(e, 2, -2), 0);
}
function gA(e, t, n, o) {
  return Rw(e, t, n, RD, jb(e, 0, o), jb(e, o + 1, -1), o);
}
function Zm(e, t) {
  for (var n = "", o = OD(e), s = 0; s < o; s++)
    n += t(e[s], s, e, t) || "";
  return n;
}
function $Y(e, t, n, o) {
  switch (e.type) {
    case mY:
      if (e.children.length) break;
    case hY:
    case RD:
      return e.return = e.return || e.value;
    case TD:
      return "";
    case uB:
      return e.return = e.value + "{" + Zm(e.children, o) + "}";
    case ED:
      e.value = e.props.join(",");
  }
  return _l(n = Zm(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function DY(e) {
  var t = OD(e);
  return function(n, o, s, l) {
    for (var u = "", p = 0; p < t; p++)
      u += e[p](n, o, s, l) || "";
    return u;
  };
}
function kY(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var MY = function(t, n, o) {
  for (var s = 0, l = 0; s = l, l = Vl(), s === 38 && l === 12 && (n[o] = 1), !Vb(l); )
    Ai();
  return f0(t, li);
}, NY = function(t, n) {
  var o = -1, s = 44;
  do
    switch (Vb(s)) {
      case 0:
        s === 38 && Vl() === 12 && (n[o] = 1), t[o] += MY(li - 1, n, o);
        break;
      case 2:
        t[o] += E1(s);
        break;
      case 4:
        if (s === 44) {
          t[++o] = Vl() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      default:
        t[o] += Tw(s);
    }
  while (s = Ai());
  return t;
}, IY = function(t, n) {
  return hB(NY(pB(t), n));
}, yA = /* @__PURE__ */ new WeakMap(), _Y = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, s = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !yA.get(o)) && !s) {
      yA.set(t, !0);
      for (var l = [], u = IY(n, l), p = o.props, h = 0, m = 0; h < u.length; h++)
        for (var b = 0; b < p.length; b++, m++)
          t.props[m] = l[h] ? u[h].replace(/&\f/g, p[b]) : p[b] + " " + u[h];
    }
  }
}, AY = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, LY = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", FY = function(t) {
  return t.type === "comm" && t.children.indexOf(LY) > -1;
}, jY = function(t) {
  return function(n, o, s) {
    if (!(n.type !== "rule" || t.compat)) {
      var l = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (l) {
        for (var u = !!n.parent, p = u ? n.parent.children : (
          // global rule at the root level
          s
        ), h = p.length - 1; h >= 0; h--) {
          var m = p[h];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (FY(m))
              return;
            break;
          }
        }
        l.forEach(function(b) {
          console.error('The pseudo class "' + b + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + b.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, mB = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, VY = function(t, n) {
  for (var o = t - 1; o >= 0; o--)
    if (!mB(n[o]))
      return !0;
  return !1;
}, bA = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, BY = function(t, n, o) {
  mB(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), bA(t)) : VY(n, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), bA(t)));
};
function vB(e, t) {
  switch (yY(e, t)) {
    case 5103:
      return Nn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Nn + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Nn + e + j1 + e + fa + e + e;
    case 6828:
    case 4268:
      return Nn + e + fa + e + e;
    case 6165:
      return Nn + e + fa + "flex-" + e + e;
    case 5187:
      return Nn + e + In(e, /(\w+).+(:[^]+)/, Nn + "box-$1$2" + fa + "flex-$1$2") + e;
    case 5443:
      return Nn + e + fa + "flex-item-" + In(e, /flex-|-self/, "") + e;
    case 4675:
      return Nn + e + fa + "flex-line-pack" + In(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Nn + e + fa + In(e, "shrink", "negative") + e;
    case 5292:
      return Nn + e + fa + In(e, "basis", "preferred-size") + e;
    case 6060:
      return Nn + "box-" + In(e, "-grow", "") + Nn + e + fa + In(e, "grow", "positive") + e;
    case 4554:
      return Nn + In(e, /([^-])(transform)/g, "$1" + Nn + "$2") + e;
    case 6187:
      return In(In(In(e, /(zoom-|grab)/, Nn + "$1"), /(image-set)/, Nn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return In(e, /(image-set\([^]*)/, Nn + "$1$`$1");
    case 4968:
      return In(In(e, /(.+:)(flex-)?(.*)/, Nn + "box-pack:$3" + fa + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Nn + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return In(e, /(.+)-inline(.+)/, Nn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (_l(e) - 1 - t > 6) switch (Wo(e, t + 1)) {
        case 109:
          if (Wo(e, t + 4) !== 45) break;
        case 102:
          return In(e, /(.+:)(.+)-([^]+)/, "$1" + Nn + "$2-$3$1" + j1 + (Wo(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~I$(e, "stretch") ? vB(In(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Wo(e, t + 1) !== 115) break;
    case 6444:
      switch (Wo(e, _l(e) - 3 - (~I$(e, "!important") && 10))) {
        case 107:
          return In(e, ":", ":" + Nn) + e;
        case 101:
          return In(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Nn + (Wo(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Nn + "$2$3$1" + fa + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Wo(e, t + 11)) {
        case 114:
          return Nn + e + fa + In(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Nn + e + fa + In(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Nn + e + fa + In(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Nn + e + fa + e + e;
  }
  return e;
}
var zY = function(t, n, o, s) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case RD:
      t.return = vB(t.value, t.length);
      break;
    case uB:
      return Zm([Zy(t, {
        value: In(t.value, "@", "@" + Nn)
      })], s);
    case ED:
      if (t.length) return xY(t.props, function(l) {
        switch (bY(l, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Zm([Zy(t, {
              props: [In(l, /:(read-\w+)/, ":" + j1 + "$1")]
            })], s);
          case "::placeholder":
            return Zm([Zy(t, {
              props: [In(l, /:(plac\w+)/, ":" + Nn + "input-$1")]
            }), Zy(t, {
              props: [In(l, /:(plac\w+)/, ":" + j1 + "$1")]
            }), Zy(t, {
              props: [In(l, /:(plac\w+)/, fa + "input-$1")]
            })], s);
        }
        return "";
      });
  }
}, UY = [zY], PD = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(E) {
      var P = E.getAttribute("data-emotion");
      P.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var s = t.stylisPlugins || UY;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var l = {}, u, p = [];
  u = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(E) {
      for (var P = E.getAttribute("data-emotion").split(" "), k = 1; k < P.length; k++)
        l[P[k]] = !0;
      p.push(E);
    }
  );
  var h, m = [_Y, AY];
  process.env.NODE_ENV !== "production" && m.push(jY({
    get compat() {
      return T.compat;
    }
  }), BY);
  {
    var b, x = [$Y, process.env.NODE_ENV !== "production" ? function(E) {
      E.root || (E.return ? b.insert(E.return) : E.value && E.type !== TD && b.insert(E.value + "{}"));
    } : kY(function(E) {
      b.insert(E);
    })], S = DY(m.concat(s, x)), R = function(P) {
      return Zm(OY(P), S);
    };
    h = function(P, k, _, L) {
      b = _, process.env.NODE_ENV !== "production" && k.map !== void 0 && (b = {
        insert: function(N) {
          _.insert(N + k.map);
        }
      }), R(P ? P + "{" + k.styles + "}" : k.styles), L && (T.inserted[k.name] = !0);
    };
  }
  var T = {
    key: n,
    sheet: new cB({
      key: n,
      container: u,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: l,
    registered: {},
    insert: h
  };
  return T.sheet.hydrate(p), T;
}, A$ = { exports: {} }, zn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xA;
function HY() {
  if (xA) return zn;
  xA = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function L(N) {
    if (typeof N == "object" && N !== null) {
      var V = N.$$typeof;
      switch (V) {
        case t:
          switch (N = N.type, N) {
            case h:
            case m:
            case o:
            case l:
            case s:
            case x:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case p:
                case b:
                case T:
                case R:
                case u:
                  return N;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function F(N) {
    return L(N) === m;
  }
  return zn.AsyncMode = h, zn.ConcurrentMode = m, zn.ContextConsumer = p, zn.ContextProvider = u, zn.Element = t, zn.ForwardRef = b, zn.Fragment = o, zn.Lazy = T, zn.Memo = R, zn.Portal = n, zn.Profiler = l, zn.StrictMode = s, zn.Suspense = x, zn.isAsyncMode = function(N) {
    return F(N) || L(N) === h;
  }, zn.isConcurrentMode = F, zn.isContextConsumer = function(N) {
    return L(N) === p;
  }, zn.isContextProvider = function(N) {
    return L(N) === u;
  }, zn.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === t;
  }, zn.isForwardRef = function(N) {
    return L(N) === b;
  }, zn.isFragment = function(N) {
    return L(N) === o;
  }, zn.isLazy = function(N) {
    return L(N) === T;
  }, zn.isMemo = function(N) {
    return L(N) === R;
  }, zn.isPortal = function(N) {
    return L(N) === n;
  }, zn.isProfiler = function(N) {
    return L(N) === l;
  }, zn.isStrictMode = function(N) {
    return L(N) === s;
  }, zn.isSuspense = function(N) {
    return L(N) === x;
  }, zn.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === o || N === m || N === l || N === s || N === x || N === S || typeof N == "object" && N !== null && (N.$$typeof === T || N.$$typeof === R || N.$$typeof === u || N.$$typeof === p || N.$$typeof === b || N.$$typeof === P || N.$$typeof === k || N.$$typeof === _ || N.$$typeof === E);
  }, zn.typeOf = L, zn;
}
var Un = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SA;
function WY() {
  return SA || (SA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, l = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function L(ie) {
      return typeof ie == "string" || typeof ie == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ie === o || ie === m || ie === l || ie === s || ie === x || ie === S || typeof ie == "object" && ie !== null && (ie.$$typeof === T || ie.$$typeof === R || ie.$$typeof === u || ie.$$typeof === p || ie.$$typeof === b || ie.$$typeof === P || ie.$$typeof === k || ie.$$typeof === _ || ie.$$typeof === E);
    }
    function F(ie) {
      if (typeof ie == "object" && ie !== null) {
        var fe = ie.$$typeof;
        switch (fe) {
          case t:
            var ye = ie.type;
            switch (ye) {
              case h:
              case m:
              case o:
              case l:
              case s:
              case x:
                return ye;
              default:
                var Ee = ye && ye.$$typeof;
                switch (Ee) {
                  case p:
                  case b:
                  case T:
                  case R:
                  case u:
                    return Ee;
                  default:
                    return fe;
                }
            }
          case n:
            return fe;
        }
      }
    }
    var N = h, V = m, z = p, H = u, ee = t, K = b, X = o, ne = T, Y = R, J = n, te = l, Z = s, ae = x, U = !1;
    function G(ie) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(ie) || F(ie) === h;
    }
    function W(ie) {
      return F(ie) === m;
    }
    function le(ie) {
      return F(ie) === p;
    }
    function pe(ie) {
      return F(ie) === u;
    }
    function ge(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === t;
    }
    function we(ie) {
      return F(ie) === b;
    }
    function de(ie) {
      return F(ie) === o;
    }
    function se(ie) {
      return F(ie) === T;
    }
    function ve(ie) {
      return F(ie) === R;
    }
    function me(ie) {
      return F(ie) === n;
    }
    function Oe(ie) {
      return F(ie) === l;
    }
    function be(ie) {
      return F(ie) === s;
    }
    function De(ie) {
      return F(ie) === x;
    }
    Un.AsyncMode = N, Un.ConcurrentMode = V, Un.ContextConsumer = z, Un.ContextProvider = H, Un.Element = ee, Un.ForwardRef = K, Un.Fragment = X, Un.Lazy = ne, Un.Memo = Y, Un.Portal = J, Un.Profiler = te, Un.StrictMode = Z, Un.Suspense = ae, Un.isAsyncMode = G, Un.isConcurrentMode = W, Un.isContextConsumer = le, Un.isContextProvider = pe, Un.isElement = ge, Un.isForwardRef = we, Un.isFragment = de, Un.isLazy = se, Un.isMemo = ve, Un.isPortal = me, Un.isProfiler = Oe, Un.isStrictMode = be, Un.isSuspense = De, Un.isValidElementType = L, Un.typeOf = F;
  }()), Un;
}
process.env.NODE_ENV === "production" ? A$.exports = HY() : A$.exports = WY();
var qY = A$.exports, gB = qY, YY = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, GY = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, yB = {};
yB[gB.ForwardRef] = YY;
yB[gB.Memo] = GY;
var KY = !0;
function $D(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : o += s + " ";
  }), o;
}
var bB = function(t, n, o) {
  var s = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  KY === !1) && t.registered[s] === void 0 && (t.registered[s] = n.styles);
}, Ow = function(t, n, o) {
  bB(t, n, o);
  var s = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var l = n;
    do
      t.insert(n === l ? "." + s : "", l, t.sheet, !0), l = l.next;
    while (l !== void 0);
  }
};
function XY(e) {
  for (var t = 0, n, o = 0, s = e.length; s >= 4; ++o, s -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var QY = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, CA = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, JY = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", ZY = /[A-Z]|^ms/g, xB = /_EMO_([^_]+?)_([^]*?)_EMO_/g, DD = function(t) {
  return t.charCodeAt(1) === 45;
}, wA = function(t) {
  return t != null && typeof t != "boolean";
}, qP = /* @__PURE__ */ lB(function(e) {
  return DD(e) ? e : e.replace(ZY, "-$&").toLowerCase();
}), V1 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(xB, function(o, s, l) {
          return Xs = {
            name: s,
            styles: l,
            next: Xs
          }, s;
        });
  }
  return QY[t] !== 1 && !DD(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var eG = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, tG = ["normal", "none", "initial", "inherit", "unset"], nG = V1, rG = /^-ms-/, oG = /-(.)/g, TA = {};
  V1 = function(t, n) {
    if (t === "content" && (typeof n != "string" || tG.indexOf(n) === -1 && !eG.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var o = nG(t, n);
    return o !== "" && !DD(t) && t.indexOf("-") !== -1 && TA[t] === void 0 && (TA[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(rG, "ms-").replace(oG, function(s, l) {
      return l.toUpperCase();
    }) + "?")), o;
  };
}
var SB = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Bb(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(SB);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Xs = {
          name: n.name,
          styles: n.styles,
          next: Xs
        }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Xs = {
              name: o.name,
              styles: o.styles,
              next: Xs
            }, o = o.next;
        var s = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (s += n.map), s;
      }
      return aG(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = Xs, u = n(e);
        return Xs = l, Bb(e, t, u);
      } else process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var p = [], h = n.replace(xB, function(b, x, S) {
          var R = "animation" + p.length;
          return p.push("const " + R + " = keyframes`" + S.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + R + "}";
        });
        p.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(p, ["`" + h + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + h + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var m = t[n];
  return m !== void 0 ? m : n;
}
function aG(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      o += Bb(e, t, n[s]) + ";";
  else
    for (var l in n) {
      var u = n[l];
      if (typeof u != "object")
        t != null && t[u] !== void 0 ? o += l + "{" + t[u] + "}" : wA(u) && (o += qP(l) + ":" + V1(l, u) + ";");
      else {
        if (l === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(SB);
        if (Array.isArray(u) && typeof u[0] == "string" && (t == null || t[u[0]] === void 0))
          for (var p = 0; p < u.length; p++)
            wA(u[p]) && (o += qP(l) + ":" + V1(l, u[p]) + ";");
        else {
          var h = Bb(e, t, u);
          switch (l) {
            case "animation":
            case "animationName": {
              o += qP(l) + ":" + h + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && l === "undefined" && console.error(JY), o += l + "{" + h + "}";
          }
        }
      }
    }
  return o;
}
var EA = /label:\s*([^\s;\n{]+)\s*(;|$)/g, CB;
process.env.NODE_ENV !== "production" && (CB = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Xs, sv = function(t, n, o) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, l = "";
  Xs = void 0;
  var u = t[0];
  u == null || u.raw === void 0 ? (s = !1, l += Bb(o, n, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(CA), l += u[0]);
  for (var p = 1; p < t.length; p++)
    l += Bb(o, n, t[p]), s && (process.env.NODE_ENV !== "production" && u[p] === void 0 && console.error(CA), l += u[p]);
  var h;
  process.env.NODE_ENV !== "production" && (l = l.replace(CB, function(S) {
    return h = S, "";
  })), EA.lastIndex = 0;
  for (var m = "", b; (b = EA.exec(l)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    b[1];
  var x = XY(l) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: x,
    styles: l,
    map: h,
    next: Xs,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: x,
    styles: l,
    next: Xs
  };
}, iG = Object.prototype.hasOwnProperty, kD = /* @__PURE__ */ GV(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ PD({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (kD.displayName = "EmotionCacheContext");
var wB = kD.Provider, Pw = function(t) {
  return /* @__PURE__ */ ft(function(n, o) {
    var s = xw(kD);
    return t(n, s, o);
  });
}, yd = /* @__PURE__ */ GV({});
process.env.NODE_ENV !== "production" && (yd.displayName = "EmotionThemeContext");
var RA = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", OA = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", sG = /* @__PURE__ */ Pw(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var s = e[RA], l = [o], u = "";
  typeof e.className == "string" ? u = $D(t.registered, l, e.className) : e.className != null && (u = e.className + " ");
  var p = sv(l, void 0, xw(yd));
  if (process.env.NODE_ENV !== "production" && p.name.indexOf("-") === -1) {
    var h = e[OA];
    h && (p = sv([p, "label:" + h + ";"]));
  }
  Ow(t, p, typeof s == "string"), u += t.key + "-" + p.name;
  var m = {};
  for (var b in e)
    iG.call(e, b) && b !== "css" && b !== RA && (process.env.NODE_ENV === "production" || b !== OA) && (m[b] = e[b]);
  m.ref = n, m.className = u;
  var x = /* @__PURE__ */ KV(s, m);
  return x;
});
process.env.NODE_ENV !== "production" && (sG.displayName = "EmotionCssPropInternal");
var lG = {
  name: "@emotion/react",
  version: "11.4.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "isolated-hoist-non-react-statics-do-not-use-this-in-your-code",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.13.10",
    "@emotion/cache": "^11.4.0",
    "@emotion/serialize": "^1.0.2",
    "@emotion/sheet": "^1.0.2",
    "@emotion/utils": "^1.0.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: !0
    },
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@babel/core": "^7.13.10",
    "@emotion/css": "11.1.3",
    "@emotion/css-prettifier": "1.0.0",
    "@emotion/server": "11.4.0",
    "@emotion/styled": "11.3.0",
    "@types/react": "^16.9.11",
    dtslint: "^0.3.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./isolated-hoist-non-react-statics-do-not-use-this-in-your-code.js"
    ],
    umdName: "emotionReact"
  }
}, PA = !1, MD = /* @__PURE__ */ Pw(function(e, t) {
  process.env.NODE_ENV !== "production" && !PA && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), PA = !0);
  var n = e.styles, o = sv([n], void 0, xw(yd)), s = l0();
  return Gf(function() {
    var l = t.key + "-global", u = new cB({
      key: l,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), p = !1, h = document.querySelector('style[data-emotion="' + l + " " + o.name + '"]');
    return t.sheet.tags.length && (u.before = t.sheet.tags[0]), h !== null && (p = !0, h.setAttribute("data-emotion", l), u.hydrate([h])), s.current = [u, p], function() {
      u.flush();
    };
  }, [t]), Gf(function() {
    var l = s.current, u = l[0], p = l[1];
    if (p) {
      l[1] = !1;
      return;
    }
    if (o.next !== void 0 && Ow(t, o.next, !0), u.tags.length) {
      var h = u.tags[u.tags.length - 1].nextElementSibling;
      u.before = h, u.flush();
    }
    t.insert("", o, u, !1);
  }, [t, o.name]), null;
});
process.env.NODE_ENV !== "production" && (MD.displayName = "EmotionGlobal");
function Bc() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return sv(t);
}
var tl = function() {
  var t = Bc.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, cG = function e(t) {
  for (var n = t.length, o = 0, s = ""; o < n; o++) {
    var l = t[o];
    if (l != null) {
      var u = void 0;
      switch (typeof l) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(l))
            u = e(l);
          else {
            process.env.NODE_ENV !== "production" && l.styles !== void 0 && l.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), u = "";
            for (var p in l)
              l[p] && p && (u && (u += " "), u += p);
          }
          break;
        }
        default:
          u = l;
      }
      u && (s && (s += " "), s += u);
    }
  }
  return s;
};
function uG(e, t, n) {
  var o = [], s = $D(e, o, n);
  return o.length < 2 ? n : s + t(o);
}
var dG = /* @__PURE__ */ Pw(function(e, t) {
  var n = !1, o = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var h = arguments.length, m = new Array(h), b = 0; b < h; b++)
      m[b] = arguments[b];
    var x = sv(m, t.registered);
    return Ow(t, x, !1), t.key + "-" + x.name;
  }, s = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var h = arguments.length, m = new Array(h), b = 0; b < h; b++)
      m[b] = arguments[b];
    return uG(t.registered, o, cG(m));
  }, l = {
    css: o,
    cx: s,
    theme: xw(yd)
  }, u = e.children(l);
  return n = !0, u;
});
process.env.NODE_ENV !== "production" && (dG.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var $A = !0, fG = typeof jest < "u";
  if ($A && !fG) {
    var DA = $A ? window : global, kA = "__EMOTION_REACT_" + lG.version.split(".")[0] + "__";
    DA[kA] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), DA[kA] = !0;
  }
}
var pG = function(t) {
  return t();
}, hG = D.useInsertionEffect ? D.useInsertionEffect : !1, mG = hG || pG, vG = dY, gG = function(t) {
  return t !== "theme";
}, MA = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? vG : gG;
}, NA = function(t, n, o) {
  var s;
  if (n) {
    var l = n.shouldForwardProp;
    s = t.__emotion_forwardProp && l ? function(u) {
      return t.__emotion_forwardProp(u) && l(u);
    } : l;
  }
  return typeof s != "function" && o && (s = t.__emotion_forwardProp), s;
}, IA = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, yG = function(t) {
  var n = t.cache, o = t.serialized, s = t.isStringTag;
  return bB(n, o, s), mG(function() {
    return Ow(n, o, s);
  }), null;
}, bG = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var o = t.__emotion_real === t, s = o && t.__emotion_base || t, l, u;
  n !== void 0 && (l = n.label, u = n.target);
  var p = NA(t, n, o), h = p || MA(s), m = !h("as");
  return function() {
    var b = arguments, x = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (l !== void 0 && x.push("label:" + l + ";"), b[0] == null || b[0].raw === void 0)
      x.push.apply(x, b);
    else {
      process.env.NODE_ENV !== "production" && b[0][0] === void 0 && console.error(IA), x.push(b[0][0]);
      for (var S = b.length, R = 1; R < S; R++)
        process.env.NODE_ENV !== "production" && b[0][R] === void 0 && console.error(IA), x.push(b[R], b[0][R]);
    }
    var T = Pw(function(E, P, k) {
      var _ = m && E.as || s, L = "", F = [], N = E;
      if (E.theme == null) {
        N = {};
        for (var V in E)
          N[V] = E[V];
        N.theme = D.useContext(yd);
      }
      typeof E.className == "string" ? L = $D(P.registered, F, E.className) : E.className != null && (L = E.className + " ");
      var z = sv(x.concat(F), P.registered, N);
      L += P.key + "-" + z.name, u !== void 0 && (L += " " + u);
      var H = m && p === void 0 ? MA(_) : h, ee = {};
      for (var K in E)
        m && K === "as" || // $FlowFixMe
        H(K) && (ee[K] = E[K]);
      return ee.className = L, ee.ref = k, /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(yG, {
        cache: P,
        serialized: z,
        isStringTag: typeof _ == "string"
      }), /* @__PURE__ */ D.createElement(_, ee));
    });
    return T.displayName = l !== void 0 ? l : "Styled(" + (typeof s == "string" ? s : s.displayName || s.name || "Component") + ")", T.defaultProps = t.defaultProps, T.__emotion_real = T, T.__emotion_base = s, T.__emotion_styles = x, T.__emotion_forwardProp = p, Object.defineProperty(T, "toString", {
      value: function() {
        return u === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + u;
      }
    }), T.withComponent = function(E, P) {
      return e(E, O({}, n, P, {
        shouldForwardProp: NA(T, P, !0)
      })).apply(void 0, x);
    }, T;
  };
}, xG = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], B1 = bG.bind();
xG.forEach(function(e) {
  B1[e] = B1(e);
});
let L$;
typeof document == "object" && (L$ = PD({
  key: "css",
  prepend: !0
}));
function ND(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && L$ ? /* @__PURE__ */ I(wB, {
    value: L$,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (ND.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: r.bool
});
function SG(e) {
  return e == null || Object.keys(e).length === 0;
}
function TB(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ I(MD, {
    styles: typeof t == "function" ? (s) => t(SG(s) ? n : s) : t
  });
}
process.env.NODE_ENV !== "production" && (TB.propTypes = {
  defaultTheme: r.object,
  styles: r.oneOfType([r.array, r.string, r.object, r.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function EB(e, t) {
  const n = B1(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((l) => l === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
const CG = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, wG = ["values", "unit", "step"], TG = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => O({}, n, {
    [o.key]: o.val
  }), {});
};
function EG(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5
  } = e, s = Te(e, wG), l = TG(t), u = Object.keys(l);
  function p(S) {
    return `@media (min-width:${typeof t[S] == "number" ? t[S] : S}${n})`;
  }
  function h(S) {
    return `@media (max-width:${(typeof t[S] == "number" ? t[S] : S) - o / 100}${n})`;
  }
  function m(S, R) {
    const T = u.indexOf(R);
    return `@media (min-width:${typeof t[S] == "number" ? t[S] : S}${n}) and (max-width:${(T !== -1 && typeof t[u[T]] == "number" ? t[u[T]] : R) - o / 100}${n})`;
  }
  function b(S) {
    return u.indexOf(S) + 1 < u.length ? m(S, u[u.indexOf(S) + 1]) : p(S);
  }
  function x(S) {
    const R = u.indexOf(S);
    return R === 0 ? p(u[1]) : R === u.length - 1 ? h(u[R]) : m(S, u[u.indexOf(S) + 1]).replace("@media", "@media not all and");
  }
  return O({
    keys: u,
    values: l,
    up: p,
    down: h,
    between: m,
    only: b,
    not: x,
    unit: n
  }, s);
}
const RG = {
  borderRadius: 4
}, bd = process.env.NODE_ENV !== "production" ? r.oneOfType([r.number, r.string, r.object, r.array]) : {};
function wb(e, t) {
  return t ? ai(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const ID = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, _A = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${ID[e]}px)`
};
function ci(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const l = o.breakpoints || _A;
    return t.reduce((u, p, h) => (u[l.up(l.keys[h])] = n(t[h]), u), {});
  }
  if (typeof t == "object") {
    const l = o.breakpoints || _A;
    return Object.keys(t).reduce((u, p) => {
      if (Object.keys(l.values || ID).indexOf(p) !== -1) {
        const h = l.up(p);
        u[h] = n(t[p], p);
      } else {
        const h = p;
        u[h] = t[h];
      }
      return u;
    }, {});
  }
  return n(t);
}
function RB(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((o, s) => {
    const l = e.up(s);
    return o[l] = {}, o;
  }, {})) || {};
}
function OB(e, t) {
  return e.reduce((n, o) => {
    const s = n[o];
    return (!s || Object.keys(s).length === 0) && delete n[o], n;
  }, t);
}
function OG(e, ...t) {
  const n = RB(e), o = [n, ...t].reduce((s, l) => ai(s, l), {});
  return OB(Object.keys(n), o);
}
function PG(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, o = Object.keys(t);
  return Array.isArray(e) ? o.forEach((s, l) => {
    l < e.length && (n[s] = !0);
  }) : o.forEach((s) => {
    e[s] != null && (n[s] = !0);
  }), n;
}
function qf({
  values: e,
  breakpoints: t,
  base: n
}) {
  const o = n || PG(e, t), s = Object.keys(o);
  if (s.length === 0)
    return e;
  let l;
  return s.reduce((u, p, h) => (Array.isArray(e) ? (u[p] = e[h] != null ? e[h] : e[l], l = h) : typeof e == "object" ? (u[p] = e[p] != null ? e[p] : e[l], l = p) : u[p] = e, u), {});
}
function lv(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((s, l) => s && s[l] ? s[l] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, s) => o && o[s] != null ? o[s] : null, e);
}
function z1(e, t, n, o = n) {
  let s;
  return typeof e == "function" ? s = e(n) : Array.isArray(e) ? s = e[n] || o : s = lv(e, n) || o, t && (s = t(s, o, e)), s;
}
function qr(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: s
  } = e, l = (u) => {
    if (u[t] == null)
      return null;
    const p = u[t], h = u.theme, m = lv(h, o) || {};
    return ci(u, p, (x) => {
      let S = z1(m, s, x);
      return x === S && typeof x == "string" && (S = z1(m, s, `${t}${x === "default" ? "" : Ae(x)}`, x)), n === !1 ? S : {
        [n]: S
      };
    });
  };
  return l.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: bd
  } : {}, l.filterProps = [t], l;
}
function $G(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const DG = {
  m: "margin",
  p: "padding"
}, kG = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, AA = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, MG = $G((e) => {
  if (e.length > 2)
    if (AA[e])
      e = AA[e];
    else
      return [e];
  const [t, n] = e.split(""), o = DG[t], s = kG[n] || "";
  return Array.isArray(s) ? s.map((l) => o + l) : [o + s];
}), $w = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Dw = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], NG = [...$w, ...Dw];
function p0(e, t, n, o) {
  var s;
  const l = (s = lv(e, t, !1)) != null ? s : n;
  return typeof l == "number" ? (u) => typeof u == "string" ? u : (process.env.NODE_ENV !== "production" && typeof u != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${u}.`), l * u) : Array.isArray(l) ? (u) => typeof u == "string" ? u : (process.env.NODE_ENV !== "production" && (Number.isInteger(u) ? u > l.length - 1 && console.error([`MUI: The value provided (${u}) overflows.`, `The supported values are: ${JSON.stringify(l)}.`, `${u} > ${l.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), l[u]) : typeof l == "function" ? l : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${l}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function _D(e) {
  return p0(e, "spacing", 8, "spacing");
}
function Qf(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), o = e(n);
  return t >= 0 ? o : typeof o == "number" ? -o : `-${o}`;
}
function IG(e, t) {
  return (n) => e.reduce((o, s) => (o[s] = Qf(t, n), o), {});
}
function _G(e, t, n, o) {
  if (t.indexOf(n) === -1)
    return null;
  const s = MG(n), l = IG(s, o), u = e[n];
  return ci(e, u, l);
}
function PB(e, t) {
  const n = _D(e.theme);
  return Object.keys(e).map((o) => _G(e, t, o, n)).reduce(wb, {});
}
function Nr(e) {
  return PB(e, $w);
}
Nr.propTypes = process.env.NODE_ENV !== "production" ? $w.reduce((e, t) => (e[t] = bd, e), {}) : {};
Nr.filterProps = $w;
function Ir(e) {
  return PB(e, Dw);
}
Ir.propTypes = process.env.NODE_ENV !== "production" ? Dw.reduce((e, t) => (e[t] = bd, e), {}) : {};
Ir.filterProps = Dw;
process.env.NODE_ENV !== "production" && NG.reduce((e, t) => (e[t] = bd, e), {});
function AG(e = 8) {
  if (e.mui)
    return e;
  const t = _D({
    spacing: e
  }), n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((l) => {
    const u = t(l);
    return typeof u == "number" ? `${u}px` : u;
  }).join(" "));
  return n.mui = !0, n;
}
function kw(...e) {
  const t = e.reduce((o, s) => (s.filterProps.forEach((l) => {
    o[l] = s;
  }), o), {}), n = (o) => Object.keys(o).reduce((s, l) => t[l] ? wb(s, t[l](o)) : s, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, s) => Object.assign(o, s.propTypes), {}) : {}, n.filterProps = e.reduce((o, s) => o.concat(s.filterProps), []), n;
}
function os(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function hs(e, t) {
  return qr({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const LG = hs("border", os), FG = hs("borderTop", os), jG = hs("borderRight", os), VG = hs("borderBottom", os), BG = hs("borderLeft", os), zG = hs("borderColor"), UG = hs("borderTopColor"), HG = hs("borderRightColor"), WG = hs("borderBottomColor"), qG = hs("borderLeftColor"), YG = hs("outline", os), GG = hs("outlineColor"), Mw = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = p0(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: Qf(t, o)
    });
    return ci(e, e.borderRadius, n);
  }
  return null;
};
Mw.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: bd
} : {};
Mw.filterProps = ["borderRadius"];
kw(LG, FG, jG, VG, BG, zG, UG, HG, WG, qG, Mw, YG, GG);
const Nw = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = p0(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: Qf(t, o)
    });
    return ci(e, e.gap, n);
  }
  return null;
};
Nw.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: bd
} : {};
Nw.filterProps = ["gap"];
const Iw = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = p0(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: Qf(t, o)
    });
    return ci(e, e.columnGap, n);
  }
  return null;
};
Iw.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: bd
} : {};
Iw.filterProps = ["columnGap"];
const _w = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = p0(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: Qf(t, o)
    });
    return ci(e, e.rowGap, n);
  }
  return null;
};
_w.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: bd
} : {};
_w.filterProps = ["rowGap"];
const KG = qr({
  prop: "gridColumn"
}), XG = qr({
  prop: "gridRow"
}), QG = qr({
  prop: "gridAutoFlow"
}), JG = qr({
  prop: "gridAutoColumns"
}), ZG = qr({
  prop: "gridAutoRows"
}), eK = qr({
  prop: "gridTemplateColumns"
}), tK = qr({
  prop: "gridTemplateRows"
}), nK = qr({
  prop: "gridTemplateAreas"
}), rK = qr({
  prop: "gridArea"
});
kw(Nw, Iw, _w, KG, XG, QG, JG, ZG, eK, tK, nK, rK);
function ev(e, t) {
  return t === "grey" ? t : e;
}
const oK = qr({
  prop: "color",
  themeKey: "palette",
  transform: ev
}), aK = qr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: ev
}), iK = qr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: ev
});
kw(oK, aK, iK);
function Ii(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const sK = qr({
  prop: "width",
  transform: Ii
}), AD = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, s;
      const l = ((o = e.theme) == null || (o = o.breakpoints) == null || (o = o.values) == null ? void 0 : o[n]) || ID[n];
      return l ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${l}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: l
      } : {
        maxWidth: Ii(n)
      };
    };
    return ci(e, e.maxWidth, t);
  }
  return null;
};
AD.filterProps = ["maxWidth"];
const lK = qr({
  prop: "minWidth",
  transform: Ii
}), cK = qr({
  prop: "height",
  transform: Ii
}), uK = qr({
  prop: "maxHeight",
  transform: Ii
}), dK = qr({
  prop: "minHeight",
  transform: Ii
});
qr({
  prop: "size",
  cssProperty: "width",
  transform: Ii
});
qr({
  prop: "size",
  cssProperty: "height",
  transform: Ii
});
const fK = qr({
  prop: "boxSizing"
});
kw(sK, AD, lK, cK, uK, dK, fK);
const Aw = {
  // borders
  border: {
    themeKey: "borders",
    transform: os
  },
  borderTop: {
    themeKey: "borders",
    transform: os
  },
  borderRight: {
    themeKey: "borders",
    transform: os
  },
  borderBottom: {
    themeKey: "borders",
    transform: os
  },
  borderLeft: {
    themeKey: "borders",
    transform: os
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: os
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Mw
  },
  // palette
  color: {
    themeKey: "palette",
    transform: ev
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: ev
  },
  backgroundColor: {
    themeKey: "palette",
    transform: ev
  },
  // spacing
  p: {
    style: Ir
  },
  pt: {
    style: Ir
  },
  pr: {
    style: Ir
  },
  pb: {
    style: Ir
  },
  pl: {
    style: Ir
  },
  px: {
    style: Ir
  },
  py: {
    style: Ir
  },
  padding: {
    style: Ir
  },
  paddingTop: {
    style: Ir
  },
  paddingRight: {
    style: Ir
  },
  paddingBottom: {
    style: Ir
  },
  paddingLeft: {
    style: Ir
  },
  paddingX: {
    style: Ir
  },
  paddingY: {
    style: Ir
  },
  paddingInline: {
    style: Ir
  },
  paddingInlineStart: {
    style: Ir
  },
  paddingInlineEnd: {
    style: Ir
  },
  paddingBlock: {
    style: Ir
  },
  paddingBlockStart: {
    style: Ir
  },
  paddingBlockEnd: {
    style: Ir
  },
  m: {
    style: Nr
  },
  mt: {
    style: Nr
  },
  mr: {
    style: Nr
  },
  mb: {
    style: Nr
  },
  ml: {
    style: Nr
  },
  mx: {
    style: Nr
  },
  my: {
    style: Nr
  },
  margin: {
    style: Nr
  },
  marginTop: {
    style: Nr
  },
  marginRight: {
    style: Nr
  },
  marginBottom: {
    style: Nr
  },
  marginLeft: {
    style: Nr
  },
  marginX: {
    style: Nr
  },
  marginY: {
    style: Nr
  },
  marginInline: {
    style: Nr
  },
  marginInlineStart: {
    style: Nr
  },
  marginInlineEnd: {
    style: Nr
  },
  marginBlock: {
    style: Nr
  },
  marginBlockStart: {
    style: Nr
  },
  marginBlockEnd: {
    style: Nr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Nw
  },
  rowGap: {
    style: _w
  },
  columnGap: {
    style: Iw
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Ii
  },
  maxWidth: {
    style: AD
  },
  minWidth: {
    transform: Ii
  },
  height: {
    transform: Ii
  },
  maxHeight: {
    transform: Ii
  },
  minHeight: {
    transform: Ii
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function pK(...e) {
  const t = e.reduce((o, s) => o.concat(Object.keys(s)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
function hK(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function mK() {
  function e(n, o, s, l) {
    const u = {
      [n]: o,
      theme: s
    }, p = l[n];
    if (!p)
      return {
        [n]: o
      };
    const {
      cssProperty: h = n,
      themeKey: m,
      transform: b,
      style: x
    } = p;
    if (o == null)
      return null;
    if (m === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const S = lv(s, m) || {};
    return x ? x(u) : ci(u, o, (T) => {
      let E = z1(S, b, T);
      return T === E && typeof T == "string" && (E = z1(S, b, `${n}${T === "default" ? "" : Ae(T)}`, T)), h === !1 ? E : {
        [h]: E
      };
    });
  }
  function t(n) {
    var o;
    const {
      sx: s,
      theme: l = {}
    } = n || {};
    if (!s)
      return null;
    const u = (o = l.unstable_sxConfig) != null ? o : Aw;
    function p(h) {
      let m = h;
      if (typeof h == "function")
        m = h(l);
      else if (typeof h != "object")
        return h;
      if (!m)
        return null;
      const b = RB(l.breakpoints), x = Object.keys(b);
      let S = b;
      return Object.keys(m).forEach((R) => {
        const T = hK(m[R], l);
        if (T != null)
          if (typeof T == "object")
            if (u[R])
              S = wb(S, e(R, T, l, u));
            else {
              const E = ci({
                theme: l
              }, T, (P) => ({
                [R]: P
              }));
              pK(E, T) ? S[R] = t({
                sx: T,
                theme: l
              }) : S = wb(S, E);
            }
          else
            S = wb(S, e(R, T, l, u));
      }), OB(x, S);
    }
    return Array.isArray(s) ? s.map(p) : p(s);
  }
  return t;
}
const h0 = mK();
h0.filterProps = ["sx"];
function vK(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const gK = ["breakpoints", "palette", "spacing", "shape"];
function Lw(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: s,
    shape: l = {}
  } = e, u = Te(e, gK), p = EG(n), h = AG(s);
  let m = ai({
    breakpoints: p,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: O({
      mode: "light"
    }, o),
    spacing: h,
    shape: O({}, RG, l)
  }, u);
  return m.applyStyles = vK, m = t.reduce((b, x) => ai(b, x), m), m.unstable_sxConfig = O({}, Aw, u == null ? void 0 : u.unstable_sxConfig), m.unstable_sx = function(x) {
    return h0({
      sx: x,
      theme: this
    });
  }, m;
}
function yK(e) {
  return Object.keys(e).length === 0;
}
function Fw(e = null) {
  const t = D.useContext(yd);
  return !t || yK(t) ? e : t;
}
const bK = Lw();
function jw(e = bK) {
  return Fw(e);
}
function $B({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const o = jw(n), s = typeof e == "function" ? e(t && o[t] || o) : e;
  return /* @__PURE__ */ I(TB, {
    styles: s
  });
}
process.env.NODE_ENV !== "production" && ($B.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: r.object,
  /**
   * @ignore
   */
  styles: r.oneOfType([r.array, r.func, r.number, r.object, r.string, r.bool]),
  /**
   * @ignore
   */
  themeId: r.string
});
const xK = ["sx"], SK = (e) => {
  var t, n;
  const o = {
    systemProps: {},
    otherProps: {}
  }, s = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : Aw;
  return Object.keys(e).forEach((l) => {
    s[l] ? o.systemProps[l] = e[l] : o.otherProps[l] = e[l];
  }), o;
};
function Vw(e) {
  const {
    sx: t
  } = e, n = Te(e, xK), {
    systemProps: o,
    otherProps: s
  } = SK(n);
  let l;
  return Array.isArray(t) ? l = [o, ...t] : typeof t == "function" ? l = (...u) => {
    const p = t(...u);
    return od(p) ? O({}, o, p) : o;
  } : l = O({}, o, t), O({}, s, {
    sx: l
  });
}
const CK = ["className", "component"];
function wK(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: o = "MuiBox-root",
    generateClassName: s
  } = e, l = EB("div", {
    shouldForwardProp: (p) => p !== "theme" && p !== "sx" && p !== "as"
  })(h0);
  return /* @__PURE__ */ D.forwardRef(function(h, m) {
    const b = jw(n), x = Vw(h), {
      className: S,
      component: R = "div"
    } = x, T = Te(x, CK);
    return /* @__PURE__ */ I(l, O({
      as: R,
      ref: m,
      className: Ne(S, s ? s(o) : o),
      theme: t && b[t] || b
    }, T));
  });
}
const TK = ["ownerState"], EK = ["variants"], RK = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function OK(e) {
  return Object.keys(e).length === 0;
}
function PK(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Tb(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const $K = Lw(), LA = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function t1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return OK(t) ? e : t[n] || t;
}
function DK(e) {
  return e ? (t, n) => n[e] : null;
}
function O1(e, t) {
  let {
    ownerState: n
  } = t, o = Te(t, TK);
  const s = typeof e == "function" ? e(O({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(s))
    return s.flatMap((l) => O1(l, O({
      ownerState: n
    }, o)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: l = []
    } = s;
    let p = Te(s, EK);
    return l.forEach((h) => {
      let m = !0;
      typeof h.props == "function" ? m = h.props(O({
        ownerState: n
      }, o, n)) : Object.keys(h.props).forEach((b) => {
        (n == null ? void 0 : n[b]) !== h.props[b] && o[b] !== h.props[b] && (m = !1);
      }), m && (Array.isArray(p) || (p = [p]), p.push(typeof h.style == "function" ? h.style(O({
        ownerState: n
      }, o, n)) : h.style));
    }), p;
  }
  return s;
}
function DB(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = $K,
    rootShouldForwardProp: o = Tb,
    slotShouldForwardProp: s = Tb
  } = e, l = (u) => h0(O({}, u, {
    theme: t1(O({}, u, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return l.__mui_systemSx = !0, (u, p = {}) => {
    CG(u, (N) => N.filter((V) => !(V != null && V.__mui_systemSx)));
    const {
      name: h,
      slot: m,
      skipVariantsResolver: b,
      skipSx: x,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: S = DK(LA(m))
    } = p, R = Te(p, RK), T = b !== void 0 ? b : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), E = x || !1;
    let P;
    process.env.NODE_ENV !== "production" && h && (P = `${h}-${LA(m || "Root")}`);
    let k = Tb;
    m === "Root" || m === "root" ? k = o : m ? k = s : PK(u) && (k = void 0);
    const _ = EB(u, O({
      shouldForwardProp: k,
      label: P
    }, R)), L = (N) => typeof N == "function" && N.__emotion_real !== N || od(N) ? (V) => O1(N, O({}, V, {
      theme: t1({
        theme: V.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : N, F = (N, ...V) => {
      let z = L(N);
      const H = V ? V.map(L) : [];
      h && S && H.push((X) => {
        const ne = t1(O({}, X, {
          defaultTheme: n,
          themeId: t
        }));
        if (!ne.components || !ne.components[h] || !ne.components[h].styleOverrides)
          return null;
        const Y = ne.components[h].styleOverrides, J = {};
        return Object.entries(Y).forEach(([te, Z]) => {
          J[te] = O1(Z, O({}, X, {
            theme: ne
          }));
        }), S(X, J);
      }), h && !T && H.push((X) => {
        var ne;
        const Y = t1(O({}, X, {
          defaultTheme: n,
          themeId: t
        })), J = Y == null || (ne = Y.components) == null || (ne = ne[h]) == null ? void 0 : ne.variants;
        return O1({
          variants: J
        }, O({}, X, {
          theme: Y
        }));
      }), E || H.push(l);
      const ee = H.length - V.length;
      if (Array.isArray(N) && ee > 0) {
        const X = new Array(ee).fill("");
        z = [...N, ...X], z.raw = [...N.raw, ...X];
      }
      const K = _(z, ...H);
      if (process.env.NODE_ENV !== "production") {
        let X;
        h && (X = `${h}${Ae(m || "")}`), X === void 0 && (X = `Styled(${Hq(u)})`), K.displayName = X;
      }
      return u.muiName && (K.muiName = u.muiName), K;
    };
    return _.withConfig && (F.withConfig = _.withConfig), F;
  };
}
const kK = DB();
function kB(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? o : wD(t.components[n].defaultProps, o);
}
function MB({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: o
}) {
  let s = jw(n);
  return o && (s = s[o] || s), kB({
    theme: s,
    name: t,
    props: e
  });
}
function LD(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), cY(e, t, n);
}
function MK(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, s) => s < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Jf(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Jf(MK(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : dd(9, e));
  let o = e.substring(t + 1, e.length - 1), s;
  if (n === "color") {
    if (o = o.split(" "), s = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : dd(10, s));
  } else
    o = o.split(",");
  return o = o.map((l) => parseFloat(l)), {
    type: n,
    values: o,
    colorSpace: s
  };
}
function Bw(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.indexOf("rgb") !== -1 ? o = o.map((s, l) => l < 3 ? parseInt(s, 10) : s) : t.indexOf("hsl") !== -1 && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.indexOf("color") !== -1 ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function NK(e) {
  e = Jf(e);
  const {
    values: t
  } = e, n = t[0], o = t[1] / 100, s = t[2] / 100, l = o * Math.min(s, 1 - s), u = (m, b = (m + n / 30) % 12) => s - l * Math.max(Math.min(b - 3, 9 - b, 1), -1);
  let p = "rgb";
  const h = [Math.round(u(0) * 255), Math.round(u(8) * 255), Math.round(u(4) * 255)];
  return e.type === "hsla" && (p += "a", h.push(t[3])), Bw({
    type: p,
    values: h
  });
}
function FA(e) {
  e = Jf(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Jf(NK(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function jA(e, t) {
  const n = FA(e), o = FA(t);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
function Mt(e, t) {
  return e = Jf(e), t = LD(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Bw(e);
}
function zw(e, t) {
  if (e = Jf(e), t = LD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Bw(e);
}
function Uw(e, t) {
  if (e = Jf(e), t = LD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Bw(e);
}
const FD = /* @__PURE__ */ D.createContext(null);
process.env.NODE_ENV !== "production" && (FD.displayName = "ThemeContext");
function NB() {
  const e = D.useContext(FD);
  return process.env.NODE_ENV !== "production" && D.useDebugValue(e), e;
}
const IK = typeof Symbol == "function" && Symbol.for, _K = IK ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function AK(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return O({}, e, t);
}
function U1(e) {
  const {
    children: t,
    theme: n
  } = e, o = NB();
  process.env.NODE_ENV !== "production" && o === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = D.useMemo(() => {
    const l = o === null ? n : AK(o, n);
    return l != null && (l[_K] = o !== null), l;
  }, [n, o]);
  return /* @__PURE__ */ I(FD.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (U1.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.object, r.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (U1.propTypes = u0(U1.propTypes));
const LK = ["value"], FK = /* @__PURE__ */ D.createContext();
function IB(e) {
  let {
    value: t
  } = e, n = Te(e, LK);
  return /* @__PURE__ */ I(FK.Provider, O({
    value: t ?? !0
  }, n));
}
process.env.NODE_ENV !== "production" && (IB.propTypes = {
  children: r.node,
  value: r.bool
});
const jK = /* @__PURE__ */ D.createContext(void 0);
function _B({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ I(jK.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (_B.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.node,
  /**
   * @ignore
   */
  value: r.object
});
const VA = {};
function BA(e, t, n, o = !1) {
  return D.useMemo(() => {
    const s = e && t[e] || t;
    if (typeof n == "function") {
      const l = n(s), u = e ? O({}, t, {
        [e]: l
      }) : l;
      return o ? () => u : u;
    }
    return e ? O({}, t, {
      [e]: n
    }) : O({}, t, n);
  }, [e, t, n, o]);
}
function H1(e) {
  const {
    children: t,
    theme: n,
    themeId: o
  } = e, s = Fw(VA), l = NB() || VA;
  process.env.NODE_ENV !== "production" && (s === null && typeof n == "function" || o && s && !s[o] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const u = BA(o, s, n), p = BA(o, l, n, !0), h = u.direction === "rtl";
  return /* @__PURE__ */ I(U1, {
    theme: p,
    children: /* @__PURE__ */ I(yd.Provider, {
      value: u,
      children: /* @__PURE__ */ I(IB, {
        value: h,
        children: /* @__PURE__ */ I(_B, {
          value: u == null ? void 0 : u.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (H1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.func, r.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: r.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (H1.propTypes = u0(H1.propTypes));
const VK = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], BK = Lw(), zK = kK("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function UK(e) {
  return MB({
    props: e,
    name: "MuiStack",
    defaultTheme: BK
  });
}
function HK(e, t) {
  const n = D.Children.toArray(e).filter(Boolean);
  return n.reduce((o, s, l) => (o.push(s), l < n.length - 1 && o.push(/* @__PURE__ */ D.cloneElement(t, {
    key: `separator-${l}`
  })), o), []);
}
const WK = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], qK = ({
  ownerState: e,
  theme: t
}) => {
  let n = O({
    display: "flex",
    flexDirection: "column"
  }, ci({
    theme: t
  }, qf({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (o) => ({
    flexDirection: o
  })));
  if (e.spacing) {
    const o = _D(t), s = Object.keys(t.breakpoints.values).reduce((h, m) => ((typeof e.spacing == "object" && e.spacing[m] != null || typeof e.direction == "object" && e.direction[m] != null) && (h[m] = !0), h), {}), l = qf({
      values: e.direction,
      base: s
    }), u = qf({
      values: e.spacing,
      base: s
    });
    typeof l == "object" && Object.keys(l).forEach((h, m, b) => {
      if (!l[h]) {
        const S = m > 0 ? l[b[m - 1]] : "column";
        l[h] = S;
      }
    }), n = ai(n, ci({
      theme: t
    }, u, (h, m) => e.useFlexGap ? {
      gap: Qf(o, h)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${WK(m ? l[m] : e.direction)}`]: Qf(o, h)
      }
    }));
  }
  return n = OG(t.breakpoints, n), n;
};
function YK(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = zK,
    useThemeProps: n = UK,
    componentName: o = "MuiStack"
  } = e, s = () => vt({
    root: ["root"]
  }, (h) => pt(o, h), {}), l = t(qK), u = /* @__PURE__ */ D.forwardRef(function(h, m) {
    const b = n(h), x = Vw(b), {
      component: S = "div",
      direction: R = "column",
      spacing: T = 0,
      divider: E,
      children: P,
      className: k,
      useFlexGap: _ = !1
    } = x, L = Te(x, VK), F = {
      direction: R,
      spacing: T,
      useFlexGap: _
    }, N = s();
    return /* @__PURE__ */ I(l, O({
      as: S,
      ownerState: F,
      ref: m,
      className: Ne(N.root, k)
    }, L, {
      children: E ? HK(P, E) : P
    }));
  });
  return process.env.NODE_ENV !== "production" && (u.propTypes = {
    children: r.node,
    direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
    divider: r.node,
    spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
    sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
  }), u;
}
function GK(e, t) {
  return O({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
const zb = {
  black: "#000",
  white: "#fff"
}, KK = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, xm = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Sm = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, eb = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Cm = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, wm = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Tm = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, XK = ["mode", "contrastThreshold", "tonalOffset"], zA = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: zb.white,
    default: zb.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, YP = {
  text: {
    primary: zb.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: zb.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function UA(e, t, n, o) {
  const s = o.light || o, l = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Uw(e.main, s) : t === "dark" && (e.dark = zw(e.main, l)));
}
function QK(e = "light") {
  return e === "dark" ? {
    main: Cm[200],
    light: Cm[50],
    dark: Cm[400]
  } : {
    main: Cm[700],
    light: Cm[400],
    dark: Cm[800]
  };
}
function JK(e = "light") {
  return e === "dark" ? {
    main: xm[200],
    light: xm[50],
    dark: xm[400]
  } : {
    main: xm[500],
    light: xm[300],
    dark: xm[700]
  };
}
function ZK(e = "light") {
  return e === "dark" ? {
    main: Sm[500],
    light: Sm[300],
    dark: Sm[700]
  } : {
    main: Sm[700],
    light: Sm[400],
    dark: Sm[800]
  };
}
function eX(e = "light") {
  return e === "dark" ? {
    main: wm[400],
    light: wm[300],
    dark: wm[700]
  } : {
    main: wm[700],
    light: wm[500],
    dark: wm[900]
  };
}
function tX(e = "light") {
  return e === "dark" ? {
    main: Tm[400],
    light: Tm[300],
    dark: Tm[700]
  } : {
    main: Tm[800],
    light: Tm[500],
    dark: Tm[900]
  };
}
function nX(e = "light") {
  return e === "dark" ? {
    main: eb[400],
    light: eb[300],
    dark: eb[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: eb[500],
    dark: eb[900]
  };
}
function rX(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2
  } = e, s = Te(e, XK), l = e.primary || QK(t), u = e.secondary || JK(t), p = e.error || ZK(t), h = e.info || eX(t), m = e.success || tX(t), b = e.warning || nX(t);
  function x(E) {
    const P = jA(E, YP.text.primary) >= n ? YP.text.primary : zA.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const k = jA(E, P);
      k < 3 && console.error([`MUI: The contrast ratio of ${k}:1 for ${P} on ${E}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return P;
  }
  const S = ({
    color: E,
    name: P,
    mainShade: k = 500,
    lightShade: _ = 300,
    darkShade: L = 700
  }) => {
    if (E = O({}, E), !E.main && E[k] && (E.main = E[k]), !E.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${P ? ` (${P})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${k}\` property.` : dd(11, P ? ` (${P})` : "", k));
    if (typeof E.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${P ? ` (${P})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(E.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : dd(12, P ? ` (${P})` : "", JSON.stringify(E.main)));
    return UA(E, "light", _, o), UA(E, "dark", L, o), E.contrastText || (E.contrastText = x(E.main)), E;
  }, R = {
    dark: YP,
    light: zA
  };
  return process.env.NODE_ENV !== "production" && (R[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), ai(O({
    // A collection of common colors.
    common: O({}, zb),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: S({
      color: l,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: S({
      color: u,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: S({
      color: p,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: S({
      color: b,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: S({
      color: h,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: S({
      color: m,
      name: "success"
    }),
    // The grey colors.
    grey: KK,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: x,
    // Generate a rich color object.
    augmentColor: S,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o
  }, R[t]), s);
}
const oX = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function aX(e) {
  return Math.round(e * 1e5) / 1e5;
}
const HA = {
  textTransform: "uppercase"
}, WA = '"Roboto", "Helvetica", "Arial", sans-serif';
function iX(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: o = WA,
    // The default font size of the Material Specification.
    fontSize: s = 14,
    // px
    fontWeightLight: l = 300,
    fontWeightRegular: u = 400,
    fontWeightMedium: p = 500,
    fontWeightBold: h = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: m = 16,
    // Apply the CSS properties to all the variants.
    allVariants: b,
    pxToRem: x
  } = n, S = Te(n, oX);
  process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof m != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const R = s / 14, T = x || ((k) => `${k / m * R}rem`), E = (k, _, L, F, N) => O({
    fontFamily: o,
    fontWeight: k,
    fontSize: T(_),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: L
  }, o === WA ? {
    letterSpacing: `${aX(F / _)}em`
  } : {}, N, b), P = {
    h1: E(l, 96, 1.167, -1.5),
    h2: E(l, 60, 1.2, -0.5),
    h3: E(u, 48, 1.167, 0),
    h4: E(u, 34, 1.235, 0.25),
    h5: E(u, 24, 1.334, 0),
    h6: E(p, 20, 1.6, 0.15),
    subtitle1: E(u, 16, 1.75, 0.15),
    subtitle2: E(p, 14, 1.57, 0.1),
    body1: E(u, 16, 1.5, 0.15),
    body2: E(u, 14, 1.43, 0.15),
    button: E(p, 14, 1.75, 0.4, HA),
    caption: E(u, 12, 1.66, 0.4),
    overline: E(u, 12, 2.66, 1, HA),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ai(O({
    htmlFontSize: m,
    pxToRem: T,
    fontFamily: o,
    fontSize: s,
    fontWeightLight: l,
    fontWeightRegular: u,
    fontWeightMedium: p,
    fontWeightBold: h
  }, P), S, {
    clone: !1
    // No need to clone deep
  });
}
const sX = 0.2, lX = 0.14, cX = 0.12;
function xr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${sX})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${lX})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${cX})`].join(",");
}
const uX = ["none", xr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), xr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), xr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), xr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), xr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), xr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), xr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), xr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), xr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), xr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), xr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), xr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), xr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), xr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), xr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), xr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), xr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), xr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), xr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), xr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), xr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), xr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), xr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), xr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], dX = ["duration", "easing", "delay"], fX = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, AB = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function qA(e) {
  return `${Math.round(e)}ms`;
}
function pX(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function hX(e) {
  const t = O({}, fX, e.easing), n = O({}, AB, e.duration);
  return O({
    getAutoHeightDuration: pX,
    create: (s = ["all"], l = {}) => {
      const {
        duration: u = n.standard,
        easing: p = t.easeInOut,
        delay: h = 0
      } = l, m = Te(l, dX);
      if (process.env.NODE_ENV !== "production") {
        const b = (S) => typeof S == "string", x = (S) => !isNaN(parseFloat(S));
        !b(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !x(u) && !b(u) && console.error(`MUI: Argument "duration" must be a number or a string but found ${u}.`), b(p) || console.error('MUI: Argument "easing" must be a string.'), !x(h) && !b(h) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof l != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(m).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(m).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((b) => `${b} ${typeof u == "string" ? u : qA(u)} ${p} ${typeof h == "string" ? h : qA(h)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const mX = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, vX = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function jD(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: o = {},
    transitions: s = {},
    typography: l = {}
  } = e, u = Te(e, vX);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : dd(18));
  const p = rX(o), h = Lw(e);
  let m = ai(h, {
    mixins: GK(h.breakpoints, n),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: uX.slice(),
    typography: iX(p, l),
    transitions: hX(s),
    zIndex: O({}, mX)
  });
  if (m = ai(m, u), m = t.reduce((b, x) => ai(b, x), m), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], x = (S, R) => {
      let T;
      for (T in S) {
        const E = S[T];
        if (b.indexOf(T) !== -1 && Object.keys(E).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const P = pt("", T);
            console.error([`MUI: The \`${R}\` component increases the CSS specificity of the \`${T}\` internal state.`, "You can not override it like this: ", JSON.stringify(S, null, 2), "", `Instead, you need to use the '&.${P}' syntax:`, JSON.stringify({
              root: {
                [`&.${P}`]: E
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          S[T] = {};
        }
      }
    };
    Object.keys(m.components).forEach((S) => {
      const R = m.components[S].styleOverrides;
      R && S.indexOf("Mui") === 0 && x(R, S);
    });
  }
  return m.unstable_sxConfig = O({}, Aw, u == null ? void 0 : u.unstable_sxConfig), m.unstable_sx = function(x) {
    return h0({
      sx: x,
      theme: this
    });
  }, m;
}
function gX(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function yX(e) {
  return parseFloat(e);
}
const Hw = jD();
function Go() {
  const e = jw(Hw);
  return process.env.NODE_ENV !== "production" && D.useDebugValue(e), e[Xf] || e;
}
function We({
  props: e,
  name: t
}) {
  return MB({
    props: e,
    name: t,
    defaultTheme: Hw,
    themeId: Xf
  });
}
const Do = (e) => Tb(e) && e !== "classes", bX = Tb, ce = DB({
  themeId: Xf,
  defaultTheme: Hw,
  rootShouldForwardProp: Do
}), xX = ["theme"];
function LB(e) {
  let {
    theme: t
  } = e, n = Te(e, xX);
  const o = t[Xf];
  return /* @__PURE__ */ I(H1, O({}, n, {
    themeId: o ? Xf : void 0,
    theme: o || t
  }));
}
process.env.NODE_ENV !== "production" && (LB.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.object, r.func]).isRequired
});
const YA = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, W2e = {
  seed: "jv"
}, SX = {}, CX = jD(SX);
function wX(e, t = LB) {
  return ({ children: n }) => /* @__PURE__ */ I(ND, { injectFirst: !0, children: /* @__PURE__ */ I(t, { theme: e, children: n }) });
}
const q2e = wX(CX), Y2e = ({ children: e }) => /* @__PURE__ */ I(ND, { injectFirst: !0, children: e });
function TX(e) {
  return pt("MuiSvgIcon", e);
}
ht("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const EX = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], RX = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, s = {
    root: ["root", t !== "inherit" && `color${Ae(t)}`, `fontSize${Ae(n)}`]
  };
  return vt(s, TX, o);
}, OX = ce("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ae(n.color)}`], t[`fontSize${Ae(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o, s, l, u, p, h, m, b, x, S, R, T;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (o = n.create) == null ? void 0 : o.call(n, "fill", {
      duration: (s = e.transitions) == null || (s = s.duration) == null ? void 0 : s.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((l = e.typography) == null || (u = l.pxToRem) == null ? void 0 : u.call(l, 20)) || "1.25rem",
      medium: ((p = e.typography) == null || (h = p.pxToRem) == null ? void 0 : h.call(p, 24)) || "1.5rem",
      large: ((m = e.typography) == null || (b = m.pxToRem) == null ? void 0 : b.call(m, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (x = (S = (e.vars || e).palette) == null || (S = S[t.color]) == null ? void 0 : S.main) != null ? x : {
      action: (R = (e.vars || e).palette) == null || (R = R.action) == null ? void 0 : R.active,
      disabled: (T = (e.vars || e).palette) == null || (T = T.action) == null ? void 0 : T.disabled,
      inherit: void 0
    }[t.color]
  };
}), Ub = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: s,
    className: l,
    color: u = "inherit",
    component: p = "svg",
    fontSize: h = "medium",
    htmlColor: m,
    inheritViewBox: b = !1,
    titleAccess: x,
    viewBox: S = "0 0 24 24"
  } = o, R = Te(o, EX), T = /* @__PURE__ */ D.isValidElement(s) && s.type === "svg", E = O({}, o, {
    color: u,
    component: p,
    fontSize: h,
    instanceFontSize: t.fontSize,
    inheritViewBox: b,
    viewBox: S,
    hasSvgAsChild: T
  }), P = {};
  b || (P.viewBox = S);
  const k = RX(E);
  return /* @__PURE__ */ qe(OX, O({
    as: p,
    className: Ne(k.root, l),
    focusable: "false",
    color: m,
    "aria-hidden": x ? void 0 : !0,
    role: x ? "img" : void 0,
    ref: n
  }, P, R, T && s.props, {
    ownerState: E,
    children: [T ? s.props.children : s, x ? /* @__PURE__ */ I("title", {
      children: x
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Ub.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: r.oneOfType([r.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: r.oneOfType([r.oneOf(["inherit", "large", "medium", "small"]), r.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: r.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: r.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: r.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: r.string
});
Ub.muiName = "SvgIcon";
function lr(e, t) {
  function n(o, s) {
    return /* @__PURE__ */ I(Ub, O({
      "data-testid": `${t}Icon`,
      ref: s
    }, o, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Ub.muiName, /* @__PURE__ */ D.memo(/* @__PURE__ */ D.forwardRef(n));
}
const PX = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), ww.configure(e);
  }
}, $X = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Ae,
  createChainedFunction: F1,
  createSvgIcon: lr,
  debounce: bv,
  deprecatedPropType: Wq,
  isMuiElement: Jm,
  ownerDocument: no,
  ownerWindow: us,
  requirePropFactory: tB,
  setRef: Fb,
  unstable_ClassNameGenerator: PX,
  unstable_useEnhancedEffect: $a,
  unstable_useId: Vc,
  unsupportedProp: SD,
  useControlled: jl,
  useEventCallback: qo,
  useForkRef: Gn,
  useIsFocusVisible: Cw
}, Symbol.toStringTag, { value: "Module" }));
function F$(e, t) {
  return F$ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, F$(e, t);
}
function VD(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, F$(e, t);
}
function DX(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function kX(e, t) {
  e.classList ? e.classList.add(t) : DX(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function GA(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function MX(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = GA(e.className, t) : e.setAttribute("class", GA(e.className && e.className.baseVal || "", t));
}
var j$ = { exports: {} }, ni = {}, n1 = { exports: {} }, GP = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KA;
function NX() {
  return KA || (KA = 1, function(e) {
    function t(U, G) {
      var W = U.length;
      U.push(G);
      e: for (; 0 < W; ) {
        var le = W - 1 >>> 1, pe = U[le];
        if (0 < s(pe, G)) U[le] = G, U[W] = pe, W = le;
        else break e;
      }
    }
    function n(U) {
      return U.length === 0 ? null : U[0];
    }
    function o(U) {
      if (U.length === 0) return null;
      var G = U[0], W = U.pop();
      if (W !== G) {
        U[0] = W;
        e: for (var le = 0, pe = U.length, ge = pe >>> 1; le < ge; ) {
          var we = 2 * (le + 1) - 1, de = U[we], se = we + 1, ve = U[se];
          if (0 > s(de, W)) se < pe && 0 > s(ve, de) ? (U[le] = ve, U[se] = W, le = se) : (U[le] = de, U[we] = W, le = we);
          else if (se < pe && 0 > s(ve, W)) U[le] = ve, U[se] = W, le = se;
          else break e;
        }
      }
      return G;
    }
    function s(U, G) {
      var W = U.sortIndex - G.sortIndex;
      return W !== 0 ? W : U.id - G.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var l = performance;
      e.unstable_now = function() {
        return l.now();
      };
    } else {
      var u = Date, p = u.now();
      e.unstable_now = function() {
        return u.now() - p;
      };
    }
    var h = [], m = [], b = 1, x = null, S = 3, R = !1, T = !1, E = !1, P = typeof setTimeout == "function" ? setTimeout : null, k = typeof clearTimeout == "function" ? clearTimeout : null, _ = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function L(U) {
      for (var G = n(m); G !== null; ) {
        if (G.callback === null) o(m);
        else if (G.startTime <= U) o(m), G.sortIndex = G.expirationTime, t(h, G);
        else break;
        G = n(m);
      }
    }
    function F(U) {
      if (E = !1, L(U), !T) if (n(h) !== null) T = !0, Z(N);
      else {
        var G = n(m);
        G !== null && ae(F, G.startTime - U);
      }
    }
    function N(U, G) {
      T = !1, E && (E = !1, k(H), H = -1), R = !0;
      var W = S;
      try {
        for (L(G), x = n(h); x !== null && (!(x.expirationTime > G) || U && !X()); ) {
          var le = x.callback;
          if (typeof le == "function") {
            x.callback = null, S = x.priorityLevel;
            var pe = le(x.expirationTime <= G);
            G = e.unstable_now(), typeof pe == "function" ? x.callback = pe : x === n(h) && o(h), L(G);
          } else o(h);
          x = n(h);
        }
        if (x !== null) var ge = !0;
        else {
          var we = n(m);
          we !== null && ae(F, we.startTime - G), ge = !1;
        }
        return ge;
      } finally {
        x = null, S = W, R = !1;
      }
    }
    var V = !1, z = null, H = -1, ee = 5, K = -1;
    function X() {
      return !(e.unstable_now() - K < ee);
    }
    function ne() {
      if (z !== null) {
        var U = e.unstable_now();
        K = U;
        var G = !0;
        try {
          G = z(!0, U);
        } finally {
          G ? Y() : (V = !1, z = null);
        }
      } else V = !1;
    }
    var Y;
    if (typeof _ == "function") Y = function() {
      _(ne);
    };
    else if (typeof MessageChannel < "u") {
      var J = new MessageChannel(), te = J.port2;
      J.port1.onmessage = ne, Y = function() {
        te.postMessage(null);
      };
    } else Y = function() {
      P(ne, 0);
    };
    function Z(U) {
      z = U, V || (V = !0, Y());
    }
    function ae(U, G) {
      H = P(function() {
        U(e.unstable_now());
      }, G);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, e.unstable_continueExecution = function() {
      T || R || (T = !0, Z(N));
    }, e.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : ee = 0 < U ? Math.floor(1e3 / U) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return S;
    }, e.unstable_getFirstCallbackNode = function() {
      return n(h);
    }, e.unstable_next = function(U) {
      switch (S) {
        case 1:
        case 2:
        case 3:
          var G = 3;
          break;
        default:
          G = S;
      }
      var W = S;
      S = G;
      try {
        return U();
      } finally {
        S = W;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(U, G) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var W = S;
      S = U;
      try {
        return G();
      } finally {
        S = W;
      }
    }, e.unstable_scheduleCallback = function(U, G, W) {
      var le = e.unstable_now();
      switch (typeof W == "object" && W !== null ? (W = W.delay, W = typeof W == "number" && 0 < W ? le + W : le) : W = le, U) {
        case 1:
          var pe = -1;
          break;
        case 2:
          pe = 250;
          break;
        case 5:
          pe = 1073741823;
          break;
        case 4:
          pe = 1e4;
          break;
        default:
          pe = 5e3;
      }
      return pe = W + pe, U = { id: b++, callback: G, priorityLevel: U, startTime: W, expirationTime: pe, sortIndex: -1 }, W > le ? (U.sortIndex = W, t(m, U), n(h) === null && U === n(m) && (E ? (k(H), H = -1) : E = !0, ae(F, W - le))) : (U.sortIndex = pe, t(h, U), T || R || (T = !0, Z(N))), U;
    }, e.unstable_shouldYield = X, e.unstable_wrapCallback = function(U) {
      var G = S;
      return function() {
        var W = S;
        S = G;
        try {
          return U.apply(this, arguments);
        } finally {
          S = W;
        }
      };
    };
  }(GP)), GP;
}
var KP = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XA;
function IX() {
  return XA || (XA = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, n = !1, o = 5;
      function s(et, st) {
        var jt = et.length;
        et.push(st), p(et, st, jt);
      }
      function l(et) {
        return et.length === 0 ? null : et[0];
      }
      function u(et) {
        if (et.length === 0)
          return null;
        var st = et[0], jt = et.pop();
        return jt !== st && (et[0] = jt, h(et, jt, 0)), st;
      }
      function p(et, st, jt) {
        for (var Xe = jt; Xe > 0; ) {
          var Be = Xe - 1 >>> 1, Qe = et[Be];
          if (m(Qe, st) > 0)
            et[Be] = st, et[Xe] = Qe, Xe = Be;
          else
            return;
        }
      }
      function h(et, st, jt) {
        for (var Xe = jt, Be = et.length, Qe = Be >>> 1; Xe < Qe; ) {
          var xt = (Xe + 1) * 2 - 1, ct = et[xt], St = xt + 1, tn = et[St];
          if (m(ct, st) < 0)
            St < Be && m(tn, ct) < 0 ? (et[Xe] = tn, et[St] = st, Xe = St) : (et[Xe] = ct, et[xt] = st, Xe = xt);
          else if (St < Be && m(tn, st) < 0)
            et[Xe] = tn, et[St] = st, Xe = St;
          else
            return;
        }
      }
      function m(et, st) {
        var jt = et.sortIndex - st.sortIndex;
        return jt !== 0 ? jt : et.id - st.id;
      }
      var b = 1, x = 2, S = 3, R = 4, T = 5;
      function E(et, st) {
      }
      var P = typeof performance == "object" && typeof performance.now == "function";
      if (P) {
        var k = performance;
        e.unstable_now = function() {
          return k.now();
        };
      } else {
        var _ = Date, L = _.now();
        e.unstable_now = function() {
          return _.now() - L;
        };
      }
      var F = 1073741823, N = -1, V = 250, z = 5e3, H = 1e4, ee = F, K = [], X = [], ne = 1, Y = null, J = S, te = !1, Z = !1, ae = !1, U = typeof setTimeout == "function" ? setTimeout : null, G = typeof clearTimeout == "function" ? clearTimeout : null, W = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function le(et) {
        for (var st = l(X); st !== null; ) {
          if (st.callback === null)
            u(X);
          else if (st.startTime <= et)
            u(X), st.sortIndex = st.expirationTime, s(K, st);
          else
            return;
          st = l(X);
        }
      }
      function pe(et) {
        if (ae = !1, le(et), !Z)
          if (l(K) !== null)
            Z = !0, fn(ge);
          else {
            var st = l(X);
            st !== null && ln(pe, st.startTime - et);
          }
      }
      function ge(et, st) {
        Z = !1, ae && (ae = !1, Rt()), te = !0;
        var jt = J;
        try {
          var Xe;
          if (!n) return we(et, st);
        } finally {
          Y = null, J = jt, te = !1;
        }
      }
      function we(et, st) {
        var jt = st;
        for (le(jt), Y = l(K); Y !== null && !t && !(Y.expirationTime > jt && (!et || lt())); ) {
          var Xe = Y.callback;
          if (typeof Xe == "function") {
            Y.callback = null, J = Y.priorityLevel;
            var Be = Y.expirationTime <= jt, Qe = Xe(Be);
            jt = e.unstable_now(), typeof Qe == "function" ? Y.callback = Qe : Y === l(K) && u(K), le(jt);
          } else
            u(K);
          Y = l(K);
        }
        if (Y !== null)
          return !0;
        var xt = l(X);
        return xt !== null && ln(pe, xt.startTime - jt), !1;
      }
      function de(et, st) {
        switch (et) {
          case b:
          case x:
          case S:
          case R:
          case T:
            break;
          default:
            et = S;
        }
        var jt = J;
        J = et;
        try {
          return st();
        } finally {
          J = jt;
        }
      }
      function se(et) {
        var st;
        switch (J) {
          case b:
          case x:
          case S:
            st = S;
            break;
          default:
            st = J;
            break;
        }
        var jt = J;
        J = st;
        try {
          return et();
        } finally {
          J = jt;
        }
      }
      function ve(et) {
        var st = J;
        return function() {
          var jt = J;
          J = st;
          try {
            return et.apply(this, arguments);
          } finally {
            J = jt;
          }
        };
      }
      function me(et, st, jt) {
        var Xe = e.unstable_now(), Be;
        if (typeof jt == "object" && jt !== null) {
          var Qe = jt.delay;
          typeof Qe == "number" && Qe > 0 ? Be = Xe + Qe : Be = Xe;
        } else
          Be = Xe;
        var xt;
        switch (et) {
          case b:
            xt = N;
            break;
          case x:
            xt = V;
            break;
          case T:
            xt = ee;
            break;
          case R:
            xt = H;
            break;
          case S:
          default:
            xt = z;
            break;
        }
        var ct = Be + xt, St = {
          id: ne++,
          callback: st,
          priorityLevel: et,
          startTime: Be,
          expirationTime: ct,
          sortIndex: -1
        };
        return Be > Xe ? (St.sortIndex = Be, s(X, St), l(K) === null && St === l(X) && (ae ? Rt() : ae = !0, ln(pe, Be - Xe))) : (St.sortIndex = ct, s(K, St), !Z && !te && (Z = !0, fn(ge))), St;
      }
      function Oe() {
      }
      function be() {
        !Z && !te && (Z = !0, fn(ge));
      }
      function De() {
        return l(K);
      }
      function ie(et) {
        et.callback = null;
      }
      function fe() {
        return J;
      }
      var ye = !1, Ee = null, _e = -1, Ve = o, Re = -1;
      function lt() {
        var et = e.unstable_now() - Re;
        return !(et < Ve);
      }
      function Pt() {
      }
      function at(et) {
        if (et < 0 || et > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        et > 0 ? Ve = Math.floor(1e3 / et) : Ve = o;
      }
      var it = function() {
        if (Ee !== null) {
          var et = e.unstable_now();
          Re = et;
          var st = !0, jt = !0;
          try {
            jt = Ee(st, et);
          } finally {
            jt ? bt() : (ye = !1, Ee = null);
          }
        } else
          ye = !1;
      }, bt;
      if (typeof W == "function")
        bt = function() {
          W(it);
        };
      else if (typeof MessageChannel < "u") {
        var Nt = new MessageChannel(), en = Nt.port2;
        Nt.port1.onmessage = it, bt = function() {
          en.postMessage(null);
        };
      } else
        bt = function() {
          U(it, 0);
        };
      function fn(et) {
        Ee = et, ye || (ye = !0, bt());
      }
      function ln(et, st) {
        _e = U(function() {
          et(e.unstable_now());
        }, st);
      }
      function Rt() {
        G(_e), _e = -1;
      }
      var rt = Pt, Qt = null;
      e.unstable_IdlePriority = T, e.unstable_ImmediatePriority = b, e.unstable_LowPriority = R, e.unstable_NormalPriority = S, e.unstable_Profiling = Qt, e.unstable_UserBlockingPriority = x, e.unstable_cancelCallback = ie, e.unstable_continueExecution = be, e.unstable_forceFrameRate = at, e.unstable_getCurrentPriorityLevel = fe, e.unstable_getFirstCallbackNode = De, e.unstable_next = se, e.unstable_pauseExecution = Oe, e.unstable_requestPaint = rt, e.unstable_runWithPriority = de, e.unstable_scheduleCallback = me, e.unstable_shouldYield = lt, e.unstable_wrapCallback = ve, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(KP)), KP;
}
var QA;
function FB() {
  return QA || (QA = 1, process.env.NODE_ENV === "production" ? n1.exports = NX() : n1.exports = IX()), n1.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JA;
function _X() {
  if (JA) return ni;
  JA = 1;
  var e = oe, t = FB();
  function n(c) {
    for (var d = "https://reactjs.org/docs/error-decoder.html?invariant=" + c, g = 1; g < arguments.length; g++) d += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + c + "; visit " + d + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = /* @__PURE__ */ new Set(), s = {};
  function l(c, d) {
    u(c, d), u(c + "Capture", d);
  }
  function u(c, d) {
    for (s[c] = d, c = 0; c < d.length; c++) o.add(d[c]);
  }
  var p = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h = Object.prototype.hasOwnProperty, m = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, b = {}, x = {};
  function S(c) {
    return h.call(x, c) ? !0 : h.call(b, c) ? !1 : m.test(c) ? x[c] = !0 : (b[c] = !0, !1);
  }
  function R(c, d, g, C) {
    if (g !== null && g.type === 0) return !1;
    switch (typeof d) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return C ? !1 : g !== null ? !g.acceptsBooleans : (c = c.toLowerCase().slice(0, 5), c !== "data-" && c !== "aria-");
      default:
        return !1;
    }
  }
  function T(c, d, g, C) {
    if (d === null || typeof d > "u" || R(c, d, g, C)) return !0;
    if (C) return !1;
    if (g !== null) switch (g.type) {
      case 3:
        return !d;
      case 4:
        return d === !1;
      case 5:
        return isNaN(d);
      case 6:
        return isNaN(d) || 1 > d;
    }
    return !1;
  }
  function E(c, d, g, C, $, A, q) {
    this.acceptsBooleans = d === 2 || d === 3 || d === 4, this.attributeName = C, this.attributeNamespace = $, this.mustUseProperty = g, this.propertyName = c, this.type = d, this.sanitizeURL = A, this.removeEmptyString = q;
  }
  var P = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(c) {
    P[c] = new E(c, 0, !1, c, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(c) {
    var d = c[0];
    P[d] = new E(d, 1, !1, c[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(c) {
    P[c] = new E(c, 2, !1, c.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(c) {
    P[c] = new E(c, 2, !1, c, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(c) {
    P[c] = new E(c, 3, !1, c.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(c) {
    P[c] = new E(c, 3, !0, c, null, !1, !1);
  }), ["capture", "download"].forEach(function(c) {
    P[c] = new E(c, 4, !1, c, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(c) {
    P[c] = new E(c, 6, !1, c, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(c) {
    P[c] = new E(c, 5, !1, c.toLowerCase(), null, !1, !1);
  });
  var k = /[\-:]([a-z])/g;
  function _(c) {
    return c[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(c) {
    var d = c.replace(
      k,
      _
    );
    P[d] = new E(d, 1, !1, c, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(c) {
    var d = c.replace(k, _);
    P[d] = new E(d, 1, !1, c, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(c) {
    var d = c.replace(k, _);
    P[d] = new E(d, 1, !1, c, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(c) {
    P[c] = new E(c, 1, !1, c.toLowerCase(), null, !1, !1);
  }), P.xlinkHref = new E("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(c) {
    P[c] = new E(c, 1, !1, c.toLowerCase(), null, !0, !0);
  });
  function L(c, d, g, C) {
    var $ = P.hasOwnProperty(d) ? P[d] : null;
    ($ !== null ? $.type !== 0 : C || !(2 < d.length) || d[0] !== "o" && d[0] !== "O" || d[1] !== "n" && d[1] !== "N") && (T(d, g, $, C) && (g = null), C || $ === null ? S(d) && (g === null ? c.removeAttribute(d) : c.setAttribute(d, "" + g)) : $.mustUseProperty ? c[$.propertyName] = g === null ? $.type === 3 ? !1 : "" : g : (d = $.attributeName, C = $.attributeNamespace, g === null ? c.removeAttribute(d) : ($ = $.type, g = $ === 3 || $ === 4 && g === !0 ? "" : "" + g, C ? c.setAttributeNS(C, d, g) : c.setAttribute(d, g))));
  }
  var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, N = Symbol.for("react.element"), V = Symbol.for("react.portal"), z = Symbol.for("react.fragment"), H = Symbol.for("react.strict_mode"), ee = Symbol.for("react.profiler"), K = Symbol.for("react.provider"), X = Symbol.for("react.context"), ne = Symbol.for("react.forward_ref"), Y = Symbol.for("react.suspense"), J = Symbol.for("react.suspense_list"), te = Symbol.for("react.memo"), Z = Symbol.for("react.lazy"), ae = Symbol.for("react.offscreen"), U = Symbol.iterator;
  function G(c) {
    return c === null || typeof c != "object" ? null : (c = U && c[U] || c["@@iterator"], typeof c == "function" ? c : null);
  }
  var W = Object.assign, le;
  function pe(c) {
    if (le === void 0) try {
      throw Error();
    } catch (g) {
      var d = g.stack.trim().match(/\n( *(at )?)/);
      le = d && d[1] || "";
    }
    return `
` + le + c;
  }
  var ge = !1;
  function we(c, d) {
    if (!c || ge) return "";
    ge = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (d) if (d = function() {
        throw Error();
      }, Object.defineProperty(d.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(d, []);
        } catch (Fe) {
          var C = Fe;
        }
        Reflect.construct(c, [], d);
      } else {
        try {
          d.call();
        } catch (Fe) {
          C = Fe;
        }
        c.call(d.prototype);
      }
      else {
        try {
          throw Error();
        } catch (Fe) {
          C = Fe;
        }
        c();
      }
    } catch (Fe) {
      if (Fe && C && typeof Fe.stack == "string") {
        for (var $ = Fe.stack.split(`
`), A = C.stack.split(`
`), q = $.length - 1, ue = A.length - 1; 1 <= q && 0 <= ue && $[q] !== A[ue]; ) ue--;
        for (; 1 <= q && 0 <= ue; q--, ue--) if ($[q] !== A[ue]) {
          if (q !== 1 || ue !== 1)
            do
              if (q--, ue--, 0 > ue || $[q] !== A[ue]) {
                var he = `
` + $[q].replace(" at new ", " at ");
                return c.displayName && he.includes("<anonymous>") && (he = he.replace("<anonymous>", c.displayName)), he;
              }
            while (1 <= q && 0 <= ue);
          break;
        }
      }
    } finally {
      ge = !1, Error.prepareStackTrace = g;
    }
    return (c = c ? c.displayName || c.name : "") ? pe(c) : "";
  }
  function de(c) {
    switch (c.tag) {
      case 5:
        return pe(c.type);
      case 16:
        return pe("Lazy");
      case 13:
        return pe("Suspense");
      case 19:
        return pe("SuspenseList");
      case 0:
      case 2:
      case 15:
        return c = we(c.type, !1), c;
      case 11:
        return c = we(c.type.render, !1), c;
      case 1:
        return c = we(c.type, !0), c;
      default:
        return "";
    }
  }
  function se(c) {
    if (c == null) return null;
    if (typeof c == "function") return c.displayName || c.name || null;
    if (typeof c == "string") return c;
    switch (c) {
      case z:
        return "Fragment";
      case V:
        return "Portal";
      case ee:
        return "Profiler";
      case H:
        return "StrictMode";
      case Y:
        return "Suspense";
      case J:
        return "SuspenseList";
    }
    if (typeof c == "object") switch (c.$$typeof) {
      case X:
        return (c.displayName || "Context") + ".Consumer";
      case K:
        return (c._context.displayName || "Context") + ".Provider";
      case ne:
        var d = c.render;
        return c = c.displayName, c || (c = d.displayName || d.name || "", c = c !== "" ? "ForwardRef(" + c + ")" : "ForwardRef"), c;
      case te:
        return d = c.displayName || null, d !== null ? d : se(c.type) || "Memo";
      case Z:
        d = c._payload, c = c._init;
        try {
          return se(c(d));
        } catch {
        }
    }
    return null;
  }
  function ve(c) {
    var d = c.type;
    switch (c.tag) {
      case 24:
        return "Cache";
      case 9:
        return (d.displayName || "Context") + ".Consumer";
      case 10:
        return (d._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return c = d.render, c = c.displayName || c.name || "", d.displayName || (c !== "" ? "ForwardRef(" + c + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return d;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return se(d);
      case 8:
        return d === H ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof d == "function") return d.displayName || d.name || null;
        if (typeof d == "string") return d;
    }
    return null;
  }
  function me(c) {
    switch (typeof c) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return c;
      case "object":
        return c;
      default:
        return "";
    }
  }
  function Oe(c) {
    var d = c.type;
    return (c = c.nodeName) && c.toLowerCase() === "input" && (d === "checkbox" || d === "radio");
  }
  function be(c) {
    var d = Oe(c) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(c.constructor.prototype, d), C = "" + c[d];
    if (!c.hasOwnProperty(d) && typeof g < "u" && typeof g.get == "function" && typeof g.set == "function") {
      var $ = g.get, A = g.set;
      return Object.defineProperty(c, d, { configurable: !0, get: function() {
        return $.call(this);
      }, set: function(q) {
        C = "" + q, A.call(this, q);
      } }), Object.defineProperty(c, d, { enumerable: g.enumerable }), { getValue: function() {
        return C;
      }, setValue: function(q) {
        C = "" + q;
      }, stopTracking: function() {
        c._valueTracker = null, delete c[d];
      } };
    }
  }
  function De(c) {
    c._valueTracker || (c._valueTracker = be(c));
  }
  function ie(c) {
    if (!c) return !1;
    var d = c._valueTracker;
    if (!d) return !0;
    var g = d.getValue(), C = "";
    return c && (C = Oe(c) ? c.checked ? "true" : "false" : c.value), c = C, c !== g ? (d.setValue(c), !0) : !1;
  }
  function fe(c) {
    if (c = c || (typeof document < "u" ? document : void 0), typeof c > "u") return null;
    try {
      return c.activeElement || c.body;
    } catch {
      return c.body;
    }
  }
  function ye(c, d) {
    var g = d.checked;
    return W({}, d, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: g ?? c._wrapperState.initialChecked });
  }
  function Ee(c, d) {
    var g = d.defaultValue == null ? "" : d.defaultValue, C = d.checked != null ? d.checked : d.defaultChecked;
    g = me(d.value != null ? d.value : g), c._wrapperState = { initialChecked: C, initialValue: g, controlled: d.type === "checkbox" || d.type === "radio" ? d.checked != null : d.value != null };
  }
  function _e(c, d) {
    d = d.checked, d != null && L(c, "checked", d, !1);
  }
  function Ve(c, d) {
    _e(c, d);
    var g = me(d.value), C = d.type;
    if (g != null) C === "number" ? (g === 0 && c.value === "" || c.value != g) && (c.value = "" + g) : c.value !== "" + g && (c.value = "" + g);
    else if (C === "submit" || C === "reset") {
      c.removeAttribute("value");
      return;
    }
    d.hasOwnProperty("value") ? lt(c, d.type, g) : d.hasOwnProperty("defaultValue") && lt(c, d.type, me(d.defaultValue)), d.checked == null && d.defaultChecked != null && (c.defaultChecked = !!d.defaultChecked);
  }
  function Re(c, d, g) {
    if (d.hasOwnProperty("value") || d.hasOwnProperty("defaultValue")) {
      var C = d.type;
      if (!(C !== "submit" && C !== "reset" || d.value !== void 0 && d.value !== null)) return;
      d = "" + c._wrapperState.initialValue, g || d === c.value || (c.value = d), c.defaultValue = d;
    }
    g = c.name, g !== "" && (c.name = ""), c.defaultChecked = !!c._wrapperState.initialChecked, g !== "" && (c.name = g);
  }
  function lt(c, d, g) {
    (d !== "number" || fe(c.ownerDocument) !== c) && (g == null ? c.defaultValue = "" + c._wrapperState.initialValue : c.defaultValue !== "" + g && (c.defaultValue = "" + g));
  }
  var Pt = Array.isArray;
  function at(c, d, g, C) {
    if (c = c.options, d) {
      d = {};
      for (var $ = 0; $ < g.length; $++) d["$" + g[$]] = !0;
      for (g = 0; g < c.length; g++) $ = d.hasOwnProperty("$" + c[g].value), c[g].selected !== $ && (c[g].selected = $), $ && C && (c[g].defaultSelected = !0);
    } else {
      for (g = "" + me(g), d = null, $ = 0; $ < c.length; $++) {
        if (c[$].value === g) {
          c[$].selected = !0, C && (c[$].defaultSelected = !0);
          return;
        }
        d !== null || c[$].disabled || (d = c[$]);
      }
      d !== null && (d.selected = !0);
    }
  }
  function it(c, d) {
    if (d.dangerouslySetInnerHTML != null) throw Error(n(91));
    return W({}, d, { value: void 0, defaultValue: void 0, children: "" + c._wrapperState.initialValue });
  }
  function bt(c, d) {
    var g = d.value;
    if (g == null) {
      if (g = d.children, d = d.defaultValue, g != null) {
        if (d != null) throw Error(n(92));
        if (Pt(g)) {
          if (1 < g.length) throw Error(n(93));
          g = g[0];
        }
        d = g;
      }
      d == null && (d = ""), g = d;
    }
    c._wrapperState = { initialValue: me(g) };
  }
  function Nt(c, d) {
    var g = me(d.value), C = me(d.defaultValue);
    g != null && (g = "" + g, g !== c.value && (c.value = g), d.defaultValue == null && c.defaultValue !== g && (c.defaultValue = g)), C != null && (c.defaultValue = "" + C);
  }
  function en(c) {
    var d = c.textContent;
    d === c._wrapperState.initialValue && d !== "" && d !== null && (c.value = d);
  }
  function fn(c) {
    switch (c) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ln(c, d) {
    return c == null || c === "http://www.w3.org/1999/xhtml" ? fn(d) : c === "http://www.w3.org/2000/svg" && d === "foreignObject" ? "http://www.w3.org/1999/xhtml" : c;
  }
  var Rt, rt = function(c) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(d, g, C, $) {
      MSApp.execUnsafeLocalFunction(function() {
        return c(d, g, C, $);
      });
    } : c;
  }(function(c, d) {
    if (c.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in c) c.innerHTML = d;
    else {
      for (Rt = Rt || document.createElement("div"), Rt.innerHTML = "<svg>" + d.valueOf().toString() + "</svg>", d = Rt.firstChild; c.firstChild; ) c.removeChild(c.firstChild);
      for (; d.firstChild; ) c.appendChild(d.firstChild);
    }
  });
  function Qt(c, d) {
    if (d) {
      var g = c.firstChild;
      if (g && g === c.lastChild && g.nodeType === 3) {
        g.nodeValue = d;
        return;
      }
    }
    c.textContent = d;
  }
  var et = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, st = ["Webkit", "ms", "Moz", "O"];
  Object.keys(et).forEach(function(c) {
    st.forEach(function(d) {
      d = d + c.charAt(0).toUpperCase() + c.substring(1), et[d] = et[c];
    });
  });
  function jt(c, d, g) {
    return d == null || typeof d == "boolean" || d === "" ? "" : g || typeof d != "number" || d === 0 || et.hasOwnProperty(c) && et[c] ? ("" + d).trim() : d + "px";
  }
  function Xe(c, d) {
    c = c.style;
    for (var g in d) if (d.hasOwnProperty(g)) {
      var C = g.indexOf("--") === 0, $ = jt(g, d[g], C);
      g === "float" && (g = "cssFloat"), C ? c.setProperty(g, $) : c[g] = $;
    }
  }
  var Be = W({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Qe(c, d) {
    if (d) {
      if (Be[c] && (d.children != null || d.dangerouslySetInnerHTML != null)) throw Error(n(137, c));
      if (d.dangerouslySetInnerHTML != null) {
        if (d.children != null) throw Error(n(60));
        if (typeof d.dangerouslySetInnerHTML != "object" || !("__html" in d.dangerouslySetInnerHTML)) throw Error(n(61));
      }
      if (d.style != null && typeof d.style != "object") throw Error(n(62));
    }
  }
  function xt(c, d) {
    if (c.indexOf("-") === -1) return typeof d.is == "string";
    switch (c) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var ct = null;
  function St(c) {
    return c = c.target || c.srcElement || window, c.correspondingUseElement && (c = c.correspondingUseElement), c.nodeType === 3 ? c.parentNode : c;
  }
  var tn = null, Wt = null, dn = null;
  function hr(c) {
    if (c = qd(c)) {
      if (typeof tn != "function") throw Error(n(280));
      var d = c.stateNode;
      d && (d = Ut(d), tn(c.stateNode, c.type, d));
    }
  }
  function yo(c) {
    Wt ? dn ? dn.push(c) : dn = [c] : Wt = c;
  }
  function ka() {
    if (Wt) {
      var c = Wt, d = dn;
      if (dn = Wt = null, hr(c), d) for (c = 0; c < d.length; c++) hr(d[c]);
    }
  }
  function Vi(c, d) {
    return c(d);
  }
  function ys() {
  }
  var bs = !1;
  function Ma(c, d, g) {
    if (bs) return c(d, g);
    bs = !0;
    try {
      return Vi(c, d, g);
    } finally {
      bs = !1, (Wt !== null || dn !== null) && (ys(), ka());
    }
  }
  function rr(c, d) {
    var g = c.stateNode;
    if (g === null) return null;
    var C = Ut(g);
    if (C === null) return null;
    g = C[d];
    e: switch (d) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (C = !C.disabled) || (c = c.type, C = !(c === "button" || c === "input" || c === "select" || c === "textarea")), c = !C;
        break e;
      default:
        c = !1;
    }
    if (c) return null;
    if (g && typeof g != "function") throw Error(n(231, d, typeof g));
    return g;
  }
  var Wn = !1;
  if (p) try {
    var Cr = {};
    Object.defineProperty(Cr, "passive", { get: function() {
      Wn = !0;
    } }), window.addEventListener("test", Cr, Cr), window.removeEventListener("test", Cr, Cr);
  } catch {
    Wn = !1;
  }
  function ko(c, d, g, C, $, A, q, ue, he) {
    var Fe = Array.prototype.slice.call(arguments, 3);
    try {
      d.apply(g, Fe);
    } catch (Je) {
      this.onError(Je);
    }
  }
  var Lr = !1, Kn = null, bo = !1, Na = null, Mo = { onError: function(c) {
    Lr = !0, Kn = c;
  } };
  function No(c, d, g, C, $, A, q, ue, he) {
    Lr = !1, Kn = null, ko.apply(Mo, arguments);
  }
  function xo(c, d, g, C, $, A, q, ue, he) {
    if (No.apply(this, arguments), Lr) {
      if (Lr) {
        var Fe = Kn;
        Lr = !1, Kn = null;
      } else throw Error(n(198));
      bo || (bo = !0, Na = Fe);
    }
  }
  function ze(c) {
    var d = c, g = c;
    if (c.alternate) for (; d.return; ) d = d.return;
    else {
      c = d;
      do
        d = c, d.flags & 4098 && (g = d.return), c = d.return;
      while (c);
    }
    return d.tag === 3 ? g : null;
  }
  function Pe(c) {
    if (c.tag === 13) {
      var d = c.memoizedState;
      if (d === null && (c = c.alternate, c !== null && (d = c.memoizedState)), d !== null) return d.dehydrated;
    }
    return null;
  }
  function tt(c) {
    if (ze(c) !== c) throw Error(n(188));
  }
  function mt(c) {
    var d = c.alternate;
    if (!d) {
      if (d = ze(c), d === null) throw Error(n(188));
      return d !== c ? null : c;
    }
    for (var g = c, C = d; ; ) {
      var $ = g.return;
      if ($ === null) break;
      var A = $.alternate;
      if (A === null) {
        if (C = $.return, C !== null) {
          g = C;
          continue;
        }
        break;
      }
      if ($.child === A.child) {
        for (A = $.child; A; ) {
          if (A === g) return tt($), c;
          if (A === C) return tt($), d;
          A = A.sibling;
        }
        throw Error(n(188));
      }
      if (g.return !== C.return) g = $, C = A;
      else {
        for (var q = !1, ue = $.child; ue; ) {
          if (ue === g) {
            q = !0, g = $, C = A;
            break;
          }
          if (ue === C) {
            q = !0, C = $, g = A;
            break;
          }
          ue = ue.sibling;
        }
        if (!q) {
          for (ue = A.child; ue; ) {
            if (ue === g) {
              q = !0, g = A, C = $;
              break;
            }
            if (ue === C) {
              q = !0, C = A, g = $;
              break;
            }
            ue = ue.sibling;
          }
          if (!q) throw Error(n(189));
        }
      }
      if (g.alternate !== C) throw Error(n(190));
    }
    if (g.tag !== 3) throw Error(n(188));
    return g.stateNode.current === g ? c : d;
  }
  function cn(c) {
    return c = mt(c), c !== null ? Rn(c) : null;
  }
  function Rn(c) {
    if (c.tag === 5 || c.tag === 6) return c;
    for (c = c.child; c !== null; ) {
      var d = Rn(c);
      if (d !== null) return d;
      c = c.sibling;
    }
    return null;
  }
  var Qn = t.unstable_scheduleCallback, zt = t.unstable_cancelCallback, Or = t.unstable_shouldYield, lE = t.unstable_requestPaint, mr = t.unstable_now, cE = t.unstable_getCurrentPriorityLevel, xs = t.unstable_ImmediatePriority, pn = t.unstable_UserBlockingPriority, ol = t.unstable_NormalPriority, X0 = t.unstable_LowPriority, zv = t.unstable_IdlePriority, Ed = null, bi = null;
  function Q0(c) {
    if (bi && typeof bi.onCommitFiberRoot == "function") try {
      bi.onCommitFiberRoot(Ed, c, void 0, (c.current.flags & 128) === 128);
    } catch {
    }
  }
  var Ia = Math.clz32 ? Math.clz32 : uE, J0 = Math.log, Z0 = Math.LN2;
  function uE(c) {
    return c >>>= 0, c === 0 ? 32 : 31 - (J0(c) / Z0 | 0) | 0;
  }
  var wp = 64, Xc = 4194304;
  function Gl(c) {
    switch (c & -c) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return c & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return c & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return c;
    }
  }
  function xi(c, d) {
    var g = c.pendingLanes;
    if (g === 0) return 0;
    var C = 0, $ = c.suspendedLanes, A = c.pingedLanes, q = g & 268435455;
    if (q !== 0) {
      var ue = q & ~$;
      ue !== 0 ? C = Gl(ue) : (A &= q, A !== 0 && (C = Gl(A)));
    } else q = g & ~$, q !== 0 ? C = Gl(q) : A !== 0 && (C = Gl(A));
    if (C === 0) return 0;
    if (d !== 0 && d !== C && !(d & $) && ($ = C & -C, A = d & -d, $ >= A || $ === 16 && (A & 4194240) !== 0)) return d;
    if (C & 4 && (C |= g & 16), d = c.entangledLanes, d !== 0) for (c = c.entanglements, d &= C; 0 < d; ) g = 31 - Ia(d), $ = 1 << g, C |= c[g], d &= ~$;
    return C;
  }
  function Uv(c, d) {
    switch (c) {
      case 1:
      case 2:
      case 4:
        return d + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return d + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Tp(c, d) {
    for (var g = c.suspendedLanes, C = c.pingedLanes, $ = c.expirationTimes, A = c.pendingLanes; 0 < A; ) {
      var q = 31 - Ia(A), ue = 1 << q, he = $[q];
      he === -1 ? (!(ue & g) || ue & C) && ($[q] = Uv(ue, d)) : he <= d && (c.expiredLanes |= ue), A &= ~ue;
    }
  }
  function Hv(c) {
    return c = c.pendingLanes & -1073741825, c !== 0 ? c : c & 1073741824 ? 1073741824 : 0;
  }
  function Ep() {
    var c = wp;
    return wp <<= 1, !(wp & 4194240) && (wp = 64), c;
  }
  function Wv(c) {
    for (var d = [], g = 0; 31 > g; g++) d.push(c);
    return d;
  }
  function Kl(c, d, g) {
    c.pendingLanes |= d, d !== 536870912 && (c.suspendedLanes = 0, c.pingedLanes = 0), c = c.eventTimes, d = 31 - Ia(d), c[d] = g;
  }
  function dE(c, d) {
    var g = c.pendingLanes & ~d;
    c.pendingLanes = d, c.suspendedLanes = 0, c.pingedLanes = 0, c.expiredLanes &= d, c.mutableReadLanes &= d, c.entangledLanes &= d, d = c.entanglements;
    var C = c.eventTimes;
    for (c = c.expirationTimes; 0 < g; ) {
      var $ = 31 - Ia(g), A = 1 << $;
      d[$] = 0, C[$] = -1, c[$] = -1, g &= ~A;
    }
  }
  function Rd(c, d) {
    var g = c.entangledLanes |= d;
    for (c = c.entanglements; g; ) {
      var C = 31 - Ia(g), $ = 1 << C;
      $ & d | c[C] & d && (c[C] |= d), g &= ~$;
    }
  }
  var kn = 0;
  function qv(c) {
    return c &= -c, 1 < c ? 4 < c ? c & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var ex, Rp, Mn, tx, Yv, nn = !1, Od = [], Pr = null, _a = null, Aa = null, Pd = /* @__PURE__ */ new Map(), Fr = /* @__PURE__ */ new Map(), _n = [], fE = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Si(c, d) {
    switch (c) {
      case "focusin":
      case "focusout":
        Pr = null;
        break;
      case "dragenter":
      case "dragleave":
        _a = null;
        break;
      case "mouseover":
      case "mouseout":
        Aa = null;
        break;
      case "pointerover":
      case "pointerout":
        Pd.delete(d.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Fr.delete(d.pointerId);
    }
  }
  function So(c, d, g, C, $, A) {
    return c === null || c.nativeEvent !== A ? (c = { blockedOn: d, domEventName: g, eventSystemFlags: C, nativeEvent: A, targetContainers: [$] }, d !== null && (d = qd(d), d !== null && Rp(d)), c) : (c.eventSystemFlags |= C, d = c.targetContainers, $ !== null && d.indexOf($) === -1 && d.push($), c);
  }
  function al(c, d, g, C, $) {
    switch (d) {
      case "focusin":
        return Pr = So(Pr, c, d, g, C, $), !0;
      case "dragenter":
        return _a = So(_a, c, d, g, C, $), !0;
      case "mouseover":
        return Aa = So(Aa, c, d, g, C, $), !0;
      case "pointerover":
        var A = $.pointerId;
        return Pd.set(A, So(Pd.get(A) || null, c, d, g, C, $)), !0;
      case "gotpointercapture":
        return A = $.pointerId, Fr.set(A, So(Fr.get(A) || null, c, d, g, C, $)), !0;
    }
    return !1;
  }
  function nx(c) {
    var d = Fa(c.target);
    if (d !== null) {
      var g = ze(d);
      if (g !== null) {
        if (d = g.tag, d === 13) {
          if (d = Pe(g), d !== null) {
            c.blockedOn = d, Yv(c.priority, function() {
              Mn(g);
            });
            return;
          }
        } else if (d === 3 && g.stateNode.current.memoizedState.isDehydrated) {
          c.blockedOn = g.tag === 3 ? g.stateNode.containerInfo : null;
          return;
        }
      }
    }
    c.blockedOn = null;
  }
  function Qc(c) {
    if (c.blockedOn !== null) return !1;
    for (var d = c.targetContainers; 0 < d.length; ) {
      var g = $p(c.domEventName, c.eventSystemFlags, d[0], c.nativeEvent);
      if (g === null) {
        g = c.nativeEvent;
        var C = new g.constructor(g.type, g);
        ct = C, g.target.dispatchEvent(C), ct = null;
      } else return d = qd(g), d !== null && Rp(d), c.blockedOn = g, !1;
      d.shift();
    }
    return !0;
  }
  function Gv(c, d, g) {
    Qc(c) && g.delete(d);
  }
  function rx() {
    nn = !1, Pr !== null && Qc(Pr) && (Pr = null), _a !== null && Qc(_a) && (_a = null), Aa !== null && Qc(Aa) && (Aa = null), Pd.forEach(Gv), Fr.forEach(Gv);
  }
  function $d(c, d) {
    c.blockedOn === d && (c.blockedOn = null, nn || (nn = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, rx)));
  }
  function Dd(c) {
    function d($) {
      return $d($, c);
    }
    if (0 < Od.length) {
      $d(Od[0], c);
      for (var g = 1; g < Od.length; g++) {
        var C = Od[g];
        C.blockedOn === c && (C.blockedOn = null);
      }
    }
    for (Pr !== null && $d(Pr, c), _a !== null && $d(_a, c), Aa !== null && $d(Aa, c), Pd.forEach(d), Fr.forEach(d), g = 0; g < _n.length; g++) C = _n[g], C.blockedOn === c && (C.blockedOn = null);
    for (; 0 < _n.length && (g = _n[0], g.blockedOn === null); ) nx(g), g.blockedOn === null && _n.shift();
  }
  var Jc = F.ReactCurrentBatchConfig, Xl = !0;
  function ox(c, d, g, C) {
    var $ = kn, A = Jc.transition;
    Jc.transition = null;
    try {
      kn = 1, Pp(c, d, g, C);
    } finally {
      kn = $, Jc.transition = A;
    }
  }
  function Op(c, d, g, C) {
    var $ = kn, A = Jc.transition;
    Jc.transition = null;
    try {
      kn = 4, Pp(c, d, g, C);
    } finally {
      kn = $, Jc.transition = A;
    }
  }
  function Pp(c, d, g, C) {
    if (Xl) {
      var $ = $p(c, d, g, C);
      if ($ === null) Bp(c, d, C, kd, g), Si(c, C);
      else if (al($, c, d, g, C)) C.stopPropagation();
      else if (Si(c, C), d & 4 && -1 < fE.indexOf(c)) {
        for (; $ !== null; ) {
          var A = qd($);
          if (A !== null && ex(A), A = $p(c, d, g, C), A === null && Bp(c, d, C, kd, g), A === $) break;
          $ = A;
        }
        $ !== null && C.stopPropagation();
      } else Bp(c, d, C, null, g);
    }
  }
  var kd = null;
  function $p(c, d, g, C) {
    if (kd = null, c = St(C), c = Fa(c), c !== null) if (d = ze(c), d === null) c = null;
    else if (g = d.tag, g === 13) {
      if (c = Pe(d), c !== null) return c;
      c = null;
    } else if (g === 3) {
      if (d.stateNode.current.memoizedState.isDehydrated) return d.tag === 3 ? d.stateNode.containerInfo : null;
      c = null;
    } else d !== c && (c = null);
    return kd = c, null;
  }
  function Kv(c) {
    switch (c) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (cE()) {
          case xs:
            return 1;
          case pn:
            return 4;
          case ol:
          case X0:
            return 16;
          case zv:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ss = null, Md = null, Nd = null;
  function Xv() {
    if (Nd) return Nd;
    var c, d = Md, g = d.length, C, $ = "value" in Ss ? Ss.value : Ss.textContent, A = $.length;
    for (c = 0; c < g && d[c] === $[c]; c++) ;
    var q = g - c;
    for (C = 1; C <= q && d[g - C] === $[A - C]; C++) ;
    return Nd = $.slice(c, 1 < C ? 1 - C : void 0);
  }
  function Zc(c) {
    var d = c.keyCode;
    return "charCode" in c ? (c = c.charCode, c === 0 && d === 13 && (c = 13)) : c = d, c === 10 && (c = 13), 32 <= c || c === 13 ? c : 0;
  }
  function Id() {
    return !0;
  }
  function ax() {
    return !1;
  }
  function ma(c) {
    function d(g, C, $, A, q) {
      this._reactName = g, this._targetInst = $, this.type = C, this.nativeEvent = A, this.target = q, this.currentTarget = null;
      for (var ue in c) c.hasOwnProperty(ue) && (g = c[ue], this[ue] = g ? g(A) : A[ue]);
      return this.isDefaultPrevented = (A.defaultPrevented != null ? A.defaultPrevented : A.returnValue === !1) ? Id : ax, this.isPropagationStopped = ax, this;
    }
    return W(d.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var g = this.nativeEvent;
      g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = Id);
    }, stopPropagation: function() {
      var g = this.nativeEvent;
      g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = Id);
    }, persist: function() {
    }, isPersistent: Id }), d;
  }
  var il = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(c) {
    return c.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Dp = ma(il), eu = W({}, il, { view: 0, detail: 0 }), ix = ma(eu), kp, Qv, _d, Gr = W({}, eu, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: tg, button: 0, buttons: 0, relatedTarget: function(c) {
    return c.relatedTarget === void 0 ? c.fromElement === c.srcElement ? c.toElement : c.fromElement : c.relatedTarget;
  }, movementX: function(c) {
    return "movementX" in c ? c.movementX : (c !== _d && (_d && c.type === "mousemove" ? (kp = c.screenX - _d.screenX, Qv = c.screenY - _d.screenY) : Qv = kp = 0, _d = c), kp);
  }, movementY: function(c) {
    return "movementY" in c ? c.movementY : Qv;
  } }), Mp = ma(Gr), sx = W({}, Gr, { dataTransfer: 0 }), lx = ma(sx), pE = W({}, eu, { relatedTarget: 0 }), sl = ma(pE), Jv = W({}, il, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), cx = ma(Jv), hE = W({}, il, { clipboardData: function(c) {
    return "clipboardData" in c ? c.clipboardData : window.clipboardData;
  } }), mE = ma(hE), vE = W({}, il, { data: 0 }), Zv = ma(vE), eg = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, ux = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, dx = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function fx(c) {
    var d = this.nativeEvent;
    return d.getModifierState ? d.getModifierState(c) : (c = dx[c]) ? !!d[c] : !1;
  }
  function tg() {
    return fx;
  }
  var Cs = W({}, eu, { key: function(c) {
    if (c.key) {
      var d = eg[c.key] || c.key;
      if (d !== "Unidentified") return d;
    }
    return c.type === "keypress" ? (c = Zc(c), c === 13 ? "Enter" : String.fromCharCode(c)) : c.type === "keydown" || c.type === "keyup" ? ux[c.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: tg, charCode: function(c) {
    return c.type === "keypress" ? Zc(c) : 0;
  }, keyCode: function(c) {
    return c.type === "keydown" || c.type === "keyup" ? c.keyCode : 0;
  }, which: function(c) {
    return c.type === "keypress" ? Zc(c) : c.type === "keydown" || c.type === "keyup" ? c.keyCode : 0;
  } }), gE = ma(Cs), ng = W({}, Gr, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Np = ma(ng), rg = W({}, eu, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: tg }), yE = ma(rg), Ip = W({}, il, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), px = ma(Ip), Xo = W({}, Gr, {
    deltaX: function(c) {
      return "deltaX" in c ? c.deltaX : "wheelDeltaX" in c ? -c.wheelDeltaX : 0;
    },
    deltaY: function(c) {
      return "deltaY" in c ? c.deltaY : "wheelDeltaY" in c ? -c.wheelDeltaY : "wheelDelta" in c ? -c.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ws = ma(Xo), $r = [9, 13, 27, 32], Ci = p && "CompositionEvent" in window, Ql = null;
  p && "documentMode" in document && (Ql = document.documentMode);
  var _p = p && "TextEvent" in window && !Ql, hx = p && (!Ci || Ql && 8 < Ql && 11 >= Ql), tu = " ", mx = !1;
  function vx(c, d) {
    switch (c) {
      case "keyup":
        return $r.indexOf(d.keyCode) !== -1;
      case "keydown":
        return d.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Ap(c) {
    return c = c.detail, typeof c == "object" && "data" in c ? c.data : null;
  }
  var nu = !1;
  function bE(c, d) {
    switch (c) {
      case "compositionend":
        return Ap(d);
      case "keypress":
        return d.which !== 32 ? null : (mx = !0, tu);
      case "textInput":
        return c = d.data, c === tu && mx ? null : c;
      default:
        return null;
    }
  }
  function xE(c, d) {
    if (nu) return c === "compositionend" || !Ci && vx(c, d) ? (c = Xv(), Nd = Md = Ss = null, nu = !1, c) : null;
    switch (c) {
      case "paste":
        return null;
      case "keypress":
        if (!(d.ctrlKey || d.altKey || d.metaKey) || d.ctrlKey && d.altKey) {
          if (d.char && 1 < d.char.length) return d.char;
          if (d.which) return String.fromCharCode(d.which);
        }
        return null;
      case "compositionend":
        return hx && d.locale !== "ko" ? null : d.data;
      default:
        return null;
    }
  }
  var gx = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function yx(c) {
    var d = c && c.nodeName && c.nodeName.toLowerCase();
    return d === "input" ? !!gx[c.type] : d === "textarea";
  }
  function bx(c, d, g, C) {
    yo(C), d = Ud(d, "onChange"), 0 < d.length && (g = new Dp("onChange", "change", null, g, C), c.push({ event: g, listeners: d }));
  }
  var Ad = null, ru = null;
  function ou(c) {
    Vp(c, 0);
  }
  function au(c) {
    var d = su(c);
    if (ie(d)) return c;
  }
  function xx(c, d) {
    if (c === "change") return d;
  }
  var og = !1;
  if (p) {
    var ag;
    if (p) {
      var ig = "oninput" in document;
      if (!ig) {
        var Sx = document.createElement("div");
        Sx.setAttribute("oninput", "return;"), ig = typeof Sx.oninput == "function";
      }
      ag = ig;
    } else ag = !1;
    og = ag && (!document.documentMode || 9 < document.documentMode);
  }
  function Cx() {
    Ad && (Ad.detachEvent("onpropertychange", wx), ru = Ad = null);
  }
  function wx(c) {
    if (c.propertyName === "value" && au(ru)) {
      var d = [];
      bx(d, ru, c, St(c)), Ma(ou, d);
    }
  }
  function SE(c, d, g) {
    c === "focusin" ? (Cx(), Ad = d, ru = g, Ad.attachEvent("onpropertychange", wx)) : c === "focusout" && Cx();
  }
  function CE(c) {
    if (c === "selectionchange" || c === "keyup" || c === "keydown") return au(ru);
  }
  function wE(c, d) {
    if (c === "click") return au(d);
  }
  function Tx(c, d) {
    if (c === "input" || c === "change") return au(d);
  }
  function TE(c, d) {
    return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
  }
  var La = typeof Object.is == "function" ? Object.is : TE;
  function Ld(c, d) {
    if (La(c, d)) return !0;
    if (typeof c != "object" || c === null || typeof d != "object" || d === null) return !1;
    var g = Object.keys(c), C = Object.keys(d);
    if (g.length !== C.length) return !1;
    for (C = 0; C < g.length; C++) {
      var $ = g[C];
      if (!h.call(d, $) || !La(c[$], d[$])) return !1;
    }
    return !0;
  }
  function Ex(c) {
    for (; c && c.firstChild; ) c = c.firstChild;
    return c;
  }
  function Rx(c, d) {
    var g = Ex(c);
    c = 0;
    for (var C; g; ) {
      if (g.nodeType === 3) {
        if (C = c + g.textContent.length, c <= d && C >= d) return { node: g, offset: d - c };
        c = C;
      }
      e: {
        for (; g; ) {
          if (g.nextSibling) {
            g = g.nextSibling;
            break e;
          }
          g = g.parentNode;
        }
        g = void 0;
      }
      g = Ex(g);
    }
  }
  function Ox(c, d) {
    return c && d ? c === d ? !0 : c && c.nodeType === 3 ? !1 : d && d.nodeType === 3 ? Ox(c, d.parentNode) : "contains" in c ? c.contains(d) : c.compareDocumentPosition ? !!(c.compareDocumentPosition(d) & 16) : !1 : !1;
  }
  function Lp() {
    for (var c = window, d = fe(); d instanceof c.HTMLIFrameElement; ) {
      try {
        var g = typeof d.contentWindow.location.href == "string";
      } catch {
        g = !1;
      }
      if (g) c = d.contentWindow;
      else break;
      d = fe(c.document);
    }
    return d;
  }
  function Ts(c) {
    var d = c && c.nodeName && c.nodeName.toLowerCase();
    return d && (d === "input" && (c.type === "text" || c.type === "search" || c.type === "tel" || c.type === "url" || c.type === "password") || d === "textarea" || c.contentEditable === "true");
  }
  function Fp(c) {
    var d = Lp(), g = c.focusedElem, C = c.selectionRange;
    if (d !== g && g && g.ownerDocument && Ox(g.ownerDocument.documentElement, g)) {
      if (C !== null && Ts(g)) {
        if (d = C.start, c = C.end, c === void 0 && (c = d), "selectionStart" in g) g.selectionStart = d, g.selectionEnd = Math.min(c, g.value.length);
        else if (c = (d = g.ownerDocument || document) && d.defaultView || window, c.getSelection) {
          c = c.getSelection();
          var $ = g.textContent.length, A = Math.min(C.start, $);
          C = C.end === void 0 ? A : Math.min(C.end, $), !c.extend && A > C && ($ = C, C = A, A = $), $ = Rx(g, A);
          var q = Rx(
            g,
            C
          );
          $ && q && (c.rangeCount !== 1 || c.anchorNode !== $.node || c.anchorOffset !== $.offset || c.focusNode !== q.node || c.focusOffset !== q.offset) && (d = d.createRange(), d.setStart($.node, $.offset), c.removeAllRanges(), A > C ? (c.addRange(d), c.extend(q.node, q.offset)) : (d.setEnd(q.node, q.offset), c.addRange(d)));
        }
      }
      for (d = [], c = g; c = c.parentNode; ) c.nodeType === 1 && d.push({ element: c, left: c.scrollLeft, top: c.scrollTop });
      for (typeof g.focus == "function" && g.focus(), g = 0; g < d.length; g++) c = d[g], c.element.scrollLeft = c.left, c.element.scrollTop = c.top;
    }
  }
  var Px = p && "documentMode" in document && 11 >= document.documentMode, wi = null, sg = null, Fd = null, lg = !1;
  function $x(c, d, g) {
    var C = g.window === g ? g.document : g.nodeType === 9 ? g : g.ownerDocument;
    lg || wi == null || wi !== fe(C) || (C = wi, "selectionStart" in C && Ts(C) ? C = { start: C.selectionStart, end: C.selectionEnd } : (C = (C.ownerDocument && C.ownerDocument.defaultView || window).getSelection(), C = { anchorNode: C.anchorNode, anchorOffset: C.anchorOffset, focusNode: C.focusNode, focusOffset: C.focusOffset }), Fd && Ld(Fd, C) || (Fd = C, C = Ud(sg, "onSelect"), 0 < C.length && (d = new Dp("onSelect", "select", null, d, g), c.push({ event: d, listeners: C }), d.target = wi)));
  }
  function jp(c, d) {
    var g = {};
    return g[c.toLowerCase()] = d.toLowerCase(), g["Webkit" + c] = "webkit" + d, g["Moz" + c] = "moz" + d, g;
  }
  var Jl = { animationend: jp("Animation", "AnimationEnd"), animationiteration: jp("Animation", "AnimationIteration"), animationstart: jp("Animation", "AnimationStart"), transitionend: jp("Transition", "TransitionEnd") }, cg = {}, ug = {};
  p && (ug = document.createElement("div").style, "AnimationEvent" in window || (delete Jl.animationend.animation, delete Jl.animationiteration.animation, delete Jl.animationstart.animation), "TransitionEvent" in window || delete Jl.transitionend.transition);
  function Kr(c) {
    if (cg[c]) return cg[c];
    if (!Jl[c]) return c;
    var d = Jl[c], g;
    for (g in d) if (d.hasOwnProperty(g) && g in ug) return cg[c] = d[g];
    return c;
  }
  var dg = Kr("animationend"), Dx = Kr("animationiteration"), kx = Kr("animationstart"), Mx = Kr("transitionend"), Nx = /* @__PURE__ */ new Map(), Ix = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Es(c, d) {
    Nx.set(c, d), l(d, [c]);
  }
  for (var jd = 0; jd < Ix.length; jd++) {
    var Zl = Ix[jd], EE = Zl.toLowerCase(), Vd = Zl[0].toUpperCase() + Zl.slice(1);
    Es(EE, "on" + Vd);
  }
  Es(dg, "onAnimationEnd"), Es(Dx, "onAnimationIteration"), Es(kx, "onAnimationStart"), Es("dblclick", "onDoubleClick"), Es("focusin", "onFocus"), Es("focusout", "onBlur"), Es(Mx, "onTransitionEnd"), u("onMouseEnter", ["mouseout", "mouseover"]), u("onMouseLeave", ["mouseout", "mouseover"]), u("onPointerEnter", ["pointerout", "pointerover"]), u("onPointerLeave", ["pointerout", "pointerover"]), l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Bd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), RE = new Set("cancel close invalid load scroll toggle".split(" ").concat(Bd));
  function _x(c, d, g) {
    var C = c.type || "unknown-event";
    c.currentTarget = g, xo(C, d, void 0, c), c.currentTarget = null;
  }
  function Vp(c, d) {
    d = (d & 4) !== 0;
    for (var g = 0; g < c.length; g++) {
      var C = c[g], $ = C.event;
      C = C.listeners;
      e: {
        var A = void 0;
        if (d) for (var q = C.length - 1; 0 <= q; q--) {
          var ue = C[q], he = ue.instance, Fe = ue.currentTarget;
          if (ue = ue.listener, he !== A && $.isPropagationStopped()) break e;
          _x($, ue, Fe), A = he;
        }
        else for (q = 0; q < C.length; q++) {
          if (ue = C[q], he = ue.instance, Fe = ue.currentTarget, ue = ue.listener, he !== A && $.isPropagationStopped()) break e;
          _x($, ue, Fe), A = he;
        }
      }
    }
    if (bo) throw c = Na, bo = !1, Na = null, c;
  }
  function qn(c, d) {
    var g = d[yg];
    g === void 0 && (g = d[yg] = /* @__PURE__ */ new Set());
    var C = c + "__bubble";
    g.has(C) || (Ax(d, c, 2, !1), g.add(C));
  }
  function ll(c, d, g) {
    var C = 0;
    d && (C |= 4), Ax(g, c, C, d);
  }
  var Rs = "_reactListening" + Math.random().toString(36).slice(2);
  function iu(c) {
    if (!c[Rs]) {
      c[Rs] = !0, o.forEach(function(g) {
        g !== "selectionchange" && (RE.has(g) || ll(g, !1, c), ll(g, !0, c));
      });
      var d = c.nodeType === 9 ? c : c.ownerDocument;
      d === null || d[Rs] || (d[Rs] = !0, ll("selectionchange", !1, d));
    }
  }
  function Ax(c, d, g, C) {
    switch (Kv(d)) {
      case 1:
        var $ = ox;
        break;
      case 4:
        $ = Op;
        break;
      default:
        $ = Pp;
    }
    g = $.bind(null, d, g, c), $ = void 0, !Wn || d !== "touchstart" && d !== "touchmove" && d !== "wheel" || ($ = !0), C ? $ !== void 0 ? c.addEventListener(d, g, { capture: !0, passive: $ }) : c.addEventListener(d, g, !0) : $ !== void 0 ? c.addEventListener(d, g, { passive: $ }) : c.addEventListener(d, g, !1);
  }
  function Bp(c, d, g, C, $) {
    var A = C;
    if (!(d & 1) && !(d & 2) && C !== null) e: for (; ; ) {
      if (C === null) return;
      var q = C.tag;
      if (q === 3 || q === 4) {
        var ue = C.stateNode.containerInfo;
        if (ue === $ || ue.nodeType === 8 && ue.parentNode === $) break;
        if (q === 4) for (q = C.return; q !== null; ) {
          var he = q.tag;
          if ((he === 3 || he === 4) && (he = q.stateNode.containerInfo, he === $ || he.nodeType === 8 && he.parentNode === $)) return;
          q = q.return;
        }
        for (; ue !== null; ) {
          if (q = Fa(ue), q === null) return;
          if (he = q.tag, he === 5 || he === 6) {
            C = A = q;
            continue e;
          }
          ue = ue.parentNode;
        }
      }
      C = C.return;
    }
    Ma(function() {
      var Fe = A, Je = St(g), Ze = [];
      e: {
        var Ke = Nx.get(c);
        if (Ke !== void 0) {
          var Ct = Dp, $t = c;
          switch (c) {
            case "keypress":
              if (Zc(g) === 0) break e;
            case "keydown":
            case "keyup":
              Ct = gE;
              break;
            case "focusin":
              $t = "focus", Ct = sl;
              break;
            case "focusout":
              $t = "blur", Ct = sl;
              break;
            case "beforeblur":
            case "afterblur":
              Ct = sl;
              break;
            case "click":
              if (g.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ct = Mp;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ct = lx;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ct = yE;
              break;
            case dg:
            case Dx:
            case kx:
              Ct = cx;
              break;
            case Mx:
              Ct = px;
              break;
            case "scroll":
              Ct = ix;
              break;
            case "wheel":
              Ct = ws;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ct = mE;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ct = Np;
          }
          var It = (d & 4) !== 0, Er = !It && c === "scroll", $e = It ? Ke !== null ? Ke + "Capture" : null : Ke;
          It = [];
          for (var Se = Fe, Ie; Se !== null; ) {
            Ie = Se;
            var ot = Ie.stateNode;
            if (Ie.tag === 5 && ot !== null && (Ie = ot, $e !== null && (ot = rr(Se, $e), ot != null && It.push(zd(Se, ot, Ie)))), Er) break;
            Se = Se.return;
          }
          0 < It.length && (Ke = new Ct(Ke, $t, null, g, Je), Ze.push({ event: Ke, listeners: It }));
        }
      }
      if (!(d & 7)) {
        e: {
          if (Ke = c === "mouseover" || c === "pointerover", Ct = c === "mouseout" || c === "pointerout", Ke && g !== ct && ($t = g.relatedTarget || g.fromElement) && (Fa($t) || $t[Os])) break e;
          if ((Ct || Ke) && (Ke = Je.window === Je ? Je : (Ke = Je.ownerDocument) ? Ke.defaultView || Ke.parentWindow : window, Ct ? ($t = g.relatedTarget || g.toElement, Ct = Fe, $t = $t ? Fa($t) : null, $t !== null && (Er = ze($t), $t !== Er || $t.tag !== 5 && $t.tag !== 6) && ($t = null)) : (Ct = null, $t = Fe), Ct !== $t)) {
            if (It = Mp, ot = "onMouseLeave", $e = "onMouseEnter", Se = "mouse", (c === "pointerout" || c === "pointerover") && (It = Np, ot = "onPointerLeave", $e = "onPointerEnter", Se = "pointer"), Er = Ct == null ? Ke : su(Ct), Ie = $t == null ? Ke : su($t), Ke = new It(ot, Se + "leave", Ct, g, Je), Ke.target = Er, Ke.relatedTarget = Ie, ot = null, Fa(Je) === Fe && (It = new It($e, Se + "enter", $t, g, Je), It.target = Ie, It.relatedTarget = Er, ot = It), Er = ot, Ct && $t) t: {
              for (It = Ct, $e = $t, Se = 0, Ie = It; Ie; Ie = ec(Ie)) Se++;
              for (Ie = 0, ot = $e; ot; ot = ec(ot)) Ie++;
              for (; 0 < Se - Ie; ) It = ec(It), Se--;
              for (; 0 < Ie - Se; ) $e = ec($e), Ie--;
              for (; Se--; ) {
                if (It === $e || $e !== null && It === $e.alternate) break t;
                It = ec(It), $e = ec($e);
              }
              It = null;
            }
            else It = null;
            Ct !== null && fg(Ze, Ke, Ct, It, !1), $t !== null && Er !== null && fg(Ze, Er, $t, It, !0);
          }
        }
        e: {
          if (Ke = Fe ? su(Fe) : window, Ct = Ke.nodeName && Ke.nodeName.toLowerCase(), Ct === "select" || Ct === "input" && Ke.type === "file") var At = xx;
          else if (yx(Ke)) if (og) At = Tx;
          else {
            At = CE;
            var qt = SE;
          }
          else (Ct = Ke.nodeName) && Ct.toLowerCase() === "input" && (Ke.type === "checkbox" || Ke.type === "radio") && (At = wE);
          if (At && (At = At(c, Fe))) {
            bx(Ze, At, g, Je);
            break e;
          }
          qt && qt(c, Ke, Fe), c === "focusout" && (qt = Ke._wrapperState) && qt.controlled && Ke.type === "number" && lt(Ke, "number", Ke.value);
        }
        switch (qt = Fe ? su(Fe) : window, c) {
          case "focusin":
            (yx(qt) || qt.contentEditable === "true") && (wi = qt, sg = Fe, Fd = null);
            break;
          case "focusout":
            Fd = sg = wi = null;
            break;
          case "mousedown":
            lg = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            lg = !1, $x(Ze, g, Je);
            break;
          case "selectionchange":
            if (Px) break;
          case "keydown":
          case "keyup":
            $x(Ze, g, Je);
        }
        var Dt;
        if (Ci) e: {
          switch (c) {
            case "compositionstart":
              var Yt = "onCompositionStart";
              break e;
            case "compositionend":
              Yt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Yt = "onCompositionUpdate";
              break e;
          }
          Yt = void 0;
        }
        else nu ? vx(c, g) && (Yt = "onCompositionEnd") : c === "keydown" && g.keyCode === 229 && (Yt = "onCompositionStart");
        Yt && (hx && g.locale !== "ko" && (nu || Yt !== "onCompositionStart" ? Yt === "onCompositionEnd" && nu && (Dt = Xv()) : (Ss = Je, Md = "value" in Ss ? Ss.value : Ss.textContent, nu = !0)), qt = Ud(Fe, Yt), 0 < qt.length && (Yt = new Zv(Yt, c, null, g, Je), Ze.push({ event: Yt, listeners: qt }), Dt ? Yt.data = Dt : (Dt = Ap(g), Dt !== null && (Yt.data = Dt)))), (Dt = _p ? bE(c, g) : xE(c, g)) && (Fe = Ud(Fe, "onBeforeInput"), 0 < Fe.length && (Je = new Zv("onBeforeInput", "beforeinput", null, g, Je), Ze.push({ event: Je, listeners: Fe }), Je.data = Dt));
      }
      Vp(Ze, d);
    });
  }
  function zd(c, d, g) {
    return { instance: c, listener: d, currentTarget: g };
  }
  function Ud(c, d) {
    for (var g = d + "Capture", C = []; c !== null; ) {
      var $ = c, A = $.stateNode;
      $.tag === 5 && A !== null && ($ = A, A = rr(c, g), A != null && C.unshift(zd(c, A, $)), A = rr(c, d), A != null && C.push(zd(c, A, $))), c = c.return;
    }
    return C;
  }
  function ec(c) {
    if (c === null) return null;
    do
      c = c.return;
    while (c && c.tag !== 5);
    return c || null;
  }
  function fg(c, d, g, C, $) {
    for (var A = d._reactName, q = []; g !== null && g !== C; ) {
      var ue = g, he = ue.alternate, Fe = ue.stateNode;
      if (he !== null && he === C) break;
      ue.tag === 5 && Fe !== null && (ue = Fe, $ ? (he = rr(g, A), he != null && q.unshift(zd(g, he, ue))) : $ || (he = rr(g, A), he != null && q.push(zd(g, he, ue)))), g = g.return;
    }
    q.length !== 0 && c.push({ event: d, listeners: q });
  }
  var pg = /\r\n?/g, OE = /\u0000|\uFFFD/g;
  function hg(c) {
    return (typeof c == "string" ? c : "" + c).replace(pg, `
`).replace(OE, "");
  }
  function zp(c, d, g) {
    if (d = hg(d), hg(c) !== d && g) throw Error(n(425));
  }
  function Up() {
  }
  var mg = null, tc = null;
  function Hd(c, d) {
    return c === "textarea" || c === "noscript" || typeof d.children == "string" || typeof d.children == "number" || typeof d.dangerouslySetInnerHTML == "object" && d.dangerouslySetInnerHTML !== null && d.dangerouslySetInnerHTML.__html != null;
  }
  var nc = typeof setTimeout == "function" ? setTimeout : void 0, Lx = typeof clearTimeout == "function" ? clearTimeout : void 0, vg = typeof Promise == "function" ? Promise : void 0, gg = typeof queueMicrotask == "function" ? queueMicrotask : typeof vg < "u" ? function(c) {
    return vg.resolve(null).then(c).catch(PE);
  } : nc;
  function PE(c) {
    setTimeout(function() {
      throw c;
    });
  }
  function cl(c, d) {
    var g = d, C = 0;
    do {
      var $ = g.nextSibling;
      if (c.removeChild(g), $ && $.nodeType === 8) if (g = $.data, g === "/$") {
        if (C === 0) {
          c.removeChild($), Dd(d);
          return;
        }
        C--;
      } else g !== "$" && g !== "$?" && g !== "$!" || C++;
      g = $;
    } while (g);
    Dd(d);
  }
  function Ti(c) {
    for (; c != null; c = c.nextSibling) {
      var d = c.nodeType;
      if (d === 1 || d === 3) break;
      if (d === 8) {
        if (d = c.data, d === "$" || d === "$!" || d === "$?") break;
        if (d === "/$") return null;
      }
    }
    return c;
  }
  function Wd(c) {
    c = c.previousSibling;
    for (var d = 0; c; ) {
      if (c.nodeType === 8) {
        var g = c.data;
        if (g === "$" || g === "$!" || g === "$?") {
          if (d === 0) return c;
          d--;
        } else g === "/$" && d++;
      }
      c = c.previousSibling;
    }
    return null;
  }
  var ul = Math.random().toString(36).slice(2), Bi = "__reactFiber$" + ul, rc = "__reactProps$" + ul, Os = "__reactContainer$" + ul, yg = "__reactEvents$" + ul, $E = "__reactListeners$" + ul, bg = "__reactHandles$" + ul;
  function Fa(c) {
    var d = c[Bi];
    if (d) return d;
    for (var g = c.parentNode; g; ) {
      if (d = g[Os] || g[Bi]) {
        if (g = d.alternate, d.child !== null || g !== null && g.child !== null) for (c = Wd(c); c !== null; ) {
          if (g = c[Bi]) return g;
          c = Wd(c);
        }
        return d;
      }
      c = g, g = c.parentNode;
    }
    return null;
  }
  function qd(c) {
    return c = c[Bi] || c[Os], !c || c.tag !== 5 && c.tag !== 6 && c.tag !== 13 && c.tag !== 3 ? null : c;
  }
  function su(c) {
    if (c.tag === 5 || c.tag === 6) return c.stateNode;
    throw Error(n(33));
  }
  function Ut(c) {
    return c[rc] || null;
  }
  var dl = [], Jn = -1;
  function an(c) {
    return { current: c };
  }
  function On(c) {
    0 > Jn || (c.current = dl[Jn], dl[Jn] = null, Jn--);
  }
  function Pn(c, d) {
    Jn++, dl[Jn] = c.current, c.current = d;
  }
  var zi = {}, Kt = an(zi), vr = an(!1), Qo = zi;
  function ja(c, d) {
    var g = c.type.contextTypes;
    if (!g) return zi;
    var C = c.stateNode;
    if (C && C.__reactInternalMemoizedUnmaskedChildContext === d) return C.__reactInternalMemoizedMaskedChildContext;
    var $ = {}, A;
    for (A in g) $[A] = d[A];
    return C && (c = c.stateNode, c.__reactInternalMemoizedUnmaskedChildContext = d, c.__reactInternalMemoizedMaskedChildContext = $), $;
  }
  function or(c) {
    return c = c.childContextTypes, c != null;
  }
  function Va() {
    On(vr), On(Kt);
  }
  function fl(c, d, g) {
    if (Kt.current !== zi) throw Error(n(168));
    Pn(Kt, d), Pn(vr, g);
  }
  function Yd(c, d, g) {
    var C = c.stateNode;
    if (d = d.childContextTypes, typeof C.getChildContext != "function") return g;
    C = C.getChildContext();
    for (var $ in C) if (!($ in d)) throw Error(n(108, ve(c) || "Unknown", $));
    return W({}, g, C);
  }
  function Hp(c) {
    return c = (c = c.stateNode) && c.__reactInternalMemoizedMergedChildContext || zi, Qo = Kt.current, Pn(Kt, c), Pn(vr, vr.current), !0;
  }
  function Fx(c, d, g) {
    var C = c.stateNode;
    if (!C) throw Error(n(169));
    g ? (c = Yd(c, d, Qo), C.__reactInternalMemoizedMergedChildContext = c, On(vr), On(Kt), Pn(Kt, c)) : On(vr), Pn(vr, g);
  }
  var va = null, Xr = !1, Gd = !1;
  function xg(c) {
    va === null ? va = [c] : va.push(c);
  }
  function Sg(c) {
    Xr = !0, xg(c);
  }
  function Jo() {
    if (!Gd && va !== null) {
      Gd = !0;
      var c = 0, d = kn;
      try {
        var g = va;
        for (kn = 1; c < g.length; c++) {
          var C = g[c];
          do
            C = C(!0);
          while (C !== null);
        }
        va = null, Xr = !1;
      } catch ($) {
        throw va !== null && (va = va.slice(c + 1)), Qn(xs, Jo), $;
      } finally {
        kn = d, Gd = !1;
      }
    }
    return null;
  }
  var pl = [], Zo = 0, oc = null, lu = 0, ea = [], Co = 0, Ba = null, ao = 1, Ps = "";
  function ga(c, d) {
    pl[Zo++] = lu, pl[Zo++] = oc, oc = c, lu = d;
  }
  function Cg(c, d, g) {
    ea[Co++] = ao, ea[Co++] = Ps, ea[Co++] = Ba, Ba = c;
    var C = ao;
    c = Ps;
    var $ = 32 - Ia(C) - 1;
    C &= ~(1 << $), g += 1;
    var A = 32 - Ia(d) + $;
    if (30 < A) {
      var q = $ - $ % 5;
      A = (C & (1 << q) - 1).toString(32), C >>= q, $ -= q, ao = 1 << 32 - Ia(d) + $ | g << $ | C, Ps = A + c;
    } else ao = 1 << A | g << $ | C, Ps = c;
  }
  function Wp(c) {
    c.return !== null && (ga(c, 1), Cg(c, 1, 0));
  }
  function wg(c) {
    for (; c === oc; ) oc = pl[--Zo], pl[Zo] = null, lu = pl[--Zo], pl[Zo] = null;
    for (; c === Ba; ) Ba = ea[--Co], ea[Co] = null, Ps = ea[--Co], ea[Co] = null, ao = ea[--Co], ea[Co] = null;
  }
  var ya = null, ta = null, Zn = !1, za = null;
  function Tg(c, d) {
    var g = Xa(5, null, null, 0);
    g.elementType = "DELETED", g.stateNode = d, g.return = c, d = c.deletions, d === null ? (c.deletions = [g], c.flags |= 16) : d.push(g);
  }
  function jx(c, d) {
    switch (c.tag) {
      case 5:
        var g = c.type;
        return d = d.nodeType !== 1 || g.toLowerCase() !== d.nodeName.toLowerCase() ? null : d, d !== null ? (c.stateNode = d, ya = c, ta = Ti(d.firstChild), !0) : !1;
      case 6:
        return d = c.pendingProps === "" || d.nodeType !== 3 ? null : d, d !== null ? (c.stateNode = d, ya = c, ta = null, !0) : !1;
      case 13:
        return d = d.nodeType !== 8 ? null : d, d !== null ? (g = Ba !== null ? { id: ao, overflow: Ps } : null, c.memoizedState = { dehydrated: d, treeContext: g, retryLane: 1073741824 }, g = Xa(18, null, null, 0), g.stateNode = d, g.return = c, c.child = g, ya = c, ta = null, !0) : !1;
      default:
        return !1;
    }
  }
  function qp(c) {
    return (c.mode & 1) !== 0 && (c.flags & 128) === 0;
  }
  function Yp(c) {
    if (Zn) {
      var d = ta;
      if (d) {
        var g = d;
        if (!jx(c, d)) {
          if (qp(c)) throw Error(n(418));
          d = Ti(g.nextSibling);
          var C = ya;
          d && jx(c, d) ? Tg(C, g) : (c.flags = c.flags & -4097 | 2, Zn = !1, ya = c);
        }
      } else {
        if (qp(c)) throw Error(n(418));
        c.flags = c.flags & -4097 | 2, Zn = !1, ya = c;
      }
    }
  }
  function Vx(c) {
    for (c = c.return; c !== null && c.tag !== 5 && c.tag !== 3 && c.tag !== 13; ) c = c.return;
    ya = c;
  }
  function Gp(c) {
    if (c !== ya) return !1;
    if (!Zn) return Vx(c), Zn = !0, !1;
    var d;
    if ((d = c.tag !== 3) && !(d = c.tag !== 5) && (d = c.type, d = d !== "head" && d !== "body" && !Hd(c.type, c.memoizedProps)), d && (d = ta)) {
      if (qp(c)) throw Bx(), Error(n(418));
      for (; d; ) Tg(c, d), d = Ti(d.nextSibling);
    }
    if (Vx(c), c.tag === 13) {
      if (c = c.memoizedState, c = c !== null ? c.dehydrated : null, !c) throw Error(n(317));
      e: {
        for (c = c.nextSibling, d = 0; c; ) {
          if (c.nodeType === 8) {
            var g = c.data;
            if (g === "/$") {
              if (d === 0) {
                ta = Ti(c.nextSibling);
                break e;
              }
              d--;
            } else g !== "$" && g !== "$!" && g !== "$?" || d++;
          }
          c = c.nextSibling;
        }
        ta = null;
      }
    } else ta = ya ? Ti(c.stateNode.nextSibling) : null;
    return !0;
  }
  function Bx() {
    for (var c = ta; c; ) c = Ti(c.nextSibling);
  }
  function cr() {
    ta = ya = null, Zn = !1;
  }
  function Eg(c) {
    za === null ? za = [c] : za.push(c);
  }
  var Kp = F.ReactCurrentBatchConfig;
  function ac(c, d, g) {
    if (c = g.ref, c !== null && typeof c != "function" && typeof c != "object") {
      if (g._owner) {
        if (g = g._owner, g) {
          if (g.tag !== 1) throw Error(n(309));
          var C = g.stateNode;
        }
        if (!C) throw Error(n(147, c));
        var $ = C, A = "" + c;
        return d !== null && d.ref !== null && typeof d.ref == "function" && d.ref._stringRef === A ? d.ref : (d = function(q) {
          var ue = $.refs;
          q === null ? delete ue[A] : ue[A] = q;
        }, d._stringRef = A, d);
      }
      if (typeof c != "string") throw Error(n(284));
      if (!g._owner) throw Error(n(290, c));
    }
    return c;
  }
  function Ui(c, d) {
    throw c = Object.prototype.toString.call(d), Error(n(31, c === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : c));
  }
  function zx(c) {
    var d = c._init;
    return d(c._payload);
  }
  function Xp(c) {
    function d($e, Se) {
      if (c) {
        var Ie = $e.deletions;
        Ie === null ? ($e.deletions = [Se], $e.flags |= 16) : Ie.push(Se);
      }
    }
    function g($e, Se) {
      if (!c) return null;
      for (; Se !== null; ) d($e, Se), Se = Se.sibling;
      return null;
    }
    function C($e, Se) {
      for ($e = /* @__PURE__ */ new Map(); Se !== null; ) Se.key !== null ? $e.set(Se.key, Se) : $e.set(Se.index, Se), Se = Se.sibling;
      return $e;
    }
    function $($e, Se) {
      return $e = Sl($e, Se), $e.index = 0, $e.sibling = null, $e;
    }
    function A($e, Se, Ie) {
      return $e.index = Ie, c ? (Ie = $e.alternate, Ie !== null ? (Ie = Ie.index, Ie < Se ? ($e.flags |= 2, Se) : Ie) : ($e.flags |= 2, Se)) : ($e.flags |= 1048576, Se);
    }
    function q($e) {
      return c && $e.alternate === null && ($e.flags |= 2), $e;
    }
    function ue($e, Se, Ie, ot) {
      return Se === null || Se.tag !== 6 ? (Se = Lh(Ie, $e.mode, ot), Se.return = $e, Se) : (Se = $(Se, Ie), Se.return = $e, Se);
    }
    function he($e, Se, Ie, ot) {
      var At = Ie.type;
      return At === z ? Je($e, Se, Ie.props.children, ot, Ie.key) : Se !== null && (Se.elementType === At || typeof At == "object" && At !== null && At.$$typeof === Z && zx(At) === Se.type) ? (ot = $(Se, Ie.props), ot.ref = ac($e, Se, Ie), ot.return = $e, ot) : (ot = _h(Ie.type, Ie.key, Ie.props, null, $e.mode, ot), ot.ref = ac($e, Se, Ie), ot.return = $e, ot);
    }
    function Fe($e, Se, Ie, ot) {
      return Se === null || Se.tag !== 4 || Se.stateNode.containerInfo !== Ie.containerInfo || Se.stateNode.implementation !== Ie.implementation ? (Se = pf(Ie, $e.mode, ot), Se.return = $e, Se) : (Se = $(Se, Ie.children || []), Se.return = $e, Se);
    }
    function Je($e, Se, Ie, ot, At) {
      return Se === null || Se.tag !== 7 ? (Se = xc(Ie, $e.mode, ot, At), Se.return = $e, Se) : (Se = $(Se, Ie), Se.return = $e, Se);
    }
    function Ze($e, Se, Ie) {
      if (typeof Se == "string" && Se !== "" || typeof Se == "number") return Se = Lh("" + Se, $e.mode, Ie), Se.return = $e, Se;
      if (typeof Se == "object" && Se !== null) {
        switch (Se.$$typeof) {
          case N:
            return Ie = _h(Se.type, Se.key, Se.props, null, $e.mode, Ie), Ie.ref = ac($e, null, Se), Ie.return = $e, Ie;
          case V:
            return Se = pf(Se, $e.mode, Ie), Se.return = $e, Se;
          case Z:
            var ot = Se._init;
            return Ze($e, ot(Se._payload), Ie);
        }
        if (Pt(Se) || G(Se)) return Se = xc(Se, $e.mode, Ie, null), Se.return = $e, Se;
        Ui($e, Se);
      }
      return null;
    }
    function Ke($e, Se, Ie, ot) {
      var At = Se !== null ? Se.key : null;
      if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number") return At !== null ? null : ue($e, Se, "" + Ie, ot);
      if (typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case N:
            return Ie.key === At ? he($e, Se, Ie, ot) : null;
          case V:
            return Ie.key === At ? Fe($e, Se, Ie, ot) : null;
          case Z:
            return At = Ie._init, Ke(
              $e,
              Se,
              At(Ie._payload),
              ot
            );
        }
        if (Pt(Ie) || G(Ie)) return At !== null ? null : Je($e, Se, Ie, ot, null);
        Ui($e, Ie);
      }
      return null;
    }
    function Ct($e, Se, Ie, ot, At) {
      if (typeof ot == "string" && ot !== "" || typeof ot == "number") return $e = $e.get(Ie) || null, ue(Se, $e, "" + ot, At);
      if (typeof ot == "object" && ot !== null) {
        switch (ot.$$typeof) {
          case N:
            return $e = $e.get(ot.key === null ? Ie : ot.key) || null, he(Se, $e, ot, At);
          case V:
            return $e = $e.get(ot.key === null ? Ie : ot.key) || null, Fe(Se, $e, ot, At);
          case Z:
            var qt = ot._init;
            return Ct($e, Se, Ie, qt(ot._payload), At);
        }
        if (Pt(ot) || G(ot)) return $e = $e.get(Ie) || null, Je(Se, $e, ot, At, null);
        Ui(Se, ot);
      }
      return null;
    }
    function $t($e, Se, Ie, ot) {
      for (var At = null, qt = null, Dt = Se, Yt = Se = 0, Ur = null; Dt !== null && Yt < Ie.length; Yt++) {
        Dt.index > Yt ? (Ur = Dt, Dt = null) : Ur = Dt.sibling;
        var wn = Ke($e, Dt, Ie[Yt], ot);
        if (wn === null) {
          Dt === null && (Dt = Ur);
          break;
        }
        c && Dt && wn.alternate === null && d($e, Dt), Se = A(wn, Se, Yt), qt === null ? At = wn : qt.sibling = wn, qt = wn, Dt = Ur;
      }
      if (Yt === Ie.length) return g($e, Dt), Zn && ga($e, Yt), At;
      if (Dt === null) {
        for (; Yt < Ie.length; Yt++) Dt = Ze($e, Ie[Yt], ot), Dt !== null && (Se = A(Dt, Se, Yt), qt === null ? At = Dt : qt.sibling = Dt, qt = Dt);
        return Zn && ga($e, Yt), At;
      }
      for (Dt = C($e, Dt); Yt < Ie.length; Yt++) Ur = Ct(Dt, $e, Yt, Ie[Yt], ot), Ur !== null && (c && Ur.alternate !== null && Dt.delete(Ur.key === null ? Yt : Ur.key), Se = A(Ur, Se, Yt), qt === null ? At = Ur : qt.sibling = Ur, qt = Ur);
      return c && Dt.forEach(function(_s) {
        return d($e, _s);
      }), Zn && ga($e, Yt), At;
    }
    function It($e, Se, Ie, ot) {
      var At = G(Ie);
      if (typeof At != "function") throw Error(n(150));
      if (Ie = At.call(Ie), Ie == null) throw Error(n(151));
      for (var qt = At = null, Dt = Se, Yt = Se = 0, Ur = null, wn = Ie.next(); Dt !== null && !wn.done; Yt++, wn = Ie.next()) {
        Dt.index > Yt ? (Ur = Dt, Dt = null) : Ur = Dt.sibling;
        var _s = Ke($e, Dt, wn.value, ot);
        if (_s === null) {
          Dt === null && (Dt = Ur);
          break;
        }
        c && Dt && _s.alternate === null && d($e, Dt), Se = A(_s, Se, Yt), qt === null ? At = _s : qt.sibling = _s, qt = _s, Dt = Ur;
      }
      if (wn.done) return g(
        $e,
        Dt
      ), Zn && ga($e, Yt), At;
      if (Dt === null) {
        for (; !wn.done; Yt++, wn = Ie.next()) wn = Ze($e, wn.value, ot), wn !== null && (Se = A(wn, Se, Yt), qt === null ? At = wn : qt.sibling = wn, qt = wn);
        return Zn && ga($e, Yt), At;
      }
      for (Dt = C($e, Dt); !wn.done; Yt++, wn = Ie.next()) wn = Ct(Dt, $e, Yt, wn.value, ot), wn !== null && (c && wn.alternate !== null && Dt.delete(wn.key === null ? Yt : wn.key), Se = A(wn, Se, Yt), qt === null ? At = wn : qt.sibling = wn, qt = wn);
      return c && Dt.forEach(function(YE) {
        return d($e, YE);
      }), Zn && ga($e, Yt), At;
    }
    function Er($e, Se, Ie, ot) {
      if (typeof Ie == "object" && Ie !== null && Ie.type === z && Ie.key === null && (Ie = Ie.props.children), typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case N:
            e: {
              for (var At = Ie.key, qt = Se; qt !== null; ) {
                if (qt.key === At) {
                  if (At = Ie.type, At === z) {
                    if (qt.tag === 7) {
                      g($e, qt.sibling), Se = $(qt, Ie.props.children), Se.return = $e, $e = Se;
                      break e;
                    }
                  } else if (qt.elementType === At || typeof At == "object" && At !== null && At.$$typeof === Z && zx(At) === qt.type) {
                    g($e, qt.sibling), Se = $(qt, Ie.props), Se.ref = ac($e, qt, Ie), Se.return = $e, $e = Se;
                    break e;
                  }
                  g($e, qt);
                  break;
                } else d($e, qt);
                qt = qt.sibling;
              }
              Ie.type === z ? (Se = xc(Ie.props.children, $e.mode, ot, Ie.key), Se.return = $e, $e = Se) : (ot = _h(Ie.type, Ie.key, Ie.props, null, $e.mode, ot), ot.ref = ac($e, Se, Ie), ot.return = $e, $e = ot);
            }
            return q($e);
          case V:
            e: {
              for (qt = Ie.key; Se !== null; ) {
                if (Se.key === qt) if (Se.tag === 4 && Se.stateNode.containerInfo === Ie.containerInfo && Se.stateNode.implementation === Ie.implementation) {
                  g($e, Se.sibling), Se = $(Se, Ie.children || []), Se.return = $e, $e = Se;
                  break e;
                } else {
                  g($e, Se);
                  break;
                }
                else d($e, Se);
                Se = Se.sibling;
              }
              Se = pf(Ie, $e.mode, ot), Se.return = $e, $e = Se;
            }
            return q($e);
          case Z:
            return qt = Ie._init, Er($e, Se, qt(Ie._payload), ot);
        }
        if (Pt(Ie)) return $t($e, Se, Ie, ot);
        if (G(Ie)) return It($e, Se, Ie, ot);
        Ui($e, Ie);
      }
      return typeof Ie == "string" && Ie !== "" || typeof Ie == "number" ? (Ie = "" + Ie, Se !== null && Se.tag === 6 ? (g($e, Se.sibling), Se = $(Se, Ie), Se.return = $e, $e = Se) : (g($e, Se), Se = Lh(Ie, $e.mode, ot), Se.return = $e, $e = Se), q($e)) : g($e, Se);
    }
    return Er;
  }
  var cu = Xp(!0), Ux = Xp(!1), $s = an(null), jr = null, ut = null, Ua = null;
  function ba() {
    Ua = ut = jr = null;
  }
  function Rg(c) {
    var d = $s.current;
    On($s), c._currentValue = d;
  }
  function Og(c, d, g) {
    for (; c !== null; ) {
      var C = c.alternate;
      if ((c.childLanes & d) !== d ? (c.childLanes |= d, C !== null && (C.childLanes |= d)) : C !== null && (C.childLanes & d) !== d && (C.childLanes |= d), c === g) break;
      c = c.return;
    }
  }
  function uu(c, d) {
    jr = c, Ua = ut = null, c = c.dependencies, c !== null && c.firstContext !== null && (c.lanes & d && (oa = !0), c.firstContext = null);
  }
  function Ha(c) {
    var d = c._currentValue;
    if (Ua !== c) if (c = { context: c, memoizedValue: d, next: null }, ut === null) {
      if (jr === null) throw Error(n(308));
      ut = c, jr.dependencies = { lanes: 0, firstContext: c };
    } else ut = ut.next = c;
    return d;
  }
  var ic = null;
  function Dr(c) {
    ic === null ? ic = [c] : ic.push(c);
  }
  function Hx(c, d, g, C) {
    var $ = d.interleaved;
    return $ === null ? (g.next = g, Dr(d)) : (g.next = $.next, $.next = g), d.interleaved = g, Ds(c, C);
  }
  function Ds(c, d) {
    c.lanes |= d;
    var g = c.alternate;
    for (g !== null && (g.lanes |= d), g = c, c = c.return; c !== null; ) c.childLanes |= d, g = c.alternate, g !== null && (g.childLanes |= d), g = c, c = c.return;
    return g.tag === 3 ? g.stateNode : null;
  }
  var hl = !1;
  function Qp(c) {
    c.updateQueue = { baseState: c.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function du(c, d) {
    c = c.updateQueue, d.updateQueue === c && (d.updateQueue = { baseState: c.baseState, firstBaseUpdate: c.firstBaseUpdate, lastBaseUpdate: c.lastBaseUpdate, shared: c.shared, effects: c.effects });
  }
  function na(c, d) {
    return { eventTime: c, lane: d, tag: 0, payload: null, callback: null, next: null };
  }
  function ml(c, d, g) {
    var C = c.updateQueue;
    if (C === null) return null;
    if (C = C.shared, hn & 2) {
      var $ = C.pending;
      return $ === null ? d.next = d : (d.next = $.next, $.next = d), C.pending = d, Ds(c, g);
    }
    return $ = C.interleaved, $ === null ? (d.next = d, Dr(C)) : (d.next = $.next, $.next = d), C.interleaved = d, Ds(c, g);
  }
  function Jp(c, d, g) {
    if (d = d.updateQueue, d !== null && (d = d.shared, (g & 4194240) !== 0)) {
      var C = d.lanes;
      C &= c.pendingLanes, g |= C, d.lanes = g, Rd(c, g);
    }
  }
  function Wx(c, d) {
    var g = c.updateQueue, C = c.alternate;
    if (C !== null && (C = C.updateQueue, g === C)) {
      var $ = null, A = null;
      if (g = g.firstBaseUpdate, g !== null) {
        do {
          var q = { eventTime: g.eventTime, lane: g.lane, tag: g.tag, payload: g.payload, callback: g.callback, next: null };
          A === null ? $ = A = q : A = A.next = q, g = g.next;
        } while (g !== null);
        A === null ? $ = A = d : A = A.next = d;
      } else $ = A = d;
      g = { baseState: C.baseState, firstBaseUpdate: $, lastBaseUpdate: A, shared: C.shared, effects: C.effects }, c.updateQueue = g;
      return;
    }
    c = g.lastBaseUpdate, c === null ? g.firstBaseUpdate = d : c.next = d, g.lastBaseUpdate = d;
  }
  function Zp(c, d, g, C) {
    var $ = c.updateQueue;
    hl = !1;
    var A = $.firstBaseUpdate, q = $.lastBaseUpdate, ue = $.shared.pending;
    if (ue !== null) {
      $.shared.pending = null;
      var he = ue, Fe = he.next;
      he.next = null, q === null ? A = Fe : q.next = Fe, q = he;
      var Je = c.alternate;
      Je !== null && (Je = Je.updateQueue, ue = Je.lastBaseUpdate, ue !== q && (ue === null ? Je.firstBaseUpdate = Fe : ue.next = Fe, Je.lastBaseUpdate = he));
    }
    if (A !== null) {
      var Ze = $.baseState;
      q = 0, Je = Fe = he = null, ue = A;
      do {
        var Ke = ue.lane, Ct = ue.eventTime;
        if ((C & Ke) === Ke) {
          Je !== null && (Je = Je.next = {
            eventTime: Ct,
            lane: 0,
            tag: ue.tag,
            payload: ue.payload,
            callback: ue.callback,
            next: null
          });
          e: {
            var $t = c, It = ue;
            switch (Ke = d, Ct = g, It.tag) {
              case 1:
                if ($t = It.payload, typeof $t == "function") {
                  Ze = $t.call(Ct, Ze, Ke);
                  break e;
                }
                Ze = $t;
                break e;
              case 3:
                $t.flags = $t.flags & -65537 | 128;
              case 0:
                if ($t = It.payload, Ke = typeof $t == "function" ? $t.call(Ct, Ze, Ke) : $t, Ke == null) break e;
                Ze = W({}, Ze, Ke);
                break e;
              case 2:
                hl = !0;
            }
          }
          ue.callback !== null && ue.lane !== 0 && (c.flags |= 64, Ke = $.effects, Ke === null ? $.effects = [ue] : Ke.push(ue));
        } else Ct = { eventTime: Ct, lane: Ke, tag: ue.tag, payload: ue.payload, callback: ue.callback, next: null }, Je === null ? (Fe = Je = Ct, he = Ze) : Je = Je.next = Ct, q |= Ke;
        if (ue = ue.next, ue === null) {
          if (ue = $.shared.pending, ue === null) break;
          Ke = ue, ue = Ke.next, Ke.next = null, $.lastBaseUpdate = Ke, $.shared.pending = null;
        }
      } while (!0);
      if (Je === null && (he = Ze), $.baseState = he, $.firstBaseUpdate = Fe, $.lastBaseUpdate = Je, d = $.shared.interleaved, d !== null) {
        $ = d;
        do
          q |= $.lane, $ = $.next;
        while ($ !== d);
      } else A === null && ($.shared.lanes = 0);
      vc |= q, c.lanes = q, c.memoizedState = Ze;
    }
  }
  function qx(c, d, g) {
    if (c = d.effects, d.effects = null, c !== null) for (d = 0; d < c.length; d++) {
      var C = c[d], $ = C.callback;
      if ($ !== null) {
        if (C.callback = null, C = g, typeof $ != "function") throw Error(n(191, $));
        $.call(C);
      }
    }
  }
  var Kd = {}, Ei = an(Kd), fu = an(Kd), Xd = an(Kd);
  function sc(c) {
    if (c === Kd) throw Error(n(174));
    return c;
  }
  function Pg(c, d) {
    switch (Pn(Xd, d), Pn(fu, c), Pn(Ei, Kd), c = d.nodeType, c) {
      case 9:
      case 11:
        d = (d = d.documentElement) ? d.namespaceURI : ln(null, "");
        break;
      default:
        c = c === 8 ? d.parentNode : d, d = c.namespaceURI || null, c = c.tagName, d = ln(d, c);
    }
    On(Ei), Pn(Ei, d);
  }
  function pu() {
    On(Ei), On(fu), On(Xd);
  }
  function Yx(c) {
    sc(Xd.current);
    var d = sc(Ei.current), g = ln(d, c.type);
    d !== g && (Pn(fu, c), Pn(Ei, g));
  }
  function $g(c) {
    fu.current === c && (On(Ei), On(fu));
  }
  var ar = an(0);
  function eh(c) {
    for (var d = c; d !== null; ) {
      if (d.tag === 13) {
        var g = d.memoizedState;
        if (g !== null && (g = g.dehydrated, g === null || g.data === "$?" || g.data === "$!")) return d;
      } else if (d.tag === 19 && d.memoizedProps.revealOrder !== void 0) {
        if (d.flags & 128) return d;
      } else if (d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === c) break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === c) return null;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
    return null;
  }
  var th = [];
  function Dg() {
    for (var c = 0; c < th.length; c++) th[c]._workInProgressVersionPrimary = null;
    th.length = 0;
  }
  var nh = F.ReactCurrentDispatcher, Qd = F.ReactCurrentBatchConfig, _t = 0, Lt = null, Xt = null, un = null, xa = !1, hu = !1, Jd = 0, DE = 0;
  function wo() {
    throw Error(n(321));
  }
  function Zd(c, d) {
    if (d === null) return !1;
    for (var g = 0; g < d.length && g < c.length; g++) if (!La(c[g], d[g])) return !1;
    return !0;
  }
  function Ge(c, d, g, C, $, A) {
    if (_t = A, Lt = d, d.memoizedState = null, d.updateQueue = null, d.lanes = 0, nh.current = c === null || c.memoizedState === null ? kE : Xn, c = g(C, $), hu) {
      A = 0;
      do {
        if (hu = !1, Jd = 0, 25 <= A) throw Error(n(301));
        A += 1, un = Xt = null, d.updateQueue = null, nh.current = gh, c = g(C, $);
      } while (hu);
    }
    if (nh.current = To, d = Xt !== null && Xt.next !== null, _t = 0, un = Xt = Lt = null, xa = !1, d) throw Error(n(300));
    return c;
  }
  function kr() {
    var c = Jd !== 0;
    return Jd = 0, c;
  }
  function Bt() {
    var c = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return un === null ? Lt.memoizedState = un = c : un = un.next = c, un;
  }
  function io() {
    if (Xt === null) {
      var c = Lt.alternate;
      c = c !== null ? c.memoizedState : null;
    } else c = Xt.next;
    var d = un === null ? Lt.memoizedState : un.next;
    if (d !== null) un = d, Xt = c;
    else {
      if (c === null) throw Error(n(310));
      Xt = c, c = { memoizedState: Xt.memoizedState, baseState: Xt.baseState, baseQueue: Xt.baseQueue, queue: Xt.queue, next: null }, un === null ? Lt.memoizedState = un = c : un = un.next = c;
    }
    return un;
  }
  function Sa(c, d) {
    return typeof d == "function" ? d(c) : d;
  }
  function ks(c) {
    var d = io(), g = d.queue;
    if (g === null) throw Error(n(311));
    g.lastRenderedReducer = c;
    var C = Xt, $ = C.baseQueue, A = g.pending;
    if (A !== null) {
      if ($ !== null) {
        var q = $.next;
        $.next = A.next, A.next = q;
      }
      C.baseQueue = $ = A, g.pending = null;
    }
    if ($ !== null) {
      A = $.next, C = C.baseState;
      var ue = q = null, he = null, Fe = A;
      do {
        var Je = Fe.lane;
        if ((_t & Je) === Je) he !== null && (he = he.next = { lane: 0, action: Fe.action, hasEagerState: Fe.hasEagerState, eagerState: Fe.eagerState, next: null }), C = Fe.hasEagerState ? Fe.eagerState : c(C, Fe.action);
        else {
          var Ze = {
            lane: Je,
            action: Fe.action,
            hasEagerState: Fe.hasEagerState,
            eagerState: Fe.eagerState,
            next: null
          };
          he === null ? (ue = he = Ze, q = C) : he = he.next = Ze, Lt.lanes |= Je, vc |= Je;
        }
        Fe = Fe.next;
      } while (Fe !== null && Fe !== A);
      he === null ? q = C : he.next = ue, La(C, d.memoizedState) || (oa = !0), d.memoizedState = C, d.baseState = q, d.baseQueue = he, g.lastRenderedState = C;
    }
    if (c = g.interleaved, c !== null) {
      $ = c;
      do
        A = $.lane, Lt.lanes |= A, vc |= A, $ = $.next;
      while ($ !== c);
    } else $ === null && (g.lanes = 0);
    return [d.memoizedState, g.dispatch];
  }
  function Wa(c) {
    var d = io(), g = d.queue;
    if (g === null) throw Error(n(311));
    g.lastRenderedReducer = c;
    var C = g.dispatch, $ = g.pending, A = d.memoizedState;
    if ($ !== null) {
      g.pending = null;
      var q = $ = $.next;
      do
        A = c(A, q.action), q = q.next;
      while (q !== $);
      La(A, d.memoizedState) || (oa = !0), d.memoizedState = A, d.baseQueue === null && (d.baseState = A), g.lastRenderedState = A;
    }
    return [A, C];
  }
  function mu() {
  }
  function lc(c, d) {
    var g = Lt, C = io(), $ = d(), A = !La(C.memoizedState, $);
    if (A && (C.memoizedState = $, oa = !0), C = C.queue, ef(oh.bind(null, g, C, c), [c]), C.getSnapshot !== d || A || un !== null && un.memoizedState.tag & 1) {
      if (g.flags |= 2048, cc(9, rh.bind(null, g, C, $, d), void 0, null), yr === null) throw Error(n(349));
      _t & 30 || vu(g, d, $);
    }
    return $;
  }
  function vu(c, d, g) {
    c.flags |= 16384, c = { getSnapshot: d, value: g }, d = Lt.updateQueue, d === null ? (d = { lastEffect: null, stores: null }, Lt.updateQueue = d, d.stores = [c]) : (g = d.stores, g === null ? d.stores = [c] : g.push(c));
  }
  function rh(c, d, g, C) {
    d.value = g, d.getSnapshot = C, ah(d) && ih(c);
  }
  function oh(c, d, g) {
    return g(function() {
      ah(d) && ih(c);
    });
  }
  function ah(c) {
    var d = c.getSnapshot;
    c = c.value;
    try {
      var g = d();
      return !La(c, g);
    } catch {
      return !0;
    }
  }
  function ih(c) {
    var d = Ds(c, 1);
    d !== null && ur(d, c, 1, -1);
  }
  function sh(c) {
    var d = Bt();
    return typeof c == "function" && (c = c()), d.memoizedState = d.baseState = c, c = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Sa, lastRenderedState: c }, d.queue = c, c = c.dispatch = tf.bind(null, Lt, c), [d.memoizedState, c];
  }
  function cc(c, d, g, C) {
    return c = { tag: c, create: d, destroy: g, deps: C, next: null }, d = Lt.updateQueue, d === null ? (d = { lastEffect: null, stores: null }, Lt.updateQueue = d, d.lastEffect = c.next = c) : (g = d.lastEffect, g === null ? d.lastEffect = c.next = c : (C = g.next, g.next = c, c.next = C, d.lastEffect = c)), c;
  }
  function lh() {
    return io().memoizedState;
  }
  function gu(c, d, g, C) {
    var $ = Bt();
    Lt.flags |= c, $.memoizedState = cc(1 | d, g, void 0, C === void 0 ? null : C);
  }
  function yu(c, d, g, C) {
    var $ = io();
    C = C === void 0 ? null : C;
    var A = void 0;
    if (Xt !== null) {
      var q = Xt.memoizedState;
      if (A = q.destroy, C !== null && Zd(C, q.deps)) {
        $.memoizedState = cc(d, g, A, C);
        return;
      }
    }
    Lt.flags |= c, $.memoizedState = cc(1 | d, g, A, C);
  }
  function ch(c, d) {
    return gu(8390656, 8, c, d);
  }
  function ef(c, d) {
    return yu(2048, 8, c, d);
  }
  function uh(c, d) {
    return yu(4, 2, c, d);
  }
  function dh(c, d) {
    return yu(4, 4, c, d);
  }
  function fh(c, d) {
    if (typeof d == "function") return c = c(), d(c), function() {
      d(null);
    };
    if (d != null) return c = c(), d.current = c, function() {
      d.current = null;
    };
  }
  function ph(c, d, g) {
    return g = g != null ? g.concat([c]) : null, yu(4, 4, fh.bind(null, d, c), g);
  }
  function bu() {
  }
  function uc(c, d) {
    var g = io();
    d = d === void 0 ? null : d;
    var C = g.memoizedState;
    return C !== null && d !== null && Zd(d, C[1]) ? C[0] : (g.memoizedState = [c, d], c);
  }
  function hh(c, d) {
    var g = io();
    d = d === void 0 ? null : d;
    var C = g.memoizedState;
    return C !== null && d !== null && Zd(d, C[1]) ? C[0] : (c = c(), g.memoizedState = [c, d], c);
  }
  function mh(c, d, g) {
    return _t & 21 ? (La(g, d) || (g = Ep(), Lt.lanes |= g, vc |= g, c.baseState = !0), d) : (c.baseState && (c.baseState = !1, oa = !0), c.memoizedState = g);
  }
  function kg(c, d) {
    var g = kn;
    kn = g !== 0 && 4 > g ? g : 4, c(!0);
    var C = Qd.transition;
    Qd.transition = {};
    try {
      c(!1), d();
    } finally {
      kn = g, Qd.transition = C;
    }
  }
  function vh() {
    return io().memoizedState;
  }
  function Gx(c, d, g) {
    var C = Is(c);
    if (g = { lane: C, action: g, hasEagerState: !1, eagerState: null, next: null }, Mg(c)) xu(d, g);
    else if (g = Hx(c, d, g, C), g !== null) {
      var $ = Zr();
      ur(g, c, C, $), vl(g, d, C);
    }
  }
  function tf(c, d, g) {
    var C = Is(c), $ = { lane: C, action: g, hasEagerState: !1, eagerState: null, next: null };
    if (Mg(c)) xu(d, $);
    else {
      var A = c.alternate;
      if (c.lanes === 0 && (A === null || A.lanes === 0) && (A = d.lastRenderedReducer, A !== null)) try {
        var q = d.lastRenderedState, ue = A(q, g);
        if ($.hasEagerState = !0, $.eagerState = ue, La(ue, q)) {
          var he = d.interleaved;
          he === null ? ($.next = $, Dr(d)) : ($.next = he.next, he.next = $), d.interleaved = $;
          return;
        }
      } catch {
      } finally {
      }
      g = Hx(c, d, $, C), g !== null && ($ = Zr(), ur(g, c, C, $), vl(g, d, C));
    }
  }
  function Mg(c) {
    var d = c.alternate;
    return c === Lt || d !== null && d === Lt;
  }
  function xu(c, d) {
    hu = xa = !0;
    var g = c.pending;
    g === null ? d.next = d : (d.next = g.next, g.next = d), c.pending = d;
  }
  function vl(c, d, g) {
    if (g & 4194240) {
      var C = d.lanes;
      C &= c.pendingLanes, g |= C, d.lanes = g, Rd(c, g);
    }
  }
  var To = { readContext: Ha, useCallback: wo, useContext: wo, useEffect: wo, useImperativeHandle: wo, useInsertionEffect: wo, useLayoutEffect: wo, useMemo: wo, useReducer: wo, useRef: wo, useState: wo, useDebugValue: wo, useDeferredValue: wo, useTransition: wo, useMutableSource: wo, useSyncExternalStore: wo, useId: wo, unstable_isNewReconciler: !1 }, kE = { readContext: Ha, useCallback: function(c, d) {
    return Bt().memoizedState = [c, d === void 0 ? null : d], c;
  }, useContext: Ha, useEffect: ch, useImperativeHandle: function(c, d, g) {
    return g = g != null ? g.concat([c]) : null, gu(
      4194308,
      4,
      fh.bind(null, d, c),
      g
    );
  }, useLayoutEffect: function(c, d) {
    return gu(4194308, 4, c, d);
  }, useInsertionEffect: function(c, d) {
    return gu(4, 2, c, d);
  }, useMemo: function(c, d) {
    var g = Bt();
    return d = d === void 0 ? null : d, c = c(), g.memoizedState = [c, d], c;
  }, useReducer: function(c, d, g) {
    var C = Bt();
    return d = g !== void 0 ? g(d) : d, C.memoizedState = C.baseState = d, c = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: c, lastRenderedState: d }, C.queue = c, c = c.dispatch = Gx.bind(null, Lt, c), [C.memoizedState, c];
  }, useRef: function(c) {
    var d = Bt();
    return c = { current: c }, d.memoizedState = c;
  }, useState: sh, useDebugValue: bu, useDeferredValue: function(c) {
    return Bt().memoizedState = c;
  }, useTransition: function() {
    var c = sh(!1), d = c[0];
    return c = kg.bind(null, c[1]), Bt().memoizedState = c, [d, c];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(c, d, g) {
    var C = Lt, $ = Bt();
    if (Zn) {
      if (g === void 0) throw Error(n(407));
      g = g();
    } else {
      if (g = d(), yr === null) throw Error(n(349));
      _t & 30 || vu(C, d, g);
    }
    $.memoizedState = g;
    var A = { value: g, getSnapshot: d };
    return $.queue = A, ch(oh.bind(
      null,
      C,
      A,
      c
    ), [c]), C.flags |= 2048, cc(9, rh.bind(null, C, A, g, d), void 0, null), g;
  }, useId: function() {
    var c = Bt(), d = yr.identifierPrefix;
    if (Zn) {
      var g = Ps, C = ao;
      g = (C & ~(1 << 32 - Ia(C) - 1)).toString(32) + g, d = ":" + d + "R" + g, g = Jd++, 0 < g && (d += "H" + g.toString(32)), d += ":";
    } else g = DE++, d = ":" + d + "r" + g.toString(32) + ":";
    return c.memoizedState = d;
  }, unstable_isNewReconciler: !1 }, Xn = {
    readContext: Ha,
    useCallback: uc,
    useContext: Ha,
    useEffect: ef,
    useImperativeHandle: ph,
    useInsertionEffect: uh,
    useLayoutEffect: dh,
    useMemo: hh,
    useReducer: ks,
    useRef: lh,
    useState: function() {
      return ks(Sa);
    },
    useDebugValue: bu,
    useDeferredValue: function(c) {
      var d = io();
      return mh(d, Xt.memoizedState, c);
    },
    useTransition: function() {
      var c = ks(Sa)[0], d = io().memoizedState;
      return [c, d];
    },
    useMutableSource: mu,
    useSyncExternalStore: lc,
    useId: vh,
    unstable_isNewReconciler: !1
  }, gh = { readContext: Ha, useCallback: uc, useContext: Ha, useEffect: ef, useImperativeHandle: ph, useInsertionEffect: uh, useLayoutEffect: dh, useMemo: hh, useReducer: Wa, useRef: lh, useState: function() {
    return Wa(Sa);
  }, useDebugValue: bu, useDeferredValue: function(c) {
    var d = io();
    return Xt === null ? d.memoizedState = c : mh(d, Xt.memoizedState, c);
  }, useTransition: function() {
    var c = Wa(Sa)[0], d = io().memoizedState;
    return [c, d];
  }, useMutableSource: mu, useSyncExternalStore: lc, useId: vh, unstable_isNewReconciler: !1 };
  function ra(c, d) {
    if (c && c.defaultProps) {
      d = W({}, d), c = c.defaultProps;
      for (var g in c) d[g] === void 0 && (d[g] = c[g]);
      return d;
    }
    return d;
  }
  function dc(c, d, g, C) {
    d = c.memoizedState, g = g(C, d), g = g == null ? d : W({}, d, g), c.memoizedState = g, c.lanes === 0 && (c.updateQueue.baseState = g);
  }
  var fc = { isMounted: function(c) {
    return (c = c._reactInternals) ? ze(c) === c : !1;
  }, enqueueSetState: function(c, d, g) {
    c = c._reactInternals;
    var C = Zr(), $ = Is(c), A = na(C, $);
    A.payload = d, g != null && (A.callback = g), d = ml(c, A, $), d !== null && (ur(d, c, $, C), Jp(d, c, $));
  }, enqueueReplaceState: function(c, d, g) {
    c = c._reactInternals;
    var C = Zr(), $ = Is(c), A = na(C, $);
    A.tag = 1, A.payload = d, g != null && (A.callback = g), d = ml(c, A, $), d !== null && (ur(d, c, $, C), Jp(d, c, $));
  }, enqueueForceUpdate: function(c, d) {
    c = c._reactInternals;
    var g = Zr(), C = Is(c), $ = na(g, C);
    $.tag = 2, d != null && ($.callback = d), d = ml(c, $, C), d !== null && (ur(d, c, C, g), Jp(d, c, C));
  } };
  function Kx(c, d, g, C, $, A, q) {
    return c = c.stateNode, typeof c.shouldComponentUpdate == "function" ? c.shouldComponentUpdate(C, A, q) : d.prototype && d.prototype.isPureReactComponent ? !Ld(g, C) || !Ld($, A) : !0;
  }
  function Xx(c, d, g) {
    var C = !1, $ = zi, A = d.contextType;
    return typeof A == "object" && A !== null ? A = Ha(A) : ($ = or(d) ? Qo : Kt.current, C = d.contextTypes, A = (C = C != null) ? ja(c, $) : zi), d = new d(g, A), c.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = fc, c.stateNode = d, d._reactInternals = c, C && (c = c.stateNode, c.__reactInternalMemoizedUnmaskedChildContext = $, c.__reactInternalMemoizedMaskedChildContext = A), d;
  }
  function Qx(c, d, g, C) {
    c = d.state, typeof d.componentWillReceiveProps == "function" && d.componentWillReceiveProps(g, C), typeof d.UNSAFE_componentWillReceiveProps == "function" && d.UNSAFE_componentWillReceiveProps(g, C), d.state !== c && fc.enqueueReplaceState(d, d.state, null);
  }
  function Ng(c, d, g, C) {
    var $ = c.stateNode;
    $.props = g, $.state = c.memoizedState, $.refs = {}, Qp(c);
    var A = d.contextType;
    typeof A == "object" && A !== null ? $.context = Ha(A) : (A = or(d) ? Qo : Kt.current, $.context = ja(c, A)), $.state = c.memoizedState, A = d.getDerivedStateFromProps, typeof A == "function" && (dc(c, d, A, g), $.state = c.memoizedState), typeof d.getDerivedStateFromProps == "function" || typeof $.getSnapshotBeforeUpdate == "function" || typeof $.UNSAFE_componentWillMount != "function" && typeof $.componentWillMount != "function" || (d = $.state, typeof $.componentWillMount == "function" && $.componentWillMount(), typeof $.UNSAFE_componentWillMount == "function" && $.UNSAFE_componentWillMount(), d !== $.state && fc.enqueueReplaceState($, $.state, null), Zp(c, g, $, C), $.state = c.memoizedState), typeof $.componentDidMount == "function" && (c.flags |= 4194308);
  }
  function gl(c, d) {
    try {
      var g = "", C = d;
      do
        g += de(C), C = C.return;
      while (C);
      var $ = g;
    } catch (A) {
      $ = `
Error generating stack: ` + A.message + `
` + A.stack;
    }
    return { value: c, source: d, stack: $, digest: null };
  }
  function Ig(c, d, g) {
    return { value: c, source: null, stack: g ?? null, digest: d ?? null };
  }
  function nf(c, d) {
    try {
      console.error(d.value);
    } catch (g) {
      setTimeout(function() {
        throw g;
      });
    }
  }
  var Jx = typeof WeakMap == "function" ? WeakMap : Map;
  function Zx(c, d, g) {
    g = na(-1, g), g.tag = 3, g.payload = { element: null };
    var C = d.value;
    return g.callback = function() {
      $h || ($h = !0, Ug = C), nf(c, d);
    }, g;
  }
  function eS(c, d, g) {
    g = na(-1, g), g.tag = 3;
    var C = c.type.getDerivedStateFromError;
    if (typeof C == "function") {
      var $ = d.value;
      g.payload = function() {
        return C($);
      }, g.callback = function() {
        nf(c, d);
      };
    }
    var A = c.stateNode;
    return A !== null && typeof A.componentDidCatch == "function" && (g.callback = function() {
      nf(c, d), typeof C != "function" && (Ga === null ? Ga = /* @__PURE__ */ new Set([this]) : Ga.add(this));
      var q = d.stack;
      this.componentDidCatch(d.value, { componentStack: q !== null ? q : "" });
    }), g;
  }
  function rf(c, d, g) {
    var C = c.pingCache;
    if (C === null) {
      C = c.pingCache = new Jx();
      var $ = /* @__PURE__ */ new Set();
      C.set(d, $);
    } else $ = C.get(d), $ === void 0 && ($ = /* @__PURE__ */ new Set(), C.set(d, $));
    $.has(g) || ($.add(g), c = BE.bind(null, c, d, g), d.then(c, c));
  }
  function tS(c) {
    do {
      var d;
      if ((d = c.tag === 13) && (d = c.memoizedState, d = d !== null ? d.dehydrated !== null : !0), d) return c;
      c = c.return;
    } while (c !== null);
    return null;
  }
  function _g(c, d, g, C, $) {
    return c.mode & 1 ? (c.flags |= 65536, c.lanes = $, c) : (c === d ? c.flags |= 65536 : (c.flags |= 128, g.flags |= 131072, g.flags &= -52805, g.tag === 1 && (g.alternate === null ? g.tag = 17 : (d = na(-1, 1), d.tag = 2, ml(g, d, 1))), g.lanes |= 1), c);
  }
  var nS = F.ReactCurrentOwner, oa = !1;
  function wr(c, d, g, C) {
    d.child = c === null ? Ux(d, null, g, C) : cu(d, c.child, g, C);
  }
  function Su(c, d, g, C, $) {
    g = g.render;
    var A = d.ref;
    return uu(d, $), C = Ge(c, d, g, C, A, $), g = kr(), c !== null && !oa ? (d.updateQueue = c.updateQueue, d.flags &= -2053, c.lanes &= ~$, Tr(c, d, $)) : (Zn && g && Wp(d), d.flags |= 1, wr(c, d, C, $), d.child);
  }
  function yl(c, d, g, C, $) {
    if (c === null) {
      var A = g.type;
      return typeof A == "function" && !Gg(A) && A.defaultProps === void 0 && g.compare === null && g.defaultProps === void 0 ? (d.tag = 15, d.type = A, yh(c, d, A, C, $)) : (c = _h(g.type, null, C, d, d.mode, $), c.ref = d.ref, c.return = d, d.child = c);
    }
    if (A = c.child, !(c.lanes & $)) {
      var q = A.memoizedProps;
      if (g = g.compare, g = g !== null ? g : Ld, g(q, C) && c.ref === d.ref) return Tr(c, d, $);
    }
    return d.flags |= 1, c = Sl(A, C), c.ref = d.ref, c.return = d, d.child = c;
  }
  function yh(c, d, g, C, $) {
    if (c !== null) {
      var A = c.memoizedProps;
      if (Ld(A, C) && c.ref === d.ref) if (oa = !1, d.pendingProps = C = A, (c.lanes & $) !== 0) c.flags & 131072 && (oa = !0);
      else return d.lanes = c.lanes, Tr(c, d, $);
    }
    return rn(c, d, g, C, $);
  }
  function aa(c, d, g) {
    var C = d.pendingProps, $ = C.children, A = c !== null ? c.memoizedState : null;
    if (C.mode === "hidden") if (!(d.mode & 1)) d.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Pn(ku, ia), ia |= g;
    else {
      if (!(g & 1073741824)) return c = A !== null ? A.baseLanes | g : g, d.lanes = d.childLanes = 1073741824, d.memoizedState = { baseLanes: c, cachePool: null, transitions: null }, d.updateQueue = null, Pn(ku, ia), ia |= c, null;
      d.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, C = A !== null ? A.baseLanes : g, Pn(ku, ia), ia |= C;
    }
    else A !== null ? (C = A.baseLanes | g, d.memoizedState = null) : C = g, Pn(ku, ia), ia |= C;
    return wr(c, d, $, g), d.child;
  }
  function pc(c, d) {
    var g = d.ref;
    (c === null && g !== null || c !== null && c.ref !== g) && (d.flags |= 512, d.flags |= 2097152);
  }
  function rn(c, d, g, C, $) {
    var A = or(g) ? Qo : Kt.current;
    return A = ja(d, A), uu(d, $), g = Ge(c, d, g, C, A, $), C = kr(), c !== null && !oa ? (d.updateQueue = c.updateQueue, d.flags &= -2053, c.lanes &= ~$, Tr(c, d, $)) : (Zn && C && Wp(d), d.flags |= 1, wr(c, d, g, $), d.child);
  }
  function of(c, d, g, C, $) {
    if (or(g)) {
      var A = !0;
      Hp(d);
    } else A = !1;
    if (uu(d, $), d.stateNode === null) sf(c, d), Xx(d, g, C), Ng(d, g, C, $), C = !0;
    else if (c === null) {
      var q = d.stateNode, ue = d.memoizedProps;
      q.props = ue;
      var he = q.context, Fe = g.contextType;
      typeof Fe == "object" && Fe !== null ? Fe = Ha(Fe) : (Fe = or(g) ? Qo : Kt.current, Fe = ja(d, Fe));
      var Je = g.getDerivedStateFromProps, Ze = typeof Je == "function" || typeof q.getSnapshotBeforeUpdate == "function";
      Ze || typeof q.UNSAFE_componentWillReceiveProps != "function" && typeof q.componentWillReceiveProps != "function" || (ue !== C || he !== Fe) && Qx(d, q, C, Fe), hl = !1;
      var Ke = d.memoizedState;
      q.state = Ke, Zp(d, C, q, $), he = d.memoizedState, ue !== C || Ke !== he || vr.current || hl ? (typeof Je == "function" && (dc(d, g, Je, C), he = d.memoizedState), (ue = hl || Kx(d, g, ue, C, Ke, he, Fe)) ? (Ze || typeof q.UNSAFE_componentWillMount != "function" && typeof q.componentWillMount != "function" || (typeof q.componentWillMount == "function" && q.componentWillMount(), typeof q.UNSAFE_componentWillMount == "function" && q.UNSAFE_componentWillMount()), typeof q.componentDidMount == "function" && (d.flags |= 4194308)) : (typeof q.componentDidMount == "function" && (d.flags |= 4194308), d.memoizedProps = C, d.memoizedState = he), q.props = C, q.state = he, q.context = Fe, C = ue) : (typeof q.componentDidMount == "function" && (d.flags |= 4194308), C = !1);
    } else {
      q = d.stateNode, du(c, d), ue = d.memoizedProps, Fe = d.type === d.elementType ? ue : ra(d.type, ue), q.props = Fe, Ze = d.pendingProps, Ke = q.context, he = g.contextType, typeof he == "object" && he !== null ? he = Ha(he) : (he = or(g) ? Qo : Kt.current, he = ja(d, he));
      var Ct = g.getDerivedStateFromProps;
      (Je = typeof Ct == "function" || typeof q.getSnapshotBeforeUpdate == "function") || typeof q.UNSAFE_componentWillReceiveProps != "function" && typeof q.componentWillReceiveProps != "function" || (ue !== Ze || Ke !== he) && Qx(d, q, C, he), hl = !1, Ke = d.memoizedState, q.state = Ke, Zp(d, C, q, $);
      var $t = d.memoizedState;
      ue !== Ze || Ke !== $t || vr.current || hl ? (typeof Ct == "function" && (dc(d, g, Ct, C), $t = d.memoizedState), (Fe = hl || Kx(d, g, Fe, C, Ke, $t, he) || !1) ? (Je || typeof q.UNSAFE_componentWillUpdate != "function" && typeof q.componentWillUpdate != "function" || (typeof q.componentWillUpdate == "function" && q.componentWillUpdate(C, $t, he), typeof q.UNSAFE_componentWillUpdate == "function" && q.UNSAFE_componentWillUpdate(C, $t, he)), typeof q.componentDidUpdate == "function" && (d.flags |= 4), typeof q.getSnapshotBeforeUpdate == "function" && (d.flags |= 1024)) : (typeof q.componentDidUpdate != "function" || ue === c.memoizedProps && Ke === c.memoizedState || (d.flags |= 4), typeof q.getSnapshotBeforeUpdate != "function" || ue === c.memoizedProps && Ke === c.memoizedState || (d.flags |= 1024), d.memoizedProps = C, d.memoizedState = $t), q.props = C, q.state = $t, q.context = he, C = Fe) : (typeof q.componentDidUpdate != "function" || ue === c.memoizedProps && Ke === c.memoizedState || (d.flags |= 4), typeof q.getSnapshotBeforeUpdate != "function" || ue === c.memoizedProps && Ke === c.memoizedState || (d.flags |= 1024), C = !1);
    }
    return bh(c, d, g, C, A, $);
  }
  function bh(c, d, g, C, $, A) {
    pc(c, d);
    var q = (d.flags & 128) !== 0;
    if (!C && !q) return $ && Fx(d, g, !1), Tr(c, d, A);
    C = d.stateNode, nS.current = d;
    var ue = q && typeof g.getDerivedStateFromError != "function" ? null : C.render();
    return d.flags |= 1, c !== null && q ? (d.child = cu(d, c.child, null, A), d.child = cu(d, null, ue, A)) : wr(c, d, ue, A), d.memoizedState = C.state, $ && Fx(d, g, !0), d.child;
  }
  function ME(c) {
    var d = c.stateNode;
    d.pendingContext ? fl(c, d.pendingContext, d.pendingContext !== d.context) : d.context && fl(c, d.context, !1), Pg(c, d.containerInfo);
  }
  function rS(c, d, g, C, $) {
    return cr(), Eg($), d.flags |= 256, wr(c, d, g, C), d.child;
  }
  var af = { dehydrated: null, treeContext: null, retryLane: 0 };
  function hc(c) {
    return { baseLanes: c, cachePool: null, transitions: null };
  }
  function oS(c, d, g) {
    var C = d.pendingProps, $ = ar.current, A = !1, q = (d.flags & 128) !== 0, ue;
    if ((ue = q) || (ue = c !== null && c.memoizedState === null ? !1 : ($ & 2) !== 0), ue ? (A = !0, d.flags &= -129) : (c === null || c.memoizedState !== null) && ($ |= 1), Pn(ar, $ & 1), c === null)
      return Yp(d), c = d.memoizedState, c !== null && (c = c.dehydrated, c !== null) ? (d.mode & 1 ? c.data === "$!" ? d.lanes = 8 : d.lanes = 1073741824 : d.lanes = 1, null) : (q = C.children, c = C.fallback, A ? (C = d.mode, A = d.child, q = { mode: "hidden", children: q }, !(C & 1) && A !== null ? (A.childLanes = 0, A.pendingProps = q) : A = Ah(q, C, 0, null), c = xc(c, C, g, null), A.return = d, c.return = d, A.sibling = c, d.child = A, d.child.memoizedState = hc(g), d.memoizedState = af, c) : xh(d, q));
    if ($ = c.memoizedState, $ !== null && (ue = $.dehydrated, ue !== null)) return Ag(c, d, q, C, ue, $, g);
    if (A) {
      A = C.fallback, q = d.mode, $ = c.child, ue = $.sibling;
      var he = { mode: "hidden", children: C.children };
      return !(q & 1) && d.child !== $ ? (C = d.child, C.childLanes = 0, C.pendingProps = he, d.deletions = null) : (C = Sl($, he), C.subtreeFlags = $.subtreeFlags & 14680064), ue !== null ? A = Sl(ue, A) : (A = xc(A, q, g, null), A.flags |= 2), A.return = d, C.return = d, C.sibling = A, d.child = C, C = A, A = d.child, q = c.child.memoizedState, q = q === null ? hc(g) : { baseLanes: q.baseLanes | g, cachePool: null, transitions: q.transitions }, A.memoizedState = q, A.childLanes = c.childLanes & ~g, d.memoizedState = af, C;
    }
    return A = c.child, c = A.sibling, C = Sl(A, { mode: "visible", children: C.children }), !(d.mode & 1) && (C.lanes = g), C.return = d, C.sibling = null, c !== null && (g = d.deletions, g === null ? (d.deletions = [c], d.flags |= 16) : g.push(c)), d.child = C, d.memoizedState = null, C;
  }
  function xh(c, d) {
    return d = Ah({ mode: "visible", children: d }, c.mode, 0, null), d.return = c, c.child = d;
  }
  function Sh(c, d, g, C) {
    return C !== null && Eg(C), cu(d, c.child, null, g), c = xh(d, d.pendingProps.children), c.flags |= 2, d.memoizedState = null, c;
  }
  function Ag(c, d, g, C, $, A, q) {
    if (g)
      return d.flags & 256 ? (d.flags &= -257, C = Ig(Error(n(422))), Sh(c, d, q, C)) : d.memoizedState !== null ? (d.child = c.child, d.flags |= 128, null) : (A = C.fallback, $ = d.mode, C = Ah({ mode: "visible", children: C.children }, $, 0, null), A = xc(A, $, q, null), A.flags |= 2, C.return = d, A.return = d, C.sibling = A, d.child = C, d.mode & 1 && cu(d, c.child, null, q), d.child.memoizedState = hc(q), d.memoizedState = af, A);
    if (!(d.mode & 1)) return Sh(c, d, q, null);
    if ($.data === "$!") {
      if (C = $.nextSibling && $.nextSibling.dataset, C) var ue = C.dgst;
      return C = ue, A = Error(n(419)), C = Ig(A, C, void 0), Sh(c, d, q, C);
    }
    if (ue = (q & c.childLanes) !== 0, oa || ue) {
      if (C = yr, C !== null) {
        switch (q & -q) {
          case 4:
            $ = 2;
            break;
          case 16:
            $ = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            $ = 32;
            break;
          case 536870912:
            $ = 268435456;
            break;
          default:
            $ = 0;
        }
        $ = $ & (C.suspendedLanes | q) ? 0 : $, $ !== 0 && $ !== A.retryLane && (A.retryLane = $, Ds(c, $), ur(C, c, $, -1));
      }
      return ff(), C = Ig(Error(n(421))), Sh(c, d, q, C);
    }
    return $.data === "$?" ? (d.flags |= 128, d.child = c.child, d = Yg.bind(null, c), $._reactRetry = d, null) : (c = A.treeContext, ta = Ti($.nextSibling), ya = d, Zn = !0, za = null, c !== null && (ea[Co++] = ao, ea[Co++] = Ps, ea[Co++] = Ba, ao = c.id, Ps = c.overflow, Ba = d), d = xh(d, C.children), d.flags |= 4096, d);
  }
  function aS(c, d, g) {
    c.lanes |= d;
    var C = c.alternate;
    C !== null && (C.lanes |= d), Og(c.return, d, g);
  }
  function Ch(c, d, g, C, $) {
    var A = c.memoizedState;
    A === null ? c.memoizedState = { isBackwards: d, rendering: null, renderingStartTime: 0, last: C, tail: g, tailMode: $ } : (A.isBackwards = d, A.rendering = null, A.renderingStartTime = 0, A.last = C, A.tail = g, A.tailMode = $);
  }
  function Lg(c, d, g) {
    var C = d.pendingProps, $ = C.revealOrder, A = C.tail;
    if (wr(c, d, C.children, g), C = ar.current, C & 2) C = C & 1 | 2, d.flags |= 128;
    else {
      if (c !== null && c.flags & 128) e: for (c = d.child; c !== null; ) {
        if (c.tag === 13) c.memoizedState !== null && aS(c, g, d);
        else if (c.tag === 19) aS(c, g, d);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === d) break e;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === d) break e;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      C &= 1;
    }
    if (Pn(ar, C), !(d.mode & 1)) d.memoizedState = null;
    else switch ($) {
      case "forwards":
        for (g = d.child, $ = null; g !== null; ) c = g.alternate, c !== null && eh(c) === null && ($ = g), g = g.sibling;
        g = $, g === null ? ($ = d.child, d.child = null) : ($ = g.sibling, g.sibling = null), Ch(d, !1, $, g, A);
        break;
      case "backwards":
        for (g = null, $ = d.child, d.child = null; $ !== null; ) {
          if (c = $.alternate, c !== null && eh(c) === null) {
            d.child = $;
            break;
          }
          c = $.sibling, $.sibling = g, g = $, $ = c;
        }
        Ch(d, !0, g, null, A);
        break;
      case "together":
        Ch(d, !1, null, null, void 0);
        break;
      default:
        d.memoizedState = null;
    }
    return d.child;
  }
  function sf(c, d) {
    !(d.mode & 1) && c !== null && (c.alternate = null, d.alternate = null, d.flags |= 2);
  }
  function Tr(c, d, g) {
    if (c !== null && (d.dependencies = c.dependencies), vc |= d.lanes, !(g & d.childLanes)) return null;
    if (c !== null && d.child !== c.child) throw Error(n(153));
    if (d.child !== null) {
      for (c = d.child, g = Sl(c, c.pendingProps), d.child = g, g.return = d; c.sibling !== null; ) c = c.sibling, g = g.sibling = Sl(c, c.pendingProps), g.return = d;
      g.sibling = null;
    }
    return d.child;
  }
  function Ms(c, d, g) {
    switch (d.tag) {
      case 3:
        ME(d), cr();
        break;
      case 5:
        Yx(d);
        break;
      case 1:
        or(d.type) && Hp(d);
        break;
      case 4:
        Pg(d, d.stateNode.containerInfo);
        break;
      case 10:
        var C = d.type._context, $ = d.memoizedProps.value;
        Pn($s, C._currentValue), C._currentValue = $;
        break;
      case 13:
        if (C = d.memoizedState, C !== null)
          return C.dehydrated !== null ? (Pn(ar, ar.current & 1), d.flags |= 128, null) : g & d.child.childLanes ? oS(c, d, g) : (Pn(ar, ar.current & 1), c = Tr(c, d, g), c !== null ? c.sibling : null);
        Pn(ar, ar.current & 1);
        break;
      case 19:
        if (C = (g & d.childLanes) !== 0, c.flags & 128) {
          if (C) return Lg(c, d, g);
          d.flags |= 128;
        }
        if ($ = d.memoizedState, $ !== null && ($.rendering = null, $.tail = null, $.lastEffect = null), Pn(ar, ar.current), C) break;
        return null;
      case 22:
      case 23:
        return d.lanes = 0, aa(c, d, g);
    }
    return Tr(c, d, g);
  }
  var Hi, Cu, wu, qa;
  Hi = function(c, d) {
    for (var g = d.child; g !== null; ) {
      if (g.tag === 5 || g.tag === 6) c.appendChild(g.stateNode);
      else if (g.tag !== 4 && g.child !== null) {
        g.child.return = g, g = g.child;
        continue;
      }
      if (g === d) break;
      for (; g.sibling === null; ) {
        if (g.return === null || g.return === d) return;
        g = g.return;
      }
      g.sibling.return = g.return, g = g.sibling;
    }
  }, Cu = function() {
  }, wu = function(c, d, g, C) {
    var $ = c.memoizedProps;
    if ($ !== C) {
      c = d.stateNode, sc(Ei.current);
      var A = null;
      switch (g) {
        case "input":
          $ = ye(c, $), C = ye(c, C), A = [];
          break;
        case "select":
          $ = W({}, $, { value: void 0 }), C = W({}, C, { value: void 0 }), A = [];
          break;
        case "textarea":
          $ = it(c, $), C = it(c, C), A = [];
          break;
        default:
          typeof $.onClick != "function" && typeof C.onClick == "function" && (c.onclick = Up);
      }
      Qe(g, C);
      var q;
      g = null;
      for (Fe in $) if (!C.hasOwnProperty(Fe) && $.hasOwnProperty(Fe) && $[Fe] != null) if (Fe === "style") {
        var ue = $[Fe];
        for (q in ue) ue.hasOwnProperty(q) && (g || (g = {}), g[q] = "");
      } else Fe !== "dangerouslySetInnerHTML" && Fe !== "children" && Fe !== "suppressContentEditableWarning" && Fe !== "suppressHydrationWarning" && Fe !== "autoFocus" && (s.hasOwnProperty(Fe) ? A || (A = []) : (A = A || []).push(Fe, null));
      for (Fe in C) {
        var he = C[Fe];
        if (ue = $ != null ? $[Fe] : void 0, C.hasOwnProperty(Fe) && he !== ue && (he != null || ue != null)) if (Fe === "style") if (ue) {
          for (q in ue) !ue.hasOwnProperty(q) || he && he.hasOwnProperty(q) || (g || (g = {}), g[q] = "");
          for (q in he) he.hasOwnProperty(q) && ue[q] !== he[q] && (g || (g = {}), g[q] = he[q]);
        } else g || (A || (A = []), A.push(
          Fe,
          g
        )), g = he;
        else Fe === "dangerouslySetInnerHTML" ? (he = he ? he.__html : void 0, ue = ue ? ue.__html : void 0, he != null && ue !== he && (A = A || []).push(Fe, he)) : Fe === "children" ? typeof he != "string" && typeof he != "number" || (A = A || []).push(Fe, "" + he) : Fe !== "suppressContentEditableWarning" && Fe !== "suppressHydrationWarning" && (s.hasOwnProperty(Fe) ? (he != null && Fe === "onScroll" && qn("scroll", c), A || ue === he || (A = [])) : (A = A || []).push(Fe, he));
      }
      g && (A = A || []).push("style", g);
      var Fe = A;
      (d.updateQueue = Fe) && (d.flags |= 4);
    }
  }, qa = function(c, d, g, C) {
    g !== C && (d.flags |= 4);
  };
  function gr(c, d) {
    if (!Zn) switch (c.tailMode) {
      case "hidden":
        d = c.tail;
        for (var g = null; d !== null; ) d.alternate !== null && (g = d), d = d.sibling;
        g === null ? c.tail = null : g.sibling = null;
        break;
      case "collapsed":
        g = c.tail;
        for (var C = null; g !== null; ) g.alternate !== null && (C = g), g = g.sibling;
        C === null ? d || c.tail === null ? c.tail = null : c.tail.sibling = null : C.sibling = null;
    }
  }
  function Eo(c) {
    var d = c.alternate !== null && c.alternate.child === c.child, g = 0, C = 0;
    if (d) for (var $ = c.child; $ !== null; ) g |= $.lanes | $.childLanes, C |= $.subtreeFlags & 14680064, C |= $.flags & 14680064, $.return = c, $ = $.sibling;
    else for ($ = c.child; $ !== null; ) g |= $.lanes | $.childLanes, C |= $.subtreeFlags, C |= $.flags, $.return = c, $ = $.sibling;
    return c.subtreeFlags |= C, c.childLanes = g, d;
  }
  function NE(c, d, g) {
    var C = d.pendingProps;
    switch (wg(d), d.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Eo(d), null;
      case 1:
        return or(d.type) && Va(), Eo(d), null;
      case 3:
        return C = d.stateNode, pu(), On(vr), On(Kt), Dg(), C.pendingContext && (C.context = C.pendingContext, C.pendingContext = null), (c === null || c.child === null) && (Gp(d) ? d.flags |= 4 : c === null || c.memoizedState.isDehydrated && !(d.flags & 256) || (d.flags |= 1024, za !== null && (Hg(za), za = null))), Cu(c, d), Eo(d), null;
      case 5:
        $g(d);
        var $ = sc(Xd.current);
        if (g = d.type, c !== null && d.stateNode != null) wu(c, d, g, C, $), c.ref !== d.ref && (d.flags |= 512, d.flags |= 2097152);
        else {
          if (!C) {
            if (d.stateNode === null) throw Error(n(166));
            return Eo(d), null;
          }
          if (c = sc(Ei.current), Gp(d)) {
            C = d.stateNode, g = d.type;
            var A = d.memoizedProps;
            switch (C[Bi] = d, C[rc] = A, c = (d.mode & 1) !== 0, g) {
              case "dialog":
                qn("cancel", C), qn("close", C);
                break;
              case "iframe":
              case "object":
              case "embed":
                qn("load", C);
                break;
              case "video":
              case "audio":
                for ($ = 0; $ < Bd.length; $++) qn(Bd[$], C);
                break;
              case "source":
                qn("error", C);
                break;
              case "img":
              case "image":
              case "link":
                qn(
                  "error",
                  C
                ), qn("load", C);
                break;
              case "details":
                qn("toggle", C);
                break;
              case "input":
                Ee(C, A), qn("invalid", C);
                break;
              case "select":
                C._wrapperState = { wasMultiple: !!A.multiple }, qn("invalid", C);
                break;
              case "textarea":
                bt(C, A), qn("invalid", C);
            }
            Qe(g, A), $ = null;
            for (var q in A) if (A.hasOwnProperty(q)) {
              var ue = A[q];
              q === "children" ? typeof ue == "string" ? C.textContent !== ue && (A.suppressHydrationWarning !== !0 && zp(C.textContent, ue, c), $ = ["children", ue]) : typeof ue == "number" && C.textContent !== "" + ue && (A.suppressHydrationWarning !== !0 && zp(
                C.textContent,
                ue,
                c
              ), $ = ["children", "" + ue]) : s.hasOwnProperty(q) && ue != null && q === "onScroll" && qn("scroll", C);
            }
            switch (g) {
              case "input":
                De(C), Re(C, A, !0);
                break;
              case "textarea":
                De(C), en(C);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof A.onClick == "function" && (C.onclick = Up);
            }
            C = $, d.updateQueue = C, C !== null && (d.flags |= 4);
          } else {
            q = $.nodeType === 9 ? $ : $.ownerDocument, c === "http://www.w3.org/1999/xhtml" && (c = fn(g)), c === "http://www.w3.org/1999/xhtml" ? g === "script" ? (c = q.createElement("div"), c.innerHTML = "<script><\/script>", c = c.removeChild(c.firstChild)) : typeof C.is == "string" ? c = q.createElement(g, { is: C.is }) : (c = q.createElement(g), g === "select" && (q = c, C.multiple ? q.multiple = !0 : C.size && (q.size = C.size))) : c = q.createElementNS(c, g), c[Bi] = d, c[rc] = C, Hi(c, d, !1, !1), d.stateNode = c;
            e: {
              switch (q = xt(g, C), g) {
                case "dialog":
                  qn("cancel", c), qn("close", c), $ = C;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  qn("load", c), $ = C;
                  break;
                case "video":
                case "audio":
                  for ($ = 0; $ < Bd.length; $++) qn(Bd[$], c);
                  $ = C;
                  break;
                case "source":
                  qn("error", c), $ = C;
                  break;
                case "img":
                case "image":
                case "link":
                  qn(
                    "error",
                    c
                  ), qn("load", c), $ = C;
                  break;
                case "details":
                  qn("toggle", c), $ = C;
                  break;
                case "input":
                  Ee(c, C), $ = ye(c, C), qn("invalid", c);
                  break;
                case "option":
                  $ = C;
                  break;
                case "select":
                  c._wrapperState = { wasMultiple: !!C.multiple }, $ = W({}, C, { value: void 0 }), qn("invalid", c);
                  break;
                case "textarea":
                  bt(c, C), $ = it(c, C), qn("invalid", c);
                  break;
                default:
                  $ = C;
              }
              Qe(g, $), ue = $;
              for (A in ue) if (ue.hasOwnProperty(A)) {
                var he = ue[A];
                A === "style" ? Xe(c, he) : A === "dangerouslySetInnerHTML" ? (he = he ? he.__html : void 0, he != null && rt(c, he)) : A === "children" ? typeof he == "string" ? (g !== "textarea" || he !== "") && Qt(c, he) : typeof he == "number" && Qt(c, "" + he) : A !== "suppressContentEditableWarning" && A !== "suppressHydrationWarning" && A !== "autoFocus" && (s.hasOwnProperty(A) ? he != null && A === "onScroll" && qn("scroll", c) : he != null && L(c, A, he, q));
              }
              switch (g) {
                case "input":
                  De(c), Re(c, C, !1);
                  break;
                case "textarea":
                  De(c), en(c);
                  break;
                case "option":
                  C.value != null && c.setAttribute("value", "" + me(C.value));
                  break;
                case "select":
                  c.multiple = !!C.multiple, A = C.value, A != null ? at(c, !!C.multiple, A, !1) : C.defaultValue != null && at(
                    c,
                    !!C.multiple,
                    C.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof $.onClick == "function" && (c.onclick = Up);
              }
              switch (g) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  C = !!C.autoFocus;
                  break e;
                case "img":
                  C = !0;
                  break e;
                default:
                  C = !1;
              }
            }
            C && (d.flags |= 4);
          }
          d.ref !== null && (d.flags |= 512, d.flags |= 2097152);
        }
        return Eo(d), null;
      case 6:
        if (c && d.stateNode != null) qa(c, d, c.memoizedProps, C);
        else {
          if (typeof C != "string" && d.stateNode === null) throw Error(n(166));
          if (g = sc(Xd.current), sc(Ei.current), Gp(d)) {
            if (C = d.stateNode, g = d.memoizedProps, C[Bi] = d, (A = C.nodeValue !== g) && (c = ya, c !== null)) switch (c.tag) {
              case 3:
                zp(C.nodeValue, g, (c.mode & 1) !== 0);
                break;
              case 5:
                c.memoizedProps.suppressHydrationWarning !== !0 && zp(C.nodeValue, g, (c.mode & 1) !== 0);
            }
            A && (d.flags |= 4);
          } else C = (g.nodeType === 9 ? g : g.ownerDocument).createTextNode(C), C[Bi] = d, d.stateNode = C;
        }
        return Eo(d), null;
      case 13:
        if (On(ar), C = d.memoizedState, c === null || c.memoizedState !== null && c.memoizedState.dehydrated !== null) {
          if (Zn && ta !== null && d.mode & 1 && !(d.flags & 128)) Bx(), cr(), d.flags |= 98560, A = !1;
          else if (A = Gp(d), C !== null && C.dehydrated !== null) {
            if (c === null) {
              if (!A) throw Error(n(318));
              if (A = d.memoizedState, A = A !== null ? A.dehydrated : null, !A) throw Error(n(317));
              A[Bi] = d;
            } else cr(), !(d.flags & 128) && (d.memoizedState = null), d.flags |= 4;
            Eo(d), A = !1;
          } else za !== null && (Hg(za), za = null), A = !0;
          if (!A) return d.flags & 65536 ? d : null;
        }
        return d.flags & 128 ? (d.lanes = g, d) : (C = C !== null, C !== (c !== null && c.memoizedState !== null) && C && (d.child.flags |= 8192, d.mode & 1 && (c === null || ar.current & 1 ? Br === 0 && (Br = 3) : ff())), d.updateQueue !== null && (d.flags |= 4), Eo(d), null);
      case 4:
        return pu(), Cu(c, d), c === null && iu(d.stateNode.containerInfo), Eo(d), null;
      case 10:
        return Rg(d.type._context), Eo(d), null;
      case 17:
        return or(d.type) && Va(), Eo(d), null;
      case 19:
        if (On(ar), A = d.memoizedState, A === null) return Eo(d), null;
        if (C = (d.flags & 128) !== 0, q = A.rendering, q === null) if (C) gr(A, !1);
        else {
          if (Br !== 0 || c !== null && c.flags & 128) for (c = d.child; c !== null; ) {
            if (q = eh(c), q !== null) {
              for (d.flags |= 128, gr(A, !1), C = q.updateQueue, C !== null && (d.updateQueue = C, d.flags |= 4), d.subtreeFlags = 0, C = g, g = d.child; g !== null; ) A = g, c = C, A.flags &= 14680066, q = A.alternate, q === null ? (A.childLanes = 0, A.lanes = c, A.child = null, A.subtreeFlags = 0, A.memoizedProps = null, A.memoizedState = null, A.updateQueue = null, A.dependencies = null, A.stateNode = null) : (A.childLanes = q.childLanes, A.lanes = q.lanes, A.child = q.child, A.subtreeFlags = 0, A.deletions = null, A.memoizedProps = q.memoizedProps, A.memoizedState = q.memoizedState, A.updateQueue = q.updateQueue, A.type = q.type, c = q.dependencies, A.dependencies = c === null ? null : { lanes: c.lanes, firstContext: c.firstContext }), g = g.sibling;
              return Pn(ar, ar.current & 1 | 2), d.child;
            }
            c = c.sibling;
          }
          A.tail !== null && mr() > Nu && (d.flags |= 128, C = !0, gr(A, !1), d.lanes = 4194304);
        }
        else {
          if (!C) if (c = eh(q), c !== null) {
            if (d.flags |= 128, C = !0, g = c.updateQueue, g !== null && (d.updateQueue = g, d.flags |= 4), gr(A, !0), A.tail === null && A.tailMode === "hidden" && !q.alternate && !Zn) return Eo(d), null;
          } else 2 * mr() - A.renderingStartTime > Nu && g !== 1073741824 && (d.flags |= 128, C = !0, gr(A, !1), d.lanes = 4194304);
          A.isBackwards ? (q.sibling = d.child, d.child = q) : (g = A.last, g !== null ? g.sibling = q : d.child = q, A.last = q);
        }
        return A.tail !== null ? (d = A.tail, A.rendering = d, A.tail = d.sibling, A.renderingStartTime = mr(), d.sibling = null, g = ar.current, Pn(ar, C ? g & 1 | 2 : g & 1), d) : (Eo(d), null);
      case 22:
      case 23:
        return Nh(), C = d.memoizedState !== null, c !== null && c.memoizedState !== null !== C && (d.flags |= 8192), C && d.mode & 1 ? ia & 1073741824 && (Eo(d), d.subtreeFlags & 6 && (d.flags |= 8192)) : Eo(d), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, d.tag));
  }
  function IE(c, d) {
    switch (wg(d), d.tag) {
      case 1:
        return or(d.type) && Va(), c = d.flags, c & 65536 ? (d.flags = c & -65537 | 128, d) : null;
      case 3:
        return pu(), On(vr), On(Kt), Dg(), c = d.flags, c & 65536 && !(c & 128) ? (d.flags = c & -65537 | 128, d) : null;
      case 5:
        return $g(d), null;
      case 13:
        if (On(ar), c = d.memoizedState, c !== null && c.dehydrated !== null) {
          if (d.alternate === null) throw Error(n(340));
          cr();
        }
        return c = d.flags, c & 65536 ? (d.flags = c & -65537 | 128, d) : null;
      case 19:
        return On(ar), null;
      case 4:
        return pu(), null;
      case 10:
        return Rg(d.type._context), null;
      case 22:
      case 23:
        return Nh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Tu = !1, so = !1, wh = typeof WeakSet == "function" ? WeakSet : Set, Ot = null;
  function Eu(c, d) {
    var g = c.ref;
    if (g !== null) if (typeof g == "function") try {
      g(null);
    } catch (C) {
      br(c, d, C);
    }
    else g.current = null;
  }
  function Fg(c, d, g) {
    try {
      g();
    } catch (C) {
      br(c, d, C);
    }
  }
  var Th = !1;
  function _E(c, d) {
    if (mg = Xl, c = Lp(), Ts(c)) {
      if ("selectionStart" in c) var g = { start: c.selectionStart, end: c.selectionEnd };
      else e: {
        g = (g = c.ownerDocument) && g.defaultView || window;
        var C = g.getSelection && g.getSelection();
        if (C && C.rangeCount !== 0) {
          g = C.anchorNode;
          var $ = C.anchorOffset, A = C.focusNode;
          C = C.focusOffset;
          try {
            g.nodeType, A.nodeType;
          } catch {
            g = null;
            break e;
          }
          var q = 0, ue = -1, he = -1, Fe = 0, Je = 0, Ze = c, Ke = null;
          t: for (; ; ) {
            for (var Ct; Ze !== g || $ !== 0 && Ze.nodeType !== 3 || (ue = q + $), Ze !== A || C !== 0 && Ze.nodeType !== 3 || (he = q + C), Ze.nodeType === 3 && (q += Ze.nodeValue.length), (Ct = Ze.firstChild) !== null; )
              Ke = Ze, Ze = Ct;
            for (; ; ) {
              if (Ze === c) break t;
              if (Ke === g && ++Fe === $ && (ue = q), Ke === A && ++Je === C && (he = q), (Ct = Ze.nextSibling) !== null) break;
              Ze = Ke, Ke = Ze.parentNode;
            }
            Ze = Ct;
          }
          g = ue === -1 || he === -1 ? null : { start: ue, end: he };
        } else g = null;
      }
      g = g || { start: 0, end: 0 };
    } else g = null;
    for (tc = { focusedElem: c, selectionRange: g }, Xl = !1, Ot = d; Ot !== null; ) if (d = Ot, c = d.child, (d.subtreeFlags & 1028) !== 0 && c !== null) c.return = d, Ot = c;
    else for (; Ot !== null; ) {
      d = Ot;
      try {
        var $t = d.alternate;
        if (d.flags & 1024) switch (d.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if ($t !== null) {
              var It = $t.memoizedProps, Er = $t.memoizedState, $e = d.stateNode, Se = $e.getSnapshotBeforeUpdate(d.elementType === d.type ? It : ra(d.type, It), Er);
              $e.__reactInternalSnapshotBeforeUpdate = Se;
            }
            break;
          case 3:
            var Ie = d.stateNode.containerInfo;
            Ie.nodeType === 1 ? Ie.textContent = "" : Ie.nodeType === 9 && Ie.documentElement && Ie.removeChild(Ie.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(n(163));
        }
      } catch (ot) {
        br(d, d.return, ot);
      }
      if (c = d.sibling, c !== null) {
        c.return = d.return, Ot = c;
        break;
      }
      Ot = d.return;
    }
    return $t = Th, Th = !1, $t;
  }
  function Ru(c, d, g) {
    var C = d.updateQueue;
    if (C = C !== null ? C.lastEffect : null, C !== null) {
      var $ = C = C.next;
      do {
        if (($.tag & c) === c) {
          var A = $.destroy;
          $.destroy = void 0, A !== void 0 && Fg(d, g, A);
        }
        $ = $.next;
      } while ($ !== C);
    }
  }
  function Eh(c, d) {
    if (d = d.updateQueue, d = d !== null ? d.lastEffect : null, d !== null) {
      var g = d = d.next;
      do {
        if ((g.tag & c) === c) {
          var C = g.create;
          g.destroy = C();
        }
        g = g.next;
      } while (g !== d);
    }
  }
  function Rh(c) {
    var d = c.ref;
    if (d !== null) {
      var g = c.stateNode;
      switch (c.tag) {
        case 5:
          c = g;
          break;
        default:
          c = g;
      }
      typeof d == "function" ? d(c) : d.current = c;
    }
  }
  function iS(c) {
    var d = c.alternate;
    d !== null && (c.alternate = null, iS(d)), c.child = null, c.deletions = null, c.sibling = null, c.tag === 5 && (d = c.stateNode, d !== null && (delete d[Bi], delete d[rc], delete d[yg], delete d[$E], delete d[bg])), c.stateNode = null, c.return = null, c.dependencies = null, c.memoizedProps = null, c.memoizedState = null, c.pendingProps = null, c.stateNode = null, c.updateQueue = null;
  }
  function jg(c) {
    return c.tag === 5 || c.tag === 3 || c.tag === 4;
  }
  function sS(c) {
    e: for (; ; ) {
      for (; c.sibling === null; ) {
        if (c.return === null || jg(c.return)) return null;
        c = c.return;
      }
      for (c.sibling.return = c.return, c = c.sibling; c.tag !== 5 && c.tag !== 6 && c.tag !== 18; ) {
        if (c.flags & 2 || c.child === null || c.tag === 4) continue e;
        c.child.return = c, c = c.child;
      }
      if (!(c.flags & 2)) return c.stateNode;
    }
  }
  function lf(c, d, g) {
    var C = c.tag;
    if (C === 5 || C === 6) c = c.stateNode, d ? g.nodeType === 8 ? g.parentNode.insertBefore(c, d) : g.insertBefore(c, d) : (g.nodeType === 8 ? (d = g.parentNode, d.insertBefore(c, g)) : (d = g, d.appendChild(c)), g = g._reactRootContainer, g != null || d.onclick !== null || (d.onclick = Up));
    else if (C !== 4 && (c = c.child, c !== null)) for (lf(c, d, g), c = c.sibling; c !== null; ) lf(c, d, g), c = c.sibling;
  }
  function Ou(c, d, g) {
    var C = c.tag;
    if (C === 5 || C === 6) c = c.stateNode, d ? g.insertBefore(c, d) : g.appendChild(c);
    else if (C !== 4 && (c = c.child, c !== null)) for (Ou(c, d, g), c = c.sibling; c !== null; ) Ou(c, d, g), c = c.sibling;
  }
  var ir = null, Qr = !1;
  function Io(c, d, g) {
    for (g = g.child; g !== null; ) Pu(c, d, g), g = g.sibling;
  }
  function Pu(c, d, g) {
    if (bi && typeof bi.onCommitFiberUnmount == "function") try {
      bi.onCommitFiberUnmount(Ed, g);
    } catch {
    }
    switch (g.tag) {
      case 5:
        so || Eu(g, d);
      case 6:
        var C = ir, $ = Qr;
        ir = null, Io(c, d, g), ir = C, Qr = $, ir !== null && (Qr ? (c = ir, g = g.stateNode, c.nodeType === 8 ? c.parentNode.removeChild(g) : c.removeChild(g)) : ir.removeChild(g.stateNode));
        break;
      case 18:
        ir !== null && (Qr ? (c = ir, g = g.stateNode, c.nodeType === 8 ? cl(c.parentNode, g) : c.nodeType === 1 && cl(c, g), Dd(c)) : cl(ir, g.stateNode));
        break;
      case 4:
        C = ir, $ = Qr, ir = g.stateNode.containerInfo, Qr = !0, Io(c, d, g), ir = C, Qr = $;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!so && (C = g.updateQueue, C !== null && (C = C.lastEffect, C !== null))) {
          $ = C = C.next;
          do {
            var A = $, q = A.destroy;
            A = A.tag, q !== void 0 && (A & 2 || A & 4) && Fg(g, d, q), $ = $.next;
          } while ($ !== C);
        }
        Io(c, d, g);
        break;
      case 1:
        if (!so && (Eu(g, d), C = g.stateNode, typeof C.componentWillUnmount == "function")) try {
          C.props = g.memoizedProps, C.state = g.memoizedState, C.componentWillUnmount();
        } catch (ue) {
          br(g, d, ue);
        }
        Io(c, d, g);
        break;
      case 21:
        Io(c, d, g);
        break;
      case 22:
        g.mode & 1 ? (so = (C = so) || g.memoizedState !== null, Io(c, d, g), so = C) : Io(c, d, g);
        break;
      default:
        Io(c, d, g);
    }
  }
  function $u(c) {
    var d = c.updateQueue;
    if (d !== null) {
      c.updateQueue = null;
      var g = c.stateNode;
      g === null && (g = c.stateNode = new wh()), d.forEach(function(C) {
        var $ = zE.bind(null, c, C);
        g.has(C) || (g.add(C), C.then($, $));
      });
    }
  }
  function Jr(c, d) {
    var g = d.deletions;
    if (g !== null) for (var C = 0; C < g.length; C++) {
      var $ = g[C];
      try {
        var A = c, q = d, ue = q;
        e: for (; ue !== null; ) {
          switch (ue.tag) {
            case 5:
              ir = ue.stateNode, Qr = !1;
              break e;
            case 3:
              ir = ue.stateNode.containerInfo, Qr = !0;
              break e;
            case 4:
              ir = ue.stateNode.containerInfo, Qr = !0;
              break e;
          }
          ue = ue.return;
        }
        if (ir === null) throw Error(n(160));
        Pu(A, q, $), ir = null, Qr = !1;
        var he = $.alternate;
        he !== null && (he.return = null), $.return = null;
      } catch (Fe) {
        br($, d, Fe);
      }
    }
    if (d.subtreeFlags & 12854) for (d = d.child; d !== null; ) lS(d, c), d = d.sibling;
  }
  function lS(c, d) {
    var g = c.alternate, C = c.flags;
    switch (c.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Jr(d, c), Wi(c), C & 4) {
          try {
            Ru(3, c, c.return), Eh(3, c);
          } catch (It) {
            br(c, c.return, It);
          }
          try {
            Ru(5, c, c.return);
          } catch (It) {
            br(c, c.return, It);
          }
        }
        break;
      case 1:
        Jr(d, c), Wi(c), C & 512 && g !== null && Eu(g, g.return);
        break;
      case 5:
        if (Jr(d, c), Wi(c), C & 512 && g !== null && Eu(g, g.return), c.flags & 32) {
          var $ = c.stateNode;
          try {
            Qt($, "");
          } catch (It) {
            br(c, c.return, It);
          }
        }
        if (C & 4 && ($ = c.stateNode, $ != null)) {
          var A = c.memoizedProps, q = g !== null ? g.memoizedProps : A, ue = c.type, he = c.updateQueue;
          if (c.updateQueue = null, he !== null) try {
            ue === "input" && A.type === "radio" && A.name != null && _e($, A), xt(ue, q);
            var Fe = xt(ue, A);
            for (q = 0; q < he.length; q += 2) {
              var Je = he[q], Ze = he[q + 1];
              Je === "style" ? Xe($, Ze) : Je === "dangerouslySetInnerHTML" ? rt($, Ze) : Je === "children" ? Qt($, Ze) : L($, Je, Ze, Fe);
            }
            switch (ue) {
              case "input":
                Ve($, A);
                break;
              case "textarea":
                Nt($, A);
                break;
              case "select":
                var Ke = $._wrapperState.wasMultiple;
                $._wrapperState.wasMultiple = !!A.multiple;
                var Ct = A.value;
                Ct != null ? at($, !!A.multiple, Ct, !1) : Ke !== !!A.multiple && (A.defaultValue != null ? at(
                  $,
                  !!A.multiple,
                  A.defaultValue,
                  !0
                ) : at($, !!A.multiple, A.multiple ? [] : "", !1));
            }
            $[rc] = A;
          } catch (It) {
            br(c, c.return, It);
          }
        }
        break;
      case 6:
        if (Jr(d, c), Wi(c), C & 4) {
          if (c.stateNode === null) throw Error(n(162));
          $ = c.stateNode, A = c.memoizedProps;
          try {
            $.nodeValue = A;
          } catch (It) {
            br(c, c.return, It);
          }
        }
        break;
      case 3:
        if (Jr(d, c), Wi(c), C & 4 && g !== null && g.memoizedState.isDehydrated) try {
          Dd(d.containerInfo);
        } catch (It) {
          br(c, c.return, It);
        }
        break;
      case 4:
        Jr(d, c), Wi(c);
        break;
      case 13:
        Jr(d, c), Wi(c), $ = c.child, $.flags & 8192 && (A = $.memoizedState !== null, $.stateNode.isHidden = A, !A || $.alternate !== null && $.alternate.memoizedState !== null || (Ph = mr())), C & 4 && $u(c);
        break;
      case 22:
        if (Je = g !== null && g.memoizedState !== null, c.mode & 1 ? (so = (Fe = so) || Je, Jr(d, c), so = Fe) : Jr(d, c), Wi(c), C & 8192) {
          if (Fe = c.memoizedState !== null, (c.stateNode.isHidden = Fe) && !Je && c.mode & 1) for (Ot = c, Je = c.child; Je !== null; ) {
            for (Ze = Ot = Je; Ot !== null; ) {
              switch (Ke = Ot, Ct = Ke.child, Ke.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Ru(4, Ke, Ke.return);
                  break;
                case 1:
                  Eu(Ke, Ke.return);
                  var $t = Ke.stateNode;
                  if (typeof $t.componentWillUnmount == "function") {
                    C = Ke, g = Ke.return;
                    try {
                      d = C, $t.props = d.memoizedProps, $t.state = d.memoizedState, $t.componentWillUnmount();
                    } catch (It) {
                      br(C, g, It);
                    }
                  }
                  break;
                case 5:
                  Eu(Ke, Ke.return);
                  break;
                case 22:
                  if (Ke.memoizedState !== null) {
                    cS(Ze);
                    continue;
                  }
              }
              Ct !== null ? (Ct.return = Ke, Ot = Ct) : cS(Ze);
            }
            Je = Je.sibling;
          }
          e: for (Je = null, Ze = c; ; ) {
            if (Ze.tag === 5) {
              if (Je === null) {
                Je = Ze;
                try {
                  $ = Ze.stateNode, Fe ? (A = $.style, typeof A.setProperty == "function" ? A.setProperty("display", "none", "important") : A.display = "none") : (ue = Ze.stateNode, he = Ze.memoizedProps.style, q = he != null && he.hasOwnProperty("display") ? he.display : null, ue.style.display = jt("display", q));
                } catch (It) {
                  br(c, c.return, It);
                }
              }
            } else if (Ze.tag === 6) {
              if (Je === null) try {
                Ze.stateNode.nodeValue = Fe ? "" : Ze.memoizedProps;
              } catch (It) {
                br(c, c.return, It);
              }
            } else if ((Ze.tag !== 22 && Ze.tag !== 23 || Ze.memoizedState === null || Ze === c) && Ze.child !== null) {
              Ze.child.return = Ze, Ze = Ze.child;
              continue;
            }
            if (Ze === c) break e;
            for (; Ze.sibling === null; ) {
              if (Ze.return === null || Ze.return === c) break e;
              Je === Ze && (Je = null), Ze = Ze.return;
            }
            Je === Ze && (Je = null), Ze.sibling.return = Ze.return, Ze = Ze.sibling;
          }
        }
        break;
      case 19:
        Jr(d, c), Wi(c), C & 4 && $u(c);
        break;
      case 21:
        break;
      default:
        Jr(
          d,
          c
        ), Wi(c);
    }
  }
  function Wi(c) {
    var d = c.flags;
    if (d & 2) {
      try {
        e: {
          for (var g = c.return; g !== null; ) {
            if (jg(g)) {
              var C = g;
              break e;
            }
            g = g.return;
          }
          throw Error(n(160));
        }
        switch (C.tag) {
          case 5:
            var $ = C.stateNode;
            C.flags & 32 && (Qt($, ""), C.flags &= -33);
            var A = sS(c);
            Ou(c, A, $);
            break;
          case 3:
          case 4:
            var q = C.stateNode.containerInfo, ue = sS(c);
            lf(c, ue, q);
            break;
          default:
            throw Error(n(161));
        }
      } catch (he) {
        br(c, c.return, he);
      }
      c.flags &= -3;
    }
    d & 4096 && (c.flags &= -4097);
  }
  function AE(c, d, g) {
    Ot = c, Vg(c);
  }
  function Vg(c, d, g) {
    for (var C = (c.mode & 1) !== 0; Ot !== null; ) {
      var $ = Ot, A = $.child;
      if ($.tag === 22 && C) {
        var q = $.memoizedState !== null || Tu;
        if (!q) {
          var ue = $.alternate, he = ue !== null && ue.memoizedState !== null || so;
          ue = Tu;
          var Fe = so;
          if (Tu = q, (so = he) && !Fe) for (Ot = $; Ot !== null; ) q = Ot, he = q.child, q.tag === 22 && q.memoizedState !== null ? Bg($) : he !== null ? (he.return = q, Ot = he) : Bg($);
          for (; A !== null; ) Ot = A, Vg(A), A = A.sibling;
          Ot = $, Tu = ue, so = Fe;
        }
        Du(c);
      } else $.subtreeFlags & 8772 && A !== null ? (A.return = $, Ot = A) : Du(c);
    }
  }
  function Du(c) {
    for (; Ot !== null; ) {
      var d = Ot;
      if (d.flags & 8772) {
        var g = d.alternate;
        try {
          if (d.flags & 8772) switch (d.tag) {
            case 0:
            case 11:
            case 15:
              so || Eh(5, d);
              break;
            case 1:
              var C = d.stateNode;
              if (d.flags & 4 && !so) if (g === null) C.componentDidMount();
              else {
                var $ = d.elementType === d.type ? g.memoizedProps : ra(d.type, g.memoizedProps);
                C.componentDidUpdate($, g.memoizedState, C.__reactInternalSnapshotBeforeUpdate);
              }
              var A = d.updateQueue;
              A !== null && qx(d, A, C);
              break;
            case 3:
              var q = d.updateQueue;
              if (q !== null) {
                if (g = null, d.child !== null) switch (d.child.tag) {
                  case 5:
                    g = d.child.stateNode;
                    break;
                  case 1:
                    g = d.child.stateNode;
                }
                qx(d, q, g);
              }
              break;
            case 5:
              var ue = d.stateNode;
              if (g === null && d.flags & 4) {
                g = ue;
                var he = d.memoizedProps;
                switch (d.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    he.autoFocus && g.focus();
                    break;
                  case "img":
                    he.src && (g.src = he.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (d.memoizedState === null) {
                var Fe = d.alternate;
                if (Fe !== null) {
                  var Je = Fe.memoizedState;
                  if (Je !== null) {
                    var Ze = Je.dehydrated;
                    Ze !== null && Dd(Ze);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(n(163));
          }
          so || d.flags & 512 && Rh(d);
        } catch (Ke) {
          br(d, d.return, Ke);
        }
      }
      if (d === c) {
        Ot = null;
        break;
      }
      if (g = d.sibling, g !== null) {
        g.return = d.return, Ot = g;
        break;
      }
      Ot = d.return;
    }
  }
  function cS(c) {
    for (; Ot !== null; ) {
      var d = Ot;
      if (d === c) {
        Ot = null;
        break;
      }
      var g = d.sibling;
      if (g !== null) {
        g.return = d.return, Ot = g;
        break;
      }
      Ot = d.return;
    }
  }
  function Bg(c) {
    for (; Ot !== null; ) {
      var d = Ot;
      try {
        switch (d.tag) {
          case 0:
          case 11:
          case 15:
            var g = d.return;
            try {
              Eh(4, d);
            } catch (he) {
              br(d, g, he);
            }
            break;
          case 1:
            var C = d.stateNode;
            if (typeof C.componentDidMount == "function") {
              var $ = d.return;
              try {
                C.componentDidMount();
              } catch (he) {
                br(d, $, he);
              }
            }
            var A = d.return;
            try {
              Rh(d);
            } catch (he) {
              br(d, A, he);
            }
            break;
          case 5:
            var q = d.return;
            try {
              Rh(d);
            } catch (he) {
              br(d, q, he);
            }
        }
      } catch (he) {
        br(d, d.return, he);
      }
      if (d === c) {
        Ot = null;
        break;
      }
      var ue = d.sibling;
      if (ue !== null) {
        ue.return = d.return, Ot = ue;
        break;
      }
      Ot = d.return;
    }
  }
  var LE = Math.ceil, mc = F.ReactCurrentDispatcher, Oh = F.ReactCurrentOwner, Ya = F.ReactCurrentBatchConfig, hn = 0, yr = null, er = null, Vr = 0, ia = 0, ku = an(0), Br = 0, cf = null, vc = 0, Mu = 0, zg = 0, bl = null, Ro = null, Ph = 0, Nu = 1 / 0, Ns = null, $h = !1, Ug = null, Ga = null, Iu = !1, Ka = null, Dh = 0, uf = 0, kh = null, df = -1, gc = 0;
  function Zr() {
    return hn & 6 ? mr() : df !== -1 ? df : df = mr();
  }
  function Is(c) {
    return c.mode & 1 ? hn & 2 && Vr !== 0 ? Vr & -Vr : Kp.transition !== null ? (gc === 0 && (gc = Ep()), gc) : (c = kn, c !== 0 || (c = window.event, c = c === void 0 ? 16 : Kv(c.type)), c) : 1;
  }
  function ur(c, d, g, C) {
    if (50 < uf) throw uf = 0, kh = null, Error(n(185));
    Kl(c, g, C), (!(hn & 2) || c !== yr) && (c === yr && (!(hn & 2) && (Mu |= g), Br === 4 && qi(c, Vr)), zr(c, C), g === 1 && hn === 0 && !(d.mode & 1) && (Nu = mr() + 500, Xr && Jo()));
  }
  function zr(c, d) {
    var g = c.callbackNode;
    Tp(c, d);
    var C = xi(c, c === yr ? Vr : 0);
    if (C === 0) g !== null && zt(g), c.callbackNode = null, c.callbackPriority = 0;
    else if (d = C & -C, c.callbackPriority !== d) {
      if (g != null && zt(g), d === 1) c.tag === 0 ? Sg(_u.bind(null, c)) : xg(_u.bind(null, c)), gg(function() {
        !(hn & 6) && Jo();
      }), g = null;
      else {
        switch (qv(C)) {
          case 1:
            g = xs;
            break;
          case 4:
            g = pn;
            break;
          case 16:
            g = ol;
            break;
          case 536870912:
            g = zv;
            break;
          default:
            g = ol;
        }
        g = gS(g, Mh.bind(null, c));
      }
      c.callbackPriority = d, c.callbackNode = g;
    }
  }
  function Mh(c, d) {
    if (df = -1, gc = 0, hn & 6) throw Error(n(327));
    var g = c.callbackNode;
    if (Au() && c.callbackNode !== g) return null;
    var C = xi(c, c === yr ? Vr : 0);
    if (C === 0) return null;
    if (C & 30 || C & c.expiredLanes || d) d = Ih(c, C);
    else {
      d = C;
      var $ = hn;
      hn |= 2;
      var A = dS();
      (yr !== c || Vr !== d) && (Ns = null, Nu = mr() + 500, bc(c, d));
      do
        try {
          jE();
          break;
        } catch (ue) {
          uS(c, ue);
        }
      while (!0);
      ba(), mc.current = A, hn = $, er !== null ? d = 0 : (yr = null, Vr = 0, d = Br);
    }
    if (d !== 0) {
      if (d === 2 && ($ = Hv(c), $ !== 0 && (C = $, d = yc(c, $))), d === 1) throw g = cf, bc(c, 0), qi(c, C), zr(c, mr()), g;
      if (d === 6) qi(c, C);
      else {
        if ($ = c.current.alternate, !(C & 30) && !Wg($) && (d = Ih(c, C), d === 2 && (A = Hv(c), A !== 0 && (C = A, d = yc(c, A))), d === 1)) throw g = cf, bc(c, 0), qi(c, C), zr(c, mr()), g;
        switch (c.finishedWork = $, c.finishedLanes = C, d) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            xl(c, Ro, Ns);
            break;
          case 3:
            if (qi(c, C), (C & 130023424) === C && (d = Ph + 500 - mr(), 10 < d)) {
              if (xi(c, 0) !== 0) break;
              if ($ = c.suspendedLanes, ($ & C) !== C) {
                Zr(), c.pingedLanes |= c.suspendedLanes & $;
                break;
              }
              c.timeoutHandle = nc(xl.bind(null, c, Ro, Ns), d);
              break;
            }
            xl(c, Ro, Ns);
            break;
          case 4:
            if (qi(c, C), (C & 4194240) === C) break;
            for (d = c.eventTimes, $ = -1; 0 < C; ) {
              var q = 31 - Ia(C);
              A = 1 << q, q = d[q], q > $ && ($ = q), C &= ~A;
            }
            if (C = $, C = mr() - C, C = (120 > C ? 120 : 480 > C ? 480 : 1080 > C ? 1080 : 1920 > C ? 1920 : 3e3 > C ? 3e3 : 4320 > C ? 4320 : 1960 * LE(C / 1960)) - C, 10 < C) {
              c.timeoutHandle = nc(xl.bind(null, c, Ro, Ns), C);
              break;
            }
            xl(c, Ro, Ns);
            break;
          case 5:
            xl(c, Ro, Ns);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return zr(c, mr()), c.callbackNode === g ? Mh.bind(null, c) : null;
  }
  function yc(c, d) {
    var g = bl;
    return c.current.memoizedState.isDehydrated && (bc(c, d).flags |= 256), c = Ih(c, d), c !== 2 && (d = Ro, Ro = g, d !== null && Hg(d)), c;
  }
  function Hg(c) {
    Ro === null ? Ro = c : Ro.push.apply(Ro, c);
  }
  function Wg(c) {
    for (var d = c; ; ) {
      if (d.flags & 16384) {
        var g = d.updateQueue;
        if (g !== null && (g = g.stores, g !== null)) for (var C = 0; C < g.length; C++) {
          var $ = g[C], A = $.getSnapshot;
          $ = $.value;
          try {
            if (!La(A(), $)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (g = d.child, d.subtreeFlags & 16384 && g !== null) g.return = d, d = g;
      else {
        if (d === c) break;
        for (; d.sibling === null; ) {
          if (d.return === null || d.return === c) return !0;
          d = d.return;
        }
        d.sibling.return = d.return, d = d.sibling;
      }
    }
    return !0;
  }
  function qi(c, d) {
    for (d &= ~zg, d &= ~Mu, c.suspendedLanes |= d, c.pingedLanes &= ~d, c = c.expirationTimes; 0 < d; ) {
      var g = 31 - Ia(d), C = 1 << g;
      c[g] = -1, d &= ~C;
    }
  }
  function _u(c) {
    if (hn & 6) throw Error(n(327));
    Au();
    var d = xi(c, 0);
    if (!(d & 1)) return zr(c, mr()), null;
    var g = Ih(c, d);
    if (c.tag !== 0 && g === 2) {
      var C = Hv(c);
      C !== 0 && (d = C, g = yc(c, C));
    }
    if (g === 1) throw g = cf, bc(c, 0), qi(c, d), zr(c, mr()), g;
    if (g === 6) throw Error(n(345));
    return c.finishedWork = c.current.alternate, c.finishedLanes = d, xl(c, Ro, Ns), zr(c, mr()), null;
  }
  function qg(c, d) {
    var g = hn;
    hn |= 1;
    try {
      return c(d);
    } finally {
      hn = g, hn === 0 && (Nu = mr() + 500, Xr && Jo());
    }
  }
  function Yi(c) {
    Ka !== null && Ka.tag === 0 && !(hn & 6) && Au();
    var d = hn;
    hn |= 1;
    var g = Ya.transition, C = kn;
    try {
      if (Ya.transition = null, kn = 1, c) return c();
    } finally {
      kn = C, Ya.transition = g, hn = d, !(hn & 6) && Jo();
    }
  }
  function Nh() {
    ia = ku.current, On(ku);
  }
  function bc(c, d) {
    c.finishedWork = null, c.finishedLanes = 0;
    var g = c.timeoutHandle;
    if (g !== -1 && (c.timeoutHandle = -1, Lx(g)), er !== null) for (g = er.return; g !== null; ) {
      var C = g;
      switch (wg(C), C.tag) {
        case 1:
          C = C.type.childContextTypes, C != null && Va();
          break;
        case 3:
          pu(), On(vr), On(Kt), Dg();
          break;
        case 5:
          $g(C);
          break;
        case 4:
          pu();
          break;
        case 13:
          On(ar);
          break;
        case 19:
          On(ar);
          break;
        case 10:
          Rg(C.type._context);
          break;
        case 22:
        case 23:
          Nh();
      }
      g = g.return;
    }
    if (yr = c, er = c = Sl(c.current, null), Vr = ia = d, Br = 0, cf = null, zg = Mu = vc = 0, Ro = bl = null, ic !== null) {
      for (d = 0; d < ic.length; d++) if (g = ic[d], C = g.interleaved, C !== null) {
        g.interleaved = null;
        var $ = C.next, A = g.pending;
        if (A !== null) {
          var q = A.next;
          A.next = $, C.next = q;
        }
        g.pending = C;
      }
      ic = null;
    }
    return c;
  }
  function uS(c, d) {
    do {
      var g = er;
      try {
        if (ba(), nh.current = To, xa) {
          for (var C = Lt.memoizedState; C !== null; ) {
            var $ = C.queue;
            $ !== null && ($.pending = null), C = C.next;
          }
          xa = !1;
        }
        if (_t = 0, un = Xt = Lt = null, hu = !1, Jd = 0, Oh.current = null, g === null || g.return === null) {
          Br = 1, cf = d, er = null;
          break;
        }
        e: {
          var A = c, q = g.return, ue = g, he = d;
          if (d = Vr, ue.flags |= 32768, he !== null && typeof he == "object" && typeof he.then == "function") {
            var Fe = he, Je = ue, Ze = Je.tag;
            if (!(Je.mode & 1) && (Ze === 0 || Ze === 11 || Ze === 15)) {
              var Ke = Je.alternate;
              Ke ? (Je.updateQueue = Ke.updateQueue, Je.memoizedState = Ke.memoizedState, Je.lanes = Ke.lanes) : (Je.updateQueue = null, Je.memoizedState = null);
            }
            var Ct = tS(q);
            if (Ct !== null) {
              Ct.flags &= -257, _g(Ct, q, ue, A, d), Ct.mode & 1 && rf(A, Fe, d), d = Ct, he = Fe;
              var $t = d.updateQueue;
              if ($t === null) {
                var It = /* @__PURE__ */ new Set();
                It.add(he), d.updateQueue = It;
              } else $t.add(he);
              break e;
            } else {
              if (!(d & 1)) {
                rf(A, Fe, d), ff();
                break e;
              }
              he = Error(n(426));
            }
          } else if (Zn && ue.mode & 1) {
            var Er = tS(q);
            if (Er !== null) {
              !(Er.flags & 65536) && (Er.flags |= 256), _g(Er, q, ue, A, d), Eg(gl(he, ue));
              break e;
            }
          }
          A = he = gl(he, ue), Br !== 4 && (Br = 2), bl === null ? bl = [A] : bl.push(A), A = q;
          do {
            switch (A.tag) {
              case 3:
                A.flags |= 65536, d &= -d, A.lanes |= d;
                var $e = Zx(A, he, d);
                Wx(A, $e);
                break e;
              case 1:
                ue = he;
                var Se = A.type, Ie = A.stateNode;
                if (!(A.flags & 128) && (typeof Se.getDerivedStateFromError == "function" || Ie !== null && typeof Ie.componentDidCatch == "function" && (Ga === null || !Ga.has(Ie)))) {
                  A.flags |= 65536, d &= -d, A.lanes |= d;
                  var ot = eS(A, ue, d);
                  Wx(A, ot);
                  break e;
                }
            }
            A = A.return;
          } while (A !== null);
        }
        pS(g);
      } catch (At) {
        d = At, er === g && g !== null && (er = g = g.return);
        continue;
      }
      break;
    } while (!0);
  }
  function dS() {
    var c = mc.current;
    return mc.current = To, c === null ? To : c;
  }
  function ff() {
    (Br === 0 || Br === 3 || Br === 2) && (Br = 4), yr === null || !(vc & 268435455) && !(Mu & 268435455) || qi(yr, Vr);
  }
  function Ih(c, d) {
    var g = hn;
    hn |= 2;
    var C = dS();
    (yr !== c || Vr !== d) && (Ns = null, bc(c, d));
    do
      try {
        FE();
        break;
      } catch ($) {
        uS(c, $);
      }
    while (!0);
    if (ba(), hn = g, mc.current = C, er !== null) throw Error(n(261));
    return yr = null, Vr = 0, Br;
  }
  function FE() {
    for (; er !== null; ) fS(er);
  }
  function jE() {
    for (; er !== null && !Or(); ) fS(er);
  }
  function fS(c) {
    var d = vS(c.alternate, c, ia);
    c.memoizedProps = c.pendingProps, d === null ? pS(c) : er = d, Oh.current = null;
  }
  function pS(c) {
    var d = c;
    do {
      var g = d.alternate;
      if (c = d.return, d.flags & 32768) {
        if (g = IE(g, d), g !== null) {
          g.flags &= 32767, er = g;
          return;
        }
        if (c !== null) c.flags |= 32768, c.subtreeFlags = 0, c.deletions = null;
        else {
          Br = 6, er = null;
          return;
        }
      } else if (g = NE(g, d, ia), g !== null) {
        er = g;
        return;
      }
      if (d = d.sibling, d !== null) {
        er = d;
        return;
      }
      er = d = c;
    } while (d !== null);
    Br === 0 && (Br = 5);
  }
  function xl(c, d, g) {
    var C = kn, $ = Ya.transition;
    try {
      Ya.transition = null, kn = 1, VE(c, d, g, C);
    } finally {
      Ya.transition = $, kn = C;
    }
    return null;
  }
  function VE(c, d, g, C) {
    do
      Au();
    while (Ka !== null);
    if (hn & 6) throw Error(n(327));
    g = c.finishedWork;
    var $ = c.finishedLanes;
    if (g === null) return null;
    if (c.finishedWork = null, c.finishedLanes = 0, g === c.current) throw Error(n(177));
    c.callbackNode = null, c.callbackPriority = 0;
    var A = g.lanes | g.childLanes;
    if (dE(c, A), c === yr && (er = yr = null, Vr = 0), !(g.subtreeFlags & 2064) && !(g.flags & 2064) || Iu || (Iu = !0, gS(ol, function() {
      return Au(), null;
    })), A = (g.flags & 15990) !== 0, g.subtreeFlags & 15990 || A) {
      A = Ya.transition, Ya.transition = null;
      var q = kn;
      kn = 1;
      var ue = hn;
      hn |= 4, Oh.current = null, _E(c, g), lS(g, c), Fp(tc), Xl = !!mg, tc = mg = null, c.current = g, AE(g), lE(), hn = ue, kn = q, Ya.transition = A;
    } else c.current = g;
    if (Iu && (Iu = !1, Ka = c, Dh = $), A = c.pendingLanes, A === 0 && (Ga = null), Q0(g.stateNode), zr(c, mr()), d !== null) for (C = c.onRecoverableError, g = 0; g < d.length; g++) $ = d[g], C($.value, { componentStack: $.stack, digest: $.digest });
    if ($h) throw $h = !1, c = Ug, Ug = null, c;
    return Dh & 1 && c.tag !== 0 && Au(), A = c.pendingLanes, A & 1 ? c === kh ? uf++ : (uf = 0, kh = c) : uf = 0, Jo(), null;
  }
  function Au() {
    if (Ka !== null) {
      var c = qv(Dh), d = Ya.transition, g = kn;
      try {
        if (Ya.transition = null, kn = 16 > c ? 16 : c, Ka === null) var C = !1;
        else {
          if (c = Ka, Ka = null, Dh = 0, hn & 6) throw Error(n(331));
          var $ = hn;
          for (hn |= 4, Ot = c.current; Ot !== null; ) {
            var A = Ot, q = A.child;
            if (Ot.flags & 16) {
              var ue = A.deletions;
              if (ue !== null) {
                for (var he = 0; he < ue.length; he++) {
                  var Fe = ue[he];
                  for (Ot = Fe; Ot !== null; ) {
                    var Je = Ot;
                    switch (Je.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Ru(8, Je, A);
                    }
                    var Ze = Je.child;
                    if (Ze !== null) Ze.return = Je, Ot = Ze;
                    else for (; Ot !== null; ) {
                      Je = Ot;
                      var Ke = Je.sibling, Ct = Je.return;
                      if (iS(Je), Je === Fe) {
                        Ot = null;
                        break;
                      }
                      if (Ke !== null) {
                        Ke.return = Ct, Ot = Ke;
                        break;
                      }
                      Ot = Ct;
                    }
                  }
                }
                var $t = A.alternate;
                if ($t !== null) {
                  var It = $t.child;
                  if (It !== null) {
                    $t.child = null;
                    do {
                      var Er = It.sibling;
                      It.sibling = null, It = Er;
                    } while (It !== null);
                  }
                }
                Ot = A;
              }
            }
            if (A.subtreeFlags & 2064 && q !== null) q.return = A, Ot = q;
            else e: for (; Ot !== null; ) {
              if (A = Ot, A.flags & 2048) switch (A.tag) {
                case 0:
                case 11:
                case 15:
                  Ru(9, A, A.return);
              }
              var $e = A.sibling;
              if ($e !== null) {
                $e.return = A.return, Ot = $e;
                break e;
              }
              Ot = A.return;
            }
          }
          var Se = c.current;
          for (Ot = Se; Ot !== null; ) {
            q = Ot;
            var Ie = q.child;
            if (q.subtreeFlags & 2064 && Ie !== null) Ie.return = q, Ot = Ie;
            else e: for (q = Se; Ot !== null; ) {
              if (ue = Ot, ue.flags & 2048) try {
                switch (ue.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Eh(9, ue);
                }
              } catch (At) {
                br(ue, ue.return, At);
              }
              if (ue === q) {
                Ot = null;
                break e;
              }
              var ot = ue.sibling;
              if (ot !== null) {
                ot.return = ue.return, Ot = ot;
                break e;
              }
              Ot = ue.return;
            }
          }
          if (hn = $, Jo(), bi && typeof bi.onPostCommitFiberRoot == "function") try {
            bi.onPostCommitFiberRoot(Ed, c);
          } catch {
          }
          C = !0;
        }
        return C;
      } finally {
        kn = g, Ya.transition = d;
      }
    }
    return !1;
  }
  function hS(c, d, g) {
    d = gl(g, d), d = Zx(c, d, 1), c = ml(c, d, 1), d = Zr(), c !== null && (Kl(c, 1, d), zr(c, d));
  }
  function br(c, d, g) {
    if (c.tag === 3) hS(c, c, g);
    else for (; d !== null; ) {
      if (d.tag === 3) {
        hS(d, c, g);
        break;
      } else if (d.tag === 1) {
        var C = d.stateNode;
        if (typeof d.type.getDerivedStateFromError == "function" || typeof C.componentDidCatch == "function" && (Ga === null || !Ga.has(C))) {
          c = gl(g, c), c = eS(d, c, 1), d = ml(d, c, 1), c = Zr(), d !== null && (Kl(d, 1, c), zr(d, c));
          break;
        }
      }
      d = d.return;
    }
  }
  function BE(c, d, g) {
    var C = c.pingCache;
    C !== null && C.delete(d), d = Zr(), c.pingedLanes |= c.suspendedLanes & g, yr === c && (Vr & g) === g && (Br === 4 || Br === 3 && (Vr & 130023424) === Vr && 500 > mr() - Ph ? bc(c, 0) : zg |= g), zr(c, d);
  }
  function mS(c, d) {
    d === 0 && (c.mode & 1 ? (d = Xc, Xc <<= 1, !(Xc & 130023424) && (Xc = 4194304)) : d = 1);
    var g = Zr();
    c = Ds(c, d), c !== null && (Kl(c, d, g), zr(c, g));
  }
  function Yg(c) {
    var d = c.memoizedState, g = 0;
    d !== null && (g = d.retryLane), mS(c, g);
  }
  function zE(c, d) {
    var g = 0;
    switch (c.tag) {
      case 13:
        var C = c.stateNode, $ = c.memoizedState;
        $ !== null && (g = $.retryLane);
        break;
      case 19:
        C = c.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    C !== null && C.delete(d), mS(c, g);
  }
  var vS;
  vS = function(c, d, g) {
    if (c !== null) if (c.memoizedProps !== d.pendingProps || vr.current) oa = !0;
    else {
      if (!(c.lanes & g) && !(d.flags & 128)) return oa = !1, Ms(c, d, g);
      oa = !!(c.flags & 131072);
    }
    else oa = !1, Zn && d.flags & 1048576 && Cg(d, lu, d.index);
    switch (d.lanes = 0, d.tag) {
      case 2:
        var C = d.type;
        sf(c, d), c = d.pendingProps;
        var $ = ja(d, Kt.current);
        uu(d, g), $ = Ge(null, d, C, c, $, g);
        var A = kr();
        return d.flags |= 1, typeof $ == "object" && $ !== null && typeof $.render == "function" && $.$$typeof === void 0 ? (d.tag = 1, d.memoizedState = null, d.updateQueue = null, or(C) ? (A = !0, Hp(d)) : A = !1, d.memoizedState = $.state !== null && $.state !== void 0 ? $.state : null, Qp(d), $.updater = fc, d.stateNode = $, $._reactInternals = d, Ng(d, C, c, g), d = bh(null, d, C, !0, A, g)) : (d.tag = 0, Zn && A && Wp(d), wr(null, d, $, g), d = d.child), d;
      case 16:
        C = d.elementType;
        e: {
          switch (sf(c, d), c = d.pendingProps, $ = C._init, C = $(C._payload), d.type = C, $ = d.tag = UE(C), c = ra(C, c), $) {
            case 0:
              d = rn(null, d, C, c, g);
              break e;
            case 1:
              d = of(null, d, C, c, g);
              break e;
            case 11:
              d = Su(null, d, C, c, g);
              break e;
            case 14:
              d = yl(null, d, C, ra(C.type, c), g);
              break e;
          }
          throw Error(n(
            306,
            C,
            ""
          ));
        }
        return d;
      case 0:
        return C = d.type, $ = d.pendingProps, $ = d.elementType === C ? $ : ra(C, $), rn(c, d, C, $, g);
      case 1:
        return C = d.type, $ = d.pendingProps, $ = d.elementType === C ? $ : ra(C, $), of(c, d, C, $, g);
      case 3:
        e: {
          if (ME(d), c === null) throw Error(n(387));
          C = d.pendingProps, A = d.memoizedState, $ = A.element, du(c, d), Zp(d, C, null, g);
          var q = d.memoizedState;
          if (C = q.element, A.isDehydrated) if (A = { element: C, isDehydrated: !1, cache: q.cache, pendingSuspenseBoundaries: q.pendingSuspenseBoundaries, transitions: q.transitions }, d.updateQueue.baseState = A, d.memoizedState = A, d.flags & 256) {
            $ = gl(Error(n(423)), d), d = rS(c, d, C, g, $);
            break e;
          } else if (C !== $) {
            $ = gl(Error(n(424)), d), d = rS(c, d, C, g, $);
            break e;
          } else for (ta = Ti(d.stateNode.containerInfo.firstChild), ya = d, Zn = !0, za = null, g = Ux(d, null, C, g), d.child = g; g; ) g.flags = g.flags & -3 | 4096, g = g.sibling;
          else {
            if (cr(), C === $) {
              d = Tr(c, d, g);
              break e;
            }
            wr(c, d, C, g);
          }
          d = d.child;
        }
        return d;
      case 5:
        return Yx(d), c === null && Yp(d), C = d.type, $ = d.pendingProps, A = c !== null ? c.memoizedProps : null, q = $.children, Hd(C, $) ? q = null : A !== null && Hd(C, A) && (d.flags |= 32), pc(c, d), wr(c, d, q, g), d.child;
      case 6:
        return c === null && Yp(d), null;
      case 13:
        return oS(c, d, g);
      case 4:
        return Pg(d, d.stateNode.containerInfo), C = d.pendingProps, c === null ? d.child = cu(d, null, C, g) : wr(c, d, C, g), d.child;
      case 11:
        return C = d.type, $ = d.pendingProps, $ = d.elementType === C ? $ : ra(C, $), Su(c, d, C, $, g);
      case 7:
        return wr(c, d, d.pendingProps, g), d.child;
      case 8:
        return wr(c, d, d.pendingProps.children, g), d.child;
      case 12:
        return wr(c, d, d.pendingProps.children, g), d.child;
      case 10:
        e: {
          if (C = d.type._context, $ = d.pendingProps, A = d.memoizedProps, q = $.value, Pn($s, C._currentValue), C._currentValue = q, A !== null) if (La(A.value, q)) {
            if (A.children === $.children && !vr.current) {
              d = Tr(c, d, g);
              break e;
            }
          } else for (A = d.child, A !== null && (A.return = d); A !== null; ) {
            var ue = A.dependencies;
            if (ue !== null) {
              q = A.child;
              for (var he = ue.firstContext; he !== null; ) {
                if (he.context === C) {
                  if (A.tag === 1) {
                    he = na(-1, g & -g), he.tag = 2;
                    var Fe = A.updateQueue;
                    if (Fe !== null) {
                      Fe = Fe.shared;
                      var Je = Fe.pending;
                      Je === null ? he.next = he : (he.next = Je.next, Je.next = he), Fe.pending = he;
                    }
                  }
                  A.lanes |= g, he = A.alternate, he !== null && (he.lanes |= g), Og(
                    A.return,
                    g,
                    d
                  ), ue.lanes |= g;
                  break;
                }
                he = he.next;
              }
            } else if (A.tag === 10) q = A.type === d.type ? null : A.child;
            else if (A.tag === 18) {
              if (q = A.return, q === null) throw Error(n(341));
              q.lanes |= g, ue = q.alternate, ue !== null && (ue.lanes |= g), Og(q, g, d), q = A.sibling;
            } else q = A.child;
            if (q !== null) q.return = A;
            else for (q = A; q !== null; ) {
              if (q === d) {
                q = null;
                break;
              }
              if (A = q.sibling, A !== null) {
                A.return = q.return, q = A;
                break;
              }
              q = q.return;
            }
            A = q;
          }
          wr(c, d, $.children, g), d = d.child;
        }
        return d;
      case 9:
        return $ = d.type, C = d.pendingProps.children, uu(d, g), $ = Ha($), C = C($), d.flags |= 1, wr(c, d, C, g), d.child;
      case 14:
        return C = d.type, $ = ra(C, d.pendingProps), $ = ra(C.type, $), yl(c, d, C, $, g);
      case 15:
        return yh(c, d, d.type, d.pendingProps, g);
      case 17:
        return C = d.type, $ = d.pendingProps, $ = d.elementType === C ? $ : ra(C, $), sf(c, d), d.tag = 1, or(C) ? (c = !0, Hp(d)) : c = !1, uu(d, g), Xx(d, C, $), Ng(d, C, $, g), bh(null, d, C, !0, c, g);
      case 19:
        return Lg(c, d, g);
      case 22:
        return aa(c, d, g);
    }
    throw Error(n(156, d.tag));
  };
  function gS(c, d) {
    return Qn(c, d);
  }
  function yS(c, d, g, C) {
    this.tag = c, this.key = g, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = d, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = C, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Xa(c, d, g, C) {
    return new yS(c, d, g, C);
  }
  function Gg(c) {
    return c = c.prototype, !(!c || !c.isReactComponent);
  }
  function UE(c) {
    if (typeof c == "function") return Gg(c) ? 1 : 0;
    if (c != null) {
      if (c = c.$$typeof, c === ne) return 11;
      if (c === te) return 14;
    }
    return 2;
  }
  function Sl(c, d) {
    var g = c.alternate;
    return g === null ? (g = Xa(c.tag, d, c.key, c.mode), g.elementType = c.elementType, g.type = c.type, g.stateNode = c.stateNode, g.alternate = c, c.alternate = g) : (g.pendingProps = d, g.type = c.type, g.flags = 0, g.subtreeFlags = 0, g.deletions = null), g.flags = c.flags & 14680064, g.childLanes = c.childLanes, g.lanes = c.lanes, g.child = c.child, g.memoizedProps = c.memoizedProps, g.memoizedState = c.memoizedState, g.updateQueue = c.updateQueue, d = c.dependencies, g.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }, g.sibling = c.sibling, g.index = c.index, g.ref = c.ref, g;
  }
  function _h(c, d, g, C, $, A) {
    var q = 2;
    if (C = c, typeof c == "function") Gg(c) && (q = 1);
    else if (typeof c == "string") q = 5;
    else e: switch (c) {
      case z:
        return xc(g.children, $, A, d);
      case H:
        q = 8, $ |= 8;
        break;
      case ee:
        return c = Xa(12, g, d, $ | 2), c.elementType = ee, c.lanes = A, c;
      case Y:
        return c = Xa(13, g, d, $), c.elementType = Y, c.lanes = A, c;
      case J:
        return c = Xa(19, g, d, $), c.elementType = J, c.lanes = A, c;
      case ae:
        return Ah(g, $, A, d);
      default:
        if (typeof c == "object" && c !== null) switch (c.$$typeof) {
          case K:
            q = 10;
            break e;
          case X:
            q = 9;
            break e;
          case ne:
            q = 11;
            break e;
          case te:
            q = 14;
            break e;
          case Z:
            q = 16, C = null;
            break e;
        }
        throw Error(n(130, c == null ? c : typeof c, ""));
    }
    return d = Xa(q, g, d, $), d.elementType = c, d.type = C, d.lanes = A, d;
  }
  function xc(c, d, g, C) {
    return c = Xa(7, c, C, d), c.lanes = g, c;
  }
  function Ah(c, d, g, C) {
    return c = Xa(22, c, C, d), c.elementType = ae, c.lanes = g, c.stateNode = { isHidden: !1 }, c;
  }
  function Lh(c, d, g) {
    return c = Xa(6, c, null, d), c.lanes = g, c;
  }
  function pf(c, d, g) {
    return d = Xa(4, c.children !== null ? c.children : [], c.key, d), d.lanes = g, d.stateNode = { containerInfo: c.containerInfo, pendingChildren: null, implementation: c.implementation }, d;
  }
  function hf(c, d, g, C, $) {
    this.tag = d, this.containerInfo = c, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Wv(0), this.expirationTimes = Wv(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Wv(0), this.identifierPrefix = C, this.onRecoverableError = $, this.mutableSourceEagerHydrationData = null;
  }
  function Kg(c, d, g, C, $, A, q, ue, he) {
    return c = new hf(c, d, g, ue, he), d === 1 ? (d = 1, A === !0 && (d |= 8)) : d = 0, A = Xa(3, null, null, d), c.current = A, A.stateNode = c, A.memoizedState = { element: C, isDehydrated: g, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Qp(A), c;
  }
  function bS(c, d, g) {
    var C = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: V, key: C == null ? null : "" + C, children: c, containerInfo: d, implementation: g };
  }
  function Xg(c) {
    if (!c) return zi;
    c = c._reactInternals;
    e: {
      if (ze(c) !== c || c.tag !== 1) throw Error(n(170));
      var d = c;
      do {
        switch (d.tag) {
          case 3:
            d = d.stateNode.context;
            break e;
          case 1:
            if (or(d.type)) {
              d = d.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        d = d.return;
      } while (d !== null);
      throw Error(n(171));
    }
    if (c.tag === 1) {
      var g = c.type;
      if (or(g)) return Yd(c, g, d);
    }
    return d;
  }
  function Qg(c, d, g, C, $, A, q, ue, he) {
    return c = Kg(g, C, !0, c, $, A, q, ue, he), c.context = Xg(null), g = c.current, C = Zr(), $ = Is(g), A = na(C, $), A.callback = d ?? null, ml(g, A, $), c.current.lanes = $, Kl(c, $, C), zr(c, C), c;
  }
  function Fh(c, d, g, C) {
    var $ = d.current, A = Zr(), q = Is($);
    return g = Xg(g), d.context === null ? d.context = g : d.pendingContext = g, d = na(A, q), d.payload = { element: c }, C = C === void 0 ? null : C, C !== null && (d.callback = C), c = ml($, d, q), c !== null && (ur(c, $, q, A), Jp(c, $, q)), q;
  }
  function mf(c) {
    if (c = c.current, !c.child) return null;
    switch (c.child.tag) {
      case 5:
        return c.child.stateNode;
      default:
        return c.child.stateNode;
    }
  }
  function xS(c, d) {
    if (c = c.memoizedState, c !== null && c.dehydrated !== null) {
      var g = c.retryLane;
      c.retryLane = g !== 0 && g < d ? g : d;
    }
  }
  function Jg(c, d) {
    xS(c, d), (c = c.alternate) && xS(c, d);
  }
  function HE() {
    return null;
  }
  var Zg = typeof reportError == "function" ? reportError : function(c) {
    console.error(c);
  };
  function jh(c) {
    this._internalRoot = c;
  }
  vf.prototype.render = jh.prototype.render = function(c) {
    var d = this._internalRoot;
    if (d === null) throw Error(n(409));
    Fh(c, d, null, null);
  }, vf.prototype.unmount = jh.prototype.unmount = function() {
    var c = this._internalRoot;
    if (c !== null) {
      this._internalRoot = null;
      var d = c.containerInfo;
      Yi(function() {
        Fh(null, c, null, null);
      }), d[Os] = null;
    }
  };
  function vf(c) {
    this._internalRoot = c;
  }
  vf.prototype.unstable_scheduleHydration = function(c) {
    if (c) {
      var d = tx();
      c = { blockedOn: null, target: c, priority: d };
      for (var g = 0; g < _n.length && d !== 0 && d < _n[g].priority; g++) ;
      _n.splice(g, 0, c), g === 0 && nx(c);
    }
  };
  function Cl(c) {
    return !(!c || c.nodeType !== 1 && c.nodeType !== 9 && c.nodeType !== 11);
  }
  function Vh(c) {
    return !(!c || c.nodeType !== 1 && c.nodeType !== 9 && c.nodeType !== 11 && (c.nodeType !== 8 || c.nodeValue !== " react-mount-point-unstable "));
  }
  function SS() {
  }
  function WE(c, d, g, C, $) {
    if ($) {
      if (typeof C == "function") {
        var A = C;
        C = function() {
          var Fe = mf(q);
          A.call(Fe);
        };
      }
      var q = Qg(d, C, c, 0, null, !1, !1, "", SS);
      return c._reactRootContainer = q, c[Os] = q.current, iu(c.nodeType === 8 ? c.parentNode : c), Yi(), q;
    }
    for (; $ = c.lastChild; ) c.removeChild($);
    if (typeof C == "function") {
      var ue = C;
      C = function() {
        var Fe = mf(he);
        ue.call(Fe);
      };
    }
    var he = Kg(c, 0, !1, null, null, !1, !1, "", SS);
    return c._reactRootContainer = he, c[Os] = he.current, iu(c.nodeType === 8 ? c.parentNode : c), Yi(function() {
      Fh(d, he, g, C);
    }), he;
  }
  function Bh(c, d, g, C, $) {
    var A = g._reactRootContainer;
    if (A) {
      var q = A;
      if (typeof $ == "function") {
        var ue = $;
        $ = function() {
          var he = mf(q);
          ue.call(he);
        };
      }
      Fh(d, q, c, $);
    } else q = WE(g, d, c, $, C);
    return mf(q);
  }
  ex = function(c) {
    switch (c.tag) {
      case 3:
        var d = c.stateNode;
        if (d.current.memoizedState.isDehydrated) {
          var g = Gl(d.pendingLanes);
          g !== 0 && (Rd(d, g | 1), zr(d, mr()), !(hn & 6) && (Nu = mr() + 500, Jo()));
        }
        break;
      case 13:
        Yi(function() {
          var C = Ds(c, 1);
          if (C !== null) {
            var $ = Zr();
            ur(C, c, 1, $);
          }
        }), Jg(c, 1);
    }
  }, Rp = function(c) {
    if (c.tag === 13) {
      var d = Ds(c, 134217728);
      if (d !== null) {
        var g = Zr();
        ur(d, c, 134217728, g);
      }
      Jg(c, 134217728);
    }
  }, Mn = function(c) {
    if (c.tag === 13) {
      var d = Is(c), g = Ds(c, d);
      if (g !== null) {
        var C = Zr();
        ur(g, c, d, C);
      }
      Jg(c, d);
    }
  }, tx = function() {
    return kn;
  }, Yv = function(c, d) {
    var g = kn;
    try {
      return kn = c, d();
    } finally {
      kn = g;
    }
  }, tn = function(c, d, g) {
    switch (d) {
      case "input":
        if (Ve(c, g), d = g.name, g.type === "radio" && d != null) {
          for (g = c; g.parentNode; ) g = g.parentNode;
          for (g = g.querySelectorAll("input[name=" + JSON.stringify("" + d) + '][type="radio"]'), d = 0; d < g.length; d++) {
            var C = g[d];
            if (C !== c && C.form === c.form) {
              var $ = Ut(C);
              if (!$) throw Error(n(90));
              ie(C), Ve(C, $);
            }
          }
        }
        break;
      case "textarea":
        Nt(c, g);
        break;
      case "select":
        d = g.value, d != null && at(c, !!g.multiple, d, !1);
    }
  }, Vi = qg, ys = Yi;
  var qE = { usingClientEntryPoint: !1, Events: [qd, su, Ut, yo, ka, qg] }, gf = { findFiberByHostInstance: Fa, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, CS = { bundleType: gf.bundleType, version: gf.version, rendererPackageName: gf.rendererPackageName, rendererConfig: gf.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: F.ReactCurrentDispatcher, findHostInstanceByFiber: function(c) {
    return c = cn(c), c === null ? null : c.stateNode;
  }, findFiberByHostInstance: gf.findFiberByHostInstance || HE, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var zh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!zh.isDisabled && zh.supportsFiber) try {
      Ed = zh.inject(CS), bi = zh;
    } catch {
    }
  }
  return ni.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = qE, ni.createPortal = function(c, d) {
    var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Cl(d)) throw Error(n(200));
    return bS(c, d, null, g);
  }, ni.createRoot = function(c, d) {
    if (!Cl(c)) throw Error(n(299));
    var g = !1, C = "", $ = Zg;
    return d != null && (d.unstable_strictMode === !0 && (g = !0), d.identifierPrefix !== void 0 && (C = d.identifierPrefix), d.onRecoverableError !== void 0 && ($ = d.onRecoverableError)), d = Kg(c, 1, !1, null, null, g, !1, C, $), c[Os] = d.current, iu(c.nodeType === 8 ? c.parentNode : c), new jh(d);
  }, ni.findDOMNode = function(c) {
    if (c == null) return null;
    if (c.nodeType === 1) return c;
    var d = c._reactInternals;
    if (d === void 0)
      throw typeof c.render == "function" ? Error(n(188)) : (c = Object.keys(c).join(","), Error(n(268, c)));
    return c = cn(d), c = c === null ? null : c.stateNode, c;
  }, ni.flushSync = function(c) {
    return Yi(c);
  }, ni.hydrate = function(c, d, g) {
    if (!Vh(d)) throw Error(n(200));
    return Bh(null, c, d, !0, g);
  }, ni.hydrateRoot = function(c, d, g) {
    if (!Cl(c)) throw Error(n(405));
    var C = g != null && g.hydratedSources || null, $ = !1, A = "", q = Zg;
    if (g != null && (g.unstable_strictMode === !0 && ($ = !0), g.identifierPrefix !== void 0 && (A = g.identifierPrefix), g.onRecoverableError !== void 0 && (q = g.onRecoverableError)), d = Qg(d, null, c, 1, g ?? null, $, !1, A, q), c[Os] = d.current, iu(c), C) for (c = 0; c < C.length; c++) g = C[c], $ = g._getVersion, $ = $(g._source), d.mutableSourceEagerHydrationData == null ? d.mutableSourceEagerHydrationData = [g, $] : d.mutableSourceEagerHydrationData.push(
      g,
      $
    );
    return new vf(d);
  }, ni.render = function(c, d, g) {
    if (!Vh(d)) throw Error(n(200));
    return Bh(null, c, d, !1, g);
  }, ni.unmountComponentAtNode = function(c) {
    if (!Vh(c)) throw Error(n(40));
    return c._reactRootContainer ? (Yi(function() {
      Bh(null, null, c, !1, function() {
        c._reactRootContainer = null, c[Os] = null;
      });
    }), !0) : !1;
  }, ni.unstable_batchedUpdates = qg, ni.unstable_renderSubtreeIntoContainer = function(c, d, g, C) {
    if (!Vh(g)) throw Error(n(200));
    if (c == null || c._reactInternals === void 0) throw Error(n(38));
    return Bh(c, d, g, !1, C);
  }, ni.version = "18.3.1-next-f1338f8080-20240426", ni;
}
var ri = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZA;
function AX() {
  return ZA || (ZA = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = oe, t = FB(), n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
    function s(a) {
      o = a;
    }
    function l(a) {
      if (!o) {
        for (var i = arguments.length, f = new Array(i > 1 ? i - 1 : 0), v = 1; v < i; v++)
          f[v - 1] = arguments[v];
        p("warn", a, f);
      }
    }
    function u(a) {
      if (!o) {
        for (var i = arguments.length, f = new Array(i > 1 ? i - 1 : 0), v = 1; v < i; v++)
          f[v - 1] = arguments[v];
        p("error", a, f);
      }
    }
    function p(a, i, f) {
      {
        var v = n.ReactDebugCurrentFrame, y = v.getStackAddendum();
        y !== "" && (i += "%s", f = f.concat([y]));
        var w = f.map(function(M) {
          return String(M);
        });
        w.unshift("Warning: " + i), Function.prototype.apply.call(console[a], console, w);
      }
    }
    var h = 0, m = 1, b = 2, x = 3, S = 4, R = 5, T = 6, E = 7, P = 8, k = 9, _ = 10, L = 11, F = 12, N = 13, V = 14, z = 15, H = 16, ee = 17, K = 18, X = 19, ne = 21, Y = 22, J = 23, te = 24, Z = 25, ae = !0, U = !1, G = !1, W = !1, le = !1, pe = !0, ge = !1, we = !0, de = !0, se = !0, ve = !0, me = /* @__PURE__ */ new Set(), Oe = {}, be = {};
    function De(a, i) {
      ie(a, i), ie(a + "Capture", i);
    }
    function ie(a, i) {
      Oe[a] && u("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", a), Oe[a] = i;
      {
        var f = a.toLowerCase();
        be[f] = a, a === "onDoubleClick" && (be.ondblclick = a);
      }
      for (var v = 0; v < i.length; v++)
        me.add(i[v]);
    }
    var fe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", ye = Object.prototype.hasOwnProperty;
    function Ee(a) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, f = i && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return f;
      }
    }
    function _e(a) {
      try {
        return Ve(a), !1;
      } catch {
        return !0;
      }
    }
    function Ve(a) {
      return "" + a;
    }
    function Re(a, i) {
      if (_e(a))
        return u("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", i, Ee(a)), Ve(a);
    }
    function lt(a) {
      if (_e(a))
        return u("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ee(a)), Ve(a);
    }
    function Pt(a, i) {
      if (_e(a))
        return u("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", i, Ee(a)), Ve(a);
    }
    function at(a, i) {
      if (_e(a))
        return u("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", i, Ee(a)), Ve(a);
    }
    function it(a) {
      if (_e(a))
        return u("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Ee(a)), Ve(a);
    }
    function bt(a) {
      if (_e(a))
        return u("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Ee(a)), Ve(a);
    }
    var Nt = 0, en = 1, fn = 2, ln = 3, Rt = 4, rt = 5, Qt = 6, et = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", st = et + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", jt = new RegExp("^[" + et + "][" + st + "]*$"), Xe = {}, Be = {};
    function Qe(a) {
      return ye.call(Be, a) ? !0 : ye.call(Xe, a) ? !1 : jt.test(a) ? (Be[a] = !0, !0) : (Xe[a] = !0, u("Invalid attribute name: `%s`", a), !1);
    }
    function xt(a, i, f) {
      return i !== null ? i.type === Nt : f ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
    }
    function ct(a, i, f, v) {
      if (f !== null && f.type === Nt)
        return !1;
      switch (typeof i) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (v)
            return !1;
          if (f !== null)
            return !f.acceptsBooleans;
          var y = a.toLowerCase().slice(0, 5);
          return y !== "data-" && y !== "aria-";
        }
        default:
          return !1;
      }
    }
    function St(a, i, f, v) {
      if (i === null || typeof i > "u" || ct(a, i, f, v))
        return !0;
      if (v)
        return !1;
      if (f !== null)
        switch (f.type) {
          case ln:
            return !i;
          case Rt:
            return i === !1;
          case rt:
            return isNaN(i);
          case Qt:
            return isNaN(i) || i < 1;
        }
      return !1;
    }
    function tn(a) {
      return dn.hasOwnProperty(a) ? dn[a] : null;
    }
    function Wt(a, i, f, v, y, w, M) {
      this.acceptsBooleans = i === fn || i === ln || i === Rt, this.attributeName = v, this.attributeNamespace = y, this.mustUseProperty = f, this.propertyName = a, this.type = i, this.sanitizeURL = w, this.removeEmptyString = M;
    }
    var dn = {}, hr = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    hr.forEach(function(a) {
      dn[a] = new Wt(
        a,
        Nt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
      var i = a[0], f = a[1];
      dn[i] = new Wt(
        i,
        en,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
      dn[a] = new Wt(
        a,
        fn,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
      dn[a] = new Wt(
        a,
        fn,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(a) {
      dn[a] = new Wt(
        a,
        ln,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      dn[a] = new Wt(
        a,
        ln,
        !0,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      dn[a] = new Wt(
        a,
        Rt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      dn[a] = new Wt(
        a,
        Qt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(a) {
      dn[a] = new Wt(
        a,
        rt,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var yo = /[\-\:]([a-z])/g, ka = function(a) {
      return a[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var i = a.replace(yo, ka);
      dn[i] = new Wt(
        i,
        en,
        !1,
        // mustUseProperty
        a,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var i = a.replace(yo, ka);
      dn[i] = new Wt(
        i,
        en,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var i = a.replace(yo, ka);
      dn[i] = new Wt(
        i,
        en,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(a) {
      dn[a] = new Wt(
        a,
        en,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Vi = "xlinkHref";
    dn[Vi] = new Wt(
      "xlinkHref",
      en,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(a) {
      dn[a] = new Wt(
        a,
        en,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ys = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, bs = !1;
    function Ma(a) {
      !bs && ys.test(a) && (bs = !0, u("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
    }
    function rr(a, i, f, v) {
      if (v.mustUseProperty) {
        var y = v.propertyName;
        return a[y];
      } else {
        Re(f, i), v.sanitizeURL && Ma("" + f);
        var w = v.attributeName, M = null;
        if (v.type === Rt) {
          if (a.hasAttribute(w)) {
            var j = a.getAttribute(w);
            return j === "" ? !0 : St(i, f, v, !1) ? j : j === "" + f ? f : j;
          }
        } else if (a.hasAttribute(w)) {
          if (St(i, f, v, !1))
            return a.getAttribute(w);
          if (v.type === ln)
            return f;
          M = a.getAttribute(w);
        }
        return St(i, f, v, !1) ? M === null ? f : M : M === "" + f ? f : M;
      }
    }
    function Wn(a, i, f, v) {
      {
        if (!Qe(i))
          return;
        if (!a.hasAttribute(i))
          return f === void 0 ? void 0 : null;
        var y = a.getAttribute(i);
        return Re(f, i), y === "" + f ? f : y;
      }
    }
    function Cr(a, i, f, v) {
      var y = tn(i);
      if (!xt(i, y, v)) {
        if (St(i, f, y, v) && (f = null), v || y === null) {
          if (Qe(i)) {
            var w = i;
            f === null ? a.removeAttribute(w) : (Re(f, i), a.setAttribute(w, "" + f));
          }
          return;
        }
        var M = y.mustUseProperty;
        if (M) {
          var j = y.propertyName;
          if (f === null) {
            var B = y.type;
            a[j] = B === ln ? !1 : "";
          } else
            a[j] = f;
          return;
        }
        var Q = y.attributeName, re = y.attributeNamespace;
        if (f === null)
          a.removeAttribute(Q);
        else {
          var Ce = y.type, xe;
          Ce === ln || Ce === Rt && f === !0 ? xe = "" : (Re(f, Q), xe = "" + f, y.sanitizeURL && Ma(xe.toString())), re ? a.setAttributeNS(re, Q, xe) : a.setAttribute(Q, xe);
        }
      }
    }
    var ko = Symbol.for("react.element"), Lr = Symbol.for("react.portal"), Kn = Symbol.for("react.fragment"), bo = Symbol.for("react.strict_mode"), Na = Symbol.for("react.profiler"), Mo = Symbol.for("react.provider"), No = Symbol.for("react.context"), xo = Symbol.for("react.forward_ref"), ze = Symbol.for("react.suspense"), Pe = Symbol.for("react.suspense_list"), tt = Symbol.for("react.memo"), mt = Symbol.for("react.lazy"), cn = Symbol.for("react.scope"), Rn = Symbol.for("react.debug_trace_mode"), Qn = Symbol.for("react.offscreen"), zt = Symbol.for("react.legacy_hidden"), Or = Symbol.for("react.cache"), lE = Symbol.for("react.tracing_marker"), mr = Symbol.iterator, cE = "@@iterator";
    function xs(a) {
      if (a === null || typeof a != "object")
        return null;
      var i = mr && a[mr] || a[cE];
      return typeof i == "function" ? i : null;
    }
    var pn = Object.assign, ol = 0, X0, zv, Ed, bi, Q0, Ia, J0;
    function Z0() {
    }
    Z0.__reactDisabledLog = !0;
    function uE() {
      {
        if (ol === 0) {
          X0 = console.log, zv = console.info, Ed = console.warn, bi = console.error, Q0 = console.group, Ia = console.groupCollapsed, J0 = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: Z0,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        ol++;
      }
    }
    function wp() {
      {
        if (ol--, ol === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: pn({}, a, {
              value: X0
            }),
            info: pn({}, a, {
              value: zv
            }),
            warn: pn({}, a, {
              value: Ed
            }),
            error: pn({}, a, {
              value: bi
            }),
            group: pn({}, a, {
              value: Q0
            }),
            groupCollapsed: pn({}, a, {
              value: Ia
            }),
            groupEnd: pn({}, a, {
              value: J0
            })
          });
        }
        ol < 0 && u("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xc = n.ReactCurrentDispatcher, Gl;
    function xi(a, i, f) {
      {
        if (Gl === void 0)
          try {
            throw Error();
          } catch (y) {
            var v = y.stack.trim().match(/\n( *(at )?)/);
            Gl = v && v[1] || "";
          }
        return `
` + Gl + a;
      }
    }
    var Uv = !1, Tp;
    {
      var Hv = typeof WeakMap == "function" ? WeakMap : Map;
      Tp = new Hv();
    }
    function Ep(a, i) {
      if (!a || Uv)
        return "";
      {
        var f = Tp.get(a);
        if (f !== void 0)
          return f;
      }
      var v;
      Uv = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var w;
      w = Xc.current, Xc.current = null, uE();
      try {
        if (i) {
          var M = function() {
            throw Error();
          };
          if (Object.defineProperty(M.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(M, []);
            } catch (je) {
              v = je;
            }
            Reflect.construct(a, [], M);
          } else {
            try {
              M.call();
            } catch (je) {
              v = je;
            }
            a.call(M.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (je) {
            v = je;
          }
          a();
        }
      } catch (je) {
        if (je && v && typeof je.stack == "string") {
          for (var j = je.stack.split(`
`), B = v.stack.split(`
`), Q = j.length - 1, re = B.length - 1; Q >= 1 && re >= 0 && j[Q] !== B[re]; )
            re--;
          for (; Q >= 1 && re >= 0; Q--, re--)
            if (j[Q] !== B[re]) {
              if (Q !== 1 || re !== 1)
                do
                  if (Q--, re--, re < 0 || j[Q] !== B[re]) {
                    var Ce = `
` + j[Q].replace(" at new ", " at ");
                    return a.displayName && Ce.includes("<anonymous>") && (Ce = Ce.replace("<anonymous>", a.displayName)), typeof a == "function" && Tp.set(a, Ce), Ce;
                  }
                while (Q >= 1 && re >= 0);
              break;
            }
        }
      } finally {
        Uv = !1, Xc.current = w, wp(), Error.prepareStackTrace = y;
      }
      var xe = a ? a.displayName || a.name : "", Le = xe ? xi(xe) : "";
      return typeof a == "function" && Tp.set(a, Le), Le;
    }
    function Wv(a, i, f) {
      return Ep(a, !0);
    }
    function Kl(a, i, f) {
      return Ep(a, !1);
    }
    function dE(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function Rd(a, i, f) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return Ep(a, dE(a));
      if (typeof a == "string")
        return xi(a);
      switch (a) {
        case ze:
          return xi("Suspense");
        case Pe:
          return xi("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case xo:
            return Kl(a.render);
          case tt:
            return Rd(a.type, i, f);
          case mt: {
            var v = a, y = v._payload, w = v._init;
            try {
              return Rd(w(y), i, f);
            } catch {
            }
          }
        }
      return "";
    }
    function kn(a) {
      switch (a._debugOwner && a._debugOwner.type, a._debugSource, a.tag) {
        case R:
          return xi(a.type);
        case H:
          return xi("Lazy");
        case N:
          return xi("Suspense");
        case X:
          return xi("SuspenseList");
        case h:
        case b:
        case z:
          return Kl(a.type);
        case L:
          return Kl(a.type.render);
        case m:
          return Wv(a.type);
        default:
          return "";
      }
    }
    function qv(a) {
      try {
        var i = "", f = a;
        do
          i += kn(f), f = f.return;
        while (f);
        return i;
      } catch (v) {
        return `
Error generating stack: ` + v.message + `
` + v.stack;
      }
    }
    function ex(a, i, f) {
      var v = a.displayName;
      if (v)
        return v;
      var y = i.displayName || i.name || "";
      return y !== "" ? f + "(" + y + ")" : f;
    }
    function Rp(a) {
      return a.displayName || "Context";
    }
    function Mn(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && u("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case Kn:
          return "Fragment";
        case Lr:
          return "Portal";
        case Na:
          return "Profiler";
        case bo:
          return "StrictMode";
        case ze:
          return "Suspense";
        case Pe:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case No:
            var i = a;
            return Rp(i) + ".Consumer";
          case Mo:
            var f = a;
            return Rp(f._context) + ".Provider";
          case xo:
            return ex(a, a.render, "ForwardRef");
          case tt:
            var v = a.displayName || null;
            return v !== null ? v : Mn(a.type) || "Memo";
          case mt: {
            var y = a, w = y._payload, M = y._init;
            try {
              return Mn(M(w));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function tx(a, i, f) {
      var v = i.displayName || i.name || "";
      return a.displayName || (v !== "" ? f + "(" + v + ")" : f);
    }
    function Yv(a) {
      return a.displayName || "Context";
    }
    function nn(a) {
      var i = a.tag, f = a.type;
      switch (i) {
        case te:
          return "Cache";
        case k:
          var v = f;
          return Yv(v) + ".Consumer";
        case _:
          var y = f;
          return Yv(y._context) + ".Provider";
        case K:
          return "DehydratedFragment";
        case L:
          return tx(f, f.render, "ForwardRef");
        case E:
          return "Fragment";
        case R:
          return f;
        case S:
          return "Portal";
        case x:
          return "Root";
        case T:
          return "Text";
        case H:
          return Mn(f);
        case P:
          return f === bo ? "StrictMode" : "Mode";
        case Y:
          return "Offscreen";
        case F:
          return "Profiler";
        case ne:
          return "Scope";
        case N:
          return "Suspense";
        case X:
          return "SuspenseList";
        case Z:
          return "TracingMarker";
        case m:
        case h:
        case ee:
        case b:
        case V:
        case z:
          if (typeof f == "function")
            return f.displayName || f.name || null;
          if (typeof f == "string")
            return f;
          break;
      }
      return null;
    }
    var Od = n.ReactDebugCurrentFrame, Pr = null, _a = !1;
    function Aa() {
      {
        if (Pr === null)
          return null;
        var a = Pr._debugOwner;
        if (a !== null && typeof a < "u")
          return nn(a);
      }
      return null;
    }
    function Pd() {
      return Pr === null ? "" : qv(Pr);
    }
    function Fr() {
      Od.getCurrentStack = null, Pr = null, _a = !1;
    }
    function _n(a) {
      Od.getCurrentStack = a === null ? null : Pd, Pr = a, _a = !1;
    }
    function fE() {
      return Pr;
    }
    function Si(a) {
      _a = a;
    }
    function So(a) {
      return "" + a;
    }
    function al(a) {
      switch (typeof a) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return a;
        case "object":
          return bt(a), a;
        default:
          return "";
      }
    }
    var nx = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Qc(a, i) {
      nx[i.type] || i.onChange || i.onInput || i.readOnly || i.disabled || i.value == null || u("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), i.onChange || i.readOnly || i.disabled || i.checked == null || u("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Gv(a) {
      var i = a.type, f = a.nodeName;
      return f && f.toLowerCase() === "input" && (i === "checkbox" || i === "radio");
    }
    function rx(a) {
      return a._valueTracker;
    }
    function $d(a) {
      a._valueTracker = null;
    }
    function Dd(a) {
      var i = "";
      return a && (Gv(a) ? i = a.checked ? "true" : "false" : i = a.value), i;
    }
    function Jc(a) {
      var i = Gv(a) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(a.constructor.prototype, i);
      bt(a[i]);
      var v = "" + a[i];
      if (!(a.hasOwnProperty(i) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var y = f.get, w = f.set;
        Object.defineProperty(a, i, {
          configurable: !0,
          get: function() {
            return y.call(this);
          },
          set: function(j) {
            bt(j), v = "" + j, w.call(this, j);
          }
        }), Object.defineProperty(a, i, {
          enumerable: f.enumerable
        });
        var M = {
          getValue: function() {
            return v;
          },
          setValue: function(j) {
            bt(j), v = "" + j;
          },
          stopTracking: function() {
            $d(a), delete a[i];
          }
        };
        return M;
      }
    }
    function Xl(a) {
      rx(a) || (a._valueTracker = Jc(a));
    }
    function ox(a) {
      if (!a)
        return !1;
      var i = rx(a);
      if (!i)
        return !0;
      var f = i.getValue(), v = Dd(a);
      return v !== f ? (i.setValue(v), !0) : !1;
    }
    function Op(a) {
      if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
        return null;
      try {
        return a.activeElement || a.body;
      } catch {
        return a.body;
      }
    }
    var Pp = !1, kd = !1, $p = !1, Kv = !1;
    function Ss(a) {
      var i = a.type === "checkbox" || a.type === "radio";
      return i ? a.checked != null : a.value != null;
    }
    function Md(a, i) {
      var f = a, v = i.checked, y = pn({}, i, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: v ?? f._wrapperState.initialChecked
      });
      return y;
    }
    function Nd(a, i) {
      Qc("input", i), i.checked !== void 0 && i.defaultChecked !== void 0 && !kd && (u("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Aa() || "A component", i.type), kd = !0), i.value !== void 0 && i.defaultValue !== void 0 && !Pp && (u("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Aa() || "A component", i.type), Pp = !0);
      var f = a, v = i.defaultValue == null ? "" : i.defaultValue;
      f._wrapperState = {
        initialChecked: i.checked != null ? i.checked : i.defaultChecked,
        initialValue: al(i.value != null ? i.value : v),
        controlled: Ss(i)
      };
    }
    function Xv(a, i) {
      var f = a, v = i.checked;
      v != null && Cr(f, "checked", v, !1);
    }
    function Zc(a, i) {
      var f = a;
      {
        var v = Ss(i);
        !f._wrapperState.controlled && v && !Kv && (u("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Kv = !0), f._wrapperState.controlled && !v && !$p && (u("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), $p = !0);
      }
      Xv(a, i);
      var y = al(i.value), w = i.type;
      if (y != null)
        w === "number" ? (y === 0 && f.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        f.value != y) && (f.value = So(y)) : f.value !== So(y) && (f.value = So(y));
      else if (w === "submit" || w === "reset") {
        f.removeAttribute("value");
        return;
      }
      i.hasOwnProperty("value") ? il(f, i.type, y) : i.hasOwnProperty("defaultValue") && il(f, i.type, al(i.defaultValue)), i.checked == null && i.defaultChecked != null && (f.defaultChecked = !!i.defaultChecked);
    }
    function Id(a, i, f) {
      var v = a;
      if (i.hasOwnProperty("value") || i.hasOwnProperty("defaultValue")) {
        var y = i.type, w = y === "submit" || y === "reset";
        if (w && (i.value === void 0 || i.value === null))
          return;
        var M = So(v._wrapperState.initialValue);
        f || M !== v.value && (v.value = M), v.defaultValue = M;
      }
      var j = v.name;
      j !== "" && (v.name = ""), v.defaultChecked = !v.defaultChecked, v.defaultChecked = !!v._wrapperState.initialChecked, j !== "" && (v.name = j);
    }
    function ax(a, i) {
      var f = a;
      Zc(f, i), ma(f, i);
    }
    function ma(a, i) {
      var f = i.name;
      if (i.type === "radio" && f != null) {
        for (var v = a; v.parentNode; )
          v = v.parentNode;
        Re(f, "name");
        for (var y = v.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), w = 0; w < y.length; w++) {
          var M = y[w];
          if (!(M === a || M.form !== a.form)) {
            var j = jS(M);
            if (!j)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            ox(M), Zc(M, j);
          }
        }
      }
    }
    function il(a, i, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (i !== "number" || Op(a.ownerDocument) !== a) && (f == null ? a.defaultValue = So(a._wrapperState.initialValue) : a.defaultValue !== So(f) && (a.defaultValue = So(f)));
    }
    var Dp = !1, eu = !1, ix = !1;
    function kp(a, i) {
      i.value == null && (typeof i.children == "object" && i.children !== null ? e.Children.forEach(i.children, function(f) {
        f != null && (typeof f == "string" || typeof f == "number" || eu || (eu = !0, u("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : i.dangerouslySetInnerHTML != null && (ix || (ix = !0, u("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), i.selected != null && !Dp && (u("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Dp = !0);
    }
    function Qv(a, i) {
      i.value != null && a.setAttribute("value", So(al(i.value)));
    }
    var _d = Array.isArray;
    function Gr(a) {
      return _d(a);
    }
    var Mp;
    Mp = !1;
    function sx() {
      var a = Aa();
      return a ? `

Check the render method of \`` + a + "`." : "";
    }
    var lx = ["value", "defaultValue"];
    function pE(a) {
      {
        Qc("select", a);
        for (var i = 0; i < lx.length; i++) {
          var f = lx[i];
          if (a[f] != null) {
            var v = Gr(a[f]);
            a.multiple && !v ? u("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, sx()) : !a.multiple && v && u("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, sx());
          }
        }
      }
    }
    function sl(a, i, f, v) {
      var y = a.options;
      if (i) {
        for (var w = f, M = {}, j = 0; j < w.length; j++)
          M["$" + w[j]] = !0;
        for (var B = 0; B < y.length; B++) {
          var Q = M.hasOwnProperty("$" + y[B].value);
          y[B].selected !== Q && (y[B].selected = Q), Q && v && (y[B].defaultSelected = !0);
        }
      } else {
        for (var re = So(al(f)), Ce = null, xe = 0; xe < y.length; xe++) {
          if (y[xe].value === re) {
            y[xe].selected = !0, v && (y[xe].defaultSelected = !0);
            return;
          }
          Ce === null && !y[xe].disabled && (Ce = y[xe]);
        }
        Ce !== null && (Ce.selected = !0);
      }
    }
    function Jv(a, i) {
      return pn({}, i, {
        value: void 0
      });
    }
    function cx(a, i) {
      var f = a;
      pE(i), f._wrapperState = {
        wasMultiple: !!i.multiple
      }, i.value !== void 0 && i.defaultValue !== void 0 && !Mp && (u("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Mp = !0);
    }
    function hE(a, i) {
      var f = a;
      f.multiple = !!i.multiple;
      var v = i.value;
      v != null ? sl(f, !!i.multiple, v, !1) : i.defaultValue != null && sl(f, !!i.multiple, i.defaultValue, !0);
    }
    function mE(a, i) {
      var f = a, v = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!i.multiple;
      var y = i.value;
      y != null ? sl(f, !!i.multiple, y, !1) : v !== !!i.multiple && (i.defaultValue != null ? sl(f, !!i.multiple, i.defaultValue, !0) : sl(f, !!i.multiple, i.multiple ? [] : "", !1));
    }
    function vE(a, i) {
      var f = a, v = i.value;
      v != null && sl(f, !!i.multiple, v, !1);
    }
    var Zv = !1;
    function eg(a, i) {
      var f = a;
      if (i.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var v = pn({}, i, {
        value: void 0,
        defaultValue: void 0,
        children: So(f._wrapperState.initialValue)
      });
      return v;
    }
    function ux(a, i) {
      var f = a;
      Qc("textarea", i), i.value !== void 0 && i.defaultValue !== void 0 && !Zv && (u("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Aa() || "A component"), Zv = !0);
      var v = i.value;
      if (v == null) {
        var y = i.children, w = i.defaultValue;
        if (y != null) {
          u("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (w != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Gr(y)) {
              if (y.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              y = y[0];
            }
            w = y;
          }
        }
        w == null && (w = ""), v = w;
      }
      f._wrapperState = {
        initialValue: al(v)
      };
    }
    function dx(a, i) {
      var f = a, v = al(i.value), y = al(i.defaultValue);
      if (v != null) {
        var w = So(v);
        w !== f.value && (f.value = w), i.defaultValue == null && f.defaultValue !== w && (f.defaultValue = w);
      }
      y != null && (f.defaultValue = So(y));
    }
    function fx(a, i) {
      var f = a, v = f.textContent;
      v === f._wrapperState.initialValue && v !== "" && v !== null && (f.value = v);
    }
    function tg(a, i) {
      dx(a, i);
    }
    var Cs = "http://www.w3.org/1999/xhtml", gE = "http://www.w3.org/1998/Math/MathML", ng = "http://www.w3.org/2000/svg";
    function Np(a) {
      switch (a) {
        case "svg":
          return ng;
        case "math":
          return gE;
        default:
          return Cs;
      }
    }
    function rg(a, i) {
      return a == null || a === Cs ? Np(i) : a === ng && i === "foreignObject" ? Cs : a;
    }
    var yE = function(a) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(i, f, v, y) {
        MSApp.execUnsafeLocalFunction(function() {
          return a(i, f, v, y);
        });
      } : a;
    }, Ip, px = yE(function(a, i) {
      if (a.namespaceURI === ng && !("innerHTML" in a)) {
        Ip = Ip || document.createElement("div"), Ip.innerHTML = "<svg>" + i.valueOf().toString() + "</svg>";
        for (var f = Ip.firstChild; a.firstChild; )
          a.removeChild(a.firstChild);
        for (; f.firstChild; )
          a.appendChild(f.firstChild);
        return;
      }
      a.innerHTML = i;
    }), Xo = 1, ws = 3, $r = 8, Ci = 9, Ql = 11, _p = function(a, i) {
      if (i) {
        var f = a.firstChild;
        if (f && f === a.lastChild && f.nodeType === ws) {
          f.nodeValue = i;
          return;
        }
      }
      a.textContent = i;
    }, hx = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, tu = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function mx(a, i) {
      return a + i.charAt(0).toUpperCase() + i.substring(1);
    }
    var vx = ["Webkit", "ms", "Moz", "O"];
    Object.keys(tu).forEach(function(a) {
      vx.forEach(function(i) {
        tu[mx(i, a)] = tu[a];
      });
    });
    function Ap(a, i, f) {
      var v = i == null || typeof i == "boolean" || i === "";
      return v ? "" : !f && typeof i == "number" && i !== 0 && !(tu.hasOwnProperty(a) && tu[a]) ? i + "px" : (at(i, a), ("" + i).trim());
    }
    var nu = /([A-Z])/g, bE = /^ms-/;
    function xE(a) {
      return a.replace(nu, "-$1").toLowerCase().replace(bE, "-ms-");
    }
    var gx = function() {
    };
    {
      var yx = /^(?:webkit|moz|o)[A-Z]/, bx = /^-ms-/, Ad = /-(.)/g, ru = /;\s*$/, ou = {}, au = {}, xx = !1, og = !1, ag = function(a) {
        return a.replace(Ad, function(i, f) {
          return f.toUpperCase();
        });
      }, ig = function(a) {
        ou.hasOwnProperty(a) && ou[a] || (ou[a] = !0, u(
          "Unsupported style property %s. Did you mean %s?",
          a,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          ag(a.replace(bx, "ms-"))
        ));
      }, Sx = function(a) {
        ou.hasOwnProperty(a) && ou[a] || (ou[a] = !0, u("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
      }, Cx = function(a, i) {
        au.hasOwnProperty(i) && au[i] || (au[i] = !0, u(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, i.replace(ru, "")));
      }, wx = function(a, i) {
        xx || (xx = !0, u("`NaN` is an invalid value for the `%s` css style property.", a));
      }, SE = function(a, i) {
        og || (og = !0, u("`Infinity` is an invalid value for the `%s` css style property.", a));
      };
      gx = function(a, i) {
        a.indexOf("-") > -1 ? ig(a) : yx.test(a) ? Sx(a) : ru.test(i) && Cx(a, i), typeof i == "number" && (isNaN(i) ? wx(a, i) : isFinite(i) || SE(a, i));
      };
    }
    var CE = gx;
    function wE(a) {
      {
        var i = "", f = "";
        for (var v in a)
          if (a.hasOwnProperty(v)) {
            var y = a[v];
            if (y != null) {
              var w = v.indexOf("--") === 0;
              i += f + (w ? v : xE(v)) + ":", i += Ap(v, y, w), f = ";";
            }
          }
        return i || null;
      }
    }
    function Tx(a, i) {
      var f = a.style;
      for (var v in i)
        if (i.hasOwnProperty(v)) {
          var y = v.indexOf("--") === 0;
          y || CE(v, i[v]);
          var w = Ap(v, i[v], y);
          v === "float" && (v = "cssFloat"), y ? f.setProperty(v, w) : f[v] = w;
        }
    }
    function TE(a) {
      return a == null || typeof a == "boolean" || a === "";
    }
    function La(a) {
      var i = {};
      for (var f in a)
        for (var v = hx[f] || [f], y = 0; y < v.length; y++)
          i[v[y]] = f;
      return i;
    }
    function Ld(a, i) {
      {
        if (!i)
          return;
        var f = La(a), v = La(i), y = {};
        for (var w in f) {
          var M = f[w], j = v[w];
          if (j && M !== j) {
            var B = M + "," + j;
            if (y[B])
              continue;
            y[B] = !0, u("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", TE(a[M]) ? "Removing" : "Updating", M, j);
          }
        }
      }
    }
    var Ex = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Rx = pn({
      menuitem: !0
    }, Ex), Ox = "__html";
    function Lp(a, i) {
      if (i) {
        if (Rx[a] && (i.children != null || i.dangerouslySetInnerHTML != null))
          throw new Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (i.dangerouslySetInnerHTML != null) {
          if (i.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof i.dangerouslySetInnerHTML != "object" || !(Ox in i.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!i.suppressContentEditableWarning && i.contentEditable && i.children != null && u("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), i.style != null && typeof i.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Ts(a, i) {
      if (a.indexOf("-") === -1)
        return typeof i.is == "string";
      switch (a) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Fp = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Px = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, wi = {}, sg = new RegExp("^(aria)-[" + st + "]*$"), Fd = new RegExp("^(aria)[A-Z][" + st + "]*$");
    function lg(a, i) {
      {
        if (ye.call(wi, i) && wi[i])
          return !0;
        if (Fd.test(i)) {
          var f = "aria-" + i.slice(4).toLowerCase(), v = Px.hasOwnProperty(f) ? f : null;
          if (v == null)
            return u("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", i), wi[i] = !0, !0;
          if (i !== v)
            return u("Invalid ARIA attribute `%s`. Did you mean `%s`?", i, v), wi[i] = !0, !0;
        }
        if (sg.test(i)) {
          var y = i.toLowerCase(), w = Px.hasOwnProperty(y) ? y : null;
          if (w == null)
            return wi[i] = !0, !1;
          if (i !== w)
            return u("Unknown ARIA attribute `%s`. Did you mean `%s`?", i, w), wi[i] = !0, !0;
        }
      }
      return !0;
    }
    function $x(a, i) {
      {
        var f = [];
        for (var v in i) {
          var y = lg(a, v);
          y || f.push(v);
        }
        var w = f.map(function(M) {
          return "`" + M + "`";
        }).join(", ");
        f.length === 1 ? u("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", w, a) : f.length > 1 && u("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", w, a);
      }
    }
    function jp(a, i) {
      Ts(a, i) || $x(a, i);
    }
    var Jl = !1;
    function cg(a, i) {
      {
        if (a !== "input" && a !== "textarea" && a !== "select")
          return;
        i != null && i.value === null && !Jl && (Jl = !0, a === "select" && i.multiple ? u("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : u("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
      }
    }
    var ug = function() {
    };
    {
      var Kr = {}, dg = /^on./, Dx = /^on[^A-Z]/, kx = new RegExp("^(aria)-[" + st + "]*$"), Mx = new RegExp("^(aria)[A-Z][" + st + "]*$");
      ug = function(a, i, f, v) {
        if (ye.call(Kr, i) && Kr[i])
          return !0;
        var y = i.toLowerCase();
        if (y === "onfocusin" || y === "onfocusout")
          return u("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Kr[i] = !0, !0;
        if (v != null) {
          var w = v.registrationNameDependencies, M = v.possibleRegistrationNames;
          if (w.hasOwnProperty(i))
            return !0;
          var j = M.hasOwnProperty(y) ? M[y] : null;
          if (j != null)
            return u("Invalid event handler property `%s`. Did you mean `%s`?", i, j), Kr[i] = !0, !0;
          if (dg.test(i))
            return u("Unknown event handler property `%s`. It will be ignored.", i), Kr[i] = !0, !0;
        } else if (dg.test(i))
          return Dx.test(i) && u("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", i), Kr[i] = !0, !0;
        if (kx.test(i) || Mx.test(i))
          return !0;
        if (y === "innerhtml")
          return u("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Kr[i] = !0, !0;
        if (y === "aria")
          return u("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Kr[i] = !0, !0;
        if (y === "is" && f !== null && f !== void 0 && typeof f != "string")
          return u("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), Kr[i] = !0, !0;
        if (typeof f == "number" && isNaN(f))
          return u("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", i), Kr[i] = !0, !0;
        var B = tn(i), Q = B !== null && B.type === Nt;
        if (Fp.hasOwnProperty(y)) {
          var re = Fp[y];
          if (re !== i)
            return u("Invalid DOM property `%s`. Did you mean `%s`?", i, re), Kr[i] = !0, !0;
        } else if (!Q && i !== y)
          return u("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", i, y), Kr[i] = !0, !0;
        return typeof f == "boolean" && ct(i, f, B, !1) ? (f ? u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, i, i, f, i) : u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, i, i, f, i, i, i), Kr[i] = !0, !0) : Q ? !0 : ct(i, f, B, !1) ? (Kr[i] = !0, !1) : ((f === "false" || f === "true") && B !== null && B.type === ln && (u("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, i, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', i, f), Kr[i] = !0), !0);
      };
    }
    var Nx = function(a, i, f) {
      {
        var v = [];
        for (var y in i) {
          var w = ug(a, y, i[y], f);
          w || v.push(y);
        }
        var M = v.map(function(j) {
          return "`" + j + "`";
        }).join(", ");
        v.length === 1 ? u("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, a) : v.length > 1 && u("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, a);
      }
    };
    function Ix(a, i, f) {
      Ts(a, i) || Nx(a, i, f);
    }
    var Es = 1, jd = 2, Zl = 4, EE = Es | jd | Zl, Vd = null;
    function Bd(a) {
      Vd !== null && u("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Vd = a;
    }
    function RE() {
      Vd === null && u("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Vd = null;
    }
    function _x(a) {
      return a === Vd;
    }
    function Vp(a) {
      var i = a.target || a.srcElement || window;
      return i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === ws ? i.parentNode : i;
    }
    var qn = null, ll = null, Rs = null;
    function iu(a) {
      var i = ju(a);
      if (i) {
        if (typeof qn != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = i.stateNode;
        if (f) {
          var v = jS(f);
          qn(i.stateNode, i.type, v);
        }
      }
    }
    function Ax(a) {
      qn = a;
    }
    function Bp(a) {
      ll ? Rs ? Rs.push(a) : Rs = [a] : ll = a;
    }
    function zd() {
      return ll !== null || Rs !== null;
    }
    function Ud() {
      if (ll) {
        var a = ll, i = Rs;
        if (ll = null, Rs = null, iu(a), i)
          for (var f = 0; f < i.length; f++)
            iu(i[f]);
      }
    }
    var ec = function(a, i) {
      return a(i);
    }, fg = function() {
    }, pg = !1;
    function OE() {
      var a = zd();
      a && (fg(), Ud());
    }
    function hg(a, i, f) {
      if (pg)
        return a(i, f);
      pg = !0;
      try {
        return ec(a, i, f);
      } finally {
        pg = !1, OE();
      }
    }
    function zp(a, i, f) {
      ec = a, fg = f;
    }
    function Up(a) {
      return a === "button" || a === "input" || a === "select" || a === "textarea";
    }
    function mg(a, i, f) {
      switch (a) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Up(i));
        default:
          return !1;
      }
    }
    function tc(a, i) {
      var f = a.stateNode;
      if (f === null)
        return null;
      var v = jS(f);
      if (v === null)
        return null;
      var y = v[i];
      if (mg(i, a.type, v))
        return null;
      if (y && typeof y != "function")
        throw new Error("Expected `" + i + "` listener to be a function, instead got a value of `" + typeof y + "` type.");
      return y;
    }
    var Hd = !1;
    if (fe)
      try {
        var nc = {};
        Object.defineProperty(nc, "passive", {
          get: function() {
            Hd = !0;
          }
        }), window.addEventListener("test", nc, nc), window.removeEventListener("test", nc, nc);
      } catch {
        Hd = !1;
      }
    function Lx(a, i, f, v, y, w, M, j, B) {
      var Q = Array.prototype.slice.call(arguments, 3);
      try {
        i.apply(f, Q);
      } catch (re) {
        this.onError(re);
      }
    }
    var vg = Lx;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var gg = document.createElement("react");
      vg = function(i, f, v, y, w, M, j, B, Q) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var re = document.createEvent("Event"), Ce = !1, xe = !0, Le = window.event, je = Object.getOwnPropertyDescriptor(window, "event");
        function Ue() {
          gg.removeEventListener(He, Ht, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Le);
        }
        var gt = Array.prototype.slice.call(arguments, 3);
        function Ht() {
          Ce = !0, Ue(), f.apply(v, gt), xe = !1;
        }
        var Ft, yn = !1, mn = !1;
        function ke(Me) {
          if (Ft = Me.error, yn = !0, Ft === null && Me.colno === 0 && Me.lineno === 0 && (mn = !0), Me.defaultPrevented && Ft != null && typeof Ft == "object")
            try {
              Ft._suppressLogging = !0;
            } catch {
            }
        }
        var He = "react-" + (i || "invokeguardedcallback");
        if (window.addEventListener("error", ke), gg.addEventListener(He, Ht, !1), re.initEvent(He, !1, !1), gg.dispatchEvent(re), je && Object.defineProperty(window, "event", je), Ce && xe && (yn ? mn && (Ft = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ft = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ft)), window.removeEventListener("error", ke), !Ce)
          return Ue(), Lx.apply(this, arguments);
      };
    }
    var PE = vg, cl = !1, Ti = null, Wd = !1, ul = null, Bi = {
      onError: function(a) {
        cl = !0, Ti = a;
      }
    };
    function rc(a, i, f, v, y, w, M, j, B) {
      cl = !1, Ti = null, PE.apply(Bi, arguments);
    }
    function Os(a, i, f, v, y, w, M, j, B) {
      if (rc.apply(this, arguments), cl) {
        var Q = bg();
        Wd || (Wd = !0, ul = Q);
      }
    }
    function yg() {
      if (Wd) {
        var a = ul;
        throw Wd = !1, ul = null, a;
      }
    }
    function $E() {
      return cl;
    }
    function bg() {
      if (cl) {
        var a = Ti;
        return cl = !1, Ti = null, a;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Fa(a) {
      return a._reactInternals;
    }
    function qd(a) {
      return a._reactInternals !== void 0;
    }
    function su(a, i) {
      a._reactInternals = i;
    }
    var Ut = (
      /*                      */
      0
    ), dl = (
      /*                */
      1
    ), Jn = (
      /*                    */
      2
    ), an = (
      /*                       */
      4
    ), On = (
      /*                */
      16
    ), Pn = (
      /*                 */
      32
    ), zi = (
      /*                     */
      64
    ), Kt = (
      /*                   */
      128
    ), vr = (
      /*            */
      256
    ), Qo = (
      /*                          */
      512
    ), ja = (
      /*                     */
      1024
    ), or = (
      /*                      */
      2048
    ), Va = (
      /*                    */
      4096
    ), fl = (
      /*                   */
      8192
    ), Yd = (
      /*             */
      16384
    ), Hp = or | an | zi | Qo | ja | Yd, Fx = (
      /*               */
      32767
    ), va = (
      /*                   */
      32768
    ), Xr = (
      /*                */
      65536
    ), Gd = (
      /* */
      131072
    ), xg = (
      /*                       */
      1048576
    ), Sg = (
      /*                    */
      2097152
    ), Jo = (
      /*                 */
      4194304
    ), pl = (
      /*                */
      8388608
    ), Zo = (
      /*               */
      16777216
    ), oc = (
      /*              */
      33554432
    ), lu = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      an | ja | 0
    ), ea = Jn | an | On | Pn | Qo | Va | fl, Co = an | zi | Qo | fl, Ba = or | On, ao = Jo | pl | Sg, Ps = n.ReactCurrentOwner;
    function ga(a) {
      var i = a, f = a;
      if (a.alternate)
        for (; i.return; )
          i = i.return;
      else {
        var v = i;
        do
          i = v, (i.flags & (Jn | Va)) !== Ut && (f = i.return), v = i.return;
        while (v);
      }
      return i.tag === x ? f : null;
    }
    function Cg(a) {
      if (a.tag === N) {
        var i = a.memoizedState;
        if (i === null) {
          var f = a.alternate;
          f !== null && (i = f.memoizedState);
        }
        if (i !== null)
          return i.dehydrated;
      }
      return null;
    }
    function Wp(a) {
      return a.tag === x ? a.stateNode.containerInfo : null;
    }
    function wg(a) {
      return ga(a) === a;
    }
    function ya(a) {
      {
        var i = Ps.current;
        if (i !== null && i.tag === m) {
          var f = i, v = f.stateNode;
          v._warnedAboutRefsInRender || u("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", nn(f) || "A component"), v._warnedAboutRefsInRender = !0;
        }
      }
      var y = Fa(a);
      return y ? ga(y) === y : !1;
    }
    function ta(a) {
      if (ga(a) !== a)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Zn(a) {
      var i = a.alternate;
      if (!i) {
        var f = ga(a);
        if (f === null)
          throw new Error("Unable to find node on an unmounted component.");
        return f !== a ? null : a;
      }
      for (var v = a, y = i; ; ) {
        var w = v.return;
        if (w === null)
          break;
        var M = w.alternate;
        if (M === null) {
          var j = w.return;
          if (j !== null) {
            v = y = j;
            continue;
          }
          break;
        }
        if (w.child === M.child) {
          for (var B = w.child; B; ) {
            if (B === v)
              return ta(w), a;
            if (B === y)
              return ta(w), i;
            B = B.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (v.return !== y.return)
          v = w, y = M;
        else {
          for (var Q = !1, re = w.child; re; ) {
            if (re === v) {
              Q = !0, v = w, y = M;
              break;
            }
            if (re === y) {
              Q = !0, y = w, v = M;
              break;
            }
            re = re.sibling;
          }
          if (!Q) {
            for (re = M.child; re; ) {
              if (re === v) {
                Q = !0, v = M, y = w;
                break;
              }
              if (re === y) {
                Q = !0, y = M, v = w;
                break;
              }
              re = re.sibling;
            }
            if (!Q)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (v.alternate !== y)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (v.tag !== x)
        throw new Error("Unable to find node on an unmounted component.");
      return v.stateNode.current === v ? a : i;
    }
    function za(a) {
      var i = Zn(a);
      return i !== null ? Tg(i) : null;
    }
    function Tg(a) {
      if (a.tag === R || a.tag === T)
        return a;
      for (var i = a.child; i !== null; ) {
        var f = Tg(i);
        if (f !== null)
          return f;
        i = i.sibling;
      }
      return null;
    }
    function jx(a) {
      var i = Zn(a);
      return i !== null ? qp(i) : null;
    }
    function qp(a) {
      if (a.tag === R || a.tag === T)
        return a;
      for (var i = a.child; i !== null; ) {
        if (i.tag !== S) {
          var f = qp(i);
          if (f !== null)
            return f;
        }
        i = i.sibling;
      }
      return null;
    }
    var Yp = t.unstable_scheduleCallback, Vx = t.unstable_cancelCallback, Gp = t.unstable_shouldYield, Bx = t.unstable_requestPaint, cr = t.unstable_now, Eg = t.unstable_getCurrentPriorityLevel, Kp = t.unstable_ImmediatePriority, ac = t.unstable_UserBlockingPriority, Ui = t.unstable_NormalPriority, zx = t.unstable_LowPriority, Xp = t.unstable_IdlePriority, cu = t.unstable_yieldValue, Ux = t.unstable_setDisableYieldValue, $s = null, jr = null, ut = null, Ua = !1, ba = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Rg(a) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var i = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (i.isDisabled)
        return !0;
      if (!i.supportsFiber)
        return u("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        de && (a = pn({}, a, {
          getLaneLabelMap: Ds,
          injectProfilingHooks: Hx
        })), $s = i.inject(a), jr = i;
      } catch (f) {
        u("React instrumentation encountered an error: %s.", f);
      }
      return !!i.checkDCE;
    }
    function Og(a, i) {
      if (jr && typeof jr.onScheduleFiberRoot == "function")
        try {
          jr.onScheduleFiberRoot($s, a, i);
        } catch (f) {
          Ua || (Ua = !0, u("React instrumentation encountered an error: %s", f));
        }
    }
    function uu(a, i) {
      if (jr && typeof jr.onCommitFiberRoot == "function")
        try {
          var f = (a.current.flags & Kt) === Kt;
          if (se) {
            var v;
            switch (i) {
              case Tr:
                v = Kp;
                break;
              case Ms:
                v = ac;
                break;
              case Hi:
                v = Ui;
                break;
              case Cu:
                v = Xp;
                break;
              default:
                v = Ui;
                break;
            }
            jr.onCommitFiberRoot($s, a, v, f);
          }
        } catch (y) {
          Ua || (Ua = !0, u("React instrumentation encountered an error: %s", y));
        }
    }
    function Ha(a) {
      if (jr && typeof jr.onPostCommitFiberRoot == "function")
        try {
          jr.onPostCommitFiberRoot($s, a);
        } catch (i) {
          Ua || (Ua = !0, u("React instrumentation encountered an error: %s", i));
        }
    }
    function ic(a) {
      if (jr && typeof jr.onCommitFiberUnmount == "function")
        try {
          jr.onCommitFiberUnmount($s, a);
        } catch (i) {
          Ua || (Ua = !0, u("React instrumentation encountered an error: %s", i));
        }
    }
    function Dr(a) {
      if (typeof cu == "function" && (Ux(a), s(a)), jr && typeof jr.setStrictMode == "function")
        try {
          jr.setStrictMode($s, a);
        } catch (i) {
          Ua || (Ua = !0, u("React instrumentation encountered an error: %s", i));
        }
    }
    function Hx(a) {
      ut = a;
    }
    function Ds() {
      {
        for (var a = /* @__PURE__ */ new Map(), i = 1, f = 0; f < Zd; f++) {
          var v = kE(i);
          a.set(i, v), i *= 2;
        }
        return a;
      }
    }
    function hl(a) {
      ut !== null && typeof ut.markCommitStarted == "function" && ut.markCommitStarted(a);
    }
    function Qp() {
      ut !== null && typeof ut.markCommitStopped == "function" && ut.markCommitStopped();
    }
    function du(a) {
      ut !== null && typeof ut.markComponentRenderStarted == "function" && ut.markComponentRenderStarted(a);
    }
    function na() {
      ut !== null && typeof ut.markComponentRenderStopped == "function" && ut.markComponentRenderStopped();
    }
    function ml(a) {
      ut !== null && typeof ut.markComponentPassiveEffectMountStarted == "function" && ut.markComponentPassiveEffectMountStarted(a);
    }
    function Jp() {
      ut !== null && typeof ut.markComponentPassiveEffectMountStopped == "function" && ut.markComponentPassiveEffectMountStopped();
    }
    function Wx(a) {
      ut !== null && typeof ut.markComponentPassiveEffectUnmountStarted == "function" && ut.markComponentPassiveEffectUnmountStarted(a);
    }
    function Zp() {
      ut !== null && typeof ut.markComponentPassiveEffectUnmountStopped == "function" && ut.markComponentPassiveEffectUnmountStopped();
    }
    function qx(a) {
      ut !== null && typeof ut.markComponentLayoutEffectMountStarted == "function" && ut.markComponentLayoutEffectMountStarted(a);
    }
    function Kd() {
      ut !== null && typeof ut.markComponentLayoutEffectMountStopped == "function" && ut.markComponentLayoutEffectMountStopped();
    }
    function Ei(a) {
      ut !== null && typeof ut.markComponentLayoutEffectUnmountStarted == "function" && ut.markComponentLayoutEffectUnmountStarted(a);
    }
    function fu() {
      ut !== null && typeof ut.markComponentLayoutEffectUnmountStopped == "function" && ut.markComponentLayoutEffectUnmountStopped();
    }
    function Xd(a, i, f) {
      ut !== null && typeof ut.markComponentErrored == "function" && ut.markComponentErrored(a, i, f);
    }
    function sc(a, i, f) {
      ut !== null && typeof ut.markComponentSuspended == "function" && ut.markComponentSuspended(a, i, f);
    }
    function Pg(a) {
      ut !== null && typeof ut.markLayoutEffectsStarted == "function" && ut.markLayoutEffectsStarted(a);
    }
    function pu() {
      ut !== null && typeof ut.markLayoutEffectsStopped == "function" && ut.markLayoutEffectsStopped();
    }
    function Yx(a) {
      ut !== null && typeof ut.markPassiveEffectsStarted == "function" && ut.markPassiveEffectsStarted(a);
    }
    function $g() {
      ut !== null && typeof ut.markPassiveEffectsStopped == "function" && ut.markPassiveEffectsStopped();
    }
    function ar(a) {
      ut !== null && typeof ut.markRenderStarted == "function" && ut.markRenderStarted(a);
    }
    function eh() {
      ut !== null && typeof ut.markRenderYielded == "function" && ut.markRenderYielded();
    }
    function th() {
      ut !== null && typeof ut.markRenderStopped == "function" && ut.markRenderStopped();
    }
    function Dg(a) {
      ut !== null && typeof ut.markRenderScheduled == "function" && ut.markRenderScheduled(a);
    }
    function nh(a, i) {
      ut !== null && typeof ut.markForceUpdateScheduled == "function" && ut.markForceUpdateScheduled(a, i);
    }
    function Qd(a, i) {
      ut !== null && typeof ut.markStateUpdateScheduled == "function" && ut.markStateUpdateScheduled(a, i);
    }
    var _t = (
      /*                         */
      0
    ), Lt = (
      /*                 */
      1
    ), Xt = (
      /*                    */
      2
    ), un = (
      /*               */
      8
    ), xa = (
      /*              */
      16
    ), hu = Math.clz32 ? Math.clz32 : wo, Jd = Math.log, DE = Math.LN2;
    function wo(a) {
      var i = a >>> 0;
      return i === 0 ? 32 : 31 - (Jd(i) / DE | 0) | 0;
    }
    var Zd = 31, Ge = (
      /*                        */
      0
    ), kr = (
      /*                          */
      0
    ), Bt = (
      /*                        */
      1
    ), io = (
      /*    */
      2
    ), Sa = (
      /*             */
      4
    ), ks = (
      /*            */
      8
    ), Wa = (
      /*                     */
      16
    ), mu = (
      /*                */
      32
    ), lc = (
      /*                       */
      4194240
    ), vu = (
      /*                        */
      64
    ), rh = (
      /*                        */
      128
    ), oh = (
      /*                        */
      256
    ), ah = (
      /*                        */
      512
    ), ih = (
      /*                        */
      1024
    ), sh = (
      /*                        */
      2048
    ), cc = (
      /*                        */
      4096
    ), lh = (
      /*                        */
      8192
    ), gu = (
      /*                        */
      16384
    ), yu = (
      /*                       */
      32768
    ), ch = (
      /*                       */
      65536
    ), ef = (
      /*                       */
      131072
    ), uh = (
      /*                       */
      262144
    ), dh = (
      /*                       */
      524288
    ), fh = (
      /*                       */
      1048576
    ), ph = (
      /*                       */
      2097152
    ), bu = (
      /*                            */
      130023424
    ), uc = (
      /*                             */
      4194304
    ), hh = (
      /*                             */
      8388608
    ), mh = (
      /*                             */
      16777216
    ), kg = (
      /*                             */
      33554432
    ), vh = (
      /*                             */
      67108864
    ), Gx = uc, tf = (
      /*          */
      134217728
    ), Mg = (
      /*                          */
      268435455
    ), xu = (
      /*               */
      268435456
    ), vl = (
      /*                        */
      536870912
    ), To = (
      /*                   */
      1073741824
    );
    function kE(a) {
      {
        if (a & Bt)
          return "Sync";
        if (a & io)
          return "InputContinuousHydration";
        if (a & Sa)
          return "InputContinuous";
        if (a & ks)
          return "DefaultHydration";
        if (a & Wa)
          return "Default";
        if (a & mu)
          return "TransitionHydration";
        if (a & lc)
          return "Transition";
        if (a & bu)
          return "Retry";
        if (a & tf)
          return "SelectiveHydration";
        if (a & xu)
          return "IdleHydration";
        if (a & vl)
          return "Idle";
        if (a & To)
          return "Offscreen";
      }
    }
    var Xn = -1, gh = vu, ra = uc;
    function dc(a) {
      switch (wr(a)) {
        case Bt:
          return Bt;
        case io:
          return io;
        case Sa:
          return Sa;
        case ks:
          return ks;
        case Wa:
          return Wa;
        case mu:
          return mu;
        case vu:
        case rh:
        case oh:
        case ah:
        case ih:
        case sh:
        case cc:
        case lh:
        case gu:
        case yu:
        case ch:
        case ef:
        case uh:
        case dh:
        case fh:
        case ph:
          return a & lc;
        case uc:
        case hh:
        case mh:
        case kg:
        case vh:
          return a & bu;
        case tf:
          return tf;
        case xu:
          return xu;
        case vl:
          return vl;
        case To:
          return To;
        default:
          return u("Should have found matching lanes. This is a bug in React."), a;
      }
    }
    function fc(a, i) {
      var f = a.pendingLanes;
      if (f === Ge)
        return Ge;
      var v = Ge, y = a.suspendedLanes, w = a.pingedLanes, M = f & Mg;
      if (M !== Ge) {
        var j = M & ~y;
        if (j !== Ge)
          v = dc(j);
        else {
          var B = M & w;
          B !== Ge && (v = dc(B));
        }
      } else {
        var Q = f & ~y;
        Q !== Ge ? v = dc(Q) : w !== Ge && (v = dc(w));
      }
      if (v === Ge)
        return Ge;
      if (i !== Ge && i !== v && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (i & y) === Ge) {
        var re = wr(v), Ce = wr(i);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          re >= Ce || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          re === Wa && (Ce & lc) !== Ge
        )
          return i;
      }
      (v & Sa) !== Ge && (v |= f & Wa);
      var xe = a.entangledLanes;
      if (xe !== Ge)
        for (var Le = a.entanglements, je = v & xe; je > 0; ) {
          var Ue = yl(je), gt = 1 << Ue;
          v |= Le[Ue], je &= ~gt;
        }
      return v;
    }
    function Kx(a, i) {
      for (var f = a.eventTimes, v = Xn; i > 0; ) {
        var y = yl(i), w = 1 << y, M = f[y];
        M > v && (v = M), i &= ~w;
      }
      return v;
    }
    function Xx(a, i) {
      switch (a) {
        case Bt:
        case io:
        case Sa:
          return i + 250;
        case ks:
        case Wa:
        case mu:
        case vu:
        case rh:
        case oh:
        case ah:
        case ih:
        case sh:
        case cc:
        case lh:
        case gu:
        case yu:
        case ch:
        case ef:
        case uh:
        case dh:
        case fh:
        case ph:
          return i + 5e3;
        case uc:
        case hh:
        case mh:
        case kg:
        case vh:
          return Xn;
        case tf:
        case xu:
        case vl:
        case To:
          return Xn;
        default:
          return u("Should have found matching lanes. This is a bug in React."), Xn;
      }
    }
    function Qx(a, i) {
      for (var f = a.pendingLanes, v = a.suspendedLanes, y = a.pingedLanes, w = a.expirationTimes, M = f; M > 0; ) {
        var j = yl(M), B = 1 << j, Q = w[j];
        Q === Xn ? ((B & v) === Ge || (B & y) !== Ge) && (w[j] = Xx(B, i)) : Q <= i && (a.expiredLanes |= B), M &= ~B;
      }
    }
    function Ng(a) {
      return dc(a.pendingLanes);
    }
    function gl(a) {
      var i = a.pendingLanes & ~To;
      return i !== Ge ? i : i & To ? To : Ge;
    }
    function Ig(a) {
      return (a & Bt) !== Ge;
    }
    function nf(a) {
      return (a & Mg) !== Ge;
    }
    function Jx(a) {
      return (a & bu) === a;
    }
    function Zx(a) {
      var i = Bt | Sa | Wa;
      return (a & i) === Ge;
    }
    function eS(a) {
      return (a & lc) === a;
    }
    function rf(a, i) {
      var f = io | Sa | ks | Wa;
      return (i & f) !== Ge;
    }
    function tS(a, i) {
      return (i & a.expiredLanes) !== Ge;
    }
    function _g(a) {
      return (a & lc) !== Ge;
    }
    function nS() {
      var a = gh;
      return gh <<= 1, (gh & lc) === Ge && (gh = vu), a;
    }
    function oa() {
      var a = ra;
      return ra <<= 1, (ra & bu) === Ge && (ra = uc), a;
    }
    function wr(a) {
      return a & -a;
    }
    function Su(a) {
      return wr(a);
    }
    function yl(a) {
      return 31 - hu(a);
    }
    function yh(a) {
      return yl(a);
    }
    function aa(a, i) {
      return (a & i) !== Ge;
    }
    function pc(a, i) {
      return (a & i) === i;
    }
    function rn(a, i) {
      return a | i;
    }
    function of(a, i) {
      return a & ~i;
    }
    function bh(a, i) {
      return a & i;
    }
    function ME(a) {
      return a;
    }
    function rS(a, i) {
      return a !== kr && a < i ? a : i;
    }
    function af(a) {
      for (var i = [], f = 0; f < Zd; f++)
        i.push(a);
      return i;
    }
    function hc(a, i, f) {
      a.pendingLanes |= i, i !== vl && (a.suspendedLanes = Ge, a.pingedLanes = Ge);
      var v = a.eventTimes, y = yh(i);
      v[y] = f;
    }
    function oS(a, i) {
      a.suspendedLanes |= i, a.pingedLanes &= ~i;
      for (var f = a.expirationTimes, v = i; v > 0; ) {
        var y = yl(v), w = 1 << y;
        f[y] = Xn, v &= ~w;
      }
    }
    function xh(a, i, f) {
      a.pingedLanes |= a.suspendedLanes & i;
    }
    function Sh(a, i) {
      var f = a.pendingLanes & ~i;
      a.pendingLanes = i, a.suspendedLanes = Ge, a.pingedLanes = Ge, a.expiredLanes &= i, a.mutableReadLanes &= i, a.entangledLanes &= i;
      for (var v = a.entanglements, y = a.eventTimes, w = a.expirationTimes, M = f; M > 0; ) {
        var j = yl(M), B = 1 << j;
        v[j] = Ge, y[j] = Xn, w[j] = Xn, M &= ~B;
      }
    }
    function Ag(a, i) {
      for (var f = a.entangledLanes |= i, v = a.entanglements, y = f; y; ) {
        var w = yl(y), M = 1 << w;
        // Is this one of the newly entangled lanes?
        M & i | // Is this lane transitively entangled with the newly entangled lanes?
        v[w] & i && (v[w] |= i), y &= ~M;
      }
    }
    function aS(a, i) {
      var f = wr(i), v;
      switch (f) {
        case Sa:
          v = io;
          break;
        case Wa:
          v = ks;
          break;
        case vu:
        case rh:
        case oh:
        case ah:
        case ih:
        case sh:
        case cc:
        case lh:
        case gu:
        case yu:
        case ch:
        case ef:
        case uh:
        case dh:
        case fh:
        case ph:
        case uc:
        case hh:
        case mh:
        case kg:
        case vh:
          v = mu;
          break;
        case vl:
          v = xu;
          break;
        default:
          v = kr;
          break;
      }
      return (v & (a.suspendedLanes | i)) !== kr ? kr : v;
    }
    function Ch(a, i, f) {
      if (ba)
        for (var v = a.pendingUpdatersLaneMap; f > 0; ) {
          var y = yh(f), w = 1 << y, M = v[y];
          M.add(i), f &= ~w;
        }
    }
    function Lg(a, i) {
      if (ba)
        for (var f = a.pendingUpdatersLaneMap, v = a.memoizedUpdaters; i > 0; ) {
          var y = yh(i), w = 1 << y, M = f[y];
          M.size > 0 && (M.forEach(function(j) {
            var B = j.alternate;
            (B === null || !v.has(B)) && v.add(j);
          }), M.clear()), i &= ~w;
        }
    }
    function sf(a, i) {
      return null;
    }
    var Tr = Bt, Ms = Sa, Hi = Wa, Cu = vl, wu = kr;
    function qa() {
      return wu;
    }
    function gr(a) {
      wu = a;
    }
    function Eo(a, i) {
      var f = wu;
      try {
        return wu = a, i();
      } finally {
        wu = f;
      }
    }
    function NE(a, i) {
      return a !== 0 && a < i ? a : i;
    }
    function IE(a, i) {
      return a > i ? a : i;
    }
    function Tu(a, i) {
      return a !== 0 && a < i;
    }
    function so(a) {
      var i = wr(a);
      return Tu(Tr, i) ? Tu(Ms, i) ? nf(i) ? Hi : Cu : Ms : Tr;
    }
    function wh(a) {
      var i = a.current.memoizedState;
      return i.isDehydrated;
    }
    var Ot;
    function Eu(a) {
      Ot = a;
    }
    function Fg(a) {
      Ot(a);
    }
    var Th;
    function _E(a) {
      Th = a;
    }
    var Ru;
    function Eh(a) {
      Ru = a;
    }
    var Rh;
    function iS(a) {
      Rh = a;
    }
    var jg;
    function sS(a) {
      jg = a;
    }
    var lf = !1, Ou = [], ir = null, Qr = null, Io = null, Pu = /* @__PURE__ */ new Map(), $u = /* @__PURE__ */ new Map(), Jr = [], lS = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Wi(a) {
      return lS.indexOf(a) > -1;
    }
    function AE(a, i, f, v, y) {
      return {
        blockedOn: a,
        domEventName: i,
        eventSystemFlags: f,
        nativeEvent: y,
        targetContainers: [v]
      };
    }
    function Vg(a, i) {
      switch (a) {
        case "focusin":
        case "focusout":
          ir = null;
          break;
        case "dragenter":
        case "dragleave":
          Qr = null;
          break;
        case "mouseover":
        case "mouseout":
          Io = null;
          break;
        case "pointerover":
        case "pointerout": {
          var f = i.pointerId;
          Pu.delete(f);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var v = i.pointerId;
          $u.delete(v);
          break;
        }
      }
    }
    function Du(a, i, f, v, y, w) {
      if (a === null || a.nativeEvent !== w) {
        var M = AE(i, f, v, y, w);
        if (i !== null) {
          var j = ju(i);
          j !== null && Th(j);
        }
        return M;
      }
      a.eventSystemFlags |= v;
      var B = a.targetContainers;
      return y !== null && B.indexOf(y) === -1 && B.push(y), a;
    }
    function cS(a, i, f, v, y) {
      switch (i) {
        case "focusin": {
          var w = y;
          return ir = Du(ir, a, i, f, v, w), !0;
        }
        case "dragenter": {
          var M = y;
          return Qr = Du(Qr, a, i, f, v, M), !0;
        }
        case "mouseover": {
          var j = y;
          return Io = Du(Io, a, i, f, v, j), !0;
        }
        case "pointerover": {
          var B = y, Q = B.pointerId;
          return Pu.set(Q, Du(Pu.get(Q) || null, a, i, f, v, B)), !0;
        }
        case "gotpointercapture": {
          var re = y, Ce = re.pointerId;
          return $u.set(Ce, Du($u.get(Ce) || null, a, i, f, v, re)), !0;
        }
      }
      return !1;
    }
    function Bg(a) {
      var i = xf(a.target);
      if (i !== null) {
        var f = ga(i);
        if (f !== null) {
          var v = f.tag;
          if (v === N) {
            var y = Cg(f);
            if (y !== null) {
              a.blockedOn = y, jg(a.priority, function() {
                Ru(f);
              });
              return;
            }
          } else if (v === x) {
            var w = f.stateNode;
            if (wh(w)) {
              a.blockedOn = Wp(f);
              return;
            }
          }
        }
      }
      a.blockedOn = null;
    }
    function LE(a) {
      for (var i = Rh(), f = {
        blockedOn: null,
        target: a,
        priority: i
      }, v = 0; v < Jr.length && Tu(i, Jr[v].priority); v++)
        ;
      Jr.splice(v, 0, f), v === 0 && Bg(f);
    }
    function mc(a) {
      if (a.blockedOn !== null)
        return !1;
      for (var i = a.targetContainers; i.length > 0; ) {
        var f = i[0], v = Ro(a.domEventName, a.eventSystemFlags, f, a.nativeEvent);
        if (v === null) {
          var y = a.nativeEvent, w = new y.constructor(y.type, y);
          Bd(w), y.target.dispatchEvent(w), RE();
        } else {
          var M = ju(v);
          return M !== null && Th(M), a.blockedOn = v, !1;
        }
        i.shift();
      }
      return !0;
    }
    function Oh(a, i, f) {
      mc(a) && f.delete(i);
    }
    function Ya() {
      lf = !1, ir !== null && mc(ir) && (ir = null), Qr !== null && mc(Qr) && (Qr = null), Io !== null && mc(Io) && (Io = null), Pu.forEach(Oh), $u.forEach(Oh);
    }
    function hn(a, i) {
      a.blockedOn === i && (a.blockedOn = null, lf || (lf = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Ya)));
    }
    function yr(a) {
      if (Ou.length > 0) {
        hn(Ou[0], a);
        for (var i = 1; i < Ou.length; i++) {
          var f = Ou[i];
          f.blockedOn === a && (f.blockedOn = null);
        }
      }
      ir !== null && hn(ir, a), Qr !== null && hn(Qr, a), Io !== null && hn(Io, a);
      var v = function(j) {
        return hn(j, a);
      };
      Pu.forEach(v), $u.forEach(v);
      for (var y = 0; y < Jr.length; y++) {
        var w = Jr[y];
        w.blockedOn === a && (w.blockedOn = null);
      }
      for (; Jr.length > 0; ) {
        var M = Jr[0];
        if (M.blockedOn !== null)
          break;
        Bg(M), M.blockedOn === null && Jr.shift();
      }
    }
    var er = n.ReactCurrentBatchConfig, Vr = !0;
    function ia(a) {
      Vr = !!a;
    }
    function ku() {
      return Vr;
    }
    function Br(a, i, f) {
      var v = Ph(i), y;
      switch (v) {
        case Tr:
          y = cf;
          break;
        case Ms:
          y = vc;
          break;
        case Hi:
        default:
          y = Mu;
          break;
      }
      return y.bind(null, i, f, a);
    }
    function cf(a, i, f, v) {
      var y = qa(), w = er.transition;
      er.transition = null;
      try {
        gr(Tr), Mu(a, i, f, v);
      } finally {
        gr(y), er.transition = w;
      }
    }
    function vc(a, i, f, v) {
      var y = qa(), w = er.transition;
      er.transition = null;
      try {
        gr(Ms), Mu(a, i, f, v);
      } finally {
        gr(y), er.transition = w;
      }
    }
    function Mu(a, i, f, v) {
      Vr && zg(a, i, f, v);
    }
    function zg(a, i, f, v) {
      var y = Ro(a, i, f, v);
      if (y === null) {
        eR(a, i, v, bl, f), Vg(a, v);
        return;
      }
      if (cS(y, a, i, f, v)) {
        v.stopPropagation();
        return;
      }
      if (Vg(a, v), i & Zl && Wi(a)) {
        for (; y !== null; ) {
          var w = ju(y);
          w !== null && Fg(w);
          var M = Ro(a, i, f, v);
          if (M === null && eR(a, i, v, bl, f), M === y)
            break;
          y = M;
        }
        y !== null && v.stopPropagation();
        return;
      }
      eR(a, i, v, null, f);
    }
    var bl = null;
    function Ro(a, i, f, v) {
      bl = null;
      var y = Vp(v), w = xf(y);
      if (w !== null) {
        var M = ga(w);
        if (M === null)
          w = null;
        else {
          var j = M.tag;
          if (j === N) {
            var B = Cg(M);
            if (B !== null)
              return B;
            w = null;
          } else if (j === x) {
            var Q = M.stateNode;
            if (wh(Q))
              return Wp(M);
            w = null;
          } else M !== w && (w = null);
        }
      }
      return bl = w, null;
    }
    function Ph(a) {
      switch (a) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Tr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ms;
        case "message": {
          var i = Eg();
          switch (i) {
            case Kp:
              return Tr;
            case ac:
              return Ms;
            case Ui:
            case zx:
              return Hi;
            case Xp:
              return Cu;
            default:
              return Hi;
          }
        }
        default:
          return Hi;
      }
    }
    function Nu(a, i, f) {
      return a.addEventListener(i, f, !1), f;
    }
    function Ns(a, i, f) {
      return a.addEventListener(i, f, !0), f;
    }
    function $h(a, i, f, v) {
      return a.addEventListener(i, f, {
        capture: !0,
        passive: v
      }), f;
    }
    function Ug(a, i, f, v) {
      return a.addEventListener(i, f, {
        passive: v
      }), f;
    }
    var Ga = null, Iu = null, Ka = null;
    function Dh(a) {
      return Ga = a, Iu = df(), !0;
    }
    function uf() {
      Ga = null, Iu = null, Ka = null;
    }
    function kh() {
      if (Ka)
        return Ka;
      var a, i = Iu, f = i.length, v, y = df(), w = y.length;
      for (a = 0; a < f && i[a] === y[a]; a++)
        ;
      var M = f - a;
      for (v = 1; v <= M && i[f - v] === y[w - v]; v++)
        ;
      var j = v > 1 ? 1 - v : void 0;
      return Ka = y.slice(a, j), Ka;
    }
    function df() {
      return "value" in Ga ? Ga.value : Ga.textContent;
    }
    function gc(a) {
      var i, f = a.keyCode;
      return "charCode" in a ? (i = a.charCode, i === 0 && f === 13 && (i = 13)) : i = f, i === 10 && (i = 13), i >= 32 || i === 13 ? i : 0;
    }
    function Zr() {
      return !0;
    }
    function Is() {
      return !1;
    }
    function ur(a) {
      function i(f, v, y, w, M) {
        this._reactName = f, this._targetInst = y, this.type = v, this.nativeEvent = w, this.target = M, this.currentTarget = null;
        for (var j in a)
          if (a.hasOwnProperty(j)) {
            var B = a[j];
            B ? this[j] = B(w) : this[j] = w[j];
          }
        var Q = w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1;
        return Q ? this.isDefaultPrevented = Zr : this.isDefaultPrevented = Is, this.isPropagationStopped = Is, this;
      }
      return pn(i.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = Zr);
        },
        stopPropagation: function() {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = Zr);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Zr
      }), i;
    }
    var zr = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(a) {
        return a.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Mh = ur(zr), yc = pn({}, zr, {
      view: 0,
      detail: 0
    }), Hg = ur(yc), Wg, qi, _u;
    function qg(a) {
      a !== _u && (_u && a.type === "mousemove" ? (Wg = a.screenX - _u.screenX, qi = a.screenY - _u.screenY) : (Wg = 0, qi = 0), _u = a);
    }
    var Yi = pn({}, yc, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Yg,
      button: 0,
      buttons: 0,
      relatedTarget: function(a) {
        return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
      },
      movementX: function(a) {
        return "movementX" in a ? a.movementX : (qg(a), Wg);
      },
      movementY: function(a) {
        return "movementY" in a ? a.movementY : qi;
      }
    }), Nh = ur(Yi), bc = pn({}, Yi, {
      dataTransfer: 0
    }), uS = ur(bc), dS = pn({}, yc, {
      relatedTarget: 0
    }), ff = ur(dS), Ih = pn({}, zr, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), FE = ur(Ih), jE = pn({}, zr, {
      clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
      }
    }), fS = ur(jE), pS = pn({}, zr, {
      data: 0
    }), xl = ur(pS), VE = xl, Au = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, hS = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function br(a) {
      if (a.key) {
        var i = Au[a.key] || a.key;
        if (i !== "Unidentified")
          return i;
      }
      if (a.type === "keypress") {
        var f = gc(a);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return a.type === "keydown" || a.type === "keyup" ? hS[a.keyCode] || "Unidentified" : "";
    }
    var BE = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function mS(a) {
      var i = this, f = i.nativeEvent;
      if (f.getModifierState)
        return f.getModifierState(a);
      var v = BE[a];
      return v ? !!f[v] : !1;
    }
    function Yg(a) {
      return mS;
    }
    var zE = pn({}, yc, {
      key: br,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Yg,
      // Legacy Interface
      charCode: function(a) {
        return a.type === "keypress" ? gc(a) : 0;
      },
      keyCode: function(a) {
        return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      },
      which: function(a) {
        return a.type === "keypress" ? gc(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      }
    }), vS = ur(zE), gS = pn({}, Yi, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), yS = ur(gS), Xa = pn({}, yc, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Yg
    }), Gg = ur(Xa), UE = pn({}, zr, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Sl = ur(UE), _h = pn({}, Yi, {
      deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in a ? -a.wheelDeltaX : 0
        );
      },
      deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in a ? -a.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in a ? -a.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), xc = ur(_h), Ah = [9, 13, 27, 32], Lh = 229, pf = fe && "CompositionEvent" in window, hf = null;
    fe && "documentMode" in document && (hf = document.documentMode);
    var Kg = fe && "TextEvent" in window && !hf, bS = fe && (!pf || hf && hf > 8 && hf <= 11), Xg = 32, Qg = String.fromCharCode(Xg);
    function Fh() {
      De("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), De("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), De("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), De("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var mf = !1;
    function xS(a) {
      return (a.ctrlKey || a.altKey || a.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(a.ctrlKey && a.altKey);
    }
    function Jg(a) {
      switch (a) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function HE(a, i) {
      return a === "keydown" && i.keyCode === Lh;
    }
    function Zg(a, i) {
      switch (a) {
        case "keyup":
          return Ah.indexOf(i.keyCode) !== -1;
        case "keydown":
          return i.keyCode !== Lh;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function jh(a) {
      var i = a.detail;
      return typeof i == "object" && "data" in i ? i.data : null;
    }
    function vf(a) {
      return a.locale === "ko";
    }
    var Cl = !1;
    function Vh(a, i, f, v, y) {
      var w, M;
      if (pf ? w = Jg(i) : Cl ? Zg(i, v) && (w = "onCompositionEnd") : HE(i, v) && (w = "onCompositionStart"), !w)
        return null;
      bS && !vf(v) && (!Cl && w === "onCompositionStart" ? Cl = Dh(y) : w === "onCompositionEnd" && Cl && (M = kh()));
      var j = RS(f, w);
      if (j.length > 0) {
        var B = new xl(w, i, null, v, y);
        if (a.push({
          event: B,
          listeners: j
        }), M)
          B.data = M;
        else {
          var Q = jh(v);
          Q !== null && (B.data = Q);
        }
      }
    }
    function SS(a, i) {
      switch (a) {
        case "compositionend":
          return jh(i);
        case "keypress":
          var f = i.which;
          return f !== Xg ? null : (mf = !0, Qg);
        case "textInput":
          var v = i.data;
          return v === Qg && mf ? null : v;
        default:
          return null;
      }
    }
    function WE(a, i) {
      if (Cl) {
        if (a === "compositionend" || !pf && Zg(a, i)) {
          var f = kh();
          return uf(), Cl = !1, f;
        }
        return null;
      }
      switch (a) {
        case "paste":
          return null;
        case "keypress":
          if (!xS(i)) {
            if (i.char && i.char.length > 1)
              return i.char;
            if (i.which)
              return String.fromCharCode(i.which);
          }
          return null;
        case "compositionend":
          return bS && !vf(i) ? null : i.data;
        default:
          return null;
      }
    }
    function Bh(a, i, f, v, y) {
      var w;
      if (Kg ? w = SS(i, v) : w = WE(i, v), !w)
        return null;
      var M = RS(f, "onBeforeInput");
      if (M.length > 0) {
        var j = new VE("onBeforeInput", "beforeinput", null, v, y);
        a.push({
          event: j,
          listeners: M
        }), j.data = w;
      }
    }
    function qE(a, i, f, v, y, w, M) {
      Vh(a, i, f, v, y), Bh(a, i, f, v, y);
    }
    var gf = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function CS(a) {
      var i = a && a.nodeName && a.nodeName.toLowerCase();
      return i === "input" ? !!gf[a.type] : i === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function zh(a) {
      if (!fe)
        return !1;
      var i = "on" + a, f = i in document;
      if (!f) {
        var v = document.createElement("div");
        v.setAttribute(i, "return;"), f = typeof v[i] == "function";
      }
      return f;
    }
    function c() {
      De("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function d(a, i, f, v) {
      Bp(v);
      var y = RS(i, "onChange");
      if (y.length > 0) {
        var w = new Mh("onChange", "change", null, f, v);
        a.push({
          event: w,
          listeners: y
        });
      }
    }
    var g = null, C = null;
    function $(a) {
      var i = a.nodeName && a.nodeName.toLowerCase();
      return i === "select" || i === "input" && a.type === "file";
    }
    function A(a) {
      var i = [];
      d(i, C, a, Vp(a)), hg(q, i);
    }
    function q(a) {
      DN(a, 0);
    }
    function ue(a) {
      var i = Gh(a);
      if (ox(i))
        return a;
    }
    function he(a, i) {
      if (a === "change")
        return i;
    }
    var Fe = !1;
    fe && (Fe = zh("input") && (!document.documentMode || document.documentMode > 9));
    function Je(a, i) {
      g = a, C = i, g.attachEvent("onpropertychange", Ke);
    }
    function Ze() {
      g && (g.detachEvent("onpropertychange", Ke), g = null, C = null);
    }
    function Ke(a) {
      a.propertyName === "value" && ue(C) && A(a);
    }
    function Ct(a, i, f) {
      a === "focusin" ? (Ze(), Je(i, f)) : a === "focusout" && Ze();
    }
    function $t(a, i) {
      if (a === "selectionchange" || a === "keyup" || a === "keydown")
        return ue(C);
    }
    function It(a) {
      var i = a.nodeName;
      return i && i.toLowerCase() === "input" && (a.type === "checkbox" || a.type === "radio");
    }
    function Er(a, i) {
      if (a === "click")
        return ue(i);
    }
    function $e(a, i) {
      if (a === "input" || a === "change")
        return ue(i);
    }
    function Se(a) {
      var i = a._wrapperState;
      !i || !i.controlled || a.type !== "number" || il(a, "number", a.value);
    }
    function Ie(a, i, f, v, y, w, M) {
      var j = f ? Gh(f) : window, B, Q;
      if ($(j) ? B = he : CS(j) ? Fe ? B = $e : (B = $t, Q = Ct) : It(j) && (B = Er), B) {
        var re = B(i, f);
        if (re) {
          d(a, re, v, y);
          return;
        }
      }
      Q && Q(i, j, f), i === "focusout" && Se(j);
    }
    function ot() {
      ie("onMouseEnter", ["mouseout", "mouseover"]), ie("onMouseLeave", ["mouseout", "mouseover"]), ie("onPointerEnter", ["pointerout", "pointerover"]), ie("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function At(a, i, f, v, y, w, M) {
      var j = i === "mouseover" || i === "pointerover", B = i === "mouseout" || i === "pointerout";
      if (j && !_x(v)) {
        var Q = v.relatedTarget || v.fromElement;
        if (Q && (xf(Q) || py(Q)))
          return;
      }
      if (!(!B && !j)) {
        var re;
        if (y.window === y)
          re = y;
        else {
          var Ce = y.ownerDocument;
          Ce ? re = Ce.defaultView || Ce.parentWindow : re = window;
        }
        var xe, Le;
        if (B) {
          var je = v.relatedTarget || v.toElement;
          if (xe = f, Le = je ? xf(je) : null, Le !== null) {
            var Ue = ga(Le);
            (Le !== Ue || Le.tag !== R && Le.tag !== T) && (Le = null);
          }
        } else
          xe = null, Le = f;
        if (xe !== Le) {
          var gt = Nh, Ht = "onMouseLeave", Ft = "onMouseEnter", yn = "mouse";
          (i === "pointerout" || i === "pointerover") && (gt = yS, Ht = "onPointerLeave", Ft = "onPointerEnter", yn = "pointer");
          var mn = xe == null ? re : Gh(xe), ke = Le == null ? re : Gh(Le), He = new gt(Ht, yn + "leave", xe, v, y);
          He.target = mn, He.relatedTarget = ke;
          var Me = null, nt = xf(y);
          if (nt === f) {
            var Et = new gt(Ft, yn + "enter", Le, v, y);
            Et.target = ke, Et.relatedTarget = mn, Me = Et;
          }
          ZH(a, He, Me, xe, Le);
        }
      }
    }
    function qt(a, i) {
      return a === i && (a !== 0 || 1 / a === 1 / i) || a !== a && i !== i;
    }
    var Dt = typeof Object.is == "function" ? Object.is : qt;
    function Yt(a, i) {
      if (Dt(a, i))
        return !0;
      if (typeof a != "object" || a === null || typeof i != "object" || i === null)
        return !1;
      var f = Object.keys(a), v = Object.keys(i);
      if (f.length !== v.length)
        return !1;
      for (var y = 0; y < f.length; y++) {
        var w = f[y];
        if (!ye.call(i, w) || !Dt(a[w], i[w]))
          return !1;
      }
      return !0;
    }
    function Ur(a) {
      for (; a && a.firstChild; )
        a = a.firstChild;
      return a;
    }
    function wn(a) {
      for (; a; ) {
        if (a.nextSibling)
          return a.nextSibling;
        a = a.parentNode;
      }
    }
    function _s(a, i) {
      for (var f = Ur(a), v = 0, y = 0; f; ) {
        if (f.nodeType === ws) {
          if (y = v + f.textContent.length, v <= i && y >= i)
            return {
              node: f,
              offset: i - v
            };
          v = y;
        }
        f = Ur(wn(f));
      }
    }
    function YE(a) {
      var i = a.ownerDocument, f = i && i.defaultView || window, v = f.getSelection && f.getSelection();
      if (!v || v.rangeCount === 0)
        return null;
      var y = v.anchorNode, w = v.anchorOffset, M = v.focusNode, j = v.focusOffset;
      try {
        y.nodeType, M.nodeType;
      } catch {
        return null;
      }
      return NH(a, y, w, M, j);
    }
    function NH(a, i, f, v, y) {
      var w = 0, M = -1, j = -1, B = 0, Q = 0, re = a, Ce = null;
      e: for (; ; ) {
        for (var xe = null; re === i && (f === 0 || re.nodeType === ws) && (M = w + f), re === v && (y === 0 || re.nodeType === ws) && (j = w + y), re.nodeType === ws && (w += re.nodeValue.length), (xe = re.firstChild) !== null; )
          Ce = re, re = xe;
        for (; ; ) {
          if (re === a)
            break e;
          if (Ce === i && ++B === f && (M = w), Ce === v && ++Q === y && (j = w), (xe = re.nextSibling) !== null)
            break;
          re = Ce, Ce = re.parentNode;
        }
        re = xe;
      }
      return M === -1 || j === -1 ? null : {
        start: M,
        end: j
      };
    }
    function IH(a, i) {
      var f = a.ownerDocument || document, v = f && f.defaultView || window;
      if (v.getSelection) {
        var y = v.getSelection(), w = a.textContent.length, M = Math.min(i.start, w), j = i.end === void 0 ? M : Math.min(i.end, w);
        if (!y.extend && M > j) {
          var B = j;
          j = M, M = B;
        }
        var Q = _s(a, M), re = _s(a, j);
        if (Q && re) {
          if (y.rangeCount === 1 && y.anchorNode === Q.node && y.anchorOffset === Q.offset && y.focusNode === re.node && y.focusOffset === re.offset)
            return;
          var Ce = f.createRange();
          Ce.setStart(Q.node, Q.offset), y.removeAllRanges(), M > j ? (y.addRange(Ce), y.extend(re.node, re.offset)) : (Ce.setEnd(re.node, re.offset), y.addRange(Ce));
        }
      }
    }
    function yN(a) {
      return a && a.nodeType === ws;
    }
    function bN(a, i) {
      return !a || !i ? !1 : a === i ? !0 : yN(a) ? !1 : yN(i) ? bN(a, i.parentNode) : "contains" in a ? a.contains(i) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(i) & 16) : !1;
    }
    function _H(a) {
      return a && a.ownerDocument && bN(a.ownerDocument.documentElement, a);
    }
    function AH(a) {
      try {
        return typeof a.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function xN() {
      for (var a = window, i = Op(); i instanceof a.HTMLIFrameElement; ) {
        if (AH(i))
          a = i.contentWindow;
        else
          return i;
        i = Op(a.document);
      }
      return i;
    }
    function GE(a) {
      var i = a && a.nodeName && a.nodeName.toLowerCase();
      return i && (i === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || i === "textarea" || a.contentEditable === "true");
    }
    function LH() {
      var a = xN();
      return {
        focusedElem: a,
        selectionRange: GE(a) ? jH(a) : null
      };
    }
    function FH(a) {
      var i = xN(), f = a.focusedElem, v = a.selectionRange;
      if (i !== f && _H(f)) {
        v !== null && GE(f) && VH(f, v);
        for (var y = [], w = f; w = w.parentNode; )
          w.nodeType === Xo && y.push({
            element: w,
            left: w.scrollLeft,
            top: w.scrollTop
          });
        typeof f.focus == "function" && f.focus();
        for (var M = 0; M < y.length; M++) {
          var j = y[M];
          j.element.scrollLeft = j.left, j.element.scrollTop = j.top;
        }
      }
    }
    function jH(a) {
      var i;
      return "selectionStart" in a ? i = {
        start: a.selectionStart,
        end: a.selectionEnd
      } : i = YE(a), i || {
        start: 0,
        end: 0
      };
    }
    function VH(a, i) {
      var f = i.start, v = i.end;
      v === void 0 && (v = f), "selectionStart" in a ? (a.selectionStart = f, a.selectionEnd = Math.min(v, a.value.length)) : IH(a, i);
    }
    var BH = fe && "documentMode" in document && document.documentMode <= 11;
    function zH() {
      De("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Uh = null, KE = null, ey = null, XE = !1;
    function UH(a) {
      if ("selectionStart" in a && GE(a))
        return {
          start: a.selectionStart,
          end: a.selectionEnd
        };
      var i = a.ownerDocument && a.ownerDocument.defaultView || window, f = i.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function HH(a) {
      return a.window === a ? a.document : a.nodeType === Ci ? a : a.ownerDocument;
    }
    function SN(a, i, f) {
      var v = HH(f);
      if (!(XE || Uh == null || Uh !== Op(v))) {
        var y = UH(Uh);
        if (!ey || !Yt(ey, y)) {
          ey = y;
          var w = RS(KE, "onSelect");
          if (w.length > 0) {
            var M = new Mh("onSelect", "select", null, i, f);
            a.push({
              event: M,
              listeners: w
            }), M.target = Uh;
          }
        }
      }
    }
    function WH(a, i, f, v, y, w, M) {
      var j = f ? Gh(f) : window;
      switch (i) {
        case "focusin":
          (CS(j) || j.contentEditable === "true") && (Uh = j, KE = f, ey = null);
          break;
        case "focusout":
          Uh = null, KE = null, ey = null;
          break;
        case "mousedown":
          XE = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          XE = !1, SN(a, v, y);
          break;
        case "selectionchange":
          if (BH)
            break;
        case "keydown":
        case "keyup":
          SN(a, v, y);
      }
    }
    function wS(a, i) {
      var f = {};
      return f[a.toLowerCase()] = i.toLowerCase(), f["Webkit" + a] = "webkit" + i, f["Moz" + a] = "moz" + i, f;
    }
    var Hh = {
      animationend: wS("Animation", "AnimationEnd"),
      animationiteration: wS("Animation", "AnimationIteration"),
      animationstart: wS("Animation", "AnimationStart"),
      transitionend: wS("Transition", "TransitionEnd")
    }, QE = {}, CN = {};
    fe && (CN = document.createElement("div").style, "AnimationEvent" in window || (delete Hh.animationend.animation, delete Hh.animationiteration.animation, delete Hh.animationstart.animation), "TransitionEvent" in window || delete Hh.transitionend.transition);
    function TS(a) {
      if (QE[a])
        return QE[a];
      if (!Hh[a])
        return a;
      var i = Hh[a];
      for (var f in i)
        if (i.hasOwnProperty(f) && f in CN)
          return QE[a] = i[f];
      return a;
    }
    var wN = TS("animationend"), TN = TS("animationiteration"), EN = TS("animationstart"), RN = TS("transitionend"), ON = /* @__PURE__ */ new Map(), PN = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Lu(a, i) {
      ON.set(a, i), De(i, [a]);
    }
    function qH() {
      for (var a = 0; a < PN.length; a++) {
        var i = PN[a], f = i.toLowerCase(), v = i[0].toUpperCase() + i.slice(1);
        Lu(f, "on" + v);
      }
      Lu(wN, "onAnimationEnd"), Lu(TN, "onAnimationIteration"), Lu(EN, "onAnimationStart"), Lu("dblclick", "onDoubleClick"), Lu("focusin", "onFocus"), Lu("focusout", "onBlur"), Lu(RN, "onTransitionEnd");
    }
    function YH(a, i, f, v, y, w, M) {
      var j = ON.get(i);
      if (j !== void 0) {
        var B = Mh, Q = i;
        switch (i) {
          case "keypress":
            if (gc(v) === 0)
              return;
          case "keydown":
          case "keyup":
            B = vS;
            break;
          case "focusin":
            Q = "focus", B = ff;
            break;
          case "focusout":
            Q = "blur", B = ff;
            break;
          case "beforeblur":
          case "afterblur":
            B = ff;
            break;
          case "click":
            if (v.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            B = Nh;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            B = uS;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            B = Gg;
            break;
          case wN:
          case TN:
          case EN:
            B = FE;
            break;
          case RN:
            B = Sl;
            break;
          case "scroll":
            B = Hg;
            break;
          case "wheel":
            B = xc;
            break;
          case "copy":
          case "cut":
          case "paste":
            B = fS;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            B = yS;
            break;
        }
        var re = (w & Zl) !== 0;
        {
          var Ce = !re && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          i === "scroll", xe = QH(f, j, v.type, re, Ce);
          if (xe.length > 0) {
            var Le = new B(j, Q, null, v, y);
            a.push({
              event: Le,
              listeners: xe
            });
          }
        }
      }
    }
    qH(), ot(), c(), zH(), Fh();
    function GH(a, i, f, v, y, w, M) {
      YH(a, i, f, v, y, w);
      var j = (w & EE) === 0;
      j && (At(a, i, f, v, y), Ie(a, i, f, v, y), WH(a, i, f, v, y), qE(a, i, f, v, y));
    }
    var ty = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], JE = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(ty));
    function $N(a, i, f) {
      var v = a.type || "unknown-event";
      a.currentTarget = f, Os(v, i, void 0, a), a.currentTarget = null;
    }
    function KH(a, i, f) {
      var v;
      if (f)
        for (var y = i.length - 1; y >= 0; y--) {
          var w = i[y], M = w.instance, j = w.currentTarget, B = w.listener;
          if (M !== v && a.isPropagationStopped())
            return;
          $N(a, B, j), v = M;
        }
      else
        for (var Q = 0; Q < i.length; Q++) {
          var re = i[Q], Ce = re.instance, xe = re.currentTarget, Le = re.listener;
          if (Ce !== v && a.isPropagationStopped())
            return;
          $N(a, Le, xe), v = Ce;
        }
    }
    function DN(a, i) {
      for (var f = (i & Zl) !== 0, v = 0; v < a.length; v++) {
        var y = a[v], w = y.event, M = y.listeners;
        KH(w, M, f);
      }
      yg();
    }
    function XH(a, i, f, v, y) {
      var w = Vp(f), M = [];
      GH(M, a, v, f, w, i), DN(M, i);
    }
    function dr(a, i) {
      JE.has(a) || u('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', a);
      var f = !1, v = R8(i), y = e6(a);
      v.has(y) || (kN(i, a, jd, f), v.add(y));
    }
    function ZE(a, i, f) {
      JE.has(a) && !i && u('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', a);
      var v = 0;
      i && (v |= Zl), kN(f, a, v, i);
    }
    var ES = "_reactListening" + Math.random().toString(36).slice(2);
    function ny(a) {
      if (!a[ES]) {
        a[ES] = !0, me.forEach(function(f) {
          f !== "selectionchange" && (JE.has(f) || ZE(f, !1, a), ZE(f, !0, a));
        });
        var i = a.nodeType === Ci ? a : a.ownerDocument;
        i !== null && (i[ES] || (i[ES] = !0, ZE("selectionchange", !1, i)));
      }
    }
    function kN(a, i, f, v, y) {
      var w = Br(a, i, f), M = void 0;
      Hd && (i === "touchstart" || i === "touchmove" || i === "wheel") && (M = !0), a = a, v ? M !== void 0 ? $h(a, i, w, M) : Ns(a, i, w) : M !== void 0 ? Ug(a, i, w, M) : Nu(a, i, w);
    }
    function MN(a, i) {
      return a === i || a.nodeType === $r && a.parentNode === i;
    }
    function eR(a, i, f, v, y) {
      var w = v;
      if (!(i & Es) && !(i & jd)) {
        var M = y;
        if (v !== null) {
          var j = v;
          e: for (; ; ) {
            if (j === null)
              return;
            var B = j.tag;
            if (B === x || B === S) {
              var Q = j.stateNode.containerInfo;
              if (MN(Q, M))
                break;
              if (B === S)
                for (var re = j.return; re !== null; ) {
                  var Ce = re.tag;
                  if (Ce === x || Ce === S) {
                    var xe = re.stateNode.containerInfo;
                    if (MN(xe, M))
                      return;
                  }
                  re = re.return;
                }
              for (; Q !== null; ) {
                var Le = xf(Q);
                if (Le === null)
                  return;
                var je = Le.tag;
                if (je === R || je === T) {
                  j = w = Le;
                  continue e;
                }
                Q = Q.parentNode;
              }
            }
            j = j.return;
          }
        }
      }
      hg(function() {
        return XH(a, i, f, w);
      });
    }
    function ry(a, i, f) {
      return {
        instance: a,
        listener: i,
        currentTarget: f
      };
    }
    function QH(a, i, f, v, y, w) {
      for (var M = i !== null ? i + "Capture" : null, j = v ? M : i, B = [], Q = a, re = null; Q !== null; ) {
        var Ce = Q, xe = Ce.stateNode, Le = Ce.tag;
        if (Le === R && xe !== null && (re = xe, j !== null)) {
          var je = tc(Q, j);
          je != null && B.push(ry(Q, je, re));
        }
        if (y)
          break;
        Q = Q.return;
      }
      return B;
    }
    function RS(a, i) {
      for (var f = i + "Capture", v = [], y = a; y !== null; ) {
        var w = y, M = w.stateNode, j = w.tag;
        if (j === R && M !== null) {
          var B = M, Q = tc(y, f);
          Q != null && v.unshift(ry(y, Q, B));
          var re = tc(y, i);
          re != null && v.push(ry(y, re, B));
        }
        y = y.return;
      }
      return v;
    }
    function Wh(a) {
      if (a === null)
        return null;
      do
        a = a.return;
      while (a && a.tag !== R);
      return a || null;
    }
    function JH(a, i) {
      for (var f = a, v = i, y = 0, w = f; w; w = Wh(w))
        y++;
      for (var M = 0, j = v; j; j = Wh(j))
        M++;
      for (; y - M > 0; )
        f = Wh(f), y--;
      for (; M - y > 0; )
        v = Wh(v), M--;
      for (var B = y; B--; ) {
        if (f === v || v !== null && f === v.alternate)
          return f;
        f = Wh(f), v = Wh(v);
      }
      return null;
    }
    function NN(a, i, f, v, y) {
      for (var w = i._reactName, M = [], j = f; j !== null && j !== v; ) {
        var B = j, Q = B.alternate, re = B.stateNode, Ce = B.tag;
        if (Q !== null && Q === v)
          break;
        if (Ce === R && re !== null) {
          var xe = re;
          if (y) {
            var Le = tc(j, w);
            Le != null && M.unshift(ry(j, Le, xe));
          } else if (!y) {
            var je = tc(j, w);
            je != null && M.push(ry(j, je, xe));
          }
        }
        j = j.return;
      }
      M.length !== 0 && a.push({
        event: i,
        listeners: M
      });
    }
    function ZH(a, i, f, v, y) {
      var w = v && y ? JH(v, y) : null;
      v !== null && NN(a, i, v, w, !1), y !== null && f !== null && NN(a, f, y, w, !0);
    }
    function e6(a, i) {
      return a + "__bubble";
    }
    var Qa = !1, oy = "dangerouslySetInnerHTML", OS = "suppressContentEditableWarning", Fu = "suppressHydrationWarning", IN = "autoFocus", yf = "children", bf = "style", PS = "__html", tR, $S, ay, _N, DS, AN, LN;
    tR = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, $S = function(a, i) {
      jp(a, i), cg(a, i), Ix(a, i, {
        registrationNameDependencies: Oe,
        possibleRegistrationNames: be
      });
    }, AN = fe && !document.documentMode, ay = function(a, i, f) {
      if (!Qa) {
        var v = kS(f), y = kS(i);
        y !== v && (Qa = !0, u("Prop `%s` did not match. Server: %s Client: %s", a, JSON.stringify(y), JSON.stringify(v)));
      }
    }, _N = function(a) {
      if (!Qa) {
        Qa = !0;
        var i = [];
        a.forEach(function(f) {
          i.push(f);
        }), u("Extra attributes from the server: %s", i);
      }
    }, DS = function(a, i) {
      i === !1 ? u("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", a, a, a) : u("Expected `%s` listener to be a function, instead got a value of `%s` type.", a, typeof i);
    }, LN = function(a, i) {
      var f = a.namespaceURI === Cs ? a.ownerDocument.createElement(a.tagName) : a.ownerDocument.createElementNS(a.namespaceURI, a.tagName);
      return f.innerHTML = i, f.innerHTML;
    };
    var t6 = /\r\n?/g, n6 = /\u0000|\uFFFD/g;
    function kS(a) {
      it(a);
      var i = typeof a == "string" ? a : "" + a;
      return i.replace(t6, `
`).replace(n6, "");
    }
    function MS(a, i, f, v) {
      var y = kS(i), w = kS(a);
      if (w !== y && (v && (Qa || (Qa = !0, u('Text content did not match. Server: "%s" Client: "%s"', w, y))), f && ae))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function FN(a) {
      return a.nodeType === Ci ? a : a.ownerDocument;
    }
    function r6() {
    }
    function NS(a) {
      a.onclick = r6;
    }
    function o6(a, i, f, v, y) {
      for (var w in v)
        if (v.hasOwnProperty(w)) {
          var M = v[w];
          if (w === bf)
            M && Object.freeze(M), Tx(i, M);
          else if (w === oy) {
            var j = M ? M[PS] : void 0;
            j != null && px(i, j);
          } else if (w === yf)
            if (typeof M == "string") {
              var B = a !== "textarea" || M !== "";
              B && _p(i, M);
            } else typeof M == "number" && _p(i, "" + M);
          else w === OS || w === Fu || w === IN || (Oe.hasOwnProperty(w) ? M != null && (typeof M != "function" && DS(w, M), w === "onScroll" && dr("scroll", i)) : M != null && Cr(i, w, M, y));
        }
    }
    function a6(a, i, f, v) {
      for (var y = 0; y < i.length; y += 2) {
        var w = i[y], M = i[y + 1];
        w === bf ? Tx(a, M) : w === oy ? px(a, M) : w === yf ? _p(a, M) : Cr(a, w, M, v);
      }
    }
    function i6(a, i, f, v) {
      var y, w = FN(f), M, j = v;
      if (j === Cs && (j = Np(a)), j === Cs) {
        if (y = Ts(a, i), !y && a !== a.toLowerCase() && u("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", a), a === "script") {
          var B = w.createElement("div");
          B.innerHTML = "<script><\/script>";
          var Q = B.firstChild;
          M = B.removeChild(Q);
        } else if (typeof i.is == "string")
          M = w.createElement(a, {
            is: i.is
          });
        else if (M = w.createElement(a), a === "select") {
          var re = M;
          i.multiple ? re.multiple = !0 : i.size && (re.size = i.size);
        }
      } else
        M = w.createElementNS(j, a);
      return j === Cs && !y && Object.prototype.toString.call(M) === "[object HTMLUnknownElement]" && !ye.call(tR, a) && (tR[a] = !0, u("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", a)), M;
    }
    function s6(a, i) {
      return FN(i).createTextNode(a);
    }
    function l6(a, i, f, v) {
      var y = Ts(i, f);
      $S(i, f);
      var w;
      switch (i) {
        case "dialog":
          dr("cancel", a), dr("close", a), w = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          dr("load", a), w = f;
          break;
        case "video":
        case "audio":
          for (var M = 0; M < ty.length; M++)
            dr(ty[M], a);
          w = f;
          break;
        case "source":
          dr("error", a), w = f;
          break;
        case "img":
        case "image":
        case "link":
          dr("error", a), dr("load", a), w = f;
          break;
        case "details":
          dr("toggle", a), w = f;
          break;
        case "input":
          Nd(a, f), w = Md(a, f), dr("invalid", a);
          break;
        case "option":
          kp(a, f), w = f;
          break;
        case "select":
          cx(a, f), w = Jv(a, f), dr("invalid", a);
          break;
        case "textarea":
          ux(a, f), w = eg(a, f), dr("invalid", a);
          break;
        default:
          w = f;
      }
      switch (Lp(i, w), o6(i, a, v, w, y), i) {
        case "input":
          Xl(a), Id(a, f, !1);
          break;
        case "textarea":
          Xl(a), fx(a);
          break;
        case "option":
          Qv(a, f);
          break;
        case "select":
          hE(a, f);
          break;
        default:
          typeof w.onClick == "function" && NS(a);
          break;
      }
    }
    function c6(a, i, f, v, y) {
      $S(i, v);
      var w = null, M, j;
      switch (i) {
        case "input":
          M = Md(a, f), j = Md(a, v), w = [];
          break;
        case "select":
          M = Jv(a, f), j = Jv(a, v), w = [];
          break;
        case "textarea":
          M = eg(a, f), j = eg(a, v), w = [];
          break;
        default:
          M = f, j = v, typeof M.onClick != "function" && typeof j.onClick == "function" && NS(a);
          break;
      }
      Lp(i, j);
      var B, Q, re = null;
      for (B in M)
        if (!(j.hasOwnProperty(B) || !M.hasOwnProperty(B) || M[B] == null))
          if (B === bf) {
            var Ce = M[B];
            for (Q in Ce)
              Ce.hasOwnProperty(Q) && (re || (re = {}), re[Q] = "");
          } else B === oy || B === yf || B === OS || B === Fu || B === IN || (Oe.hasOwnProperty(B) ? w || (w = []) : (w = w || []).push(B, null));
      for (B in j) {
        var xe = j[B], Le = M != null ? M[B] : void 0;
        if (!(!j.hasOwnProperty(B) || xe === Le || xe == null && Le == null))
          if (B === bf)
            if (xe && Object.freeze(xe), Le) {
              for (Q in Le)
                Le.hasOwnProperty(Q) && (!xe || !xe.hasOwnProperty(Q)) && (re || (re = {}), re[Q] = "");
              for (Q in xe)
                xe.hasOwnProperty(Q) && Le[Q] !== xe[Q] && (re || (re = {}), re[Q] = xe[Q]);
            } else
              re || (w || (w = []), w.push(B, re)), re = xe;
          else if (B === oy) {
            var je = xe ? xe[PS] : void 0, Ue = Le ? Le[PS] : void 0;
            je != null && Ue !== je && (w = w || []).push(B, je);
          } else B === yf ? (typeof xe == "string" || typeof xe == "number") && (w = w || []).push(B, "" + xe) : B === OS || B === Fu || (Oe.hasOwnProperty(B) ? (xe != null && (typeof xe != "function" && DS(B, xe), B === "onScroll" && dr("scroll", a)), !w && Le !== xe && (w = [])) : (w = w || []).push(B, xe));
      }
      return re && (Ld(re, j[bf]), (w = w || []).push(bf, re)), w;
    }
    function u6(a, i, f, v, y) {
      f === "input" && y.type === "radio" && y.name != null && Xv(a, y);
      var w = Ts(f, v), M = Ts(f, y);
      switch (a6(a, i, w, M), f) {
        case "input":
          Zc(a, y);
          break;
        case "textarea":
          dx(a, y);
          break;
        case "select":
          mE(a, y);
          break;
      }
    }
    function d6(a) {
      {
        var i = a.toLowerCase();
        return Fp.hasOwnProperty(i) && Fp[i] || null;
      }
    }
    function f6(a, i, f, v, y, w, M) {
      var j, B;
      switch (j = Ts(i, f), $S(i, f), i) {
        case "dialog":
          dr("cancel", a), dr("close", a);
          break;
        case "iframe":
        case "object":
        case "embed":
          dr("load", a);
          break;
        case "video":
        case "audio":
          for (var Q = 0; Q < ty.length; Q++)
            dr(ty[Q], a);
          break;
        case "source":
          dr("error", a);
          break;
        case "img":
        case "image":
        case "link":
          dr("error", a), dr("load", a);
          break;
        case "details":
          dr("toggle", a);
          break;
        case "input":
          Nd(a, f), dr("invalid", a);
          break;
        case "option":
          kp(a, f);
          break;
        case "select":
          cx(a, f), dr("invalid", a);
          break;
        case "textarea":
          ux(a, f), dr("invalid", a);
          break;
      }
      Lp(i, f);
      {
        B = /* @__PURE__ */ new Set();
        for (var re = a.attributes, Ce = 0; Ce < re.length; Ce++) {
          var xe = re[Ce].name.toLowerCase();
          switch (xe) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              B.add(re[Ce].name);
          }
        }
      }
      var Le = null;
      for (var je in f)
        if (f.hasOwnProperty(je)) {
          var Ue = f[je];
          if (je === yf)
            typeof Ue == "string" ? a.textContent !== Ue && (f[Fu] !== !0 && MS(a.textContent, Ue, w, M), Le = [yf, Ue]) : typeof Ue == "number" && a.textContent !== "" + Ue && (f[Fu] !== !0 && MS(a.textContent, Ue, w, M), Le = [yf, "" + Ue]);
          else if (Oe.hasOwnProperty(je))
            Ue != null && (typeof Ue != "function" && DS(je, Ue), je === "onScroll" && dr("scroll", a));
          else if (M && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof j == "boolean") {
            var gt = void 0, Ht = j && ge ? null : tn(je);
            if (f[Fu] !== !0) {
              if (!(je === OS || je === Fu || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              je === "value" || je === "checked" || je === "selected")) {
                if (je === oy) {
                  var Ft = a.innerHTML, yn = Ue ? Ue[PS] : void 0;
                  if (yn != null) {
                    var mn = LN(a, yn);
                    mn !== Ft && ay(je, Ft, mn);
                  }
                } else if (je === bf) {
                  if (B.delete(je), AN) {
                    var ke = wE(Ue);
                    gt = a.getAttribute("style"), ke !== gt && ay(je, gt, ke);
                  }
                } else if (j && !ge)
                  B.delete(je.toLowerCase()), gt = Wn(a, je, Ue), Ue !== gt && ay(je, gt, Ue);
                else if (!xt(je, Ht, j) && !St(je, Ue, Ht, j)) {
                  var He = !1;
                  if (Ht !== null)
                    B.delete(Ht.attributeName), gt = rr(a, je, Ue, Ht);
                  else {
                    var Me = v;
                    if (Me === Cs && (Me = Np(i)), Me === Cs)
                      B.delete(je.toLowerCase());
                    else {
                      var nt = d6(je);
                      nt !== null && nt !== je && (He = !0, B.delete(nt)), B.delete(je);
                    }
                    gt = Wn(a, je, Ue);
                  }
                  var Et = ge;
                  !Et && Ue !== gt && !He && ay(je, gt, Ue);
                }
              }
            }
          }
        }
      switch (M && // $FlowFixMe - Should be inferred as not undefined.
      B.size > 0 && f[Fu] !== !0 && _N(B), i) {
        case "input":
          Xl(a), Id(a, f, !0);
          break;
        case "textarea":
          Xl(a), fx(a);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && NS(a);
          break;
      }
      return Le;
    }
    function p6(a, i, f) {
      var v = a.nodeValue !== i;
      return v;
    }
    function nR(a, i) {
      {
        if (Qa)
          return;
        Qa = !0, u("Did not expect server HTML to contain a <%s> in <%s>.", i.nodeName.toLowerCase(), a.nodeName.toLowerCase());
      }
    }
    function rR(a, i) {
      {
        if (Qa)
          return;
        Qa = !0, u('Did not expect server HTML to contain the text node "%s" in <%s>.', i.nodeValue, a.nodeName.toLowerCase());
      }
    }
    function oR(a, i, f) {
      {
        if (Qa)
          return;
        Qa = !0, u("Expected server HTML to contain a matching <%s> in <%s>.", i, a.nodeName.toLowerCase());
      }
    }
    function aR(a, i) {
      {
        if (i === "" || Qa)
          return;
        Qa = !0, u('Expected server HTML to contain a matching text node for "%s" in <%s>.', i, a.nodeName.toLowerCase());
      }
    }
    function h6(a, i, f) {
      switch (i) {
        case "input":
          ax(a, f);
          return;
        case "textarea":
          tg(a, f);
          return;
        case "select":
          vE(a, f);
          return;
      }
    }
    var iy = function() {
    }, sy = function() {
    };
    {
      var m6 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], jN = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], v6 = jN.concat(["button"]), g6 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], VN = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      sy = function(a, i) {
        var f = pn({}, a || VN), v = {
          tag: i
        };
        return jN.indexOf(i) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), v6.indexOf(i) !== -1 && (f.pTagInButtonScope = null), m6.indexOf(i) !== -1 && i !== "address" && i !== "div" && i !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = v, i === "form" && (f.formTag = v), i === "a" && (f.aTagInScope = v), i === "button" && (f.buttonTagInScope = v), i === "nobr" && (f.nobrTagInScope = v), i === "p" && (f.pTagInButtonScope = v), i === "li" && (f.listItemTagAutoclosing = v), (i === "dd" || i === "dt") && (f.dlItemTagAutoclosing = v), f;
      };
      var y6 = function(a, i) {
        switch (i) {
          case "select":
            return a === "option" || a === "optgroup" || a === "#text";
          case "optgroup":
            return a === "option" || a === "#text";
          case "option":
            return a === "#text";
          case "tr":
            return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return a === "tr" || a === "style" || a === "script" || a === "template";
          case "colgroup":
            return a === "col" || a === "template";
          case "table":
            return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
          case "head":
            return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
          case "html":
            return a === "head" || a === "body" || a === "frameset";
          case "frameset":
            return a === "frame";
          case "#document":
            return a === "html";
        }
        switch (a) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return i !== "h1" && i !== "h2" && i !== "h3" && i !== "h4" && i !== "h5" && i !== "h6";
          case "rp":
          case "rt":
            return g6.indexOf(i) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return i == null;
        }
        return !0;
      }, b6 = function(a, i) {
        switch (a) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return i.pTagInButtonScope;
          case "form":
            return i.formTag || i.pTagInButtonScope;
          case "li":
            return i.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return i.dlItemTagAutoclosing;
          case "button":
            return i.buttonTagInScope;
          case "a":
            return i.aTagInScope;
          case "nobr":
            return i.nobrTagInScope;
        }
        return null;
      }, BN = {};
      iy = function(a, i, f) {
        f = f || VN;
        var v = f.current, y = v && v.tag;
        i != null && (a != null && u("validateDOMNesting: when childText is passed, childTag should be null"), a = "#text");
        var w = y6(a, y) ? null : v, M = w ? null : b6(a, f), j = w || M;
        if (j) {
          var B = j.tag, Q = !!w + "|" + a + "|" + B;
          if (!BN[Q]) {
            BN[Q] = !0;
            var re = a, Ce = "";
            if (a === "#text" ? /\S/.test(i) ? re = "Text nodes" : (re = "Whitespace text nodes", Ce = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : re = "<" + a + ">", w) {
              var xe = "";
              B === "table" && a === "tr" && (xe += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), u("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", re, B, Ce, xe);
            } else
              u("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", re, B);
          }
        }
      };
    }
    var IS = "suppressHydrationWarning", _S = "$", AS = "/$", ly = "$?", cy = "$!", x6 = "style", iR = null, sR = null;
    function S6(a) {
      var i, f, v = a.nodeType;
      switch (v) {
        case Ci:
        case Ql: {
          i = v === Ci ? "#document" : "#fragment";
          var y = a.documentElement;
          f = y ? y.namespaceURI : rg(null, "");
          break;
        }
        default: {
          var w = v === $r ? a.parentNode : a, M = w.namespaceURI || null;
          i = w.tagName, f = rg(M, i);
          break;
        }
      }
      {
        var j = i.toLowerCase(), B = sy(null, j);
        return {
          namespace: f,
          ancestorInfo: B
        };
      }
    }
    function C6(a, i, f) {
      {
        var v = a, y = rg(v.namespace, i), w = sy(v.ancestorInfo, i);
        return {
          namespace: y,
          ancestorInfo: w
        };
      }
    }
    function j2e(a) {
      return a;
    }
    function w6(a) {
      iR = ku(), sR = LH();
      var i = null;
      return ia(!1), i;
    }
    function T6(a) {
      FH(sR), ia(iR), iR = null, sR = null;
    }
    function E6(a, i, f, v, y) {
      var w;
      {
        var M = v;
        if (iy(a, null, M.ancestorInfo), typeof i.children == "string" || typeof i.children == "number") {
          var j = "" + i.children, B = sy(M.ancestorInfo, a);
          iy(null, j, B);
        }
        w = M.namespace;
      }
      var Q = i6(a, i, f, w);
      return fy(y, Q), mR(Q, i), Q;
    }
    function R6(a, i) {
      a.appendChild(i);
    }
    function O6(a, i, f, v, y) {
      switch (l6(a, i, f, v), i) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function P6(a, i, f, v, y, w) {
      {
        var M = w;
        if (typeof v.children != typeof f.children && (typeof v.children == "string" || typeof v.children == "number")) {
          var j = "" + v.children, B = sy(M.ancestorInfo, i);
          iy(null, j, B);
        }
      }
      return c6(a, i, f, v);
    }
    function lR(a, i) {
      return a === "textarea" || a === "noscript" || typeof i.children == "string" || typeof i.children == "number" || typeof i.dangerouslySetInnerHTML == "object" && i.dangerouslySetInnerHTML !== null && i.dangerouslySetInnerHTML.__html != null;
    }
    function $6(a, i, f, v) {
      {
        var y = f;
        iy(null, a, y.ancestorInfo);
      }
      var w = s6(a, i);
      return fy(v, w), w;
    }
    function D6() {
      var a = window.event;
      return a === void 0 ? Hi : Ph(a.type);
    }
    var cR = typeof setTimeout == "function" ? setTimeout : void 0, k6 = typeof clearTimeout == "function" ? clearTimeout : void 0, uR = -1, zN = typeof Promise == "function" ? Promise : void 0, M6 = typeof queueMicrotask == "function" ? queueMicrotask : typeof zN < "u" ? function(a) {
      return zN.resolve(null).then(a).catch(N6);
    } : cR;
    function N6(a) {
      setTimeout(function() {
        throw a;
      });
    }
    function I6(a, i, f, v) {
      switch (i) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && a.focus();
          return;
        case "img": {
          f.src && (a.src = f.src);
          return;
        }
      }
    }
    function _6(a, i, f, v, y, w) {
      u6(a, i, f, v, y), mR(a, y);
    }
    function UN(a) {
      _p(a, "");
    }
    function A6(a, i, f) {
      a.nodeValue = f;
    }
    function L6(a, i) {
      a.appendChild(i);
    }
    function F6(a, i) {
      var f;
      a.nodeType === $r ? (f = a.parentNode, f.insertBefore(i, a)) : (f = a, f.appendChild(i));
      var v = a._reactRootContainer;
      v == null && f.onclick === null && NS(f);
    }
    function j6(a, i, f) {
      a.insertBefore(i, f);
    }
    function V6(a, i, f) {
      a.nodeType === $r ? a.parentNode.insertBefore(i, f) : a.insertBefore(i, f);
    }
    function B6(a, i) {
      a.removeChild(i);
    }
    function z6(a, i) {
      a.nodeType === $r ? a.parentNode.removeChild(i) : a.removeChild(i);
    }
    function dR(a, i) {
      var f = i, v = 0;
      do {
        var y = f.nextSibling;
        if (a.removeChild(f), y && y.nodeType === $r) {
          var w = y.data;
          if (w === AS)
            if (v === 0) {
              a.removeChild(y), yr(i);
              return;
            } else
              v--;
          else (w === _S || w === ly || w === cy) && v++;
        }
        f = y;
      } while (f);
      yr(i);
    }
    function U6(a, i) {
      a.nodeType === $r ? dR(a.parentNode, i) : a.nodeType === Xo && dR(a, i), yr(a);
    }
    function H6(a) {
      a = a;
      var i = a.style;
      typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
    }
    function W6(a) {
      a.nodeValue = "";
    }
    function q6(a, i) {
      a = a;
      var f = i[x6], v = f != null && f.hasOwnProperty("display") ? f.display : null;
      a.style.display = Ap("display", v);
    }
    function Y6(a, i) {
      a.nodeValue = i;
    }
    function G6(a) {
      a.nodeType === Xo ? a.textContent = "" : a.nodeType === Ci && a.documentElement && a.removeChild(a.documentElement);
    }
    function K6(a, i, f) {
      return a.nodeType !== Xo || i.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
    }
    function X6(a, i) {
      return i === "" || a.nodeType !== ws ? null : a;
    }
    function Q6(a) {
      return a.nodeType !== $r ? null : a;
    }
    function HN(a) {
      return a.data === ly;
    }
    function fR(a) {
      return a.data === cy;
    }
    function J6(a) {
      var i = a.nextSibling && a.nextSibling.dataset, f, v, y;
      return i && (f = i.dgst, v = i.msg, y = i.stck), {
        message: v,
        digest: f,
        stack: y
      };
    }
    function Z6(a, i) {
      a._reactRetry = i;
    }
    function LS(a) {
      for (; a != null; a = a.nextSibling) {
        var i = a.nodeType;
        if (i === Xo || i === ws)
          break;
        if (i === $r) {
          var f = a.data;
          if (f === _S || f === cy || f === ly)
            break;
          if (f === AS)
            return null;
        }
      }
      return a;
    }
    function uy(a) {
      return LS(a.nextSibling);
    }
    function e8(a) {
      return LS(a.firstChild);
    }
    function t8(a) {
      return LS(a.firstChild);
    }
    function n8(a) {
      return LS(a.nextSibling);
    }
    function r8(a, i, f, v, y, w, M) {
      fy(w, a), mR(a, f);
      var j;
      {
        var B = y;
        j = B.namespace;
      }
      var Q = (w.mode & Lt) !== _t;
      return f6(a, i, f, j, v, Q, M);
    }
    function o8(a, i, f, v) {
      return fy(f, a), f.mode & Lt, p6(a, i);
    }
    function a8(a, i) {
      fy(i, a);
    }
    function i8(a) {
      for (var i = a.nextSibling, f = 0; i; ) {
        if (i.nodeType === $r) {
          var v = i.data;
          if (v === AS) {
            if (f === 0)
              return uy(i);
            f--;
          } else (v === _S || v === cy || v === ly) && f++;
        }
        i = i.nextSibling;
      }
      return null;
    }
    function WN(a) {
      for (var i = a.previousSibling, f = 0; i; ) {
        if (i.nodeType === $r) {
          var v = i.data;
          if (v === _S || v === cy || v === ly) {
            if (f === 0)
              return i;
            f--;
          } else v === AS && f++;
        }
        i = i.previousSibling;
      }
      return null;
    }
    function s8(a) {
      yr(a);
    }
    function l8(a) {
      yr(a);
    }
    function c8(a) {
      return a !== "head" && a !== "body";
    }
    function u8(a, i, f, v) {
      var y = !0;
      MS(i.nodeValue, f, v, y);
    }
    function d8(a, i, f, v, y, w) {
      if (i[IS] !== !0) {
        var M = !0;
        MS(v.nodeValue, y, w, M);
      }
    }
    function f8(a, i) {
      i.nodeType === Xo ? nR(a, i) : i.nodeType === $r || rR(a, i);
    }
    function p8(a, i) {
      {
        var f = a.parentNode;
        f !== null && (i.nodeType === Xo ? nR(f, i) : i.nodeType === $r || rR(f, i));
      }
    }
    function h8(a, i, f, v, y) {
      (y || i[IS] !== !0) && (v.nodeType === Xo ? nR(f, v) : v.nodeType === $r || rR(f, v));
    }
    function m8(a, i, f) {
      oR(a, i);
    }
    function v8(a, i) {
      aR(a, i);
    }
    function g8(a, i, f) {
      {
        var v = a.parentNode;
        v !== null && oR(v, i);
      }
    }
    function y8(a, i) {
      {
        var f = a.parentNode;
        f !== null && aR(f, i);
      }
    }
    function b8(a, i, f, v, y, w) {
      (w || i[IS] !== !0) && oR(f, v);
    }
    function x8(a, i, f, v, y) {
      (y || i[IS] !== !0) && aR(f, v);
    }
    function S8(a) {
      u("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", a.nodeName.toLowerCase());
    }
    function C8(a) {
      ny(a);
    }
    var qh = Math.random().toString(36).slice(2), Yh = "__reactFiber$" + qh, pR = "__reactProps$" + qh, dy = "__reactContainer$" + qh, hR = "__reactEvents$" + qh, w8 = "__reactListeners$" + qh, T8 = "__reactHandles$" + qh;
    function E8(a) {
      delete a[Yh], delete a[pR], delete a[hR], delete a[w8], delete a[T8];
    }
    function fy(a, i) {
      i[Yh] = a;
    }
    function FS(a, i) {
      i[dy] = a;
    }
    function qN(a) {
      a[dy] = null;
    }
    function py(a) {
      return !!a[dy];
    }
    function xf(a) {
      var i = a[Yh];
      if (i)
        return i;
      for (var f = a.parentNode; f; ) {
        if (i = f[dy] || f[Yh], i) {
          var v = i.alternate;
          if (i.child !== null || v !== null && v.child !== null)
            for (var y = WN(a); y !== null; ) {
              var w = y[Yh];
              if (w)
                return w;
              y = WN(y);
            }
          return i;
        }
        a = f, f = a.parentNode;
      }
      return null;
    }
    function ju(a) {
      var i = a[Yh] || a[dy];
      return i && (i.tag === R || i.tag === T || i.tag === N || i.tag === x) ? i : null;
    }
    function Gh(a) {
      if (a.tag === R || a.tag === T)
        return a.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function jS(a) {
      return a[pR] || null;
    }
    function mR(a, i) {
      a[pR] = i;
    }
    function R8(a) {
      var i = a[hR];
      return i === void 0 && (i = a[hR] = /* @__PURE__ */ new Set()), i;
    }
    var YN = {}, GN = n.ReactDebugCurrentFrame;
    function VS(a) {
      if (a) {
        var i = a._owner, f = Rd(a.type, a._source, i ? i.type : null);
        GN.setExtraStackFrame(f);
      } else
        GN.setExtraStackFrame(null);
    }
    function As(a, i, f, v, y) {
      {
        var w = Function.call.bind(ye);
        for (var M in a)
          if (w(a, M)) {
            var j = void 0;
            try {
              if (typeof a[M] != "function") {
                var B = Error((v || "React class") + ": " + f + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw B.name = "Invariant Violation", B;
              }
              j = a[M](i, M, v, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Q) {
              j = Q;
            }
            j && !(j instanceof Error) && (VS(y), u("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", f, M, typeof j), VS(null)), j instanceof Error && !(j.message in YN) && (YN[j.message] = !0, VS(y), u("Failed %s type: %s", f, j.message), VS(null));
          }
      }
    }
    var vR = [], BS;
    BS = [];
    var Sc = -1;
    function Vu(a) {
      return {
        current: a
      };
    }
    function sa(a, i) {
      if (Sc < 0) {
        u("Unexpected pop.");
        return;
      }
      i !== BS[Sc] && u("Unexpected Fiber popped."), a.current = vR[Sc], vR[Sc] = null, BS[Sc] = null, Sc--;
    }
    function la(a, i, f) {
      Sc++, vR[Sc] = a.current, BS[Sc] = f, a.current = i;
    }
    var gR;
    gR = {};
    var Ri = {};
    Object.freeze(Ri);
    var Cc = Vu(Ri), wl = Vu(!1), yR = Ri;
    function Kh(a, i, f) {
      return f && Tl(i) ? yR : Cc.current;
    }
    function KN(a, i, f) {
      {
        var v = a.stateNode;
        v.__reactInternalMemoizedUnmaskedChildContext = i, v.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function Xh(a, i) {
      {
        var f = a.type, v = f.contextTypes;
        if (!v)
          return Ri;
        var y = a.stateNode;
        if (y && y.__reactInternalMemoizedUnmaskedChildContext === i)
          return y.__reactInternalMemoizedMaskedChildContext;
        var w = {};
        for (var M in v)
          w[M] = i[M];
        {
          var j = nn(a) || "Unknown";
          As(v, w, "context", j);
        }
        return y && KN(a, i, w), w;
      }
    }
    function zS() {
      return wl.current;
    }
    function Tl(a) {
      {
        var i = a.childContextTypes;
        return i != null;
      }
    }
    function US(a) {
      sa(wl, a), sa(Cc, a);
    }
    function bR(a) {
      sa(wl, a), sa(Cc, a);
    }
    function XN(a, i, f) {
      {
        if (Cc.current !== Ri)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        la(Cc, i, a), la(wl, f, a);
      }
    }
    function QN(a, i, f) {
      {
        var v = a.stateNode, y = i.childContextTypes;
        if (typeof v.getChildContext != "function") {
          {
            var w = nn(a) || "Unknown";
            gR[w] || (gR[w] = !0, u("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", w, w));
          }
          return f;
        }
        var M = v.getChildContext();
        for (var j in M)
          if (!(j in y))
            throw new Error((nn(a) || "Unknown") + '.getChildContext(): key "' + j + '" is not defined in childContextTypes.');
        {
          var B = nn(a) || "Unknown";
          As(y, M, "child context", B);
        }
        return pn({}, f, M);
      }
    }
    function HS(a) {
      {
        var i = a.stateNode, f = i && i.__reactInternalMemoizedMergedChildContext || Ri;
        return yR = Cc.current, la(Cc, f, a), la(wl, wl.current, a), !0;
      }
    }
    function JN(a, i, f) {
      {
        var v = a.stateNode;
        if (!v)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var y = QN(a, i, yR);
          v.__reactInternalMemoizedMergedChildContext = y, sa(wl, a), sa(Cc, a), la(Cc, y, a), la(wl, f, a);
        } else
          sa(wl, a), la(wl, f, a);
      }
    }
    function O8(a) {
      {
        if (!wg(a) || a.tag !== m)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var i = a;
        do {
          switch (i.tag) {
            case x:
              return i.stateNode.context;
            case m: {
              var f = i.type;
              if (Tl(f))
                return i.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          i = i.return;
        } while (i !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Bu = 0, WS = 1, wc = null, xR = !1, SR = !1;
    function ZN(a) {
      wc === null ? wc = [a] : wc.push(a);
    }
    function P8(a) {
      xR = !0, ZN(a);
    }
    function eI() {
      xR && zu();
    }
    function zu() {
      if (!SR && wc !== null) {
        SR = !0;
        var a = 0, i = qa();
        try {
          var f = !0, v = wc;
          for (gr(Tr); a < v.length; a++) {
            var y = v[a];
            do
              y = y(f);
            while (y !== null);
          }
          wc = null, xR = !1;
        } catch (w) {
          throw wc !== null && (wc = wc.slice(a + 1)), Yp(Kp, zu), w;
        } finally {
          gr(i), SR = !1;
        }
      }
      return null;
    }
    var Qh = [], Jh = 0, qS = null, YS = 0, Gi = [], Ki = 0, Sf = null, Tc = 1, Ec = "";
    function $8(a) {
      return wf(), (a.flags & xg) !== Ut;
    }
    function D8(a) {
      return wf(), YS;
    }
    function k8() {
      var a = Ec, i = Tc, f = i & ~M8(i);
      return f.toString(32) + a;
    }
    function Cf(a, i) {
      wf(), Qh[Jh++] = YS, Qh[Jh++] = qS, qS = a, YS = i;
    }
    function tI(a, i, f) {
      wf(), Gi[Ki++] = Tc, Gi[Ki++] = Ec, Gi[Ki++] = Sf, Sf = a;
      var v = Tc, y = Ec, w = GS(v) - 1, M = v & ~(1 << w), j = f + 1, B = GS(i) + w;
      if (B > 30) {
        var Q = w - w % 5, re = (1 << Q) - 1, Ce = (M & re).toString(32), xe = M >> Q, Le = w - Q, je = GS(i) + Le, Ue = j << Le, gt = Ue | xe, Ht = Ce + y;
        Tc = 1 << je | gt, Ec = Ht;
      } else {
        var Ft = j << w, yn = Ft | M, mn = y;
        Tc = 1 << B | yn, Ec = mn;
      }
    }
    function CR(a) {
      wf();
      var i = a.return;
      if (i !== null) {
        var f = 1, v = 0;
        Cf(a, f), tI(a, f, v);
      }
    }
    function GS(a) {
      return 32 - hu(a);
    }
    function M8(a) {
      return 1 << GS(a) - 1;
    }
    function wR(a) {
      for (; a === qS; )
        qS = Qh[--Jh], Qh[Jh] = null, YS = Qh[--Jh], Qh[Jh] = null;
      for (; a === Sf; )
        Sf = Gi[--Ki], Gi[Ki] = null, Ec = Gi[--Ki], Gi[Ki] = null, Tc = Gi[--Ki], Gi[Ki] = null;
    }
    function N8() {
      return wf(), Sf !== null ? {
        id: Tc,
        overflow: Ec
      } : null;
    }
    function I8(a, i) {
      wf(), Gi[Ki++] = Tc, Gi[Ki++] = Ec, Gi[Ki++] = Sf, Tc = i.id, Ec = i.overflow, Sf = a;
    }
    function wf() {
      Ao() || u("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var _o = null, Xi = null, Ls = !1, Tf = !1, Uu = null;
    function _8() {
      Ls && u("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function nI() {
      Tf = !0;
    }
    function A8() {
      return Tf;
    }
    function L8(a) {
      var i = a.stateNode.containerInfo;
      return Xi = t8(i), _o = a, Ls = !0, Uu = null, Tf = !1, !0;
    }
    function F8(a, i, f) {
      return Xi = n8(i), _o = a, Ls = !0, Uu = null, Tf = !1, f !== null && I8(a, f), !0;
    }
    function rI(a, i) {
      switch (a.tag) {
        case x: {
          f8(a.stateNode.containerInfo, i);
          break;
        }
        case R: {
          var f = (a.mode & Lt) !== _t;
          h8(
            a.type,
            a.memoizedProps,
            a.stateNode,
            i,
            // TODO: Delete this argument when we remove the legacy root API.
            f
          );
          break;
        }
        case N: {
          var v = a.memoizedState;
          v.dehydrated !== null && p8(v.dehydrated, i);
          break;
        }
      }
    }
    function oI(a, i) {
      rI(a, i);
      var f = z7();
      f.stateNode = i, f.return = a;
      var v = a.deletions;
      v === null ? (a.deletions = [f], a.flags |= On) : v.push(f);
    }
    function TR(a, i) {
      {
        if (Tf)
          return;
        switch (a.tag) {
          case x: {
            var f = a.stateNode.containerInfo;
            switch (i.tag) {
              case R:
                var v = i.type;
                i.pendingProps, m8(f, v);
                break;
              case T:
                var y = i.pendingProps;
                v8(f, y);
                break;
            }
            break;
          }
          case R: {
            var w = a.type, M = a.memoizedProps, j = a.stateNode;
            switch (i.tag) {
              case R: {
                var B = i.type, Q = i.pendingProps, re = (a.mode & Lt) !== _t;
                b8(
                  w,
                  M,
                  j,
                  B,
                  Q,
                  // TODO: Delete this argument when we remove the legacy root API.
                  re
                );
                break;
              }
              case T: {
                var Ce = i.pendingProps, xe = (a.mode & Lt) !== _t;
                x8(
                  w,
                  M,
                  j,
                  Ce,
                  // TODO: Delete this argument when we remove the legacy root API.
                  xe
                );
                break;
              }
            }
            break;
          }
          case N: {
            var Le = a.memoizedState, je = Le.dehydrated;
            if (je !== null) switch (i.tag) {
              case R:
                var Ue = i.type;
                i.pendingProps, g8(je, Ue);
                break;
              case T:
                var gt = i.pendingProps;
                y8(je, gt);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function aI(a, i) {
      i.flags = i.flags & ~Va | Jn, TR(a, i);
    }
    function iI(a, i) {
      switch (a.tag) {
        case R: {
          var f = a.type;
          a.pendingProps;
          var v = K6(i, f);
          return v !== null ? (a.stateNode = v, _o = a, Xi = e8(v), !0) : !1;
        }
        case T: {
          var y = a.pendingProps, w = X6(i, y);
          return w !== null ? (a.stateNode = w, _o = a, Xi = null, !0) : !1;
        }
        case N: {
          var M = Q6(i);
          if (M !== null) {
            var j = {
              dehydrated: M,
              treeContext: N8(),
              retryLane: To
            };
            a.memoizedState = j;
            var B = U7(M);
            return B.return = a, a.child = B, _o = a, Xi = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function ER(a) {
      return (a.mode & Lt) !== _t && (a.flags & Kt) === Ut;
    }
    function RR(a) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function OR(a) {
      if (Ls) {
        var i = Xi;
        if (!i) {
          ER(a) && (TR(_o, a), RR()), aI(_o, a), Ls = !1, _o = a;
          return;
        }
        var f = i;
        if (!iI(a, i)) {
          ER(a) && (TR(_o, a), RR()), i = uy(f);
          var v = _o;
          if (!i || !iI(a, i)) {
            aI(_o, a), Ls = !1, _o = a;
            return;
          }
          oI(v, f);
        }
      }
    }
    function j8(a, i, f) {
      var v = a.stateNode, y = !Tf, w = r8(v, a.type, a.memoizedProps, i, f, a, y);
      return a.updateQueue = w, w !== null;
    }
    function V8(a) {
      var i = a.stateNode, f = a.memoizedProps, v = o8(i, f, a);
      if (v) {
        var y = _o;
        if (y !== null)
          switch (y.tag) {
            case x: {
              var w = y.stateNode.containerInfo, M = (y.mode & Lt) !== _t;
              u8(
                w,
                i,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                M
              );
              break;
            }
            case R: {
              var j = y.type, B = y.memoizedProps, Q = y.stateNode, re = (y.mode & Lt) !== _t;
              d8(
                j,
                B,
                Q,
                i,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                re
              );
              break;
            }
          }
      }
      return v;
    }
    function B8(a) {
      var i = a.memoizedState, f = i !== null ? i.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      a8(f, a);
    }
    function z8(a) {
      var i = a.memoizedState, f = i !== null ? i.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return i8(f);
    }
    function sI(a) {
      for (var i = a.return; i !== null && i.tag !== R && i.tag !== x && i.tag !== N; )
        i = i.return;
      _o = i;
    }
    function KS(a) {
      if (a !== _o)
        return !1;
      if (!Ls)
        return sI(a), Ls = !0, !1;
      if (a.tag !== x && (a.tag !== R || c8(a.type) && !lR(a.type, a.memoizedProps))) {
        var i = Xi;
        if (i)
          if (ER(a))
            lI(a), RR();
          else
            for (; i; )
              oI(a, i), i = uy(i);
      }
      return sI(a), a.tag === N ? Xi = z8(a) : Xi = _o ? uy(a.stateNode) : null, !0;
    }
    function U8() {
      return Ls && Xi !== null;
    }
    function lI(a) {
      for (var i = Xi; i; )
        rI(a, i), i = uy(i);
    }
    function Zh() {
      _o = null, Xi = null, Ls = !1, Tf = !1;
    }
    function cI() {
      Uu !== null && (n2(Uu), Uu = null);
    }
    function Ao() {
      return Ls;
    }
    function PR(a) {
      Uu === null ? Uu = [a] : Uu.push(a);
    }
    var H8 = n.ReactCurrentBatchConfig, W8 = null;
    function q8() {
      return H8.transition;
    }
    var Fs = {
      recordUnsafeLifecycleWarnings: function(a, i) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(a, i) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var Y8 = function(a) {
        for (var i = null, f = a; f !== null; )
          f.mode & un && (i = f), f = f.return;
        return i;
      }, Ef = function(a) {
        var i = [];
        return a.forEach(function(f) {
          i.push(f);
        }), i.sort().join(", ");
      }, hy = [], my = [], vy = [], gy = [], yy = [], by = [], Rf = /* @__PURE__ */ new Set();
      Fs.recordUnsafeLifecycleWarnings = function(a, i) {
        Rf.has(a.type) || (typeof i.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        i.componentWillMount.__suppressDeprecationWarning !== !0 && hy.push(a), a.mode & un && typeof i.UNSAFE_componentWillMount == "function" && my.push(a), typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && vy.push(a), a.mode & un && typeof i.UNSAFE_componentWillReceiveProps == "function" && gy.push(a), typeof i.componentWillUpdate == "function" && i.componentWillUpdate.__suppressDeprecationWarning !== !0 && yy.push(a), a.mode & un && typeof i.UNSAFE_componentWillUpdate == "function" && by.push(a));
      }, Fs.flushPendingUnsafeLifecycleWarnings = function() {
        var a = /* @__PURE__ */ new Set();
        hy.length > 0 && (hy.forEach(function(xe) {
          a.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), hy = []);
        var i = /* @__PURE__ */ new Set();
        my.length > 0 && (my.forEach(function(xe) {
          i.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), my = []);
        var f = /* @__PURE__ */ new Set();
        vy.length > 0 && (vy.forEach(function(xe) {
          f.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), vy = []);
        var v = /* @__PURE__ */ new Set();
        gy.length > 0 && (gy.forEach(function(xe) {
          v.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), gy = []);
        var y = /* @__PURE__ */ new Set();
        yy.length > 0 && (yy.forEach(function(xe) {
          y.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), yy = []);
        var w = /* @__PURE__ */ new Set();
        if (by.length > 0 && (by.forEach(function(xe) {
          w.add(nn(xe) || "Component"), Rf.add(xe.type);
        }), by = []), i.size > 0) {
          var M = Ef(i);
          u(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, M);
        }
        if (v.size > 0) {
          var j = Ef(v);
          u(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, j);
        }
        if (w.size > 0) {
          var B = Ef(w);
          u(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, B);
        }
        if (a.size > 0) {
          var Q = Ef(a);
          l(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Q);
        }
        if (f.size > 0) {
          var re = Ef(f);
          l(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, re);
        }
        if (y.size > 0) {
          var Ce = Ef(y);
          l(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ce);
        }
      };
      var XS = /* @__PURE__ */ new Map(), uI = /* @__PURE__ */ new Set();
      Fs.recordLegacyContextWarning = function(a, i) {
        var f = Y8(a);
        if (f === null) {
          u("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!uI.has(a.type)) {
          var v = XS.get(f);
          (a.type.contextTypes != null || a.type.childContextTypes != null || i !== null && typeof i.getChildContext == "function") && (v === void 0 && (v = [], XS.set(f, v)), v.push(a));
        }
      }, Fs.flushLegacyContextWarning = function() {
        XS.forEach(function(a, i) {
          if (a.length !== 0) {
            var f = a[0], v = /* @__PURE__ */ new Set();
            a.forEach(function(w) {
              v.add(nn(w) || "Component"), uI.add(w.type);
            });
            var y = Ef(v);
            try {
              _n(f), u(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, y);
            } finally {
              Fr();
            }
          }
        });
      }, Fs.discardPendingWarnings = function() {
        hy = [], my = [], vy = [], gy = [], yy = [], by = [], XS = /* @__PURE__ */ new Map();
      };
    }
    var $R, DR, kR, MR, NR, dI = function(a, i) {
    };
    $R = !1, DR = !1, kR = {}, MR = {}, NR = {}, dI = function(a, i) {
      if (!(a === null || typeof a != "object") && !(!a._store || a._store.validated || a.key != null)) {
        if (typeof a._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        a._store.validated = !0;
        var f = nn(i) || "Component";
        MR[f] || (MR[f] = !0, u('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function G8(a) {
      return a.prototype && a.prototype.isReactComponent;
    }
    function xy(a, i, f) {
      var v = f.ref;
      if (v !== null && typeof v != "function" && typeof v != "object") {
        if ((a.mode & un || we) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self) && // Will already throw with "Function components cannot have string refs"
        !(f._owner && f._owner.tag !== m) && // Will already warn with "Function components cannot be given refs"
        !(typeof f.type == "function" && !G8(f.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        f._owner) {
          var y = nn(a) || "Component";
          kR[y] || (u('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', y, v), kR[y] = !0);
        }
        if (f._owner) {
          var w = f._owner, M;
          if (w) {
            var j = w;
            if (j.tag !== m)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            M = j.stateNode;
          }
          if (!M)
            throw new Error("Missing owner for string ref " + v + ". This error is likely caused by a bug in React. Please file an issue.");
          var B = M;
          Pt(v, "ref");
          var Q = "" + v;
          if (i !== null && i.ref !== null && typeof i.ref == "function" && i.ref._stringRef === Q)
            return i.ref;
          var re = function(Ce) {
            var xe = B.refs;
            Ce === null ? delete xe[Q] : xe[Q] = Ce;
          };
          return re._stringRef = Q, re;
        } else {
          if (typeof v != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner)
            throw new Error("Element ref was specified as a string (" + v + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return v;
    }
    function QS(a, i) {
      var f = Object.prototype.toString.call(i);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function JS(a) {
      {
        var i = nn(a) || "Component";
        if (NR[i])
          return;
        NR[i] = !0, u("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function fI(a) {
      var i = a._payload, f = a._init;
      return f(i);
    }
    function pI(a) {
      function i(ke, He) {
        if (a) {
          var Me = ke.deletions;
          Me === null ? (ke.deletions = [He], ke.flags |= On) : Me.push(He);
        }
      }
      function f(ke, He) {
        if (!a)
          return null;
        for (var Me = He; Me !== null; )
          i(ke, Me), Me = Me.sibling;
        return null;
      }
      function v(ke, He) {
        for (var Me = /* @__PURE__ */ new Map(), nt = He; nt !== null; )
          nt.key !== null ? Me.set(nt.key, nt) : Me.set(nt.index, nt), nt = nt.sibling;
        return Me;
      }
      function y(ke, He) {
        var Me = _f(ke, He);
        return Me.index = 0, Me.sibling = null, Me;
      }
      function w(ke, He, Me) {
        if (ke.index = Me, !a)
          return ke.flags |= xg, He;
        var nt = ke.alternate;
        if (nt !== null) {
          var Et = nt.index;
          return Et < He ? (ke.flags |= Jn, He) : Et;
        } else
          return ke.flags |= Jn, He;
      }
      function M(ke) {
        return a && ke.alternate === null && (ke.flags |= Jn), ke;
      }
      function j(ke, He, Me, nt) {
        if (He === null || He.tag !== T) {
          var Et = PP(Me, ke.mode, nt);
          return Et.return = ke, Et;
        } else {
          var yt = y(He, Me);
          return yt.return = ke, yt;
        }
      }
      function B(ke, He, Me, nt) {
        var Et = Me.type;
        if (Et === Kn)
          return re(ke, He, Me.props.children, nt, Me.key);
        if (He !== null && (He.elementType === Et || // Keep this check inline so it only runs on the false path:
        y2(He, Me) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Et == "object" && Et !== null && Et.$$typeof === mt && fI(Et) === He.type)) {
          var yt = y(He, Me.props);
          return yt.ref = xy(ke, He, Me), yt.return = ke, yt._debugSource = Me._source, yt._debugOwner = Me._owner, yt;
        }
        var Gt = OP(Me, ke.mode, nt);
        return Gt.ref = xy(ke, He, Me), Gt.return = ke, Gt;
      }
      function Q(ke, He, Me, nt) {
        if (He === null || He.tag !== S || He.stateNode.containerInfo !== Me.containerInfo || He.stateNode.implementation !== Me.implementation) {
          var Et = $P(Me, ke.mode, nt);
          return Et.return = ke, Et;
        } else {
          var yt = y(He, Me.children || []);
          return yt.return = ke, yt;
        }
      }
      function re(ke, He, Me, nt, Et) {
        if (He === null || He.tag !== E) {
          var yt = ed(Me, ke.mode, nt, Et);
          return yt.return = ke, yt;
        } else {
          var Gt = y(He, Me);
          return Gt.return = ke, Gt;
        }
      }
      function Ce(ke, He, Me) {
        if (typeof He == "string" && He !== "" || typeof He == "number") {
          var nt = PP("" + He, ke.mode, Me);
          return nt.return = ke, nt;
        }
        if (typeof He == "object" && He !== null) {
          switch (He.$$typeof) {
            case ko: {
              var Et = OP(He, ke.mode, Me);
              return Et.ref = xy(ke, null, He), Et.return = ke, Et;
            }
            case Lr: {
              var yt = $P(He, ke.mode, Me);
              return yt.return = ke, yt;
            }
            case mt: {
              var Gt = He._payload, Zt = He._init;
              return Ce(ke, Zt(Gt), Me);
            }
          }
          if (Gr(He) || xs(He)) {
            var Ln = ed(He, ke.mode, Me, null);
            return Ln.return = ke, Ln;
          }
          QS(ke, He);
        }
        return typeof He == "function" && JS(ke), null;
      }
      function xe(ke, He, Me, nt) {
        var Et = He !== null ? He.key : null;
        if (typeof Me == "string" && Me !== "" || typeof Me == "number")
          return Et !== null ? null : j(ke, He, "" + Me, nt);
        if (typeof Me == "object" && Me !== null) {
          switch (Me.$$typeof) {
            case ko:
              return Me.key === Et ? B(ke, He, Me, nt) : null;
            case Lr:
              return Me.key === Et ? Q(ke, He, Me, nt) : null;
            case mt: {
              var yt = Me._payload, Gt = Me._init;
              return xe(ke, He, Gt(yt), nt);
            }
          }
          if (Gr(Me) || xs(Me))
            return Et !== null ? null : re(ke, He, Me, nt, null);
          QS(ke, Me);
        }
        return typeof Me == "function" && JS(ke), null;
      }
      function Le(ke, He, Me, nt, Et) {
        if (typeof nt == "string" && nt !== "" || typeof nt == "number") {
          var yt = ke.get(Me) || null;
          return j(He, yt, "" + nt, Et);
        }
        if (typeof nt == "object" && nt !== null) {
          switch (nt.$$typeof) {
            case ko: {
              var Gt = ke.get(nt.key === null ? Me : nt.key) || null;
              return B(He, Gt, nt, Et);
            }
            case Lr: {
              var Zt = ke.get(nt.key === null ? Me : nt.key) || null;
              return Q(He, Zt, nt, Et);
            }
            case mt:
              var Ln = nt._payload, Tn = nt._init;
              return Le(ke, He, Me, Tn(Ln), Et);
          }
          if (Gr(nt) || xs(nt)) {
            var Hr = ke.get(Me) || null;
            return re(He, Hr, nt, Et, null);
          }
          QS(He, nt);
        }
        return typeof nt == "function" && JS(He), null;
      }
      function je(ke, He, Me) {
        {
          if (typeof ke != "object" || ke === null)
            return He;
          switch (ke.$$typeof) {
            case ko:
            case Lr:
              dI(ke, Me);
              var nt = ke.key;
              if (typeof nt != "string")
                break;
              if (He === null) {
                He = /* @__PURE__ */ new Set(), He.add(nt);
                break;
              }
              if (!He.has(nt)) {
                He.add(nt);
                break;
              }
              u("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", nt);
              break;
            case mt:
              var Et = ke._payload, yt = ke._init;
              je(yt(Et), He, Me);
              break;
          }
        }
        return He;
      }
      function Ue(ke, He, Me, nt) {
        for (var Et = null, yt = 0; yt < Me.length; yt++) {
          var Gt = Me[yt];
          Et = je(Gt, Et, ke);
        }
        for (var Zt = null, Ln = null, Tn = He, Hr = 0, En = 0, Mr = null; Tn !== null && En < Me.length; En++) {
          Tn.index > En ? (Mr = Tn, Tn = null) : Mr = Tn.sibling;
          var ua = xe(ke, Tn, Me[En], nt);
          if (ua === null) {
            Tn === null && (Tn = Mr);
            break;
          }
          a && Tn && ua.alternate === null && i(ke, Tn), Hr = w(ua, Hr, En), Ln === null ? Zt = ua : Ln.sibling = ua, Ln = ua, Tn = Mr;
        }
        if (En === Me.length) {
          if (f(ke, Tn), Ao()) {
            var Uo = En;
            Cf(ke, Uo);
          }
          return Zt;
        }
        if (Tn === null) {
          for (; En < Me.length; En++) {
            var Pi = Ce(ke, Me[En], nt);
            Pi !== null && (Hr = w(Pi, Hr, En), Ln === null ? Zt = Pi : Ln.sibling = Pi, Ln = Pi);
          }
          if (Ao()) {
            var Ea = En;
            Cf(ke, Ea);
          }
          return Zt;
        }
        for (var Ra = v(ke, Tn); En < Me.length; En++) {
          var da = Le(Ra, ke, En, Me[En], nt);
          da !== null && (a && da.alternate !== null && Ra.delete(da.key === null ? En : da.key), Hr = w(da, Hr, En), Ln === null ? Zt = da : Ln.sibling = da, Ln = da);
        }
        if (a && Ra.forEach(function(ym) {
          return i(ke, ym);
        }), Ao()) {
          var Mc = En;
          Cf(ke, Mc);
        }
        return Zt;
      }
      function gt(ke, He, Me, nt) {
        var Et = xs(Me);
        if (typeof Et != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Me[Symbol.toStringTag] === "Generator" && (DR || u("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), DR = !0), Me.entries === Et && ($R || u("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), $R = !0);
          var yt = Et.call(Me);
          if (yt)
            for (var Gt = null, Zt = yt.next(); !Zt.done; Zt = yt.next()) {
              var Ln = Zt.value;
              Gt = je(Ln, Gt, ke);
            }
        }
        var Tn = Et.call(Me);
        if (Tn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Hr = null, En = null, Mr = He, ua = 0, Uo = 0, Pi = null, Ea = Tn.next(); Mr !== null && !Ea.done; Uo++, Ea = Tn.next()) {
          Mr.index > Uo ? (Pi = Mr, Mr = null) : Pi = Mr.sibling;
          var Ra = xe(ke, Mr, Ea.value, nt);
          if (Ra === null) {
            Mr === null && (Mr = Pi);
            break;
          }
          a && Mr && Ra.alternate === null && i(ke, Mr), ua = w(Ra, ua, Uo), En === null ? Hr = Ra : En.sibling = Ra, En = Ra, Mr = Pi;
        }
        if (Ea.done) {
          if (f(ke, Mr), Ao()) {
            var da = Uo;
            Cf(ke, da);
          }
          return Hr;
        }
        if (Mr === null) {
          for (; !Ea.done; Uo++, Ea = Tn.next()) {
            var Mc = Ce(ke, Ea.value, nt);
            Mc !== null && (ua = w(Mc, ua, Uo), En === null ? Hr = Mc : En.sibling = Mc, En = Mc);
          }
          if (Ao()) {
            var ym = Uo;
            Cf(ke, ym);
          }
          return Hr;
        }
        for (var Jy = v(ke, Mr); !Ea.done; Uo++, Ea = Tn.next()) {
          var Ml = Le(Jy, ke, Uo, Ea.value, nt);
          Ml !== null && (a && Ml.alternate !== null && Jy.delete(Ml.key === null ? Uo : Ml.key), ua = w(Ml, ua, Uo), En === null ? Hr = Ml : En.sibling = Ml, En = Ml);
        }
        if (a && Jy.forEach(function(xq) {
          return i(ke, xq);
        }), Ao()) {
          var bq = Uo;
          Cf(ke, bq);
        }
        return Hr;
      }
      function Ht(ke, He, Me, nt) {
        if (He !== null && He.tag === T) {
          f(ke, He.sibling);
          var Et = y(He, Me);
          return Et.return = ke, Et;
        }
        f(ke, He);
        var yt = PP(Me, ke.mode, nt);
        return yt.return = ke, yt;
      }
      function Ft(ke, He, Me, nt) {
        for (var Et = Me.key, yt = He; yt !== null; ) {
          if (yt.key === Et) {
            var Gt = Me.type;
            if (Gt === Kn) {
              if (yt.tag === E) {
                f(ke, yt.sibling);
                var Zt = y(yt, Me.props.children);
                return Zt.return = ke, Zt._debugSource = Me._source, Zt._debugOwner = Me._owner, Zt;
              }
            } else if (yt.elementType === Gt || // Keep this check inline so it only runs on the false path:
            y2(yt, Me) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Gt == "object" && Gt !== null && Gt.$$typeof === mt && fI(Gt) === yt.type) {
              f(ke, yt.sibling);
              var Ln = y(yt, Me.props);
              return Ln.ref = xy(ke, yt, Me), Ln.return = ke, Ln._debugSource = Me._source, Ln._debugOwner = Me._owner, Ln;
            }
            f(ke, yt);
            break;
          } else
            i(ke, yt);
          yt = yt.sibling;
        }
        if (Me.type === Kn) {
          var Tn = ed(Me.props.children, ke.mode, nt, Me.key);
          return Tn.return = ke, Tn;
        } else {
          var Hr = OP(Me, ke.mode, nt);
          return Hr.ref = xy(ke, He, Me), Hr.return = ke, Hr;
        }
      }
      function yn(ke, He, Me, nt) {
        for (var Et = Me.key, yt = He; yt !== null; ) {
          if (yt.key === Et)
            if (yt.tag === S && yt.stateNode.containerInfo === Me.containerInfo && yt.stateNode.implementation === Me.implementation) {
              f(ke, yt.sibling);
              var Gt = y(yt, Me.children || []);
              return Gt.return = ke, Gt;
            } else {
              f(ke, yt);
              break;
            }
          else
            i(ke, yt);
          yt = yt.sibling;
        }
        var Zt = $P(Me, ke.mode, nt);
        return Zt.return = ke, Zt;
      }
      function mn(ke, He, Me, nt) {
        var Et = typeof Me == "object" && Me !== null && Me.type === Kn && Me.key === null;
        if (Et && (Me = Me.props.children), typeof Me == "object" && Me !== null) {
          switch (Me.$$typeof) {
            case ko:
              return M(Ft(ke, He, Me, nt));
            case Lr:
              return M(yn(ke, He, Me, nt));
            case mt:
              var yt = Me._payload, Gt = Me._init;
              return mn(ke, He, Gt(yt), nt);
          }
          if (Gr(Me))
            return Ue(ke, He, Me, nt);
          if (xs(Me))
            return gt(ke, He, Me, nt);
          QS(ke, Me);
        }
        return typeof Me == "string" && Me !== "" || typeof Me == "number" ? M(Ht(ke, He, "" + Me, nt)) : (typeof Me == "function" && JS(ke), f(ke, He));
      }
      return mn;
    }
    var em = pI(!0), hI = pI(!1);
    function K8(a, i) {
      if (a !== null && i.child !== a.child)
        throw new Error("Resuming work not yet implemented.");
      if (i.child !== null) {
        var f = i.child, v = _f(f, f.pendingProps);
        for (i.child = v, v.return = i; f.sibling !== null; )
          f = f.sibling, v = v.sibling = _f(f, f.pendingProps), v.return = i;
        v.sibling = null;
      }
    }
    function X8(a, i) {
      for (var f = a.child; f !== null; )
        L7(f, i), f = f.sibling;
    }
    var IR = Vu(null), _R;
    _R = {};
    var ZS = null, tm = null, AR = null, eC = !1;
    function tC() {
      ZS = null, tm = null, AR = null, eC = !1;
    }
    function mI() {
      eC = !0;
    }
    function vI() {
      eC = !1;
    }
    function gI(a, i, f) {
      la(IR, i._currentValue, a), i._currentValue = f, i._currentRenderer !== void 0 && i._currentRenderer !== null && i._currentRenderer !== _R && u("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), i._currentRenderer = _R;
    }
    function LR(a, i) {
      var f = IR.current;
      sa(IR, i), a._currentValue = f;
    }
    function FR(a, i, f) {
      for (var v = a; v !== null; ) {
        var y = v.alternate;
        if (pc(v.childLanes, i) ? y !== null && !pc(y.childLanes, i) && (y.childLanes = rn(y.childLanes, i)) : (v.childLanes = rn(v.childLanes, i), y !== null && (y.childLanes = rn(y.childLanes, i))), v === f)
          break;
        v = v.return;
      }
      v !== f && u("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Q8(a, i, f) {
      J8(a, i, f);
    }
    function J8(a, i, f) {
      var v = a.child;
      for (v !== null && (v.return = a); v !== null; ) {
        var y = void 0, w = v.dependencies;
        if (w !== null) {
          y = v.child;
          for (var M = w.firstContext; M !== null; ) {
            if (M.context === i) {
              if (v.tag === m) {
                var j = Su(f), B = Rc(Xn, j);
                B.tag = rC;
                var Q = v.updateQueue;
                if (Q !== null) {
                  var re = Q.shared, Ce = re.pending;
                  Ce === null ? B.next = B : (B.next = Ce.next, Ce.next = B), re.pending = B;
                }
              }
              v.lanes = rn(v.lanes, f);
              var xe = v.alternate;
              xe !== null && (xe.lanes = rn(xe.lanes, f)), FR(v.return, f, a), w.lanes = rn(w.lanes, f);
              break;
            }
            M = M.next;
          }
        } else if (v.tag === _)
          y = v.type === a.type ? null : v.child;
        else if (v.tag === K) {
          var Le = v.return;
          if (Le === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Le.lanes = rn(Le.lanes, f);
          var je = Le.alternate;
          je !== null && (je.lanes = rn(je.lanes, f)), FR(Le, f, a), y = v.sibling;
        } else
          y = v.child;
        if (y !== null)
          y.return = v;
        else
          for (y = v; y !== null; ) {
            if (y === a) {
              y = null;
              break;
            }
            var Ue = y.sibling;
            if (Ue !== null) {
              Ue.return = y.return, y = Ue;
              break;
            }
            y = y.return;
          }
        v = y;
      }
    }
    function nm(a, i) {
      ZS = a, tm = null, AR = null;
      var f = a.dependencies;
      if (f !== null) {
        var v = f.firstContext;
        v !== null && (aa(f.lanes, i) && _y(), f.firstContext = null);
      }
    }
    function eo(a) {
      eC && u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var i = a._currentValue;
      if (AR !== a) {
        var f = {
          context: a,
          memoizedValue: i,
          next: null
        };
        if (tm === null) {
          if (ZS === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          tm = f, ZS.dependencies = {
            lanes: Ge,
            firstContext: f
          };
        } else
          tm = tm.next = f;
      }
      return i;
    }
    var Of = null;
    function jR(a) {
      Of === null ? Of = [a] : Of.push(a);
    }
    function Z8() {
      if (Of !== null) {
        for (var a = 0; a < Of.length; a++) {
          var i = Of[a], f = i.interleaved;
          if (f !== null) {
            i.interleaved = null;
            var v = f.next, y = i.pending;
            if (y !== null) {
              var w = y.next;
              y.next = v, f.next = w;
            }
            i.pending = f;
          }
        }
        Of = null;
      }
    }
    function yI(a, i, f, v) {
      var y = i.interleaved;
      return y === null ? (f.next = f, jR(i)) : (f.next = y.next, y.next = f), i.interleaved = f, nC(a, v);
    }
    function eW(a, i, f, v) {
      var y = i.interleaved;
      y === null ? (f.next = f, jR(i)) : (f.next = y.next, y.next = f), i.interleaved = f;
    }
    function tW(a, i, f, v) {
      var y = i.interleaved;
      return y === null ? (f.next = f, jR(i)) : (f.next = y.next, y.next = f), i.interleaved = f, nC(a, v);
    }
    function Ja(a, i) {
      return nC(a, i);
    }
    var nW = nC;
    function nC(a, i) {
      a.lanes = rn(a.lanes, i);
      var f = a.alternate;
      f !== null && (f.lanes = rn(f.lanes, i)), f === null && (a.flags & (Jn | Va)) !== Ut && h2(a);
      for (var v = a, y = a.return; y !== null; )
        y.childLanes = rn(y.childLanes, i), f = y.alternate, f !== null ? f.childLanes = rn(f.childLanes, i) : (y.flags & (Jn | Va)) !== Ut && h2(a), v = y, y = y.return;
      if (v.tag === x) {
        var w = v.stateNode;
        return w;
      } else
        return null;
    }
    var bI = 0, xI = 1, rC = 2, VR = 3, oC = !1, BR, aC;
    BR = !1, aC = null;
    function zR(a) {
      var i = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Ge
        },
        effects: null
      };
      a.updateQueue = i;
    }
    function SI(a, i) {
      var f = i.updateQueue, v = a.updateQueue;
      if (f === v) {
        var y = {
          baseState: v.baseState,
          firstBaseUpdate: v.firstBaseUpdate,
          lastBaseUpdate: v.lastBaseUpdate,
          shared: v.shared,
          effects: v.effects
        };
        i.updateQueue = y;
      }
    }
    function Rc(a, i) {
      var f = {
        eventTime: a,
        lane: i,
        tag: bI,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function Hu(a, i, f) {
      var v = a.updateQueue;
      if (v === null)
        return null;
      var y = v.shared;
      if (aC === y && !BR && (u("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), BR = !0), e7()) {
        var w = y.pending;
        return w === null ? i.next = i : (i.next = w.next, w.next = i), y.pending = i, nW(a, f);
      } else
        return tW(a, y, i, f);
    }
    function iC(a, i, f) {
      var v = i.updateQueue;
      if (v !== null) {
        var y = v.shared;
        if (_g(f)) {
          var w = y.lanes;
          w = bh(w, a.pendingLanes);
          var M = rn(w, f);
          y.lanes = M, Ag(a, M);
        }
      }
    }
    function UR(a, i) {
      var f = a.updateQueue, v = a.alternate;
      if (v !== null) {
        var y = v.updateQueue;
        if (f === y) {
          var w = null, M = null, j = f.firstBaseUpdate;
          if (j !== null) {
            var B = j;
            do {
              var Q = {
                eventTime: B.eventTime,
                lane: B.lane,
                tag: B.tag,
                payload: B.payload,
                callback: B.callback,
                next: null
              };
              M === null ? w = M = Q : (M.next = Q, M = Q), B = B.next;
            } while (B !== null);
            M === null ? w = M = i : (M.next = i, M = i);
          } else
            w = M = i;
          f = {
            baseState: y.baseState,
            firstBaseUpdate: w,
            lastBaseUpdate: M,
            shared: y.shared,
            effects: y.effects
          }, a.updateQueue = f;
          return;
        }
      }
      var re = f.lastBaseUpdate;
      re === null ? f.firstBaseUpdate = i : re.next = i, f.lastBaseUpdate = i;
    }
    function rW(a, i, f, v, y, w) {
      switch (f.tag) {
        case xI: {
          var M = f.payload;
          if (typeof M == "function") {
            mI();
            var j = M.call(w, v, y);
            {
              if (a.mode & un) {
                Dr(!0);
                try {
                  M.call(w, v, y);
                } finally {
                  Dr(!1);
                }
              }
              vI();
            }
            return j;
          }
          return M;
        }
        case VR:
          a.flags = a.flags & ~Xr | Kt;
        case bI: {
          var B = f.payload, Q;
          if (typeof B == "function") {
            mI(), Q = B.call(w, v, y);
            {
              if (a.mode & un) {
                Dr(!0);
                try {
                  B.call(w, v, y);
                } finally {
                  Dr(!1);
                }
              }
              vI();
            }
          } else
            Q = B;
          return Q == null ? v : pn({}, v, Q);
        }
        case rC:
          return oC = !0, v;
      }
      return v;
    }
    function sC(a, i, f, v) {
      var y = a.updateQueue;
      oC = !1, aC = y.shared;
      var w = y.firstBaseUpdate, M = y.lastBaseUpdate, j = y.shared.pending;
      if (j !== null) {
        y.shared.pending = null;
        var B = j, Q = B.next;
        B.next = null, M === null ? w = Q : M.next = Q, M = B;
        var re = a.alternate;
        if (re !== null) {
          var Ce = re.updateQueue, xe = Ce.lastBaseUpdate;
          xe !== M && (xe === null ? Ce.firstBaseUpdate = Q : xe.next = Q, Ce.lastBaseUpdate = B);
        }
      }
      if (w !== null) {
        var Le = y.baseState, je = Ge, Ue = null, gt = null, Ht = null, Ft = w;
        do {
          var yn = Ft.lane, mn = Ft.eventTime;
          if (pc(v, yn)) {
            if (Ht !== null) {
              var He = {
                eventTime: mn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: kr,
                tag: Ft.tag,
                payload: Ft.payload,
                callback: Ft.callback,
                next: null
              };
              Ht = Ht.next = He;
            }
            Le = rW(a, y, Ft, Le, i, f);
            var Me = Ft.callback;
            if (Me !== null && // If the update was already committed, we should not queue its
            // callback again.
            Ft.lane !== kr) {
              a.flags |= zi;
              var nt = y.effects;
              nt === null ? y.effects = [Ft] : nt.push(Ft);
            }
          } else {
            var ke = {
              eventTime: mn,
              lane: yn,
              tag: Ft.tag,
              payload: Ft.payload,
              callback: Ft.callback,
              next: null
            };
            Ht === null ? (gt = Ht = ke, Ue = Le) : Ht = Ht.next = ke, je = rn(je, yn);
          }
          if (Ft = Ft.next, Ft === null) {
            if (j = y.shared.pending, j === null)
              break;
            var Et = j, yt = Et.next;
            Et.next = null, Ft = yt, y.lastBaseUpdate = Et, y.shared.pending = null;
          }
        } while (!0);
        Ht === null && (Ue = Le), y.baseState = Ue, y.firstBaseUpdate = gt, y.lastBaseUpdate = Ht;
        var Gt = y.shared.interleaved;
        if (Gt !== null) {
          var Zt = Gt;
          do
            je = rn(je, Zt.lane), Zt = Zt.next;
          while (Zt !== Gt);
        } else w === null && (y.shared.lanes = Ge);
        Yy(je), a.lanes = je, a.memoizedState = Le;
      }
      aC = null;
    }
    function oW(a, i) {
      if (typeof a != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + a));
      a.call(i);
    }
    function CI() {
      oC = !1;
    }
    function lC() {
      return oC;
    }
    function wI(a, i, f) {
      var v = i.effects;
      if (i.effects = null, v !== null)
        for (var y = 0; y < v.length; y++) {
          var w = v[y], M = w.callback;
          M !== null && (w.callback = null, oW(M, f));
        }
    }
    var Sy = {}, Wu = Vu(Sy), Cy = Vu(Sy), cC = Vu(Sy);
    function uC(a) {
      if (a === Sy)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return a;
    }
    function TI() {
      var a = uC(cC.current);
      return a;
    }
    function HR(a, i) {
      la(cC, i, a), la(Cy, a, a), la(Wu, Sy, a);
      var f = S6(i);
      sa(Wu, a), la(Wu, f, a);
    }
    function rm(a) {
      sa(Wu, a), sa(Cy, a), sa(cC, a);
    }
    function WR() {
      var a = uC(Wu.current);
      return a;
    }
    function EI(a) {
      uC(cC.current);
      var i = uC(Wu.current), f = C6(i, a.type);
      i !== f && (la(Cy, a, a), la(Wu, f, a));
    }
    function qR(a) {
      Cy.current === a && (sa(Wu, a), sa(Cy, a));
    }
    var aW = 0, RI = 1, OI = 1, wy = 2, js = Vu(aW);
    function YR(a, i) {
      return (a & i) !== 0;
    }
    function om(a) {
      return a & RI;
    }
    function GR(a, i) {
      return a & RI | i;
    }
    function iW(a, i) {
      return a | i;
    }
    function qu(a, i) {
      la(js, i, a);
    }
    function am(a) {
      sa(js, a);
    }
    function sW(a, i) {
      var f = a.memoizedState;
      return f !== null ? f.dehydrated !== null : (a.memoizedProps, !0);
    }
    function dC(a) {
      for (var i = a; i !== null; ) {
        if (i.tag === N) {
          var f = i.memoizedState;
          if (f !== null) {
            var v = f.dehydrated;
            if (v === null || HN(v) || fR(v))
              return i;
          }
        } else if (i.tag === X && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        i.memoizedProps.revealOrder !== void 0) {
          var y = (i.flags & Kt) !== Ut;
          if (y)
            return i;
        } else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === a)
          return null;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === a)
            return null;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      return null;
    }
    var Za = (
      /*   */
      0
    ), lo = (
      /* */
      1
    ), El = (
      /*  */
      2
    ), co = (
      /*    */
      4
    ), Lo = (
      /*   */
      8
    ), KR = [];
    function XR() {
      for (var a = 0; a < KR.length; a++) {
        var i = KR[a];
        i._workInProgressVersionPrimary = null;
      }
      KR.length = 0;
    }
    function lW(a, i) {
      var f = i._getVersion, v = f(i._source);
      a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [i, v] : a.mutableSourceEagerHydrationData.push(i, v);
    }
    var wt = n.ReactCurrentDispatcher, Ty = n.ReactCurrentBatchConfig, QR, im;
    QR = /* @__PURE__ */ new Set();
    var Pf = Ge, An = null, uo = null, fo = null, fC = !1, Ey = !1, Ry = 0, cW = 0, uW = 25, Ye = null, Qi = null, Yu = -1, JR = !1;
    function $n() {
      {
        var a = Ye;
        Qi === null ? Qi = [a] : Qi.push(a);
      }
    }
    function dt() {
      {
        var a = Ye;
        Qi !== null && (Yu++, Qi[Yu] !== a && dW(a));
      }
    }
    function sm(a) {
      a != null && !Gr(a) && u("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Ye, typeof a);
    }
    function dW(a) {
      {
        var i = nn(An);
        if (!QR.has(i) && (QR.add(i), Qi !== null)) {
          for (var f = "", v = 30, y = 0; y <= Yu; y++) {
            for (var w = Qi[y], M = y === Yu ? a : w, j = y + 1 + ". " + w; j.length < v; )
              j += " ";
            j += M + `
`, f += j;
          }
          u(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, i, f);
        }
      }
    }
    function ca() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function ZR(a, i) {
      if (JR)
        return !1;
      if (i === null)
        return u("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ye), !1;
      a.length !== i.length && u(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ye, "[" + i.join(", ") + "]", "[" + a.join(", ") + "]");
      for (var f = 0; f < i.length && f < a.length; f++)
        if (!Dt(a[f], i[f]))
          return !1;
      return !0;
    }
    function lm(a, i, f, v, y, w) {
      Pf = w, An = i, Qi = a !== null ? a._debugHookTypes : null, Yu = -1, JR = a !== null && a.type !== i.type, i.memoizedState = null, i.updateQueue = null, i.lanes = Ge, a !== null && a.memoizedState !== null ? wt.current = KI : Qi !== null ? wt.current = GI : wt.current = YI;
      var M = f(v, y);
      if (Ey) {
        var j = 0;
        do {
          if (Ey = !1, Ry = 0, j >= uW)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          j += 1, JR = !1, uo = null, fo = null, i.updateQueue = null, Yu = -1, wt.current = XI, M = f(v, y);
        } while (Ey);
      }
      wt.current = EC, i._debugHookTypes = Qi;
      var B = uo !== null && uo.next !== null;
      if (Pf = Ge, An = null, uo = null, fo = null, Ye = null, Qi = null, Yu = -1, a !== null && (a.flags & ao) !== (i.flags & ao) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (a.mode & Lt) !== _t && u("Internal React error: Expected static flag was missing. Please notify the React team."), fC = !1, B)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return M;
    }
    function cm() {
      var a = Ry !== 0;
      return Ry = 0, a;
    }
    function PI(a, i, f) {
      i.updateQueue = a.updateQueue, (i.mode & xa) !== _t ? i.flags &= ~(oc | Zo | or | an) : i.flags &= ~(or | an), a.lanes = of(a.lanes, f);
    }
    function $I() {
      if (wt.current = EC, fC) {
        for (var a = An.memoizedState; a !== null; ) {
          var i = a.queue;
          i !== null && (i.pending = null), a = a.next;
        }
        fC = !1;
      }
      Pf = Ge, An = null, uo = null, fo = null, Qi = null, Yu = -1, Ye = null, zI = !1, Ey = !1, Ry = 0;
    }
    function Rl() {
      var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return fo === null ? An.memoizedState = fo = a : fo = fo.next = a, fo;
    }
    function Ji() {
      var a;
      if (uo === null) {
        var i = An.alternate;
        i !== null ? a = i.memoizedState : a = null;
      } else
        a = uo.next;
      var f;
      if (fo === null ? f = An.memoizedState : f = fo.next, f !== null)
        fo = f, f = fo.next, uo = a;
      else {
        if (a === null)
          throw new Error("Rendered more hooks than during the previous render.");
        uo = a;
        var v = {
          memoizedState: uo.memoizedState,
          baseState: uo.baseState,
          baseQueue: uo.baseQueue,
          queue: uo.queue,
          next: null
        };
        fo === null ? An.memoizedState = fo = v : fo = fo.next = v;
      }
      return fo;
    }
    function DI() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function eO(a, i) {
      return typeof i == "function" ? i(a) : i;
    }
    function tO(a, i, f) {
      var v = Rl(), y;
      f !== void 0 ? y = f(i) : y = i, v.memoizedState = v.baseState = y;
      var w = {
        pending: null,
        interleaved: null,
        lanes: Ge,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: y
      };
      v.queue = w;
      var M = w.dispatch = mW.bind(null, An, w);
      return [v.memoizedState, M];
    }
    function nO(a, i, f) {
      var v = Ji(), y = v.queue;
      if (y === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      y.lastRenderedReducer = a;
      var w = uo, M = w.baseQueue, j = y.pending;
      if (j !== null) {
        if (M !== null) {
          var B = M.next, Q = j.next;
          M.next = Q, j.next = B;
        }
        w.baseQueue !== M && u("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), w.baseQueue = M = j, y.pending = null;
      }
      if (M !== null) {
        var re = M.next, Ce = w.baseState, xe = null, Le = null, je = null, Ue = re;
        do {
          var gt = Ue.lane;
          if (pc(Pf, gt)) {
            if (je !== null) {
              var Ft = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: kr,
                action: Ue.action,
                hasEagerState: Ue.hasEagerState,
                eagerState: Ue.eagerState,
                next: null
              };
              je = je.next = Ft;
            }
            if (Ue.hasEagerState)
              Ce = Ue.eagerState;
            else {
              var yn = Ue.action;
              Ce = a(Ce, yn);
            }
          } else {
            var Ht = {
              lane: gt,
              action: Ue.action,
              hasEagerState: Ue.hasEagerState,
              eagerState: Ue.eagerState,
              next: null
            };
            je === null ? (Le = je = Ht, xe = Ce) : je = je.next = Ht, An.lanes = rn(An.lanes, gt), Yy(gt);
          }
          Ue = Ue.next;
        } while (Ue !== null && Ue !== re);
        je === null ? xe = Ce : je.next = Le, Dt(Ce, v.memoizedState) || _y(), v.memoizedState = Ce, v.baseState = xe, v.baseQueue = je, y.lastRenderedState = Ce;
      }
      var mn = y.interleaved;
      if (mn !== null) {
        var ke = mn;
        do {
          var He = ke.lane;
          An.lanes = rn(An.lanes, He), Yy(He), ke = ke.next;
        } while (ke !== mn);
      } else M === null && (y.lanes = Ge);
      var Me = y.dispatch;
      return [v.memoizedState, Me];
    }
    function rO(a, i, f) {
      var v = Ji(), y = v.queue;
      if (y === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      y.lastRenderedReducer = a;
      var w = y.dispatch, M = y.pending, j = v.memoizedState;
      if (M !== null) {
        y.pending = null;
        var B = M.next, Q = B;
        do {
          var re = Q.action;
          j = a(j, re), Q = Q.next;
        } while (Q !== B);
        Dt(j, v.memoizedState) || _y(), v.memoizedState = j, v.baseQueue === null && (v.baseState = j), y.lastRenderedState = j;
      }
      return [j, w];
    }
    function V2e(a, i, f) {
    }
    function B2e(a, i, f) {
    }
    function oO(a, i, f) {
      var v = An, y = Rl(), w, M = Ao();
      if (M) {
        if (f === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        w = f(), im || w !== f() && (u("The result of getServerSnapshot should be cached to avoid an infinite loop"), im = !0);
      } else {
        if (w = i(), !im) {
          var j = i();
          Dt(w, j) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), im = !0);
        }
        var B = HC();
        if (B === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        rf(B, Pf) || kI(v, i, w);
      }
      y.memoizedState = w;
      var Q = {
        value: w,
        getSnapshot: i
      };
      return y.queue = Q, gC(NI.bind(null, v, Q, a), [a]), v.flags |= or, Oy(lo | Lo, MI.bind(null, v, Q, w, i), void 0, null), w;
    }
    function pC(a, i, f) {
      var v = An, y = Ji(), w = i();
      if (!im) {
        var M = i();
        Dt(w, M) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), im = !0);
      }
      var j = y.memoizedState, B = !Dt(j, w);
      B && (y.memoizedState = w, _y());
      var Q = y.queue;
      if ($y(NI.bind(null, v, Q, a), [a]), Q.getSnapshot !== i || B || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      fo !== null && fo.memoizedState.tag & lo) {
        v.flags |= or, Oy(lo | Lo, MI.bind(null, v, Q, w, i), void 0, null);
        var re = HC();
        if (re === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        rf(re, Pf) || kI(v, i, w);
      }
      return w;
    }
    function kI(a, i, f) {
      a.flags |= Yd;
      var v = {
        getSnapshot: i,
        value: f
      }, y = An.updateQueue;
      if (y === null)
        y = DI(), An.updateQueue = y, y.stores = [v];
      else {
        var w = y.stores;
        w === null ? y.stores = [v] : w.push(v);
      }
    }
    function MI(a, i, f, v) {
      i.value = f, i.getSnapshot = v, II(i) && _I(a);
    }
    function NI(a, i, f) {
      var v = function() {
        II(i) && _I(a);
      };
      return f(v);
    }
    function II(a) {
      var i = a.getSnapshot, f = a.value;
      try {
        var v = i();
        return !Dt(f, v);
      } catch {
        return !0;
      }
    }
    function _I(a) {
      var i = Ja(a, Bt);
      i !== null && vo(i, a, Bt, Xn);
    }
    function hC(a) {
      var i = Rl();
      typeof a == "function" && (a = a()), i.memoizedState = i.baseState = a;
      var f = {
        pending: null,
        interleaved: null,
        lanes: Ge,
        dispatch: null,
        lastRenderedReducer: eO,
        lastRenderedState: a
      };
      i.queue = f;
      var v = f.dispatch = vW.bind(null, An, f);
      return [i.memoizedState, v];
    }
    function aO(a) {
      return nO(eO);
    }
    function iO(a) {
      return rO(eO);
    }
    function Oy(a, i, f, v) {
      var y = {
        tag: a,
        create: i,
        destroy: f,
        deps: v,
        // Circular
        next: null
      }, w = An.updateQueue;
      if (w === null)
        w = DI(), An.updateQueue = w, w.lastEffect = y.next = y;
      else {
        var M = w.lastEffect;
        if (M === null)
          w.lastEffect = y.next = y;
        else {
          var j = M.next;
          M.next = y, y.next = j, w.lastEffect = y;
        }
      }
      return y;
    }
    function sO(a) {
      var i = Rl();
      {
        var f = {
          current: a
        };
        return i.memoizedState = f, f;
      }
    }
    function mC(a) {
      var i = Ji();
      return i.memoizedState;
    }
    function Py(a, i, f, v) {
      var y = Rl(), w = v === void 0 ? null : v;
      An.flags |= a, y.memoizedState = Oy(lo | i, f, void 0, w);
    }
    function vC(a, i, f, v) {
      var y = Ji(), w = v === void 0 ? null : v, M = void 0;
      if (uo !== null) {
        var j = uo.memoizedState;
        if (M = j.destroy, w !== null) {
          var B = j.deps;
          if (ZR(w, B)) {
            y.memoizedState = Oy(i, f, M, w);
            return;
          }
        }
      }
      An.flags |= a, y.memoizedState = Oy(lo | i, f, M, w);
    }
    function gC(a, i) {
      return (An.mode & xa) !== _t ? Py(oc | or | pl, Lo, a, i) : Py(or | pl, Lo, a, i);
    }
    function $y(a, i) {
      return vC(or, Lo, a, i);
    }
    function lO(a, i) {
      return Py(an, El, a, i);
    }
    function yC(a, i) {
      return vC(an, El, a, i);
    }
    function cO(a, i) {
      var f = an;
      return f |= Jo, (An.mode & xa) !== _t && (f |= Zo), Py(f, co, a, i);
    }
    function bC(a, i) {
      return vC(an, co, a, i);
    }
    function AI(a, i) {
      if (typeof i == "function") {
        var f = i, v = a();
        return f(v), function() {
          f(null);
        };
      } else if (i != null) {
        var y = i;
        y.hasOwnProperty("current") || u("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(y).join(", ") + "}");
        var w = a();
        return y.current = w, function() {
          y.current = null;
        };
      }
    }
    function uO(a, i, f) {
      typeof i != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", i !== null ? typeof i : "null");
      var v = f != null ? f.concat([a]) : null, y = an;
      return y |= Jo, (An.mode & xa) !== _t && (y |= Zo), Py(y, co, AI.bind(null, i, a), v);
    }
    function xC(a, i, f) {
      typeof i != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", i !== null ? typeof i : "null");
      var v = f != null ? f.concat([a]) : null;
      return vC(an, co, AI.bind(null, i, a), v);
    }
    function fW(a, i) {
    }
    var SC = fW;
    function dO(a, i) {
      var f = Rl(), v = i === void 0 ? null : i;
      return f.memoizedState = [a, v], a;
    }
    function CC(a, i) {
      var f = Ji(), v = i === void 0 ? null : i, y = f.memoizedState;
      if (y !== null && v !== null) {
        var w = y[1];
        if (ZR(v, w))
          return y[0];
      }
      return f.memoizedState = [a, v], a;
    }
    function fO(a, i) {
      var f = Rl(), v = i === void 0 ? null : i, y = a();
      return f.memoizedState = [y, v], y;
    }
    function wC(a, i) {
      var f = Ji(), v = i === void 0 ? null : i, y = f.memoizedState;
      if (y !== null && v !== null) {
        var w = y[1];
        if (ZR(v, w))
          return y[0];
      }
      var M = a();
      return f.memoizedState = [M, v], M;
    }
    function pO(a) {
      var i = Rl();
      return i.memoizedState = a, a;
    }
    function LI(a) {
      var i = Ji(), f = uo, v = f.memoizedState;
      return jI(i, v, a);
    }
    function FI(a) {
      var i = Ji();
      if (uo === null)
        return i.memoizedState = a, a;
      var f = uo.memoizedState;
      return jI(i, f, a);
    }
    function jI(a, i, f) {
      var v = !Zx(Pf);
      if (v) {
        if (!Dt(f, i)) {
          var y = nS();
          An.lanes = rn(An.lanes, y), Yy(y), a.baseState = !0;
        }
        return i;
      } else
        return a.baseState && (a.baseState = !1, _y()), a.memoizedState = f, f;
    }
    function pW(a, i, f) {
      var v = qa();
      gr(NE(v, Ms)), a(!0);
      var y = Ty.transition;
      Ty.transition = {};
      var w = Ty.transition;
      Ty.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        a(!1), i();
      } finally {
        if (gr(v), Ty.transition = y, y === null && w._updatedFibers) {
          var M = w._updatedFibers.size;
          M > 10 && l("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), w._updatedFibers.clear();
        }
      }
    }
    function hO() {
      var a = hC(!1), i = a[0], f = a[1], v = pW.bind(null, f), y = Rl();
      return y.memoizedState = v, [i, v];
    }
    function VI() {
      var a = aO(), i = a[0], f = Ji(), v = f.memoizedState;
      return [i, v];
    }
    function BI() {
      var a = iO(), i = a[0], f = Ji(), v = f.memoizedState;
      return [i, v];
    }
    var zI = !1;
    function hW() {
      return zI;
    }
    function mO() {
      var a = Rl(), i = HC(), f = i.identifierPrefix, v;
      if (Ao()) {
        var y = k8();
        v = ":" + f + "R" + y;
        var w = Ry++;
        w > 0 && (v += "H" + w.toString(32)), v += ":";
      } else {
        var M = cW++;
        v = ":" + f + "r" + M.toString(32) + ":";
      }
      return a.memoizedState = v, v;
    }
    function TC() {
      var a = Ji(), i = a.memoizedState;
      return i;
    }
    function mW(a, i, f) {
      typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var v = Ju(a), y = {
        lane: v,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (UI(a))
        HI(i, y);
      else {
        var w = yI(a, i, y, v);
        if (w !== null) {
          var M = Ta();
          vo(w, a, v, M), WI(w, i, v);
        }
      }
      qI(a, v);
    }
    function vW(a, i, f) {
      typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var v = Ju(a), y = {
        lane: v,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (UI(a))
        HI(i, y);
      else {
        var w = a.alternate;
        if (a.lanes === Ge && (w === null || w.lanes === Ge)) {
          var M = i.lastRenderedReducer;
          if (M !== null) {
            var j;
            j = wt.current, wt.current = Vs;
            try {
              var B = i.lastRenderedState, Q = M(B, f);
              if (y.hasEagerState = !0, y.eagerState = Q, Dt(Q, B)) {
                eW(a, i, y, v);
                return;
              }
            } catch {
            } finally {
              wt.current = j;
            }
          }
        }
        var re = yI(a, i, y, v);
        if (re !== null) {
          var Ce = Ta();
          vo(re, a, v, Ce), WI(re, i, v);
        }
      }
      qI(a, v);
    }
    function UI(a) {
      var i = a.alternate;
      return a === An || i !== null && i === An;
    }
    function HI(a, i) {
      Ey = fC = !0;
      var f = a.pending;
      f === null ? i.next = i : (i.next = f.next, f.next = i), a.pending = i;
    }
    function WI(a, i, f) {
      if (_g(f)) {
        var v = i.lanes;
        v = bh(v, a.pendingLanes);
        var y = rn(v, f);
        i.lanes = y, Ag(a, y);
      }
    }
    function qI(a, i, f) {
      Qd(a, i);
    }
    var EC = {
      readContext: eo,
      useCallback: ca,
      useContext: ca,
      useEffect: ca,
      useImperativeHandle: ca,
      useInsertionEffect: ca,
      useLayoutEffect: ca,
      useMemo: ca,
      useReducer: ca,
      useRef: ca,
      useState: ca,
      useDebugValue: ca,
      useDeferredValue: ca,
      useTransition: ca,
      useMutableSource: ca,
      useSyncExternalStore: ca,
      useId: ca,
      unstable_isNewReconciler: U
    }, YI = null, GI = null, KI = null, XI = null, Ol = null, Vs = null, RC = null;
    {
      var vO = function() {
        u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Jt = function() {
        u("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      YI = {
        readContext: function(a) {
          return eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", $n(), sm(i), dO(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", $n(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", $n(), sm(i), gC(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", $n(), sm(f), uO(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", $n(), sm(i), lO(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", $n(), sm(i), cO(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", $n(), sm(i);
          var f = wt.current;
          wt.current = Ol;
          try {
            return fO(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", $n();
          var v = wt.current;
          wt.current = Ol;
          try {
            return tO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", $n(), sO(a);
        },
        useState: function(a) {
          Ye = "useState", $n();
          var i = wt.current;
          wt.current = Ol;
          try {
            return hC(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", $n(), void 0;
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", $n(), pO(a);
        },
        useTransition: function() {
          return Ye = "useTransition", $n(), hO();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", $n(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", $n(), oO(a, i, f);
        },
        useId: function() {
          return Ye = "useId", $n(), mO();
        },
        unstable_isNewReconciler: U
      }, GI = {
        readContext: function(a) {
          return eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", dt(), dO(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", dt(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", dt(), gC(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", dt(), uO(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", dt(), lO(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", dt(), cO(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", dt();
          var f = wt.current;
          wt.current = Ol;
          try {
            return fO(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", dt();
          var v = wt.current;
          wt.current = Ol;
          try {
            return tO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", dt(), sO(a);
        },
        useState: function(a) {
          Ye = "useState", dt();
          var i = wt.current;
          wt.current = Ol;
          try {
            return hC(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", dt(), void 0;
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", dt(), pO(a);
        },
        useTransition: function() {
          return Ye = "useTransition", dt(), hO();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", dt(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", dt(), oO(a, i, f);
        },
        useId: function() {
          return Ye = "useId", dt(), mO();
        },
        unstable_isNewReconciler: U
      }, KI = {
        readContext: function(a) {
          return eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", dt(), CC(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", dt(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", dt(), $y(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", dt(), xC(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", dt(), yC(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", dt(), bC(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", dt();
          var f = wt.current;
          wt.current = Vs;
          try {
            return wC(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", dt();
          var v = wt.current;
          wt.current = Vs;
          try {
            return nO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", dt(), mC();
        },
        useState: function(a) {
          Ye = "useState", dt();
          var i = wt.current;
          wt.current = Vs;
          try {
            return aO(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", dt(), SC();
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", dt(), LI(a);
        },
        useTransition: function() {
          return Ye = "useTransition", dt(), VI();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", dt(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", dt(), pC(a, i);
        },
        useId: function() {
          return Ye = "useId", dt(), TC();
        },
        unstable_isNewReconciler: U
      }, XI = {
        readContext: function(a) {
          return eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", dt(), CC(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", dt(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", dt(), $y(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", dt(), xC(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", dt(), yC(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", dt(), bC(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", dt();
          var f = wt.current;
          wt.current = RC;
          try {
            return wC(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", dt();
          var v = wt.current;
          wt.current = RC;
          try {
            return rO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", dt(), mC();
        },
        useState: function(a) {
          Ye = "useState", dt();
          var i = wt.current;
          wt.current = RC;
          try {
            return iO(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", dt(), SC();
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", dt(), FI(a);
        },
        useTransition: function() {
          return Ye = "useTransition", dt(), BI();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", dt(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", dt(), pC(a, i);
        },
        useId: function() {
          return Ye = "useId", dt(), TC();
        },
        unstable_isNewReconciler: U
      }, Ol = {
        readContext: function(a) {
          return vO(), eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", Jt(), $n(), dO(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", Jt(), $n(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", Jt(), $n(), gC(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", Jt(), $n(), uO(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", Jt(), $n(), lO(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", Jt(), $n(), cO(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", Jt(), $n();
          var f = wt.current;
          wt.current = Ol;
          try {
            return fO(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", Jt(), $n();
          var v = wt.current;
          wt.current = Ol;
          try {
            return tO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", Jt(), $n(), sO(a);
        },
        useState: function(a) {
          Ye = "useState", Jt(), $n();
          var i = wt.current;
          wt.current = Ol;
          try {
            return hC(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", Jt(), $n(), void 0;
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", Jt(), $n(), pO(a);
        },
        useTransition: function() {
          return Ye = "useTransition", Jt(), $n(), hO();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", Jt(), $n(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", Jt(), $n(), oO(a, i, f);
        },
        useId: function() {
          return Ye = "useId", Jt(), $n(), mO();
        },
        unstable_isNewReconciler: U
      }, Vs = {
        readContext: function(a) {
          return vO(), eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", Jt(), dt(), CC(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", Jt(), dt(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", Jt(), dt(), $y(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", Jt(), dt(), xC(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", Jt(), dt(), yC(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", Jt(), dt(), bC(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", Jt(), dt();
          var f = wt.current;
          wt.current = Vs;
          try {
            return wC(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", Jt(), dt();
          var v = wt.current;
          wt.current = Vs;
          try {
            return nO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", Jt(), dt(), mC();
        },
        useState: function(a) {
          Ye = "useState", Jt(), dt();
          var i = wt.current;
          wt.current = Vs;
          try {
            return aO(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", Jt(), dt(), SC();
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", Jt(), dt(), LI(a);
        },
        useTransition: function() {
          return Ye = "useTransition", Jt(), dt(), VI();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", Jt(), dt(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", Jt(), dt(), pC(a, i);
        },
        useId: function() {
          return Ye = "useId", Jt(), dt(), TC();
        },
        unstable_isNewReconciler: U
      }, RC = {
        readContext: function(a) {
          return vO(), eo(a);
        },
        useCallback: function(a, i) {
          return Ye = "useCallback", Jt(), dt(), CC(a, i);
        },
        useContext: function(a) {
          return Ye = "useContext", Jt(), dt(), eo(a);
        },
        useEffect: function(a, i) {
          return Ye = "useEffect", Jt(), dt(), $y(a, i);
        },
        useImperativeHandle: function(a, i, f) {
          return Ye = "useImperativeHandle", Jt(), dt(), xC(a, i, f);
        },
        useInsertionEffect: function(a, i) {
          return Ye = "useInsertionEffect", Jt(), dt(), yC(a, i);
        },
        useLayoutEffect: function(a, i) {
          return Ye = "useLayoutEffect", Jt(), dt(), bC(a, i);
        },
        useMemo: function(a, i) {
          Ye = "useMemo", Jt(), dt();
          var f = wt.current;
          wt.current = Vs;
          try {
            return wC(a, i);
          } finally {
            wt.current = f;
          }
        },
        useReducer: function(a, i, f) {
          Ye = "useReducer", Jt(), dt();
          var v = wt.current;
          wt.current = Vs;
          try {
            return rO(a, i, f);
          } finally {
            wt.current = v;
          }
        },
        useRef: function(a) {
          return Ye = "useRef", Jt(), dt(), mC();
        },
        useState: function(a) {
          Ye = "useState", Jt(), dt();
          var i = wt.current;
          wt.current = Vs;
          try {
            return iO(a);
          } finally {
            wt.current = i;
          }
        },
        useDebugValue: function(a, i) {
          return Ye = "useDebugValue", Jt(), dt(), SC();
        },
        useDeferredValue: function(a) {
          return Ye = "useDeferredValue", Jt(), dt(), FI(a);
        },
        useTransition: function() {
          return Ye = "useTransition", Jt(), dt(), BI();
        },
        useMutableSource: function(a, i, f) {
          return Ye = "useMutableSource", Jt(), dt(), void 0;
        },
        useSyncExternalStore: function(a, i, f) {
          return Ye = "useSyncExternalStore", Jt(), dt(), pC(a, i);
        },
        useId: function() {
          return Ye = "useId", Jt(), dt(), TC();
        },
        unstable_isNewReconciler: U
      };
    }
    var Gu = t.unstable_now, QI = 0, OC = -1, Dy = -1, PC = -1, gO = !1, $C = !1;
    function JI() {
      return gO;
    }
    function gW() {
      $C = !0;
    }
    function yW() {
      gO = !1, $C = !1;
    }
    function bW() {
      gO = $C, $C = !1;
    }
    function ZI() {
      return QI;
    }
    function e_() {
      QI = Gu();
    }
    function yO(a) {
      Dy = Gu(), a.actualStartTime < 0 && (a.actualStartTime = Gu());
    }
    function t_(a) {
      Dy = -1;
    }
    function DC(a, i) {
      if (Dy >= 0) {
        var f = Gu() - Dy;
        a.actualDuration += f, i && (a.selfBaseDuration = f), Dy = -1;
      }
    }
    function Pl(a) {
      if (OC >= 0) {
        var i = Gu() - OC;
        OC = -1;
        for (var f = a.return; f !== null; ) {
          switch (f.tag) {
            case x:
              var v = f.stateNode;
              v.effectDuration += i;
              return;
            case F:
              var y = f.stateNode;
              y.effectDuration += i;
              return;
          }
          f = f.return;
        }
      }
    }
    function bO(a) {
      if (PC >= 0) {
        var i = Gu() - PC;
        PC = -1;
        for (var f = a.return; f !== null; ) {
          switch (f.tag) {
            case x:
              var v = f.stateNode;
              v !== null && (v.passiveEffectDuration += i);
              return;
            case F:
              var y = f.stateNode;
              y !== null && (y.passiveEffectDuration += i);
              return;
          }
          f = f.return;
        }
      }
    }
    function $l() {
      OC = Gu();
    }
    function xO() {
      PC = Gu();
    }
    function SO(a) {
      for (var i = a.child; i; )
        a.actualDuration += i.actualDuration, i = i.sibling;
    }
    function Bs(a, i) {
      if (a && a.defaultProps) {
        var f = pn({}, i), v = a.defaultProps;
        for (var y in v)
          f[y] === void 0 && (f[y] = v[y]);
        return f;
      }
      return i;
    }
    var CO = {}, wO, TO, EO, RO, OO, n_, kC, PO, $O, DO, ky;
    {
      wO = /* @__PURE__ */ new Set(), TO = /* @__PURE__ */ new Set(), EO = /* @__PURE__ */ new Set(), RO = /* @__PURE__ */ new Set(), PO = /* @__PURE__ */ new Set(), OO = /* @__PURE__ */ new Set(), $O = /* @__PURE__ */ new Set(), DO = /* @__PURE__ */ new Set(), ky = /* @__PURE__ */ new Set();
      var r_ = /* @__PURE__ */ new Set();
      kC = function(a, i) {
        if (!(a === null || typeof a == "function")) {
          var f = i + "_" + a;
          r_.has(f) || (r_.add(f), u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i, a));
        }
      }, n_ = function(a, i) {
        if (i === void 0) {
          var f = Mn(a) || "Component";
          OO.has(f) || (OO.add(f), u("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(CO, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(CO);
    }
    function kO(a, i, f, v) {
      var y = a.memoizedState, w = f(v, y);
      {
        if (a.mode & un) {
          Dr(!0);
          try {
            w = f(v, y);
          } finally {
            Dr(!1);
          }
        }
        n_(i, w);
      }
      var M = w == null ? y : pn({}, y, w);
      if (a.memoizedState = M, a.lanes === Ge) {
        var j = a.updateQueue;
        j.baseState = M;
      }
    }
    var MO = {
      isMounted: ya,
      enqueueSetState: function(a, i, f) {
        var v = Fa(a), y = Ta(), w = Ju(v), M = Rc(y, w);
        M.payload = i, f != null && (kC(f, "setState"), M.callback = f);
        var j = Hu(v, M, w);
        j !== null && (vo(j, v, w, y), iC(j, v, w)), Qd(v, w);
      },
      enqueueReplaceState: function(a, i, f) {
        var v = Fa(a), y = Ta(), w = Ju(v), M = Rc(y, w);
        M.tag = xI, M.payload = i, f != null && (kC(f, "replaceState"), M.callback = f);
        var j = Hu(v, M, w);
        j !== null && (vo(j, v, w, y), iC(j, v, w)), Qd(v, w);
      },
      enqueueForceUpdate: function(a, i) {
        var f = Fa(a), v = Ta(), y = Ju(f), w = Rc(v, y);
        w.tag = rC, i != null && (kC(i, "forceUpdate"), w.callback = i);
        var M = Hu(f, w, y);
        M !== null && (vo(M, f, y, v), iC(M, f, y)), nh(f, y);
      }
    };
    function o_(a, i, f, v, y, w, M) {
      var j = a.stateNode;
      if (typeof j.shouldComponentUpdate == "function") {
        var B = j.shouldComponentUpdate(v, w, M);
        {
          if (a.mode & un) {
            Dr(!0);
            try {
              B = j.shouldComponentUpdate(v, w, M);
            } finally {
              Dr(!1);
            }
          }
          B === void 0 && u("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Mn(i) || "Component");
        }
        return B;
      }
      return i.prototype && i.prototype.isPureReactComponent ? !Yt(f, v) || !Yt(y, w) : !0;
    }
    function xW(a, i, f) {
      var v = a.stateNode;
      {
        var y = Mn(i) || "Component", w = v.render;
        w || (i.prototype && typeof i.prototype.render == "function" ? u("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", y) : u("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", y)), v.getInitialState && !v.getInitialState.isReactClassApproved && !v.state && u("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", y), v.getDefaultProps && !v.getDefaultProps.isReactClassApproved && u("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", y), v.propTypes && u("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", y), v.contextType && u("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", y), i.childContextTypes && !ky.has(i) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (a.mode & un) === _t && (ky.add(i), u(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, y)), i.contextTypes && !ky.has(i) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (a.mode & un) === _t && (ky.add(i), u(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, y)), v.contextTypes && u("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", y), i.contextType && i.contextTypes && !$O.has(i) && ($O.add(i), u("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", y)), typeof v.componentShouldUpdate == "function" && u("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", y), i.prototype && i.prototype.isPureReactComponent && typeof v.shouldComponentUpdate < "u" && u("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Mn(i) || "A pure component"), typeof v.componentDidUnmount == "function" && u("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", y), typeof v.componentDidReceiveProps == "function" && u("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", y), typeof v.componentWillRecieveProps == "function" && u("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", y), typeof v.UNSAFE_componentWillRecieveProps == "function" && u("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", y);
        var M = v.props !== f;
        v.props !== void 0 && M && u("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", y, y), v.defaultProps && u("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", y, y), typeof v.getSnapshotBeforeUpdate == "function" && typeof v.componentDidUpdate != "function" && !EO.has(i) && (EO.add(i), u("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Mn(i))), typeof v.getDerivedStateFromProps == "function" && u("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", y), typeof v.getDerivedStateFromError == "function" && u("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", y), typeof i.getSnapshotBeforeUpdate == "function" && u("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", y);
        var j = v.state;
        j && (typeof j != "object" || Gr(j)) && u("%s.state: must be set to an object or null", y), typeof v.getChildContext == "function" && typeof i.childContextTypes != "object" && u("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", y);
      }
    }
    function a_(a, i) {
      i.updater = MO, a.stateNode = i, su(i, a), i._reactInternalInstance = CO;
    }
    function i_(a, i, f) {
      var v = !1, y = Ri, w = Ri, M = i.contextType;
      if ("contextType" in i) {
        var j = (
          // Allow null for conditional declaration
          M === null || M !== void 0 && M.$$typeof === No && M._context === void 0
        );
        if (!j && !DO.has(i)) {
          DO.add(i);
          var B = "";
          M === void 0 ? B = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof M != "object" ? B = " However, it is set to a " + typeof M + "." : M.$$typeof === Mo ? B = " Did you accidentally pass the Context.Provider instead?" : M._context !== void 0 ? B = " Did you accidentally pass the Context.Consumer instead?" : B = " However, it is set to an object with keys {" + Object.keys(M).join(", ") + "}.", u("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Mn(i) || "Component", B);
        }
      }
      if (typeof M == "object" && M !== null)
        w = eo(M);
      else {
        y = Kh(a, i, !0);
        var Q = i.contextTypes;
        v = Q != null, w = v ? Xh(a, y) : Ri;
      }
      var re = new i(f, w);
      if (a.mode & un) {
        Dr(!0);
        try {
          re = new i(f, w);
        } finally {
          Dr(!1);
        }
      }
      var Ce = a.memoizedState = re.state !== null && re.state !== void 0 ? re.state : null;
      a_(a, re);
      {
        if (typeof i.getDerivedStateFromProps == "function" && Ce === null) {
          var xe = Mn(i) || "Component";
          TO.has(xe) || (TO.add(xe), u("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", xe, re.state === null ? "null" : "undefined", xe));
        }
        if (typeof i.getDerivedStateFromProps == "function" || typeof re.getSnapshotBeforeUpdate == "function") {
          var Le = null, je = null, Ue = null;
          if (typeof re.componentWillMount == "function" && re.componentWillMount.__suppressDeprecationWarning !== !0 ? Le = "componentWillMount" : typeof re.UNSAFE_componentWillMount == "function" && (Le = "UNSAFE_componentWillMount"), typeof re.componentWillReceiveProps == "function" && re.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? je = "componentWillReceiveProps" : typeof re.UNSAFE_componentWillReceiveProps == "function" && (je = "UNSAFE_componentWillReceiveProps"), typeof re.componentWillUpdate == "function" && re.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ue = "componentWillUpdate" : typeof re.UNSAFE_componentWillUpdate == "function" && (Ue = "UNSAFE_componentWillUpdate"), Le !== null || je !== null || Ue !== null) {
            var gt = Mn(i) || "Component", Ht = typeof i.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            RO.has(gt) || (RO.add(gt), u(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, gt, Ht, Le !== null ? `
  ` + Le : "", je !== null ? `
  ` + je : "", Ue !== null ? `
  ` + Ue : ""));
          }
        }
      }
      return v && KN(a, y, w), re;
    }
    function SW(a, i) {
      var f = i.state;
      typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), f !== i.state && (u("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", nn(a) || "Component"), MO.enqueueReplaceState(i, i.state, null));
    }
    function s_(a, i, f, v) {
      var y = i.state;
      if (typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps(f, v), typeof i.UNSAFE_componentWillReceiveProps == "function" && i.UNSAFE_componentWillReceiveProps(f, v), i.state !== y) {
        {
          var w = nn(a) || "Component";
          wO.has(w) || (wO.add(w), u("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", w));
        }
        MO.enqueueReplaceState(i, i.state, null);
      }
    }
    function NO(a, i, f, v) {
      xW(a, i, f);
      var y = a.stateNode;
      y.props = f, y.state = a.memoizedState, y.refs = {}, zR(a);
      var w = i.contextType;
      if (typeof w == "object" && w !== null)
        y.context = eo(w);
      else {
        var M = Kh(a, i, !0);
        y.context = Xh(a, M);
      }
      {
        if (y.state === f) {
          var j = Mn(i) || "Component";
          PO.has(j) || (PO.add(j), u("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", j));
        }
        a.mode & un && Fs.recordLegacyContextWarning(a, y), Fs.recordUnsafeLifecycleWarnings(a, y);
      }
      y.state = a.memoizedState;
      var B = i.getDerivedStateFromProps;
      if (typeof B == "function" && (kO(a, i, B, f), y.state = a.memoizedState), typeof i.getDerivedStateFromProps != "function" && typeof y.getSnapshotBeforeUpdate != "function" && (typeof y.UNSAFE_componentWillMount == "function" || typeof y.componentWillMount == "function") && (SW(a, y), sC(a, f, y, v), y.state = a.memoizedState), typeof y.componentDidMount == "function") {
        var Q = an;
        Q |= Jo, (a.mode & xa) !== _t && (Q |= Zo), a.flags |= Q;
      }
    }
    function CW(a, i, f, v) {
      var y = a.stateNode, w = a.memoizedProps;
      y.props = w;
      var M = y.context, j = i.contextType, B = Ri;
      if (typeof j == "object" && j !== null)
        B = eo(j);
      else {
        var Q = Kh(a, i, !0);
        B = Xh(a, Q);
      }
      var re = i.getDerivedStateFromProps, Ce = typeof re == "function" || typeof y.getSnapshotBeforeUpdate == "function";
      !Ce && (typeof y.UNSAFE_componentWillReceiveProps == "function" || typeof y.componentWillReceiveProps == "function") && (w !== f || M !== B) && s_(a, y, f, B), CI();
      var xe = a.memoizedState, Le = y.state = xe;
      if (sC(a, f, y, v), Le = a.memoizedState, w === f && xe === Le && !zS() && !lC()) {
        if (typeof y.componentDidMount == "function") {
          var je = an;
          je |= Jo, (a.mode & xa) !== _t && (je |= Zo), a.flags |= je;
        }
        return !1;
      }
      typeof re == "function" && (kO(a, i, re, f), Le = a.memoizedState);
      var Ue = lC() || o_(a, i, w, f, xe, Le, B);
      if (Ue) {
        if (!Ce && (typeof y.UNSAFE_componentWillMount == "function" || typeof y.componentWillMount == "function") && (typeof y.componentWillMount == "function" && y.componentWillMount(), typeof y.UNSAFE_componentWillMount == "function" && y.UNSAFE_componentWillMount()), typeof y.componentDidMount == "function") {
          var gt = an;
          gt |= Jo, (a.mode & xa) !== _t && (gt |= Zo), a.flags |= gt;
        }
      } else {
        if (typeof y.componentDidMount == "function") {
          var Ht = an;
          Ht |= Jo, (a.mode & xa) !== _t && (Ht |= Zo), a.flags |= Ht;
        }
        a.memoizedProps = f, a.memoizedState = Le;
      }
      return y.props = f, y.state = Le, y.context = B, Ue;
    }
    function wW(a, i, f, v, y) {
      var w = i.stateNode;
      SI(a, i);
      var M = i.memoizedProps, j = i.type === i.elementType ? M : Bs(i.type, M);
      w.props = j;
      var B = i.pendingProps, Q = w.context, re = f.contextType, Ce = Ri;
      if (typeof re == "object" && re !== null)
        Ce = eo(re);
      else {
        var xe = Kh(i, f, !0);
        Ce = Xh(i, xe);
      }
      var Le = f.getDerivedStateFromProps, je = typeof Le == "function" || typeof w.getSnapshotBeforeUpdate == "function";
      !je && (typeof w.UNSAFE_componentWillReceiveProps == "function" || typeof w.componentWillReceiveProps == "function") && (M !== B || Q !== Ce) && s_(i, w, v, Ce), CI();
      var Ue = i.memoizedState, gt = w.state = Ue;
      if (sC(i, v, w, y), gt = i.memoizedState, M === B && Ue === gt && !zS() && !lC() && !G)
        return typeof w.componentDidUpdate == "function" && (M !== a.memoizedProps || Ue !== a.memoizedState) && (i.flags |= an), typeof w.getSnapshotBeforeUpdate == "function" && (M !== a.memoizedProps || Ue !== a.memoizedState) && (i.flags |= ja), !1;
      typeof Le == "function" && (kO(i, f, Le, v), gt = i.memoizedState);
      var Ht = lC() || o_(i, f, j, v, Ue, gt, Ce) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      G;
      return Ht ? (!je && (typeof w.UNSAFE_componentWillUpdate == "function" || typeof w.componentWillUpdate == "function") && (typeof w.componentWillUpdate == "function" && w.componentWillUpdate(v, gt, Ce), typeof w.UNSAFE_componentWillUpdate == "function" && w.UNSAFE_componentWillUpdate(v, gt, Ce)), typeof w.componentDidUpdate == "function" && (i.flags |= an), typeof w.getSnapshotBeforeUpdate == "function" && (i.flags |= ja)) : (typeof w.componentDidUpdate == "function" && (M !== a.memoizedProps || Ue !== a.memoizedState) && (i.flags |= an), typeof w.getSnapshotBeforeUpdate == "function" && (M !== a.memoizedProps || Ue !== a.memoizedState) && (i.flags |= ja), i.memoizedProps = v, i.memoizedState = gt), w.props = v, w.state = gt, w.context = Ce, Ht;
    }
    function $f(a, i) {
      return {
        value: a,
        source: i,
        stack: qv(i),
        digest: null
      };
    }
    function IO(a, i, f) {
      return {
        value: a,
        source: null,
        stack: f ?? null,
        digest: i ?? null
      };
    }
    function TW(a, i) {
      return !0;
    }
    function _O(a, i) {
      try {
        var f = TW(a, i);
        if (f === !1)
          return;
        var v = i.value, y = i.source, w = i.stack, M = w !== null ? w : "";
        if (v != null && v._suppressLogging) {
          if (a.tag === m)
            return;
          console.error(v);
        }
        var j = y ? nn(y) : null, B = j ? "The above error occurred in the <" + j + "> component:" : "The above error occurred in one of your React components:", Q;
        if (a.tag === x)
          Q = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var re = nn(a) || "Anonymous";
          Q = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + re + ".");
        }
        var Ce = B + `
` + M + `

` + ("" + Q);
        console.error(Ce);
      } catch (xe) {
        setTimeout(function() {
          throw xe;
        });
      }
    }
    var EW = typeof WeakMap == "function" ? WeakMap : Map;
    function l_(a, i, f) {
      var v = Rc(Xn, f);
      v.tag = VR, v.payload = {
        element: null
      };
      var y = i.value;
      return v.callback = function() {
        g7(y), _O(a, i);
      }, v;
    }
    function AO(a, i, f) {
      var v = Rc(Xn, f);
      v.tag = VR;
      var y = a.type.getDerivedStateFromError;
      if (typeof y == "function") {
        var w = i.value;
        v.payload = function() {
          return y(w);
        }, v.callback = function() {
          b2(a), _O(a, i);
        };
      }
      var M = a.stateNode;
      return M !== null && typeof M.componentDidCatch == "function" && (v.callback = function() {
        b2(a), _O(a, i), typeof y != "function" && m7(this);
        var B = i.value, Q = i.stack;
        this.componentDidCatch(B, {
          componentStack: Q !== null ? Q : ""
        }), typeof y != "function" && (aa(a.lanes, Bt) || u("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", nn(a) || "Unknown"));
      }), v;
    }
    function c_(a, i, f) {
      var v = a.pingCache, y;
      if (v === null ? (v = a.pingCache = new EW(), y = /* @__PURE__ */ new Set(), v.set(i, y)) : (y = v.get(i), y === void 0 && (y = /* @__PURE__ */ new Set(), v.set(i, y))), !y.has(f)) {
        y.add(f);
        var w = y7.bind(null, a, i, f);
        ba && Gy(a, f), i.then(w, w);
      }
    }
    function RW(a, i, f, v) {
      var y = a.updateQueue;
      if (y === null) {
        var w = /* @__PURE__ */ new Set();
        w.add(f), a.updateQueue = w;
      } else
        y.add(f);
    }
    function OW(a, i) {
      var f = a.tag;
      if ((a.mode & Lt) === _t && (f === h || f === L || f === z)) {
        var v = a.alternate;
        v ? (a.updateQueue = v.updateQueue, a.memoizedState = v.memoizedState, a.lanes = v.lanes) : (a.updateQueue = null, a.memoizedState = null);
      }
    }
    function u_(a) {
      var i = a;
      do {
        if (i.tag === N && sW(i))
          return i;
        i = i.return;
      } while (i !== null);
      return null;
    }
    function d_(a, i, f, v, y) {
      if ((a.mode & Lt) === _t) {
        if (a === i)
          a.flags |= Xr;
        else {
          if (a.flags |= Kt, f.flags |= Gd, f.flags &= ~(Hp | va), f.tag === m) {
            var w = f.alternate;
            if (w === null)
              f.tag = ee;
            else {
              var M = Rc(Xn, Bt);
              M.tag = rC, Hu(f, M, Bt);
            }
          }
          f.lanes = rn(f.lanes, Bt);
        }
        return a;
      }
      return a.flags |= Xr, a.lanes = y, a;
    }
    function PW(a, i, f, v, y) {
      if (f.flags |= va, ba && Gy(a, y), v !== null && typeof v == "object" && typeof v.then == "function") {
        var w = v;
        OW(f), Ao() && f.mode & Lt && nI();
        var M = u_(i);
        if (M !== null) {
          M.flags &= ~vr, d_(M, i, f, a, y), M.mode & Lt && c_(a, w, y), RW(M, a, w);
          return;
        } else {
          if (!Ig(y)) {
            c_(a, w, y), mP();
            return;
          }
          var j = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          v = j;
        }
      } else if (Ao() && f.mode & Lt) {
        nI();
        var B = u_(i);
        if (B !== null) {
          (B.flags & Xr) === Ut && (B.flags |= vr), d_(B, i, f, a, y), PR($f(v, f));
          return;
        }
      }
      v = $f(v, f), s7(v);
      var Q = i;
      do {
        switch (Q.tag) {
          case x: {
            var re = v;
            Q.flags |= Xr;
            var Ce = Su(y);
            Q.lanes = rn(Q.lanes, Ce);
            var xe = l_(Q, re, Ce);
            UR(Q, xe);
            return;
          }
          case m:
            var Le = v, je = Q.type, Ue = Q.stateNode;
            if ((Q.flags & Kt) === Ut && (typeof je.getDerivedStateFromError == "function" || Ue !== null && typeof Ue.componentDidCatch == "function" && !u2(Ue))) {
              Q.flags |= Xr;
              var gt = Su(y);
              Q.lanes = rn(Q.lanes, gt);
              var Ht = AO(Q, Le, gt);
              UR(Q, Ht);
              return;
            }
            break;
        }
        Q = Q.return;
      } while (Q !== null);
    }
    function $W() {
      return null;
    }
    var My = n.ReactCurrentOwner, zs = !1, LO, Ny, FO, jO, VO, Df, BO, MC, Iy;
    LO = {}, Ny = {}, FO = {}, jO = {}, VO = {}, Df = !1, BO = {}, MC = {}, Iy = {};
    function Ca(a, i, f, v) {
      a === null ? i.child = hI(i, null, f, v) : i.child = em(i, a.child, f, v);
    }
    function DW(a, i, f, v) {
      i.child = em(i, a.child, null, v), i.child = em(i, null, f, v);
    }
    function f_(a, i, f, v, y) {
      if (i.type !== i.elementType) {
        var w = f.propTypes;
        w && As(
          w,
          v,
          // Resolved props
          "prop",
          Mn(f)
        );
      }
      var M = f.render, j = i.ref, B, Q;
      nm(i, y), du(i);
      {
        if (My.current = i, Si(!0), B = lm(a, i, M, v, j, y), Q = cm(), i.mode & un) {
          Dr(!0);
          try {
            B = lm(a, i, M, v, j, y), Q = cm();
          } finally {
            Dr(!1);
          }
        }
        Si(!1);
      }
      return na(), a !== null && !zs ? (PI(a, i, y), Oc(a, i, y)) : (Ao() && Q && CR(i), i.flags |= dl, Ca(a, i, B, y), i.child);
    }
    function p_(a, i, f, v, y) {
      if (a === null) {
        var w = f.type;
        if (_7(w) && f.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var M = w;
          return M = gm(w), i.tag = z, i.type = M, HO(i, w), h_(a, i, M, v, y);
        }
        {
          var j = w.propTypes;
          if (j && As(
            j,
            v,
            // Resolved props
            "prop",
            Mn(w)
          ), f.defaultProps !== void 0) {
            var B = Mn(w) || "Unknown";
            Iy[B] || (u("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", B), Iy[B] = !0);
          }
        }
        var Q = RP(f.type, null, v, i, i.mode, y);
        return Q.ref = i.ref, Q.return = i, i.child = Q, Q;
      }
      {
        var re = f.type, Ce = re.propTypes;
        Ce && As(
          Ce,
          v,
          // Resolved props
          "prop",
          Mn(re)
        );
      }
      var xe = a.child, Le = XO(a, y);
      if (!Le) {
        var je = xe.memoizedProps, Ue = f.compare;
        if (Ue = Ue !== null ? Ue : Yt, Ue(je, v) && a.ref === i.ref)
          return Oc(a, i, y);
      }
      i.flags |= dl;
      var gt = _f(xe, v);
      return gt.ref = i.ref, gt.return = i, i.child = gt, gt;
    }
    function h_(a, i, f, v, y) {
      if (i.type !== i.elementType) {
        var w = i.elementType;
        if (w.$$typeof === mt) {
          var M = w, j = M._payload, B = M._init;
          try {
            w = B(j);
          } catch {
            w = null;
          }
          var Q = w && w.propTypes;
          Q && As(
            Q,
            v,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Mn(w)
          );
        }
      }
      if (a !== null) {
        var re = a.memoizedProps;
        if (Yt(re, v) && a.ref === i.ref && // Prevent bailout if the implementation changed due to hot reload.
        i.type === a.type)
          if (zs = !1, i.pendingProps = v = re, XO(a, y))
            (a.flags & Gd) !== Ut && (zs = !0);
          else return i.lanes = a.lanes, Oc(a, i, y);
      }
      return zO(a, i, f, v, y);
    }
    function m_(a, i, f) {
      var v = i.pendingProps, y = v.children, w = a !== null ? a.memoizedState : null;
      if (v.mode === "hidden" || W)
        if ((i.mode & Lt) === _t) {
          var M = {
            baseLanes: Ge,
            cachePool: null,
            transitions: null
          };
          i.memoizedState = M, WC(i, f);
        } else if (aa(f, To)) {
          var Ce = {
            baseLanes: Ge,
            cachePool: null,
            transitions: null
          };
          i.memoizedState = Ce;
          var xe = w !== null ? w.baseLanes : f;
          WC(i, xe);
        } else {
          var j = null, B;
          if (w !== null) {
            var Q = w.baseLanes;
            B = rn(Q, f);
          } else
            B = f;
          i.lanes = i.childLanes = To;
          var re = {
            baseLanes: B,
            cachePool: j,
            transitions: null
          };
          return i.memoizedState = re, i.updateQueue = null, WC(i, B), null;
        }
      else {
        var Le;
        w !== null ? (Le = rn(w.baseLanes, f), i.memoizedState = null) : Le = f, WC(i, Le);
      }
      return Ca(a, i, y, f), i.child;
    }
    function kW(a, i, f) {
      var v = i.pendingProps;
      return Ca(a, i, v, f), i.child;
    }
    function MW(a, i, f) {
      var v = i.pendingProps.children;
      return Ca(a, i, v, f), i.child;
    }
    function NW(a, i, f) {
      {
        i.flags |= an;
        {
          var v = i.stateNode;
          v.effectDuration = 0, v.passiveEffectDuration = 0;
        }
      }
      var y = i.pendingProps, w = y.children;
      return Ca(a, i, w, f), i.child;
    }
    function v_(a, i) {
      var f = i.ref;
      (a === null && f !== null || a !== null && a.ref !== f) && (i.flags |= Qo, i.flags |= Sg);
    }
    function zO(a, i, f, v, y) {
      if (i.type !== i.elementType) {
        var w = f.propTypes;
        w && As(
          w,
          v,
          // Resolved props
          "prop",
          Mn(f)
        );
      }
      var M;
      {
        var j = Kh(i, f, !0);
        M = Xh(i, j);
      }
      var B, Q;
      nm(i, y), du(i);
      {
        if (My.current = i, Si(!0), B = lm(a, i, f, v, M, y), Q = cm(), i.mode & un) {
          Dr(!0);
          try {
            B = lm(a, i, f, v, M, y), Q = cm();
          } finally {
            Dr(!1);
          }
        }
        Si(!1);
      }
      return na(), a !== null && !zs ? (PI(a, i, y), Oc(a, i, y)) : (Ao() && Q && CR(i), i.flags |= dl, Ca(a, i, B, y), i.child);
    }
    function g_(a, i, f, v, y) {
      {
        switch (X7(i)) {
          case !1: {
            var w = i.stateNode, M = i.type, j = new M(i.memoizedProps, w.context), B = j.state;
            w.updater.enqueueSetState(w, B, null);
            break;
          }
          case !0: {
            i.flags |= Kt, i.flags |= Xr;
            var Q = new Error("Simulated error coming from DevTools"), re = Su(y);
            i.lanes = rn(i.lanes, re);
            var Ce = AO(i, $f(Q, i), re);
            UR(i, Ce);
            break;
          }
        }
        if (i.type !== i.elementType) {
          var xe = f.propTypes;
          xe && As(
            xe,
            v,
            // Resolved props
            "prop",
            Mn(f)
          );
        }
      }
      var Le;
      Tl(f) ? (Le = !0, HS(i)) : Le = !1, nm(i, y);
      var je = i.stateNode, Ue;
      je === null ? (IC(a, i), i_(i, f, v), NO(i, f, v, y), Ue = !0) : a === null ? Ue = CW(i, f, v, y) : Ue = wW(a, i, f, v, y);
      var gt = UO(a, i, f, Ue, Le, y);
      {
        var Ht = i.stateNode;
        Ue && Ht.props !== v && (Df || u("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", nn(i) || "a component"), Df = !0);
      }
      return gt;
    }
    function UO(a, i, f, v, y, w) {
      v_(a, i);
      var M = (i.flags & Kt) !== Ut;
      if (!v && !M)
        return y && JN(i, f, !1), Oc(a, i, w);
      var j = i.stateNode;
      My.current = i;
      var B;
      if (M && typeof f.getDerivedStateFromError != "function")
        B = null, t_();
      else {
        du(i);
        {
          if (Si(!0), B = j.render(), i.mode & un) {
            Dr(!0);
            try {
              j.render();
            } finally {
              Dr(!1);
            }
          }
          Si(!1);
        }
        na();
      }
      return i.flags |= dl, a !== null && M ? DW(a, i, B, w) : Ca(a, i, B, w), i.memoizedState = j.state, y && JN(i, f, !0), i.child;
    }
    function y_(a) {
      var i = a.stateNode;
      i.pendingContext ? XN(a, i.pendingContext, i.pendingContext !== i.context) : i.context && XN(a, i.context, !1), HR(a, i.containerInfo);
    }
    function IW(a, i, f) {
      if (y_(i), a === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var v = i.pendingProps, y = i.memoizedState, w = y.element;
      SI(a, i), sC(i, v, null, f);
      var M = i.memoizedState;
      i.stateNode;
      var j = M.element;
      if (y.isDehydrated) {
        var B = {
          element: j,
          isDehydrated: !1,
          cache: M.cache,
          pendingSuspenseBoundaries: M.pendingSuspenseBoundaries,
          transitions: M.transitions
        }, Q = i.updateQueue;
        if (Q.baseState = B, i.memoizedState = B, i.flags & vr) {
          var re = $f(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), i);
          return b_(a, i, j, f, re);
        } else if (j !== w) {
          var Ce = $f(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), i);
          return b_(a, i, j, f, Ce);
        } else {
          L8(i);
          var xe = hI(i, null, j, f);
          i.child = xe;
          for (var Le = xe; Le; )
            Le.flags = Le.flags & ~Jn | Va, Le = Le.sibling;
        }
      } else {
        if (Zh(), j === w)
          return Oc(a, i, f);
        Ca(a, i, j, f);
      }
      return i.child;
    }
    function b_(a, i, f, v, y) {
      return Zh(), PR(y), i.flags |= vr, Ca(a, i, f, v), i.child;
    }
    function _W(a, i, f) {
      EI(i), a === null && OR(i);
      var v = i.type, y = i.pendingProps, w = a !== null ? a.memoizedProps : null, M = y.children, j = lR(v, y);
      return j ? M = null : w !== null && lR(v, w) && (i.flags |= Pn), v_(a, i), Ca(a, i, M, f), i.child;
    }
    function AW(a, i) {
      return a === null && OR(i), null;
    }
    function LW(a, i, f, v) {
      IC(a, i);
      var y = i.pendingProps, w = f, M = w._payload, j = w._init, B = j(M);
      i.type = B;
      var Q = i.tag = A7(B), re = Bs(B, y), Ce;
      switch (Q) {
        case h:
          return HO(i, B), i.type = B = gm(B), Ce = zO(null, i, B, re, v), Ce;
        case m:
          return i.type = B = xP(B), Ce = g_(null, i, B, re, v), Ce;
        case L:
          return i.type = B = SP(B), Ce = f_(null, i, B, re, v), Ce;
        case V: {
          if (i.type !== i.elementType) {
            var xe = B.propTypes;
            xe && As(
              xe,
              re,
              // Resolved for outer only
              "prop",
              Mn(B)
            );
          }
          return Ce = p_(
            null,
            i,
            B,
            Bs(B.type, re),
            // The inner type can have defaults too
            v
          ), Ce;
        }
      }
      var Le = "";
      throw B !== null && typeof B == "object" && B.$$typeof === mt && (Le = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + B + ". " + ("Lazy element type must resolve to a class or function." + Le));
    }
    function FW(a, i, f, v, y) {
      IC(a, i), i.tag = m;
      var w;
      return Tl(f) ? (w = !0, HS(i)) : w = !1, nm(i, y), i_(i, f, v), NO(i, f, v, y), UO(null, i, f, !0, w, y);
    }
    function jW(a, i, f, v) {
      IC(a, i);
      var y = i.pendingProps, w;
      {
        var M = Kh(i, f, !1);
        w = Xh(i, M);
      }
      nm(i, v);
      var j, B;
      du(i);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var Q = Mn(f) || "Unknown";
          LO[Q] || (u("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Q, Q), LO[Q] = !0);
        }
        i.mode & un && Fs.recordLegacyContextWarning(i, null), Si(!0), My.current = i, j = lm(null, i, f, y, w, v), B = cm(), Si(!1);
      }
      if (na(), i.flags |= dl, typeof j == "object" && j !== null && typeof j.render == "function" && j.$$typeof === void 0) {
        var re = Mn(f) || "Unknown";
        Ny[re] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", re, re, re), Ny[re] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof j == "object" && j !== null && typeof j.render == "function" && j.$$typeof === void 0
      ) {
        {
          var Ce = Mn(f) || "Unknown";
          Ny[Ce] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ce, Ce, Ce), Ny[Ce] = !0);
        }
        i.tag = m, i.memoizedState = null, i.updateQueue = null;
        var xe = !1;
        return Tl(f) ? (xe = !0, HS(i)) : xe = !1, i.memoizedState = j.state !== null && j.state !== void 0 ? j.state : null, zR(i), a_(i, j), NO(i, f, y, v), UO(null, i, f, !0, xe, v);
      } else {
        if (i.tag = h, i.mode & un) {
          Dr(!0);
          try {
            j = lm(null, i, f, y, w, v), B = cm();
          } finally {
            Dr(!1);
          }
        }
        return Ao() && B && CR(i), Ca(null, i, j, v), HO(i, f), i.child;
      }
    }
    function HO(a, i) {
      {
        if (i && i.childContextTypes && u("%s(...): childContextTypes cannot be defined on a function component.", i.displayName || i.name || "Component"), a.ref !== null) {
          var f = "", v = Aa();
          v && (f += `

Check the render method of \`` + v + "`.");
          var y = v || "", w = a._debugSource;
          w && (y = w.fileName + ":" + w.lineNumber), VO[y] || (VO[y] = !0, u("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (i.defaultProps !== void 0) {
          var M = Mn(i) || "Unknown";
          Iy[M] || (u("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", M), Iy[M] = !0);
        }
        if (typeof i.getDerivedStateFromProps == "function") {
          var j = Mn(i) || "Unknown";
          jO[j] || (u("%s: Function components do not support getDerivedStateFromProps.", j), jO[j] = !0);
        }
        if (typeof i.contextType == "object" && i.contextType !== null) {
          var B = Mn(i) || "Unknown";
          FO[B] || (u("%s: Function components do not support contextType.", B), FO[B] = !0);
        }
      }
    }
    var WO = {
      dehydrated: null,
      treeContext: null,
      retryLane: kr
    };
    function qO(a) {
      return {
        baseLanes: a,
        cachePool: $W(),
        transitions: null
      };
    }
    function VW(a, i) {
      var f = null;
      return {
        baseLanes: rn(a.baseLanes, i),
        cachePool: f,
        transitions: a.transitions
      };
    }
    function BW(a, i, f, v) {
      if (i !== null) {
        var y = i.memoizedState;
        if (y === null)
          return !1;
      }
      return YR(a, wy);
    }
    function zW(a, i) {
      return of(a.childLanes, i);
    }
    function x_(a, i, f) {
      var v = i.pendingProps;
      Q7(i) && (i.flags |= Kt);
      var y = js.current, w = !1, M = (i.flags & Kt) !== Ut;
      if (M || BW(y, a) ? (w = !0, i.flags &= ~Kt) : (a === null || a.memoizedState !== null) && (y = iW(y, OI)), y = om(y), qu(i, y), a === null) {
        OR(i);
        var j = i.memoizedState;
        if (j !== null) {
          var B = j.dehydrated;
          if (B !== null)
            return YW(i, B);
        }
        var Q = v.children, re = v.fallback;
        if (w) {
          var Ce = UW(i, Q, re, f), xe = i.child;
          return xe.memoizedState = qO(f), i.memoizedState = WO, Ce;
        } else
          return YO(i, Q);
      } else {
        var Le = a.memoizedState;
        if (Le !== null) {
          var je = Le.dehydrated;
          if (je !== null)
            return GW(a, i, M, v, je, Le, f);
        }
        if (w) {
          var Ue = v.fallback, gt = v.children, Ht = WW(a, i, gt, Ue, f), Ft = i.child, yn = a.child.memoizedState;
          return Ft.memoizedState = yn === null ? qO(f) : VW(yn, f), Ft.childLanes = zW(a, f), i.memoizedState = WO, Ht;
        } else {
          var mn = v.children, ke = HW(a, i, mn, f);
          return i.memoizedState = null, ke;
        }
      }
    }
    function YO(a, i, f) {
      var v = a.mode, y = {
        mode: "visible",
        children: i
      }, w = GO(y, v);
      return w.return = a, a.child = w, w;
    }
    function UW(a, i, f, v) {
      var y = a.mode, w = a.child, M = {
        mode: "hidden",
        children: i
      }, j, B;
      return (y & Lt) === _t && w !== null ? (j = w, j.childLanes = Ge, j.pendingProps = M, a.mode & Xt && (j.actualDuration = 0, j.actualStartTime = -1, j.selfBaseDuration = 0, j.treeBaseDuration = 0), B = ed(f, y, v, null)) : (j = GO(M, y), B = ed(f, y, v, null)), j.return = a, B.return = a, j.sibling = B, a.child = j, B;
    }
    function GO(a, i, f) {
      return S2(a, i, Ge, null);
    }
    function S_(a, i) {
      return _f(a, i);
    }
    function HW(a, i, f, v) {
      var y = a.child, w = y.sibling, M = S_(y, {
        mode: "visible",
        children: f
      });
      if ((i.mode & Lt) === _t && (M.lanes = v), M.return = i, M.sibling = null, w !== null) {
        var j = i.deletions;
        j === null ? (i.deletions = [w], i.flags |= On) : j.push(w);
      }
      return i.child = M, M;
    }
    function WW(a, i, f, v, y) {
      var w = i.mode, M = a.child, j = M.sibling, B = {
        mode: "hidden",
        children: f
      }, Q;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (w & Lt) === _t && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        i.child !== M
      ) {
        var re = i.child;
        Q = re, Q.childLanes = Ge, Q.pendingProps = B, i.mode & Xt && (Q.actualDuration = 0, Q.actualStartTime = -1, Q.selfBaseDuration = M.selfBaseDuration, Q.treeBaseDuration = M.treeBaseDuration), i.deletions = null;
      } else
        Q = S_(M, B), Q.subtreeFlags = M.subtreeFlags & ao;
      var Ce;
      return j !== null ? Ce = _f(j, v) : (Ce = ed(v, w, y, null), Ce.flags |= Jn), Ce.return = i, Q.return = i, Q.sibling = Ce, i.child = Q, Ce;
    }
    function NC(a, i, f, v) {
      v !== null && PR(v), em(i, a.child, null, f);
      var y = i.pendingProps, w = y.children, M = YO(i, w);
      return M.flags |= Jn, i.memoizedState = null, M;
    }
    function qW(a, i, f, v, y) {
      var w = i.mode, M = {
        mode: "visible",
        children: f
      }, j = GO(M, w), B = ed(v, w, y, null);
      return B.flags |= Jn, j.return = i, B.return = i, j.sibling = B, i.child = j, (i.mode & Lt) !== _t && em(i, a.child, null, y), B;
    }
    function YW(a, i, f) {
      return (a.mode & Lt) === _t ? (u("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), a.lanes = Bt) : fR(i) ? a.lanes = ks : a.lanes = To, null;
    }
    function GW(a, i, f, v, y, w, M) {
      if (f)
        if (i.flags & vr) {
          i.flags &= ~vr;
          var ke = IO(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return NC(a, i, M, ke);
        } else {
          if (i.memoizedState !== null)
            return i.child = a.child, i.flags |= Kt, null;
          var He = v.children, Me = v.fallback, nt = qW(a, i, He, Me, M), Et = i.child;
          return Et.memoizedState = qO(M), i.memoizedState = WO, nt;
        }
      else {
        if (_8(), (i.mode & Lt) === _t)
          return NC(
            a,
            i,
            M,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (fR(y)) {
          var j, B, Q;
          {
            var re = J6(y);
            j = re.digest, B = re.message, Q = re.stack;
          }
          var Ce;
          B ? Ce = new Error(B) : Ce = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var xe = IO(Ce, j, Q);
          return NC(a, i, M, xe);
        }
        var Le = aa(M, a.childLanes);
        if (zs || Le) {
          var je = HC();
          if (je !== null) {
            var Ue = aS(je, M);
            if (Ue !== kr && Ue !== w.retryLane) {
              w.retryLane = Ue;
              var gt = Xn;
              Ja(a, Ue), vo(je, a, Ue, gt);
            }
          }
          mP();
          var Ht = IO(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return NC(a, i, M, Ht);
        } else if (HN(y)) {
          i.flags |= Kt, i.child = a.child;
          var Ft = b7.bind(null, a);
          return Z6(y, Ft), null;
        } else {
          F8(i, y, w.treeContext);
          var yn = v.children, mn = YO(i, yn);
          return mn.flags |= Va, mn;
        }
      }
    }
    function C_(a, i, f) {
      a.lanes = rn(a.lanes, i);
      var v = a.alternate;
      v !== null && (v.lanes = rn(v.lanes, i)), FR(a.return, i, f);
    }
    function KW(a, i, f) {
      for (var v = i; v !== null; ) {
        if (v.tag === N) {
          var y = v.memoizedState;
          y !== null && C_(v, f, a);
        } else if (v.tag === X)
          C_(v, f, a);
        else if (v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === a)
          return;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === a)
            return;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
    }
    function XW(a) {
      for (var i = a, f = null; i !== null; ) {
        var v = i.alternate;
        v !== null && dC(v) === null && (f = i), i = i.sibling;
      }
      return f;
    }
    function QW(a) {
      if (a !== void 0 && a !== "forwards" && a !== "backwards" && a !== "together" && !BO[a])
        if (BO[a] = !0, typeof a == "string")
          switch (a.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              u('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', a, a.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              u('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', a, a.toLowerCase());
              break;
            }
            default:
              u('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
              break;
          }
        else
          u('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
    }
    function JW(a, i) {
      a !== void 0 && !MC[a] && (a !== "collapsed" && a !== "hidden" ? (MC[a] = !0, u('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', a)) : i !== "forwards" && i !== "backwards" && (MC[a] = !0, u('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', a)));
    }
    function w_(a, i) {
      {
        var f = Gr(a), v = !f && typeof xs(a) == "function";
        if (f || v) {
          var y = f ? "array" : "iterable";
          return u("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", y, i, y), !1;
        }
      }
      return !0;
    }
    function ZW(a, i) {
      if ((i === "forwards" || i === "backwards") && a !== void 0 && a !== null && a !== !1)
        if (Gr(a)) {
          for (var f = 0; f < a.length; f++)
            if (!w_(a[f], f))
              return;
        } else {
          var v = xs(a);
          if (typeof v == "function") {
            var y = v.call(a);
            if (y)
              for (var w = y.next(), M = 0; !w.done; w = y.next()) {
                if (!w_(w.value, M))
                  return;
                M++;
              }
          } else
            u('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', i);
        }
    }
    function KO(a, i, f, v, y) {
      var w = a.memoizedState;
      w === null ? a.memoizedState = {
        isBackwards: i,
        rendering: null,
        renderingStartTime: 0,
        last: v,
        tail: f,
        tailMode: y
      } : (w.isBackwards = i, w.rendering = null, w.renderingStartTime = 0, w.last = v, w.tail = f, w.tailMode = y);
    }
    function T_(a, i, f) {
      var v = i.pendingProps, y = v.revealOrder, w = v.tail, M = v.children;
      QW(y), JW(w, y), ZW(M, y), Ca(a, i, M, f);
      var j = js.current, B = YR(j, wy);
      if (B)
        j = GR(j, wy), i.flags |= Kt;
      else {
        var Q = a !== null && (a.flags & Kt) !== Ut;
        Q && KW(i, i.child, f), j = om(j);
      }
      if (qu(i, j), (i.mode & Lt) === _t)
        i.memoizedState = null;
      else
        switch (y) {
          case "forwards": {
            var re = XW(i.child), Ce;
            re === null ? (Ce = i.child, i.child = null) : (Ce = re.sibling, re.sibling = null), KO(
              i,
              !1,
              // isBackwards
              Ce,
              re,
              w
            );
            break;
          }
          case "backwards": {
            var xe = null, Le = i.child;
            for (i.child = null; Le !== null; ) {
              var je = Le.alternate;
              if (je !== null && dC(je) === null) {
                i.child = Le;
                break;
              }
              var Ue = Le.sibling;
              Le.sibling = xe, xe = Le, Le = Ue;
            }
            KO(
              i,
              !0,
              // isBackwards
              xe,
              null,
              // last
              w
            );
            break;
          }
          case "together": {
            KO(
              i,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            i.memoizedState = null;
        }
      return i.child;
    }
    function e9(a, i, f) {
      HR(i, i.stateNode.containerInfo);
      var v = i.pendingProps;
      return a === null ? i.child = em(i, null, v, f) : Ca(a, i, v, f), i.child;
    }
    var E_ = !1;
    function t9(a, i, f) {
      var v = i.type, y = v._context, w = i.pendingProps, M = i.memoizedProps, j = w.value;
      {
        "value" in w || E_ || (E_ = !0, u("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var B = i.type.propTypes;
        B && As(B, w, "prop", "Context.Provider");
      }
      if (gI(i, y, j), M !== null) {
        var Q = M.value;
        if (Dt(Q, j)) {
          if (M.children === w.children && !zS())
            return Oc(a, i, f);
        } else
          Q8(i, y, f);
      }
      var re = w.children;
      return Ca(a, i, re, f), i.child;
    }
    var R_ = !1;
    function n9(a, i, f) {
      var v = i.type;
      v._context === void 0 ? v !== v.Consumer && (R_ || (R_ = !0, u("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : v = v._context;
      var y = i.pendingProps, w = y.children;
      typeof w != "function" && u("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), nm(i, f);
      var M = eo(v);
      du(i);
      var j;
      return My.current = i, Si(!0), j = w(M), Si(!1), na(), i.flags |= dl, Ca(a, i, j, f), i.child;
    }
    function _y() {
      zs = !0;
    }
    function IC(a, i) {
      (i.mode & Lt) === _t && a !== null && (a.alternate = null, i.alternate = null, i.flags |= Jn);
    }
    function Oc(a, i, f) {
      return a !== null && (i.dependencies = a.dependencies), t_(), Yy(i.lanes), aa(f, i.childLanes) ? (K8(a, i), i.child) : null;
    }
    function r9(a, i, f) {
      {
        var v = i.return;
        if (v === null)
          throw new Error("Cannot swap the root fiber.");
        if (a.alternate = null, i.alternate = null, f.index = i.index, f.sibling = i.sibling, f.return = i.return, f.ref = i.ref, i === v.child)
          v.child = f;
        else {
          var y = v.child;
          if (y === null)
            throw new Error("Expected parent to have a child.");
          for (; y.sibling !== i; )
            if (y = y.sibling, y === null)
              throw new Error("Expected to find the previous sibling.");
          y.sibling = f;
        }
        var w = v.deletions;
        return w === null ? (v.deletions = [a], v.flags |= On) : w.push(a), f.flags |= Jn, f;
      }
    }
    function XO(a, i) {
      var f = a.lanes;
      return !!aa(f, i);
    }
    function o9(a, i, f) {
      switch (i.tag) {
        case x:
          y_(i), i.stateNode, Zh();
          break;
        case R:
          EI(i);
          break;
        case m: {
          var v = i.type;
          Tl(v) && HS(i);
          break;
        }
        case S:
          HR(i, i.stateNode.containerInfo);
          break;
        case _: {
          var y = i.memoizedProps.value, w = i.type._context;
          gI(i, w, y);
          break;
        }
        case F:
          {
            var M = aa(f, i.childLanes);
            M && (i.flags |= an);
            {
              var j = i.stateNode;
              j.effectDuration = 0, j.passiveEffectDuration = 0;
            }
          }
          break;
        case N: {
          var B = i.memoizedState;
          if (B !== null) {
            if (B.dehydrated !== null)
              return qu(i, om(js.current)), i.flags |= Kt, null;
            var Q = i.child, re = Q.childLanes;
            if (aa(f, re))
              return x_(a, i, f);
            qu(i, om(js.current));
            var Ce = Oc(a, i, f);
            return Ce !== null ? Ce.sibling : null;
          } else
            qu(i, om(js.current));
          break;
        }
        case X: {
          var xe = (a.flags & Kt) !== Ut, Le = aa(f, i.childLanes);
          if (xe) {
            if (Le)
              return T_(a, i, f);
            i.flags |= Kt;
          }
          var je = i.memoizedState;
          if (je !== null && (je.rendering = null, je.tail = null, je.lastEffect = null), qu(i, js.current), Le)
            break;
          return null;
        }
        case Y:
        case J:
          return i.lanes = Ge, m_(a, i, f);
      }
      return Oc(a, i, f);
    }
    function O_(a, i, f) {
      if (i._debugNeedsRemount && a !== null)
        return r9(a, i, RP(i.type, i.key, i.pendingProps, i._debugOwner || null, i.mode, i.lanes));
      if (a !== null) {
        var v = a.memoizedProps, y = i.pendingProps;
        if (v !== y || zS() || // Force a re-render if the implementation changed due to hot reload:
        i.type !== a.type)
          zs = !0;
        else {
          var w = XO(a, f);
          if (!w && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (i.flags & Kt) === Ut)
            return zs = !1, o9(a, i, f);
          (a.flags & Gd) !== Ut ? zs = !0 : zs = !1;
        }
      } else if (zs = !1, Ao() && $8(i)) {
        var M = i.index, j = D8();
        tI(i, j, M);
      }
      switch (i.lanes = Ge, i.tag) {
        case b:
          return jW(a, i, i.type, f);
        case H: {
          var B = i.elementType;
          return LW(a, i, B, f);
        }
        case h: {
          var Q = i.type, re = i.pendingProps, Ce = i.elementType === Q ? re : Bs(Q, re);
          return zO(a, i, Q, Ce, f);
        }
        case m: {
          var xe = i.type, Le = i.pendingProps, je = i.elementType === xe ? Le : Bs(xe, Le);
          return g_(a, i, xe, je, f);
        }
        case x:
          return IW(a, i, f);
        case R:
          return _W(a, i, f);
        case T:
          return AW(a, i);
        case N:
          return x_(a, i, f);
        case S:
          return e9(a, i, f);
        case L: {
          var Ue = i.type, gt = i.pendingProps, Ht = i.elementType === Ue ? gt : Bs(Ue, gt);
          return f_(a, i, Ue, Ht, f);
        }
        case E:
          return kW(a, i, f);
        case P:
          return MW(a, i, f);
        case F:
          return NW(a, i, f);
        case _:
          return t9(a, i, f);
        case k:
          return n9(a, i, f);
        case V: {
          var Ft = i.type, yn = i.pendingProps, mn = Bs(Ft, yn);
          if (i.type !== i.elementType) {
            var ke = Ft.propTypes;
            ke && As(
              ke,
              mn,
              // Resolved for outer only
              "prop",
              Mn(Ft)
            );
          }
          return mn = Bs(Ft.type, mn), p_(a, i, Ft, mn, f);
        }
        case z:
          return h_(a, i, i.type, i.pendingProps, f);
        case ee: {
          var He = i.type, Me = i.pendingProps, nt = i.elementType === He ? Me : Bs(He, Me);
          return FW(a, i, He, nt, f);
        }
        case X:
          return T_(a, i, f);
        case ne:
          break;
        case Y:
          return m_(a, i, f);
      }
      throw new Error("Unknown unit of work tag (" + i.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function um(a) {
      a.flags |= an;
    }
    function P_(a) {
      a.flags |= Qo, a.flags |= Sg;
    }
    var $_, QO, D_, k_;
    $_ = function(a, i, f, v) {
      for (var y = i.child; y !== null; ) {
        if (y.tag === R || y.tag === T)
          R6(a, y.stateNode);
        else if (y.tag !== S) {
          if (y.child !== null) {
            y.child.return = y, y = y.child;
            continue;
          }
        }
        if (y === i)
          return;
        for (; y.sibling === null; ) {
          if (y.return === null || y.return === i)
            return;
          y = y.return;
        }
        y.sibling.return = y.return, y = y.sibling;
      }
    }, QO = function(a, i) {
    }, D_ = function(a, i, f, v, y) {
      var w = a.memoizedProps;
      if (w !== v) {
        var M = i.stateNode, j = WR(), B = P6(M, f, w, v, y, j);
        i.updateQueue = B, B && um(i);
      }
    }, k_ = function(a, i, f, v) {
      f !== v && um(i);
    };
    function Ay(a, i) {
      if (!Ao())
        switch (a.tailMode) {
          case "hidden": {
            for (var f = a.tail, v = null; f !== null; )
              f.alternate !== null && (v = f), f = f.sibling;
            v === null ? a.tail = null : v.sibling = null;
            break;
          }
          case "collapsed": {
            for (var y = a.tail, w = null; y !== null; )
              y.alternate !== null && (w = y), y = y.sibling;
            w === null ? !i && a.tail !== null ? a.tail.sibling = null : a.tail = null : w.sibling = null;
            break;
          }
        }
    }
    function Fo(a) {
      var i = a.alternate !== null && a.alternate.child === a.child, f = Ge, v = Ut;
      if (i) {
        if ((a.mode & Xt) !== _t) {
          for (var B = a.selfBaseDuration, Q = a.child; Q !== null; )
            f = rn(f, rn(Q.lanes, Q.childLanes)), v |= Q.subtreeFlags & ao, v |= Q.flags & ao, B += Q.treeBaseDuration, Q = Q.sibling;
          a.treeBaseDuration = B;
        } else
          for (var re = a.child; re !== null; )
            f = rn(f, rn(re.lanes, re.childLanes)), v |= re.subtreeFlags & ao, v |= re.flags & ao, re.return = a, re = re.sibling;
        a.subtreeFlags |= v;
      } else {
        if ((a.mode & Xt) !== _t) {
          for (var y = a.actualDuration, w = a.selfBaseDuration, M = a.child; M !== null; )
            f = rn(f, rn(M.lanes, M.childLanes)), v |= M.subtreeFlags, v |= M.flags, y += M.actualDuration, w += M.treeBaseDuration, M = M.sibling;
          a.actualDuration = y, a.treeBaseDuration = w;
        } else
          for (var j = a.child; j !== null; )
            f = rn(f, rn(j.lanes, j.childLanes)), v |= j.subtreeFlags, v |= j.flags, j.return = a, j = j.sibling;
        a.subtreeFlags |= v;
      }
      return a.childLanes = f, i;
    }
    function a9(a, i, f) {
      if (U8() && (i.mode & Lt) !== _t && (i.flags & Kt) === Ut)
        return lI(i), Zh(), i.flags |= vr | va | Xr, !1;
      var v = KS(i);
      if (f !== null && f.dehydrated !== null)
        if (a === null) {
          if (!v)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (B8(i), Fo(i), (i.mode & Xt) !== _t) {
            var y = f !== null;
            if (y) {
              var w = i.child;
              w !== null && (i.treeBaseDuration -= w.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Zh(), (i.flags & Kt) === Ut && (i.memoizedState = null), i.flags |= an, Fo(i), (i.mode & Xt) !== _t) {
            var M = f !== null;
            if (M) {
              var j = i.child;
              j !== null && (i.treeBaseDuration -= j.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return cI(), !0;
    }
    function M_(a, i, f) {
      var v = i.pendingProps;
      switch (wR(i), i.tag) {
        case b:
        case H:
        case z:
        case h:
        case L:
        case E:
        case P:
        case F:
        case k:
        case V:
          return Fo(i), null;
        case m: {
          var y = i.type;
          return Tl(y) && US(i), Fo(i), null;
        }
        case x: {
          var w = i.stateNode;
          if (rm(i), bR(i), XR(), w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), a === null || a.child === null) {
            var M = KS(i);
            if (M)
              um(i);
            else if (a !== null) {
              var j = a.memoizedState;
              // Check if this is a client root
              (!j.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (i.flags & vr) !== Ut) && (i.flags |= ja, cI());
            }
          }
          return QO(a, i), Fo(i), null;
        }
        case R: {
          qR(i);
          var B = TI(), Q = i.type;
          if (a !== null && i.stateNode != null)
            D_(a, i, Q, v, B), a.ref !== i.ref && P_(i);
          else {
            if (!v) {
              if (i.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Fo(i), null;
            }
            var re = WR(), Ce = KS(i);
            if (Ce)
              j8(i, B, re) && um(i);
            else {
              var xe = E6(Q, v, B, re, i);
              $_(xe, i, !1, !1), i.stateNode = xe, O6(xe, Q, v, B) && um(i);
            }
            i.ref !== null && P_(i);
          }
          return Fo(i), null;
        }
        case T: {
          var Le = v;
          if (a && i.stateNode != null) {
            var je = a.memoizedProps;
            k_(a, i, je, Le);
          } else {
            if (typeof Le != "string" && i.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Ue = TI(), gt = WR(), Ht = KS(i);
            Ht ? V8(i) && um(i) : i.stateNode = $6(Le, Ue, gt, i);
          }
          return Fo(i), null;
        }
        case N: {
          am(i);
          var Ft = i.memoizedState;
          if (a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
            var yn = a9(a, i, Ft);
            if (!yn)
              return i.flags & Xr ? i : null;
          }
          if ((i.flags & Kt) !== Ut)
            return i.lanes = f, (i.mode & Xt) !== _t && SO(i), i;
          var mn = Ft !== null, ke = a !== null && a.memoizedState !== null;
          if (mn !== ke && mn) {
            var He = i.child;
            if (He.flags |= fl, (i.mode & Lt) !== _t) {
              var Me = a === null && (i.memoizedProps.unstable_avoidThisFallback !== !0 || !le);
              Me || YR(js.current, OI) ? i7() : mP();
            }
          }
          var nt = i.updateQueue;
          if (nt !== null && (i.flags |= an), Fo(i), (i.mode & Xt) !== _t && mn) {
            var Et = i.child;
            Et !== null && (i.treeBaseDuration -= Et.treeBaseDuration);
          }
          return null;
        }
        case S:
          return rm(i), QO(a, i), a === null && C8(i.stateNode.containerInfo), Fo(i), null;
        case _:
          var yt = i.type._context;
          return LR(yt, i), Fo(i), null;
        case ee: {
          var Gt = i.type;
          return Tl(Gt) && US(i), Fo(i), null;
        }
        case X: {
          am(i);
          var Zt = i.memoizedState;
          if (Zt === null)
            return Fo(i), null;
          var Ln = (i.flags & Kt) !== Ut, Tn = Zt.rendering;
          if (Tn === null)
            if (Ln)
              Ay(Zt, !1);
            else {
              var Hr = l7() && (a === null || (a.flags & Kt) === Ut);
              if (!Hr)
                for (var En = i.child; En !== null; ) {
                  var Mr = dC(En);
                  if (Mr !== null) {
                    Ln = !0, i.flags |= Kt, Ay(Zt, !1);
                    var ua = Mr.updateQueue;
                    return ua !== null && (i.updateQueue = ua, i.flags |= an), i.subtreeFlags = Ut, X8(i, f), qu(i, GR(js.current, wy)), i.child;
                  }
                  En = En.sibling;
                }
              Zt.tail !== null && cr() > Z_() && (i.flags |= Kt, Ln = !0, Ay(Zt, !1), i.lanes = Gx);
            }
          else {
            if (!Ln) {
              var Uo = dC(Tn);
              if (Uo !== null) {
                i.flags |= Kt, Ln = !0;
                var Pi = Uo.updateQueue;
                if (Pi !== null && (i.updateQueue = Pi, i.flags |= an), Ay(Zt, !0), Zt.tail === null && Zt.tailMode === "hidden" && !Tn.alternate && !Ao())
                  return Fo(i), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              cr() * 2 - Zt.renderingStartTime > Z_() && f !== To && (i.flags |= Kt, Ln = !0, Ay(Zt, !1), i.lanes = Gx);
            }
            if (Zt.isBackwards)
              Tn.sibling = i.child, i.child = Tn;
            else {
              var Ea = Zt.last;
              Ea !== null ? Ea.sibling = Tn : i.child = Tn, Zt.last = Tn;
            }
          }
          if (Zt.tail !== null) {
            var Ra = Zt.tail;
            Zt.rendering = Ra, Zt.tail = Ra.sibling, Zt.renderingStartTime = cr(), Ra.sibling = null;
            var da = js.current;
            return Ln ? da = GR(da, wy) : da = om(da), qu(i, da), Ra;
          }
          return Fo(i), null;
        }
        case ne:
          break;
        case Y:
        case J: {
          hP(i);
          var Mc = i.memoizedState, ym = Mc !== null;
          if (a !== null) {
            var Jy = a.memoizedState, Ml = Jy !== null;
            Ml !== ym && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !W && (i.flags |= fl);
          }
          return !ym || (i.mode & Lt) === _t ? Fo(i) : aa(kl, To) && (Fo(i), i.subtreeFlags & (Jn | an) && (i.flags |= fl)), null;
        }
        case te:
          return null;
        case Z:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + i.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function i9(a, i, f) {
      switch (wR(i), i.tag) {
        case m: {
          var v = i.type;
          Tl(v) && US(i);
          var y = i.flags;
          return y & Xr ? (i.flags = y & ~Xr | Kt, (i.mode & Xt) !== _t && SO(i), i) : null;
        }
        case x: {
          i.stateNode, rm(i), bR(i), XR();
          var w = i.flags;
          return (w & Xr) !== Ut && (w & Kt) === Ut ? (i.flags = w & ~Xr | Kt, i) : null;
        }
        case R:
          return qR(i), null;
        case N: {
          am(i);
          var M = i.memoizedState;
          if (M !== null && M.dehydrated !== null) {
            if (i.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Zh();
          }
          var j = i.flags;
          return j & Xr ? (i.flags = j & ~Xr | Kt, (i.mode & Xt) !== _t && SO(i), i) : null;
        }
        case X:
          return am(i), null;
        case S:
          return rm(i), null;
        case _:
          var B = i.type._context;
          return LR(B, i), null;
        case Y:
        case J:
          return hP(i), null;
        case te:
          return null;
        default:
          return null;
      }
    }
    function N_(a, i, f) {
      switch (wR(i), i.tag) {
        case m: {
          var v = i.type.childContextTypes;
          v != null && US(i);
          break;
        }
        case x: {
          i.stateNode, rm(i), bR(i), XR();
          break;
        }
        case R: {
          qR(i);
          break;
        }
        case S:
          rm(i);
          break;
        case N:
          am(i);
          break;
        case X:
          am(i);
          break;
        case _:
          var y = i.type._context;
          LR(y, i);
          break;
        case Y:
        case J:
          hP(i);
          break;
      }
    }
    var I_ = null;
    I_ = /* @__PURE__ */ new Set();
    var _C = !1, jo = !1, s9 = typeof WeakSet == "function" ? WeakSet : Set, kt = null, dm = null, fm = null;
    function l9(a) {
      rc(null, function() {
        throw a;
      }), bg();
    }
    var c9 = function(a, i) {
      if (i.props = a.memoizedProps, i.state = a.memoizedState, a.mode & Xt)
        try {
          $l(), i.componentWillUnmount();
        } finally {
          Pl(a);
        }
      else
        i.componentWillUnmount();
    };
    function __(a, i) {
      try {
        Ku(co, a);
      } catch (f) {
        tr(a, i, f);
      }
    }
    function JO(a, i, f) {
      try {
        c9(a, f);
      } catch (v) {
        tr(a, i, v);
      }
    }
    function u9(a, i, f) {
      try {
        f.componentDidMount();
      } catch (v) {
        tr(a, i, v);
      }
    }
    function A_(a, i) {
      try {
        F_(a);
      } catch (f) {
        tr(a, i, f);
      }
    }
    function pm(a, i) {
      var f = a.ref;
      if (f !== null)
        if (typeof f == "function") {
          var v;
          try {
            if (se && ve && a.mode & Xt)
              try {
                $l(), v = f(null);
              } finally {
                Pl(a);
              }
            else
              v = f(null);
          } catch (y) {
            tr(a, i, y);
          }
          typeof v == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nn(a));
        } else
          f.current = null;
    }
    function AC(a, i, f) {
      try {
        f();
      } catch (v) {
        tr(a, i, v);
      }
    }
    var L_ = !1;
    function d9(a, i) {
      w6(a.containerInfo), kt = i, f9();
      var f = L_;
      return L_ = !1, f;
    }
    function f9() {
      for (; kt !== null; ) {
        var a = kt, i = a.child;
        (a.subtreeFlags & lu) !== Ut && i !== null ? (i.return = a, kt = i) : p9();
      }
    }
    function p9() {
      for (; kt !== null; ) {
        var a = kt;
        _n(a);
        try {
          h9(a);
        } catch (f) {
          tr(a, a.return, f);
        }
        Fr();
        var i = a.sibling;
        if (i !== null) {
          i.return = a.return, kt = i;
          return;
        }
        kt = a.return;
      }
    }
    function h9(a) {
      var i = a.alternate, f = a.flags;
      if ((f & ja) !== Ut) {
        switch (_n(a), a.tag) {
          case h:
          case L:
          case z:
            break;
          case m: {
            if (i !== null) {
              var v = i.memoizedProps, y = i.memoizedState, w = a.stateNode;
              a.type === a.elementType && !Df && (w.props !== a.memoizedProps && u("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nn(a) || "instance"), w.state !== a.memoizedState && u("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nn(a) || "instance"));
              var M = w.getSnapshotBeforeUpdate(a.elementType === a.type ? v : Bs(a.type, v), y);
              {
                var j = I_;
                M === void 0 && !j.has(a.type) && (j.add(a.type), u("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", nn(a)));
              }
              w.__reactInternalSnapshotBeforeUpdate = M;
            }
            break;
          }
          case x: {
            {
              var B = a.stateNode;
              G6(B.containerInfo);
            }
            break;
          }
          case R:
          case T:
          case S:
          case ee:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Fr();
      }
    }
    function Us(a, i, f) {
      var v = i.updateQueue, y = v !== null ? v.lastEffect : null;
      if (y !== null) {
        var w = y.next, M = w;
        do {
          if ((M.tag & a) === a) {
            var j = M.destroy;
            M.destroy = void 0, j !== void 0 && ((a & Lo) !== Za ? Wx(i) : (a & co) !== Za && Ei(i), (a & El) !== Za && Ky(!0), AC(i, f, j), (a & El) !== Za && Ky(!1), (a & Lo) !== Za ? Zp() : (a & co) !== Za && fu());
          }
          M = M.next;
        } while (M !== w);
      }
    }
    function Ku(a, i) {
      var f = i.updateQueue, v = f !== null ? f.lastEffect : null;
      if (v !== null) {
        var y = v.next, w = y;
        do {
          if ((w.tag & a) === a) {
            (a & Lo) !== Za ? ml(i) : (a & co) !== Za && qx(i);
            var M = w.create;
            (a & El) !== Za && Ky(!0), w.destroy = M(), (a & El) !== Za && Ky(!1), (a & Lo) !== Za ? Jp() : (a & co) !== Za && Kd();
            {
              var j = w.destroy;
              if (j !== void 0 && typeof j != "function") {
                var B = void 0;
                (w.tag & co) !== Ut ? B = "useLayoutEffect" : (w.tag & El) !== Ut ? B = "useInsertionEffect" : B = "useEffect";
                var Q = void 0;
                j === null ? Q = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof j.then == "function" ? Q = `

It looks like you wrote ` + B + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + B + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : Q = " You returned: " + j, u("%s must not return anything besides a function, which is used for clean-up.%s", B, Q);
              }
            }
          }
          w = w.next;
        } while (w !== y);
      }
    }
    function m9(a, i) {
      if ((i.flags & an) !== Ut)
        switch (i.tag) {
          case F: {
            var f = i.stateNode.passiveEffectDuration, v = i.memoizedProps, y = v.id, w = v.onPostCommit, M = ZI(), j = i.alternate === null ? "mount" : "update";
            JI() && (j = "nested-update"), typeof w == "function" && w(y, j, f, M);
            var B = i.return;
            e: for (; B !== null; ) {
              switch (B.tag) {
                case x:
                  var Q = B.stateNode;
                  Q.passiveEffectDuration += f;
                  break e;
                case F:
                  var re = B.stateNode;
                  re.passiveEffectDuration += f;
                  break e;
              }
              B = B.return;
            }
            break;
          }
        }
    }
    function v9(a, i, f, v) {
      if ((f.flags & Co) !== Ut)
        switch (f.tag) {
          case h:
          case L:
          case z: {
            if (!jo)
              if (f.mode & Xt)
                try {
                  $l(), Ku(co | lo, f);
                } finally {
                  Pl(f);
                }
              else
                Ku(co | lo, f);
            break;
          }
          case m: {
            var y = f.stateNode;
            if (f.flags & an && !jo)
              if (i === null)
                if (f.type === f.elementType && !Df && (y.props !== f.memoizedProps && u("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nn(f) || "instance"), y.state !== f.memoizedState && u("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nn(f) || "instance")), f.mode & Xt)
                  try {
                    $l(), y.componentDidMount();
                  } finally {
                    Pl(f);
                  }
                else
                  y.componentDidMount();
              else {
                var w = f.elementType === f.type ? i.memoizedProps : Bs(f.type, i.memoizedProps), M = i.memoizedState;
                if (f.type === f.elementType && !Df && (y.props !== f.memoizedProps && u("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nn(f) || "instance"), y.state !== f.memoizedState && u("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nn(f) || "instance")), f.mode & Xt)
                  try {
                    $l(), y.componentDidUpdate(w, M, y.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Pl(f);
                  }
                else
                  y.componentDidUpdate(w, M, y.__reactInternalSnapshotBeforeUpdate);
              }
            var j = f.updateQueue;
            j !== null && (f.type === f.elementType && !Df && (y.props !== f.memoizedProps && u("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nn(f) || "instance"), y.state !== f.memoizedState && u("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nn(f) || "instance")), wI(f, j, y));
            break;
          }
          case x: {
            var B = f.updateQueue;
            if (B !== null) {
              var Q = null;
              if (f.child !== null)
                switch (f.child.tag) {
                  case R:
                    Q = f.child.stateNode;
                    break;
                  case m:
                    Q = f.child.stateNode;
                    break;
                }
              wI(f, B, Q);
            }
            break;
          }
          case R: {
            var re = f.stateNode;
            if (i === null && f.flags & an) {
              var Ce = f.type, xe = f.memoizedProps;
              I6(re, Ce, xe);
            }
            break;
          }
          case T:
            break;
          case S:
            break;
          case F: {
            {
              var Le = f.memoizedProps, je = Le.onCommit, Ue = Le.onRender, gt = f.stateNode.effectDuration, Ht = ZI(), Ft = i === null ? "mount" : "update";
              JI() && (Ft = "nested-update"), typeof Ue == "function" && Ue(f.memoizedProps.id, Ft, f.actualDuration, f.treeBaseDuration, f.actualStartTime, Ht);
              {
                typeof je == "function" && je(f.memoizedProps.id, Ft, gt, Ht), p7(f);
                var yn = f.return;
                e: for (; yn !== null; ) {
                  switch (yn.tag) {
                    case x:
                      var mn = yn.stateNode;
                      mn.effectDuration += gt;
                      break e;
                    case F:
                      var ke = yn.stateNode;
                      ke.effectDuration += gt;
                      break e;
                  }
                  yn = yn.return;
                }
              }
            }
            break;
          }
          case N: {
            T9(a, f);
            break;
          }
          case X:
          case ee:
          case ne:
          case Y:
          case J:
          case Z:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      jo || f.flags & Qo && F_(f);
    }
    function g9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          if (a.mode & Xt)
            try {
              $l(), __(a, a.return);
            } finally {
              Pl(a);
            }
          else
            __(a, a.return);
          break;
        }
        case m: {
          var i = a.stateNode;
          typeof i.componentDidMount == "function" && u9(a, a.return, i), A_(a, a.return);
          break;
        }
        case R: {
          A_(a, a.return);
          break;
        }
      }
    }
    function y9(a, i) {
      for (var f = null, v = a; ; ) {
        if (v.tag === R) {
          if (f === null) {
            f = v;
            try {
              var y = v.stateNode;
              i ? H6(y) : q6(v.stateNode, v.memoizedProps);
            } catch (M) {
              tr(a, a.return, M);
            }
          }
        } else if (v.tag === T) {
          if (f === null)
            try {
              var w = v.stateNode;
              i ? W6(w) : Y6(w, v.memoizedProps);
            } catch (M) {
              tr(a, a.return, M);
            }
        } else if (!((v.tag === Y || v.tag === J) && v.memoizedState !== null && v !== a)) {
          if (v.child !== null) {
            v.child.return = v, v = v.child;
            continue;
          }
        }
        if (v === a)
          return;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === a)
            return;
          f === v && (f = null), v = v.return;
        }
        f === v && (f = null), v.sibling.return = v.return, v = v.sibling;
      }
    }
    function F_(a) {
      var i = a.ref;
      if (i !== null) {
        var f = a.stateNode, v;
        switch (a.tag) {
          case R:
            v = f;
            break;
          default:
            v = f;
        }
        if (typeof i == "function") {
          var y;
          if (a.mode & Xt)
            try {
              $l(), y = i(v);
            } finally {
              Pl(a);
            }
          else
            y = i(v);
          typeof y == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nn(a));
        } else
          i.hasOwnProperty("current") || u("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", nn(a)), i.current = v;
      }
    }
    function b9(a) {
      var i = a.alternate;
      i !== null && (i.return = null), a.return = null;
    }
    function j_(a) {
      var i = a.alternate;
      i !== null && (a.alternate = null, j_(i));
      {
        if (a.child = null, a.deletions = null, a.sibling = null, a.tag === R) {
          var f = a.stateNode;
          f !== null && E8(f);
        }
        a.stateNode = null, a._debugOwner = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
      }
    }
    function x9(a) {
      for (var i = a.return; i !== null; ) {
        if (V_(i))
          return i;
        i = i.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function V_(a) {
      return a.tag === R || a.tag === x || a.tag === S;
    }
    function B_(a) {
      var i = a;
      e: for (; ; ) {
        for (; i.sibling === null; ) {
          if (i.return === null || V_(i.return))
            return null;
          i = i.return;
        }
        for (i.sibling.return = i.return, i = i.sibling; i.tag !== R && i.tag !== T && i.tag !== K; ) {
          if (i.flags & Jn || i.child === null || i.tag === S)
            continue e;
          i.child.return = i, i = i.child;
        }
        if (!(i.flags & Jn))
          return i.stateNode;
      }
    }
    function S9(a) {
      var i = x9(a);
      switch (i.tag) {
        case R: {
          var f = i.stateNode;
          i.flags & Pn && (UN(f), i.flags &= ~Pn);
          var v = B_(a);
          eP(a, v, f);
          break;
        }
        case x:
        case S: {
          var y = i.stateNode.containerInfo, w = B_(a);
          ZO(a, w, y);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function ZO(a, i, f) {
      var v = a.tag, y = v === R || v === T;
      if (y) {
        var w = a.stateNode;
        i ? V6(f, w, i) : F6(f, w);
      } else if (v !== S) {
        var M = a.child;
        if (M !== null) {
          ZO(M, i, f);
          for (var j = M.sibling; j !== null; )
            ZO(j, i, f), j = j.sibling;
        }
      }
    }
    function eP(a, i, f) {
      var v = a.tag, y = v === R || v === T;
      if (y) {
        var w = a.stateNode;
        i ? j6(f, w, i) : L6(f, w);
      } else if (v !== S) {
        var M = a.child;
        if (M !== null) {
          eP(M, i, f);
          for (var j = M.sibling; j !== null; )
            eP(j, i, f), j = j.sibling;
        }
      }
    }
    var Vo = null, Hs = !1;
    function C9(a, i, f) {
      {
        var v = i;
        e: for (; v !== null; ) {
          switch (v.tag) {
            case R: {
              Vo = v.stateNode, Hs = !1;
              break e;
            }
            case x: {
              Vo = v.stateNode.containerInfo, Hs = !0;
              break e;
            }
            case S: {
              Vo = v.stateNode.containerInfo, Hs = !0;
              break e;
            }
          }
          v = v.return;
        }
        if (Vo === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        z_(a, i, f), Vo = null, Hs = !1;
      }
      b9(f);
    }
    function Xu(a, i, f) {
      for (var v = f.child; v !== null; )
        z_(a, i, v), v = v.sibling;
    }
    function z_(a, i, f) {
      switch (ic(f), f.tag) {
        case R:
          jo || pm(f, i);
        case T: {
          {
            var v = Vo, y = Hs;
            Vo = null, Xu(a, i, f), Vo = v, Hs = y, Vo !== null && (Hs ? z6(Vo, f.stateNode) : B6(Vo, f.stateNode));
          }
          return;
        }
        case K: {
          Vo !== null && (Hs ? U6(Vo, f.stateNode) : dR(Vo, f.stateNode));
          return;
        }
        case S: {
          {
            var w = Vo, M = Hs;
            Vo = f.stateNode.containerInfo, Hs = !0, Xu(a, i, f), Vo = w, Hs = M;
          }
          return;
        }
        case h:
        case L:
        case V:
        case z: {
          if (!jo) {
            var j = f.updateQueue;
            if (j !== null) {
              var B = j.lastEffect;
              if (B !== null) {
                var Q = B.next, re = Q;
                do {
                  var Ce = re, xe = Ce.destroy, Le = Ce.tag;
                  xe !== void 0 && ((Le & El) !== Za ? AC(f, i, xe) : (Le & co) !== Za && (Ei(f), f.mode & Xt ? ($l(), AC(f, i, xe), Pl(f)) : AC(f, i, xe), fu())), re = re.next;
                } while (re !== Q);
              }
            }
          }
          Xu(a, i, f);
          return;
        }
        case m: {
          if (!jo) {
            pm(f, i);
            var je = f.stateNode;
            typeof je.componentWillUnmount == "function" && JO(f, i, je);
          }
          Xu(a, i, f);
          return;
        }
        case ne: {
          Xu(a, i, f);
          return;
        }
        case Y: {
          if (
            // TODO: Remove this dead flag
            f.mode & Lt
          ) {
            var Ue = jo;
            jo = Ue || f.memoizedState !== null, Xu(a, i, f), jo = Ue;
          } else
            Xu(a, i, f);
          break;
        }
        default: {
          Xu(a, i, f);
          return;
        }
      }
    }
    function w9(a) {
      a.memoizedState;
    }
    function T9(a, i) {
      var f = i.memoizedState;
      if (f === null) {
        var v = i.alternate;
        if (v !== null) {
          var y = v.memoizedState;
          if (y !== null) {
            var w = y.dehydrated;
            w !== null && l8(w);
          }
        }
      }
    }
    function U_(a) {
      var i = a.updateQueue;
      if (i !== null) {
        a.updateQueue = null;
        var f = a.stateNode;
        f === null && (f = a.stateNode = new s9()), i.forEach(function(v) {
          var y = x7.bind(null, a, v);
          if (!f.has(v)) {
            if (f.add(v), ba)
              if (dm !== null && fm !== null)
                Gy(fm, dm);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            v.then(y, y);
          }
        });
      }
    }
    function E9(a, i, f) {
      dm = f, fm = a, _n(i), H_(i, a), _n(i), dm = null, fm = null;
    }
    function Ws(a, i, f) {
      var v = i.deletions;
      if (v !== null)
        for (var y = 0; y < v.length; y++) {
          var w = v[y];
          try {
            C9(a, i, w);
          } catch (B) {
            tr(w, i, B);
          }
        }
      var M = fE();
      if (i.subtreeFlags & ea)
        for (var j = i.child; j !== null; )
          _n(j), H_(j, a), j = j.sibling;
      _n(M);
    }
    function H_(a, i, f) {
      var v = a.alternate, y = a.flags;
      switch (a.tag) {
        case h:
        case L:
        case V:
        case z: {
          if (Ws(i, a), Dl(a), y & an) {
            try {
              Us(El | lo, a, a.return), Ku(El | lo, a);
            } catch (Gt) {
              tr(a, a.return, Gt);
            }
            if (a.mode & Xt) {
              try {
                $l(), Us(co | lo, a, a.return);
              } catch (Gt) {
                tr(a, a.return, Gt);
              }
              Pl(a);
            } else
              try {
                Us(co | lo, a, a.return);
              } catch (Gt) {
                tr(a, a.return, Gt);
              }
          }
          return;
        }
        case m: {
          Ws(i, a), Dl(a), y & Qo && v !== null && pm(v, v.return);
          return;
        }
        case R: {
          Ws(i, a), Dl(a), y & Qo && v !== null && pm(v, v.return);
          {
            if (a.flags & Pn) {
              var w = a.stateNode;
              try {
                UN(w);
              } catch (Gt) {
                tr(a, a.return, Gt);
              }
            }
            if (y & an) {
              var M = a.stateNode;
              if (M != null) {
                var j = a.memoizedProps, B = v !== null ? v.memoizedProps : j, Q = a.type, re = a.updateQueue;
                if (a.updateQueue = null, re !== null)
                  try {
                    _6(M, re, Q, B, j, a);
                  } catch (Gt) {
                    tr(a, a.return, Gt);
                  }
              }
            }
          }
          return;
        }
        case T: {
          if (Ws(i, a), Dl(a), y & an) {
            if (a.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Ce = a.stateNode, xe = a.memoizedProps, Le = v !== null ? v.memoizedProps : xe;
            try {
              A6(Ce, Le, xe);
            } catch (Gt) {
              tr(a, a.return, Gt);
            }
          }
          return;
        }
        case x: {
          if (Ws(i, a), Dl(a), y & an && v !== null) {
            var je = v.memoizedState;
            if (je.isDehydrated)
              try {
                s8(i.containerInfo);
              } catch (Gt) {
                tr(a, a.return, Gt);
              }
          }
          return;
        }
        case S: {
          Ws(i, a), Dl(a);
          return;
        }
        case N: {
          Ws(i, a), Dl(a);
          var Ue = a.child;
          if (Ue.flags & fl) {
            var gt = Ue.stateNode, Ht = Ue.memoizedState, Ft = Ht !== null;
            if (gt.isHidden = Ft, Ft) {
              var yn = Ue.alternate !== null && Ue.alternate.memoizedState !== null;
              yn || a7();
            }
          }
          if (y & an) {
            try {
              w9(a);
            } catch (Gt) {
              tr(a, a.return, Gt);
            }
            U_(a);
          }
          return;
        }
        case Y: {
          var mn = v !== null && v.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            a.mode & Lt
          ) {
            var ke = jo;
            jo = ke || mn, Ws(i, a), jo = ke;
          } else
            Ws(i, a);
          if (Dl(a), y & fl) {
            var He = a.stateNode, Me = a.memoizedState, nt = Me !== null, Et = a;
            if (He.isHidden = nt, nt && !mn && (Et.mode & Lt) !== _t) {
              kt = Et;
              for (var yt = Et.child; yt !== null; )
                kt = yt, O9(yt), yt = yt.sibling;
            }
            y9(Et, nt);
          }
          return;
        }
        case X: {
          Ws(i, a), Dl(a), y & an && U_(a);
          return;
        }
        case ne:
          return;
        default: {
          Ws(i, a), Dl(a);
          return;
        }
      }
    }
    function Dl(a) {
      var i = a.flags;
      if (i & Jn) {
        try {
          S9(a);
        } catch (f) {
          tr(a, a.return, f);
        }
        a.flags &= ~Jn;
      }
      i & Va && (a.flags &= ~Va);
    }
    function R9(a, i, f) {
      dm = f, fm = i, kt = a, W_(a, i, f), dm = null, fm = null;
    }
    function W_(a, i, f) {
      for (var v = (a.mode & Lt) !== _t; kt !== null; ) {
        var y = kt, w = y.child;
        if (y.tag === Y && v) {
          var M = y.memoizedState !== null, j = M || _C;
          if (j) {
            tP(a, i, f);
            continue;
          } else {
            var B = y.alternate, Q = B !== null && B.memoizedState !== null, re = Q || jo, Ce = _C, xe = jo;
            _C = j, jo = re, jo && !xe && (kt = y, P9(y));
            for (var Le = w; Le !== null; )
              kt = Le, W_(
                Le,
                // New root; bubble back up to here and stop.
                i,
                f
              ), Le = Le.sibling;
            kt = y, _C = Ce, jo = xe, tP(a, i, f);
            continue;
          }
        }
        (y.subtreeFlags & Co) !== Ut && w !== null ? (w.return = y, kt = w) : tP(a, i, f);
      }
    }
    function tP(a, i, f) {
      for (; kt !== null; ) {
        var v = kt;
        if ((v.flags & Co) !== Ut) {
          var y = v.alternate;
          _n(v);
          try {
            v9(i, y, v, f);
          } catch (M) {
            tr(v, v.return, M);
          }
          Fr();
        }
        if (v === a) {
          kt = null;
          return;
        }
        var w = v.sibling;
        if (w !== null) {
          w.return = v.return, kt = w;
          return;
        }
        kt = v.return;
      }
    }
    function O9(a) {
      for (; kt !== null; ) {
        var i = kt, f = i.child;
        switch (i.tag) {
          case h:
          case L:
          case V:
          case z: {
            if (i.mode & Xt)
              try {
                $l(), Us(co, i, i.return);
              } finally {
                Pl(i);
              }
            else
              Us(co, i, i.return);
            break;
          }
          case m: {
            pm(i, i.return);
            var v = i.stateNode;
            typeof v.componentWillUnmount == "function" && JO(i, i.return, v);
            break;
          }
          case R: {
            pm(i, i.return);
            break;
          }
          case Y: {
            var y = i.memoizedState !== null;
            if (y) {
              q_(a);
              continue;
            }
            break;
          }
        }
        f !== null ? (f.return = i, kt = f) : q_(a);
      }
    }
    function q_(a) {
      for (; kt !== null; ) {
        var i = kt;
        if (i === a) {
          kt = null;
          return;
        }
        var f = i.sibling;
        if (f !== null) {
          f.return = i.return, kt = f;
          return;
        }
        kt = i.return;
      }
    }
    function P9(a) {
      for (; kt !== null; ) {
        var i = kt, f = i.child;
        if (i.tag === Y) {
          var v = i.memoizedState !== null;
          if (v) {
            Y_(a);
            continue;
          }
        }
        f !== null ? (f.return = i, kt = f) : Y_(a);
      }
    }
    function Y_(a) {
      for (; kt !== null; ) {
        var i = kt;
        _n(i);
        try {
          g9(i);
        } catch (v) {
          tr(i, i.return, v);
        }
        if (Fr(), i === a) {
          kt = null;
          return;
        }
        var f = i.sibling;
        if (f !== null) {
          f.return = i.return, kt = f;
          return;
        }
        kt = i.return;
      }
    }
    function $9(a, i, f, v) {
      kt = i, D9(i, a, f, v);
    }
    function D9(a, i, f, v) {
      for (; kt !== null; ) {
        var y = kt, w = y.child;
        (y.subtreeFlags & Ba) !== Ut && w !== null ? (w.return = y, kt = w) : k9(a, i, f, v);
      }
    }
    function k9(a, i, f, v) {
      for (; kt !== null; ) {
        var y = kt;
        if ((y.flags & or) !== Ut) {
          _n(y);
          try {
            M9(i, y, f, v);
          } catch (M) {
            tr(y, y.return, M);
          }
          Fr();
        }
        if (y === a) {
          kt = null;
          return;
        }
        var w = y.sibling;
        if (w !== null) {
          w.return = y.return, kt = w;
          return;
        }
        kt = y.return;
      }
    }
    function M9(a, i, f, v) {
      switch (i.tag) {
        case h:
        case L:
        case z: {
          if (i.mode & Xt) {
            xO();
            try {
              Ku(Lo | lo, i);
            } finally {
              bO(i);
            }
          } else
            Ku(Lo | lo, i);
          break;
        }
      }
    }
    function N9(a) {
      kt = a, I9();
    }
    function I9() {
      for (; kt !== null; ) {
        var a = kt, i = a.child;
        if ((kt.flags & On) !== Ut) {
          var f = a.deletions;
          if (f !== null) {
            for (var v = 0; v < f.length; v++) {
              var y = f[v];
              kt = y, L9(y, a);
            }
            {
              var w = a.alternate;
              if (w !== null) {
                var M = w.child;
                if (M !== null) {
                  w.child = null;
                  do {
                    var j = M.sibling;
                    M.sibling = null, M = j;
                  } while (M !== null);
                }
              }
            }
            kt = a;
          }
        }
        (a.subtreeFlags & Ba) !== Ut && i !== null ? (i.return = a, kt = i) : _9();
      }
    }
    function _9() {
      for (; kt !== null; ) {
        var a = kt;
        (a.flags & or) !== Ut && (_n(a), A9(a), Fr());
        var i = a.sibling;
        if (i !== null) {
          i.return = a.return, kt = i;
          return;
        }
        kt = a.return;
      }
    }
    function A9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          a.mode & Xt ? (xO(), Us(Lo | lo, a, a.return), bO(a)) : Us(Lo | lo, a, a.return);
          break;
        }
      }
    }
    function L9(a, i) {
      for (; kt !== null; ) {
        var f = kt;
        _n(f), j9(f, i), Fr();
        var v = f.child;
        v !== null ? (v.return = f, kt = v) : F9(a);
      }
    }
    function F9(a) {
      for (; kt !== null; ) {
        var i = kt, f = i.sibling, v = i.return;
        if (j_(i), i === a) {
          kt = null;
          return;
        }
        if (f !== null) {
          f.return = v, kt = f;
          return;
        }
        kt = v;
      }
    }
    function j9(a, i) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          a.mode & Xt ? (xO(), Us(Lo, a, i), bO(a)) : Us(Lo, a, i);
          break;
        }
      }
    }
    function V9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          try {
            Ku(co | lo, a);
          } catch (f) {
            tr(a, a.return, f);
          }
          break;
        }
        case m: {
          var i = a.stateNode;
          try {
            i.componentDidMount();
          } catch (f) {
            tr(a, a.return, f);
          }
          break;
        }
      }
    }
    function B9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          try {
            Ku(Lo | lo, a);
          } catch (i) {
            tr(a, a.return, i);
          }
          break;
        }
      }
    }
    function z9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z: {
          try {
            Us(co | lo, a, a.return);
          } catch (f) {
            tr(a, a.return, f);
          }
          break;
        }
        case m: {
          var i = a.stateNode;
          typeof i.componentWillUnmount == "function" && JO(a, a.return, i);
          break;
        }
      }
    }
    function U9(a) {
      switch (a.tag) {
        case h:
        case L:
        case z:
          try {
            Us(Lo | lo, a, a.return);
          } catch (i) {
            tr(a, a.return, i);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Ly = Symbol.for;
      Ly("selector.component"), Ly("selector.has_pseudo_class"), Ly("selector.role"), Ly("selector.test_id"), Ly("selector.text");
    }
    var H9 = [];
    function W9() {
      H9.forEach(function(a) {
        return a();
      });
    }
    var q9 = n.ReactCurrentActQueue;
    function Y9(a) {
      {
        var i = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), f = typeof jest < "u";
        return f && i !== !1;
      }
    }
    function G_() {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !a && q9.current !== null && u("The current testing environment is not configured to support act(...)"), a;
      }
    }
    var G9 = Math.ceil, nP = n.ReactCurrentDispatcher, rP = n.ReactCurrentOwner, Bo = n.ReactCurrentBatchConfig, qs = n.ReactCurrentActQueue, po = (
      /*             */
      0
    ), K_ = (
      /*               */
      1
    ), zo = (
      /*                */
      2
    ), Zi = (
      /*                */
      4
    ), Pc = 0, Fy = 1, kf = 2, LC = 3, jy = 4, X_ = 5, oP = 6, gn = po, wa = null, Rr = null, ho = Ge, kl = Ge, aP = Vu(Ge), mo = Pc, Vy = null, FC = Ge, By = Ge, jC = Ge, zy = null, ei = null, iP = 0, Q_ = 500, J_ = 1 / 0, K9 = 500, $c = null;
    function Uy() {
      J_ = cr() + K9;
    }
    function Z_() {
      return J_;
    }
    var VC = !1, sP = null, hm = null, Mf = !1, Qu = null, Hy = Ge, lP = [], cP = null, X9 = 50, Wy = 0, uP = null, dP = !1, BC = !1, Q9 = 50, mm = 0, zC = null, qy = Xn, UC = Ge, e2 = !1;
    function HC() {
      return wa;
    }
    function Ta() {
      return (gn & (zo | Zi)) !== po ? cr() : (qy !== Xn || (qy = cr()), qy);
    }
    function Ju(a) {
      var i = a.mode;
      if ((i & Lt) === _t)
        return Bt;
      if ((gn & zo) !== po && ho !== Ge)
        return Su(ho);
      var f = q8() !== W8;
      if (f) {
        if (Bo.transition !== null) {
          var v = Bo.transition;
          v._updatedFibers || (v._updatedFibers = /* @__PURE__ */ new Set()), v._updatedFibers.add(a);
        }
        return UC === kr && (UC = nS()), UC;
      }
      var y = qa();
      if (y !== kr)
        return y;
      var w = D6();
      return w;
    }
    function J9(a) {
      var i = a.mode;
      return (i & Lt) === _t ? Bt : oa();
    }
    function vo(a, i, f, v) {
      C7(), e2 && u("useInsertionEffect must not schedule updates."), dP && (BC = !0), hc(a, f, v), (gn & zo) !== Ge && a === wa ? E7(i) : (ba && Ch(a, i, f), R7(i), a === wa && ((gn & zo) === po && (By = rn(By, f)), mo === jy && Zu(a, ho)), ti(a, v), f === Bt && gn === po && (i.mode & Lt) === _t && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !qs.isBatchingLegacy && (Uy(), eI()));
    }
    function Z9(a, i, f) {
      var v = a.current;
      v.lanes = i, hc(a, i, f), ti(a, f);
    }
    function e7(a) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (gn & zo) !== po
      );
    }
    function ti(a, i) {
      var f = a.callbackNode;
      Qx(a, i);
      var v = fc(a, a === wa ? ho : Ge);
      if (v === Ge) {
        f !== null && v2(f), a.callbackNode = null, a.callbackPriority = kr;
        return;
      }
      var y = wr(v), w = a.callbackPriority;
      if (w === y && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(qs.current !== null && f !== yP)) {
        f == null && w !== Bt && u("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && v2(f);
      var M;
      if (y === Bt)
        a.tag === Bu ? (qs.isBatchingLegacy !== null && (qs.didScheduleLegacyUpdate = !0), P8(r2.bind(null, a))) : ZN(r2.bind(null, a)), qs.current !== null ? qs.current.push(zu) : M6(function() {
          (gn & (zo | Zi)) === po && zu();
        }), M = null;
      else {
        var j;
        switch (so(v)) {
          case Tr:
            j = Kp;
            break;
          case Ms:
            j = ac;
            break;
          case Hi:
            j = Ui;
            break;
          case Cu:
            j = Xp;
            break;
          default:
            j = Ui;
            break;
        }
        M = bP(j, t2.bind(null, a));
      }
      a.callbackPriority = y, a.callbackNode = M;
    }
    function t2(a, i) {
      if (yW(), qy = Xn, UC = Ge, (gn & (zo | Zi)) !== po)
        throw new Error("Should not already be working.");
      var f = a.callbackNode, v = kc();
      if (v && a.callbackNode !== f)
        return null;
      var y = fc(a, a === wa ? ho : Ge);
      if (y === Ge)
        return null;
      var w = !rf(a, y) && !tS(a, y) && !i, M = w ? u7(a, y) : qC(a, y);
      if (M !== Pc) {
        if (M === kf) {
          var j = gl(a);
          j !== Ge && (y = j, M = fP(a, j));
        }
        if (M === Fy) {
          var B = Vy;
          throw Nf(a, Ge), Zu(a, y), ti(a, cr()), B;
        }
        if (M === oP)
          Zu(a, y);
        else {
          var Q = !rf(a, y), re = a.current.alternate;
          if (Q && !n7(re)) {
            if (M = qC(a, y), M === kf) {
              var Ce = gl(a);
              Ce !== Ge && (y = Ce, M = fP(a, Ce));
            }
            if (M === Fy) {
              var xe = Vy;
              throw Nf(a, Ge), Zu(a, y), ti(a, cr()), xe;
            }
          }
          a.finishedWork = re, a.finishedLanes = y, t7(a, M, y);
        }
      }
      return ti(a, cr()), a.callbackNode === f ? t2.bind(null, a) : null;
    }
    function fP(a, i) {
      var f = zy;
      if (wh(a)) {
        var v = Nf(a, i);
        v.flags |= vr, S8(a.containerInfo);
      }
      var y = qC(a, i);
      if (y !== kf) {
        var w = ei;
        ei = f, w !== null && n2(w);
      }
      return y;
    }
    function n2(a) {
      ei === null ? ei = a : ei.push.apply(ei, a);
    }
    function t7(a, i, f) {
      switch (i) {
        case Pc:
        case Fy:
          throw new Error("Root did not complete. This is a bug in React.");
        case kf: {
          If(a, ei, $c);
          break;
        }
        case LC: {
          if (Zu(a, f), Jx(f) && // do not delay if we're inside an act() scope
          !g2()) {
            var v = iP + Q_ - cr();
            if (v > 10) {
              var y = fc(a, Ge);
              if (y !== Ge)
                break;
              var w = a.suspendedLanes;
              if (!pc(w, f)) {
                Ta(), xh(a, w);
                break;
              }
              a.timeoutHandle = cR(If.bind(null, a, ei, $c), v);
              break;
            }
          }
          If(a, ei, $c);
          break;
        }
        case jy: {
          if (Zu(a, f), eS(f))
            break;
          if (!g2()) {
            var M = Kx(a, f), j = M, B = cr() - j, Q = S7(B) - B;
            if (Q > 10) {
              a.timeoutHandle = cR(If.bind(null, a, ei, $c), Q);
              break;
            }
          }
          If(a, ei, $c);
          break;
        }
        case X_: {
          If(a, ei, $c);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function n7(a) {
      for (var i = a; ; ) {
        if (i.flags & Yd) {
          var f = i.updateQueue;
          if (f !== null) {
            var v = f.stores;
            if (v !== null)
              for (var y = 0; y < v.length; y++) {
                var w = v[y], M = w.getSnapshot, j = w.value;
                try {
                  if (!Dt(M(), j))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var B = i.child;
        if (i.subtreeFlags & Yd && B !== null) {
          B.return = i, i = B;
          continue;
        }
        if (i === a)
          return !0;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === a)
            return !0;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      return !0;
    }
    function Zu(a, i) {
      i = of(i, jC), i = of(i, By), oS(a, i);
    }
    function r2(a) {
      if (bW(), (gn & (zo | Zi)) !== po)
        throw new Error("Should not already be working.");
      kc();
      var i = fc(a, Ge);
      if (!aa(i, Bt))
        return ti(a, cr()), null;
      var f = qC(a, i);
      if (a.tag !== Bu && f === kf) {
        var v = gl(a);
        v !== Ge && (i = v, f = fP(a, v));
      }
      if (f === Fy) {
        var y = Vy;
        throw Nf(a, Ge), Zu(a, i), ti(a, cr()), y;
      }
      if (f === oP)
        throw new Error("Root did not complete. This is a bug in React.");
      var w = a.current.alternate;
      return a.finishedWork = w, a.finishedLanes = i, If(a, ei, $c), ti(a, cr()), null;
    }
    function r7(a, i) {
      i !== Ge && (Ag(a, rn(i, Bt)), ti(a, cr()), (gn & (zo | Zi)) === po && (Uy(), zu()));
    }
    function pP(a, i) {
      var f = gn;
      gn |= K_;
      try {
        return a(i);
      } finally {
        gn = f, gn === po && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !qs.isBatchingLegacy && (Uy(), eI());
      }
    }
    function o7(a, i, f, v, y) {
      var w = qa(), M = Bo.transition;
      try {
        return Bo.transition = null, gr(Tr), a(i, f, v, y);
      } finally {
        gr(w), Bo.transition = M, gn === po && Uy();
      }
    }
    function Dc(a) {
      Qu !== null && Qu.tag === Bu && (gn & (zo | Zi)) === po && kc();
      var i = gn;
      gn |= K_;
      var f = Bo.transition, v = qa();
      try {
        return Bo.transition = null, gr(Tr), a ? a() : void 0;
      } finally {
        gr(v), Bo.transition = f, gn = i, (gn & (zo | Zi)) === po && zu();
      }
    }
    function o2() {
      return (gn & (zo | Zi)) !== po;
    }
    function WC(a, i) {
      la(aP, kl, a), kl = rn(kl, i);
    }
    function hP(a) {
      kl = aP.current, sa(aP, a);
    }
    function Nf(a, i) {
      a.finishedWork = null, a.finishedLanes = Ge;
      var f = a.timeoutHandle;
      if (f !== uR && (a.timeoutHandle = uR, k6(f)), Rr !== null)
        for (var v = Rr.return; v !== null; ) {
          var y = v.alternate;
          N_(y, v), v = v.return;
        }
      wa = a;
      var w = _f(a.current, null);
      return Rr = w, ho = kl = i, mo = Pc, Vy = null, FC = Ge, By = Ge, jC = Ge, zy = null, ei = null, Z8(), Fs.discardPendingWarnings(), w;
    }
    function a2(a, i) {
      do {
        var f = Rr;
        try {
          if (tC(), $I(), Fr(), rP.current = null, f === null || f.return === null) {
            mo = Fy, Vy = i, Rr = null;
            return;
          }
          if (se && f.mode & Xt && DC(f, !0), de)
            if (na(), i !== null && typeof i == "object" && typeof i.then == "function") {
              var v = i;
              sc(f, v, ho);
            } else
              Xd(f, i, ho);
          PW(a, f.return, f, i, ho), c2(f);
        } catch (y) {
          i = y, Rr === f && f !== null ? (f = f.return, Rr = f) : f = Rr;
          continue;
        }
        return;
      } while (!0);
    }
    function i2() {
      var a = nP.current;
      return nP.current = EC, a === null ? EC : a;
    }
    function s2(a) {
      nP.current = a;
    }
    function a7() {
      iP = cr();
    }
    function Yy(a) {
      FC = rn(a, FC);
    }
    function i7() {
      mo === Pc && (mo = LC);
    }
    function mP() {
      (mo === Pc || mo === LC || mo === kf) && (mo = jy), wa !== null && (nf(FC) || nf(By)) && Zu(wa, ho);
    }
    function s7(a) {
      mo !== jy && (mo = kf), zy === null ? zy = [a] : zy.push(a);
    }
    function l7() {
      return mo === Pc;
    }
    function qC(a, i) {
      var f = gn;
      gn |= zo;
      var v = i2();
      if (wa !== a || ho !== i) {
        if (ba) {
          var y = a.memoizedUpdaters;
          y.size > 0 && (Gy(a, ho), y.clear()), Lg(a, i);
        }
        $c = sf(), Nf(a, i);
      }
      ar(i);
      do
        try {
          c7();
          break;
        } catch (w) {
          a2(a, w);
        }
      while (!0);
      if (tC(), gn = f, s2(v), Rr !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return th(), wa = null, ho = Ge, mo;
    }
    function c7() {
      for (; Rr !== null; )
        l2(Rr);
    }
    function u7(a, i) {
      var f = gn;
      gn |= zo;
      var v = i2();
      if (wa !== a || ho !== i) {
        if (ba) {
          var y = a.memoizedUpdaters;
          y.size > 0 && (Gy(a, ho), y.clear()), Lg(a, i);
        }
        $c = sf(), Uy(), Nf(a, i);
      }
      ar(i);
      do
        try {
          d7();
          break;
        } catch (w) {
          a2(a, w);
        }
      while (!0);
      return tC(), s2(v), gn = f, Rr !== null ? (eh(), Pc) : (th(), wa = null, ho = Ge, mo);
    }
    function d7() {
      for (; Rr !== null && !Gp(); )
        l2(Rr);
    }
    function l2(a) {
      var i = a.alternate;
      _n(a);
      var f;
      (a.mode & Xt) !== _t ? (yO(a), f = vP(i, a, kl), DC(a, !0)) : f = vP(i, a, kl), Fr(), a.memoizedProps = a.pendingProps, f === null ? c2(a) : Rr = f, rP.current = null;
    }
    function c2(a) {
      var i = a;
      do {
        var f = i.alternate, v = i.return;
        if ((i.flags & va) === Ut) {
          _n(i);
          var y = void 0;
          if ((i.mode & Xt) === _t ? y = M_(f, i, kl) : (yO(i), y = M_(f, i, kl), DC(i, !1)), Fr(), y !== null) {
            Rr = y;
            return;
          }
        } else {
          var w = i9(f, i);
          if (w !== null) {
            w.flags &= Fx, Rr = w;
            return;
          }
          if ((i.mode & Xt) !== _t) {
            DC(i, !1);
            for (var M = i.actualDuration, j = i.child; j !== null; )
              M += j.actualDuration, j = j.sibling;
            i.actualDuration = M;
          }
          if (v !== null)
            v.flags |= va, v.subtreeFlags = Ut, v.deletions = null;
          else {
            mo = oP, Rr = null;
            return;
          }
        }
        var B = i.sibling;
        if (B !== null) {
          Rr = B;
          return;
        }
        i = v, Rr = i;
      } while (i !== null);
      mo === Pc && (mo = X_);
    }
    function If(a, i, f) {
      var v = qa(), y = Bo.transition;
      try {
        Bo.transition = null, gr(Tr), f7(a, i, f, v);
      } finally {
        Bo.transition = y, gr(v);
      }
      return null;
    }
    function f7(a, i, f, v) {
      do
        kc();
      while (Qu !== null);
      if (w7(), (gn & (zo | Zi)) !== po)
        throw new Error("Should not already be working.");
      var y = a.finishedWork, w = a.finishedLanes;
      if (hl(w), y === null)
        return Qp(), null;
      if (w === Ge && u("root.finishedLanes should not be empty during a commit. This is a bug in React."), a.finishedWork = null, a.finishedLanes = Ge, y === a.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      a.callbackNode = null, a.callbackPriority = kr;
      var M = rn(y.lanes, y.childLanes);
      Sh(a, M), a === wa && (wa = null, Rr = null, ho = Ge), ((y.subtreeFlags & Ba) !== Ut || (y.flags & Ba) !== Ut) && (Mf || (Mf = !0, cP = f, bP(Ui, function() {
        return kc(), null;
      })));
      var j = (y.subtreeFlags & (lu | ea | Co | Ba)) !== Ut, B = (y.flags & (lu | ea | Co | Ba)) !== Ut;
      if (j || B) {
        var Q = Bo.transition;
        Bo.transition = null;
        var re = qa();
        gr(Tr);
        var Ce = gn;
        gn |= Zi, rP.current = null, d9(a, y), e_(), E9(a, y, w), T6(a.containerInfo), a.current = y, Pg(w), R9(y, a, w), pu(), Bx(), gn = Ce, gr(re), Bo.transition = Q;
      } else
        a.current = y, e_();
      var xe = Mf;
      if (Mf ? (Mf = !1, Qu = a, Hy = w) : (mm = 0, zC = null), M = a.pendingLanes, M === Ge && (hm = null), xe || p2(a.current, !1), uu(y.stateNode, v), ba && a.memoizedUpdaters.clear(), W9(), ti(a, cr()), i !== null)
        for (var Le = a.onRecoverableError, je = 0; je < i.length; je++) {
          var Ue = i[je], gt = Ue.stack, Ht = Ue.digest;
          Le(Ue.value, {
            componentStack: gt,
            digest: Ht
          });
        }
      if (VC) {
        VC = !1;
        var Ft = sP;
        throw sP = null, Ft;
      }
      return aa(Hy, Bt) && a.tag !== Bu && kc(), M = a.pendingLanes, aa(M, Bt) ? (gW(), a === uP ? Wy++ : (Wy = 0, uP = a)) : Wy = 0, zu(), Qp(), null;
    }
    function kc() {
      if (Qu !== null) {
        var a = so(Hy), i = IE(Hi, a), f = Bo.transition, v = qa();
        try {
          return Bo.transition = null, gr(i), h7();
        } finally {
          gr(v), Bo.transition = f;
        }
      }
      return !1;
    }
    function p7(a) {
      lP.push(a), Mf || (Mf = !0, bP(Ui, function() {
        return kc(), null;
      }));
    }
    function h7() {
      if (Qu === null)
        return !1;
      var a = cP;
      cP = null;
      var i = Qu, f = Hy;
      if (Qu = null, Hy = Ge, (gn & (zo | Zi)) !== po)
        throw new Error("Cannot flush passive effects while already rendering.");
      dP = !0, BC = !1, Yx(f);
      var v = gn;
      gn |= Zi, N9(i.current), $9(i, i.current, f, a);
      {
        var y = lP;
        lP = [];
        for (var w = 0; w < y.length; w++) {
          var M = y[w];
          m9(i, M);
        }
      }
      $g(), p2(i.current, !0), gn = v, zu(), BC ? i === zC ? mm++ : (mm = 0, zC = i) : mm = 0, dP = !1, BC = !1, Ha(i);
      {
        var j = i.current.stateNode;
        j.effectDuration = 0, j.passiveEffectDuration = 0;
      }
      return !0;
    }
    function u2(a) {
      return hm !== null && hm.has(a);
    }
    function m7(a) {
      hm === null ? hm = /* @__PURE__ */ new Set([a]) : hm.add(a);
    }
    function v7(a) {
      VC || (VC = !0, sP = a);
    }
    var g7 = v7;
    function d2(a, i, f) {
      var v = $f(f, i), y = l_(a, v, Bt), w = Hu(a, y, Bt), M = Ta();
      w !== null && (hc(w, Bt, M), ti(w, M));
    }
    function tr(a, i, f) {
      if (l9(f), Ky(!1), a.tag === x) {
        d2(a, a, f);
        return;
      }
      var v = null;
      for (v = i; v !== null; ) {
        if (v.tag === x) {
          d2(v, a, f);
          return;
        } else if (v.tag === m) {
          var y = v.type, w = v.stateNode;
          if (typeof y.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && !u2(w)) {
            var M = $f(f, a), j = AO(v, M, Bt), B = Hu(v, j, Bt), Q = Ta();
            B !== null && (hc(B, Bt, Q), ti(B, Q));
            return;
          }
        }
        v = v.return;
      }
      u(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function y7(a, i, f) {
      var v = a.pingCache;
      v !== null && v.delete(i);
      var y = Ta();
      xh(a, f), O7(a), wa === a && pc(ho, f) && (mo === jy || mo === LC && Jx(ho) && cr() - iP < Q_ ? Nf(a, Ge) : jC = rn(jC, f)), ti(a, y);
    }
    function f2(a, i) {
      i === kr && (i = J9(a));
      var f = Ta(), v = Ja(a, i);
      v !== null && (hc(v, i, f), ti(v, f));
    }
    function b7(a) {
      var i = a.memoizedState, f = kr;
      i !== null && (f = i.retryLane), f2(a, f);
    }
    function x7(a, i) {
      var f = kr, v;
      switch (a.tag) {
        case N:
          v = a.stateNode;
          var y = a.memoizedState;
          y !== null && (f = y.retryLane);
          break;
        case X:
          v = a.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      v !== null && v.delete(i), f2(a, f);
    }
    function S7(a) {
      return a < 120 ? 120 : a < 480 ? 480 : a < 1080 ? 1080 : a < 1920 ? 1920 : a < 3e3 ? 3e3 : a < 4320 ? 4320 : G9(a / 1960) * 1960;
    }
    function C7() {
      if (Wy > X9)
        throw Wy = 0, uP = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      mm > Q9 && (mm = 0, zC = null, u("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function w7() {
      Fs.flushLegacyContextWarning(), Fs.flushPendingUnsafeLifecycleWarnings();
    }
    function p2(a, i) {
      _n(a), YC(a, Zo, z9), i && YC(a, oc, U9), YC(a, Zo, V9), i && YC(a, oc, B9), Fr();
    }
    function YC(a, i, f) {
      for (var v = a, y = null; v !== null; ) {
        var w = v.subtreeFlags & i;
        v !== y && v.child !== null && w !== Ut ? v = v.child : ((v.flags & i) !== Ut && f(v), v.sibling !== null ? v = v.sibling : v = y = v.return);
      }
    }
    var GC = null;
    function h2(a) {
      {
        if ((gn & zo) !== po || !(a.mode & Lt))
          return;
        var i = a.tag;
        if (i !== b && i !== x && i !== m && i !== h && i !== L && i !== V && i !== z)
          return;
        var f = nn(a) || "ReactComponent";
        if (GC !== null) {
          if (GC.has(f))
            return;
          GC.add(f);
        } else
          GC = /* @__PURE__ */ new Set([f]);
        var v = Pr;
        try {
          _n(a), u("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          v ? _n(a) : Fr();
        }
      }
    }
    var vP;
    {
      var T7 = null;
      vP = function(a, i, f) {
        var v = C2(T7, i);
        try {
          return O_(a, i, f);
        } catch (w) {
          if (A8() || w !== null && typeof w == "object" && typeof w.then == "function")
            throw w;
          if (tC(), $I(), N_(a, i), C2(i, v), i.mode & Xt && yO(i), rc(null, O_, null, a, i, f), $E()) {
            var y = bg();
            typeof y == "object" && y !== null && y._suppressLogging && typeof w == "object" && w !== null && !w._suppressLogging && (w._suppressLogging = !0);
          }
          throw w;
        }
      };
    }
    var m2 = !1, gP;
    gP = /* @__PURE__ */ new Set();
    function E7(a) {
      if (_a && !hW())
        switch (a.tag) {
          case h:
          case L:
          case z: {
            var i = Rr && nn(Rr) || "Unknown", f = i;
            if (!gP.has(f)) {
              gP.add(f);
              var v = nn(a) || "Unknown";
              u("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", v, i, i);
            }
            break;
          }
          case m: {
            m2 || (u("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), m2 = !0);
            break;
          }
        }
    }
    function Gy(a, i) {
      if (ba) {
        var f = a.memoizedUpdaters;
        f.forEach(function(v) {
          Ch(a, v, i);
        });
      }
    }
    var yP = {};
    function bP(a, i) {
      {
        var f = qs.current;
        return f !== null ? (f.push(i), yP) : Yp(a, i);
      }
    }
    function v2(a) {
      if (a !== yP)
        return Vx(a);
    }
    function g2() {
      return qs.current !== null;
    }
    function R7(a) {
      {
        if (a.mode & Lt) {
          if (!G_())
            return;
        } else if (!Y9() || gn !== po || a.tag !== h && a.tag !== L && a.tag !== z)
          return;
        if (qs.current === null) {
          var i = Pr;
          try {
            _n(a), u(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, nn(a));
          } finally {
            i ? _n(a) : Fr();
          }
        }
      }
    }
    function O7(a) {
      a.tag !== Bu && G_() && qs.current === null && u(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Ky(a) {
      e2 = a;
    }
    var es = null, vm = null, P7 = function(a) {
      es = a;
    };
    function gm(a) {
      {
        if (es === null)
          return a;
        var i = es(a);
        return i === void 0 ? a : i.current;
      }
    }
    function xP(a) {
      return gm(a);
    }
    function SP(a) {
      {
        if (es === null)
          return a;
        var i = es(a);
        if (i === void 0) {
          if (a != null && typeof a.render == "function") {
            var f = gm(a.render);
            if (a.render !== f) {
              var v = {
                $$typeof: xo,
                render: f
              };
              return a.displayName !== void 0 && (v.displayName = a.displayName), v;
            }
          }
          return a;
        }
        return i.current;
      }
    }
    function y2(a, i) {
      {
        if (es === null)
          return !1;
        var f = a.elementType, v = i.type, y = !1, w = typeof v == "object" && v !== null ? v.$$typeof : null;
        switch (a.tag) {
          case m: {
            typeof v == "function" && (y = !0);
            break;
          }
          case h: {
            (typeof v == "function" || w === mt) && (y = !0);
            break;
          }
          case L: {
            (w === xo || w === mt) && (y = !0);
            break;
          }
          case V:
          case z: {
            (w === tt || w === mt) && (y = !0);
            break;
          }
          default:
            return !1;
        }
        if (y) {
          var M = es(f);
          if (M !== void 0 && M === es(v))
            return !0;
        }
        return !1;
      }
    }
    function b2(a) {
      {
        if (es === null || typeof WeakSet != "function")
          return;
        vm === null && (vm = /* @__PURE__ */ new WeakSet()), vm.add(a);
      }
    }
    var $7 = function(a, i) {
      {
        if (es === null)
          return;
        var f = i.staleFamilies, v = i.updatedFamilies;
        kc(), Dc(function() {
          CP(a.current, v, f);
        });
      }
    }, D7 = function(a, i) {
      {
        if (a.context !== Ri)
          return;
        kc(), Dc(function() {
          Xy(i, a, null, null);
        });
      }
    };
    function CP(a, i, f) {
      {
        var v = a.alternate, y = a.child, w = a.sibling, M = a.tag, j = a.type, B = null;
        switch (M) {
          case h:
          case z:
          case m:
            B = j;
            break;
          case L:
            B = j.render;
            break;
        }
        if (es === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var Q = !1, re = !1;
        if (B !== null) {
          var Ce = es(B);
          Ce !== void 0 && (f.has(Ce) ? re = !0 : i.has(Ce) && (M === m ? re = !0 : Q = !0));
        }
        if (vm !== null && (vm.has(a) || v !== null && vm.has(v)) && (re = !0), re && (a._debugNeedsRemount = !0), re || Q) {
          var xe = Ja(a, Bt);
          xe !== null && vo(xe, a, Bt, Xn);
        }
        y !== null && !re && CP(y, i, f), w !== null && CP(w, i, f);
      }
    }
    var k7 = function(a, i) {
      {
        var f = /* @__PURE__ */ new Set(), v = new Set(i.map(function(y) {
          return y.current;
        }));
        return wP(a.current, v, f), f;
      }
    };
    function wP(a, i, f) {
      {
        var v = a.child, y = a.sibling, w = a.tag, M = a.type, j = null;
        switch (w) {
          case h:
          case z:
          case m:
            j = M;
            break;
          case L:
            j = M.render;
            break;
        }
        var B = !1;
        j !== null && i.has(j) && (B = !0), B ? M7(a, f) : v !== null && wP(v, i, f), y !== null && wP(y, i, f);
      }
    }
    function M7(a, i) {
      {
        var f = N7(a, i);
        if (f)
          return;
        for (var v = a; ; ) {
          switch (v.tag) {
            case R:
              i.add(v.stateNode);
              return;
            case S:
              i.add(v.stateNode.containerInfo);
              return;
            case x:
              i.add(v.stateNode.containerInfo);
              return;
          }
          if (v.return === null)
            throw new Error("Expected to reach root first.");
          v = v.return;
        }
      }
    }
    function N7(a, i) {
      for (var f = a, v = !1; ; ) {
        if (f.tag === R)
          v = !0, i.add(f.stateNode);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === a)
          return v;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === a)
            return v;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var TP;
    {
      TP = !1;
      try {
        var x2 = Object.preventExtensions({});
      } catch {
        TP = !0;
      }
    }
    function I7(a, i, f, v) {
      this.tag = a, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = i, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = v, this.flags = Ut, this.subtreeFlags = Ut, this.deletions = null, this.lanes = Ge, this.childLanes = Ge, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !TP && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Oi = function(a, i, f, v) {
      return new I7(a, i, f, v);
    };
    function EP(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function _7(a) {
      return typeof a == "function" && !EP(a) && a.defaultProps === void 0;
    }
    function A7(a) {
      if (typeof a == "function")
        return EP(a) ? m : h;
      if (a != null) {
        var i = a.$$typeof;
        if (i === xo)
          return L;
        if (i === tt)
          return V;
      }
      return b;
    }
    function _f(a, i) {
      var f = a.alternate;
      f === null ? (f = Oi(a.tag, i, a.key, a.mode), f.elementType = a.elementType, f.type = a.type, f.stateNode = a.stateNode, f._debugSource = a._debugSource, f._debugOwner = a._debugOwner, f._debugHookTypes = a._debugHookTypes, f.alternate = a, a.alternate = f) : (f.pendingProps = i, f.type = a.type, f.flags = Ut, f.subtreeFlags = Ut, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = a.flags & ao, f.childLanes = a.childLanes, f.lanes = a.lanes, f.child = a.child, f.memoizedProps = a.memoizedProps, f.memoizedState = a.memoizedState, f.updateQueue = a.updateQueue;
      var v = a.dependencies;
      switch (f.dependencies = v === null ? null : {
        lanes: v.lanes,
        firstContext: v.firstContext
      }, f.sibling = a.sibling, f.index = a.index, f.ref = a.ref, f.selfBaseDuration = a.selfBaseDuration, f.treeBaseDuration = a.treeBaseDuration, f._debugNeedsRemount = a._debugNeedsRemount, f.tag) {
        case b:
        case h:
        case z:
          f.type = gm(a.type);
          break;
        case m:
          f.type = xP(a.type);
          break;
        case L:
          f.type = SP(a.type);
          break;
      }
      return f;
    }
    function L7(a, i) {
      a.flags &= ao | Jn;
      var f = a.alternate;
      if (f === null)
        a.childLanes = Ge, a.lanes = i, a.child = null, a.subtreeFlags = Ut, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0;
      else {
        a.childLanes = f.childLanes, a.lanes = f.lanes, a.child = f.child, a.subtreeFlags = Ut, a.deletions = null, a.memoizedProps = f.memoizedProps, a.memoizedState = f.memoizedState, a.updateQueue = f.updateQueue, a.type = f.type;
        var v = f.dependencies;
        a.dependencies = v === null ? null : {
          lanes: v.lanes,
          firstContext: v.firstContext
        }, a.selfBaseDuration = f.selfBaseDuration, a.treeBaseDuration = f.treeBaseDuration;
      }
      return a;
    }
    function F7(a, i, f) {
      var v;
      return a === WS ? (v = Lt, i === !0 && (v |= un, v |= xa)) : v = _t, ba && (v |= Xt), Oi(x, null, null, v);
    }
    function RP(a, i, f, v, y, w) {
      var M = b, j = a;
      if (typeof a == "function")
        EP(a) ? (M = m, j = xP(j)) : j = gm(j);
      else if (typeof a == "string")
        M = R;
      else
        e: switch (a) {
          case Kn:
            return ed(f.children, y, w, i);
          case bo:
            M = P, y |= un, (y & Lt) !== _t && (y |= xa);
            break;
          case Na:
            return j7(f, y, w, i);
          case ze:
            return V7(f, y, w, i);
          case Pe:
            return B7(f, y, w, i);
          case Qn:
            return S2(f, y, w, i);
          case zt:
          case cn:
          case Or:
          case lE:
          case Rn:
          default: {
            if (typeof a == "object" && a !== null)
              switch (a.$$typeof) {
                case Mo:
                  M = _;
                  break e;
                case No:
                  M = k;
                  break e;
                case xo:
                  M = L, j = SP(j);
                  break e;
                case tt:
                  M = V;
                  break e;
                case mt:
                  M = H, j = null;
                  break e;
              }
            var B = "";
            {
              (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var Q = v ? nn(v) : null;
              Q && (B += `

Check the render method of \`` + Q + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (a == null ? a : typeof a) + "." + B));
          }
        }
      var re = Oi(M, f, i, y);
      return re.elementType = a, re.type = j, re.lanes = w, re._debugOwner = v, re;
    }
    function OP(a, i, f) {
      var v = null;
      v = a._owner;
      var y = a.type, w = a.key, M = a.props, j = RP(y, w, M, v, i, f);
      return j._debugSource = a._source, j._debugOwner = a._owner, j;
    }
    function ed(a, i, f, v) {
      var y = Oi(E, a, v, i);
      return y.lanes = f, y;
    }
    function j7(a, i, f, v) {
      typeof a.id != "string" && u('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof a.id);
      var y = Oi(F, a, v, i | Xt);
      return y.elementType = Na, y.lanes = f, y.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, y;
    }
    function V7(a, i, f, v) {
      var y = Oi(N, a, v, i);
      return y.elementType = ze, y.lanes = f, y;
    }
    function B7(a, i, f, v) {
      var y = Oi(X, a, v, i);
      return y.elementType = Pe, y.lanes = f, y;
    }
    function S2(a, i, f, v) {
      var y = Oi(Y, a, v, i);
      y.elementType = Qn, y.lanes = f;
      var w = {
        isHidden: !1
      };
      return y.stateNode = w, y;
    }
    function PP(a, i, f) {
      var v = Oi(T, a, null, i);
      return v.lanes = f, v;
    }
    function z7() {
      var a = Oi(R, null, null, _t);
      return a.elementType = "DELETED", a;
    }
    function U7(a) {
      var i = Oi(K, null, null, _t);
      return i.stateNode = a, i;
    }
    function $P(a, i, f) {
      var v = a.children !== null ? a.children : [], y = Oi(S, v, a.key, i);
      return y.lanes = f, y.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: a.implementation
      }, y;
    }
    function C2(a, i) {
      return a === null && (a = Oi(b, null, null, _t)), a.tag = i.tag, a.key = i.key, a.elementType = i.elementType, a.type = i.type, a.stateNode = i.stateNode, a.return = i.return, a.child = i.child, a.sibling = i.sibling, a.index = i.index, a.ref = i.ref, a.pendingProps = i.pendingProps, a.memoizedProps = i.memoizedProps, a.updateQueue = i.updateQueue, a.memoizedState = i.memoizedState, a.dependencies = i.dependencies, a.mode = i.mode, a.flags = i.flags, a.subtreeFlags = i.subtreeFlags, a.deletions = i.deletions, a.lanes = i.lanes, a.childLanes = i.childLanes, a.alternate = i.alternate, a.actualDuration = i.actualDuration, a.actualStartTime = i.actualStartTime, a.selfBaseDuration = i.selfBaseDuration, a.treeBaseDuration = i.treeBaseDuration, a._debugSource = i._debugSource, a._debugOwner = i._debugOwner, a._debugNeedsRemount = i._debugNeedsRemount, a._debugHookTypes = i._debugHookTypes, a;
    }
    function H7(a, i, f, v, y) {
      this.tag = i, this.containerInfo = a, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = uR, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = kr, this.eventTimes = af(Ge), this.expirationTimes = af(Xn), this.pendingLanes = Ge, this.suspendedLanes = Ge, this.pingedLanes = Ge, this.expiredLanes = Ge, this.mutableReadLanes = Ge, this.finishedLanes = Ge, this.entangledLanes = Ge, this.entanglements = af(Ge), this.identifierPrefix = v, this.onRecoverableError = y, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var w = this.pendingUpdatersLaneMap = [], M = 0; M < Zd; M++)
          w.push(/* @__PURE__ */ new Set());
      }
      switch (i) {
        case WS:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case Bu:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function w2(a, i, f, v, y, w, M, j, B, Q) {
      var re = new H7(a, i, f, j, B), Ce = F7(i, w);
      re.current = Ce, Ce.stateNode = re;
      {
        var xe = {
          element: v,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Ce.memoizedState = xe;
      }
      return zR(Ce), re;
    }
    var DP = "18.3.1";
    function W7(a, i, f) {
      var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return lt(v), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Lr,
        key: v == null ? null : "" + v,
        children: a,
        containerInfo: i,
        implementation: f
      };
    }
    var kP, MP;
    kP = !1, MP = {};
    function T2(a) {
      if (!a)
        return Ri;
      var i = Fa(a), f = O8(i);
      if (i.tag === m) {
        var v = i.type;
        if (Tl(v))
          return QN(i, v, f);
      }
      return f;
    }
    function q7(a, i) {
      {
        var f = Fa(a);
        if (f === void 0) {
          if (typeof a.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var v = Object.keys(a).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + v);
        }
        var y = za(f);
        if (y === null)
          return null;
        if (y.mode & un) {
          var w = nn(f) || "Component";
          if (!MP[w]) {
            MP[w] = !0;
            var M = Pr;
            try {
              _n(y), f.mode & un ? u("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", i, i, w) : u("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", i, i, w);
            } finally {
              M ? _n(M) : Fr();
            }
          }
        }
        return y.stateNode;
      }
    }
    function E2(a, i, f, v, y, w, M, j) {
      var B = !1, Q = null;
      return w2(a, i, B, Q, f, v, y, w, M);
    }
    function R2(a, i, f, v, y, w, M, j, B, Q) {
      var re = !0, Ce = w2(f, v, re, a, y, w, M, j, B);
      Ce.context = T2(null);
      var xe = Ce.current, Le = Ta(), je = Ju(xe), Ue = Rc(Le, je);
      return Ue.callback = i ?? null, Hu(xe, Ue, je), Z9(Ce, je, Le), Ce;
    }
    function Xy(a, i, f, v) {
      Og(i, a);
      var y = i.current, w = Ta(), M = Ju(y);
      Dg(M);
      var j = T2(f);
      i.context === null ? i.context = j : i.pendingContext = j, _a && Pr !== null && !kP && (kP = !0, u(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, nn(Pr) || "Unknown"));
      var B = Rc(w, M);
      B.payload = {
        element: a
      }, v = v === void 0 ? null : v, v !== null && (typeof v != "function" && u("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", v), B.callback = v);
      var Q = Hu(y, B, M);
      return Q !== null && (vo(Q, y, M, w), iC(Q, y, M)), M;
    }
    function KC(a) {
      var i = a.current;
      if (!i.child)
        return null;
      switch (i.child.tag) {
        case R:
          return i.child.stateNode;
        default:
          return i.child.stateNode;
      }
    }
    function Y7(a) {
      switch (a.tag) {
        case x: {
          var i = a.stateNode;
          if (wh(i)) {
            var f = Ng(i);
            r7(i, f);
          }
          break;
        }
        case N: {
          Dc(function() {
            var y = Ja(a, Bt);
            if (y !== null) {
              var w = Ta();
              vo(y, a, Bt, w);
            }
          });
          var v = Bt;
          NP(a, v);
          break;
        }
      }
    }
    function O2(a, i) {
      var f = a.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = rS(f.retryLane, i));
    }
    function NP(a, i) {
      O2(a, i);
      var f = a.alternate;
      f && O2(f, i);
    }
    function G7(a) {
      if (a.tag === N) {
        var i = tf, f = Ja(a, i);
        if (f !== null) {
          var v = Ta();
          vo(f, a, i, v);
        }
        NP(a, i);
      }
    }
    function K7(a) {
      if (a.tag === N) {
        var i = Ju(a), f = Ja(a, i);
        if (f !== null) {
          var v = Ta();
          vo(f, a, i, v);
        }
        NP(a, i);
      }
    }
    function P2(a) {
      var i = jx(a);
      return i === null ? null : i.stateNode;
    }
    var $2 = function(a) {
      return null;
    };
    function X7(a) {
      return $2(a);
    }
    var D2 = function(a) {
      return !1;
    };
    function Q7(a) {
      return D2(a);
    }
    var k2 = null, M2 = null, N2 = null, I2 = null, _2 = null, A2 = null, L2 = null, F2 = null, j2 = null;
    {
      var V2 = function(a, i, f) {
        var v = i[f], y = Gr(a) ? a.slice() : pn({}, a);
        return f + 1 === i.length ? (Gr(y) ? y.splice(v, 1) : delete y[v], y) : (y[v] = V2(a[v], i, f + 1), y);
      }, B2 = function(a, i) {
        return V2(a, i, 0);
      }, z2 = function(a, i, f, v) {
        var y = i[v], w = Gr(a) ? a.slice() : pn({}, a);
        if (v + 1 === i.length) {
          var M = f[v];
          w[M] = w[y], Gr(w) ? w.splice(y, 1) : delete w[y];
        } else
          w[y] = z2(
            // $FlowFixMe number or string is fine here
            a[y],
            i,
            f,
            v + 1
          );
        return w;
      }, U2 = function(a, i, f) {
        if (i.length !== f.length) {
          l("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var v = 0; v < f.length - 1; v++)
            if (i[v] !== f[v]) {
              l("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return z2(a, i, f, 0);
      }, H2 = function(a, i, f, v) {
        if (f >= i.length)
          return v;
        var y = i[f], w = Gr(a) ? a.slice() : pn({}, a);
        return w[y] = H2(a[y], i, f + 1, v), w;
      }, W2 = function(a, i, f) {
        return H2(a, i, 0, f);
      }, IP = function(a, i) {
        for (var f = a.memoizedState; f !== null && i > 0; )
          f = f.next, i--;
        return f;
      };
      k2 = function(a, i, f, v) {
        var y = IP(a, i);
        if (y !== null) {
          var w = W2(y.memoizedState, f, v);
          y.memoizedState = w, y.baseState = w, a.memoizedProps = pn({}, a.memoizedProps);
          var M = Ja(a, Bt);
          M !== null && vo(M, a, Bt, Xn);
        }
      }, M2 = function(a, i, f) {
        var v = IP(a, i);
        if (v !== null) {
          var y = B2(v.memoizedState, f);
          v.memoizedState = y, v.baseState = y, a.memoizedProps = pn({}, a.memoizedProps);
          var w = Ja(a, Bt);
          w !== null && vo(w, a, Bt, Xn);
        }
      }, N2 = function(a, i, f, v) {
        var y = IP(a, i);
        if (y !== null) {
          var w = U2(y.memoizedState, f, v);
          y.memoizedState = w, y.baseState = w, a.memoizedProps = pn({}, a.memoizedProps);
          var M = Ja(a, Bt);
          M !== null && vo(M, a, Bt, Xn);
        }
      }, I2 = function(a, i, f) {
        a.pendingProps = W2(a.memoizedProps, i, f), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var v = Ja(a, Bt);
        v !== null && vo(v, a, Bt, Xn);
      }, _2 = function(a, i) {
        a.pendingProps = B2(a.memoizedProps, i), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var f = Ja(a, Bt);
        f !== null && vo(f, a, Bt, Xn);
      }, A2 = function(a, i, f) {
        a.pendingProps = U2(a.memoizedProps, i, f), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var v = Ja(a, Bt);
        v !== null && vo(v, a, Bt, Xn);
      }, L2 = function(a) {
        var i = Ja(a, Bt);
        i !== null && vo(i, a, Bt, Xn);
      }, F2 = function(a) {
        $2 = a;
      }, j2 = function(a) {
        D2 = a;
      };
    }
    function J7(a) {
      var i = za(a);
      return i === null ? null : i.stateNode;
    }
    function Z7(a) {
      return null;
    }
    function eq() {
      return Pr;
    }
    function tq(a) {
      var i = a.findFiberByHostInstance, f = n.ReactCurrentDispatcher;
      return Rg({
        bundleType: a.bundleType,
        version: a.version,
        rendererPackageName: a.rendererPackageName,
        rendererConfig: a.rendererConfig,
        overrideHookState: k2,
        overrideHookStateDeletePath: M2,
        overrideHookStateRenamePath: N2,
        overrideProps: I2,
        overridePropsDeletePath: _2,
        overridePropsRenamePath: A2,
        setErrorHandler: F2,
        setSuspenseHandler: j2,
        scheduleUpdate: L2,
        currentDispatcherRef: f,
        findHostInstanceByFiber: J7,
        findFiberByHostInstance: i || Z7,
        // React Refresh
        findHostInstancesForRefresh: k7,
        scheduleRefresh: $7,
        scheduleRoot: D7,
        setRefreshHandler: P7,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: eq,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: DP
      });
    }
    var q2 = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(a) {
      console.error(a);
    };
    function _P(a) {
      this._internalRoot = a;
    }
    XC.prototype.render = _P.prototype.render = function(a) {
      var i = this._internalRoot;
      if (i === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? u("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : QC(arguments[1]) ? u("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && u("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = i.containerInfo;
        if (f.nodeType !== $r) {
          var v = P2(i.current);
          v && v.parentNode !== f && u("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Xy(a, i, null, null);
    }, XC.prototype.unmount = _P.prototype.unmount = function() {
      typeof arguments[0] == "function" && u("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var a = this._internalRoot;
      if (a !== null) {
        this._internalRoot = null;
        var i = a.containerInfo;
        o2() && u("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Dc(function() {
          Xy(null, a, null, null);
        }), qN(i);
      }
    };
    function nq(a, i) {
      if (!QC(a))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      Y2(a);
      var f = !1, v = !1, y = "", w = q2;
      i != null && (i.hydrate ? l("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof i == "object" && i !== null && i.$$typeof === ko && u(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), i.unstable_strictMode === !0 && (f = !0), i.identifierPrefix !== void 0 && (y = i.identifierPrefix), i.onRecoverableError !== void 0 && (w = i.onRecoverableError), i.transitionCallbacks !== void 0 && i.transitionCallbacks);
      var M = E2(a, WS, null, f, v, y, w);
      FS(M.current, a);
      var j = a.nodeType === $r ? a.parentNode : a;
      return ny(j), new _P(M);
    }
    function XC(a) {
      this._internalRoot = a;
    }
    function rq(a) {
      a && LE(a);
    }
    XC.prototype.unstable_scheduleHydration = rq;
    function oq(a, i, f) {
      if (!QC(a))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      Y2(a), i === void 0 && u("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var v = f ?? null, y = f != null && f.hydratedSources || null, w = !1, M = !1, j = "", B = q2;
      f != null && (f.unstable_strictMode === !0 && (w = !0), f.identifierPrefix !== void 0 && (j = f.identifierPrefix), f.onRecoverableError !== void 0 && (B = f.onRecoverableError));
      var Q = R2(i, null, a, WS, v, w, M, j, B);
      if (FS(Q.current, a), ny(a), y)
        for (var re = 0; re < y.length; re++) {
          var Ce = y[re];
          lW(Q, Ce);
        }
      return new XC(Q);
    }
    function QC(a) {
      return !!(a && (a.nodeType === Xo || a.nodeType === Ci || a.nodeType === Ql || !pe));
    }
    function Qy(a) {
      return !!(a && (a.nodeType === Xo || a.nodeType === Ci || a.nodeType === Ql || a.nodeType === $r && a.nodeValue === " react-mount-point-unstable "));
    }
    function Y2(a) {
      a.nodeType === Xo && a.tagName && a.tagName.toUpperCase() === "BODY" && u("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), py(a) && (a._reactRootContainer ? u("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : u("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var aq = n.ReactCurrentOwner, G2;
    G2 = function(a) {
      if (a._reactRootContainer && a.nodeType !== $r) {
        var i = P2(a._reactRootContainer.current);
        i && i.parentNode !== a && u("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!a._reactRootContainer, v = AP(a), y = !!(v && ju(v));
      y && !f && u("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), a.nodeType === Xo && a.tagName && a.tagName.toUpperCase() === "BODY" && u("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function AP(a) {
      return a ? a.nodeType === Ci ? a.documentElement : a.firstChild : null;
    }
    function K2() {
    }
    function iq(a, i, f, v, y) {
      if (y) {
        if (typeof v == "function") {
          var w = v;
          v = function() {
            var xe = KC(M);
            w.call(xe);
          };
        }
        var M = R2(
          i,
          v,
          a,
          Bu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          K2
        );
        a._reactRootContainer = M, FS(M.current, a);
        var j = a.nodeType === $r ? a.parentNode : a;
        return ny(j), Dc(), M;
      } else {
        for (var B; B = a.lastChild; )
          a.removeChild(B);
        if (typeof v == "function") {
          var Q = v;
          v = function() {
            var xe = KC(re);
            Q.call(xe);
          };
        }
        var re = E2(
          a,
          Bu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          K2
        );
        a._reactRootContainer = re, FS(re.current, a);
        var Ce = a.nodeType === $r ? a.parentNode : a;
        return ny(Ce), Dc(function() {
          Xy(i, re, f, v);
        }), re;
      }
    }
    function sq(a, i) {
      a !== null && typeof a != "function" && u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i, a);
    }
    function JC(a, i, f, v, y) {
      G2(f), sq(y === void 0 ? null : y, "render");
      var w = f._reactRootContainer, M;
      if (!w)
        M = iq(f, i, a, y, v);
      else {
        if (M = w, typeof y == "function") {
          var j = y;
          y = function() {
            var B = KC(M);
            j.call(B);
          };
        }
        Xy(i, M, a, y);
      }
      return KC(M);
    }
    var X2 = !1;
    function lq(a) {
      {
        X2 || (X2 = !0, u("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var i = aq.current;
        if (i !== null && i.stateNode !== null) {
          var f = i.stateNode._warnedAboutRefsInRender;
          f || u("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Mn(i.type) || "A component"), i.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return a == null ? null : a.nodeType === Xo ? a : q7(a, "findDOMNode");
    }
    function cq(a, i, f) {
      if (u("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Qy(i))
        throw new Error("Target container is not a DOM element.");
      {
        var v = py(i) && i._reactRootContainer === void 0;
        v && u("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return JC(null, a, i, !0, f);
    }
    function uq(a, i, f) {
      if (u("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Qy(i))
        throw new Error("Target container is not a DOM element.");
      {
        var v = py(i) && i._reactRootContainer === void 0;
        v && u("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return JC(null, a, i, !1, f);
    }
    function dq(a, i, f, v) {
      if (u("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Qy(f))
        throw new Error("Target container is not a DOM element.");
      if (a == null || !qd(a))
        throw new Error("parentComponent must be a valid React Component");
      return JC(a, i, f, !1, v);
    }
    var Q2 = !1;
    function fq(a) {
      if (Q2 || (Q2 = !0, u("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Qy(a))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var i = py(a) && a._reactRootContainer === void 0;
        i && u("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (a._reactRootContainer) {
        {
          var f = AP(a), v = f && !ju(f);
          v && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Dc(function() {
          JC(null, null, a, !1, function() {
            a._reactRootContainer = null, qN(a);
          });
        }), !0;
      } else {
        {
          var y = AP(a), w = !!(y && ju(y)), M = a.nodeType === Xo && Qy(a.parentNode) && !!a.parentNode._reactRootContainer;
          w && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", M ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Eu(Y7), _E(G7), Eh(K7), iS(qa), sS(Eo), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && u("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ax(h6), zp(pP, o7, Dc);
    function pq(a, i) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!QC(i))
        throw new Error("Target container is not a DOM element.");
      return W7(a, i, null, f);
    }
    function hq(a, i, f, v) {
      return dq(a, i, f, v);
    }
    var LP = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [ju, Gh, jS, Bp, Ud, pP]
    };
    function mq(a, i) {
      return LP.usingClientEntryPoint || u('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), nq(a, i);
    }
    function vq(a, i, f) {
      return LP.usingClientEntryPoint || u('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), oq(a, i, f);
    }
    function gq(a) {
      return o2() && u("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Dc(a);
    }
    var yq = tq({
      findFiberByHostInstance: xf,
      bundleType: 1,
      version: DP,
      rendererPackageName: "react-dom"
    });
    if (!yq && fe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var J2 = window.location.protocol;
      /^(https?|file):$/.test(J2) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (J2 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ri.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = LP, ri.createPortal = pq, ri.createRoot = mq, ri.findDOMNode = lq, ri.flushSync = gq, ri.hydrate = cq, ri.hydrateRoot = vq, ri.render = uq, ri.unmountComponentAtNode = fq, ri.unstable_batchedUpdates = pP, ri.unstable_renderSubtreeIntoContainer = hq, ri.version = DP, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ri;
}
function jB() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(jB);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (jB(), j$.exports = _X()) : j$.exports = AX();
var Ww = j$.exports;
const r1 = /* @__PURE__ */ qc(Ww), eL = {
  disabled: !1
};
var LX = process.env.NODE_ENV !== "production" ? r.oneOfType([r.number, r.shape({
  enter: r.number,
  exit: r.number,
  appear: r.number
}).isRequired]) : null, FX = process.env.NODE_ENV !== "production" ? r.oneOfType([r.string, r.shape({
  enter: r.string,
  exit: r.string,
  active: r.string
}), r.shape({
  enter: r.string,
  enterDone: r.string,
  enterActive: r.string,
  exit: r.string,
  exitDone: r.string,
  exitActive: r.string
})]) : null;
const W1 = oe.createContext(null);
var VB = function(t) {
  return t.scrollTop;
}, mb = "unmounted", Bf = "exited", zf = "entering", Pm = "entered", V$ = "exiting", hi = /* @__PURE__ */ function(e) {
  VD(t, e);
  function t(o, s) {
    var l;
    l = e.call(this, o, s) || this;
    var u = s, p = u && !u.isMounting ? o.enter : o.appear, h;
    return l.appearStatus = null, o.in ? p ? (h = Bf, l.appearStatus = zf) : h = Pm : o.unmountOnExit || o.mountOnEnter ? h = mb : h = Bf, l.state = {
      status: h
    }, l.nextCallback = null, l;
  }
  t.getDerivedStateFromProps = function(s, l) {
    var u = s.in;
    return u && l.status === mb ? {
      status: Bf
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(s) {
    var l = null;
    if (s !== this.props) {
      var u = this.state.status;
      this.props.in ? u !== zf && u !== Pm && (l = zf) : (u === zf || u === Pm) && (l = V$);
    }
    this.updateStatus(!1, l);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var s = this.props.timeout, l, u, p;
    return l = u = p = s, s != null && typeof s != "number" && (l = s.exit, u = s.enter, p = s.appear !== void 0 ? s.appear : u), {
      exit: l,
      enter: u,
      appear: p
    };
  }, n.updateStatus = function(s, l) {
    if (s === void 0 && (s = !1), l !== null)
      if (this.cancelNextCallback(), l === zf) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var u = this.props.nodeRef ? this.props.nodeRef.current : r1.findDOMNode(this);
          u && VB(u);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Bf && this.setState({
      status: mb
    });
  }, n.performEnter = function(s) {
    var l = this, u = this.props.enter, p = this.context ? this.context.isMounting : s, h = this.props.nodeRef ? [p] : [r1.findDOMNode(this), p], m = h[0], b = h[1], x = this.getTimeouts(), S = p ? x.appear : x.enter;
    if (!s && !u || eL.disabled) {
      this.safeSetState({
        status: Pm
      }, function() {
        l.props.onEntered(m);
      });
      return;
    }
    this.props.onEnter(m, b), this.safeSetState({
      status: zf
    }, function() {
      l.props.onEntering(m, b), l.onTransitionEnd(S, function() {
        l.safeSetState({
          status: Pm
        }, function() {
          l.props.onEntered(m, b);
        });
      });
    });
  }, n.performExit = function() {
    var s = this, l = this.props.exit, u = this.getTimeouts(), p = this.props.nodeRef ? void 0 : r1.findDOMNode(this);
    if (!l || eL.disabled) {
      this.safeSetState({
        status: Bf
      }, function() {
        s.props.onExited(p);
      });
      return;
    }
    this.props.onExit(p), this.safeSetState({
      status: V$
    }, function() {
      s.props.onExiting(p), s.onTransitionEnd(u.exit, function() {
        s.safeSetState({
          status: Bf
        }, function() {
          s.props.onExited(p);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(s, l) {
    l = this.setNextCallback(l), this.setState(s, l);
  }, n.setNextCallback = function(s) {
    var l = this, u = !0;
    return this.nextCallback = function(p) {
      u && (u = !1, l.nextCallback = null, s(p));
    }, this.nextCallback.cancel = function() {
      u = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(s, l) {
    this.setNextCallback(l);
    var u = this.props.nodeRef ? this.props.nodeRef.current : r1.findDOMNode(this), p = s == null && !this.props.addEndListener;
    if (!u || p) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [u, this.nextCallback], m = h[0], b = h[1];
      this.props.addEndListener(m, b);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, n.render = function() {
    var s = this.state.status;
    if (s === mb)
      return null;
    var l = this.props, u = l.children;
    l.in, l.mountOnEnter, l.unmountOnExit, l.appear, l.enter, l.exit, l.timeout, l.addEndListener, l.onEnter, l.onEntering, l.onEntered, l.onExit, l.onExiting, l.onExited, l.nodeRef;
    var p = Te(l, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ oe.createElement(W1.Provider, {
        value: null
      }, typeof u == "function" ? u(s, p) : oe.cloneElement(oe.Children.only(u), p))
    );
  }, t;
}(oe.Component);
hi.contextType = W1;
hi.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: r.shape({
    current: typeof Element > "u" ? r.any : function(e, t, n, o, s, l) {
      var u = e[t];
      return r.instanceOf(u && "ownerDocument" in u ? u.ownerDocument.defaultView.Element : Element)(e, t, n, o, s, l);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: r.oneOfType([r.func.isRequired, r.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: r.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: r.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: r.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: r.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: r.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: r.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = LX;
    t.addEndListener || (n = n.isRequired);
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
      s[l - 1] = arguments[l];
    return n.apply(void 0, [t].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: r.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: r.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: r.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: r.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: r.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: r.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: r.func
} : {};
function Em() {
}
hi.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Em,
  onEntering: Em,
  onEntered: Em,
  onExit: Em,
  onExiting: Em,
  onExited: Em
};
hi.UNMOUNTED = mb;
hi.EXITED = Bf;
hi.ENTERING = zf;
hi.ENTERED = Pm;
hi.EXITING = V$;
var jX = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return kX(t, o);
  });
}, XP = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return MX(t, o);
  });
}, BD = /* @__PURE__ */ function(e) {
  VD(t, e);
  function t() {
    for (var o, s = arguments.length, l = new Array(s), u = 0; u < s; u++)
      l[u] = arguments[u];
    return o = e.call.apply(e, [this].concat(l)) || this, o.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, o.onEnter = function(p, h) {
      var m = o.resolveArguments(p, h), b = m[0], x = m[1];
      o.removeClasses(b, "exit"), o.addClass(b, x ? "appear" : "enter", "base"), o.props.onEnter && o.props.onEnter(p, h);
    }, o.onEntering = function(p, h) {
      var m = o.resolveArguments(p, h), b = m[0], x = m[1], S = x ? "appear" : "enter";
      o.addClass(b, S, "active"), o.props.onEntering && o.props.onEntering(p, h);
    }, o.onEntered = function(p, h) {
      var m = o.resolveArguments(p, h), b = m[0], x = m[1], S = x ? "appear" : "enter";
      o.removeClasses(b, S), o.addClass(b, S, "done"), o.props.onEntered && o.props.onEntered(p, h);
    }, o.onExit = function(p) {
      var h = o.resolveArguments(p), m = h[0];
      o.removeClasses(m, "appear"), o.removeClasses(m, "enter"), o.addClass(m, "exit", "base"), o.props.onExit && o.props.onExit(p);
    }, o.onExiting = function(p) {
      var h = o.resolveArguments(p), m = h[0];
      o.addClass(m, "exit", "active"), o.props.onExiting && o.props.onExiting(p);
    }, o.onExited = function(p) {
      var h = o.resolveArguments(p), m = h[0];
      o.removeClasses(m, "exit"), o.addClass(m, "exit", "done"), o.props.onExited && o.props.onExited(p);
    }, o.resolveArguments = function(p, h) {
      return o.props.nodeRef ? [o.props.nodeRef.current, p] : [p, h];
    }, o.getClassNames = function(p) {
      var h = o.props.classNames, m = typeof h == "string", b = m && h ? h + "-" : "", x = m ? "" + b + p : h[p], S = m ? x + "-active" : h[p + "Active"], R = m ? x + "-done" : h[p + "Done"];
      return {
        baseClassName: x,
        activeClassName: S,
        doneClassName: R
      };
    }, o;
  }
  var n = t.prototype;
  return n.addClass = function(s, l, u) {
    var p = this.getClassNames(l)[u + "ClassName"], h = this.getClassNames("enter"), m = h.doneClassName;
    l === "appear" && u === "done" && m && (p += " " + m), u === "active" && s && VB(s), p && (this.appliedClasses[l][u] = p, jX(s, p));
  }, n.removeClasses = function(s, l) {
    var u = this.appliedClasses[l], p = u.base, h = u.active, m = u.done;
    this.appliedClasses[l] = {}, p && XP(s, p), h && XP(s, h), m && XP(s, m);
  }, n.render = function() {
    var s = this.props;
    s.classNames;
    var l = Te(s, ["classNames"]);
    return /* @__PURE__ */ oe.createElement(hi, O({}, l, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(oe.Component);
BD.defaultProps = {
  classNames: ""
};
BD.propTypes = process.env.NODE_ENV !== "production" ? O({}, hi.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: FX,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: r.func
}) : {};
function VX(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zD(e, t) {
  var n = function(l) {
    return t && Cb(l) ? t(l) : l;
  }, o = /* @__PURE__ */ Object.create(null);
  return e && Tq.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    o[s.key] = n(s);
  }), o;
}
function BX(e, t) {
  e = e || {}, t = t || {};
  function n(b) {
    return b in t ? t[b] : e[b];
  }
  var o = /* @__PURE__ */ Object.create(null), s = [];
  for (var l in e)
    l in t ? s.length && (o[l] = s, s = []) : s.push(l);
  var u, p = {};
  for (var h in t) {
    if (o[h])
      for (u = 0; u < o[h].length; u++) {
        var m = o[h][u];
        p[o[h][u]] = n(m);
      }
    p[h] = n(h);
  }
  for (u = 0; u < s.length; u++)
    p[s[u]] = n(s[u]);
  return p;
}
function Wf(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function zX(e, t) {
  return zD(e.children, function(n) {
    return w1(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Wf(n, "appear", e),
      enter: Wf(n, "enter", e),
      exit: Wf(n, "exit", e)
    });
  });
}
function UX(e, t, n) {
  var o = zD(e.children), s = BX(t, o);
  return Object.keys(s).forEach(function(l) {
    var u = s[l];
    if (Cb(u)) {
      var p = l in t, h = l in o, m = t[l], b = Cb(m) && !m.props.in;
      h && (!p || b) ? s[l] = w1(u, {
        onExited: n.bind(null, u),
        in: !0,
        exit: Wf(u, "exit", e),
        enter: Wf(u, "enter", e)
      }) : !h && p && !b ? s[l] = w1(u, {
        in: !1
      }) : h && p && Cb(m) && (s[l] = w1(u, {
        onExited: n.bind(null, u),
        in: m.props.in,
        exit: Wf(u, "exit", e),
        enter: Wf(u, "enter", e)
      }));
    }
  }), s;
}
var HX = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, WX = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, m0 = /* @__PURE__ */ function(e) {
  VD(t, e);
  function t(o, s) {
    var l;
    l = e.call(this, o, s) || this;
    var u = l.handleExited.bind(VX(l));
    return l.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: u,
      firstRender: !0
    }, l;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(s, l) {
    var u = l.children, p = l.handleExited, h = l.firstRender;
    return {
      children: h ? zX(s, p) : UX(s, u, p),
      firstRender: !1
    };
  }, n.handleExited = function(s, l) {
    var u = zD(this.props.children);
    s.key in u || (s.props.onExited && s.props.onExited(l), this.mounted && this.setState(function(p) {
      var h = O({}, p.children);
      return delete h[s.key], {
        children: h
      };
    }));
  }, n.render = function() {
    var s = this.props, l = s.component, u = s.childFactory, p = Te(s, ["component", "childFactory"]), h = this.state.contextValue, m = HX(this.state.children).map(u);
    return delete p.appear, delete p.enter, delete p.exit, l === null ? /* @__PURE__ */ oe.createElement(W1.Provider, {
      value: h
    }, m) : /* @__PURE__ */ oe.createElement(W1.Provider, {
      value: h
    }, /* @__PURE__ */ oe.createElement(l, p, m));
  }, t;
}(oe.Component);
m0.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: r.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: r.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: r.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: r.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: r.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: r.func
} : {};
m0.defaultProps = WX;
const UD = (e) => e.scrollTop;
function fd(e, t) {
  var n, o;
  const {
    timeout: s,
    easing: l,
    style: u = {}
  } = e;
  return {
    duration: (n = u.transitionDuration) != null ? n : typeof s == "number" ? s : s[t.mode] || 0,
    easing: (o = u.transitionTimingFunction) != null ? o : typeof l == "object" ? l[t.mode] : l,
    delay: u.transitionDelay
  };
}
function qX(e) {
  return pt("MuiCollapse", e);
}
ht("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const YX = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], GX = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return vt(o, qX, n);
}, KX = ce("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && O({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), XX = ce("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => O({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), QX = ce("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => O({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Sv = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: s,
    children: l,
    className: u,
    collapsedSize: p = "0px",
    component: h,
    easing: m,
    in: b,
    onEnter: x,
    onEntered: S,
    onEntering: R,
    onExit: T,
    onExited: E,
    onExiting: P,
    orientation: k = "vertical",
    style: _,
    timeout: L = AB.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: F = hi
  } = o, N = Te(o, YX), V = O({}, o, {
    orientation: k,
    collapsedSize: p
  }), z = GX(V), H = Go(), ee = Hf(), K = D.useRef(null), X = D.useRef(), ne = typeof p == "number" ? `${p}px` : p, Y = k === "horizontal", J = Y ? "width" : "height", te = D.useRef(null), Z = Gn(n, te), ae = (se) => (ve) => {
    if (se) {
      const me = te.current;
      ve === void 0 ? se(me) : se(me, ve);
    }
  }, U = () => K.current ? K.current[Y ? "clientWidth" : "clientHeight"] : 0, G = ae((se, ve) => {
    K.current && Y && (K.current.style.position = "absolute"), se.style[J] = ne, x && x(se, ve);
  }), W = ae((se, ve) => {
    const me = U();
    K.current && Y && (K.current.style.position = "");
    const {
      duration: Oe,
      easing: be
    } = fd({
      style: _,
      timeout: L,
      easing: m
    }, {
      mode: "enter"
    });
    if (L === "auto") {
      const De = H.transitions.getAutoHeightDuration(me);
      se.style.transitionDuration = `${De}ms`, X.current = De;
    } else
      se.style.transitionDuration = typeof Oe == "string" ? Oe : `${Oe}ms`;
    se.style[J] = `${me}px`, se.style.transitionTimingFunction = be, R && R(se, ve);
  }), le = ae((se, ve) => {
    se.style[J] = "auto", S && S(se, ve);
  }), pe = ae((se) => {
    se.style[J] = `${U()}px`, T && T(se);
  }), ge = ae(E), we = ae((se) => {
    const ve = U(), {
      duration: me,
      easing: Oe
    } = fd({
      style: _,
      timeout: L,
      easing: m
    }, {
      mode: "exit"
    });
    if (L === "auto") {
      const be = H.transitions.getAutoHeightDuration(ve);
      se.style.transitionDuration = `${be}ms`, X.current = be;
    } else
      se.style.transitionDuration = typeof me == "string" ? me : `${me}ms`;
    se.style[J] = ne, se.style.transitionTimingFunction = Oe, P && P(se);
  });
  return /* @__PURE__ */ I(F, O({
    in: b,
    onEnter: G,
    onEntered: le,
    onEntering: W,
    onExit: pe,
    onExited: ge,
    onExiting: we,
    addEndListener: (se) => {
      L === "auto" && ee.start(X.current || 0, se), s && s(te.current, se);
    },
    nodeRef: te,
    timeout: L === "auto" ? null : L
  }, N, {
    children: (se, ve) => /* @__PURE__ */ I(KX, O({
      as: h,
      className: Ne(z.root, u, {
        entered: z.entered,
        exited: !b && ne === "0px" && z.hidden
      }[se]),
      style: O({
        [Y ? "minWidth" : "minHeight"]: ne
      }, _),
      ownerState: O({}, V, {
        state: se
      }),
      ref: Z
    }, ve, {
      children: /* @__PURE__ */ I(XX, {
        ownerState: O({}, V, {
          state: se
        }),
        className: z.wrapper,
        ref: K,
        children: /* @__PURE__ */ I(QX, {
          ownerState: O({}, V, {
            state: se
          }),
          className: z.wrapperInner,
          children: l
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Sv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * The content node to be collapsed.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: r.oneOfType([r.number, r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: yv,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
Sv.muiSupportAuto = !0;
function JX(e) {
  return pt("MuiPaper", e);
}
ht("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const ZX = ["className", "component", "elevation", "square", "variant"], eQ = (e) => {
  const {
    square: t,
    elevation: n,
    variant: o,
    classes: s
  } = e, l = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${n}`]
  };
  return vt(l, JX, s);
}, tQ = ce("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return O({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && O({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Mt("#fff", YA(t.elevation))}, ${Mt("#fff", YA(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), ms = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPaper"
  }), {
    className: s,
    component: l = "div",
    elevation: u = 1,
    square: p = !1,
    variant: h = "elevation"
  } = o, m = Te(o, ZX), b = O({}, o, {
    component: l,
    elevation: u,
    square: p,
    variant: h
  }), x = eQ(b);
  return process.env.NODE_ENV !== "production" && Go().shadows[u] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${u}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${u}]\` is defined.`].join(`
`)), /* @__PURE__ */ I(tQ, O({
    as: l,
    ownerState: b,
    className: Ne(x.root, s),
    ref: n
  }, m));
});
process.env.NODE_ENV !== "production" && (ms.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Pa(Lc, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: r.oneOfType([r.oneOf(["elevation", "outlined"]), r.string])
});
const HD = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (HD.displayName = "AccordionContext");
function Zf(e) {
  return typeof e == "string";
}
function Km(e, t, n) {
  return e === void 0 || Zf(e) ? t : O({}, t, {
    ownerState: O({}, t.ownerState, n)
  });
}
const nQ = {
  disableDefaultClasses: !1
}, rQ = /* @__PURE__ */ D.createContext(nQ);
function oQ(e) {
  const {
    disableDefaultClasses: t
  } = D.useContext(rQ);
  return (n) => t ? "" : e(n);
}
function BB(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function zB(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function tL(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function UB(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: s,
    className: l
  } = e;
  if (!t) {
    const R = Ne(n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), T = O({}, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), E = O({}, n, s, o);
    return R.length > 0 && (E.className = R), Object.keys(T).length > 0 && (E.style = T), {
      props: E,
      internalRef: void 0
    };
  }
  const u = BB(O({}, s, o)), p = tL(o), h = tL(s), m = t(u), b = Ne(m == null ? void 0 : m.className, n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), x = O({}, m == null ? void 0 : m.style, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), S = O({}, m, n, h, p);
  return b.length > 0 && (S.className = b), Object.keys(x).length > 0 && (S.style = x), {
    props: S,
    internalRef: m.ref
  };
}
const aQ = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Li(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: o,
    ownerState: s,
    skipResolvingSlotProps: l = !1
  } = e, u = Te(e, aQ), p = l ? {} : zB(o, s), {
    props: h,
    internalRef: m
  } = UB(O({}, u, {
    externalSlotProps: p
  })), b = Gn(m, p == null ? void 0 : p.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return Km(n, O({}, h, {
    ref: b
  }), s);
}
const iQ = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], sQ = ["component", "slots", "slotProps"], lQ = ["component"];
function cQ(e, t) {
  const {
    className: n,
    elementType: o,
    ownerState: s,
    externalForwardedProps: l,
    getSlotOwnerState: u,
    internalForwardedProps: p
  } = t, h = Te(t, iQ), {
    component: m,
    slots: b = {
      [e]: void 0
    },
    slotProps: x = {
      [e]: void 0
    }
  } = l;
  Te(l, sQ);
  const S = b[e] || o, R = zB(x[e], s), T = UB(O({
    className: n
  }, h, {
    externalForwardedProps: void 0,
    externalSlotProps: R
  })), {
    props: {
      component: E
    },
    internalRef: P
  } = T, k = Te(T.props, lQ), _ = Gn(P, R == null ? void 0 : R.ref, t.ref), L = u ? u(k) : {}, F = O({}, s, L), N = E, V = Km(S, O({}, e === "root", !b[e] && p, k, N && {
    as: N
  }, {
    ref: _
  }), F);
  return Object.keys(L).forEach((z) => {
    delete V[z];
  }), [S, V];
}
function uQ(e) {
  return pt("MuiAccordion", e);
}
const o1 = ht("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), dQ = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], fQ = (e) => {
  const {
    classes: t,
    square: n,
    expanded: o,
    disabled: s,
    disableGutters: l
  } = e;
  return vt({
    root: ["root", !n && "rounded", o && "expanded", s && "disabled", !l && "gutters"],
    region: ["region"]
  }, uQ, t);
}, pQ = ce(ms, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${o1.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${o1.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${o1.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e,
  ownerState: t
}) => O({}, !t.square && {
  borderRadius: 0,
  "&:first-of-type": {
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius
  },
  "&:last-of-type": {
    borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
    borderBottomRightRadius: (e.vars || e).shape.borderRadius,
    // Fix a rendering issue on Edge
    "@supports (-ms-ime-align: auto)": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
}, !t.disableGutters && {
  [`&.${o1.expanded}`]: {
    margin: "16px 0"
  }
})), HB = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiAccordion"
  }), {
    children: s,
    className: l,
    defaultExpanded: u = !1,
    disabled: p = !1,
    disableGutters: h = !1,
    expanded: m,
    onChange: b,
    square: x = !1,
    slots: S = {},
    slotProps: R = {},
    TransitionComponent: T,
    TransitionProps: E
  } = o, P = Te(o, dQ), [k, _] = jl({
    controlled: m,
    default: u,
    name: "Accordion",
    state: "expanded"
  }), L = D.useCallback((Y) => {
    _(!k), b && b(Y, !k);
  }, [k, b, _]), [F, ...N] = D.Children.toArray(s), V = D.useMemo(() => ({
    expanded: k,
    disabled: p,
    disableGutters: h,
    toggle: L
  }), [k, p, h, L]), z = O({}, o, {
    square: x,
    disabled: p,
    disableGutters: h,
    expanded: k
  }), H = fQ(z), ee = O({
    transition: T
  }, S), K = O({
    transition: E
  }, R), [X, ne] = cQ("transition", {
    elementType: Sv,
    externalForwardedProps: {
      slots: ee,
      slotProps: K
    },
    ownerState: z
  });
  return delete ne.ownerState, /* @__PURE__ */ qe(pQ, O({
    className: Ne(H.root, l),
    ref: n,
    ownerState: z,
    square: x
  }, P, {
    children: [/* @__PURE__ */ I(HD.Provider, {
      value: V,
      children: F
    }), /* @__PURE__ */ I(X, O({
      in: k,
      timeout: "auto"
    }, ne, {
      children: /* @__PURE__ */ I("div", {
        "aria-labelledby": F.props.id,
        id: F.props["aria-controls"],
        role: "region",
        className: H.region,
        children: N
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (HB.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Pa(r.node.isRequired, (e) => {
    const t = D.Children.toArray(e.children)[0];
    return jc.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ D.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: r.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: r.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    transition: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    transition: r.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7.
   */
  TransitionComponent: r.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7.
   */
  TransitionProps: r.object
});
function hQ(e) {
  return pt("MuiAccordionDetails", e);
}
ht("MuiAccordionDetails", ["root"]);
const mQ = ["className"], vQ = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, hQ, t);
}, gQ = ce("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), WB = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: s
  } = o, l = Te(o, mQ), u = o, p = vQ(u);
  return /* @__PURE__ */ I(gQ, O({
    className: Ne(p.root, s),
    ref: n,
    ownerState: u
  }, l));
});
process.env.NODE_ENV !== "production" && (WB.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function qB(e) {
  const {
    className: t,
    classes: n,
    pulsate: o = !1,
    rippleX: s,
    rippleY: l,
    rippleSize: u,
    in: p,
    onExited: h,
    timeout: m
  } = e, [b, x] = D.useState(!1), S = Ne(t, n.ripple, n.rippleVisible, o && n.ripplePulsate), R = {
    width: u,
    height: u,
    top: -(u / 2) + l,
    left: -(u / 2) + s
  }, T = Ne(n.child, b && n.childLeaving, o && n.childPulsate);
  return !p && !b && x(!0), D.useEffect(() => {
    if (!p && h != null) {
      const E = setTimeout(h, m);
      return () => {
        clearTimeout(E);
      };
    }
  }, [h, p, m]), /* @__PURE__ */ I("span", {
    className: S,
    style: R,
    children: /* @__PURE__ */ I("span", {
      className: T
    })
  });
}
process.env.NODE_ENV !== "production" && (qB.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object.isRequired,
  className: r.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: r.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: r.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: r.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: r.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: r.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: r.number,
  /**
   * exit delay
   */
  timeout: r.number.isRequired
});
const rs = ht("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), yQ = ["center", "classes", "className"];
let qw = (e) => e, nL, rL, oL, aL;
const B$ = 550, bQ = 80, xQ = tl(nL || (nL = qw`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), SQ = tl(rL || (rL = qw`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), CQ = tl(oL || (oL = qw`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), wQ = ce("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TQ = ce(qB, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(aL || (aL = qw`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), rs.rippleVisible, xQ, B$, ({
  theme: e
}) => e.transitions.easing.easeInOut, rs.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, rs.child, rs.childLeaving, SQ, B$, ({
  theme: e
}) => e.transitions.easing.easeInOut, rs.childPulsate, CQ, ({
  theme: e
}) => e.transitions.easing.easeInOut), YB = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: l = {},
    className: u
  } = o, p = Te(o, yQ), [h, m] = D.useState([]), b = D.useRef(0), x = D.useRef(null);
  D.useEffect(() => {
    x.current && (x.current(), x.current = null);
  }, [h]);
  const S = D.useRef(!1), R = Hf(), T = D.useRef(null), E = D.useRef(null), P = D.useCallback((F) => {
    const {
      pulsate: N,
      rippleX: V,
      rippleY: z,
      rippleSize: H,
      cb: ee
    } = F;
    m((K) => [...K, /* @__PURE__ */ I(TQ, {
      classes: {
        ripple: Ne(l.ripple, rs.ripple),
        rippleVisible: Ne(l.rippleVisible, rs.rippleVisible),
        ripplePulsate: Ne(l.ripplePulsate, rs.ripplePulsate),
        child: Ne(l.child, rs.child),
        childLeaving: Ne(l.childLeaving, rs.childLeaving),
        childPulsate: Ne(l.childPulsate, rs.childPulsate)
      },
      timeout: B$,
      pulsate: N,
      rippleX: V,
      rippleY: z,
      rippleSize: H
    }, b.current)]), b.current += 1, x.current = ee;
  }, [l]), k = D.useCallback((F = {}, N = {}, V = () => {
  }) => {
    const {
      pulsate: z = !1,
      center: H = s || N.pulsate,
      fakeElement: ee = !1
      // For test purposes
    } = N;
    if ((F == null ? void 0 : F.type) === "mousedown" && S.current) {
      S.current = !1;
      return;
    }
    (F == null ? void 0 : F.type) === "touchstart" && (S.current = !0);
    const K = ee ? null : E.current, X = K ? K.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let ne, Y, J;
    if (H || F === void 0 || F.clientX === 0 && F.clientY === 0 || !F.clientX && !F.touches)
      ne = Math.round(X.width / 2), Y = Math.round(X.height / 2);
    else {
      const {
        clientX: te,
        clientY: Z
      } = F.touches && F.touches.length > 0 ? F.touches[0] : F;
      ne = Math.round(te - X.left), Y = Math.round(Z - X.top);
    }
    if (H)
      J = Math.sqrt((2 * X.width ** 2 + X.height ** 2) / 3), J % 2 === 0 && (J += 1);
    else {
      const te = Math.max(Math.abs((K ? K.clientWidth : 0) - ne), ne) * 2 + 2, Z = Math.max(Math.abs((K ? K.clientHeight : 0) - Y), Y) * 2 + 2;
      J = Math.sqrt(te ** 2 + Z ** 2);
    }
    F != null && F.touches ? T.current === null && (T.current = () => {
      P({
        pulsate: z,
        rippleX: ne,
        rippleY: Y,
        rippleSize: J,
        cb: V
      });
    }, R.start(bQ, () => {
      T.current && (T.current(), T.current = null);
    })) : P({
      pulsate: z,
      rippleX: ne,
      rippleY: Y,
      rippleSize: J,
      cb: V
    });
  }, [s, P, R]), _ = D.useCallback(() => {
    k({}, {
      pulsate: !0
    });
  }, [k]), L = D.useCallback((F, N) => {
    if (R.clear(), (F == null ? void 0 : F.type) === "touchend" && T.current) {
      T.current(), T.current = null, R.start(0, () => {
        L(F, N);
      });
      return;
    }
    T.current = null, m((V) => V.length > 0 ? V.slice(1) : V), x.current = N;
  }, [R]);
  return D.useImperativeHandle(n, () => ({
    pulsate: _,
    start: k,
    stop: L
  }), [_, k, L]), /* @__PURE__ */ I(wQ, O({
    className: Ne(rs.root, l.root, u),
    ref: E
  }, p, {
    children: /* @__PURE__ */ I(m0, {
      component: null,
      exit: !0,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (YB.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: r.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string
});
function EQ(e) {
  return pt("MuiButtonBase", e);
}
const RQ = ht("MuiButtonBase", ["root", "disabled", "focusVisible"]), OQ = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], PQ = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: o,
    classes: s
  } = e, u = vt({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, EQ, s);
  return n && o && (u.root += ` ${o}`), u;
}, $Q = ce("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${RQ.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ui = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: l = !1,
    children: u,
    className: p,
    component: h = "button",
    disabled: m = !1,
    disableRipple: b = !1,
    disableTouchRipple: x = !1,
    focusRipple: S = !1,
    LinkComponent: R = "a",
    onBlur: T,
    onClick: E,
    onContextMenu: P,
    onDragLeave: k,
    onFocus: _,
    onFocusVisible: L,
    onKeyDown: F,
    onKeyUp: N,
    onMouseDown: V,
    onMouseLeave: z,
    onMouseUp: H,
    onTouchEnd: ee,
    onTouchMove: K,
    onTouchStart: X,
    tabIndex: ne = 0,
    TouchRippleProps: Y,
    touchRippleRef: J,
    type: te
  } = o, Z = Te(o, OQ), ae = D.useRef(null), U = D.useRef(null), G = Gn(U, J), {
    isFocusVisibleRef: W,
    onFocus: le,
    onBlur: pe,
    ref: ge
  } = Cw(), [we, de] = D.useState(!1);
  m && we && de(!1), D.useImperativeHandle(s, () => ({
    focusVisible: () => {
      de(!0), ae.current.focus();
    }
  }), []);
  const [se, ve] = D.useState(!1);
  D.useEffect(() => {
    ve(!0);
  }, []);
  const me = se && !b && !m;
  D.useEffect(() => {
    we && S && !b && se && U.current.pulsate();
  }, [b, S, we, se]);
  function Oe(rt, Qt, et = x) {
    return qo((st) => (Qt && Qt(st), !et && U.current && U.current[rt](st), !0));
  }
  const be = Oe("start", V), De = Oe("stop", P), ie = Oe("stop", k), fe = Oe("stop", H), ye = Oe("stop", (rt) => {
    we && rt.preventDefault(), z && z(rt);
  }), Ee = Oe("start", X), _e = Oe("stop", ee), Ve = Oe("stop", K), Re = Oe("stop", (rt) => {
    pe(rt), W.current === !1 && de(!1), T && T(rt);
  }, !1), lt = qo((rt) => {
    ae.current || (ae.current = rt.currentTarget), le(rt), W.current === !0 && (de(!0), L && L(rt)), _ && _(rt);
  }), Pt = () => {
    const rt = ae.current;
    return h && h !== "button" && !(rt.tagName === "A" && rt.href);
  }, at = D.useRef(!1), it = qo((rt) => {
    S && !at.current && we && U.current && rt.key === " " && (at.current = !0, U.current.stop(rt, () => {
      U.current.start(rt);
    })), rt.target === rt.currentTarget && Pt() && rt.key === " " && rt.preventDefault(), F && F(rt), rt.target === rt.currentTarget && Pt() && rt.key === "Enter" && !m && (rt.preventDefault(), E && E(rt));
  }), bt = qo((rt) => {
    S && rt.key === " " && U.current && we && !rt.defaultPrevented && (at.current = !1, U.current.stop(rt, () => {
      U.current.pulsate(rt);
    })), N && N(rt), E && rt.target === rt.currentTarget && Pt() && rt.key === " " && !rt.defaultPrevented && E(rt);
  });
  let Nt = h;
  Nt === "button" && (Z.href || Z.to) && (Nt = R);
  const en = {};
  Nt === "button" ? (en.type = te === void 0 ? "button" : te, en.disabled = m) : (!Z.href && !Z.to && (en.role = "button"), m && (en["aria-disabled"] = m));
  const fn = Gn(n, ge, ae);
  process.env.NODE_ENV !== "production" && D.useEffect(() => {
    me && !U.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [me]);
  const ln = O({}, o, {
    centerRipple: l,
    component: h,
    disabled: m,
    disableRipple: b,
    disableTouchRipple: x,
    focusRipple: S,
    tabIndex: ne,
    focusVisible: we
  }), Rt = PQ(ln);
  return /* @__PURE__ */ qe($Q, O({
    as: Nt,
    className: Ne(Rt.root, p),
    ownerState: ln,
    onBlur: Re,
    onClick: E,
    onContextMenu: De,
    onFocus: lt,
    onKeyDown: it,
    onKeyUp: bt,
    onMouseDown: be,
    onMouseLeave: ye,
    onMouseUp: fe,
    onDragLeave: ie,
    onTouchEnd: _e,
    onTouchMove: Ve,
    onTouchStart: Ee,
    ref: fn,
    tabIndex: m ? -1 : ne,
    type: te
  }, en, Z, {
    children: [u, me ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ I(YB, O({
        ref: G,
        center: l
      }, Y))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (ui.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Yo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: yv,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: r.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  href: r.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: r.elementType,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onContextMenu: r.func,
  /**
   * @ignore
   */
  onDragLeave: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * @ignore
   */
  onMouseDown: r.func,
  /**
   * @ignore
   */
  onMouseLeave: r.func,
  /**
   * @ignore
   */
  onMouseUp: r.func,
  /**
   * @ignore
   */
  onTouchEnd: r.func,
  /**
   * @ignore
   */
  onTouchMove: r.func,
  /**
   * @ignore
   */
  onTouchStart: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: r.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      pulsate: r.func.isRequired,
      start: r.func.isRequired,
      stop: r.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: r.oneOfType([r.oneOf(["button", "reset", "submit"]), r.string])
});
function DQ(e) {
  return pt("MuiAccordionSummary", e);
}
const Xm = ht("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), kQ = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], MQ = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: o,
    disableGutters: s
  } = e;
  return vt({
    root: ["root", n && "expanded", o && "disabled", !s && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !s && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, DQ, t);
}, NQ = ce(ui, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const n = {
    duration: e.transitions.duration.shortest
  };
  return O({
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], n),
    [`&.${Xm.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${Xm.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${Xm.disabled})`]: {
      cursor: "pointer"
    }
  }, !t.disableGutters && {
    [`&.${Xm.expanded}`]: {
      minHeight: 64
    }
  });
}), IQ = ce("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0"
}, !t.disableGutters && {
  transition: e.transitions.create(["margin"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Xm.expanded}`]: {
    margin: "20px 0"
  }
})), _Q = ce("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Xm.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), GB = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: s,
    className: l,
    expandIcon: u,
    focusVisibleClassName: p,
    onClick: h
  } = o, m = Te(o, kQ), {
    disabled: b = !1,
    disableGutters: x,
    expanded: S,
    toggle: R
  } = D.useContext(HD), T = (k) => {
    R && R(k), h && h(k);
  }, E = O({}, o, {
    expanded: S,
    disabled: b,
    disableGutters: x
  }), P = MQ(E);
  return /* @__PURE__ */ qe(NQ, O({
    focusRipple: !1,
    disableRipple: !0,
    disabled: b,
    component: "div",
    "aria-expanded": S,
    className: Ne(P.root, l),
    focusVisibleClassName: Ne(P.focusVisible, p),
    onClick: T,
    ref: n,
    ownerState: E
  }, m, {
    children: [/* @__PURE__ */ I(IQ, {
      className: P.content,
      ownerState: E,
      children: s
    }), u && /* @__PURE__ */ I(_Q, {
      className: P.expandIconWrapper,
      ownerState: E,
      children: u
    })]
  }));
});
process.env.NODE_ENV !== "production" && (GB.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: r.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function AQ(e) {
  return pt("MuiIconButton", e);
}
const LQ = ht("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), FQ = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], jQ = (e) => {
  const {
    classes: t,
    disabled: n,
    color: o,
    edge: s,
    size: l
  } = e, u = {
    root: ["root", n && "disabled", o !== "default" && `color${Ae(o)}`, s && `edge${Ae(s)}`, `size${Ae(l)}`]
  };
  return vt(u, AQ, t);
}, VQ = ce(ui, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Ae(n.color)}`], n.edge && t[`edge${Ae(n.edge)}`], t[`size${Ae(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const o = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return O({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && O({
    color: o == null ? void 0 : o.main
  }, !t.disableRipple && {
    "&:hover": O({}, o && {
      backgroundColor: e.vars ? `rgba(${o.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(o.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${LQ.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), oi = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: l,
    className: u,
    color: p = "default",
    disabled: h = !1,
    disableFocusRipple: m = !1,
    size: b = "medium"
  } = o, x = Te(o, FQ), S = O({}, o, {
    edge: s,
    color: p,
    disabled: h,
    disableFocusRipple: m,
    size: b
  }), R = jQ(S);
  return /* @__PURE__ */ I(VQ, O({
    className: Ne(R.root, u),
    centerRipple: !0,
    focusRipple: !m,
    disabled: h,
    ref: n,
    ownerState: S
  }, x, {
    children: l
  }));
});
process.env.NODE_ENV !== "production" && (oi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Pa(r.node, (e) => D.Children.toArray(e.children).some((n) => /* @__PURE__ */ D.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const BQ = lr(/* @__PURE__ */ I("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function zQ(e) {
  return pt("MuiTypography", e);
}
ht("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const UQ = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], HQ = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: o,
    paragraph: s,
    variant: l,
    classes: u
  } = e, p = {
    root: ["root", l, e.align !== "inherit" && `align${Ae(t)}`, n && "gutterBottom", o && "noWrap", s && "paragraph"]
  };
  return vt(p, zQ, u);
}, WQ = ce("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Ae(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), iL = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, qQ = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, YQ = (e) => qQ[e] || e, nr = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTypography"
  }), s = YQ(o.color), l = Vw(O({}, o, {
    color: s
  })), {
    align: u = "inherit",
    className: p,
    component: h,
    gutterBottom: m = !1,
    noWrap: b = !1,
    paragraph: x = !1,
    variant: S = "body1",
    variantMapping: R = iL
  } = l, T = Te(l, UQ), E = O({}, l, {
    align: u,
    color: s,
    className: p,
    component: h,
    gutterBottom: m,
    noWrap: b,
    paragraph: x,
    variant: S,
    variantMapping: R
  }), P = h || (x ? "p" : R[S] || iL[S]) || "span", k = HQ(E);
  return /* @__PURE__ */ I(WQ, O({
    as: P,
    ref: n,
    ownerState: E,
    className: Ne(k.root, p)
  }, T));
});
process.env.NODE_ENV !== "production" && (nr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: r.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: r.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: r.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: r.oneOfType([r.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), r.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: r.object
});
function GQ(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: o = 99,
    showZero: s = !1
  } = e, l = CD({
    badgeContent: t,
    max: o
  });
  let u = n;
  n === !1 && t === 0 && !s && (u = !0);
  const {
    badgeContent: p,
    max: h = o
  } = u ? l : e, m = p && Number(p) > h ? `${h}+` : p;
  return {
    badgeContent: p,
    invisible: u,
    max: h,
    displayValue: m
  };
}
const KB = "base";
function KQ(e) {
  return `${KB}--${e}`;
}
function XQ(e, t) {
  return `${KB}-${e}-${t}`;
}
function XB(e, t) {
  const n = iB[t];
  return n ? KQ(n) : XQ(e, t);
}
function QQ(e, t) {
  const n = {};
  return t.forEach((o) => {
    n[o] = XB(e, o);
  }), n;
}
function sL(e) {
  return e.substring(2).toLowerCase();
}
function JQ(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function q1(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: o = "onClick",
    onClickAway: s,
    touchEvent: l = "onTouchEnd"
  } = e, u = D.useRef(!1), p = D.useRef(null), h = D.useRef(!1), m = D.useRef(!1);
  D.useEffect(() => (setTimeout(() => {
    h.current = !0;
  }, 0), () => {
    h.current = !1;
  }), []);
  const b = Gn(
    // @ts-expect-error TODO upstream fix
    t.ref,
    p
  ), x = qo((T) => {
    const E = m.current;
    m.current = !1;
    const P = no(p.current);
    if (!h.current || !p.current || "clientX" in T && JQ(T, P))
      return;
    if (u.current) {
      u.current = !1;
      return;
    }
    let k;
    T.composedPath ? k = T.composedPath().indexOf(p.current) > -1 : k = !P.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      T.target
    ) || p.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      T.target
    ), !k && (n || !E) && s(T);
  }), S = (T) => (E) => {
    m.current = !0;
    const P = t.props[T];
    P && P(E);
  }, R = {
    ref: b
  };
  return l !== !1 && (R[l] = S(l)), D.useEffect(() => {
    if (l !== !1) {
      const T = sL(l), E = no(p.current), P = () => {
        u.current = !0;
      };
      return E.addEventListener(T, x), E.addEventListener("touchmove", P), () => {
        E.removeEventListener(T, x), E.removeEventListener("touchmove", P);
      };
    }
  }, [x, l]), o !== !1 && (R[o] = S(o)), D.useEffect(() => {
    if (o !== !1) {
      const T = sL(o), E = no(p.current);
      return E.addEventListener(T, x), () => {
        E.removeEventListener(T, x);
      };
    }
  }, [x, o]), /* @__PURE__ */ I(D.Fragment, {
    children: /* @__PURE__ */ D.cloneElement(t, R)
  });
}
process.env.NODE_ENV !== "production" && (q1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: gd.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: r.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: r.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: r.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: r.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (q1.propTypes = u0(q1.propTypes));
const ZQ = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function eJ(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function tJ(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function nJ(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || tJ(e));
}
function rJ(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(ZQ)).forEach((o, s) => {
    const l = eJ(o);
    l === -1 || !nJ(o) || (l === 0 ? t.push(o) : n.push({
      documentOrder: s,
      tabIndex: l,
      node: o
    }));
  }), n.sort((o, s) => o.tabIndex === s.tabIndex ? o.documentOrder - s.documentOrder : o.tabIndex - s.tabIndex).map((o) => o.node).concat(t);
}
function oJ() {
  return !0;
}
function Hb(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: s = !1,
    getTabbable: l = rJ,
    isEnabled: u = oJ,
    open: p
  } = e, h = D.useRef(!1), m = D.useRef(null), b = D.useRef(null), x = D.useRef(null), S = D.useRef(null), R = D.useRef(!1), T = D.useRef(null), E = Gn(t.ref, T), P = D.useRef(null);
  D.useEffect(() => {
    !p || !T.current || (R.current = !n);
  }, [n, p]), D.useEffect(() => {
    if (!p || !T.current)
      return;
    const L = no(T.current);
    return T.current.contains(L.activeElement) || (T.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), T.current.setAttribute("tabIndex", "-1")), R.current && T.current.focus()), () => {
      s || (x.current && x.current.focus && (h.current = !0, x.current.focus()), x.current = null);
    };
  }, [p]), D.useEffect(() => {
    if (!p || !T.current)
      return;
    const L = no(T.current), F = (z) => {
      P.current = z, !(o || !u() || z.key !== "Tab") && L.activeElement === T.current && z.shiftKey && (h.current = !0, b.current && b.current.focus());
    }, N = () => {
      const z = T.current;
      if (z === null)
        return;
      if (!L.hasFocus() || !u() || h.current) {
        h.current = !1;
        return;
      }
      if (z.contains(L.activeElement) || o && L.activeElement !== m.current && L.activeElement !== b.current)
        return;
      if (L.activeElement !== S.current)
        S.current = null;
      else if (S.current !== null)
        return;
      if (!R.current)
        return;
      let H = [];
      if ((L.activeElement === m.current || L.activeElement === b.current) && (H = l(T.current)), H.length > 0) {
        var ee, K;
        const X = !!((ee = P.current) != null && ee.shiftKey && ((K = P.current) == null ? void 0 : K.key) === "Tab"), ne = H[0], Y = H[H.length - 1];
        typeof ne != "string" && typeof Y != "string" && (X ? Y.focus() : ne.focus());
      } else
        z.focus();
    };
    L.addEventListener("focusin", N), L.addEventListener("keydown", F, !0);
    const V = setInterval(() => {
      L.activeElement && L.activeElement.tagName === "BODY" && N();
    }, 50);
    return () => {
      clearInterval(V), L.removeEventListener("focusin", N), L.removeEventListener("keydown", F, !0);
    };
  }, [n, o, s, u, p, l]);
  const k = (L) => {
    x.current === null && (x.current = L.relatedTarget), R.current = !0, S.current = L.target;
    const F = t.props.onFocus;
    F && F(L);
  }, _ = (L) => {
    x.current === null && (x.current = L.relatedTarget), R.current = !0;
  };
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ I("div", {
      tabIndex: p ? 0 : -1,
      onFocus: _,
      ref: m,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ D.cloneElement(t, {
      ref: E,
      onFocus: k
    }), /* @__PURE__ */ I("div", {
      tabIndex: p ? 0 : -1,
      onFocus: _,
      ref: b,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Hb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: gd,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: r.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: r.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: r.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: r.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: r.func,
  /**
   * If `true`, focus is locked.
   */
  open: r.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Hb.propTypes = u0(Hb.propTypes));
var ii = "top", ds = "bottom", fs = "right", si = "left", WD = "auto", v0 = [ii, ds, fs, si], cv = "start", Wb = "end", aJ = "clippingParents", QB = "viewport", tb = "popper", iJ = "reference", lL = /* @__PURE__ */ v0.reduce(function(e, t) {
  return e.concat([t + "-" + cv, t + "-" + Wb]);
}, []), JB = /* @__PURE__ */ [].concat(v0, [WD]).reduce(function(e, t) {
  return e.concat([t, t + "-" + cv, t + "-" + Wb]);
}, []), sJ = "beforeRead", lJ = "read", cJ = "afterRead", uJ = "beforeMain", dJ = "main", fJ = "afterMain", pJ = "beforeWrite", hJ = "write", mJ = "afterWrite", vJ = [sJ, lJ, cJ, uJ, dJ, fJ, pJ, hJ, mJ];
function Wl(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Fi(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ep(e) {
  var t = Fi(e).Element;
  return e instanceof t || e instanceof Element;
}
function ls(e) {
  var t = Fi(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function qD(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Fi(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function gJ(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, s = t.attributes[n] || {}, l = t.elements[n];
    !ls(l) || !Wl(l) || (Object.assign(l.style, o), Object.keys(s).forEach(function(u) {
      var p = s[u];
      p === !1 ? l.removeAttribute(u) : l.setAttribute(u, p === !0 ? "" : p);
    }));
  });
}
function yJ(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var s = t.elements[o], l = t.attributes[o] || {}, u = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), p = u.reduce(function(h, m) {
        return h[m] = "", h;
      }, {});
      !ls(s) || !Wl(s) || (Object.assign(s.style, p), Object.keys(l).forEach(function(h) {
        s.removeAttribute(h);
      }));
    });
  };
}
const bJ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: gJ,
  effect: yJ,
  requires: ["computeStyles"]
};
function Bl(e) {
  return e.split("-")[0];
}
var Yf = Math.max, Y1 = Math.min, uv = Math.round;
function z$() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function ZB() {
  return !/^((?!chrome|android).)*safari/i.test(z$());
}
function dv(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), s = 1, l = 1;
  t && ls(e) && (s = e.offsetWidth > 0 && uv(o.width) / e.offsetWidth || 1, l = e.offsetHeight > 0 && uv(o.height) / e.offsetHeight || 1);
  var u = ep(e) ? Fi(e) : window, p = u.visualViewport, h = !ZB() && n, m = (o.left + (h && p ? p.offsetLeft : 0)) / s, b = (o.top + (h && p ? p.offsetTop : 0)) / l, x = o.width / s, S = o.height / l;
  return {
    width: x,
    height: S,
    top: b,
    right: m + x,
    bottom: b + S,
    left: m,
    x: m,
    y: b
  };
}
function YD(e) {
  var t = dv(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function ez(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && qD(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function zc(e) {
  return Fi(e).getComputedStyle(e);
}
function xJ(e) {
  return ["table", "td", "th"].indexOf(Wl(e)) >= 0;
}
function xd(e) {
  return ((ep(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Yw(e) {
  return Wl(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (qD(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    xd(e)
  );
}
function cL(e) {
  return !ls(e) || // https://github.com/popperjs/popper-core/issues/837
  zc(e).position === "fixed" ? null : e.offsetParent;
}
function SJ(e) {
  var t = /firefox/i.test(z$()), n = /Trident/i.test(z$());
  if (n && ls(e)) {
    var o = zc(e);
    if (o.position === "fixed")
      return null;
  }
  var s = Yw(e);
  for (qD(s) && (s = s.host); ls(s) && ["html", "body"].indexOf(Wl(s)) < 0; ) {
    var l = zc(s);
    if (l.transform !== "none" || l.perspective !== "none" || l.contain === "paint" || ["transform", "perspective"].indexOf(l.willChange) !== -1 || t && l.willChange === "filter" || t && l.filter && l.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function g0(e) {
  for (var t = Fi(e), n = cL(e); n && xJ(n) && zc(n).position === "static"; )
    n = cL(n);
  return n && (Wl(n) === "html" || Wl(n) === "body" && zc(n).position === "static") ? t : n || SJ(e) || t;
}
function GD(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Eb(e, t, n) {
  return Yf(e, Y1(t, n));
}
function CJ(e, t, n) {
  var o = Eb(e, t, n);
  return o > n ? n : o;
}
function tz() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function nz(e) {
  return Object.assign({}, tz(), e);
}
function rz(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var wJ = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, nz(typeof t != "number" ? t : rz(t, v0));
};
function TJ(e) {
  var t, n = e.state, o = e.name, s = e.options, l = n.elements.arrow, u = n.modifiersData.popperOffsets, p = Bl(n.placement), h = GD(p), m = [si, fs].indexOf(p) >= 0, b = m ? "height" : "width";
  if (!(!l || !u)) {
    var x = wJ(s.padding, n), S = YD(l), R = h === "y" ? ii : si, T = h === "y" ? ds : fs, E = n.rects.reference[b] + n.rects.reference[h] - u[h] - n.rects.popper[b], P = u[h] - n.rects.reference[h], k = g0(l), _ = k ? h === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, L = E / 2 - P / 2, F = x[R], N = _ - S[b] - x[T], V = _ / 2 - S[b] / 2 + L, z = Eb(F, V, N), H = h;
    n.modifiersData[o] = (t = {}, t[H] = z, t.centerOffset = z - V, t);
  }
}
function EJ(e) {
  var t = e.state, n = e.options, o = n.element, s = o === void 0 ? "[data-popper-arrow]" : o;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || ez(t.elements.popper, s) && (t.elements.arrow = s));
}
const RJ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: TJ,
  effect: EJ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function fv(e) {
  return e.split("-")[1];
}
var OJ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function PJ(e, t) {
  var n = e.x, o = e.y, s = t.devicePixelRatio || 1;
  return {
    x: uv(n * s) / s || 0,
    y: uv(o * s) / s || 0
  };
}
function uL(e) {
  var t, n = e.popper, o = e.popperRect, s = e.placement, l = e.variation, u = e.offsets, p = e.position, h = e.gpuAcceleration, m = e.adaptive, b = e.roundOffsets, x = e.isFixed, S = u.x, R = S === void 0 ? 0 : S, T = u.y, E = T === void 0 ? 0 : T, P = typeof b == "function" ? b({
    x: R,
    y: E
  }) : {
    x: R,
    y: E
  };
  R = P.x, E = P.y;
  var k = u.hasOwnProperty("x"), _ = u.hasOwnProperty("y"), L = si, F = ii, N = window;
  if (m) {
    var V = g0(n), z = "clientHeight", H = "clientWidth";
    if (V === Fi(n) && (V = xd(n), zc(V).position !== "static" && p === "absolute" && (z = "scrollHeight", H = "scrollWidth")), V = V, s === ii || (s === si || s === fs) && l === Wb) {
      F = ds;
      var ee = x && V === N && N.visualViewport ? N.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        V[z]
      );
      E -= ee - o.height, E *= h ? 1 : -1;
    }
    if (s === si || (s === ii || s === ds) && l === Wb) {
      L = fs;
      var K = x && V === N && N.visualViewport ? N.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        V[H]
      );
      R -= K - o.width, R *= h ? 1 : -1;
    }
  }
  var X = Object.assign({
    position: p
  }, m && OJ), ne = b === !0 ? PJ({
    x: R,
    y: E
  }, Fi(n)) : {
    x: R,
    y: E
  };
  if (R = ne.x, E = ne.y, h) {
    var Y;
    return Object.assign({}, X, (Y = {}, Y[F] = _ ? "0" : "", Y[L] = k ? "0" : "", Y.transform = (N.devicePixelRatio || 1) <= 1 ? "translate(" + R + "px, " + E + "px)" : "translate3d(" + R + "px, " + E + "px, 0)", Y));
  }
  return Object.assign({}, X, (t = {}, t[F] = _ ? E + "px" : "", t[L] = k ? R + "px" : "", t.transform = "", t));
}
function $J(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, s = o === void 0 ? !0 : o, l = n.adaptive, u = l === void 0 ? !0 : l, p = n.roundOffsets, h = p === void 0 ? !0 : p, m = {
    placement: Bl(t.placement),
    variation: fv(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, uL(Object.assign({}, m, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: u,
    roundOffsets: h
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, uL(Object.assign({}, m, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: h
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const DJ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: $J,
  data: {}
};
var a1 = {
  passive: !0
};
function kJ(e) {
  var t = e.state, n = e.instance, o = e.options, s = o.scroll, l = s === void 0 ? !0 : s, u = o.resize, p = u === void 0 ? !0 : u, h = Fi(t.elements.popper), m = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return l && m.forEach(function(b) {
    b.addEventListener("scroll", n.update, a1);
  }), p && h.addEventListener("resize", n.update, a1), function() {
    l && m.forEach(function(b) {
      b.removeEventListener("scroll", n.update, a1);
    }), p && h.removeEventListener("resize", n.update, a1);
  };
}
const MJ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: kJ,
  data: {}
};
var NJ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function P1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return NJ[t];
  });
}
var IJ = {
  start: "end",
  end: "start"
};
function dL(e) {
  return e.replace(/start|end/g, function(t) {
    return IJ[t];
  });
}
function KD(e) {
  var t = Fi(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function XD(e) {
  return dv(xd(e)).left + KD(e).scrollLeft;
}
function _J(e, t) {
  var n = Fi(e), o = xd(e), s = n.visualViewport, l = o.clientWidth, u = o.clientHeight, p = 0, h = 0;
  if (s) {
    l = s.width, u = s.height;
    var m = ZB();
    (m || !m && t === "fixed") && (p = s.offsetLeft, h = s.offsetTop);
  }
  return {
    width: l,
    height: u,
    x: p + XD(e),
    y: h
  };
}
function AJ(e) {
  var t, n = xd(e), o = KD(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, l = Yf(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), u = Yf(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), p = -o.scrollLeft + XD(e), h = -o.scrollTop;
  return zc(s || n).direction === "rtl" && (p += Yf(n.clientWidth, s ? s.clientWidth : 0) - l), {
    width: l,
    height: u,
    x: p,
    y: h
  };
}
function QD(e) {
  var t = zc(e), n = t.overflow, o = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + o);
}
function oz(e) {
  return ["html", "body", "#document"].indexOf(Wl(e)) >= 0 ? e.ownerDocument.body : ls(e) && QD(e) ? e : oz(Yw(e));
}
function Rb(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = oz(e), s = o === ((n = e.ownerDocument) == null ? void 0 : n.body), l = Fi(o), u = s ? [l].concat(l.visualViewport || [], QD(o) ? o : []) : o, p = t.concat(u);
  return s ? p : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    p.concat(Rb(Yw(u)))
  );
}
function U$(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function LJ(e, t) {
  var n = dv(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function fL(e, t, n) {
  return t === QB ? U$(_J(e, n)) : ep(t) ? LJ(t, n) : U$(AJ(xd(e)));
}
function FJ(e) {
  var t = Rb(Yw(e)), n = ["absolute", "fixed"].indexOf(zc(e).position) >= 0, o = n && ls(e) ? g0(e) : e;
  return ep(o) ? t.filter(function(s) {
    return ep(s) && ez(s, o) && Wl(s) !== "body";
  }) : [];
}
function jJ(e, t, n, o) {
  var s = t === "clippingParents" ? FJ(e) : [].concat(t), l = [].concat(s, [n]), u = l[0], p = l.reduce(function(h, m) {
    var b = fL(e, m, o);
    return h.top = Yf(b.top, h.top), h.right = Y1(b.right, h.right), h.bottom = Y1(b.bottom, h.bottom), h.left = Yf(b.left, h.left), h;
  }, fL(e, u, o));
  return p.width = p.right - p.left, p.height = p.bottom - p.top, p.x = p.left, p.y = p.top, p;
}
function az(e) {
  var t = e.reference, n = e.element, o = e.placement, s = o ? Bl(o) : null, l = o ? fv(o) : null, u = t.x + t.width / 2 - n.width / 2, p = t.y + t.height / 2 - n.height / 2, h;
  switch (s) {
    case ii:
      h = {
        x: u,
        y: t.y - n.height
      };
      break;
    case ds:
      h = {
        x: u,
        y: t.y + t.height
      };
      break;
    case fs:
      h = {
        x: t.x + t.width,
        y: p
      };
      break;
    case si:
      h = {
        x: t.x - n.width,
        y: p
      };
      break;
    default:
      h = {
        x: t.x,
        y: t.y
      };
  }
  var m = s ? GD(s) : null;
  if (m != null) {
    var b = m === "y" ? "height" : "width";
    switch (l) {
      case cv:
        h[m] = h[m] - (t[b] / 2 - n[b] / 2);
        break;
      case Wb:
        h[m] = h[m] + (t[b] / 2 - n[b] / 2);
        break;
    }
  }
  return h;
}
function qb(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = o === void 0 ? e.placement : o, l = n.strategy, u = l === void 0 ? e.strategy : l, p = n.boundary, h = p === void 0 ? aJ : p, m = n.rootBoundary, b = m === void 0 ? QB : m, x = n.elementContext, S = x === void 0 ? tb : x, R = n.altBoundary, T = R === void 0 ? !1 : R, E = n.padding, P = E === void 0 ? 0 : E, k = nz(typeof P != "number" ? P : rz(P, v0)), _ = S === tb ? iJ : tb, L = e.rects.popper, F = e.elements[T ? _ : S], N = jJ(ep(F) ? F : F.contextElement || xd(e.elements.popper), h, b, u), V = dv(e.elements.reference), z = az({
    reference: V,
    element: L,
    strategy: "absolute",
    placement: s
  }), H = U$(Object.assign({}, L, z)), ee = S === tb ? H : V, K = {
    top: N.top - ee.top + k.top,
    bottom: ee.bottom - N.bottom + k.bottom,
    left: N.left - ee.left + k.left,
    right: ee.right - N.right + k.right
  }, X = e.modifiersData.offset;
  if (S === tb && X) {
    var ne = X[s];
    Object.keys(K).forEach(function(Y) {
      var J = [fs, ds].indexOf(Y) >= 0 ? 1 : -1, te = [ii, ds].indexOf(Y) >= 0 ? "y" : "x";
      K[Y] += ne[te] * J;
    });
  }
  return K;
}
function VJ(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = n.boundary, l = n.rootBoundary, u = n.padding, p = n.flipVariations, h = n.allowedAutoPlacements, m = h === void 0 ? JB : h, b = fv(o), x = b ? p ? lL : lL.filter(function(T) {
    return fv(T) === b;
  }) : v0, S = x.filter(function(T) {
    return m.indexOf(T) >= 0;
  });
  S.length === 0 && (S = x);
  var R = S.reduce(function(T, E) {
    return T[E] = qb(e, {
      placement: E,
      boundary: s,
      rootBoundary: l,
      padding: u
    })[Bl(E)], T;
  }, {});
  return Object.keys(R).sort(function(T, E) {
    return R[T] - R[E];
  });
}
function BJ(e) {
  if (Bl(e) === WD)
    return [];
  var t = P1(e);
  return [dL(e), t, dL(t)];
}
function zJ(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var s = n.mainAxis, l = s === void 0 ? !0 : s, u = n.altAxis, p = u === void 0 ? !0 : u, h = n.fallbackPlacements, m = n.padding, b = n.boundary, x = n.rootBoundary, S = n.altBoundary, R = n.flipVariations, T = R === void 0 ? !0 : R, E = n.allowedAutoPlacements, P = t.options.placement, k = Bl(P), _ = k === P, L = h || (_ || !T ? [P1(P)] : BJ(P)), F = [P].concat(L).reduce(function(we, de) {
      return we.concat(Bl(de) === WD ? VJ(t, {
        placement: de,
        boundary: b,
        rootBoundary: x,
        padding: m,
        flipVariations: T,
        allowedAutoPlacements: E
      }) : de);
    }, []), N = t.rects.reference, V = t.rects.popper, z = /* @__PURE__ */ new Map(), H = !0, ee = F[0], K = 0; K < F.length; K++) {
      var X = F[K], ne = Bl(X), Y = fv(X) === cv, J = [ii, ds].indexOf(ne) >= 0, te = J ? "width" : "height", Z = qb(t, {
        placement: X,
        boundary: b,
        rootBoundary: x,
        altBoundary: S,
        padding: m
      }), ae = J ? Y ? fs : si : Y ? ds : ii;
      N[te] > V[te] && (ae = P1(ae));
      var U = P1(ae), G = [];
      if (l && G.push(Z[ne] <= 0), p && G.push(Z[ae] <= 0, Z[U] <= 0), G.every(function(we) {
        return we;
      })) {
        ee = X, H = !1;
        break;
      }
      z.set(X, G);
    }
    if (H)
      for (var W = T ? 3 : 1, le = function(de) {
        var se = F.find(function(ve) {
          var me = z.get(ve);
          if (me)
            return me.slice(0, de).every(function(Oe) {
              return Oe;
            });
        });
        if (se)
          return ee = se, "break";
      }, pe = W; pe > 0; pe--) {
        var ge = le(pe);
        if (ge === "break") break;
      }
    t.placement !== ee && (t.modifiersData[o]._skip = !0, t.placement = ee, t.reset = !0);
  }
}
const UJ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: zJ,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function pL(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function hL(e) {
  return [ii, fs, ds, si].some(function(t) {
    return e[t] >= 0;
  });
}
function HJ(e) {
  var t = e.state, n = e.name, o = t.rects.reference, s = t.rects.popper, l = t.modifiersData.preventOverflow, u = qb(t, {
    elementContext: "reference"
  }), p = qb(t, {
    altBoundary: !0
  }), h = pL(u, o), m = pL(p, s, l), b = hL(h), x = hL(m);
  t.modifiersData[n] = {
    referenceClippingOffsets: h,
    popperEscapeOffsets: m,
    isReferenceHidden: b,
    hasPopperEscaped: x
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": b,
    "data-popper-escaped": x
  });
}
const WJ = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: HJ
};
function qJ(e, t, n) {
  var o = Bl(e), s = [si, ii].indexOf(o) >= 0 ? -1 : 1, l = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, u = l[0], p = l[1];
  return u = u || 0, p = (p || 0) * s, [si, fs].indexOf(o) >= 0 ? {
    x: p,
    y: u
  } : {
    x: u,
    y: p
  };
}
function YJ(e) {
  var t = e.state, n = e.options, o = e.name, s = n.offset, l = s === void 0 ? [0, 0] : s, u = JB.reduce(function(b, x) {
    return b[x] = qJ(x, t.rects, l), b;
  }, {}), p = u[t.placement], h = p.x, m = p.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += h, t.modifiersData.popperOffsets.y += m), t.modifiersData[o] = u;
}
const GJ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: YJ
};
function KJ(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = az({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const XJ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: KJ,
  data: {}
};
function QJ(e) {
  return e === "x" ? "y" : "x";
}
function JJ(e) {
  var t = e.state, n = e.options, o = e.name, s = n.mainAxis, l = s === void 0 ? !0 : s, u = n.altAxis, p = u === void 0 ? !1 : u, h = n.boundary, m = n.rootBoundary, b = n.altBoundary, x = n.padding, S = n.tether, R = S === void 0 ? !0 : S, T = n.tetherOffset, E = T === void 0 ? 0 : T, P = qb(t, {
    boundary: h,
    rootBoundary: m,
    padding: x,
    altBoundary: b
  }), k = Bl(t.placement), _ = fv(t.placement), L = !_, F = GD(k), N = QJ(F), V = t.modifiersData.popperOffsets, z = t.rects.reference, H = t.rects.popper, ee = typeof E == "function" ? E(Object.assign({}, t.rects, {
    placement: t.placement
  })) : E, K = typeof ee == "number" ? {
    mainAxis: ee,
    altAxis: ee
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, ee), X = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (V) {
    if (l) {
      var Y, J = F === "y" ? ii : si, te = F === "y" ? ds : fs, Z = F === "y" ? "height" : "width", ae = V[F], U = ae + P[J], G = ae - P[te], W = R ? -H[Z] / 2 : 0, le = _ === cv ? z[Z] : H[Z], pe = _ === cv ? -H[Z] : -z[Z], ge = t.elements.arrow, we = R && ge ? YD(ge) : {
        width: 0,
        height: 0
      }, de = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : tz(), se = de[J], ve = de[te], me = Eb(0, z[Z], we[Z]), Oe = L ? z[Z] / 2 - W - me - se - K.mainAxis : le - me - se - K.mainAxis, be = L ? -z[Z] / 2 + W + me + ve + K.mainAxis : pe + me + ve + K.mainAxis, De = t.elements.arrow && g0(t.elements.arrow), ie = De ? F === "y" ? De.clientTop || 0 : De.clientLeft || 0 : 0, fe = (Y = X == null ? void 0 : X[F]) != null ? Y : 0, ye = ae + Oe - fe - ie, Ee = ae + be - fe, _e = Eb(R ? Y1(U, ye) : U, ae, R ? Yf(G, Ee) : G);
      V[F] = _e, ne[F] = _e - ae;
    }
    if (p) {
      var Ve, Re = F === "x" ? ii : si, lt = F === "x" ? ds : fs, Pt = V[N], at = N === "y" ? "height" : "width", it = Pt + P[Re], bt = Pt - P[lt], Nt = [ii, si].indexOf(k) !== -1, en = (Ve = X == null ? void 0 : X[N]) != null ? Ve : 0, fn = Nt ? it : Pt - z[at] - H[at] - en + K.altAxis, ln = Nt ? Pt + z[at] + H[at] - en - K.altAxis : bt, Rt = R && Nt ? CJ(fn, Pt, ln) : Eb(R ? fn : it, Pt, R ? ln : bt);
      V[N] = Rt, ne[N] = Rt - Pt;
    }
    t.modifiersData[o] = ne;
  }
}
const ZJ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: JJ,
  requiresIfExists: ["offset"]
};
function eZ(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function tZ(e) {
  return e === Fi(e) || !ls(e) ? KD(e) : eZ(e);
}
function nZ(e) {
  var t = e.getBoundingClientRect(), n = uv(t.width) / e.offsetWidth || 1, o = uv(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function rZ(e, t, n) {
  n === void 0 && (n = !1);
  var o = ls(t), s = ls(t) && nZ(t), l = xd(t), u = dv(e, s, n), p = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((Wl(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  QD(l)) && (p = tZ(t)), ls(t) ? (h = dv(t, !0), h.x += t.clientLeft, h.y += t.clientTop) : l && (h.x = XD(l))), {
    x: u.left + p.scrollLeft - h.x,
    y: u.top + p.scrollTop - h.y,
    width: u.width,
    height: u.height
  };
}
function oZ(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(l) {
    t.set(l.name, l);
  });
  function s(l) {
    n.add(l.name);
    var u = [].concat(l.requires || [], l.requiresIfExists || []);
    u.forEach(function(p) {
      if (!n.has(p)) {
        var h = t.get(p);
        h && s(h);
      }
    }), o.push(l);
  }
  return e.forEach(function(l) {
    n.has(l.name) || s(l);
  }), o;
}
function aZ(e) {
  var t = oZ(e);
  return vJ.reduce(function(n, o) {
    return n.concat(t.filter(function(s) {
      return s.phase === o;
    }));
  }, []);
}
function iZ(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function sZ(e) {
  var t = e.reduce(function(n, o) {
    var s = n[o.name];
    return n[o.name] = s ? Object.assign({}, s, o, {
      options: Object.assign({}, s.options, o.options),
      data: Object.assign({}, s.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var mL = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function vL() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function lZ(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, s = t.defaultOptions, l = s === void 0 ? mL : s;
  return function(p, h, m) {
    m === void 0 && (m = l);
    var b = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, mL, l),
      modifiersData: {},
      elements: {
        reference: p,
        popper: h
      },
      attributes: {},
      styles: {}
    }, x = [], S = !1, R = {
      state: b,
      setOptions: function(k) {
        var _ = typeof k == "function" ? k(b.options) : k;
        E(), b.options = Object.assign({}, l, b.options, _), b.scrollParents = {
          reference: ep(p) ? Rb(p) : p.contextElement ? Rb(p.contextElement) : [],
          popper: Rb(h)
        };
        var L = aZ(sZ([].concat(o, b.options.modifiers)));
        return b.orderedModifiers = L.filter(function(F) {
          return F.enabled;
        }), T(), R.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!S) {
          var k = b.elements, _ = k.reference, L = k.popper;
          if (vL(_, L)) {
            b.rects = {
              reference: rZ(_, g0(L), b.options.strategy === "fixed"),
              popper: YD(L)
            }, b.reset = !1, b.placement = b.options.placement, b.orderedModifiers.forEach(function(K) {
              return b.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var F = 0; F < b.orderedModifiers.length; F++) {
              if (b.reset === !0) {
                b.reset = !1, F = -1;
                continue;
              }
              var N = b.orderedModifiers[F], V = N.fn, z = N.options, H = z === void 0 ? {} : z, ee = N.name;
              typeof V == "function" && (b = V({
                state: b,
                options: H,
                name: ee,
                instance: R
              }) || b);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: iZ(function() {
        return new Promise(function(P) {
          R.forceUpdate(), P(b);
        });
      }),
      destroy: function() {
        E(), S = !0;
      }
    };
    if (!vL(p, h))
      return R;
    R.setOptions(m).then(function(P) {
      !S && m.onFirstUpdate && m.onFirstUpdate(P);
    });
    function T() {
      b.orderedModifiers.forEach(function(P) {
        var k = P.name, _ = P.options, L = _ === void 0 ? {} : _, F = P.effect;
        if (typeof F == "function") {
          var N = F({
            state: b,
            name: k,
            instance: R,
            options: L
          }), V = function() {
          };
          x.push(N || V);
        }
      });
    }
    function E() {
      x.forEach(function(P) {
        return P();
      }), x = [];
    }
    return R;
  };
}
var cZ = [MJ, XJ, DJ, bJ, GJ, UJ, ZJ, RJ, WJ], uZ = /* @__PURE__ */ lZ({
  defaultModifiers: cZ
});
function dZ(e) {
  return typeof e == "function" ? e() : e;
}
const Yb = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    children: o,
    container: s,
    disablePortal: l = !1
  } = t, [u, p] = D.useState(null), h = Gn(/* @__PURE__ */ D.isValidElement(o) ? o.ref : null, n);
  if ($a(() => {
    l || p(dZ(s) || document.body);
  }, [s, l]), $a(() => {
    if (u && !l)
      return Fb(n, u), () => {
        Fb(n, null);
      };
  }, [n, u, l]), l) {
    if (/* @__PURE__ */ D.isValidElement(o)) {
      const m = {
        ref: h
      };
      return /* @__PURE__ */ D.cloneElement(o, m);
    }
    return /* @__PURE__ */ I(D.Fragment, {
      children: o
    });
  }
  return /* @__PURE__ */ I(D.Fragment, {
    children: u && /* @__PURE__ */ Ww.createPortal(o, u)
  });
});
process.env.NODE_ENV !== "production" && (Yb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: r.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Hl, r.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool
});
process.env.NODE_ENV !== "production" && (Yb.propTypes = u0(Yb.propTypes));
const iz = "Popper";
function fZ(e) {
  return XB(iz, e);
}
QQ(iz, ["root"]);
const pZ = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], hZ = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function mZ(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function G1(e) {
  return typeof e == "function" ? e() : e;
}
function Gw(e) {
  return e.nodeType !== void 0;
}
function vZ(e) {
  return !Gw(e);
}
const gZ = () => vt({
  root: ["root"]
}, oQ(fZ)), yZ = {}, bZ = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const {
    anchorEl: s,
    children: l,
    direction: u,
    disablePortal: p,
    modifiers: h,
    open: m,
    placement: b,
    popperOptions: x,
    popperRef: S,
    slotProps: R = {},
    slots: T = {},
    TransitionProps: E
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, P = Te(t, pZ), k = D.useRef(null), _ = Gn(k, n), L = D.useRef(null), F = Gn(L, S), N = D.useRef(F);
  $a(() => {
    N.current = F;
  }, [F]), D.useImperativeHandle(S, () => L.current, []);
  const V = mZ(b, u), [z, H] = D.useState(V), [ee, K] = D.useState(G1(s));
  D.useEffect(() => {
    L.current && L.current.forceUpdate();
  }), D.useEffect(() => {
    s && K(G1(s));
  }, [s]), $a(() => {
    if (!ee || !m)
      return;
    const te = (U) => {
      H(U.placement);
    };
    if (process.env.NODE_ENV !== "production" && ee && Gw(ee) && ee.nodeType === 1) {
      const U = ee.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && U.top === 0 && U.left === 0 && U.right === 0 && U.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let Z = [{
      name: "preventOverflow",
      options: {
        altBoundary: p
      }
    }, {
      name: "flip",
      options: {
        altBoundary: p
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: U
      }) => {
        te(U);
      }
    }];
    h != null && (Z = Z.concat(h)), x && x.modifiers != null && (Z = Z.concat(x.modifiers));
    const ae = uZ(ee, k.current, O({
      placement: V
    }, x, {
      modifiers: Z
    }));
    return N.current(ae), () => {
      ae.destroy(), N.current(null);
    };
  }, [ee, p, h, m, x, V]);
  const X = {
    placement: z
  };
  E !== null && (X.TransitionProps = E);
  const ne = gZ(), Y = (o = T.root) != null ? o : "div", J = Li({
    elementType: Y,
    externalSlotProps: R.root,
    externalForwardedProps: P,
    additionalProps: {
      role: "tooltip",
      ref: _
    },
    ownerState: t,
    className: ne.root
  });
  return /* @__PURE__ */ I(Y, O({}, J, {
    children: typeof l == "function" ? l(X) : l
  }));
}), sz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    anchorEl: o,
    children: s,
    container: l,
    direction: u = "ltr",
    disablePortal: p = !1,
    keepMounted: h = !1,
    modifiers: m,
    open: b,
    placement: x = "bottom",
    popperOptions: S = yZ,
    popperRef: R,
    style: T,
    transition: E = !1,
    slotProps: P = {},
    slots: k = {}
  } = t, _ = Te(t, hZ), [L, F] = D.useState(!0), N = () => {
    F(!1);
  }, V = () => {
    F(!0);
  };
  if (!h && !b && (!E || L))
    return null;
  let z;
  if (l)
    z = l;
  else if (o) {
    const K = G1(o);
    z = K && Gw(K) ? no(K).body : no(null).body;
  }
  const H = !b && h && (!E || L) ? "none" : void 0, ee = E ? {
    in: b,
    onEnter: N,
    onExited: V
  } : void 0;
  return /* @__PURE__ */ I(Yb, {
    disablePortal: p,
    container: z,
    children: /* @__PURE__ */ I(bZ, O({
      anchorEl: o,
      direction: u,
      disablePortal: p,
      modifiers: m,
      ref: n,
      open: E ? !L : b,
      placement: x,
      popperOptions: S,
      popperRef: R,
      slotProps: P,
      slots: k
    }, _, {
      style: O({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: H
      }, T),
      TransitionProps: ee,
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (sz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Pa(r.oneOfType([Hl, r.object, r.func]), (e) => {
    if (e.open) {
      const t = G1(e.anchorEl);
      if (t && Gw(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || vZ(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: r.oneOfType([r.node, r.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Hl, r.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: r.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: r.arrayOf(r.shape({
    data: r.object,
    effect: r.func,
    enabled: r.bool,
    fn: r.func,
    name: r.any,
    options: r.object,
    phase: r.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: r.arrayOf(r.string),
    requiresIfExists: r.arrayOf(r.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: r.shape({
    modifiers: r.array,
    onFirstUpdate: r.func,
    placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: r.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Yo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: r.bool
});
function xZ(e) {
  const t = no(e);
  return t.body === e ? us(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Ob(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function gL(e) {
  return parseInt(us(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function SZ(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || o;
}
function yL(e, t, n, o, s) {
  const l = [t, n, ...o];
  [].forEach.call(e.children, (u) => {
    const p = l.indexOf(u) === -1, h = !SZ(u);
    p && h && Ob(u, s);
  });
}
function QP(e, t) {
  let n = -1;
  return e.some((o, s) => t(o) ? (n = s, !0) : !1), n;
}
function CZ(e, t) {
  const n = [], o = e.container;
  if (!t.disableScrollLock) {
    if (xZ(o)) {
      const u = nB(no(o));
      n.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${gL(o) + u}px`;
      const p = no(o).querySelectorAll(".mui-fixed");
      [].forEach.call(p, (h) => {
        n.push({
          value: h.style.paddingRight,
          property: "padding-right",
          el: h
        }), h.style.paddingRight = `${gL(h) + u}px`;
      });
    }
    let l;
    if (o.parentNode instanceof DocumentFragment)
      l = no(o).body;
    else {
      const u = o.parentElement, p = us(o);
      l = (u == null ? void 0 : u.nodeName) === "HTML" && p.getComputedStyle(u).overflowY === "scroll" ? u : o;
    }
    n.push({
      value: l.style.overflow,
      property: "overflow",
      el: l
    }, {
      value: l.style.overflowX,
      property: "overflow-x",
      el: l
    }, {
      value: l.style.overflowY,
      property: "overflow-y",
      el: l
    }), l.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: l,
      el: u,
      property: p
    }) => {
      l ? u.style.setProperty(p, l) : u.style.removeProperty(p);
    });
  };
}
function wZ(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class TZ {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && Ob(t.modalRef, !1);
    const s = wZ(n);
    yL(n, t.mount, t.modalRef, s, !0);
    const l = QP(this.containers, (u) => u.container === n);
    return l !== -1 ? (this.containers[l].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: s
    }), o);
  }
  mount(t, n) {
    const o = QP(this.containers, (l) => l.modals.indexOf(t) !== -1), s = this.containers[o];
    s.restore || (s.restore = CZ(s, n));
  }
  remove(t, n = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const s = QP(this.containers, (u) => u.modals.indexOf(t) !== -1), l = this.containers[s];
    if (l.modals.splice(l.modals.indexOf(t), 1), this.modals.splice(o, 1), l.modals.length === 0)
      l.restore && l.restore(), t.modalRef && Ob(t.modalRef, n), yL(l.container, t.mount, t.modalRef, l.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const u = l.modals[l.modals.length - 1];
      u.modalRef && Ob(u.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function EZ(e) {
  return typeof e == "function" ? e() : e;
}
function RZ(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const OZ = new TZ();
function PZ(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: o = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = OZ,
    closeAfterTransition: l = !1,
    onTransitionEnter: u,
    onTransitionExited: p,
    children: h,
    onClose: m,
    open: b,
    rootRef: x
  } = e, S = D.useRef({}), R = D.useRef(null), T = D.useRef(null), E = Gn(T, x), [P, k] = D.useState(!b), _ = RZ(h);
  let L = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (L = !1);
  const F = () => no(R.current), N = () => (S.current.modalRef = T.current, S.current.mount = R.current, S.current), V = () => {
    s.mount(N(), {
      disableScrollLock: o
    }), T.current && (T.current.scrollTop = 0);
  }, z = qo(() => {
    const Z = EZ(t) || F().body;
    s.add(N(), Z), T.current && V();
  }), H = D.useCallback(() => s.isTopModal(N()), [s]), ee = qo((Z) => {
    R.current = Z, Z && (b && H() ? V() : T.current && Ob(T.current, L));
  }), K = D.useCallback(() => {
    s.remove(N(), L);
  }, [L, s]);
  D.useEffect(() => () => {
    K();
  }, [K]), D.useEffect(() => {
    b ? z() : (!_ || !l) && K();
  }, [b, K, _, l, z]);
  const X = (Z) => (ae) => {
    var U;
    (U = Z.onKeyDown) == null || U.call(Z, ae), !(ae.key !== "Escape" || ae.which === 229 || // Wait until IME is settled.
    !H()) && (n || (ae.stopPropagation(), m && m(ae, "escapeKeyDown")));
  }, ne = (Z) => (ae) => {
    var U;
    (U = Z.onClick) == null || U.call(Z, ae), ae.target === ae.currentTarget && m && m(ae, "backdropClick");
  };
  return {
    getRootProps: (Z = {}) => {
      const ae = BB(e);
      delete ae.onTransitionEnter, delete ae.onTransitionExited;
      const U = O({}, ae, Z);
      return O({
        role: "presentation"
      }, U, {
        onKeyDown: X(U),
        ref: E
      });
    },
    getBackdropProps: (Z = {}) => {
      const ae = Z;
      return O({
        "aria-hidden": !0
      }, ae, {
        onClick: ne(ae),
        open: b
      });
    },
    getTransitionProps: () => {
      const Z = () => {
        k(!1), u && u();
      }, ae = () => {
        k(!0), p && p(), l && K();
      };
      return {
        onEnter: F1(Z, h == null ? void 0 : h.props.onEnter),
        onExited: F1(ae, h == null ? void 0 : h.props.onExited)
      };
    },
    rootRef: E,
    portalRef: ee,
    isTopModal: H,
    exited: P,
    hasTransition: _
  };
}
const $Z = ["onChange", "maxRows", "minRows", "style", "value"];
function i1(e) {
  return parseInt(e, 10) || 0;
}
const DZ = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function bL(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflow;
}
const lz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    onChange: o,
    maxRows: s,
    minRows: l = 1,
    style: u,
    value: p
  } = t, h = Te(t, $Z), {
    current: m
  } = D.useRef(p != null), b = D.useRef(null), x = Gn(n, b), S = D.useRef(null), R = D.useRef(0), [T, E] = D.useState({
    outerHeightStyle: 0
  }), P = D.useCallback(() => {
    const F = b.current, V = us(F).getComputedStyle(F);
    if (V.width === "0px")
      return {
        outerHeightStyle: 0
      };
    const z = S.current;
    z.style.width = V.width, z.value = F.value || t.placeholder || "x", z.value.slice(-1) === `
` && (z.value += " ");
    const H = V.boxSizing, ee = i1(V.paddingBottom) + i1(V.paddingTop), K = i1(V.borderBottomWidth) + i1(V.borderTopWidth), X = z.scrollHeight;
    z.value = "x";
    const ne = z.scrollHeight;
    let Y = X;
    l && (Y = Math.max(Number(l) * ne, Y)), s && (Y = Math.min(Number(s) * ne, Y)), Y = Math.max(Y, ne);
    const J = Y + (H === "border-box" ? ee + K : 0), te = Math.abs(Y - X) <= 1;
    return {
      outerHeightStyle: J,
      overflow: te
    };
  }, [s, l, t.placeholder]), k = (F, N) => {
    const {
      outerHeightStyle: V,
      overflow: z
    } = N;
    return R.current < 20 && (V > 0 && Math.abs((F.outerHeightStyle || 0) - V) > 1 || F.overflow !== z) ? (R.current += 1, {
      overflow: z,
      outerHeightStyle: V
    }) : (process.env.NODE_ENV !== "production" && R.current === 20 && console.error(["MUI: Too many re-renders. The layout is unstable.", "TextareaAutosize limits the number of renders to prevent an infinite loop."].join(`
`)), F);
  }, _ = D.useCallback(() => {
    const F = P();
    bL(F) || E((N) => k(N, F));
  }, [P]);
  $a(() => {
    const F = () => {
      const ne = P();
      bL(ne) || Ww.flushSync(() => {
        E((Y) => k(Y, ne));
      });
    }, N = () => {
      R.current = 0, F();
    };
    let V;
    const z = () => {
      cancelAnimationFrame(V), V = requestAnimationFrame(() => {
        N();
      });
    }, H = bv(N), ee = b.current, K = us(ee);
    K.addEventListener("resize", H);
    let X;
    return typeof ResizeObserver < "u" && (X = new ResizeObserver(process.env.NODE_ENV === "test" ? z : N), X.observe(ee)), () => {
      H.clear(), cancelAnimationFrame(V), K.removeEventListener("resize", H), X && X.disconnect();
    };
  }, [P]), $a(() => {
    _();
  }), D.useEffect(() => {
    R.current = 0;
  }, [p]);
  const L = (F) => {
    R.current = 0, m || _(), o && o(F);
  };
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ I("textarea", O({
      value: p,
      onChange: L,
      ref: x,
      rows: l,
      style: O({
        height: T.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: T.overflow ? "hidden" : void 0
      }, u)
    }, h)), /* @__PURE__ */ I("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: S,
      tabIndex: -1,
      style: O({}, DZ.shadow, u, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (lz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  onChange: r.func,
  /**
   * @ignore
   */
  placeholder: r.string,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * @ignore
   */
  value: r.oneOfType([r.arrayOf(r.string), r.number, r.string])
});
function xL(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function kZ(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: o,
    matchFrom: s = "any",
    stringify: l,
    trim: u = !1
  } = e;
  return (p, {
    inputValue: h,
    getOptionLabel: m
  }) => {
    let b = u ? h.trim() : h;
    n && (b = b.toLowerCase()), t && (b = xL(b));
    const x = b ? p.filter((S) => {
      let R = (l || m)(S);
      return n && (R = R.toLowerCase()), t && (R = xL(R)), s === "start" ? R.indexOf(b) === 0 : R.indexOf(b) > -1;
    }) : p;
    return typeof o == "number" ? x.slice(0, o) : x;
  };
}
function JP(e, t) {
  for (let n = 0; n < e.length; n += 1)
    if (t(e[n]))
      return n;
  return -1;
}
const MZ = kZ(), SL = 5, NZ = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
};
function IZ(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = NZ,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: o = !1,
    autoHighlight: s = !1,
    autoSelect: l = !1,
    blurOnSelect: u = !1,
    clearOnBlur: p = !e.freeSolo,
    clearOnEscape: h = !1,
    componentName: m = "useAutocomplete",
    defaultValue: b = e.multiple ? [] : null,
    disableClearable: x = !1,
    disableCloseOnSelect: S = !1,
    disabled: R,
    disabledItemsFocusable: T = !1,
    disableListWrap: E = !1,
    filterOptions: P = MZ,
    filterSelectedOptions: k = !1,
    freeSolo: _ = !1,
    getOptionDisabled: L,
    getOptionKey: F,
    getOptionLabel: N = (ze) => {
      var Pe;
      return (Pe = ze.label) != null ? Pe : ze;
    },
    groupBy: V,
    handleHomeEndKeys: z = !e.freeSolo,
    id: H,
    includeInputInList: ee = !1,
    inputValue: K,
    isOptionEqualToValue: X = (ze, Pe) => ze === Pe,
    multiple: ne = !1,
    onChange: Y,
    onClose: J,
    onHighlightChange: te,
    onInputChange: Z,
    onOpen: ae,
    open: U,
    openOnFocus: G = !1,
    options: W,
    readOnly: le = !1,
    selectOnFocus: pe = !e.freeSolo,
    value: ge
  } = e, we = Vc(H);
  let de = N;
  de = (ze) => {
    const Pe = N(ze);
    if (typeof Pe != "string") {
      if (process.env.NODE_ENV !== "production") {
        const tt = Pe === void 0 ? "undefined" : `${typeof Pe} (${Pe})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${m} returned ${tt} instead of a string for ${JSON.stringify(ze)}.`);
      }
      return String(Pe);
    }
    return Pe;
  };
  const se = D.useRef(!1), ve = D.useRef(!0), me = D.useRef(null), Oe = D.useRef(null), [be, De] = D.useState(null), [ie, fe] = D.useState(-1), ye = s ? 0 : -1, Ee = D.useRef(ye), [_e, Ve] = jl({
    controlled: ge,
    default: b,
    name: m
  }), [Re, lt] = jl({
    controlled: K,
    default: "",
    name: m,
    state: "inputValue"
  }), [Pt, at] = D.useState(!1), it = D.useCallback((ze, Pe) => {
    if (!(ne ? _e.length < Pe.length : Pe !== null) && !p)
      return;
    let mt;
    if (ne)
      mt = "";
    else if (Pe == null)
      mt = "";
    else {
      const cn = de(Pe);
      mt = typeof cn == "string" ? cn : "";
    }
    Re !== mt && (lt(mt), Z && Z(ze, mt, "reset"));
  }, [de, Re, ne, Z, lt, p, _e]), [bt, Nt] = jl({
    controlled: U,
    default: !1,
    name: m,
    state: "open"
  }), [en, fn] = D.useState(!0), ln = !ne && _e != null && Re === de(_e), Rt = bt && !le, rt = Rt ? P(
    W.filter((ze) => !(k && (ne ? _e : [_e]).some((Pe) => Pe !== null && X(ze, Pe)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: ln && en ? "" : Re,
      getOptionLabel: de
    }
  ) : [], Qt = CD({
    filteredOptions: rt,
    value: _e,
    inputValue: Re
  });
  D.useEffect(() => {
    const ze = _e !== Qt.value;
    Pt && !ze || _ && !ze || it(null, _e);
  }, [_e, it, Pt, Qt.value, _]);
  const et = bt && rt.length > 0 && !le;
  if (process.env.NODE_ENV !== "production" && _e !== null && !_ && W.length > 0) {
    const ze = (ne ? _e : [_e]).filter((Pe) => !W.some((tt) => X(tt, Pe)));
    ze.length > 0 && console.warn([`MUI: The value provided to ${m} is invalid.`, `None of the options match with \`${ze.length > 1 ? JSON.stringify(ze) : JSON.stringify(ze[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const st = qo((ze) => {
    ze === -1 ? me.current.focus() : be.querySelector(`[data-tag-index="${ze}"]`).focus();
  });
  D.useEffect(() => {
    ne && ie > _e.length - 1 && (fe(-1), st(-1));
  }, [_e, ne, ie, st]);
  function jt(ze, Pe) {
    if (!Oe.current || ze < 0 || ze >= rt.length)
      return -1;
    let tt = ze;
    for (; ; ) {
      const mt = Oe.current.querySelector(`[data-option-index="${tt}"]`), cn = T ? !1 : !mt || mt.disabled || mt.getAttribute("aria-disabled") === "true";
      if (mt && mt.hasAttribute("tabindex") && !cn)
        return tt;
      if (Pe === "next" ? tt = (tt + 1) % rt.length : tt = (tt - 1 + rt.length) % rt.length, tt === ze)
        return -1;
    }
  }
  const Xe = qo(({
    event: ze,
    index: Pe,
    reason: tt = "auto"
  }) => {
    if (Ee.current = Pe, Pe === -1 ? me.current.removeAttribute("aria-activedescendant") : me.current.setAttribute("aria-activedescendant", `${we}-option-${Pe}`), te && te(ze, Pe === -1 ? null : rt[Pe], tt), !Oe.current)
      return;
    const mt = Oe.current.querySelector(`[role="option"].${n}-focused`);
    mt && (mt.classList.remove(`${n}-focused`), mt.classList.remove(`${n}-focusVisible`));
    let cn = Oe.current;
    if (Oe.current.getAttribute("role") !== "listbox" && (cn = Oe.current.parentElement.querySelector('[role="listbox"]')), !cn)
      return;
    if (Pe === -1) {
      cn.scrollTop = 0;
      return;
    }
    const Rn = Oe.current.querySelector(`[data-option-index="${Pe}"]`);
    if (Rn && (Rn.classList.add(`${n}-focused`), tt === "keyboard" && Rn.classList.add(`${n}-focusVisible`), cn.scrollHeight > cn.clientHeight && tt !== "mouse" && tt !== "touch")) {
      const Qn = Rn, zt = cn.clientHeight + cn.scrollTop, Or = Qn.offsetTop + Qn.offsetHeight;
      Or > zt ? cn.scrollTop = Or - cn.clientHeight : Qn.offsetTop - Qn.offsetHeight * (V ? 1.3 : 0) < cn.scrollTop && (cn.scrollTop = Qn.offsetTop - Qn.offsetHeight * (V ? 1.3 : 0));
    }
  }), Be = qo(({
    event: ze,
    diff: Pe,
    direction: tt = "next",
    reason: mt = "auto"
  }) => {
    if (!Rt)
      return;
    const Rn = jt((() => {
      const Qn = rt.length - 1;
      if (Pe === "reset")
        return ye;
      if (Pe === "start")
        return 0;
      if (Pe === "end")
        return Qn;
      const zt = Ee.current + Pe;
      return zt < 0 ? zt === -1 && ee ? -1 : E && Ee.current !== -1 || Math.abs(Pe) > 1 ? 0 : Qn : zt > Qn ? zt === Qn + 1 && ee ? -1 : E || Math.abs(Pe) > 1 ? Qn : 0 : zt;
    })(), tt);
    if (Xe({
      index: Rn,
      reason: mt,
      event: ze
    }), o && Pe !== "reset")
      if (Rn === -1)
        me.current.value = Re;
      else {
        const Qn = de(rt[Rn]);
        me.current.value = Qn, Qn.toLowerCase().indexOf(Re.toLowerCase()) === 0 && Re.length > 0 && me.current.setSelectionRange(Re.length, Qn.length);
      }
  }), Qe = () => {
    const ze = (Pe, tt) => {
      const mt = Pe ? de(Pe) : "", cn = tt ? de(tt) : "";
      return mt === cn;
    };
    if (Ee.current !== -1 && Qt.filteredOptions && Qt.filteredOptions.length !== rt.length && Qt.inputValue === Re && (ne ? _e.length === Qt.value.length && Qt.value.every((Pe, tt) => de(_e[tt]) === de(Pe)) : ze(Qt.value, _e))) {
      const Pe = Qt.filteredOptions[Ee.current];
      if (Pe && rt.some((mt) => de(mt) === de(Pe)))
        return !0;
    }
    return !1;
  }, xt = D.useCallback(() => {
    if (!Rt || Qe())
      return;
    const ze = ne ? _e[0] : _e;
    if (rt.length === 0 || ze == null) {
      Be({
        diff: "reset"
      });
      return;
    }
    if (Oe.current) {
      if (ze != null) {
        const Pe = rt[Ee.current];
        if (ne && Pe && JP(_e, (mt) => X(Pe, mt)) !== -1)
          return;
        const tt = JP(rt, (mt) => X(mt, ze));
        tt === -1 ? Be({
          diff: "reset"
        }) : Xe({
          index: tt
        });
        return;
      }
      if (Ee.current >= rt.length - 1) {
        Xe({
          index: rt.length - 1
        });
        return;
      }
      Xe({
        index: Ee.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    rt.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ne ? !1 : _e,
    k,
    Be,
    Xe,
    Rt,
    Re,
    ne
  ]), ct = qo((ze) => {
    Fb(Oe, ze), ze && xt();
  });
  process.env.NODE_ENV !== "production" && D.useEffect(() => {
    (!me.current || me.current.nodeName !== "INPUT") && (me.current && me.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${m} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (e.g. enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${me.current} while an HTMLInputElement was expected.`, `Instead, ${m} expects an input element.`, "", m === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [m]), D.useEffect(() => {
    xt();
  }, [xt]);
  const St = (ze) => {
    bt || (Nt(!0), fn(!0), ae && ae(ze));
  }, tn = (ze, Pe) => {
    bt && (Nt(!1), J && J(ze, Pe));
  }, Wt = (ze, Pe, tt, mt) => {
    if (ne) {
      if (_e.length === Pe.length && _e.every((cn, Rn) => cn === Pe[Rn]))
        return;
    } else if (_e === Pe)
      return;
    Y && Y(ze, Pe, tt, mt), Ve(Pe);
  }, dn = D.useRef(!1), hr = (ze, Pe, tt = "selectOption", mt = "options") => {
    let cn = tt, Rn = Pe;
    if (ne) {
      if (Rn = Array.isArray(_e) ? _e.slice() : [], process.env.NODE_ENV !== "production") {
        const zt = Rn.filter((Or) => X(Pe, Or));
        zt.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${m} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${zt.length} matches.`].join(`
`));
      }
      const Qn = JP(Rn, (zt) => X(Pe, zt));
      Qn === -1 ? Rn.push(Pe) : mt !== "freeSolo" && (Rn.splice(Qn, 1), cn = "removeOption");
    }
    it(ze, Rn), Wt(ze, Rn, cn, {
      option: Pe
    }), !S && (!ze || !ze.ctrlKey && !ze.metaKey) && tn(ze, cn), (u === !0 || u === "touch" && dn.current || u === "mouse" && !dn.current) && me.current.blur();
  };
  function yo(ze, Pe) {
    if (ze === -1)
      return -1;
    let tt = ze;
    for (; ; ) {
      if (Pe === "next" && tt === _e.length || Pe === "previous" && tt === -1)
        return -1;
      const mt = be.querySelector(`[data-tag-index="${tt}"]`);
      if (!mt || !mt.hasAttribute("tabindex") || mt.disabled || mt.getAttribute("aria-disabled") === "true")
        tt += Pe === "next" ? 1 : -1;
      else
        return tt;
    }
  }
  const ka = (ze, Pe) => {
    if (!ne)
      return;
    Re === "" && tn(ze, "toggleInput");
    let tt = ie;
    ie === -1 ? Re === "" && Pe === "previous" && (tt = _e.length - 1) : (tt += Pe === "next" ? 1 : -1, tt < 0 && (tt = 0), tt === _e.length && (tt = -1)), tt = yo(tt, Pe), fe(tt), st(tt);
  }, Vi = (ze) => {
    se.current = !0, lt(""), Z && Z(ze, "", "clear"), Wt(ze, ne ? [] : null, "clear");
  }, ys = (ze) => (Pe) => {
    if (ze.onKeyDown && ze.onKeyDown(Pe), !Pe.defaultMuiPrevented && (ie !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(Pe.key) === -1 && (fe(-1), st(-1)), Pe.which !== 229))
      switch (Pe.key) {
        case "Home":
          Rt && z && (Pe.preventDefault(), Be({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Pe
          }));
          break;
        case "End":
          Rt && z && (Pe.preventDefault(), Be({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }));
          break;
        case "PageUp":
          Pe.preventDefault(), Be({
            diff: -SL,
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }), St(Pe);
          break;
        case "PageDown":
          Pe.preventDefault(), Be({
            diff: SL,
            direction: "next",
            reason: "keyboard",
            event: Pe
          }), St(Pe);
          break;
        case "ArrowDown":
          Pe.preventDefault(), Be({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Pe
          }), St(Pe);
          break;
        case "ArrowUp":
          Pe.preventDefault(), Be({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Pe
          }), St(Pe);
          break;
        case "ArrowLeft":
          ka(Pe, "previous");
          break;
        case "ArrowRight":
          ka(Pe, "next");
          break;
        case "Enter":
          if (Ee.current !== -1 && Rt) {
            const tt = rt[Ee.current], mt = L ? L(tt) : !1;
            if (Pe.preventDefault(), mt)
              return;
            hr(Pe, tt, "selectOption"), o && me.current.setSelectionRange(me.current.value.length, me.current.value.length);
          } else _ && Re !== "" && ln === !1 && (ne && Pe.preventDefault(), hr(Pe, Re, "createOption", "freeSolo"));
          break;
        case "Escape":
          Rt ? (Pe.preventDefault(), Pe.stopPropagation(), tn(Pe, "escape")) : h && (Re !== "" || ne && _e.length > 0) && (Pe.preventDefault(), Pe.stopPropagation(), Vi(Pe));
          break;
        case "Backspace":
          if (ne && !le && Re === "" && _e.length > 0) {
            const tt = ie === -1 ? _e.length - 1 : ie, mt = _e.slice();
            mt.splice(tt, 1), Wt(Pe, mt, "removeOption", {
              option: _e[tt]
            });
          }
          break;
        case "Delete":
          if (ne && !le && Re === "" && _e.length > 0 && ie !== -1) {
            const tt = ie, mt = _e.slice();
            mt.splice(tt, 1), Wt(Pe, mt, "removeOption", {
              option: _e[tt]
            });
          }
          break;
      }
  }, bs = (ze) => {
    at(!0), G && !se.current && St(ze);
  }, Ma = (ze) => {
    if (t(Oe)) {
      me.current.focus();
      return;
    }
    at(!1), ve.current = !0, se.current = !1, l && Ee.current !== -1 && Rt ? hr(ze, rt[Ee.current], "blur") : l && _ && Re !== "" ? hr(ze, Re, "blur", "freeSolo") : p && it(ze, _e), tn(ze, "blur");
  }, rr = (ze) => {
    const Pe = ze.target.value;
    Re !== Pe && (lt(Pe), fn(!1), Z && Z(ze, Pe, "input")), Pe === "" ? !x && !ne && Wt(ze, null, "clear") : St(ze);
  }, Wn = (ze) => {
    const Pe = Number(ze.currentTarget.getAttribute("data-option-index"));
    Ee.current !== Pe && Xe({
      event: ze,
      index: Pe,
      reason: "mouse"
    });
  }, Cr = (ze) => {
    Xe({
      event: ze,
      index: Number(ze.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), dn.current = !0;
  }, ko = (ze) => {
    const Pe = Number(ze.currentTarget.getAttribute("data-option-index"));
    hr(ze, rt[Pe], "selectOption"), dn.current = !1;
  }, Lr = (ze) => (Pe) => {
    const tt = _e.slice();
    tt.splice(ze, 1), Wt(Pe, tt, "removeOption", {
      option: _e[ze]
    });
  }, Kn = (ze) => {
    bt ? tn(ze, "toggleInput") : St(ze);
  }, bo = (ze) => {
    ze.currentTarget.contains(ze.target) && ze.target.getAttribute("id") !== we && ze.preventDefault();
  }, Na = (ze) => {
    ze.currentTarget.contains(ze.target) && (me.current.focus(), pe && ve.current && me.current.selectionEnd - me.current.selectionStart === 0 && me.current.select(), ve.current = !1);
  }, Mo = (ze) => {
    !R && (Re === "" || !bt) && Kn(ze);
  };
  let No = _ && Re.length > 0;
  No = No || (ne ? _e.length > 0 : _e !== null);
  let xo = rt;
  if (V) {
    const ze = /* @__PURE__ */ new Map();
    let Pe = !1;
    xo = rt.reduce((tt, mt, cn) => {
      const Rn = V(mt);
      return tt.length > 0 && tt[tt.length - 1].group === Rn ? tt[tt.length - 1].options.push(mt) : (process.env.NODE_ENV !== "production" && (ze.get(Rn) && !Pe && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${m} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Pe = !0), ze.set(Rn, !0)), tt.push({
        key: cn,
        index: cn,
        group: Rn,
        options: [mt]
      })), tt;
    }, []);
  }
  return R && Pt && Ma(), {
    getRootProps: (ze = {}) => O({
      "aria-owns": et ? `${we}-listbox` : null
    }, ze, {
      onKeyDown: ys(ze),
      onMouseDown: bo,
      onClick: Na
    }),
    getInputLabelProps: () => ({
      id: `${we}-label`,
      htmlFor: we
    }),
    getInputProps: () => ({
      id: we,
      value: Re,
      onBlur: Ma,
      onFocus: bs,
      onChange: rr,
      onMouseDown: Mo,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Rt ? "" : null,
      "aria-autocomplete": o ? "both" : "list",
      "aria-controls": et ? `${we}-listbox` : void 0,
      "aria-expanded": et,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: me,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: R
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Vi
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Kn
    }),
    getTagProps: ({
      index: ze
    }) => O({
      key: ze,
      "data-tag-index": ze,
      tabIndex: -1
    }, !le && {
      onDelete: Lr(ze)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${we}-listbox`,
      "aria-labelledby": `${we}-label`,
      ref: ct,
      onMouseDown: (ze) => {
        ze.preventDefault();
      }
    }),
    getOptionProps: ({
      index: ze,
      option: Pe
    }) => {
      var tt;
      const mt = (ne ? _e : [_e]).some((Rn) => Rn != null && X(Pe, Rn)), cn = L ? L(Pe) : !1;
      return {
        key: (tt = F == null ? void 0 : F(Pe)) != null ? tt : de(Pe),
        tabIndex: -1,
        role: "option",
        id: `${we}-option-${ze}`,
        onMouseMove: Wn,
        onClick: ko,
        onTouchStart: Cr,
        "data-option-index": ze,
        "aria-disabled": cn,
        "aria-selected": mt
      };
    },
    id: we,
    inputValue: Re,
    value: _e,
    dirty: No,
    expanded: Rt && be,
    popupOpen: Rt,
    focused: Pt || ie !== -1,
    anchorEl: be,
    setAnchorEl: De,
    focusedTag: ie,
    groupedOptions: xo
  };
}
const _Z = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], AZ = ce(sz, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ip = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const s = Fw(), l = We({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: u,
    component: p,
    components: h,
    componentsProps: m,
    container: b,
    disablePortal: x,
    keepMounted: S,
    modifiers: R,
    open: T,
    placement: E,
    popperOptions: P,
    popperRef: k,
    transition: _,
    slots: L,
    slotProps: F
  } = l, N = Te(l, _Z), V = (o = L == null ? void 0 : L.root) != null ? o : h == null ? void 0 : h.Root, z = O({
    anchorEl: u,
    container: b,
    disablePortal: x,
    keepMounted: S,
    modifiers: R,
    open: T,
    placement: E,
    popperOptions: P,
    popperRef: k,
    transition: _
  }, N);
  return /* @__PURE__ */ I(AZ, O({
    as: p,
    direction: s == null ? void 0 : s.direction,
    slots: {
      root: V
    },
    slotProps: F ?? m
  }, z, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (ip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: r.oneOfType([Hl, r.object, r.func]),
  /**
   * Popper render function or node.
   */
  children: r.oneOfType([r.node, r.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Hl, r.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: r.arrayOf(r.shape({
    data: r.object,
    effect: r.func,
    enabled: r.bool,
    fn: r.func,
    name: r.any,
    options: r.object,
    phase: r.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: r.arrayOf(r.string),
    requiresIfExists: r.arrayOf(r.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: r.shape({
    modifiers: r.array,
    onFirstUpdate: r.func,
    placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: r.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Yo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: r.bool
});
function LZ(e) {
  return pt("MuiListSubheader", e);
}
ht("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const FZ = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], jZ = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: o,
    inset: s,
    disableSticky: l
  } = e, u = {
    root: ["root", n !== "default" && `color${Ae(n)}`, !o && "gutters", s && "inset", !l && "sticky"]
  };
  return vt(u, LZ, t);
}, VZ = ce("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Ae(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), JD = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: s,
    color: l = "default",
    component: u = "li",
    disableGutters: p = !1,
    disableSticky: h = !1,
    inset: m = !1
  } = o, b = Te(o, FZ), x = O({}, o, {
    color: l,
    component: u,
    disableGutters: p,
    disableSticky: h,
    inset: m
  }), S = jZ(x);
  return /* @__PURE__ */ I(VZ, O({
    as: u,
    className: Ne(S.root, s),
    ref: n,
    ownerState: x
  }, b));
});
JD.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (JD.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: r.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: r.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const BZ = lr(/* @__PURE__ */ I("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function zZ(e) {
  return pt("MuiChip", e);
}
const Dn = ht("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), UZ = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], HZ = (e) => {
  const {
    classes: t,
    disabled: n,
    size: o,
    color: s,
    iconColor: l,
    onDelete: u,
    clickable: p,
    variant: h
  } = e, m = {
    root: ["root", h, n && "disabled", `size${Ae(o)}`, `color${Ae(s)}`, p && "clickable", p && `clickableColor${Ae(s)}`, u && "deletable", u && `deletableColor${Ae(s)}`, `${h}${Ae(s)}`],
    label: ["label", `label${Ae(o)}`],
    avatar: ["avatar", `avatar${Ae(o)}`, `avatarColor${Ae(s)}`],
    icon: ["icon", `icon${Ae(o)}`, `iconColor${Ae(l)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Ae(o)}`, `deleteIconColor${Ae(s)}`, `deleteIcon${Ae(h)}Color${Ae(s)}`]
  };
  return vt(m, zZ, t);
}, WZ = ce("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: o,
      iconColor: s,
      clickable: l,
      onDelete: u,
      size: p,
      variant: h
    } = n;
    return [{
      [`& .${Dn.avatar}`]: t.avatar
    }, {
      [`& .${Dn.avatar}`]: t[`avatar${Ae(p)}`]
    }, {
      [`& .${Dn.avatar}`]: t[`avatarColor${Ae(o)}`]
    }, {
      [`& .${Dn.icon}`]: t.icon
    }, {
      [`& .${Dn.icon}`]: t[`icon${Ae(p)}`]
    }, {
      [`& .${Dn.icon}`]: t[`iconColor${Ae(s)}`]
    }, {
      [`& .${Dn.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Dn.deleteIcon}`]: t[`deleteIcon${Ae(p)}`]
    }, {
      [`& .${Dn.deleteIcon}`]: t[`deleteIconColor${Ae(o)}`]
    }, {
      [`& .${Dn.deleteIcon}`]: t[`deleteIcon${Ae(h)}Color${Ae(o)}`]
    }, t.root, t[`size${Ae(p)}`], t[`color${Ae(o)}`], l && t.clickable, l && o !== "default" && t[`clickableColor${Ae(o)})`], u && t.deletable, u && o !== "default" && t[`deletableColor${Ae(o)}`], t[h], t[`${h}${Ae(o)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return O({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Dn.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Dn.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Dn.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Dn.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Dn.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Dn.icon}`]: O({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && O({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${Dn.deleteIcon}`]: O({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Mt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Mt(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : Mt(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${Dn.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${Dn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => O({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${Dn.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${Dn.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => O({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${Dn.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Dn.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${Dn.avatar}`]: {
    marginLeft: 4
  },
  [`& .${Dn.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${Dn.icon}`]: {
    marginLeft: 4
  },
  [`& .${Dn.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${Dn.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${Dn.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Mt(e.palette[t.color].main, 0.7)}`,
  [`&.${Dn.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${Dn.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Mt(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${Dn.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Mt(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), qZ = ce("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: o
    } = n;
    return [t.label, t[`label${Ae(o)}`]];
  }
})(({
  ownerState: e
}) => O({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function CL(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const ZD = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiChip"
  }), {
    avatar: s,
    className: l,
    clickable: u,
    color: p = "default",
    component: h,
    deleteIcon: m,
    disabled: b = !1,
    icon: x,
    label: S,
    onClick: R,
    onDelete: T,
    onKeyDown: E,
    onKeyUp: P,
    size: k = "medium",
    variant: _ = "filled",
    tabIndex: L,
    skipFocusWhenDisabled: F = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = o, N = Te(o, UZ), V = D.useRef(null), z = Gn(V, n), H = (G) => {
    G.stopPropagation(), T && T(G);
  }, ee = (G) => {
    G.currentTarget === G.target && CL(G) && G.preventDefault(), E && E(G);
  }, K = (G) => {
    G.currentTarget === G.target && (T && CL(G) ? T(G) : G.key === "Escape" && V.current && V.current.blur()), P && P(G);
  }, X = u !== !1 && R ? !0 : u, ne = X || T ? ui : h || "div", Y = O({}, o, {
    component: ne,
    disabled: b,
    size: k,
    color: p,
    iconColor: /* @__PURE__ */ D.isValidElement(x) && x.props.color || p,
    onDelete: !!T,
    clickable: X,
    variant: _
  }), J = HZ(Y), te = ne === ui ? O({
    component: h || "div",
    focusVisibleClassName: J.focusVisible
  }, T && {
    disableRipple: !0
  }) : {};
  let Z = null;
  T && (Z = m && /* @__PURE__ */ D.isValidElement(m) ? /* @__PURE__ */ D.cloneElement(m, {
    className: Ne(m.props.className, J.deleteIcon),
    onClick: H
  }) : /* @__PURE__ */ I(BZ, {
    className: Ne(J.deleteIcon),
    onClick: H
  }));
  let ae = null;
  s && /* @__PURE__ */ D.isValidElement(s) && (ae = /* @__PURE__ */ D.cloneElement(s, {
    className: Ne(J.avatar, s.props.className)
  }));
  let U = null;
  return x && /* @__PURE__ */ D.isValidElement(x) && (U = /* @__PURE__ */ D.cloneElement(x, {
    className: Ne(J.icon, x.props.className)
  })), process.env.NODE_ENV !== "production" && ae && U && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ qe(WZ, O({
    as: ne,
    className: Ne(J.root, l),
    disabled: X && b ? !0 : void 0,
    onClick: R,
    onKeyDown: ee,
    onKeyUp: K,
    ref: z,
    tabIndex: F && b ? -1 : L,
    ownerState: Y
  }, te, N, {
    children: [ae || U, /* @__PURE__ */ I(qZ, {
      className: Ne(J.label),
      ownerState: Y,
      children: S
    }), Z]
  }));
});
process.env.NODE_ENV !== "production" && (ZD.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: r.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: SD,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: r.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Icon element.
   */
  icon: r.element,
  /**
   * The content of the component.
   */
  label: r.node,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @ignore
   */
  tabIndex: r.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined"]), r.string])
});
function Sd({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((o, s) => (o[s] = e[s], n && typeof e[s] > "u" && (o[s] = n[s]), o), {});
}
const y0 = /* @__PURE__ */ D.createContext(void 0);
process.env.NODE_ENV !== "production" && (y0.displayName = "FormControlContext");
function mi() {
  return D.useContext(y0);
}
function cz(e) {
  return /* @__PURE__ */ I($B, O({}, e, {
    defaultTheme: Hw,
    themeId: Xf
  }));
}
process.env.NODE_ENV !== "production" && (cz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: r.oneOfType([r.array, r.func, r.number, r.object, r.string, r.bool])
});
function wL(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function K1(e, t = !1) {
  return e && (wL(e.value) && e.value !== "" || t && wL(e.defaultValue) && e.defaultValue !== "");
}
function YZ(e) {
  return e.startAdornment;
}
function GZ(e) {
  return pt("MuiInputBase", e);
}
const ki = ht("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), KZ = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], Kw = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Ae(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, Xw = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, XZ = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    error: s,
    endAdornment: l,
    focused: u,
    formControl: p,
    fullWidth: h,
    hiddenLabel: m,
    multiline: b,
    readOnly: x,
    size: S,
    startAdornment: R,
    type: T
  } = e, E = {
    root: ["root", `color${Ae(n)}`, o && "disabled", s && "error", h && "fullWidth", u && "focused", p && "formControl", S && S !== "medium" && `size${Ae(S)}`, b && "multiline", R && "adornedStart", l && "adornedEnd", m && "hiddenLabel", x && "readOnly"],
    input: ["input", o && "disabled", T === "search" && "inputTypeSearch", b && "inputMultiline", S === "small" && "inputSizeSmall", m && "inputHiddenLabel", R && "inputAdornedStart", l && "inputAdornedEnd", x && "readOnly"]
  };
  return vt(E, GZ, t);
}, Qw = ce("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Kw
})(({
  theme: e,
  ownerState: t
}) => O({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${ki.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && O({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), Jw = ce("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Xw
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", o = O({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), s = {
    opacity: "0 !important"
  }, l = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return O({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": o,
    "&::-moz-placeholder": o,
    // Firefox 19+
    "&:-ms-input-placeholder": o,
    // IE11
    "&::-ms-input-placeholder": o,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${ki.formControl} &`]: {
      "&::-webkit-input-placeholder": s,
      "&::-moz-placeholder": s,
      // Firefox 19+
      "&:-ms-input-placeholder": s,
      // IE11
      "&::-ms-input-placeholder": s,
      // Edge
      "&:focus::-webkit-input-placeholder": l,
      "&:focus::-moz-placeholder": l,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": l,
      // IE11
      "&:focus::-ms-input-placeholder": l
      // Edge
    },
    [`&.${ki.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), QZ = /* @__PURE__ */ I(cz, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), uz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const s = We({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": l,
    autoComplete: u,
    autoFocus: p,
    className: h,
    components: m = {},
    componentsProps: b = {},
    defaultValue: x,
    disabled: S,
    disableInjectingGlobalStyles: R,
    endAdornment: T,
    fullWidth: E = !1,
    id: P,
    inputComponent: k = "input",
    inputProps: _ = {},
    inputRef: L,
    maxRows: F,
    minRows: N,
    multiline: V = !1,
    name: z,
    onBlur: H,
    onChange: ee,
    onClick: K,
    onFocus: X,
    onKeyDown: ne,
    onKeyUp: Y,
    placeholder: J,
    readOnly: te,
    renderSuffix: Z,
    rows: ae,
    slotProps: U = {},
    slots: G = {},
    startAdornment: W,
    type: le = "text",
    value: pe
  } = s, ge = Te(s, KZ), we = _.value != null ? _.value : pe, {
    current: de
  } = D.useRef(we != null), se = D.useRef(), ve = D.useCallback((Rt) => {
    process.env.NODE_ENV !== "production" && Rt && Rt.nodeName !== "INPUT" && !Rt.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), me = Gn(se, L, _.ref, ve), [Oe, be] = D.useState(!1), De = mi();
  process.env.NODE_ENV !== "production" && D.useEffect(() => {
    if (De)
      return De.registerEffect();
  }, [De]);
  const ie = Sd({
    props: s,
    muiFormControl: De,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  ie.focused = De ? De.focused : Oe, D.useEffect(() => {
    !De && S && Oe && (be(!1), H && H());
  }, [De, S, Oe, H]);
  const fe = De && De.onFilled, ye = De && De.onEmpty, Ee = D.useCallback((Rt) => {
    K1(Rt) ? fe && fe() : ye && ye();
  }, [fe, ye]);
  $a(() => {
    de && Ee({
      value: we
    });
  }, [we, Ee, de]);
  const _e = (Rt) => {
    if (ie.disabled) {
      Rt.stopPropagation();
      return;
    }
    X && X(Rt), _.onFocus && _.onFocus(Rt), De && De.onFocus ? De.onFocus(Rt) : be(!0);
  }, Ve = (Rt) => {
    H && H(Rt), _.onBlur && _.onBlur(Rt), De && De.onBlur ? De.onBlur(Rt) : be(!1);
  }, Re = (Rt, ...rt) => {
    if (!de) {
      const Qt = Rt.target || se.current;
      if (Qt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : dd(1));
      Ee({
        value: Qt.value
      });
    }
    _.onChange && _.onChange(Rt, ...rt), ee && ee(Rt, ...rt);
  };
  D.useEffect(() => {
    Ee(se.current);
  }, []);
  const lt = (Rt) => {
    se.current && Rt.currentTarget === Rt.target && se.current.focus(), K && K(Rt);
  };
  let Pt = k, at = _;
  V && Pt === "input" && (ae ? (process.env.NODE_ENV !== "production" && (N || F) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), at = O({
    type: void 0,
    minRows: ae,
    maxRows: ae
  }, at)) : at = O({
    type: void 0,
    maxRows: F,
    minRows: N
  }, at), Pt = lz);
  const it = (Rt) => {
    Ee(Rt.animationName === "mui-auto-fill-cancel" ? se.current : {
      value: "x"
    });
  };
  D.useEffect(() => {
    De && De.setAdornedStart(!!W);
  }, [De, W]);
  const bt = O({}, s, {
    color: ie.color || "primary",
    disabled: ie.disabled,
    endAdornment: T,
    error: ie.error,
    focused: ie.focused,
    formControl: De,
    fullWidth: E,
    hiddenLabel: ie.hiddenLabel,
    multiline: V,
    size: ie.size,
    startAdornment: W,
    type: le
  }), Nt = XZ(bt), en = G.root || m.Root || Qw, fn = U.root || b.root || {}, ln = G.input || m.Input || Jw;
  return at = O({}, at, (o = U.input) != null ? o : b.input), /* @__PURE__ */ qe(D.Fragment, {
    children: [!R && QZ, /* @__PURE__ */ qe(en, O({}, fn, !Zf(en) && {
      ownerState: O({}, bt, fn.ownerState)
    }, {
      ref: n,
      onClick: lt
    }, ge, {
      className: Ne(Nt.root, fn.className, h, te && "MuiInputBase-readOnly"),
      children: [W, /* @__PURE__ */ I(y0.Provider, {
        value: null,
        children: /* @__PURE__ */ I(ln, O({
          ownerState: bt,
          "aria-invalid": ie.error,
          "aria-describedby": l,
          autoComplete: u,
          autoFocus: p,
          defaultValue: x,
          disabled: ie.disabled,
          id: P,
          onAnimationStart: it,
          name: z,
          placeholder: J,
          readOnly: te,
          required: ie.required,
          rows: ae,
          value: we,
          onKeyDown: ne,
          onKeyUp: Y,
          type: le
        }, at, !Zf(ln) && {
          as: Pt,
          ownerState: O({}, bt, at.ownerState)
        }, {
          ref: me,
          className: Ne(Nt.input, at.className, te && "MuiInputBase-readOnly"),
          onBlur: Ve,
          onChange: Re,
          onFocus: _e
        }))
      }), T, Z ? Z(O({}, ie, {
        startAdornment: W
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (uz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": r.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: yv,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: r.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * @ignore
   */
  renderSuffix: r.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The size of the component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
const Zw = uz;
function JZ(e) {
  return pt("MuiInput", e);
}
const ad = O({}, ki, ht("MuiInput", ["root", "underline", "input"]));
function ZZ(e) {
  return pt("MuiOutlinedInput", e);
}
const Nl = O({}, ki, ht("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function eee(e) {
  return pt("MuiFilledInput", e);
}
const Mi = O({}, ki, ht("MuiFilledInput", ["root", "underline", "input"])), dz = lr(/* @__PURE__ */ I("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function tee(e) {
  return pt("MuiAutocomplete", e);
}
const bn = ht("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var TL, EL;
const nee = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], ree = ["ref"], oee = ["key"], aee = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: o,
    focused: s,
    fullWidth: l,
    hasClearIcon: u,
    hasPopupIcon: p,
    inputFocused: h,
    popupOpen: m,
    size: b
  } = e, x = {
    root: ["root", o && "expanded", s && "focused", l && "fullWidth", u && "hasClearIcon", p && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", h && "inputFocused"],
    tag: ["tag", `tagSize${Ae(b)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", m && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return vt(x, tee, t);
}, iee = ce("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: o,
      hasClearIcon: s,
      hasPopupIcon: l,
      inputFocused: u,
      size: p
    } = n;
    return [{
      [`& .${bn.tag}`]: t.tag
    }, {
      [`& .${bn.tag}`]: t[`tagSize${Ae(p)}`]
    }, {
      [`& .${bn.inputRoot}`]: t.inputRoot
    }, {
      [`& .${bn.input}`]: t.input
    }, {
      [`& .${bn.input}`]: u && t.inputFocused
    }, t.root, o && t.fullWidth, l && t.hasPopupIcon, s && t.hasClearIcon];
  }
})(({
  ownerState: e
}) => O({
  [`&.${bn.focused} .${bn.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${bn.clearIndicator}`]: {
      visibility: "visible"
    }
  }
}, e.fullWidth && {
  width: "100%"
}, {
  [`& .${bn.tag}`]: O({
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  }, e.size === "small" && {
    margin: 2,
    maxWidth: "calc(100% - 4px)"
  }),
  [`& .${bn.inputRoot}`]: {
    flexWrap: "wrap",
    [`.${bn.hasPopupIcon}&, .${bn.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${bn.hasPopupIcon}.${bn.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${bn.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${ad.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${ad.root}.${ki.sizeSmall}`]: {
    [`& .${ad.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Nl.root}`]: {
    padding: 9,
    [`.${bn.hasPopupIcon}&, .${bn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${bn.hasPopupIcon}.${bn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${bn.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${bn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Nl.root}.${ki.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${bn.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Mi.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${bn.hasPopupIcon}&, .${bn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${bn.hasPopupIcon}.${bn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Mi.input}`]: {
      padding: "7px 4px"
    },
    [`& .${bn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Mi.root}.${ki.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Mi.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${ki.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Mi.root}.${ki.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${bn.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Mi.root}.${ki.hiddenLabel}.${ki.sizeSmall}`]: {
    [`& .${bn.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${bn.input}`]: O({
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  }, e.inputFocused && {
    opacity: 1
  })
})), see = ce("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "calc(50% - 14px)"
  // Center vertically
}), lee = ce(oi, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), cee = ce(oi, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => O({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})(({
  ownerState: e
}) => O({
  padding: 2,
  marginRight: -2
}, e.popupOpen && {
  transform: "rotate(180deg)"
})), uee = ce(ip, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${bn.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  zIndex: (e.vars || e).zIndex.modal
}, t.disablePortal && {
  position: "absolute"
})), dee = ce(ms, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => O({}, e.typography.body1, {
  overflow: "auto"
})), fee = ce("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), pee = ce("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), hee = ce("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${bn.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${bn.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${bn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${bn.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${bn.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), mee = ce(JD, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), vee = ce("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${bn.option}`]: {
    paddingLeft: 24
  }
}), fz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u;
  const p = We({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: h = !1,
    autoHighlight: m = !1,
    autoSelect: b = !1,
    blurOnSelect: x = !1,
    ChipProps: S,
    className: R,
    clearIcon: T = TL || (TL = /* @__PURE__ */ I(BQ, {
      fontSize: "small"
    })),
    clearOnBlur: E = !p.freeSolo,
    clearOnEscape: P = !1,
    clearText: k = "Clear",
    closeText: _ = "Close",
    componentsProps: L = {},
    defaultValue: F = p.multiple ? [] : null,
    disableClearable: N = !1,
    disableCloseOnSelect: V = !1,
    disabled: z = !1,
    disabledItemsFocusable: H = !1,
    disableListWrap: ee = !1,
    disablePortal: K = !1,
    filterSelectedOptions: X = !1,
    forcePopupIcon: ne = "auto",
    freeSolo: Y = !1,
    fullWidth: J = !1,
    getLimitTagsText: te = (Pe) => `+${Pe}`,
    getOptionLabel: Z,
    groupBy: ae,
    handleHomeEndKeys: U = !p.freeSolo,
    includeInputInList: G = !1,
    limitTags: W = -1,
    ListboxComponent: le = "ul",
    ListboxProps: pe,
    loading: ge = !1,
    loadingText: we = "Loading…",
    multiple: de = !1,
    noOptionsText: se = "No options",
    openOnFocus: ve = !1,
    openText: me = "Open",
    PaperComponent: Oe = ms,
    PopperComponent: be = ip,
    popupIcon: De = EL || (EL = /* @__PURE__ */ I(dz, {})),
    readOnly: ie = !1,
    renderGroup: fe,
    renderInput: ye,
    renderOption: Ee,
    renderTags: _e,
    selectOnFocus: Ve = !p.freeSolo,
    size: Re = "medium",
    slotProps: lt = {}
  } = p, Pt = Te(p, nee), {
    getRootProps: at,
    getInputProps: it,
    getInputLabelProps: bt,
    getPopupIndicatorProps: Nt,
    getClearProps: en,
    getTagProps: fn,
    getListboxProps: ln,
    getOptionProps: Rt,
    value: rt,
    dirty: Qt,
    expanded: et,
    id: st,
    popupOpen: jt,
    focused: Xe,
    focusedTag: Be,
    anchorEl: Qe,
    setAnchorEl: xt,
    inputValue: ct,
    groupedOptions: St
  } = IZ(O({}, p, {
    componentName: "Autocomplete"
  })), tn = !N && !z && Qt && !ie, Wt = (!Y || ne === !0) && ne !== !1, {
    onMouseDown: dn
  } = it(), {
    ref: hr
  } = pe ?? {}, yo = ln(), {
    ref: ka
  } = yo, Vi = Te(yo, ree), ys = Gn(ka, hr), Ma = Z || ((Pe) => {
    var tt;
    return (tt = Pe.label) != null ? tt : Pe;
  }), rr = O({}, p, {
    disablePortal: K,
    expanded: et,
    focused: Xe,
    fullWidth: J,
    getOptionLabel: Ma,
    hasClearIcon: tn,
    hasPopupIcon: Wt,
    inputFocused: Be === -1,
    popupOpen: jt,
    size: Re
  }), Wn = aee(rr);
  let Cr;
  if (de && rt.length > 0) {
    const Pe = (tt) => O({
      className: Wn.tag,
      disabled: z
    }, fn(tt));
    _e ? Cr = _e(rt, Pe, rr) : Cr = rt.map((tt, mt) => /* @__PURE__ */ I(ZD, O({
      label: Ma(tt),
      size: Re
    }, Pe({
      index: mt
    }), S)));
  }
  if (W > -1 && Array.isArray(Cr)) {
    const Pe = Cr.length - W;
    !Xe && Pe > 0 && (Cr = Cr.splice(0, W), Cr.push(/* @__PURE__ */ I("span", {
      className: Wn.tag,
      children: te(Pe)
    }, Cr.length)));
  }
  const Lr = fe || ((Pe) => /* @__PURE__ */ qe("li", {
    children: [/* @__PURE__ */ I(mee, {
      className: Wn.groupLabel,
      ownerState: rr,
      component: "div",
      children: Pe.group
    }), /* @__PURE__ */ I(vee, {
      className: Wn.groupUl,
      ownerState: rr,
      children: Pe.children
    })]
  }, Pe.key)), bo = Ee || ((Pe, tt) => {
    const {
      key: mt
    } = Pe, cn = Te(Pe, oee);
    return /* @__PURE__ */ I("li", O({}, cn, {
      children: Ma(tt)
    }), mt);
  }), Na = (Pe, tt) => {
    const mt = Rt({
      option: Pe,
      index: tt
    });
    return bo(O({}, mt, {
      className: Wn.option
    }), Pe, {
      selected: mt["aria-selected"],
      index: tt,
      inputValue: ct
    }, rr);
  }, Mo = (o = lt.clearIndicator) != null ? o : L.clearIndicator, No = (s = lt.paper) != null ? s : L.paper, xo = (l = lt.popper) != null ? l : L.popper, ze = (u = lt.popupIndicator) != null ? u : L.popupIndicator;
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ I(iee, O({
      ref: n,
      className: Ne(Wn.root, R),
      ownerState: rr
    }, at(Pt), {
      children: ye({
        id: st,
        disabled: z,
        fullWidth: !0,
        size: Re === "small" ? "small" : void 0,
        InputLabelProps: bt(),
        InputProps: O({
          ref: xt,
          className: Wn.inputRoot,
          startAdornment: Cr,
          onClick: (Pe) => {
            Pe.target === Pe.currentTarget && dn(Pe);
          }
        }, (tn || Wt) && {
          endAdornment: /* @__PURE__ */ qe(see, {
            className: Wn.endAdornment,
            ownerState: rr,
            children: [tn ? /* @__PURE__ */ I(lee, O({}, en(), {
              "aria-label": k,
              title: k,
              ownerState: rr
            }, Mo, {
              className: Ne(Wn.clearIndicator, Mo == null ? void 0 : Mo.className),
              children: T
            })) : null, Wt ? /* @__PURE__ */ I(cee, O({}, Nt(), {
              disabled: z,
              "aria-label": jt ? _ : me,
              title: jt ? _ : me,
              ownerState: rr
            }, ze, {
              className: Ne(Wn.popupIndicator, ze == null ? void 0 : ze.className),
              children: De
            })) : null]
          })
        }),
        inputProps: O({
          className: Wn.input,
          disabled: z,
          readOnly: ie
        }, it())
      })
    })), Qe ? /* @__PURE__ */ I(uee, O({
      as: be,
      disablePortal: K,
      style: {
        width: Qe ? Qe.clientWidth : null
      },
      ownerState: rr,
      role: "presentation",
      anchorEl: Qe,
      open: jt
    }, xo, {
      className: Ne(Wn.popper, xo == null ? void 0 : xo.className),
      children: /* @__PURE__ */ qe(dee, O({
        ownerState: rr,
        as: Oe
      }, No, {
        className: Ne(Wn.paper, No == null ? void 0 : No.className),
        children: [ge && St.length === 0 ? /* @__PURE__ */ I(fee, {
          className: Wn.loading,
          ownerState: rr,
          children: we
        }) : null, St.length === 0 && !Y && !ge ? /* @__PURE__ */ I(pee, {
          className: Wn.noOptions,
          ownerState: rr,
          role: "presentation",
          onMouseDown: (Pe) => {
            Pe.preventDefault();
          },
          children: se
        }) : null, St.length > 0 ? /* @__PURE__ */ I(hee, O({
          as: le,
          className: Wn.listbox,
          ownerState: rr
        }, Vi, pe, {
          ref: ys,
          children: St.map((Pe, tt) => ae ? Lr({
            key: Pe.key,
            group: Pe.group,
            children: Pe.options.map((mt, cn) => Na(mt, Pe.index + cn))
          }) : Na(Pe, tt))
        })) : null]
      }))
    })) : null]
  });
});
process.env.NODE_ENV !== "production" && (fz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: r.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: r.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: r.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: r.oneOfType([r.oneOf(["mouse", "touch"]), r.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: r.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: r.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: r.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: r.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: r.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: r.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: r.shape({
    clearIndicator: r.object,
    paper: r.object,
    popper: r.object,
    popupIndicator: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: Pa(r.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: r.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: r.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: r.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: r.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: r.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: r.oneOfType([r.oneOf(["auto"]), r.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: r.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: r.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: r.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: r.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: r.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: r.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: r.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: r.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: r.bool,
  /**
   * The input value.
   */
  inputValue: r.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: r.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Lc,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: r.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: r.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, e.g. `options` are empty).
   * @default false
   */
  loading: r.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: r.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: r.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: r.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: r.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: r.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: r.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: r.string,
  /**
   * Array of options.
   */
  options: r.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: r.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: r.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: r.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: r.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: r.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: r.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: r.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: r.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: r.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium"]), r.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    clearIndicator: r.object,
    paper: r.object,
    popper: r.object,
    popupIndicator: r.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: Pa(r.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const gee = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], yee = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, sp = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = Go(), s = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: l,
    appear: u = !0,
    children: p,
    easing: h,
    in: m,
    onEnter: b,
    onEntered: x,
    onEntering: S,
    onExit: R,
    onExited: T,
    onExiting: E,
    style: P,
    timeout: k = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: _ = hi
  } = t, L = Te(t, gee), F = D.useRef(null), N = Gn(F, p.ref, n), V = (J) => (te) => {
    if (J) {
      const Z = F.current;
      te === void 0 ? J(Z) : J(Z, te);
    }
  }, z = V(S), H = V((J, te) => {
    UD(J);
    const Z = fd({
      style: P,
      timeout: k,
      easing: h
    }, {
      mode: "enter"
    });
    J.style.webkitTransition = o.transitions.create("opacity", Z), J.style.transition = o.transitions.create("opacity", Z), b && b(J, te);
  }), ee = V(x), K = V(E), X = V((J) => {
    const te = fd({
      style: P,
      timeout: k,
      easing: h
    }, {
      mode: "exit"
    });
    J.style.webkitTransition = o.transitions.create("opacity", te), J.style.transition = o.transitions.create("opacity", te), R && R(J);
  }), ne = V(T);
  return /* @__PURE__ */ I(_, O({
    appear: u,
    in: m,
    nodeRef: F,
    onEnter: H,
    onEntered: ee,
    onEntering: z,
    onExit: X,
    onExited: ne,
    onExiting: K,
    addEndListener: (J) => {
      l && l(F.current, J);
    },
    timeout: k
  }, L, {
    children: (J, te) => /* @__PURE__ */ D.cloneElement(p, O({
      style: O({
        opacity: 0,
        visibility: J === "exited" && !m ? "hidden" : void 0
      }, yee[J], P, p.props.style),
      ref: N
    }, te))
  }));
});
process.env.NODE_ENV !== "production" && (sp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: gd.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function bee(e) {
  return pt("MuiBackdrop", e);
}
ht("MuiBackdrop", ["root", "invisible"]);
const xee = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], See = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return vt({
    root: ["root", n && "invisible"]
  }, bee, t);
}, Cee = ce("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => O({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), ek = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l;
  const u = We({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: p,
    className: h,
    component: m = "div",
    components: b = {},
    componentsProps: x = {},
    invisible: S = !1,
    open: R,
    slotProps: T = {},
    slots: E = {},
    TransitionComponent: P = sp,
    transitionDuration: k
  } = u, _ = Te(u, xee), L = O({}, u, {
    component: m,
    invisible: S
  }), F = See(L), N = (o = T.root) != null ? o : x.root;
  return /* @__PURE__ */ I(P, O({
    in: R,
    timeout: k
  }, _, {
    children: /* @__PURE__ */ I(Cee, O({
      "aria-hidden": !0
    }, N, {
      as: (s = (l = E.root) != null ? l : b.Root) != null ? s : m,
      className: Ne(F.root, h, N == null ? void 0 : N.className),
      ownerState: O({}, L, N == null ? void 0 : N.ownerState),
      classes: F,
      ref: n,
      children: p
    }))
  }));
});
process.env.NODE_ENV !== "production" && (ek.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    root: r.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: r.bool,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: r.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function wee(e) {
  return We;
}
function Tee(e) {
  return pt("MuiBadge", e);
}
const td = ht("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), Eee = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], ZP = 10, e$ = 4, Ree = wee(), Oee = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: o,
    overlap: s,
    variant: l,
    classes: u = {}
  } = e, p = {
    root: ["root"],
    badge: ["badge", l, o && "invisible", `anchorOrigin${Ae(n.vertical)}${Ae(n.horizontal)}`, `anchorOrigin${Ae(n.vertical)}${Ae(n.horizontal)}${Ae(s)}`, `overlap${Ae(s)}`, t !== "default" && `color${Ae(t)}`]
  };
  return vt(p, Tee, u);
}, Pee = ce("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), $ee = ce("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${Ae(n.anchorOrigin.vertical)}${Ae(n.anchorOrigin.horizontal)}${Ae(n.overlap)}`], n.color !== "default" && t[`color${Ae(n.color)}`], n.invisible && t.invisible];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    fontFamily: e.typography.fontFamily,
    fontWeight: e.typography.fontWeightMedium,
    fontSize: e.typography.pxToRem(12),
    minWidth: ZP * 2,
    lineHeight: 1,
    padding: "0 6px",
    height: ZP * 2,
    borderRadius: ZP,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: e.transitions.create("transform", {
      easing: e.transitions.easing.easeInOut,
      duration: e.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var o, s;
      return ((o = e.vars) != null ? o : e).palette[n].main && ((s = e.vars) != null ? s : e).palette[n].contrastText;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText
      }
    })), {
      props: {
        variant: "dot"
      },
      style: {
        borderRadius: e$,
        height: e$ * 2,
        minWidth: e$ * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${td.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: {
        invisible: !0
      },
      style: {
        transition: e.transitions.create("transform", {
          easing: e.transitions.easing.easeInOut,
          duration: e.transitions.duration.leavingScreen
        })
      }
    }]
  };
}), pz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u, p, h;
  const m = Ree({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: b = {
      vertical: "top",
      horizontal: "right"
    },
    className: x,
    component: S,
    components: R = {},
    componentsProps: T = {},
    children: E,
    overlap: P = "rectangular",
    color: k = "default",
    invisible: _ = !1,
    max: L = 99,
    badgeContent: F,
    slots: N,
    slotProps: V,
    showZero: z = !1,
    variant: H = "standard"
  } = m, ee = Te(m, Eee), {
    badgeContent: K,
    invisible: X,
    max: ne,
    displayValue: Y
  } = GQ({
    max: L,
    invisible: _,
    badgeContent: F,
    showZero: z
  }), J = CD({
    anchorOrigin: b,
    color: k,
    overlap: P,
    variant: H,
    badgeContent: F
  }), te = X || K == null && H !== "dot", {
    color: Z = k,
    overlap: ae = P,
    anchorOrigin: U = b,
    variant: G = H
  } = te ? J : m, W = G !== "dot" ? Y : void 0, le = O({}, m, {
    badgeContent: K,
    invisible: te,
    max: ne,
    displayValue: W,
    showZero: z,
    anchorOrigin: U,
    color: Z,
    overlap: ae,
    variant: G
  }), pe = Oee(le), ge = (o = (s = N == null ? void 0 : N.root) != null ? s : R.Root) != null ? o : Pee, we = (l = (u = N == null ? void 0 : N.badge) != null ? u : R.Badge) != null ? l : $ee, de = (p = V == null ? void 0 : V.root) != null ? p : T.root, se = (h = V == null ? void 0 : V.badge) != null ? h : T.badge, ve = Li({
    elementType: ge,
    externalSlotProps: de,
    externalForwardedProps: ee,
    additionalProps: {
      ref: n,
      as: S
    },
    ownerState: le,
    className: Ne(de == null ? void 0 : de.className, pe.root, x)
  }), me = Li({
    elementType: we,
    externalSlotProps: se,
    ownerState: le,
    className: Ne(pe.badge, se == null ? void 0 : se.className)
  });
  return /* @__PURE__ */ qe(ge, O({}, ve, {
    children: [E, /* @__PURE__ */ I(we, O({}, me, {
      children: W
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (pz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: r.shape({
    horizontal: r.oneOf(["left", "right"]).isRequired,
    vertical: r.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: r.node,
  /**
   * The badge will be added relative to this node.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Badge: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    badge: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: r.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: r.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: r.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: r.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: r.shape({
    badge: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    badge: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: r.oneOfType([r.oneOf(["dot", "standard"]), r.string])
});
const Dee = ht("MuiBox", ["root"]), kee = jD(), hz = wK({
  themeId: Xf,
  defaultTheme: kee,
  defaultClassName: Dee.root,
  generateClassName: ww.generate
});
process.env.NODE_ENV !== "production" && (hz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Mee(e) {
  return pt("MuiButton", e);
}
const s1 = ht("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), tk = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (tk.displayName = "ButtonGroupContext");
const nk = /* @__PURE__ */ D.createContext(void 0);
process.env.NODE_ENV !== "production" && (nk.displayName = "ButtonGroupButtonContext");
const Nee = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], Iee = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: o,
    size: s,
    variant: l,
    classes: u
  } = e, p = {
    root: ["root", l, `${l}${Ae(t)}`, `size${Ae(s)}`, `${l}Size${Ae(s)}`, t === "inherit" && "colorInherit", n && "disableElevation", o && "fullWidth"],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${Ae(s)}`],
    endIcon: ["endIcon", `iconSize${Ae(s)}`]
  }, h = vt(p, Mee, u);
  return O({}, u, h);
}, mz = (e) => O({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), _ee = ce(ui, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Ae(n.color)}`], t[`size${Ae(n.size)}`], t[`${n.variant}Size${Ae(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, o;
  const s = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], l = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return O({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": O({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : l,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": O({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${s1.focusVisible}`]: O({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${s1.disabled}`]: O({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${Mt(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (o = e.palette).getContrastText) == null ? void 0 : n.call(o, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : s,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${s1.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${s1.disabled}`]: {
    boxShadow: "none"
  }
}), Aee = ce("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${Ae(n.size)}`]];
  }
})(({
  ownerState: e
}) => O({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, mz(e))), Lee = ce("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${Ae(n.size)}`]];
  }
})(({
  ownerState: e
}) => O({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, mz(e))), sd = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = D.useContext(tk), s = D.useContext(nk), l = wD(o, t), u = We({
    props: l,
    name: "MuiButton"
  }), {
    children: p,
    color: h = "primary",
    component: m = "button",
    className: b,
    disabled: x = !1,
    disableElevation: S = !1,
    disableFocusRipple: R = !1,
    endIcon: T,
    focusVisibleClassName: E,
    fullWidth: P = !1,
    size: k = "medium",
    startIcon: _,
    type: L,
    variant: F = "text"
  } = u, N = Te(u, Nee), V = O({}, u, {
    color: h,
    component: m,
    disabled: x,
    disableElevation: S,
    disableFocusRipple: R,
    fullWidth: P,
    size: k,
    type: L,
    variant: F
  }), z = Iee(V), H = _ && /* @__PURE__ */ I(Aee, {
    className: z.startIcon,
    ownerState: V,
    children: _
  }), ee = T && /* @__PURE__ */ I(Lee, {
    className: z.endIcon,
    ownerState: V,
    children: T
  }), K = s || "";
  return /* @__PURE__ */ qe(_ee, O({
    ownerState: V,
    className: Ne(o.className, z.root, b, K),
    component: m,
    disabled: x,
    focusRipple: !R,
    focusVisibleClassName: Ne(z.focusVisible, E),
    ref: n,
    type: L
  }, N, {
    classes: z,
    children: [H, p, ee]
  }));
});
process.env.NODE_ENV !== "production" && (sd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * Element placed after the children.
   */
  endIcon: r.node,
  /**
   * @ignore
   */
  focusVisibleClassName: r.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: r.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * Element placed before the children.
   */
  startIcon: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @ignore
   */
  type: r.oneOfType([r.oneOf(["button", "reset", "submit"]), r.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: r.oneOfType([r.oneOf(["contained", "outlined", "text"]), r.string])
});
function Fee(e) {
  return pt("MuiButtonGroup", e);
}
const Ho = ht("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), jee = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], Vee = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [{
    [`& .${Ho.grouped}`]: t.grouped
  }, {
    [`& .${Ho.grouped}`]: t[`grouped${Ae(n.orientation)}`]
  }, {
    [`& .${Ho.grouped}`]: t[`grouped${Ae(n.variant)}`]
  }, {
    [`& .${Ho.grouped}`]: t[`grouped${Ae(n.variant)}${Ae(n.orientation)}`]
  }, {
    [`& .${Ho.grouped}`]: t[`grouped${Ae(n.variant)}${Ae(n.color)}`]
  }, {
    [`& .${Ho.firstButton}`]: t.firstButton
  }, {
    [`& .${Ho.lastButton}`]: t.lastButton
  }, {
    [`& .${Ho.middleButton}`]: t.middleButton
  }, t.root, t[n.variant], n.disableElevation === !0 && t.disableElevation, n.fullWidth && t.fullWidth, n.orientation === "vertical" && t.vertical];
}, Bee = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    disableElevation: s,
    fullWidth: l,
    orientation: u,
    variant: p
  } = e, h = {
    root: ["root", p, u === "vertical" && "vertical", l && "fullWidth", s && "disableElevation"],
    grouped: ["grouped", `grouped${Ae(u)}`, `grouped${Ae(p)}`, `grouped${Ae(p)}${Ae(u)}`, `grouped${Ae(p)}${Ae(n)}`, o && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return vt(h, Fee, t);
}, zee = ce("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: Vee
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${Ho.grouped}`]: O({
    minWidth: 40,
    "&:hover": O({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  }),
  [`& .${Ho.firstButton},& .${Ho.middleButton}`]: O({}, t.orientation === "horizontal" && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, t.orientation === "vertical" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, t.variant === "text" && t.orientation === "horizontal" && {
    borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Ho.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.orientation === "vertical" && {
    borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Ho.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.color !== "inherit" && {
    borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : Mt(e.palette[t.color].main, 0.5)
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    borderRightColor: "transparent"
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    borderBottomColor: "transparent"
  }, t.variant === "contained" && t.orientation === "horizontal" && {
    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Ho.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.orientation === "vertical" && {
    borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Ho.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.color !== "inherit" && {
    borderColor: (e.vars || e).palette[t.color].dark
  }, {
    "&:hover": O({}, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "currentColor"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "currentColor"
    })
  }),
  [`& .${Ho.lastButton},& .${Ho.middleButton}`]: O({}, t.orientation === "horizontal" && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, t.orientation === "vertical" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    marginLeft: -1
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    marginTop: -1
  })
})), vz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: s,
    className: l,
    color: u = "primary",
    component: p = "div",
    disabled: h = !1,
    disableElevation: m = !1,
    disableFocusRipple: b = !1,
    disableRipple: x = !1,
    fullWidth: S = !1,
    orientation: R = "horizontal",
    size: T = "medium",
    variant: E = "outlined"
  } = o, P = Te(o, jee), k = O({}, o, {
    color: u,
    component: p,
    disabled: h,
    disableElevation: m,
    disableFocusRipple: b,
    disableRipple: x,
    fullWidth: S,
    orientation: R,
    size: T,
    variant: E
  }), _ = Bee(k), L = D.useMemo(() => ({
    className: _.grouped,
    color: u,
    disabled: h,
    disableElevation: m,
    disableFocusRipple: b,
    disableRipple: x,
    fullWidth: S,
    size: T,
    variant: E
  }), [u, h, m, b, x, S, T, E, _.grouped]), F = oY(s), N = F.length, V = (z) => {
    const H = z === 0, ee = z === N - 1;
    return H && ee ? "" : H ? _.firstButton : ee ? _.lastButton : _.middleButton;
  };
  return /* @__PURE__ */ I(zee, O({
    as: p,
    role: "group",
    className: Ne(_.root, l),
    ref: n,
    ownerState: k
  }, P, {
    children: /* @__PURE__ */ I(tk.Provider, {
      value: L,
      children: F.map((z, H) => /* @__PURE__ */ I(nk.Provider, {
        value: V(H),
        children: z
      }, H))
    })
  }));
});
process.env.NODE_ENV !== "production" && (vz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: r.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOfType([r.oneOf(["contained", "outlined", "text"]), r.string])
});
function Uee(e) {
  return pt("MuiCard", e);
}
ht("MuiCard", ["root"]);
const Hee = ["className", "raised"], Wee = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, Uee, t);
}, qee = ce(ms, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  overflow: "hidden"
})), eT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiCard"
  }), {
    className: s,
    raised: l = !1
  } = o, u = Te(o, Hee), p = O({}, o, {
    raised: l
  }), h = Wee(p);
  return /* @__PURE__ */ I(qee, O({
    className: Ne(h.root, s),
    elevation: l ? 8 : void 0,
    ref: n,
    ownerState: p
  }, u));
});
process.env.NODE_ENV !== "production" && (eT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: Pa(r.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Yee(e) {
  return pt("MuiCardContent", e);
}
ht("MuiCardContent", ["root"]);
const Gee = ["className", "component"], Kee = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, Yee, t);
}, Xee = ce("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), rk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiCardContent"
  }), {
    className: s,
    component: l = "div"
  } = o, u = Te(o, Gee), p = O({}, o, {
    component: l
  }), h = Kee(p);
  return /* @__PURE__ */ I(Xee, O({
    as: l,
    className: Ne(h.root, s),
    ownerState: p,
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (rk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Qee(e) {
  return pt("MuiCardHeader", e);
}
const RL = ht("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), Jee = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"], Zee = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, Qee, t);
}, ete = ce("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => O({
    [`& .${RL.title}`]: t.title,
    [`& .${RL.subheader}`]: t.subheader
  }, t.root)
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), tte = ce("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), nte = ce("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), rte = ce("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto"
}), ok = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: s,
    avatar: l,
    className: u,
    component: p = "div",
    disableTypography: h = !1,
    subheader: m,
    subheaderTypographyProps: b,
    title: x,
    titleTypographyProps: S
  } = o, R = Te(o, Jee), T = O({}, o, {
    component: p,
    disableTypography: h
  }), E = Zee(T);
  let P = x;
  P != null && P.type !== nr && !h && (P = /* @__PURE__ */ I(nr, O({
    variant: l ? "body2" : "h5",
    className: E.title,
    component: "span",
    display: "block"
  }, S, {
    children: P
  })));
  let k = m;
  return k != null && k.type !== nr && !h && (k = /* @__PURE__ */ I(nr, O({
    variant: l ? "body2" : "body1",
    className: E.subheader,
    color: "text.secondary",
    component: "span",
    display: "block"
  }, b, {
    children: k
  }))), /* @__PURE__ */ qe(ete, O({
    className: Ne(E.root, u),
    as: p,
    ref: n,
    ownerState: T
  }, R, {
    children: [l && /* @__PURE__ */ I(tte, {
      className: E.avatar,
      ownerState: T,
      children: l
    }), /* @__PURE__ */ qe(rte, {
      className: E.content,
      ownerState: T,
      children: [P, k]
    }), s && /* @__PURE__ */ I(nte, {
      className: E.action,
      ownerState: T,
      children: s
    })]
  }));
});
process.env.NODE_ENV !== "production" && (ok.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: r.node,
  /**
   * The Avatar element to display.
   */
  avatar: r.node,
  /**
   * @ignore
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: r.bool,
  /**
   * The content of the component.
   */
  subheader: r.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The content of the component.
   */
  title: r.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: r.object
});
function ote(e) {
  return pt("PrivateSwitchBase", e);
}
ht("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const ate = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], ite = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: o,
    edge: s
  } = e, l = {
    root: ["root", n && "checked", o && "disabled", s && `edge${Ae(s)}`],
    input: ["input"]
  };
  return vt(l, ote, t);
}, ste = ce(ui)(({
  ownerState: e
}) => O({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), lte = ce("input", {
  shouldForwardProp: Do
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), tT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    autoFocus: o,
    checked: s,
    checkedIcon: l,
    className: u,
    defaultChecked: p,
    disabled: h,
    disableFocusRipple: m = !1,
    edge: b = !1,
    icon: x,
    id: S,
    inputProps: R,
    inputRef: T,
    name: E,
    onBlur: P,
    onChange: k,
    onFocus: _,
    readOnly: L,
    required: F = !1,
    tabIndex: N,
    type: V,
    value: z
  } = t, H = Te(t, ate), [ee, K] = jl({
    controlled: s,
    default: !!p,
    name: "SwitchBase",
    state: "checked"
  }), X = mi(), ne = (G) => {
    _ && _(G), X && X.onFocus && X.onFocus(G);
  }, Y = (G) => {
    P && P(G), X && X.onBlur && X.onBlur(G);
  }, J = (G) => {
    if (G.nativeEvent.defaultPrevented)
      return;
    const W = G.target.checked;
    K(W), k && k(G, W);
  };
  let te = h;
  X && typeof te > "u" && (te = X.disabled);
  const Z = V === "checkbox" || V === "radio", ae = O({}, t, {
    checked: ee,
    disabled: te,
    disableFocusRipple: m,
    edge: b
  }), U = ite(ae);
  return /* @__PURE__ */ qe(ste, O({
    component: "span",
    className: Ne(U.root, u),
    centerRipple: !0,
    focusRipple: !m,
    disabled: te,
    tabIndex: null,
    role: void 0,
    onFocus: ne,
    onBlur: Y,
    ownerState: ae,
    ref: n
  }, H, {
    children: [/* @__PURE__ */ I(lte, O({
      autoFocus: o,
      checked: s,
      defaultChecked: p,
      className: U.input,
      disabled: te,
      id: Z ? S : void 0,
      name: E,
      onChange: J,
      readOnly: L,
      ref: T,
      required: F,
      ownerState: ae,
      tabIndex: N,
      type: V
    }, V === "checkbox" && z === void 0 ? {} : {
      value: z
    }, R)), ee ? l : x]
  }));
});
process.env.NODE_ENV !== "production" && (tT.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: r.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: r.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /*
   * @ignore
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.object,
  /**
   * @ignore
   */
  tabIndex: r.oneOfType([r.number, r.string]),
  /**
   * The input component prop `type`.
   */
  type: r.string.isRequired,
  /**
   * The value of the component.
   */
  value: r.any
});
const cte = lr(/* @__PURE__ */ I("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), ute = lr(/* @__PURE__ */ I("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), dte = lr(/* @__PURE__ */ I("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function fte(e) {
  return pt("MuiCheckbox", e);
}
const t$ = ht("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), pte = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], hte = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: o,
    size: s
  } = e, l = {
    root: ["root", n && "indeterminate", `color${Ae(o)}`, `size${Ae(s)}`]
  }, u = vt(l, fte, t);
  return O({}, t, u);
}, mte = ce(tT, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Ae(n.size)}`], n.color !== "default" && t[`color${Ae(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${t$.checked}, &.${t$.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${t$.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), vte = /* @__PURE__ */ I(ute, {}), gte = /* @__PURE__ */ I(cte, {}), yte = /* @__PURE__ */ I(dte, {}), b0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s;
  const l = We({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: u = vte,
    color: p = "primary",
    icon: h = gte,
    indeterminate: m = !1,
    indeterminateIcon: b = yte,
    inputProps: x,
    size: S = "medium",
    className: R
  } = l, T = Te(l, pte), E = m ? b : h, P = m ? b : u, k = O({}, l, {
    color: p,
    indeterminate: m,
    size: S
  }), _ = hte(k);
  return /* @__PURE__ */ I(mte, O({
    type: "checkbox",
    inputProps: O({
      "data-indeterminate": m
    }, x),
    icon: /* @__PURE__ */ D.cloneElement(E, {
      fontSize: (o = E.props.fontSize) != null ? o : S
    }),
    checkedIcon: /* @__PURE__ */ D.cloneElement(P, {
      fontSize: (s = P.props.fontSize) != null ? s : S
    }),
    ownerState: k,
    ref: n,
    className: Ne(_.root, R)
  }, T, {
    classes: _
  }));
});
process.env.NODE_ENV !== "production" && (b0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: r.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: r.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: r.any
});
function bte(e) {
  return pt("MuiCircularProgress", e);
}
ht("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const xte = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let nT = (e) => e, OL, PL, $L, DL;
const nd = 44, Ste = tl(OL || (OL = nT`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), Cte = tl(PL || (PL = nT`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), wte = (e) => {
  const {
    classes: t,
    variant: n,
    color: o,
    disableShrink: s
  } = e, l = {
    root: ["root", n, `color${Ae(o)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Ae(n)}`, s && "circleDisableShrink"]
  };
  return vt(l, bte, t);
}, Tte = ce("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${Ae(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && Bc($L || ($L = nT`
      animation: ${0} 1.4s linear infinite;
    `), Ste)), Ete = ce("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), Rte = ce("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${Ae(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && Bc(DL || (DL = nT`
      animation: ${0} 1.4s ease-in-out infinite;
    `), Cte)), gz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: s,
    color: l = "primary",
    disableShrink: u = !1,
    size: p = 40,
    style: h,
    thickness: m = 3.6,
    value: b = 0,
    variant: x = "indeterminate"
  } = o, S = Te(o, xte), R = O({}, o, {
    color: l,
    disableShrink: u,
    size: p,
    thickness: m,
    value: b,
    variant: x
  }), T = wte(R), E = {}, P = {}, k = {};
  if (x === "determinate") {
    const _ = 2 * Math.PI * ((nd - m) / 2);
    E.strokeDasharray = _.toFixed(3), k["aria-valuenow"] = Math.round(b), E.strokeDashoffset = `${((100 - b) / 100 * _).toFixed(3)}px`, P.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ I(Tte, O({
    className: Ne(T.root, s),
    style: O({
      width: p,
      height: p
    }, P, h),
    ownerState: R,
    ref: n,
    role: "progressbar"
  }, k, S, {
    children: /* @__PURE__ */ I(Ete, {
      className: T.svg,
      ownerState: R,
      viewBox: `${nd / 2} ${nd / 2} ${nd} ${nd}`,
      children: /* @__PURE__ */ I(Rte, {
        className: T.circle,
        style: E,
        ownerState: R,
        cx: nd,
        cy: nd,
        r: (nd - m) / 2,
        fill: "none",
        strokeWidth: m
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (gz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Pa(r.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g. '3rem'.
   * @default 40
   */
  size: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: r.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: r.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: r.oneOf(["determinate", "indeterminate"])
});
function Ote(e) {
  return pt("MuiModal", e);
}
ht("MuiModal", ["root", "hidden", "backdrop"]);
const Pte = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], $te = (e) => {
  const {
    open: t,
    exited: n,
    classes: o
  } = e;
  return vt({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, Ote, o);
}, Dte = ce("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), kte = ce(ek, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), rT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u, p, h;
  const m = We({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: b = kte,
    BackdropProps: x,
    className: S,
    closeAfterTransition: R = !1,
    children: T,
    container: E,
    component: P,
    components: k = {},
    componentsProps: _ = {},
    disableAutoFocus: L = !1,
    disableEnforceFocus: F = !1,
    disableEscapeKeyDown: N = !1,
    disablePortal: V = !1,
    disableRestoreFocus: z = !1,
    disableScrollLock: H = !1,
    hideBackdrop: ee = !1,
    keepMounted: K = !1,
    onBackdropClick: X,
    open: ne,
    slotProps: Y,
    slots: J
    // eslint-disable-next-line react/prop-types
  } = m, te = Te(m, Pte), Z = O({}, m, {
    closeAfterTransition: R,
    disableAutoFocus: L,
    disableEnforceFocus: F,
    disableEscapeKeyDown: N,
    disablePortal: V,
    disableRestoreFocus: z,
    disableScrollLock: H,
    hideBackdrop: ee,
    keepMounted: K
  }), {
    getRootProps: ae,
    getBackdropProps: U,
    getTransitionProps: G,
    portalRef: W,
    isTopModal: le,
    exited: pe,
    hasTransition: ge
  } = PZ(O({}, Z, {
    rootRef: n
  })), we = O({}, Z, {
    exited: pe
  }), de = $te(we), se = {};
  if (T.props.tabIndex === void 0 && (se.tabIndex = "-1"), ge) {
    const {
      onEnter: fe,
      onExited: ye
    } = G();
    se.onEnter = fe, se.onExited = ye;
  }
  const ve = (o = (s = J == null ? void 0 : J.root) != null ? s : k.Root) != null ? o : Dte, me = (l = (u = J == null ? void 0 : J.backdrop) != null ? u : k.Backdrop) != null ? l : b, Oe = (p = Y == null ? void 0 : Y.root) != null ? p : _.root, be = (h = Y == null ? void 0 : Y.backdrop) != null ? h : _.backdrop, De = Li({
    elementType: ve,
    externalSlotProps: Oe,
    externalForwardedProps: te,
    getSlotProps: ae,
    additionalProps: {
      ref: n,
      as: P
    },
    ownerState: we,
    className: Ne(S, Oe == null ? void 0 : Oe.className, de == null ? void 0 : de.root, !we.open && we.exited && (de == null ? void 0 : de.hidden))
  }), ie = Li({
    elementType: me,
    externalSlotProps: be,
    additionalProps: x,
    getSlotProps: (fe) => U(O({}, fe, {
      onClick: (ye) => {
        X && X(ye), fe != null && fe.onClick && fe.onClick(ye);
      }
    })),
    className: Ne(be == null ? void 0 : be.className, x == null ? void 0 : x.className, de == null ? void 0 : de.backdrop),
    ownerState: we
  });
  return !K && !ne && (!ge || pe) ? null : /* @__PURE__ */ I(Yb, {
    ref: W,
    container: E,
    disablePortal: V,
    children: /* @__PURE__ */ qe(ve, O({}, De, {
      children: [!ee && b ? /* @__PURE__ */ I(me, O({}, ie)) : null, /* @__PURE__ */ I(Hb, {
        disableEnforceFocus: F,
        disableAutoFocus: L,
        disableRestoreFocus: z,
        isEnabled: le,
        open: ne,
        children: /* @__PURE__ */ D.cloneElement(T, se)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (rT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: r.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: r.object,
  /**
   * A single child content element.
   */
  children: gd.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: r.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Backdrop: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    backdrop: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Hl, r.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: r.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: r.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: r.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: r.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: r.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: r.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: r.shape({
    backdrop: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    backdrop: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Mte(e) {
  return pt("MuiDialog", e);
}
const Pb = ht("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), ak = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (ak.displayName = "DialogContext");
const Nte = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], Ite = ce(ek, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), _te = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: o,
    fullWidth: s,
    fullScreen: l
  } = e, u = {
    root: ["root"],
    container: ["container", `scroll${Ae(n)}`],
    paper: ["paper", `paperScroll${Ae(n)}`, `paperWidth${Ae(String(o))}`, s && "paperFullWidth", l && "paperFullScreen"]
  };
  return vt(u, Mte, t);
}, Ate = ce(rT, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), Lte = ce("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${Ae(n.scroll)}`]];
  }
})(({
  ownerState: e
}) => O({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), Fte = ce(ms, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${Ae(n.scroll)}`], t[`paperWidth${Ae(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${Pb.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${Pb.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${Pb.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), oT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDialog"
  }), s = Go(), l = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    "aria-describedby": u,
    "aria-labelledby": p,
    BackdropComponent: h,
    BackdropProps: m,
    children: b,
    className: x,
    disableEscapeKeyDown: S = !1,
    fullScreen: R = !1,
    fullWidth: T = !1,
    maxWidth: E = "sm",
    onBackdropClick: P,
    onClose: k,
    open: _,
    PaperComponent: L = ms,
    PaperProps: F = {},
    scroll: N = "paper",
    TransitionComponent: V = sp,
    transitionDuration: z = l,
    TransitionProps: H
  } = o, ee = Te(o, Nte), K = O({}, o, {
    disableEscapeKeyDown: S,
    fullScreen: R,
    fullWidth: T,
    maxWidth: E,
    scroll: N
  }), X = _te(K), ne = D.useRef(), Y = (ae) => {
    ne.current = ae.target === ae.currentTarget;
  }, J = (ae) => {
    ne.current && (ne.current = null, P && P(ae), k && k(ae, "backdropClick"));
  }, te = Vc(p), Z = D.useMemo(() => ({
    titleId: te
  }), [te]);
  return /* @__PURE__ */ I(Ate, O({
    className: Ne(X.root, x),
    closeAfterTransition: !0,
    components: {
      Backdrop: Ite
    },
    componentsProps: {
      backdrop: O({
        transitionDuration: z,
        as: h
      }, m)
    },
    disableEscapeKeyDown: S,
    onClose: k,
    open: _,
    ref: n,
    onClick: J,
    ownerState: K
  }, ee, {
    children: /* @__PURE__ */ I(V, O({
      appear: !0,
      in: _,
      timeout: z,
      role: "presentation"
    }, H, {
      children: /* @__PURE__ */ I(Lte, {
        className: Ne(X.container),
        onMouseDown: Y,
        ownerState: K,
        children: /* @__PURE__ */ I(Fte, O({
          as: L,
          elevation: 24,
          role: "dialog",
          "aria-describedby": u,
          "aria-labelledby": te
        }, F, {
          className: Ne(X.paper, F.className),
          ownerState: K,
          children: /* @__PURE__ */ I(ak.Provider, {
            value: Z,
            children: b
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (oT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": r.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": r.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: r.elementType,
  /**
   * @ignore
   */
  BackdropProps: r.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: r.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: r.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: r.oneOfType([r.oneOf(["xs", "sm", "md", "lg", "xl", !1]), r.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: r.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: r.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: r.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: r.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: r.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: r.object
});
function jte(e) {
  return pt("MuiDialogActions", e);
}
ht("MuiDialogActions", ["root", "spacing"]);
const Vte = ["className", "disableSpacing"], Bte = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return vt({
    root: ["root", !n && "spacing"]
  }, jte, t);
}, zte = ce("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => O({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), aT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: s,
    disableSpacing: l = !1
  } = o, u = Te(o, Vte), p = O({}, o, {
    disableSpacing: l
  }), h = Bte(p);
  return /* @__PURE__ */ I(zte, O({
    className: Ne(h.root, s),
    ownerState: p,
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (aT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Ute(e) {
  return pt("MuiDialogContent", e);
}
ht("MuiDialogContent", ["root", "dividers"]);
function Hte(e) {
  return pt("MuiDialogTitle", e);
}
const Wte = ht("MuiDialogTitle", ["root"]), qte = ["className", "dividers"], Yte = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return vt({
    root: ["root", n && "dividers"]
  }, Ute, t);
}, Gte = ce("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${Wte.root} + &`]: {
    paddingTop: 0
  }
})), iT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: s,
    dividers: l = !1
  } = o, u = Te(o, qte), p = O({}, o, {
    dividers: l
  }), h = Yte(p);
  return /* @__PURE__ */ I(Gte, O({
    className: Ne(h.root, s),
    ownerState: p,
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (iT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Kte = ["className", "id"], Xte = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, Hte, t);
}, Qte = ce(nr, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), ik = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: s,
    id: l
  } = o, u = Te(o, Kte), p = o, h = Xte(p), {
    titleId: m = l
  } = D.useContext(ak);
  return /* @__PURE__ */ I(Qte, O({
    component: "h2",
    className: Ne(h.root, s),
    ownerState: p,
    ref: n,
    variant: "h6",
    id: l ?? m
  }, u));
});
process.env.NODE_ENV !== "production" && (ik.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  id: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Jte(e) {
  return pt("MuiDivider", e);
}
const kL = ht("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Zte = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], ene = (e) => {
  const {
    absolute: t,
    children: n,
    classes: o,
    flexItem: s,
    light: l,
    orientation: u,
    textAlign: p,
    variant: h
  } = e;
  return vt({
    root: ["root", t && "absolute", h, l && "light", u === "vertical" && "vertical", s && "flexItem", n && "withChildren", n && u === "vertical" && "withChildrenVertical", p === "right" && u !== "vertical" && "textAlignRight", p === "left" && u !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", u === "vertical" && "wrapperVertical"]
  }, Jte, o);
}, tne = ce("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Mt(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => O({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => O({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  theme: e,
  ownerState: t
}) => O({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  ownerState: e
}) => O({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), nne = ce("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), x0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: s = !1,
    children: l,
    className: u,
    component: p = l ? "div" : "hr",
    flexItem: h = !1,
    light: m = !1,
    orientation: b = "horizontal",
    role: x = p !== "hr" ? "separator" : void 0,
    textAlign: S = "center",
    variant: R = "fullWidth"
  } = o, T = Te(o, Zte), E = O({}, o, {
    absolute: s,
    component: p,
    flexItem: h,
    light: m,
    orientation: b,
    role: x,
    textAlign: S,
    variant: R
  }), P = ene(E);
  return /* @__PURE__ */ I(tne, O({
    as: p,
    className: Ne(P.root, u),
    role: x,
    ref: n,
    ownerState: E
  }, T, {
    children: l ? /* @__PURE__ */ I(nne, {
      className: P.wrapper,
      ownerState: E,
      children: l
    }) : null
  }));
});
x0.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (x0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: r.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ bgcolor: '#eee' }} /> (or any color) instead.
   */
  light: r.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: r.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: r.oneOfType([r.oneOf(["fullWidth", "inset", "middle"]), r.string])
});
const rne = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function one(e, t, n) {
  const o = t.getBoundingClientRect(), s = n && n.getBoundingClientRect(), l = us(t);
  let u;
  if (t.fakeTransform)
    u = t.fakeTransform;
  else {
    const m = l.getComputedStyle(t);
    u = m.getPropertyValue("-webkit-transform") || m.getPropertyValue("transform");
  }
  let p = 0, h = 0;
  if (u && u !== "none" && typeof u == "string") {
    const m = u.split("(")[1].split(")")[0].split(",");
    p = parseInt(m[4], 10), h = parseInt(m[5], 10);
  }
  return e === "left" ? s ? `translateX(${s.right + p - o.left}px)` : `translateX(${l.innerWidth + p - o.left}px)` : e === "right" ? s ? `translateX(-${o.right - s.left - p}px)` : `translateX(-${o.left + o.width - p}px)` : e === "up" ? s ? `translateY(${s.bottom + h - o.top}px)` : `translateY(${l.innerHeight + h - o.top}px)` : s ? `translateY(-${o.top - s.top + o.height - h}px)` : `translateY(-${o.top + o.height - h}px)`;
}
function yz(e) {
  return typeof e == "function" ? e() : e;
}
function l1(e, t, n) {
  const o = yz(n), s = one(e, t, o);
  s && (t.style.webkitTransform = s, t.style.transform = s);
}
const bz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = Go(), s = {
    enter: o.transitions.easing.easeOut,
    exit: o.transitions.easing.sharp
  }, l = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: u,
    appear: p = !0,
    children: h,
    container: m,
    direction: b = "down",
    easing: x = s,
    in: S,
    onEnter: R,
    onEntered: T,
    onEntering: E,
    onExit: P,
    onExited: k,
    onExiting: _,
    style: L,
    timeout: F = l,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: N = hi
  } = t, V = Te(t, rne), z = D.useRef(null), H = Gn(h.ref, z, n), ee = (U) => (G) => {
    U && (G === void 0 ? U(z.current) : U(z.current, G));
  }, K = ee((U, G) => {
    l1(b, U, m), UD(U), R && R(U, G);
  }), X = ee((U, G) => {
    const W = fd({
      timeout: F,
      style: L,
      easing: x
    }, {
      mode: "enter"
    });
    U.style.webkitTransition = o.transitions.create("-webkit-transform", O({}, W)), U.style.transition = o.transitions.create("transform", O({}, W)), U.style.webkitTransform = "none", U.style.transform = "none", E && E(U, G);
  }), ne = ee(T), Y = ee(_), J = ee((U) => {
    const G = fd({
      timeout: F,
      style: L,
      easing: x
    }, {
      mode: "exit"
    });
    U.style.webkitTransition = o.transitions.create("-webkit-transform", G), U.style.transition = o.transitions.create("transform", G), l1(b, U, m), P && P(U);
  }), te = ee((U) => {
    U.style.webkitTransition = "", U.style.transition = "", k && k(U);
  }), Z = (U) => {
    u && u(z.current, U);
  }, ae = D.useCallback(() => {
    z.current && l1(b, z.current, m);
  }, [b, m]);
  return D.useEffect(() => {
    if (S || b === "down" || b === "right")
      return;
    const U = bv(() => {
      z.current && l1(b, z.current, m);
    }), G = us(z.current);
    return G.addEventListener("resize", U), () => {
      U.clear(), G.removeEventListener("resize", U);
    };
  }, [b, S, m]), D.useEffect(() => {
    S || ae();
  }, [S, ae]), /* @__PURE__ */ I(N, O({
    nodeRef: z,
    onEnter: K,
    onEntered: ne,
    onEntering: X,
    onExit: J,
    onExited: te,
    onExiting: Y,
    addEndListener: Z,
    appear: p,
    in: S,
    timeout: F
  }, V, {
    children: (U, G) => /* @__PURE__ */ D.cloneElement(h, O({
      ref: H,
      style: O({
        visibility: U === "exited" && !S ? "hidden" : void 0
      }, L, h.props.style)
    }, G))
  }));
});
process.env.NODE_ENV !== "production" && (bz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: gd.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: Pa(r.oneOfType([Hl, r.func]), (e) => {
    if (e.open) {
      const t = yz(e.container);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: r.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function ane(e) {
  return pt("MuiDrawer", e);
}
ht("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const ine = ["BackdropProps"], sne = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"], xz = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, (n.variant === "permanent" || n.variant === "persistent") && t.docked, t.modal];
}, lne = (e) => {
  const {
    classes: t,
    anchor: n,
    variant: o
  } = e, s = {
    root: ["root"],
    docked: [(o === "permanent" || o === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${Ae(n)}`, o !== "temporary" && `paperAnchorDocked${Ae(n)}`]
  };
  return vt(s, ane, t);
}, cne = ce(rT, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: xz
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
})), ML = ce("div", {
  shouldForwardProp: Do,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: xz
})({
  flex: "0 0 auto"
}), une = ce(ms, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`paperAnchor${Ae(n.anchor)}`], n.variant !== "temporary" && t[`paperAnchorDocked${Ae(n.anchor)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, t.anchor === "left" && {
  left: 0
}, t.anchor === "top" && {
  top: 0,
  left: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, t.anchor === "right" && {
  right: 0
}, t.anchor === "bottom" && {
  top: "auto",
  left: 0,
  bottom: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, t.anchor === "left" && t.variant !== "temporary" && {
  borderRight: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "top" && t.variant !== "temporary" && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "right" && t.variant !== "temporary" && {
  borderLeft: `1px solid ${(e.vars || e).palette.divider}`
}, t.anchor === "bottom" && t.variant !== "temporary" && {
  borderTop: `1px solid ${(e.vars || e).palette.divider}`
})), Sz = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function dne(e) {
  return ["left", "right"].indexOf(e) !== -1;
}
function fne(e, t) {
  return e.direction === "rtl" && dne(t) ? Sz[t] : t;
}
const sT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDrawer"
  }), s = Go(), l = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    anchor: u = "left",
    BackdropProps: p,
    children: h,
    className: m,
    elevation: b = 16,
    hideBackdrop: x = !1,
    ModalProps: {
      BackdropProps: S
    } = {},
    onClose: R,
    open: T = !1,
    PaperProps: E = {},
    SlideProps: P,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: k = bz,
    transitionDuration: _ = l,
    variant: L = "temporary"
  } = o, F = Te(o.ModalProps, ine), N = Te(o, sne), V = D.useRef(!1);
  D.useEffect(() => {
    V.current = !0;
  }, []);
  const z = fne(s, u), ee = O({}, o, {
    anchor: u,
    elevation: b,
    open: T,
    variant: L
  }, N), K = lne(ee), X = /* @__PURE__ */ I(une, O({
    elevation: L === "temporary" ? b : 0,
    square: !0
  }, E, {
    className: Ne(K.paper, E.className),
    ownerState: ee,
    children: h
  }));
  if (L === "permanent")
    return /* @__PURE__ */ I(ML, O({
      className: Ne(K.root, K.docked, m),
      ownerState: ee,
      ref: n
    }, N, {
      children: X
    }));
  const ne = /* @__PURE__ */ I(k, O({
    in: T,
    direction: Sz[z],
    timeout: _,
    appear: V.current
  }, P, {
    children: X
  }));
  return L === "persistent" ? /* @__PURE__ */ I(ML, O({
    className: Ne(K.root, K.docked, m),
    ownerState: ee,
    ref: n
  }, N, {
    children: ne
  })) : /* @__PURE__ */ I(cne, O({
    BackdropProps: O({}, p, S, {
      transitionDuration: _
    }),
    className: Ne(K.root, K.modal, m),
    open: T,
    ownerState: ee,
    onClose: R,
    hideBackdrop: x,
    ref: n
  }, N, F, {
    children: ne
  }));
});
process.env.NODE_ENV !== "production" && (sT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: r.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: r.object,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: Lc,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: r.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: r.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: r.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: r.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: r.oneOf(["permanent", "persistent", "temporary"])
});
const pne = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], hne = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = vt({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, eee, t);
  return O({}, t, s);
}, mne = ce(Qw, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Kw(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const o = e.palette.mode === "light", s = o ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", l = o ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", u = o ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", p = o ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return O({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : u,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l
      }
    },
    [`&.${Mi.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : l
    },
    [`&.${Mi.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : p
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Mi.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Mi.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : s}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Mi.disabled}, .${Mi.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${Mi.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && O({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), vne = ce(Jw, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Xw
})(({
  theme: e,
  ownerState: t
}) => O({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), lT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u;
  const p = We({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: h = {},
    componentsProps: m,
    fullWidth: b = !1,
    // declare here to prevent spreading to DOM
    inputComponent: x = "input",
    multiline: S = !1,
    slotProps: R,
    slots: T = {},
    type: E = "text"
  } = p, P = Te(p, pne), k = O({}, p, {
    fullWidth: b,
    inputComponent: x,
    multiline: S,
    type: E
  }), _ = hne(p), L = {
    root: {
      ownerState: k
    },
    input: {
      ownerState: k
    }
  }, F = R ?? m ? ai(L, R ?? m) : L, N = (o = (s = T.root) != null ? s : h.Root) != null ? o : mne, V = (l = (u = T.input) != null ? u : h.Input) != null ? l : vne;
  return /* @__PURE__ */ I(Zw, O({
    slots: {
      root: N,
      input: V
    },
    componentsProps: F,
    fullWidth: b,
    inputComponent: x,
    multiline: S,
    ref: n,
    type: E
  }, P, {
    classes: _
  }));
});
process.env.NODE_ENV !== "production" && (lT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
lT.muiName = "Input";
function gne(e) {
  return pt("MuiFormControl", e);
}
ht("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const yne = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], bne = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: o
  } = e, s = {
    root: ["root", n !== "none" && `margin${Ae(n)}`, o && "fullWidth"]
  };
  return vt(s, gne, t);
}, xne = ce("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => O({}, t.root, t[`margin${Ae(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => O({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), Cv = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiFormControl"
  }), {
    children: s,
    className: l,
    color: u = "primary",
    component: p = "div",
    disabled: h = !1,
    error: m = !1,
    focused: b,
    fullWidth: x = !1,
    hiddenLabel: S = !1,
    margin: R = "none",
    required: T = !1,
    size: E = "medium",
    variant: P = "outlined"
  } = o, k = Te(o, yne), _ = O({}, o, {
    color: u,
    component: p,
    disabled: h,
    error: m,
    fullWidth: x,
    hiddenLabel: S,
    margin: R,
    required: T,
    size: E,
    variant: P
  }), L = bne(_), [F, N] = D.useState(() => {
    let Y = !1;
    return s && D.Children.forEach(s, (J) => {
      if (!Jm(J, ["Input", "Select"]))
        return;
      const te = Jm(J, ["Select"]) ? J.props.input : J;
      te && YZ(te.props) && (Y = !0);
    }), Y;
  }), [V, z] = D.useState(() => {
    let Y = !1;
    return s && D.Children.forEach(s, (J) => {
      Jm(J, ["Input", "Select"]) && (K1(J.props, !0) || K1(J.props.inputProps, !0)) && (Y = !0);
    }), Y;
  }), [H, ee] = D.useState(!1);
  h && H && ee(!1);
  const K = b !== void 0 && !h ? b : H;
  let X;
  if (process.env.NODE_ENV !== "production") {
    const Y = D.useRef(!1);
    X = () => (Y.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), Y.current = !0, () => {
      Y.current = !1;
    });
  }
  const ne = D.useMemo(() => ({
    adornedStart: F,
    setAdornedStart: N,
    color: u,
    disabled: h,
    error: m,
    filled: V,
    focused: K,
    fullWidth: x,
    hiddenLabel: S,
    size: E,
    onBlur: () => {
      ee(!1);
    },
    onEmpty: () => {
      z(!1);
    },
    onFilled: () => {
      z(!0);
    },
    onFocus: () => {
      ee(!0);
    },
    registerEffect: X,
    required: T,
    variant: P
  }), [F, u, h, m, V, K, x, S, X, T, E, P]);
  return /* @__PURE__ */ I(y0.Provider, {
    value: ne,
    children: /* @__PURE__ */ I(xne, O({
      as: p,
      ownerState: _,
      className: Ne(L.root, l),
      ref: n
    }, k, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (Cv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const X1 = YK({
  createStyledComponent: ce("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => We({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (X1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * Add an element between each child.
   */
  divider: r.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: r.bool
});
function Sne(e) {
  return pt("MuiFormControlLabel", e);
}
const vb = ht("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), Cne = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], wne = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: o,
    error: s,
    required: l
  } = e, u = {
    root: ["root", n && "disabled", `labelPlacement${Ae(o)}`, s && "error", l && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", s && "error"]
  };
  return vt(u, Sne, t);
}, Tne = ce("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${vb.label}`]: t.label
    }, t.root, t[`labelPlacement${Ae(n.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${vb.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${vb.label}`]: {
    [`&.${vb.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), Ene = ce("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${vb.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), cT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s;
  const l = We({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: u,
    componentsProps: p = {},
    control: h,
    disabled: m,
    disableTypography: b,
    label: x,
    labelPlacement: S = "end",
    required: R,
    slotProps: T = {}
  } = l, E = Te(l, Cne), P = mi(), k = (o = m ?? h.props.disabled) != null ? o : P == null ? void 0 : P.disabled, _ = R ?? h.props.required, L = {
    disabled: k,
    required: _
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((ee) => {
    typeof h.props[ee] > "u" && typeof l[ee] < "u" && (L[ee] = l[ee]);
  });
  const F = Sd({
    props: l,
    muiFormControl: P,
    states: ["error"]
  }), N = O({}, l, {
    disabled: k,
    labelPlacement: S,
    required: _,
    error: F.error
  }), V = wne(N), z = (s = T.typography) != null ? s : p.typography;
  let H = x;
  return H != null && H.type !== nr && !b && (H = /* @__PURE__ */ I(nr, O({
    component: "span"
  }, z, {
    className: Ne(V.label, z == null ? void 0 : z.className),
    children: H
  }))), /* @__PURE__ */ qe(Tne, O({
    className: Ne(V.root, u),
    ownerState: N,
    ref: n
  }, E, {
    children: [/* @__PURE__ */ D.cloneElement(h, L), _ ? /* @__PURE__ */ qe(X1, {
      display: "block",
      children: [H, /* @__PURE__ */ qe(Ene, {
        ownerState: N,
        "aria-hidden": !0,
        className: V.asterisk,
        children: [" ", "*"]
      })]
    }) : H]
  }));
});
process.env.NODE_ENV !== "production" && (cT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: r.shape({
    typography: r.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: r.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: r.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: r.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: r.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: r.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    typography: r.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component.
   */
  value: r.any
});
function Rne(e) {
  return pt("MuiFormGroup", e);
}
ht("MuiFormGroup", ["root", "row", "error"]);
const One = ["className", "row"], Pne = (e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return vt({
    root: ["root", n && "row", o && "error"]
  }, Rne, t);
}, $ne = ce("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})(({
  ownerState: e
}) => O({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), sk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: s,
    row: l = !1
  } = o, u = Te(o, One), p = mi(), h = Sd({
    props: o,
    muiFormControl: p,
    states: ["error"]
  }), m = O({}, o, {
    row: l,
    error: h.error
  }), b = Pne(m);
  return /* @__PURE__ */ I($ne, O({
    className: Ne(b.root, s),
    ownerState: m,
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (sk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Dne(e) {
  return pt("MuiFormHelperText", e);
}
const NL = ht("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var IL;
const kne = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], Mne = (e) => {
  const {
    classes: t,
    contained: n,
    size: o,
    disabled: s,
    error: l,
    filled: u,
    focused: p,
    required: h
  } = e, m = {
    root: ["root", s && "disabled", l && "error", o && `size${Ae(o)}`, n && "contained", p && "focused", u && "filled", h && "required"]
  };
  return vt(m, Dne, t);
}, Nne = ce("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Ae(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${NL.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${NL.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), ql = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: s,
    className: l,
    component: u = "p"
  } = o, p = Te(o, kne), h = mi(), m = Sd({
    props: o,
    muiFormControl: h,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), b = O({}, o, {
    component: u,
    contained: m.variant === "filled" || m.variant === "outlined",
    variant: m.variant,
    size: m.size,
    disabled: m.disabled,
    error: m.error,
    filled: m.filled,
    focused: m.focused,
    required: m.required
  }), x = Mne(b);
  return /* @__PURE__ */ I(Nne, O({
    as: u,
    ownerState: b,
    className: Ne(x.root, l),
    ref: n
  }, p, {
    children: s === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      IL || (IL = /* @__PURE__ */ I("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : s
  }));
});
process.env.NODE_ENV !== "production" && (ql.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined", "standard"]), r.string])
});
function Ine(e) {
  return pt("MuiFormLabel", e);
}
const $b = ht("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), _ne = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], Ane = (e) => {
  const {
    classes: t,
    color: n,
    focused: o,
    disabled: s,
    error: l,
    filled: u,
    required: p
  } = e, h = {
    root: ["root", `color${Ae(n)}`, s && "disabled", l && "error", u && "filled", o && "focused", p && "required"],
    asterisk: ["asterisk", l && "error"]
  };
  return vt(h, Ine, t);
}, Lne = ce("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => O({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => O({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${$b.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${$b.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${$b.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Fne = ce("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${$b.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), uT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: s,
    className: l,
    component: u = "label"
  } = o, p = Te(o, _ne), h = mi(), m = Sd({
    props: o,
    muiFormControl: h,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), b = O({}, o, {
    color: m.color || "primary",
    component: u,
    disabled: m.disabled,
    error: m.error,
    filled: m.filled,
    focused: m.focused,
    required: m.required
  }), x = Ane(b);
  return /* @__PURE__ */ qe(Lne, O({
    as: u,
    ownerState: b,
    className: Ne(x.root, l),
    ref: n
  }, p, {
    children: [s, m.required && /* @__PURE__ */ qe(Fne, {
      ownerState: b,
      "aria-hidden": !0,
      className: x.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (uT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: r.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const H$ = /* @__PURE__ */ D.createContext();
process.env.NODE_ENV !== "production" && (H$.displayName = "GridContext");
function jne(e) {
  return pt("MuiGrid", e);
}
const Vne = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Bne = ["column-reverse", "column", "row-reverse", "row"], zne = ["nowrap", "wrap-reverse", "wrap"], nb = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Gb = ht("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...Vne.map((e) => `spacing-xs-${e}`),
  // direction values
  ...Bne.map((e) => `direction-xs-${e}`),
  // wrap values
  ...zne.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...nb.map((e) => `grid-xs-${e}`),
  ...nb.map((e) => `grid-sm-${e}`),
  ...nb.map((e) => `grid-md-${e}`),
  ...nb.map((e) => `grid-lg-${e}`),
  ...nb.map((e) => `grid-xl-${e}`)
]), Une = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function tv(e) {
  const t = parseFloat(e);
  return `${t}${String(e).replace(String(t), "") || "px"}`;
}
function Hne({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((o, s) => {
    let l = {};
    if (t[s] && (n = t[s]), !n)
      return o;
    if (n === !0)
      l = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      l = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const u = qf({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), p = typeof u == "object" ? u[s] : u;
      if (p == null)
        return o;
      const h = `${Math.round(n / p * 1e8) / 1e6}%`;
      let m = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const b = e.spacing(t.columnSpacing);
        if (b !== "0px") {
          const x = `calc(${h} + ${tv(b)})`;
          m = {
            flexBasis: x,
            maxWidth: x
          };
        }
      }
      l = O({
        flexBasis: h,
        flexGrow: 0,
        maxWidth: h
      }, m);
    }
    return e.breakpoints.values[s] === 0 ? Object.assign(o, l) : o[e.breakpoints.up(s)] = l, o;
  }, {});
}
function Wne({
  theme: e,
  ownerState: t
}) {
  const n = qf({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return ci({
    theme: e
  }, n, (o) => {
    const s = {
      flexDirection: o
    };
    return o.indexOf("column") === 0 && (s[`& > .${Gb.item}`] = {
      maxWidth: "none"
    }), s;
  });
}
function Cz({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((s) => {
    n === "" && t[s] !== 0 && (n = s);
  });
  const o = Object.keys(e).sort((s, l) => e[s] - e[l]);
  return o.slice(0, o.indexOf(n));
}
function qne({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: o
  } = t;
  let s = {};
  if (n && o !== 0) {
    const l = qf({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let u;
    typeof l == "object" && (u = Cz({
      breakpoints: e.breakpoints.values,
      values: l
    })), s = ci({
      theme: e
    }, l, (p, h) => {
      var m;
      const b = e.spacing(p);
      return b !== "0px" ? {
        marginTop: `-${tv(b)}`,
        [`& > .${Gb.item}`]: {
          paddingTop: tv(b)
        }
      } : (m = u) != null && m.includes(h) ? {} : {
        marginTop: 0,
        [`& > .${Gb.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return s;
}
function Yne({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: o
  } = t;
  let s = {};
  if (n && o !== 0) {
    const l = qf({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let u;
    typeof l == "object" && (u = Cz({
      breakpoints: e.breakpoints.values,
      values: l
    })), s = ci({
      theme: e
    }, l, (p, h) => {
      var m;
      const b = e.spacing(p);
      return b !== "0px" ? {
        width: `calc(100% + ${tv(b)})`,
        marginLeft: `-${tv(b)}`,
        [`& > .${Gb.item}`]: {
          paddingLeft: tv(b)
        }
      } : (m = u) != null && m.includes(h) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Gb.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return s;
}
function Gne(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const o = [];
  return t.forEach((s) => {
    const l = e[s];
    Number(l) > 0 && o.push(n[`spacing-${s}-${String(l)}`]);
  }), o;
}
const Kne = ce("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: o,
      direction: s,
      item: l,
      spacing: u,
      wrap: p,
      zeroMinWidth: h,
      breakpoints: m
    } = n;
    let b = [];
    o && (b = Gne(u, m, t));
    const x = [];
    return m.forEach((S) => {
      const R = n[S];
      R && x.push(t[`grid-${S}-${String(R)}`]);
    }), [t.root, o && t.container, l && t.item, h && t.zeroMinWidth, ...b, s !== "row" && t[`direction-xs-${String(s)}`], p !== "wrap" && t[`wrap-xs-${String(p)}`], ...x];
  }
})(({
  ownerState: e
}) => O({
  boxSizing: "border-box"
}, e.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, e.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, e.zeroMinWidth && {
  minWidth: 0
}, e.wrap !== "wrap" && {
  flexWrap: e.wrap
}), Wne, qne, Yne, Hne);
function Xne(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((o) => {
    const s = e[o];
    if (Number(s) > 0) {
      const l = `spacing-${o}-${String(s)}`;
      n.push(l);
    }
  }), n;
}
const Qne = (e) => {
  const {
    classes: t,
    container: n,
    direction: o,
    item: s,
    spacing: l,
    wrap: u,
    zeroMinWidth: p,
    breakpoints: h
  } = e;
  let m = [];
  n && (m = Xne(l, h));
  const b = [];
  h.forEach((S) => {
    const R = e[S];
    R && b.push(`grid-${S}-${String(R)}`);
  });
  const x = {
    root: ["root", n && "container", s && "item", p && "zeroMinWidth", ...m, o !== "row" && `direction-xs-${String(o)}`, u !== "wrap" && `wrap-xs-${String(u)}`, ...b]
  };
  return vt(x, jne, t);
}, Db = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: s
  } = Go(), l = Vw(o), {
    className: u,
    columns: p,
    columnSpacing: h,
    component: m = "div",
    container: b = !1,
    direction: x = "row",
    item: S = !1,
    rowSpacing: R,
    spacing: T = 0,
    wrap: E = "wrap",
    zeroMinWidth: P = !1
  } = l, k = Te(l, Une), _ = R || T, L = h || T, F = D.useContext(H$), N = b ? p || 12 : F, V = {}, z = O({}, k);
  s.keys.forEach((K) => {
    k[K] != null && (V[K] = k[K], delete z[K]);
  });
  const H = O({}, l, {
    columns: N,
    container: b,
    direction: x,
    item: S,
    rowSpacing: _,
    columnSpacing: L,
    wrap: E,
    zeroMinWidth: P,
    spacing: T
  }, V, {
    breakpoints: s.keys
  }), ee = Qne(H);
  return /* @__PURE__ */ I(H$.Provider, {
    value: N,
    children: /* @__PURE__ */ I(Kne, O({
      ownerState: H,
      className: Ne(ee.root, u),
      as: m,
      ref: n
    }, z))
  });
});
process.env.NODE_ENV !== "production" && (Db.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: r.oneOfType([r.arrayOf(r.number), r.number, r.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: r.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: r.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: r.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: r.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = tB("Grid", Db);
  Db.propTypes = O({}, Db.propTypes, {
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  });
}
const Jne = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function W$(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Zne = {
  entering: {
    opacity: 1,
    transform: W$(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, n$ = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), pv = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    addEndListener: o,
    appear: s = !0,
    children: l,
    easing: u,
    in: p,
    onEnter: h,
    onEntered: m,
    onEntering: b,
    onExit: x,
    onExited: S,
    onExiting: R,
    style: T,
    timeout: E = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: P = hi
  } = t, k = Te(t, Jne), _ = Hf(), L = D.useRef(), F = Go(), N = D.useRef(null), V = Gn(N, l.ref, n), z = (te) => (Z) => {
    if (te) {
      const ae = N.current;
      Z === void 0 ? te(ae) : te(ae, Z);
    }
  }, H = z(b), ee = z((te, Z) => {
    UD(te);
    const {
      duration: ae,
      delay: U,
      easing: G
    } = fd({
      style: T,
      timeout: E,
      easing: u
    }, {
      mode: "enter"
    });
    let W;
    E === "auto" ? (W = F.transitions.getAutoHeightDuration(te.clientHeight), L.current = W) : W = ae, te.style.transition = [F.transitions.create("opacity", {
      duration: W,
      delay: U
    }), F.transitions.create("transform", {
      duration: n$ ? W : W * 0.666,
      delay: U,
      easing: G
    })].join(","), h && h(te, Z);
  }), K = z(m), X = z(R), ne = z((te) => {
    const {
      duration: Z,
      delay: ae,
      easing: U
    } = fd({
      style: T,
      timeout: E,
      easing: u
    }, {
      mode: "exit"
    });
    let G;
    E === "auto" ? (G = F.transitions.getAutoHeightDuration(te.clientHeight), L.current = G) : G = Z, te.style.transition = [F.transitions.create("opacity", {
      duration: G,
      delay: ae
    }), F.transitions.create("transform", {
      duration: n$ ? G : G * 0.666,
      delay: n$ ? ae : ae || G * 0.333,
      easing: U
    })].join(","), te.style.opacity = 0, te.style.transform = W$(0.75), x && x(te);
  }), Y = z(S);
  return /* @__PURE__ */ I(P, O({
    appear: s,
    in: p,
    nodeRef: N,
    onEnter: ee,
    onEntered: K,
    onEntering: H,
    onExit: ne,
    onExited: Y,
    onExiting: X,
    addEndListener: (te) => {
      E === "auto" && _.start(L.current || 0, te), o && o(N.current, te);
    },
    timeout: E === "auto" ? null : E
  }, k, {
    children: (te, Z) => /* @__PURE__ */ D.cloneElement(l, O({
      style: O({
        opacity: 0,
        transform: W$(0.75),
        visibility: te === "exited" && !p ? "hidden" : void 0
      }, Zne[te], T, l.props.style),
      ref: V
    }, Z))
  }));
});
process.env.NODE_ENV !== "production" && (pv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: gd.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
pv.muiSupportAuto = !0;
function ere(e, t, n, o, s) {
  const [l, u] = D.useState(() => s && n ? n(e).matches : o ? o(e).matches : t);
  return $a(() => {
    let p = !0;
    if (!n)
      return;
    const h = n(e), m = () => {
      p && u(h.matches);
    };
    return m(), h.addListener(m), () => {
      p = !1, h.removeListener(m);
    };
  }, [e, n]), l;
}
const wz = D.useSyncExternalStore;
function tre(e, t, n, o, s) {
  const l = D.useCallback(() => t, [t]), u = D.useMemo(() => {
    if (s && n)
      return () => n(e).matches;
    if (o !== null) {
      const {
        matches: b
      } = o(e);
      return () => b;
    }
    return l;
  }, [l, e, o, s, n]), [p, h] = D.useMemo(() => {
    if (n === null)
      return [l, () => () => {
      }];
    const b = n(e);
    return [() => b.matches, (x) => (b.addListener(x), () => {
      b.removeListener(x);
    })];
  }, [l, n, e]);
  return wz(h, p, u);
}
function dT(e, t = {}) {
  const n = Fw(), o = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: s = !1,
    matchMedia: l = o ? window.matchMedia : null,
    ssrMatchMedia: u = null,
    noSsr: p = !1
  } = kB({
    name: "MuiUseMediaQuery",
    props: t,
    theme: n
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && n === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let h = typeof e == "function" ? e(n) : e;
  h = h.replace(/^@media( ?)/m, "");
  const b = (wz !== void 0 ? tre : ere)(h, s, l, u, p);
  return process.env.NODE_ENV !== "production" && D.useDebugValue({
    query: h,
    match: b
  }), b;
}
function nre(e) {
  return pt("MuiIcon", e);
}
ht("MuiIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const rre = ["baseClassName", "className", "color", "component", "fontSize"], ore = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, s = {
    root: ["root", t !== "inherit" && `color${Ae(t)}`, `fontSize${Ae(n)}`]
  };
  return vt(s, nre, o);
}, are = ce("span", {
  name: "MuiIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ae(n.color)}`], t[`fontSize${Ae(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
  // To remove at some point.
  overflow: "hidden",
  display: "inline-block",
  // allow overflow hidden to take action
  textAlign: "center",
  // support non-square icon
  flexShrink: 0,
  fontSize: {
    inherit: "inherit",
    small: e.typography.pxToRem(20),
    medium: e.typography.pxToRem(24),
    large: e.typography.pxToRem(36)
  }[t.fontSize],
  // TODO v5 deprecate, v6 remove for sx
  color: {
    primary: (e.vars || e).palette.primary.main,
    secondary: (e.vars || e).palette.secondary.main,
    info: (e.vars || e).palette.info.main,
    success: (e.vars || e).palette.success.main,
    warning: (e.vars || e).palette.warning.main,
    action: (e.vars || e).palette.action.active,
    error: (e.vars || e).palette.error.main,
    disabled: (e.vars || e).palette.action.disabled,
    inherit: void 0
  }[t.color]
})), lk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiIcon"
  }), {
    baseClassName: s = "material-icons",
    className: l,
    color: u = "inherit",
    component: p = "span",
    fontSize: h = "medium"
  } = o, m = Te(o, rre), b = O({}, o, {
    baseClassName: s,
    color: u,
    component: p,
    fontSize: h
  }), x = ore(b);
  return /* @__PURE__ */ I(are, O({
    as: p,
    className: Ne(
      s,
      // Prevent the translation of the text content.
      // The font relies on the exact text content to render the icon.
      "notranslate",
      x.root,
      l
    ),
    ownerState: b,
    "aria-hidden": !0,
    ref: n
  }, m));
});
process.env.NODE_ENV !== "production" && (lk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (e.g. material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: r.string,
  /**
   * The name of the icon font ligature.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */
  color: r.oneOfType([r.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: r.oneOfType([r.oneOf(["inherit", "large", "medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
lk.muiName = "Icon";
const ire = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], sre = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = vt({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, JZ, t);
  return O({}, t, s);
}, lre = ce(Qw, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Kw(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), O({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${ad.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${ad.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${ad.disabled}, .${ad.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${o}`
      }
    },
    [`&.${ad.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), cre = ce(Jw, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Xw
})({}), fT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u;
  const p = We({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: h,
    components: m = {},
    componentsProps: b,
    fullWidth: x = !1,
    inputComponent: S = "input",
    multiline: R = !1,
    slotProps: T,
    slots: E = {},
    type: P = "text"
  } = p, k = Te(p, ire), _ = sre(p), F = {
    root: {
      ownerState: {
        disableUnderline: h
      }
    }
  }, N = T ?? b ? ai(T ?? b, F) : F, V = (o = (s = E.root) != null ? s : m.Root) != null ? o : lre, z = (l = (u = E.input) != null ? u : m.Input) != null ? l : cre;
  return /* @__PURE__ */ I(Zw, O({
    slots: {
      root: V,
      input: z
    },
    slotProps: N,
    fullWidth: x,
    inputComponent: S,
    multiline: R,
    ref: n,
    type: P
  }, k, {
    classes: _
  }));
});
process.env.NODE_ENV !== "production" && (fT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
fT.muiName = "Input";
function ure(e) {
  return pt("MuiInputAdornment", e);
}
const _L = ht("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var AL;
const dre = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], fre = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${Ae(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, pre = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: o,
    position: s,
    size: l,
    variant: u
  } = e, p = {
    root: ["root", n && "disablePointerEvents", s && `position${Ae(s)}`, u, o && "hiddenLabel", l && `size${Ae(l)}`]
  };
  return vt(p, ure, t);
}, hre = ce("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: fre
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${_L.positionStart}&:not(.${_L.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), pT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: s,
    className: l,
    component: u = "div",
    disablePointerEvents: p = !1,
    disableTypography: h = !1,
    position: m,
    variant: b
  } = o, x = Te(o, dre), S = mi() || {};
  let R = b;
  b && S.variant && process.env.NODE_ENV !== "production" && b === S.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), S && !R && (R = S.variant);
  const T = O({}, o, {
    hiddenLabel: S.hiddenLabel,
    size: S.size,
    disablePointerEvents: p,
    position: m,
    variant: R
  }), E = pre(T);
  return /* @__PURE__ */ I(y0.Provider, {
    value: null,
    children: /* @__PURE__ */ I(hre, O({
      as: u,
      ownerState: T,
      className: Ne(E.root, l),
      ref: n
    }, x, {
      children: typeof s == "string" && !h ? /* @__PURE__ */ I(nr, {
        color: "text.secondary",
        children: s
      }) : /* @__PURE__ */ qe(D.Fragment, {
        children: [m === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          AL || (AL = /* @__PURE__ */ I("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, s]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (pT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: r.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: r.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: r.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function mre(e) {
  return pt("MuiInputLabel", e);
}
ht("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const vre = ["disableAnimation", "margin", "shrink", "variant", "className"], gre = (e) => {
  const {
    classes: t,
    formControl: n,
    size: o,
    shrink: s,
    disableAnimation: l,
    variant: u,
    required: p
  } = e, h = {
    root: ["root", n && "formControl", !l && "animated", s && "shrink", o && o !== "normal" && `size${Ae(o)}`, u],
    asterisk: [p && "asterisk"]
  }, m = vt(h, mre, t);
  return O({}, t, m);
}, yre = ce(uT, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${$b.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && O({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && O({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && O({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), S0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: s = !1,
    shrink: l,
    className: u
  } = o, p = Te(o, vre), h = mi();
  let m = l;
  typeof m > "u" && h && (m = h.filled || h.focused || h.adornedStart);
  const b = Sd({
    props: o,
    muiFormControl: h,
    states: ["size", "variant", "required", "focused"]
  }), x = O({}, o, {
    disableAnimation: s,
    formControl: h,
    shrink: m,
    size: b.size,
    variant: b.variant,
    required: b.required,
    focused: b.focused
  }), S = gre(x);
  return /* @__PURE__ */ I(yre, O({
    "data-shrink": m,
    ownerState: x,
    ref: n,
    className: Ne(S.root, u)
  }, p, {
    classes: S
  }));
});
process.env.NODE_ENV !== "production" && (S0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: r.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: r.oneOfType([r.oneOf(["normal", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function bre(e) {
  return pt("MuiLinearProgress", e);
}
ht("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const xre = ["className", "color", "value", "valueBuffer", "variant"];
let wv = (e) => e, LL, FL, jL, VL, BL, zL;
const q$ = 4, Sre = tl(LL || (LL = wv`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), Cre = tl(FL || (FL = wv`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), wre = tl(jL || (jL = wv`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), Tre = (e) => {
  const {
    classes: t,
    variant: n,
    color: o
  } = e, s = {
    root: ["root", `color${Ae(o)}`, n],
    dashed: ["dashed", `dashedColor${Ae(o)}`],
    bar1: ["bar", `barColor${Ae(o)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", n !== "buffer" && `barColor${Ae(o)}`, n === "buffer" && `color${Ae(o)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return vt(s, bre, t);
}, ck = (e, t) => t === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? Uw(e.palette[t].main, 0.62) : zw(e.palette[t].main, 0.5), Ere = ce("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${Ae(n.color)}`], t[n.variant]];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: ck(t, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), Rre = ce("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.dashed, t[`dashedColor${Ae(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const n = ck(t, e.color);
  return O({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, Bc(VL || (VL = wv`
    animation: ${0} 3s infinite linear;
  `), wre)), Ore = ce("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${Ae(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar1Indeterminate, n.variant === "determinate" && t.bar1Determinate, n.variant === "buffer" && t.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${q$}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${q$}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Bc(BL || (BL = wv`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), Sre)), Pre = ce("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${Ae(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar2Indeterminate, n.variant === "buffer" && t.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: ck(t, e.color),
  transition: `transform .${q$}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Bc(zL || (zL = wv`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), Cre)), Tz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: s,
    color: l = "primary",
    value: u,
    valueBuffer: p,
    variant: h = "indeterminate"
  } = o, m = Te(o, xre), b = O({}, o, {
    color: l,
    variant: h
  }), x = Tre(b), S = Go(), R = {}, T = {
    bar1: {},
    bar2: {}
  };
  if (h === "determinate" || h === "buffer")
    if (u !== void 0) {
      R["aria-valuenow"] = Math.round(u), R["aria-valuemin"] = 0, R["aria-valuemax"] = 100;
      let E = u - 100;
      S.direction === "rtl" && (E = -E), T.bar1.transform = `translateX(${E}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (h === "buffer")
    if (p !== void 0) {
      let E = (p || 0) - 100;
      S.direction === "rtl" && (E = -E), T.bar2.transform = `translateX(${E}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ qe(Ere, O({
    className: Ne(x.root, s),
    ownerState: b,
    role: "progressbar"
  }, R, {
    ref: n
  }, m, {
    children: [h === "buffer" ? /* @__PURE__ */ I(Rre, {
      className: x.dashed,
      ownerState: b
    }) : null, /* @__PURE__ */ I(Ore, {
      className: x.bar1,
      ownerState: b,
      style: T.bar1
    }), h === "determinate" ? null : /* @__PURE__ */ I(Pre, {
      className: x.bar2,
      ownerState: b,
      style: T.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Tz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: r.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: r.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: r.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function $re(e) {
  return pt("MuiLink", e);
}
const Dre = ht("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), Ez = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, kre = (e) => Ez[e] || e, Mre = ({
  theme: e,
  ownerState: t
}) => {
  const n = kre(t.color), o = lv(e, `palette.${n}`, !1) || t.color, s = lv(e, `palette.${n}Channel`);
  return "vars" in e && s ? `rgba(${s} / 0.4)` : Mt(o, 0.4);
}, Nre = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], Ire = (e) => {
  const {
    classes: t,
    component: n,
    focusVisible: o,
    underline: s
  } = e, l = {
    root: ["root", `underline${Ae(s)}`, n === "button" && "button", o && "focusVisible"]
  };
  return vt(l, $re, t);
}, _re = ce(nr, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`underline${Ae(n.underline)}`], n.component === "button" && t.button];
  }
})(({
  theme: e,
  ownerState: t
}) => O({}, t.underline === "none" && {
  textDecoration: "none"
}, t.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, t.underline === "always" && O({
  textDecoration: "underline"
}, t.color !== "inherit" && {
  textDecorationColor: Mre({
    theme: e,
    ownerState: t
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), t.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Dre.focusVisible}`]: {
    outline: "auto"
  }
})), Rz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiLink"
  }), {
    className: s,
    color: l = "primary",
    component: u = "a",
    onBlur: p,
    onFocus: h,
    TypographyClasses: m,
    underline: b = "always",
    variant: x = "inherit",
    sx: S
  } = o, R = Te(o, Nre), {
    isFocusVisibleRef: T,
    onBlur: E,
    onFocus: P,
    ref: k
  } = Cw(), [_, L] = D.useState(!1), F = Gn(n, k), N = (ee) => {
    E(ee), T.current === !1 && L(!1), p && p(ee);
  }, V = (ee) => {
    P(ee), T.current === !0 && L(!0), h && h(ee);
  }, z = O({}, o, {
    color: l,
    component: u,
    focusVisible: _,
    underline: b,
    variant: x
  }), H = Ire(z);
  return /* @__PURE__ */ I(_re, O({
    color: l,
    className: Ne(H.root, s),
    classes: m,
    component: u,
    onBlur: N,
    onFocus: V,
    ref: F,
    ownerState: z,
    variant: x,
    sx: [...Object.keys(Ez).includes(l) ? [] : [{
      color: l
    }], ...Array.isArray(S) ? S : [S]]
  }, R));
});
process.env.NODE_ENV !== "production" && (Rz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: r.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: yv,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: r.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: r.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: r.oneOfType([r.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), r.string])
});
const el = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (el.displayName = "ListContext");
function Are(e) {
  return pt("MuiList", e);
}
ht("MuiList", ["root", "padding", "dense", "subheader"]);
const Lre = ["children", "className", "component", "dense", "disablePadding", "subheader"], Fre = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: o,
    subheader: s
  } = e;
  return vt({
    root: ["root", !n && "padding", o && "dense", s && "subheader"]
  }, Are, t);
}, jre = ce("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => O({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), Tv = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiList"
  }), {
    children: s,
    className: l,
    component: u = "ul",
    dense: p = !1,
    disablePadding: h = !1,
    subheader: m
  } = o, b = Te(o, Lre), x = D.useMemo(() => ({
    dense: p
  }), [p]), S = O({}, o, {
    component: u,
    dense: p,
    disablePadding: h
  }), R = Fre(S);
  return /* @__PURE__ */ I(el.Provider, {
    value: x,
    children: /* @__PURE__ */ qe(jre, O({
      as: u,
      className: Ne(R.root, l),
      ref: n,
      ownerState: S
    }, b, {
      children: [m, s]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Tv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: r.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Vre(e) {
  return pt("MuiListItem", e);
}
const $m = ht("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]);
function Bre(e) {
  return pt("MuiListItemButton", e);
}
const Dm = ht("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), zre = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], Ure = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters];
}, Hre = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: o,
    disabled: s,
    disableGutters: l,
    divider: u,
    selected: p
  } = e, m = vt({
    root: ["root", o && "dense", !l && "gutters", u && "divider", s && "disabled", t === "flex-start" && "alignItemsFlexStart", p && "selected"]
  }, Bre, n);
  return O({}, n, m);
}, Wre = ce(ui, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: Ure
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Dm.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Dm.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Dm.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Dm.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Dm.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), Oz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: s = "center",
    autoFocus: l = !1,
    component: u = "div",
    children: p,
    dense: h = !1,
    disableGutters: m = !1,
    divider: b = !1,
    focusVisibleClassName: x,
    selected: S = !1,
    className: R
  } = o, T = Te(o, zre), E = D.useContext(el), P = D.useMemo(() => ({
    dense: h || E.dense || !1,
    alignItems: s,
    disableGutters: m
  }), [s, E.dense, h, m]), k = D.useRef(null);
  $a(() => {
    l && (k.current ? k.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [l]);
  const _ = O({}, o, {
    alignItems: s,
    dense: P.dense,
    disableGutters: m,
    divider: b,
    selected: S
  }), L = Hre(_), F = Gn(k, n);
  return /* @__PURE__ */ I(el.Provider, {
    value: P,
    children: /* @__PURE__ */ I(Wre, O({
      ref: F,
      href: T.href || T.to,
      component: (T.href || T.to) && u === "div" ? "button" : u,
      focusVisibleClassName: Ne(L.focusVisible, x),
      ownerState: _,
      className: Ne(L.root, R)
    }, T, {
      classes: L,
      children: p
    }))
  });
});
process.env.NODE_ENV !== "production" && (Oz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: r.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  href: r.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function qre(e) {
  return pt("MuiListItemSecondaryAction", e);
}
ht("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const Yre = ["className"], Gre = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return vt({
    root: ["root", t && "disableGutters"]
  }, qre, n);
}, Kre = ce("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => O({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), uk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: s
  } = o, l = Te(o, Yre), u = D.useContext(el), p = O({}, o, {
    disableGutters: u.disableGutters
  }), h = Gre(p);
  return /* @__PURE__ */ I(Kre, O({
    className: Ne(h.root, s),
    ownerState: p,
    ref: n
  }, l));
});
process.env.NODE_ENV !== "production" && (uk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
uk.muiName = "ListItemSecondaryAction";
const Xre = ["className"], Qre = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], Jre = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.button && t.button, n.hasSecondaryAction && t.secondaryAction];
}, Zre = (e) => {
  const {
    alignItems: t,
    button: n,
    classes: o,
    dense: s,
    disabled: l,
    disableGutters: u,
    disablePadding: p,
    divider: h,
    hasSecondaryAction: m,
    selected: b
  } = e;
  return vt({
    root: ["root", s && "dense", !u && "gutters", !p && "padding", h && "divider", l && "disabled", n && "button", t === "flex-start" && "alignItemsFlexStart", m && "secondaryAction", b && "selected"],
    container: ["container"]
  }, Vre, o);
}, eoe = ce("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: Jre
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && O({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${Dm.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${$m.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${$m.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${$m.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${$m.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${$m.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), toe = ce("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), C0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: s = "center",
    autoFocus: l = !1,
    button: u = !1,
    children: p,
    className: h,
    component: m,
    components: b = {},
    componentsProps: x = {},
    ContainerComponent: S = "li",
    ContainerProps: {
      className: R
    } = {},
    dense: T = !1,
    disabled: E = !1,
    disableGutters: P = !1,
    disablePadding: k = !1,
    divider: _ = !1,
    focusVisibleClassName: L,
    secondaryAction: F,
    selected: N = !1,
    slotProps: V = {},
    slots: z = {}
  } = o, H = Te(o.ContainerProps, Xre), ee = Te(o, Qre), K = D.useContext(el), X = D.useMemo(() => ({
    dense: T || K.dense || !1,
    alignItems: s,
    disableGutters: P
  }), [s, K.dense, T, P]), ne = D.useRef(null);
  $a(() => {
    l && (ne.current ? ne.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [l]);
  const Y = D.Children.toArray(p), J = Y.length && Jm(Y[Y.length - 1], ["ListItemSecondaryAction"]), te = O({}, o, {
    alignItems: s,
    autoFocus: l,
    button: u,
    dense: X.dense,
    disabled: E,
    disableGutters: P,
    disablePadding: k,
    divider: _,
    hasSecondaryAction: J,
    selected: N
  }), Z = Zre(te), ae = Gn(ne, n), U = z.root || b.Root || eoe, G = V.root || x.root || {}, W = O({
    className: Ne(Z.root, G.className, h),
    disabled: E
  }, ee);
  let le = m || "li";
  return u && (W.component = m || "div", W.focusVisibleClassName = Ne($m.focusVisible, L), le = ui), J ? (le = !W.component && !m ? "div" : le, S === "li" && (le === "li" ? le = "div" : W.component === "li" && (W.component = "div")), /* @__PURE__ */ I(el.Provider, {
    value: X,
    children: /* @__PURE__ */ qe(toe, O({
      as: S,
      className: Ne(Z.container, R),
      ref: ae,
      ownerState: te
    }, H, {
      children: [/* @__PURE__ */ I(U, O({}, G, !Zf(U) && {
        as: le,
        ownerState: O({}, te, G.ownerState)
      }, W, {
        children: Y
      })), Y.pop()]
    }))
  })) : /* @__PURE__ */ I(el.Provider, {
    value: X,
    children: /* @__PURE__ */ qe(U, O({}, G, {
      as: le,
      ref: ae
    }, !Zf(U) && {
      ownerState: O({}, te, G.ownerState)
    }, W, {
      children: [Y, F && /* @__PURE__ */ I(uk, {
        children: F
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (C0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: r.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: r.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: r.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: Pa(r.node, (e) => {
    const t = D.Children.toArray(e.children);
    let n = -1;
    for (let o = t.length - 1; o >= 0; o -= 1) {
      const s = t[o];
      if (Jm(s, ["ListItemSecondaryAction"])) {
        n = o;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    root: r.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: yv,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: r.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: r.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: r.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: r.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: r.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const UL = ht("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function noe(e) {
  return pt("MuiListItemText", e);
}
const Q1 = ht("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), roe = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], ooe = (e) => {
  const {
    classes: t,
    inset: n,
    primary: o,
    secondary: s,
    dense: l
  } = e;
  return vt({
    root: ["root", n && "inset", l && "dense", o && s && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, noe, t);
}, aoe = ce("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Q1.primary}`]: t.primary
    }, {
      [`& .${Q1.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})(({
  ownerState: e
}) => O({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), dk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiListItemText"
  }), {
    children: s,
    className: l,
    disableTypography: u = !1,
    inset: p = !1,
    primary: h,
    primaryTypographyProps: m,
    secondary: b,
    secondaryTypographyProps: x
  } = o, S = Te(o, roe), {
    dense: R
  } = D.useContext(el);
  let T = h ?? s, E = b;
  const P = O({}, o, {
    disableTypography: u,
    inset: p,
    primary: !!T,
    secondary: !!E,
    dense: R
  }), k = ooe(P);
  return T != null && T.type !== nr && !u && (T = /* @__PURE__ */ I(nr, O({
    variant: R ? "body2" : "body1",
    className: k.primary,
    component: m != null && m.variant ? void 0 : "span",
    display: "block"
  }, m, {
    children: T
  }))), E != null && E.type !== nr && !u && (E = /* @__PURE__ */ I(nr, O({
    variant: "body2",
    className: k.secondary,
    color: "text.secondary",
    display: "block"
  }, x, {
    children: E
  }))), /* @__PURE__ */ qe(aoe, O({
    className: Ne(k.root, l),
    ownerState: P,
    ref: n
  }, S, {
    children: [T, E]
  }));
});
process.env.NODE_ENV !== "production" && (dk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: r.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: r.bool,
  /**
   * The main content element.
   */
  primary: r.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: r.object,
  /**
   * The secondary content element.
   */
  secondary: r.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const ioe = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function r$(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function HL(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function Pz(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function rb(e, t, n, o, s, l) {
  let u = !1, p = s(e, t, t ? n : !1);
  for (; p; ) {
    if (p === e.firstChild) {
      if (u)
        return !1;
      u = !0;
    }
    const h = o ? !1 : p.disabled || p.getAttribute("aria-disabled") === "true";
    if (!p.hasAttribute("tabindex") || !Pz(p, l) || h)
      p = s(e, p, n);
    else
      return p.focus(), !0;
  }
  return !1;
}
const hT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: s = !1,
    autoFocusItem: l = !1,
    children: u,
    className: p,
    disabledItemsFocusable: h = !1,
    disableListWrap: m = !1,
    onKeyDown: b,
    variant: x = "selectedMenu"
  } = t, S = Te(t, ioe), R = D.useRef(null), T = D.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  $a(() => {
    s && R.current.focus();
  }, [s]), D.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: (L, F) => {
      const N = !R.current.style.width;
      if (L.clientHeight < R.current.clientHeight && N) {
        const V = `${nB(no(L))}px`;
        R.current.style[F.direction === "rtl" ? "paddingLeft" : "paddingRight"] = V, R.current.style.width = `calc(100% + ${V})`;
      }
      return R.current;
    }
  }), []);
  const E = (L) => {
    const F = R.current, N = L.key, V = no(F).activeElement;
    if (N === "ArrowDown")
      L.preventDefault(), rb(F, V, m, h, r$);
    else if (N === "ArrowUp")
      L.preventDefault(), rb(F, V, m, h, HL);
    else if (N === "Home")
      L.preventDefault(), rb(F, null, m, h, r$);
    else if (N === "End")
      L.preventDefault(), rb(F, null, m, h, HL);
    else if (N.length === 1) {
      const z = T.current, H = N.toLowerCase(), ee = performance.now();
      z.keys.length > 0 && (ee - z.lastTime > 500 ? (z.keys = [], z.repeating = !0, z.previousKeyMatched = !0) : z.repeating && H !== z.keys[0] && (z.repeating = !1)), z.lastTime = ee, z.keys.push(H);
      const K = V && !z.repeating && Pz(V, z);
      z.previousKeyMatched && (K || rb(F, V, !1, h, r$, z)) ? L.preventDefault() : z.previousKeyMatched = !1;
    }
    b && b(L);
  }, P = Gn(R, n);
  let k = -1;
  D.Children.forEach(u, (L, F) => {
    if (!/* @__PURE__ */ D.isValidElement(L)) {
      k === F && (k += 1, k >= u.length && (k = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && jc.isFragment(L) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), L.props.disabled || (x === "selectedMenu" && L.props.selected || k === -1) && (k = F), k === F && (L.props.disabled || L.props.muiSkipListHighlight || L.type.muiSkipListHighlight) && (k += 1, k >= u.length && (k = -1));
  });
  const _ = D.Children.map(u, (L, F) => {
    if (F === k) {
      const N = {};
      return l && (N.autoFocus = !0), L.props.tabIndex === void 0 && x === "selectedMenu" && (N.tabIndex = 0), /* @__PURE__ */ D.cloneElement(L, N);
    }
    return L;
  });
  return /* @__PURE__ */ I(Tv, O({
    role: "menu",
    ref: P,
    className: p,
    onKeyDown: E,
    tabIndex: s ? 0 : -1
  }, S, {
    children: _
  }));
});
process.env.NODE_ENV !== "production" && (hT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: r.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: r.node,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: r.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: r.bool,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: r.oneOf(["menu", "selectedMenu"])
});
function soe(e) {
  return pt("MuiPopover", e);
}
ht("MuiPopover", ["root", "paper"]);
const loe = ["onEntering"], coe = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], uoe = ["slotProps"];
function WL(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function qL(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function YL(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function $1(e) {
  return typeof e == "function" ? e() : e;
}
const doe = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"],
    paper: ["paper"]
  }, soe, t);
}, foe = ce(rT, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), $z = ce(ms, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), fk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l;
  const u = We({
    props: t,
    name: "MuiPopover"
  }), {
    action: p,
    anchorEl: h,
    anchorOrigin: m = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: b,
    anchorReference: x = "anchorEl",
    children: S,
    className: R,
    container: T,
    elevation: E = 8,
    marginThreshold: P = 16,
    open: k,
    PaperProps: _ = {},
    slots: L,
    slotProps: F,
    transformOrigin: N = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: V = pv,
    transitionDuration: z = "auto",
    TransitionProps: {
      onEntering: H
    } = {},
    disableScrollLock: ee = !1
  } = u, K = Te(u.TransitionProps, loe), X = Te(u, coe), ne = (o = F == null ? void 0 : F.paper) != null ? o : _, Y = D.useRef(), J = Gn(Y, ne.ref), te = O({}, u, {
    anchorOrigin: m,
    anchorReference: x,
    elevation: E,
    marginThreshold: P,
    externalPaperSlotProps: ne,
    transformOrigin: N,
    TransitionComponent: V,
    transitionDuration: z,
    TransitionProps: K
  }), Z = doe(te), ae = D.useCallback(() => {
    if (x === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (b || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), b;
    const fe = $1(h), ye = fe && fe.nodeType === 1 ? fe : no(Y.current).body, Ee = ye.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const _e = ye.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && _e.top === 0 && _e.left === 0 && _e.right === 0 && _e.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Ee.top + WL(Ee, m.vertical),
      left: Ee.left + qL(Ee, m.horizontal)
    };
  }, [h, m.horizontal, m.vertical, b, x]), U = D.useCallback((fe) => ({
    vertical: WL(fe, N.vertical),
    horizontal: qL(fe, N.horizontal)
  }), [N.horizontal, N.vertical]), G = D.useCallback((fe) => {
    const ye = {
      width: fe.offsetWidth,
      height: fe.offsetHeight
    }, Ee = U(ye);
    if (x === "none")
      return {
        top: null,
        left: null,
        transformOrigin: YL(Ee)
      };
    const _e = ae();
    let Ve = _e.top - Ee.vertical, Re = _e.left - Ee.horizontal;
    const lt = Ve + ye.height, Pt = Re + ye.width, at = us($1(h)), it = at.innerHeight - P, bt = at.innerWidth - P;
    if (P !== null && Ve < P) {
      const Nt = Ve - P;
      Ve -= Nt, Ee.vertical += Nt;
    } else if (P !== null && lt > it) {
      const Nt = lt - it;
      Ve -= Nt, Ee.vertical += Nt;
    }
    if (process.env.NODE_ENV !== "production" && ye.height > it && ye.height && it && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ye.height - it}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), P !== null && Re < P) {
      const Nt = Re - P;
      Re -= Nt, Ee.horizontal += Nt;
    } else if (Pt > bt) {
      const Nt = Pt - bt;
      Re -= Nt, Ee.horizontal += Nt;
    }
    return {
      top: `${Math.round(Ve)}px`,
      left: `${Math.round(Re)}px`,
      transformOrigin: YL(Ee)
    };
  }, [h, x, ae, U, P]), [W, le] = D.useState(k), pe = D.useCallback(() => {
    const fe = Y.current;
    if (!fe)
      return;
    const ye = G(fe);
    ye.top !== null && (fe.style.top = ye.top), ye.left !== null && (fe.style.left = ye.left), fe.style.transformOrigin = ye.transformOrigin, le(!0);
  }, [G]);
  D.useEffect(() => (ee && window.addEventListener("scroll", pe), () => window.removeEventListener("scroll", pe)), [h, ee, pe]);
  const ge = (fe, ye) => {
    H && H(fe, ye), pe();
  }, we = () => {
    le(!1);
  };
  D.useEffect(() => {
    k && pe();
  }), D.useImperativeHandle(p, () => k ? {
    updatePosition: () => {
      pe();
    }
  } : null, [k, pe]), D.useEffect(() => {
    if (!k)
      return;
    const fe = bv(() => {
      pe();
    }), ye = us(h);
    return ye.addEventListener("resize", fe), () => {
      fe.clear(), ye.removeEventListener("resize", fe);
    };
  }, [h, k, pe]);
  let de = z;
  z === "auto" && !V.muiSupportAuto && (de = void 0);
  const se = T || (h ? no($1(h)).body : void 0), ve = (s = L == null ? void 0 : L.root) != null ? s : foe, me = (l = L == null ? void 0 : L.paper) != null ? l : $z, Oe = Li({
    elementType: me,
    externalSlotProps: O({}, ne, {
      style: W ? ne.style : O({}, ne.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: E,
      ref: J
    },
    ownerState: te,
    className: Ne(Z.paper, ne == null ? void 0 : ne.className)
  }), be = Li({
    elementType: ve,
    externalSlotProps: (F == null ? void 0 : F.root) || {},
    externalForwardedProps: X,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: se,
      open: k
    },
    ownerState: te,
    className: Ne(Z.root, R)
  }), {
    slotProps: De
  } = be, ie = Te(be, uoe);
  return /* @__PURE__ */ I(ve, O({}, ie, !Zf(ve) && {
    slotProps: De,
    disableScrollLock: ee
  }, {
    children: /* @__PURE__ */ I(V, O({
      appear: !0,
      in: k,
      onEntering: ge,
      onExited: we,
      timeout: de
    }, K, {
      children: /* @__PURE__ */ I(me, O({}, Oe, {
        children: S
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (fk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Yo,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Pa(r.oneOfType([Hl, r.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = $1(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: r.shape({
    horizontal: r.oneOfType([r.oneOf(["center", "left", "right"]), r.number]).isRequired,
    vertical: r.oneOfType([r.oneOf(["bottom", "center", "top"]), r.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: r.shape({
    left: r.number.isRequired,
    top: r.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: r.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Hl, r.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: r.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Lc,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: r.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: r.shape({
    component: yv
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: r.shape({
    paper: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.shape({
    paper: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: r.shape({
    horizontal: r.oneOfType([r.oneOf(["center", "left", "right"]), r.number]).isRequired,
    vertical: r.oneOfType([r.oneOf(["bottom", "center", "top"]), r.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: r.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: r.object
});
function poe(e) {
  return pt("MuiMenu", e);
}
ht("MuiMenu", ["root", "paper", "list"]);
const hoe = ["onEntering"], moe = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], voe = {
  vertical: "top",
  horizontal: "right"
}, goe = {
  vertical: "top",
  horizontal: "left"
}, yoe = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, poe, t);
}, boe = ce(fk, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), xoe = ce($z, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Soe = ce(hT, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Dz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s;
  const l = We({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: u = !0,
    children: p,
    className: h,
    disableAutoFocusItem: m = !1,
    MenuListProps: b = {},
    onClose: x,
    open: S,
    PaperProps: R = {},
    PopoverClasses: T,
    transitionDuration: E = "auto",
    TransitionProps: {
      onEntering: P
    } = {},
    variant: k = "selectedMenu",
    slots: _ = {},
    slotProps: L = {}
  } = l, F = Te(l.TransitionProps, hoe), N = Te(l, moe), V = Go(), z = V.direction === "rtl", H = O({}, l, {
    autoFocus: u,
    disableAutoFocusItem: m,
    MenuListProps: b,
    onEntering: P,
    PaperProps: R,
    transitionDuration: E,
    TransitionProps: F,
    variant: k
  }), ee = yoe(H), K = u && !m && S, X = D.useRef(null), ne = (G, W) => {
    X.current && X.current.adjustStyleForScrollbar(G, V), P && P(G, W);
  }, Y = (G) => {
    G.key === "Tab" && (G.preventDefault(), x && x(G, "tabKeyDown"));
  };
  let J = -1;
  D.Children.map(p, (G, W) => {
    /* @__PURE__ */ D.isValidElement(G) && (process.env.NODE_ENV !== "production" && jc.isFragment(G) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), G.props.disabled || (k === "selectedMenu" && G.props.selected || J === -1) && (J = W));
  });
  const te = (o = _.paper) != null ? o : xoe, Z = (s = L.paper) != null ? s : R, ae = Li({
    elementType: _.root,
    externalSlotProps: L.root,
    ownerState: H,
    className: [ee.root, h]
  }), U = Li({
    elementType: te,
    externalSlotProps: Z,
    ownerState: H,
    className: ee.paper
  });
  return /* @__PURE__ */ I(boe, O({
    onClose: x,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: z ? "right" : "left"
    },
    transformOrigin: z ? voe : goe,
    slots: {
      paper: te,
      root: _.root
    },
    slotProps: {
      root: ae,
      paper: U
    },
    open: S,
    ref: n,
    transitionDuration: E,
    TransitionProps: O({
      onEntering: ne
    }, F),
    ownerState: H
  }, N, {
    classes: T,
    children: /* @__PURE__ */ I(Soe, O({
      onKeyDown: Y,
      actions: X,
      autoFocus: u && (J === -1 || m),
      autoFocusItem: K,
      variant: k
    }, b, {
      className: Ne(ee.list, b.className),
      children: p
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Dz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: r.oneOfType([Hl, r.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: r.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: r.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: r.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: r.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: r.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: r.shape({
    paper: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.shape({
    paper: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: r.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: r.oneOf(["menu", "selectedMenu"])
});
function Coe(e) {
  return pt("MuiMenuItem", e);
}
const ob = ht("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), woe = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], Toe = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, Eoe = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: o,
    disableGutters: s,
    selected: l,
    classes: u
  } = e, h = vt({
    root: ["root", n && "dense", t && "disabled", !s && "gutters", o && "divider", l && "selected"]
  }, Coe, u);
  return O({}, u, h);
}, Roe = ce(ui, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: Toe
})(({
  theme: e,
  ownerState: t
}) => O({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${ob.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${ob.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${ob.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${ob.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${ob.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${kL.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${kL.inset}`]: {
    marginLeft: 52
  },
  [`& .${Q1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Q1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${UL.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && O({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${UL.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), Ev = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: l = "li",
    dense: u = !1,
    divider: p = !1,
    disableGutters: h = !1,
    focusVisibleClassName: m,
    role: b = "menuitem",
    tabIndex: x,
    className: S
  } = o, R = Te(o, woe), T = D.useContext(el), E = D.useMemo(() => ({
    dense: u || T.dense || !1,
    disableGutters: h
  }), [T.dense, u, h]), P = D.useRef(null);
  $a(() => {
    s && (P.current ? P.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const k = O({}, o, {
    dense: E.dense,
    divider: p,
    disableGutters: h
  }), _ = Eoe(o), L = Gn(P, n);
  let F;
  return o.disabled || (F = x !== void 0 ? x : -1), /* @__PURE__ */ I(el.Provider, {
    value: E,
    children: /* @__PURE__ */ I(Roe, O({
      ref: L,
      role: b,
      tabIndex: F,
      component: l,
      focusVisibleClassName: Ne(_.focusVisible, m),
      className: Ne(_.root, S)
    }, R, {
      ownerState: k,
      classes: _
    }))
  });
});
process.env.NODE_ENV !== "production" && (Ev.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: r.bool,
  /**
   * @ignore
   */
  disabled: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  role: r.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number
});
function Ooe(e) {
  return pt("MuiNativeSelect", e);
}
const pk = ht("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), Poe = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], $oe = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: l,
    error: u
  } = e, p = {
    select: ["select", n, o && "disabled", s && "multiple", u && "error"],
    icon: ["icon", `icon${Ae(n)}`, l && "iconOpen", o && "disabled"]
  };
  return vt(p, Ooe, t);
}, kz = ({
  ownerState: e,
  theme: t
}) => O({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": O({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${pk.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), Doe = ce("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Do,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${pk.multiple}`]: t.multiple
    }];
  }
})(kz), Mz = ({
  ownerState: e,
  theme: t
}) => O({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${pk.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), koe = ce("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ae(n.variant)}`], n.open && t.iconOpen];
  }
})(Mz), Nz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    className: o,
    disabled: s,
    error: l,
    IconComponent: u,
    inputRef: p,
    variant: h = "standard"
  } = t, m = Te(t, Poe), b = O({}, t, {
    disabled: s,
    variant: h,
    error: l
  }), x = $oe(b);
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ I(Doe, O({
      ownerState: b,
      className: Ne(x.select, o),
      disabled: s,
      ref: p || n
    }, m)), t.multiple ? null : /* @__PURE__ */ I(koe, {
      as: u,
      ownerState: b,
      className: x.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (Nz.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * The CSS class name of the select element.
   */
  className: r.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: r.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: r.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Yo,
  /**
   * @ignore
   */
  multiple: r.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: r.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The input value.
   */
  value: r.any,
  /**
   * The variant to use.
   */
  variant: r.oneOf(["standard", "outlined", "filled"])
});
var GL;
const Moe = ["children", "classes", "className", "label", "notched"], Noe = ce("fieldset", {
  shouldForwardProp: Do
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), Ioe = ce("legend", {
  shouldForwardProp: Do
})(({
  ownerState: e,
  theme: t
}) => O({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && O({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function Iz(e) {
  const {
    className: t,
    label: n,
    notched: o
  } = e, s = Te(e, Moe), l = n != null && n !== "", u = O({}, e, {
    notched: o,
    withLabel: l
  });
  return /* @__PURE__ */ I(Noe, O({
    "aria-hidden": !0,
    className: t,
    ownerState: u
  }, s, {
    children: /* @__PURE__ */ I(Ioe, {
      ownerState: u,
      children: l ? /* @__PURE__ */ I("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        GL || (GL = /* @__PURE__ */ I("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (Iz.propTypes = {
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The label.
   */
  label: r.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: r.bool.isRequired,
  /**
   * @ignore
   */
  style: r.object
});
const _oe = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], Aoe = (e) => {
  const {
    classes: t
  } = e, o = vt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, ZZ, t);
  return O({}, t, o);
}, Loe = ce(Qw, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: Kw
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return O({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Nl.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Nl.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${Nl.focused} .${Nl.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Nl.error} .${Nl.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Nl.disabled} .${Nl.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && O({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), Foe = ce(Iz, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), joe = ce(Jw, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Xw
})(({
  theme: e,
  ownerState: t
}) => O({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), w0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u, p;
  const h = We({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: m = {},
    fullWidth: b = !1,
    inputComponent: x = "input",
    label: S,
    multiline: R = !1,
    notched: T,
    slots: E = {},
    type: P = "text"
  } = h, k = Te(h, _oe), _ = Aoe(h), L = mi(), F = Sd({
    props: h,
    muiFormControl: L,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), N = O({}, h, {
    color: F.color || "primary",
    disabled: F.disabled,
    error: F.error,
    focused: F.focused,
    formControl: L,
    fullWidth: b,
    hiddenLabel: F.hiddenLabel,
    multiline: R,
    size: F.size,
    type: P
  }), V = (o = (s = E.root) != null ? s : m.Root) != null ? o : Loe, z = (l = (u = E.input) != null ? u : m.Input) != null ? l : joe;
  return /* @__PURE__ */ I(Zw, O({
    slots: {
      root: V,
      input: z
    },
    renderSuffix: (H) => /* @__PURE__ */ I(Foe, {
      ownerState: N,
      className: _.notchedOutline,
      label: S != null && S !== "" && F.required ? p || (p = /* @__PURE__ */ qe(D.Fragment, {
        children: [S, " ", "*"]
      })) : S,
      notched: typeof T < "u" ? T : !!(H.startAdornment || H.filled || H.focused)
    }),
    fullWidth: b,
    inputComponent: x,
    multiline: R,
    ref: n,
    type: P
  }, k, {
    classes: O({}, _, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (w0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: r.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: r.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
w0.muiName = "Input";
const Voe = lr(/* @__PURE__ */ I("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), Boe = lr(/* @__PURE__ */ I("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), zoe = lr(/* @__PURE__ */ I("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), Uoe = lr(/* @__PURE__ */ I("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Hoe = ce("span", {
  shouldForwardProp: Do
})({
  position: "relative",
  display: "flex"
}), Woe = ce(zoe)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), qoe = ce(Uoe)(({
  theme: e,
  ownerState: t
}) => O({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function hk(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: o
  } = e, s = O({}, e, {
    checked: t
  });
  return /* @__PURE__ */ qe(Hoe, {
    className: n.root,
    ownerState: s,
    children: [/* @__PURE__ */ I(Woe, {
      fontSize: o,
      className: n.background,
      ownerState: s
    }), /* @__PURE__ */ I(qoe, {
      fontSize: o,
      className: n.dot,
      ownerState: s
    })]
  });
}
process.env.NODE_ENV !== "production" && (hk.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: r.oneOf(["small", "medium"])
});
const mk = /* @__PURE__ */ D.createContext(void 0);
process.env.NODE_ENV !== "production" && (mk.displayName = "RadioGroupContext");
function Yoe() {
  return D.useContext(mk);
}
function Goe(e) {
  return pt("MuiRadio", e);
}
const KL = ht("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), Koe = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], Xoe = (e) => {
  const {
    classes: t,
    color: n,
    size: o
  } = e, s = {
    root: ["root", `color${Ae(n)}`, o !== "medium" && `size${Ae(o)}`]
  };
  return O({}, t, vt(s, Goe, t));
}, Qoe = ce(tT, {
  shouldForwardProp: (e) => Do(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${Ae(n.size)}`], t[`color${Ae(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${KL.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${KL.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function Joe(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const XL = /* @__PURE__ */ I(hk, {
  checked: !0
}), QL = /* @__PURE__ */ I(hk, {}), _z = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s;
  const l = We({
    props: t,
    name: "MuiRadio"
  }), {
    checked: u,
    checkedIcon: p = XL,
    color: h = "primary",
    icon: m = QL,
    name: b,
    onChange: x,
    size: S = "medium",
    className: R
  } = l, T = Te(l, Koe), E = O({}, l, {
    color: h,
    size: S
  }), P = Xoe(E), k = Yoe();
  let _ = u;
  const L = F1(x, k && k.onChange);
  let F = b;
  return k && (typeof _ > "u" && (_ = Joe(k.value, l.value)), typeof F > "u" && (F = k.name)), /* @__PURE__ */ I(Qoe, O({
    type: "radio",
    icon: /* @__PURE__ */ D.cloneElement(m, {
      fontSize: (o = QL.props.fontSize) != null ? o : S
    }),
    checkedIcon: /* @__PURE__ */ D.cloneElement(p, {
      fontSize: (s = XL.props.fontSize) != null ? s : S
    }),
    ownerState: E,
    classes: P,
    name: F,
    checked: _,
    onChange: L,
    ref: n,
    className: Ne(P.root, R)
  }, T));
});
process.env.NODE_ENV !== "production" && (_z.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: r.any
});
const Zoe = ["actions", "children", "defaultValue", "name", "onChange", "value"], Az = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    children: s,
    defaultValue: l,
    name: u,
    onChange: p,
    value: h
  } = t, m = Te(t, Zoe), b = D.useRef(null), [x, S] = jl({
    controlled: h,
    default: l,
    name: "RadioGroup"
  });
  D.useImperativeHandle(o, () => ({
    focus: () => {
      let P = b.current.querySelector("input:not(:disabled):checked");
      P || (P = b.current.querySelector("input:not(:disabled)")), P && P.focus();
    }
  }), []);
  const R = Gn(n, b), T = Vc(u), E = D.useMemo(() => ({
    name: T,
    onChange(P) {
      S(P.target.value), p && p(P, P.target.value);
    },
    value: x
  }), [T, p, S, x]);
  return /* @__PURE__ */ I(mk.Provider, {
    value: E,
    children: /* @__PURE__ */ I(sk, O({
      role: "radiogroup",
      ref: R
    }, m, {
      children: s
    }))
  });
});
process.env.NODE_ENV !== "production" && (Az.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: r.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: r.any
});
function eae(e) {
  return pt("MuiSelect", e);
}
const ab = ht("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var JL;
const tae = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], nae = ce("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${ab.select}`]: t.select
      },
      {
        [`&.${ab.select}`]: t[n.variant]
      },
      {
        [`&.${ab.error}`]: t.error
      },
      {
        [`&.${ab.multiple}`]: t.multiple
      }
    ];
  }
})(kz, {
  // Win specificity over the input base
  [`&.${ab.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), rae = ce("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ae(n.variant)}`], n.open && t.iconOpen];
  }
})(Mz), oae = ce("input", {
  shouldForwardProp: (e) => bX(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function ZL(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function aae(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const iae = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: l,
    error: u
  } = e, p = {
    select: ["select", n, o && "disabled", s && "multiple", u && "error"],
    icon: ["icon", `icon${Ae(n)}`, l && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return vt(p, eae, t);
}, Lz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const {
    "aria-describedby": s,
    "aria-label": l,
    autoFocus: u,
    autoWidth: p,
    children: h,
    className: m,
    defaultOpen: b,
    defaultValue: x,
    disabled: S,
    displayEmpty: R,
    error: T = !1,
    IconComponent: E,
    inputRef: P,
    labelId: k,
    MenuProps: _ = {},
    multiple: L,
    name: F,
    onBlur: N,
    onChange: V,
    onClose: z,
    onFocus: H,
    onOpen: ee,
    open: K,
    readOnly: X,
    renderValue: ne,
    SelectDisplayProps: Y = {},
    tabIndex: J,
    value: te,
    variant: Z = "standard"
  } = t, ae = Te(t, tae), [U, G] = jl({
    controlled: te,
    default: x,
    name: "Select"
  }), [W, le] = jl({
    controlled: K,
    default: b,
    name: "Select"
  }), pe = D.useRef(null), ge = D.useRef(null), [we, de] = D.useState(null), {
    current: se
  } = D.useRef(K != null), [ve, me] = D.useState(), Oe = Gn(n, P), be = D.useCallback((Xe) => {
    ge.current = Xe, Xe && de(Xe);
  }, []), De = we == null ? void 0 : we.parentNode;
  D.useImperativeHandle(Oe, () => ({
    focus: () => {
      ge.current.focus();
    },
    node: pe.current,
    value: U
  }), [U]), D.useEffect(() => {
    b && W && we && !se && (me(p ? null : De.clientWidth), ge.current.focus());
  }, [we, p]), D.useEffect(() => {
    u && ge.current.focus();
  }, [u]), D.useEffect(() => {
    if (!k)
      return;
    const Xe = no(ge.current).getElementById(k);
    if (Xe) {
      const Be = () => {
        getSelection().isCollapsed && ge.current.focus();
      };
      return Xe.addEventListener("click", Be), () => {
        Xe.removeEventListener("click", Be);
      };
    }
  }, [k]);
  const ie = (Xe, Be) => {
    Xe ? ee && ee(Be) : z && z(Be), se || (me(p ? null : De.clientWidth), le(Xe));
  }, fe = (Xe) => {
    Xe.button === 0 && (Xe.preventDefault(), ge.current.focus(), ie(!0, Xe));
  }, ye = (Xe) => {
    ie(!1, Xe);
  }, Ee = D.Children.toArray(h), _e = (Xe) => {
    const Be = Ee.find((Qe) => Qe.props.value === Xe.target.value);
    Be !== void 0 && (G(Be.props.value), V && V(Xe, Be));
  }, Ve = (Xe) => (Be) => {
    let Qe;
    if (Be.currentTarget.hasAttribute("tabindex")) {
      if (L) {
        Qe = Array.isArray(U) ? U.slice() : [];
        const xt = U.indexOf(Xe.props.value);
        xt === -1 ? Qe.push(Xe.props.value) : Qe.splice(xt, 1);
      } else
        Qe = Xe.props.value;
      if (Xe.props.onClick && Xe.props.onClick(Be), U !== Qe && (G(Qe), V)) {
        const xt = Be.nativeEvent || Be, ct = new xt.constructor(xt.type, xt);
        Object.defineProperty(ct, "target", {
          writable: !0,
          value: {
            value: Qe,
            name: F
          }
        }), V(ct, Xe);
      }
      L || ie(!1, Be);
    }
  }, Re = (Xe) => {
    X || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Xe.key) !== -1 && (Xe.preventDefault(), ie(!0, Xe));
  }, lt = we !== null && W, Pt = (Xe) => {
    !lt && N && (Object.defineProperty(Xe, "target", {
      writable: !0,
      value: {
        value: U,
        name: F
      }
    }), N(Xe));
  };
  delete ae["aria-invalid"];
  let at, it;
  const bt = [];
  let Nt = !1, en = !1;
  (K1({
    value: U
  }) || R) && (ne ? at = ne(U) : Nt = !0);
  const fn = Ee.map((Xe) => {
    if (!/* @__PURE__ */ D.isValidElement(Xe))
      return null;
    process.env.NODE_ENV !== "production" && jc.isFragment(Xe) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Be;
    if (L) {
      if (!Array.isArray(U))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : dd(2));
      Be = U.some((Qe) => ZL(Qe, Xe.props.value)), Be && Nt && bt.push(Xe.props.children);
    } else
      Be = ZL(U, Xe.props.value), Be && Nt && (it = Xe.props.children);
    return Be && (en = !0), /* @__PURE__ */ D.cloneElement(Xe, {
      "aria-selected": Be ? "true" : "false",
      onClick: Ve(Xe),
      onKeyUp: (Qe) => {
        Qe.key === " " && Qe.preventDefault(), Xe.props.onKeyUp && Xe.props.onKeyUp(Qe);
      },
      role: "option",
      selected: Be,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Xe.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && D.useEffect(() => {
    if (!en && !L && U !== "") {
      const Xe = Ee.map((Be) => Be.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${U}\` for the select ${F ? `(name="${F}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Xe.filter((Be) => Be != null).map((Be) => `\`${Be}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [en, Ee, L, F, U]), Nt && (L ? bt.length === 0 ? at = null : at = bt.reduce((Xe, Be, Qe) => (Xe.push(Be), Qe < bt.length - 1 && Xe.push(", "), Xe), []) : at = it);
  let ln = ve;
  !p && se && we && (ln = De.clientWidth);
  let Rt;
  typeof J < "u" ? Rt = J : Rt = S ? null : 0;
  const rt = Y.id || (F ? `mui-component-select-${F}` : void 0), Qt = O({}, t, {
    variant: Z,
    value: U,
    open: lt,
    error: T
  }), et = iae(Qt), st = O({}, _.PaperProps, (o = _.slotProps) == null ? void 0 : o.paper), jt = Vc();
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ I(nae, O({
      ref: be,
      tabIndex: Rt,
      role: "combobox",
      "aria-controls": jt,
      "aria-disabled": S ? "true" : void 0,
      "aria-expanded": lt ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": l,
      "aria-labelledby": [k, rt].filter(Boolean).join(" ") || void 0,
      "aria-describedby": s,
      onKeyDown: Re,
      onMouseDown: S || X ? null : fe,
      onBlur: Pt,
      onFocus: H
    }, Y, {
      ownerState: Qt,
      className: Ne(Y.className, et.select, m),
      id: rt,
      children: aae(at) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        JL || (JL = /* @__PURE__ */ I("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : at
    })), /* @__PURE__ */ I(oae, O({
      "aria-invalid": T,
      value: Array.isArray(U) ? U.join(",") : U,
      name: F,
      ref: pe,
      "aria-hidden": !0,
      onChange: _e,
      tabIndex: -1,
      disabled: S,
      className: et.nativeInput,
      autoFocus: u,
      ownerState: Qt
    }, ae)), /* @__PURE__ */ I(rae, {
      as: E,
      className: et.icon,
      ownerState: Qt
    }), /* @__PURE__ */ I(Dz, O({
      id: `menu-${F || ""}`,
      anchorEl: De,
      open: lt,
      onClose: ye,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, _, {
      MenuListProps: O({
        "aria-labelledby": k,
        role: "listbox",
        "aria-multiselectable": L ? "true" : void 0,
        disableListWrap: !0,
        id: jt
      }, _.MenuListProps),
      slotProps: O({}, _.slotProps, {
        paper: O({}, st, {
          style: O({
            minWidth: ln
          }, st != null ? st.style : null)
        })
      }),
      children: fn
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Lz.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": r.string,
  /**
   * @ignore
   */
  "aria-label": r.string,
  /**
   * @ignore
   */
  autoFocus: r.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: r.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: r.object,
  /**
   * The CSS class name of the select element.
   */
  className: r.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: r.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: r.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: r.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: r.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Yo,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: r.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: r.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: r.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * @ignore
   */
  readOnly: r.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: r.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: r.object,
  /**
   * @ignore
   */
  tabIndex: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  type: r.any,
  /**
   * The input value.
   */
  value: r.any,
  /**
   * The variant to use.
   */
  variant: r.oneOf(["standard", "outlined", "filled"])
});
const sae = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], lae = ["root"], cae = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, vk = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Do(e) && e !== "variant",
  slot: "Root"
}, uae = ce(fT, vk)(""), dae = ce(w0, vk)(""), fae = ce(lT, vk)(""), T0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: s = !1,
    children: l,
    classes: u = {},
    className: p,
    defaultOpen: h = !1,
    displayEmpty: m = !1,
    IconComponent: b = dz,
    id: x,
    input: S,
    inputProps: R,
    label: T,
    labelId: E,
    MenuProps: P,
    multiple: k = !1,
    native: _ = !1,
    onClose: L,
    onOpen: F,
    open: N,
    renderValue: V,
    SelectDisplayProps: z,
    variant: H = "outlined"
  } = o, ee = Te(o, sae), K = _ ? Nz : Lz, X = mi(), ne = Sd({
    props: o,
    muiFormControl: X,
    states: ["variant", "error"]
  }), Y = ne.variant || H, J = O({}, o, {
    variant: Y,
    classes: u
  }), te = cae(J), Z = Te(te, lae), ae = S || {
    standard: /* @__PURE__ */ I(uae, {
      ownerState: J
    }),
    outlined: /* @__PURE__ */ I(dae, {
      label: T,
      ownerState: J
    }),
    filled: /* @__PURE__ */ I(fae, {
      ownerState: J
    })
  }[Y], U = Gn(n, ae.ref);
  return /* @__PURE__ */ I(D.Fragment, {
    children: /* @__PURE__ */ D.cloneElement(ae, O({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: K,
      inputProps: O({
        children: l,
        error: ne.error,
        IconComponent: b,
        variant: Y,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: k
      }, _ ? {
        id: x
      } : {
        autoWidth: s,
        defaultOpen: h,
        displayEmpty: m,
        labelId: E,
        MenuProps: P,
        onClose: L,
        onOpen: F,
        open: N,
        renderValue: V,
        SelectDisplayProps: O({
          id: x
        }, z)
      }, R, {
        classes: R ? ai(Z, R.classes) : Z
      }, S ? S.props.inputProps : {})
    }, (k && _ || m) && Y === "outlined" ? {
      notched: !0
    } : {}, {
      ref: U,
      className: Ne(ae.props.className, p, te.root)
    }, !S && {
      variant: Y
    }, ee))
  });
});
process.env.NODE_ENV !== "production" && (T0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: r.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: r.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: r.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: r.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: r.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: r.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: r.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: r.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: r.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: r.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: r.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: r.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: r.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: r.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: r.oneOfType([r.oneOf([""]), r.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
T0.muiName = "Select";
function pae(e) {
  return pt("MuiSkeleton", e);
}
ht("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const hae = ["animation", "className", "component", "height", "style", "variant", "width"];
let J1 = (e) => e, eF, tF, nF, rF;
const mae = (e) => {
  const {
    classes: t,
    variant: n,
    animation: o,
    hasChildren: s,
    width: l,
    height: u
  } = e;
  return vt({
    root: ["root", n, o, s && "withChildren", s && !l && "fitContent", s && !u && "heightAuto"]
  }, pae, t);
}, vae = tl(eF || (eF = J1`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), gae = tl(tF || (tF = J1`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), yae = ce("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = gX(e.shape.borderRadius) || "px", o = yX(e.shape.borderRadius);
  return O({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : Mt(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${o}${n}/${Math.round(o / 0.6 * 10) / 10}${n}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && Bc(nF || (nF = J1`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), vae), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && Bc(rF || (rF = J1`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), gae, (t.vars || t).palette.action.hover)), Y$ = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: s = "pulse",
    className: l,
    component: u = "span",
    height: p,
    style: h,
    variant: m = "text",
    width: b
  } = o, x = Te(o, hae), S = O({}, o, {
    animation: s,
    component: u,
    variant: m,
    hasChildren: !!x.children
  }), R = mae(S);
  return /* @__PURE__ */ I(yae, O({
    as: u,
    ref: n,
    className: Ne(R.root, l),
    ownerState: S
  }, x, {
    style: O({
      width: b,
      height: p
    }, h)
  }));
});
process.env.NODE_ENV !== "production" && (Y$.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: r.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: r.oneOfType([r.oneOf(["circular", "rectangular", "rounded", "text"]), r.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: r.oneOfType([r.number, r.string])
});
function bae(e) {
  return pt("MuiTooltip", e);
}
const ld = ht("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), xae = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function Sae(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Cae = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: o,
    touch: s,
    placement: l
  } = e, u = {
    popper: ["popper", !n && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", s && "touch", `tooltipPlacement${Ae(l.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return vt(u, bae, t);
}, wae = ce(ip, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => O({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${ld.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${ld.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${ld.arrow}`]: O({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${ld.arrow}`]: O({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), Tae = ce("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Ae(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Mt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${Sae(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${ld.popper}[data-popper-placement*="left"] &`]: O({
    transformOrigin: "right center"
  }, t.isRtl ? O({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : O({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${ld.popper}[data-popper-placement*="right"] &`]: O({
    transformOrigin: "left center"
  }, t.isRtl ? O({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : O({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${ld.popper}[data-popper-placement*="top"] &`]: O({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${ld.popper}[data-popper-placement*="bottom"] &`]: O({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), Eae = ce("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Mt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let c1 = !1;
const oF = new d0();
let ib = {
  x: 0,
  y: 0
};
function u1(e, t) {
  return (n) => {
    t && t(n), e(n);
  };
}
const Fz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u, p, h, m, b, x, S, R, T, E, P, k, _, L, F, N;
  const V = We({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: z = !1,
    children: H,
    components: ee = {},
    componentsProps: K = {},
    describeChild: X = !1,
    disableFocusListener: ne = !1,
    disableHoverListener: Y = !1,
    disableInteractive: J = !1,
    disableTouchListener: te = !1,
    enterDelay: Z = 100,
    enterNextDelay: ae = 0,
    enterTouchDelay: U = 700,
    followCursor: G = !1,
    id: W,
    leaveDelay: le = 0,
    leaveTouchDelay: pe = 1500,
    onClose: ge,
    onOpen: we,
    open: de,
    placement: se = "bottom",
    PopperComponent: ve,
    PopperProps: me = {},
    slotProps: Oe = {},
    slots: be = {},
    title: De,
    TransitionComponent: ie = pv,
    TransitionProps: fe
  } = V, ye = Te(V, xae), Ee = /* @__PURE__ */ D.isValidElement(H) ? H : /* @__PURE__ */ I("span", {
    children: H
  }), _e = Go(), Ve = _e.direction === "rtl", [Re, lt] = D.useState(), [Pt, at] = D.useState(null), it = D.useRef(!1), bt = J || G, Nt = Hf(), en = Hf(), fn = Hf(), ln = Hf(), [Rt, rt] = jl({
    controlled: de,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Qt = Rt;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: zt
    } = D.useRef(de !== void 0);
    D.useEffect(() => {
      Re && Re.disabled && !zt && De !== "" && Re.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [De, Re, zt]);
  }
  const et = Vc(W), st = D.useRef(), jt = qo(() => {
    st.current !== void 0 && (document.body.style.WebkitUserSelect = st.current, st.current = void 0), ln.clear();
  });
  D.useEffect(() => jt, [jt]);
  const Xe = (zt) => {
    oF.clear(), c1 = !0, rt(!0), we && !Qt && we(zt);
  }, Be = qo(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (zt) => {
      oF.start(800 + le, () => {
        c1 = !1;
      }), rt(!1), ge && Qt && ge(zt), Nt.start(_e.transitions.duration.shortest, () => {
        it.current = !1;
      });
    }
  ), Qe = (zt) => {
    it.current && zt.type !== "touchstart" || (Re && Re.removeAttribute("title"), en.clear(), fn.clear(), Z || c1 && ae ? en.start(c1 ? ae : Z, () => {
      Xe(zt);
    }) : Xe(zt));
  }, xt = (zt) => {
    en.clear(), fn.start(le, () => {
      Be(zt);
    });
  }, {
    isFocusVisibleRef: ct,
    onBlur: St,
    onFocus: tn,
    ref: Wt
  } = Cw(), [, dn] = D.useState(!1), hr = (zt) => {
    St(zt), ct.current === !1 && (dn(!1), xt(zt));
  }, yo = (zt) => {
    Re || lt(zt.currentTarget), tn(zt), ct.current === !0 && (dn(!0), Qe(zt));
  }, ka = (zt) => {
    it.current = !0;
    const Or = Ee.props;
    Or.onTouchStart && Or.onTouchStart(zt);
  }, Vi = Qe, ys = xt, bs = (zt) => {
    ka(zt), fn.clear(), Nt.clear(), jt(), st.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ln.start(U, () => {
      document.body.style.WebkitUserSelect = st.current, Qe(zt);
    });
  }, Ma = (zt) => {
    Ee.props.onTouchEnd && Ee.props.onTouchEnd(zt), jt(), fn.start(pe, () => {
      Be(zt);
    });
  };
  D.useEffect(() => {
    if (!Qt)
      return;
    function zt(Or) {
      (Or.key === "Escape" || Or.key === "Esc") && Be(Or);
    }
    return document.addEventListener("keydown", zt), () => {
      document.removeEventListener("keydown", zt);
    };
  }, [Be, Qt]);
  const rr = Gn(Ee.ref, Wt, lt, n);
  !De && De !== 0 && (Qt = !1);
  const Wn = D.useRef(), Cr = (zt) => {
    const Or = Ee.props;
    Or.onMouseMove && Or.onMouseMove(zt), ib = {
      x: zt.clientX,
      y: zt.clientY
    }, Wn.current && Wn.current.update();
  }, ko = {}, Lr = typeof De == "string";
  X ? (ko.title = !Qt && Lr && !Y ? De : null, ko["aria-describedby"] = Qt ? et : null) : (ko["aria-label"] = Lr ? De : null, ko["aria-labelledby"] = Qt && !Lr ? et : null);
  const Kn = O({}, ko, ye, Ee.props, {
    className: Ne(ye.className, Ee.props.className),
    onTouchStart: ka,
    ref: rr
  }, G ? {
    onMouseMove: Cr
  } : {});
  process.env.NODE_ENV !== "production" && (Kn["data-mui-internal-clone-element"] = !0, D.useEffect(() => {
    Re && !Re.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Re]));
  const bo = {};
  te || (Kn.onTouchStart = bs, Kn.onTouchEnd = Ma), Y || (Kn.onMouseOver = u1(Vi, Kn.onMouseOver), Kn.onMouseLeave = u1(ys, Kn.onMouseLeave), bt || (bo.onMouseOver = Vi, bo.onMouseLeave = ys)), ne || (Kn.onFocus = u1(yo, Kn.onFocus), Kn.onBlur = u1(hr, Kn.onBlur), bt || (bo.onFocus = yo, bo.onBlur = hr)), process.env.NODE_ENV !== "production" && Ee.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${Ee.props.title}\` or the Tooltip component.`].join(`
`));
  const Na = D.useMemo(() => {
    var zt;
    let Or = [{
      name: "arrow",
      enabled: !!Pt,
      options: {
        element: Pt,
        padding: 4
      }
    }];
    return (zt = me.popperOptions) != null && zt.modifiers && (Or = Or.concat(me.popperOptions.modifiers)), O({}, me.popperOptions, {
      modifiers: Or
    });
  }, [Pt, me]), Mo = O({}, V, {
    isRtl: Ve,
    arrow: z,
    disableInteractive: bt,
    placement: se,
    PopperComponentProp: ve,
    touch: it.current
  }), No = Cae(Mo), xo = (o = (s = be.popper) != null ? s : ee.Popper) != null ? o : wae, ze = (l = (u = (p = be.transition) != null ? p : ee.Transition) != null ? u : ie) != null ? l : pv, Pe = (h = (m = be.tooltip) != null ? m : ee.Tooltip) != null ? h : Tae, tt = (b = (x = be.arrow) != null ? x : ee.Arrow) != null ? b : Eae, mt = Km(xo, O({}, me, (S = Oe.popper) != null ? S : K.popper, {
    className: Ne(No.popper, me == null ? void 0 : me.className, (R = (T = Oe.popper) != null ? T : K.popper) == null ? void 0 : R.className)
  }), Mo), cn = Km(ze, O({}, fe, (E = Oe.transition) != null ? E : K.transition), Mo), Rn = Km(Pe, O({}, (P = Oe.tooltip) != null ? P : K.tooltip, {
    className: Ne(No.tooltip, (k = (_ = Oe.tooltip) != null ? _ : K.tooltip) == null ? void 0 : k.className)
  }), Mo), Qn = Km(tt, O({}, (L = Oe.arrow) != null ? L : K.arrow, {
    className: Ne(No.arrow, (F = (N = Oe.arrow) != null ? N : K.arrow) == null ? void 0 : F.className)
  }), Mo);
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [/* @__PURE__ */ D.cloneElement(Ee, Kn), /* @__PURE__ */ I(xo, O({
      as: ve ?? ip,
      placement: se,
      anchorEl: G ? {
        getBoundingClientRect: () => ({
          top: ib.y,
          left: ib.x,
          right: ib.x,
          bottom: ib.y,
          width: 0,
          height: 0
        })
      } : Re,
      popperRef: Wn,
      open: Re ? Qt : !1,
      id: et,
      transition: !0
    }, bo, mt, {
      popperOptions: Na,
      children: ({
        TransitionProps: zt
      }) => /* @__PURE__ */ I(ze, O({
        timeout: _e.transitions.duration.shorter
      }, zt, cn, {
        children: /* @__PURE__ */ qe(Pe, O({}, Rn, {
          children: [De, z ? /* @__PURE__ */ I(tt, O({}, Qn, {
            ref: at
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Fz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: r.bool,
  /**
   * Tooltip reference element.
   */
  children: gd.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: r.shape({
    Arrow: r.elementType,
    Popper: r.elementType,
    Tooltip: r.elementType,
    Transition: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: r.shape({
    arrow: r.object,
    popper: r.object,
    tooltip: r.object,
    transition: r.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: r.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: r.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: r.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: r.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: r.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: r.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: r.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: r.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: r.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: r.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: r.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: r.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: r.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: r.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    arrow: r.object,
    popper: r.object,
    tooltip: r.object,
    transition: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    arrow: r.elementType,
    popper: r.elementType,
    tooltip: r.elementType,
    transition: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: r.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: r.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: r.object
});
const E0 = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (E0.displayName = "StepperContext");
const mT = /* @__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (mT.displayName = "StepContext");
function Rae(e) {
  return pt("MuiStep", e);
}
ht("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const Oae = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"], Pae = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: o,
    completed: s
  } = e;
  return vt({
    root: ["root", n, o && "alternativeLabel", s && "completed"]
  }, Rae, t);
}, $ae = ce("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})(({
  ownerState: e
}) => O({}, e.orientation === "horizontal" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.alternativeLabel && {
  flex: 1,
  position: "relative"
})), jz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiStep"
  }), {
    active: s,
    children: l,
    className: u,
    component: p = "div",
    completed: h,
    disabled: m,
    expanded: b = !1,
    index: x,
    last: S
  } = o, R = Te(o, Oae), {
    activeStep: T,
    connector: E,
    alternativeLabel: P,
    orientation: k,
    nonLinear: _
  } = D.useContext(E0);
  let [L = !1, F = !1, N = !1] = [s, h, m];
  T === x ? L = s !== void 0 ? s : !0 : !_ && T > x ? F = h !== void 0 ? h : !0 : !_ && T < x && (N = m !== void 0 ? m : !0);
  const V = D.useMemo(() => ({
    index: x,
    last: S,
    expanded: b,
    icon: x + 1,
    active: L,
    completed: F,
    disabled: N
  }), [x, S, b, L, F, N]), z = O({}, o, {
    active: L,
    orientation: k,
    alternativeLabel: P,
    completed: F,
    disabled: N,
    expanded: b,
    component: p
  }), H = Pae(z), ee = /* @__PURE__ */ qe($ae, O({
    as: p,
    className: Ne(H.root, u),
    ref: n,
    ownerState: z
  }, R, {
    children: [E && P && x !== 0 ? E : null, l]
  }));
  return /* @__PURE__ */ I(mT.Provider, {
    value: V,
    children: E && !P && x !== 0 ? /* @__PURE__ */ qe(D.Fragment, {
      children: [E, ee]
    }) : ee
  });
});
process.env.NODE_ENV !== "production" && (jz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: r.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: r.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: r.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: r.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: Lc,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Dae = lr(/* @__PURE__ */ I("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), kae = lr(/* @__PURE__ */ I("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function Mae(e) {
  return pt("MuiStepIcon", e);
}
const o$ = ht("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var aF;
const Nae = ["active", "className", "completed", "error", "icon"], Iae = (e) => {
  const {
    classes: t,
    active: n,
    completed: o,
    error: s
  } = e;
  return vt({
    root: ["root", n && "active", o && "completed", s && "error"],
    text: ["text"]
  }, Mae, t);
}, a$ = ce(Ub, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${o$.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${o$.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${o$.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), _ae = ce("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
})), Vz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: s = !1,
    className: l,
    completed: u = !1,
    error: p = !1,
    icon: h
  } = o, m = Te(o, Nae), b = O({}, o, {
    active: s,
    completed: u,
    error: p
  }), x = Iae(b);
  if (typeof h == "number" || typeof h == "string") {
    const S = Ne(l, x.root);
    return p ? /* @__PURE__ */ I(a$, O({
      as: kae,
      className: S,
      ref: n,
      ownerState: b
    }, m)) : u ? /* @__PURE__ */ I(a$, O({
      as: Dae,
      className: S,
      ref: n,
      ownerState: b
    }, m)) : /* @__PURE__ */ qe(a$, O({
      className: S,
      ref: n,
      ownerState: b
    }, m, {
      children: [aF || (aF = /* @__PURE__ */ I("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ I(_ae, {
        className: x.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: b,
        children: h
      })]
    }));
  }
  return h;
});
process.env.NODE_ENV !== "production" && (Vz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: r.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: r.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Aae(e) {
  return pt("MuiStepLabel", e);
}
const cd = ht("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), Lae = ["children", "className", "componentsProps", "error", "icon", "optional", "slotProps", "StepIconComponent", "StepIconProps"], Fae = (e) => {
  const {
    classes: t,
    orientation: n,
    active: o,
    completed: s,
    error: l,
    disabled: u,
    alternativeLabel: p
  } = e;
  return vt({
    root: ["root", n, l && "error", u && "disabled", p && "alternativeLabel"],
    label: ["label", o && "active", s && "completed", l && "error", u && "disabled", p && "alternativeLabel"],
    iconContainer: ["iconContainer", o && "active", s && "completed", l && "error", u && "disabled", p && "alternativeLabel"],
    labelContainer: ["labelContainer", p && "alternativeLabel"]
  }, Aae, t);
}, jae = ce("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation]];
  }
})(({
  ownerState: e
}) => O({
  display: "flex",
  alignItems: "center",
  [`&.${cd.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${cd.disabled}`]: {
    cursor: "default"
  }
}, e.orientation === "vertical" && {
  textAlign: "left",
  padding: "8px 0"
})), Vae = ce("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e
}) => O({}, e.typography.body2, {
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${cd.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${cd.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${cd.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${cd.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Bae = ce("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: "flex",
  paddingRight: 8,
  [`&.${cd.alternativeLabel}`]: {
    paddingRight: 0
  }
})), zae = ce("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${cd.alternativeLabel}`]: {
    textAlign: "center"
  }
})), gk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const s = We({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: l,
    className: u,
    componentsProps: p = {},
    error: h = !1,
    icon: m,
    optional: b,
    slotProps: x = {},
    StepIconComponent: S,
    StepIconProps: R
  } = s, T = Te(s, Lae), {
    alternativeLabel: E,
    orientation: P
  } = D.useContext(E0), {
    active: k,
    disabled: _,
    completed: L,
    icon: F
  } = D.useContext(mT), N = m || F;
  let V = S;
  N && !V && (V = Vz);
  const z = O({}, s, {
    active: k,
    alternativeLabel: E,
    completed: L,
    disabled: _,
    error: h,
    orientation: P
  }), H = Fae(z), ee = (o = x.label) != null ? o : p.label;
  return /* @__PURE__ */ qe(jae, O({
    className: Ne(H.root, u),
    ref: n,
    ownerState: z
  }, T, {
    children: [N || V ? /* @__PURE__ */ I(Bae, {
      className: H.iconContainer,
      ownerState: z,
      children: /* @__PURE__ */ I(V, O({
        completed: L,
        active: k,
        error: h,
        icon: N
      }, R))
    }) : null, /* @__PURE__ */ qe(zae, {
      className: H.labelContainer,
      ownerState: z,
      children: [l ? /* @__PURE__ */ I(Vae, O({
        ownerState: z
      }, ee, {
        className: Ne(H.label, ee == null ? void 0 : ee.className),
        children: l
      })) : null, b]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (gk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: r.shape({
    label: r.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: r.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: r.node,
  /**
   * The optional node to display.
   */
  optional: r.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    label: r.object
  }),
  /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */
  StepIconComponent: r.elementType,
  /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */
  StepIconProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
gk.muiName = "StepLabel";
function Uae(e) {
  return pt("MuiStepConnector", e);
}
ht("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const Hae = ["className"], Wae = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: o,
    active: s,
    completed: l,
    disabled: u
  } = e, p = {
    root: ["root", n, o && "alternativeLabel", s && "active", l && "completed", u && "disabled"],
    line: ["line", `line${Ae(n)}`]
  };
  return vt(p, Uae, t);
}, qae = ce("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})(({
  ownerState: e
}) => O({
  flex: "1 1 auto"
}, e.orientation === "vertical" && {
  marginLeft: 12
  // half icon
}, e.alternativeLabel && {
  position: "absolute",
  top: 12,
  left: "calc(-50% + 20px)",
  right: "calc(50% + 20px)"
})), Yae = ce("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.line, t[`line${Ae(n.orientation)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const n = t.palette.mode === "light" ? t.palette.grey[400] : t.palette.grey[600];
  return O({
    display: "block",
    borderColor: t.vars ? t.vars.palette.StepConnector.border : n
  }, e.orientation === "horizontal" && {
    borderTopStyle: "solid",
    borderTopWidth: 1
  }, e.orientation === "vertical" && {
    borderLeftStyle: "solid",
    borderLeftWidth: 1,
    minHeight: 24
  });
}), Bz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: s
  } = o, l = Te(o, Hae), {
    alternativeLabel: u,
    orientation: p = "horizontal"
  } = D.useContext(E0), {
    active: h,
    disabled: m,
    completed: b
  } = D.useContext(mT), x = O({}, o, {
    alternativeLabel: u,
    orientation: p,
    active: h,
    completed: b,
    disabled: m
  }), S = Wae(x);
  return /* @__PURE__ */ I(qae, O({
    className: Ne(S.root, s),
    ref: n,
    ownerState: x
  }, l, {
    children: /* @__PURE__ */ I(Yae, {
      className: S.line,
      ownerState: x
    })
  }));
});
process.env.NODE_ENV !== "production" && (Bz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Gae(e) {
  return pt("MuiStepper", e);
}
ht("MuiStepper", ["root", "horizontal", "vertical", "alternativeLabel"]);
const Kae = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"], Xae = (e) => {
  const {
    orientation: t,
    alternativeLabel: n,
    classes: o
  } = e;
  return vt({
    root: ["root", t, n && "alternativeLabel"]
  }, Gae, o);
}, Qae = ce("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel];
  }
})(({
  ownerState: e
}) => O({
  display: "flex"
}, e.orientation === "horizontal" && {
  flexDirection: "row",
  alignItems: "center"
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.alternativeLabel && {
  alignItems: "flex-start"
})), Jae = /* @__PURE__ */ I(Bz, {}), zz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: s = 0,
    alternativeLabel: l = !1,
    children: u,
    className: p,
    component: h = "div",
    connector: m = Jae,
    nonLinear: b = !1,
    orientation: x = "horizontal"
  } = o, S = Te(o, Kae), R = O({}, o, {
    alternativeLabel: l,
    orientation: x,
    component: h
  }), T = Xae(R), E = D.Children.toArray(u).filter(Boolean), P = E.map((_, L) => /* @__PURE__ */ D.cloneElement(_, O({
    index: L,
    last: L + 1 === E.length
  }, _.props))), k = D.useMemo(() => ({
    activeStep: s,
    alternativeLabel: l,
    connector: m,
    nonLinear: b,
    orientation: x
  }), [s, l, m, b, x]);
  return /* @__PURE__ */ I(E0.Provider, {
    value: k,
    children: /* @__PURE__ */ I(Qae, O({
      as: h,
      ownerState: R,
      className: Ne(T.root, p),
      ref: n
    }, S, {
      children: P
    }))
  });
});
process.env.NODE_ENV !== "production" && (zz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: Lc,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: r.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: r.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: r.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Zae(e) {
  return pt("MuiSwitch", e);
}
const Oa = ht("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), eie = ["className", "color", "edge", "size", "sx"], tie = (e) => {
  const {
    classes: t,
    edge: n,
    size: o,
    color: s,
    checked: l,
    disabled: u
  } = e, p = {
    root: ["root", n && `edge${Ae(n)}`, `size${Ae(o)}`],
    switchBase: ["switchBase", `color${Ae(s)}`, l && "checked", u && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, h = vt(p, Zae, t);
  return O({}, t, h);
}, nie = ce("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.edge && t[`edge${Ae(n.edge)}`], t[`size${Ae(n.size)}`]];
  }
})(({
  ownerState: e
}) => O({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  }
}, e.edge === "start" && {
  marginLeft: -8
}, e.edge === "end" && {
  marginRight: -8
}, e.size === "small" && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${Oa.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${Oa.switchBase}`]: {
    padding: 4,
    [`&.${Oa.checked}`]: {
      transform: "translateX(16px)"
    }
  }
})), rie = ce(tT, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.switchBase, {
      [`& .${Oa.input}`]: t.input
    }, n.color !== "default" && t[`color${Ae(n.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Oa.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Oa.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${Oa.checked} + .${Oa.track}`]: {
    opacity: 0.5
  },
  [`&.${Oa.disabled} + .${Oa.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Oa.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e,
  ownerState: t
}) => O({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${Oa.checked}`]: {
    color: (e.vars || e).palette[t.color].main,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Oa.disabled}`]: {
      color: e.vars ? e.vars.palette.Switch[`${t.color}DisabledColor`] : `${e.palette.mode === "light" ? Uw(e.palette[t.color].main, 0.62) : zw(e.palette[t.color].main, 0.55)}`
    }
  },
  [`&.${Oa.checked} + .${Oa.track}`]: {
    backgroundColor: (e.vars || e).palette[t.color].main
  }
})), oie = ce("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), aie = ce("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), Uz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiSwitch"
  }), {
    className: s,
    color: l = "primary",
    edge: u = !1,
    size: p = "medium",
    sx: h
  } = o, m = Te(o, eie), b = O({}, o, {
    color: l,
    edge: u,
    size: p
  }), x = tie(b), S = /* @__PURE__ */ I(aie, {
    className: x.thumb,
    ownerState: b
  });
  return /* @__PURE__ */ qe(nie, {
    className: Ne(x.root, s),
    sx: h,
    ownerState: b,
    children: [/* @__PURE__ */ I(rie, O({
      type: "checkbox",
      icon: S,
      checkedIcon: S,
      ref: n,
      ownerState: b
    }, m, {
      classes: O({}, x, {
        root: x.switchBase
      })
    })), /* @__PURE__ */ I(oie, {
      className: x.track,
      ownerState: b
    })]
  });
});
process.env.NODE_ENV !== "production" && (Uz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: r.any
});
function iie(e) {
  return pt("MuiTab", e);
}
const Af = ht("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), sie = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], lie = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: o,
    wrapped: s,
    icon: l,
    label: u,
    selected: p,
    disabled: h
  } = e, m = {
    root: ["root", l && u && "labelIcon", `textColor${Ae(n)}`, o && "fullWidth", s && "wrapped", p && "selected", h && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return vt(m, iie, t);
}, cie = ce(ui, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${Ae(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped];
  }
})(({
  theme: e,
  ownerState: t
}) => O({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${Af.iconWrapper}`]: O({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${Af.selected}`]: {
    opacity: 1
  },
  [`&.${Af.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Af.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Af.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Af.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${Af.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), Z1 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTab"
  }), {
    className: s,
    disabled: l = !1,
    disableFocusRipple: u = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: p,
    icon: h,
    iconPosition: m = "top",
    // eslint-disable-next-line react/prop-types
    indicator: b,
    label: x,
    onChange: S,
    onClick: R,
    onFocus: T,
    // eslint-disable-next-line react/prop-types
    selected: E,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: P,
    // eslint-disable-next-line react/prop-types
    textColor: k = "inherit",
    value: _,
    wrapped: L = !1
  } = o, F = Te(o, sie), N = O({}, o, {
    disabled: l,
    disableFocusRipple: u,
    selected: E,
    icon: !!h,
    iconPosition: m,
    label: !!x,
    fullWidth: p,
    textColor: k,
    wrapped: L
  }), V = lie(N), z = h && x && /* @__PURE__ */ D.isValidElement(h) ? /* @__PURE__ */ D.cloneElement(h, {
    className: Ne(V.iconWrapper, h.props.className)
  }) : h, H = (K) => {
    !E && S && S(K, _), R && R(K);
  }, ee = (K) => {
    P && !E && S && S(K, _), T && T(K);
  };
  return /* @__PURE__ */ qe(cie, O({
    focusRipple: !u,
    className: Ne(V.root, s),
    ref: n,
    role: "tab",
    "aria-selected": E,
    disabled: l,
    onClick: H,
    onFocus: ee,
    ownerState: N,
    tabIndex: E ? 0 : -1
  }, F, {
    children: [m === "top" || m === "start" ? /* @__PURE__ */ qe(D.Fragment, {
      children: [z, x]
    }) : /* @__PURE__ */ qe(D.Fragment, {
      children: [x, z]
    }), b]
  }));
});
process.env.NODE_ENV !== "production" && (Z1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: SD,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display.
   */
  icon: r.oneOfType([r.element, r.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: r.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: r.node,
  /**
   * @ignore
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: r.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: r.bool
});
const yk = /* @__PURE__ */ D.createContext();
process.env.NODE_ENV !== "production" && (yk.displayName = "TableContext");
function uie(e) {
  return pt("MuiTable", e);
}
ht("MuiTable", ["root", "stickyHeader"]);
const die = ["className", "component", "padding", "size", "stickyHeader"], fie = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return vt({
    root: ["root", n && "stickyHeader"]
  }, uie, t);
}, pie = ce("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": O({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), iF = "table", Hz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTable"
  }), {
    className: s,
    component: l = iF,
    padding: u = "normal",
    size: p = "medium",
    stickyHeader: h = !1
  } = o, m = Te(o, die), b = O({}, o, {
    component: l,
    padding: u,
    size: p,
    stickyHeader: h
  }), x = fie(b), S = D.useMemo(() => ({
    padding: u,
    size: p,
    stickyHeader: h
  }), [u, p, h]);
  return /* @__PURE__ */ I(yk.Provider, {
    value: S,
    children: /* @__PURE__ */ I(pie, O({
      as: l,
      role: l === iF ? null : "table",
      ref: n,
      className: Ne(x.root, s),
      ownerState: b
    }, m))
  });
});
process.env.NODE_ENV !== "production" && (Hz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: r.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const R0 = /* @__PURE__ */ D.createContext();
process.env.NODE_ENV !== "production" && (R0.displayName = "Tablelvl2Context");
function hie(e) {
  return pt("MuiTableBody", e);
}
ht("MuiTableBody", ["root"]);
const mie = ["className", "component"], vie = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, hie, t);
}, gie = ce("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), yie = {
  variant: "body"
}, sF = "tbody", Wz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableBody"
  }), {
    className: s,
    component: l = sF
  } = o, u = Te(o, mie), p = O({}, o, {
    component: l
  }), h = vie(p);
  return /* @__PURE__ */ I(R0.Provider, {
    value: yie,
    children: /* @__PURE__ */ I(gie, O({
      className: Ne(h.root, s),
      as: l,
      ref: n,
      role: l === sF ? null : "rowgroup",
      ownerState: p
    }, u))
  });
});
process.env.NODE_ENV !== "production" && (Wz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function bie(e) {
  return pt("MuiTableCell", e);
}
const xie = ht("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), Sie = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], Cie = (e) => {
  const {
    classes: t,
    variant: n,
    align: o,
    padding: s,
    size: l,
    stickyHeader: u
  } = e, p = {
    root: ["root", n, u && "stickyHeader", o !== "inherit" && `align${Ae(o)}`, s !== "normal" && `padding${Ae(s)}`, `size${Ae(l)}`]
  };
  return vt(p, bie, t);
}, wie = ce("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${Ae(n.size)}`], n.padding !== "normal" && t[`padding${Ae(n.padding)}`], n.align !== "inherit" && t[`align${Ae(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => O({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? Uw(Mt(e.palette.divider, 1), 0.88) : zw(Mt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${xie.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), Kb = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableCell"
  }), {
    align: s = "inherit",
    className: l,
    component: u,
    padding: p,
    scope: h,
    size: m,
    sortDirection: b,
    variant: x
  } = o, S = Te(o, Sie), R = D.useContext(yk), T = D.useContext(R0), E = T && T.variant === "head";
  let P;
  u ? P = u : P = E ? "th" : "td";
  let k = h;
  P === "td" ? k = void 0 : !k && E && (k = "col");
  const _ = x || T && T.variant, L = O({}, o, {
    align: s,
    component: P,
    padding: p || (R && R.padding ? R.padding : "normal"),
    size: m || (R && R.size ? R.size : "medium"),
    sortDirection: b,
    stickyHeader: _ === "head" && R && R.stickyHeader,
    variant: _
  }), F = Cie(L);
  let N = null;
  return b && (N = b === "asc" ? "ascending" : "descending"), /* @__PURE__ */ I(wie, O({
    as: P,
    ref: n,
    className: Ne(F.root, l),
    "aria-sort": N,
    scope: k,
    ownerState: L
  }, S));
});
process.env.NODE_ENV !== "production" && (Kb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: r.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: r.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: r.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: r.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: r.oneOfType([r.oneOf(["body", "footer", "head"]), r.string])
});
function Tie(e) {
  return pt("MuiTableContainer", e);
}
ht("MuiTableContainer", ["root"]);
const Eie = ["className", "component"], Rie = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, Tie, t);
}, Oie = ce("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), qz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: s,
    component: l = "div"
  } = o, u = Te(o, Eie), p = O({}, o, {
    component: l
  }), h = Rie(p);
  return /* @__PURE__ */ I(Oie, O({
    ref: n,
    as: l,
    className: Ne(h.root, s),
    ownerState: p
  }, u));
});
process.env.NODE_ENV !== "production" && (qz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Pie(e) {
  return pt("MuiTableHead", e);
}
ht("MuiTableHead", ["root"]);
const $ie = ["className", "component"], Die = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, Pie, t);
}, kie = ce("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), Mie = {
  variant: "head"
}, lF = "thead", Yz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableHead"
  }), {
    className: s,
    component: l = lF
  } = o, u = Te(o, $ie), p = O({}, o, {
    component: l
  }), h = Die(p);
  return /* @__PURE__ */ I(R0.Provider, {
    value: Mie,
    children: /* @__PURE__ */ I(kie, O({
      as: l,
      className: Ne(h.root, s),
      ref: n,
      role: l === lF ? null : "rowgroup",
      ownerState: p
    }, u))
  });
});
process.env.NODE_ENV !== "production" && (Yz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Nie(e) {
  return pt("MuiToolbar", e);
}
ht("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const Iie = ["className", "component", "disableGutters", "variant"], _ie = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: o
  } = e;
  return vt({
    root: ["root", !n && "gutters", o]
  }, Nie, t);
}, Aie = ce("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), bk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiToolbar"
  }), {
    className: s,
    component: l = "div",
    disableGutters: u = !1,
    variant: p = "regular"
  } = o, h = Te(o, Iie), m = O({}, o, {
    component: l,
    disableGutters: u,
    variant: p
  }), b = _ie(m);
  return /* @__PURE__ */ I(Aie, O({
    as: l,
    className: Ne(b.root, s),
    ref: n,
    ownerState: m
  }, h));
});
process.env.NODE_ENV !== "production" && (bk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: r.oneOfType([r.oneOf(["dense", "regular"]), r.string])
});
const Gz = lr(/* @__PURE__ */ I("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), Kz = lr(/* @__PURE__ */ I("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), Lie = ["backIconButtonProps", "count", "disabled", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton", "slots", "slotProps"], Xz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s, l, u, p, h, m, b;
  const {
    backIconButtonProps: x,
    count: S,
    disabled: R = !1,
    getItemAriaLabel: T,
    nextIconButtonProps: E,
    onPageChange: P,
    page: k,
    rowsPerPage: _,
    showFirstButton: L,
    showLastButton: F,
    slots: N = {},
    slotProps: V = {}
  } = t, z = Te(t, Lie), H = Go(), ee = (Oe) => {
    P(Oe, 0);
  }, K = (Oe) => {
    P(Oe, k - 1);
  }, X = (Oe) => {
    P(Oe, k + 1);
  }, ne = (Oe) => {
    P(Oe, Math.max(0, Math.ceil(S / _) - 1));
  }, Y = (o = N.firstButton) != null ? o : oi, J = (s = N.lastButton) != null ? s : oi, te = (l = N.nextButton) != null ? l : oi, Z = (u = N.previousButton) != null ? u : oi, ae = (p = N.firstButtonIcon) != null ? p : Voe, U = (h = N.lastButtonIcon) != null ? h : Boe, G = (m = N.nextButtonIcon) != null ? m : Kz, W = (b = N.previousButtonIcon) != null ? b : Gz, le = H.direction === "rtl" ? J : Y, pe = H.direction === "rtl" ? te : Z, ge = H.direction === "rtl" ? Z : te, we = H.direction === "rtl" ? Y : J, de = H.direction === "rtl" ? V.lastButton : V.firstButton, se = H.direction === "rtl" ? V.nextButton : V.previousButton, ve = H.direction === "rtl" ? V.previousButton : V.nextButton, me = H.direction === "rtl" ? V.firstButton : V.lastButton;
  return /* @__PURE__ */ qe("div", O({
    ref: n
  }, z, {
    children: [L && /* @__PURE__ */ I(le, O({
      onClick: ee,
      disabled: R || k === 0,
      "aria-label": T("first", k),
      title: T("first", k)
    }, de, {
      children: H.direction === "rtl" ? /* @__PURE__ */ I(U, O({}, V.lastButtonIcon)) : /* @__PURE__ */ I(ae, O({}, V.firstButtonIcon))
    })), /* @__PURE__ */ I(pe, O({
      onClick: K,
      disabled: R || k === 0,
      color: "inherit",
      "aria-label": T("previous", k),
      title: T("previous", k)
    }, se ?? x, {
      children: H.direction === "rtl" ? /* @__PURE__ */ I(G, O({}, V.nextButtonIcon)) : /* @__PURE__ */ I(W, O({}, V.previousButtonIcon))
    })), /* @__PURE__ */ I(ge, O({
      onClick: X,
      disabled: R || (S !== -1 ? k >= Math.ceil(S / _) - 1 : !1),
      color: "inherit",
      "aria-label": T("next", k),
      title: T("next", k)
    }, ve ?? E, {
      children: H.direction === "rtl" ? /* @__PURE__ */ I(W, O({}, V.previousButtonIcon)) : /* @__PURE__ */ I(G, O({}, V.nextButtonIcon))
    })), F && /* @__PURE__ */ I(we, O({
      onClick: ne,
      disabled: R || k >= Math.ceil(S / _) - 1,
      "aria-label": T("last", k),
      title: T("last", k)
    }, me, {
      children: H.direction === "rtl" ? /* @__PURE__ */ I(ae, O({}, V.firstButtonIcon)) : /* @__PURE__ */ I(U, O({}, V.lastButtonIcon))
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Xz.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: r.object,
  /**
   * The total number of rows.
   */
  count: r.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: r.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: r.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: r.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: r.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: r.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: r.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: r.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: r.shape({
    firstButton: r.object,
    firstButtonIcon: r.object,
    lastButton: r.object,
    lastButtonIcon: r.object,
    nextButton: r.object,
    nextButtonIcon: r.object,
    previousButton: r.object,
    previousButtonIcon: r.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    firstButton: r.elementType,
    firstButtonIcon: r.elementType,
    lastButton: r.elementType,
    lastButtonIcon: r.elementType,
    nextButton: r.elementType,
    nextButtonIcon: r.elementType,
    previousButton: r.elementType,
    previousButtonIcon: r.elementType
  })
});
function Fie(e) {
  return pt("MuiTablePagination", e);
}
const kb = ht("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var cF;
const jie = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "disabled", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton", "slotProps", "slots"], Vie = ce(Kb, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
})), Bie = ce(bk, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => O({
    [`& .${kb.actions}`]: t.actions
  }, t.toolbar)
})(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${kb.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
})), zie = ce("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), Uie = ce("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})(({
  theme: e
}) => O({}, e.typography.body2, {
  flexShrink: 0
})), Hie = ce(T0, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => O({
    [`& .${kb.selectIcon}`]: t.selectIcon,
    [`& .${kb.select}`]: t.select
  }, t.input, t.selectRoot)
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${kb.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), Wie = ce(Ev, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), qie = ce("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})(({
  theme: e
}) => O({}, e.typography.body2, {
  flexShrink: 0
}));
function Yie({
  from: e,
  to: t,
  count: n
}) {
  return `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`;
}
function Gie(e) {
  return `Go to ${e} page`;
}
const Kie = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, Fie, t);
}, Qz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o;
  const s = We({
    props: t,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: l = Xz,
    backIconButtonProps: u,
    className: p,
    colSpan: h,
    component: m = Kb,
    count: b,
    disabled: x = !1,
    getItemAriaLabel: S = Gie,
    labelDisplayedRows: R = Yie,
    labelRowsPerPage: T = "Rows per page:",
    nextIconButtonProps: E,
    onPageChange: P,
    onRowsPerPageChange: k,
    page: _,
    rowsPerPage: L,
    rowsPerPageOptions: F = [10, 25, 50, 100],
    SelectProps: N = {},
    showFirstButton: V = !1,
    showLastButton: z = !1,
    slotProps: H = {},
    slots: ee = {}
  } = s, K = Te(s, jie), X = s, ne = Kie(X), Y = (o = H == null ? void 0 : H.select) != null ? o : N, J = Y.native ? "option" : Wie;
  let te;
  (m === Kb || m === "td") && (te = h || 1e3);
  const Z = Vc(Y.id), ae = Vc(Y.labelId), U = () => b === -1 ? (_ + 1) * L : L === -1 ? b : Math.min(b, (_ + 1) * L);
  return /* @__PURE__ */ I(Vie, O({
    colSpan: te,
    ref: n,
    as: m,
    ownerState: X,
    className: Ne(ne.root, p)
  }, K, {
    children: /* @__PURE__ */ qe(Bie, {
      className: ne.toolbar,
      children: [/* @__PURE__ */ I(zie, {
        className: ne.spacer
      }), F.length > 1 && /* @__PURE__ */ I(Uie, {
        className: ne.selectLabel,
        id: ae,
        children: T
      }), F.length > 1 && /* @__PURE__ */ I(Hie, O({
        variant: "standard"
      }, !Y.variant && {
        input: cF || (cF = /* @__PURE__ */ I(Zw, {}))
      }, {
        value: L,
        onChange: k,
        id: Z,
        labelId: ae
      }, Y, {
        classes: O({}, Y.classes, {
          // TODO v5 remove `classes.input`
          root: Ne(ne.input, ne.selectRoot, (Y.classes || {}).root),
          select: Ne(ne.select, (Y.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: Ne(ne.selectIcon, (Y.classes || {}).icon)
        }),
        disabled: x,
        children: F.map((G) => /* @__PURE__ */ KV(J, O({}, !Zf(J) && {
          ownerState: X
        }, {
          className: ne.menuItem,
          key: G.label ? G.label : G,
          value: G.value ? G.value : G
        }), G.label ? G.label : G))
      })), /* @__PURE__ */ I(qie, {
        className: ne.displayedRows,
        children: R({
          from: b === 0 ? 0 : _ * L + 1,
          to: U(),
          count: b === -1 ? -1 : b,
          page: _
        })
      }), /* @__PURE__ */ I(l, {
        className: ne.actions,
        backIconButtonProps: u,
        count: b,
        nextIconButtonProps: E,
        onPageChange: P,
        page: _,
        rowsPerPage: L,
        showFirstButton: V,
        showLastButton: z,
        slotProps: H.actions,
        slots: ee.actions,
        getItemAriaLabel: S,
        disabled: x
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" && (Qz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: r.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: r.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  colSpan: r.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: Lc.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: r.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: r.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: r.node,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: r.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: r.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: r.func,
  /**
   * The zero-based index of the current page.
   */
  page: Pa(Lc.isRequired, (e) => {
    const {
      count: t,
      page: n,
      rowsPerPage: o
    } = e;
    if (t === -1)
      return null;
    const s = Math.max(0, Math.ceil(t / o) - 1);
    return n < 0 || n > s ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${s}, but page is ${n}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: Lc.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: r.arrayOf(r.oneOfType([r.number, r.shape({
    label: r.string.isRequired,
    value: r.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: r.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: r.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: r.bool,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: r.shape({
    actions: r.shape({
      firstButton: r.object,
      firstButtonIcon: r.object,
      lastButton: r.object,
      lastButtonIcon: r.object,
      nextButton: r.object,
      nextButtonIcon: r.object,
      previousButton: r.object,
      previousButtonIcon: r.object
    }),
    select: r.object
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    actions: r.shape({
      firstButton: r.elementType,
      firstButtonIcon: r.elementType,
      lastButton: r.elementType,
      lastButtonIcon: r.elementType,
      nextButton: r.elementType,
      nextButtonIcon: r.elementType,
      previousButton: r.elementType,
      previousButtonIcon: r.elementType
    })
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Xie(e) {
  return pt("MuiTableRow", e);
}
const uF = ht("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), Qie = ["className", "component", "hover", "selected"], Jie = (e) => {
  const {
    classes: t,
    selected: n,
    hover: o,
    head: s,
    footer: l
  } = e;
  return vt({
    root: ["root", n && "selected", o && "hover", s && "head", l && "footer"]
  }, Xie, t);
}, Zie = ce("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${uF.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${uF.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), dF = "tr", Jz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableRow"
  }), {
    className: s,
    component: l = dF,
    hover: u = !1,
    selected: p = !1
  } = o, h = Te(o, Qie), m = D.useContext(R0), b = O({}, o, {
    component: l,
    hover: u,
    selected: p,
    head: m && m.variant === "head",
    footer: m && m.variant === "footer"
  }), x = Jie(b);
  return /* @__PURE__ */ I(Zie, O({
    as: l,
    ref: n,
    className: Ne(x.root, s),
    role: l === dF ? null : "row",
    ownerState: b
  }, h));
});
process.env.NODE_ENV !== "production" && (Jz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: r.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const ese = lr(/* @__PURE__ */ I("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function tse(e) {
  return pt("MuiTableSortLabel", e);
}
const i$ = ht("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc"]), nse = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"], rse = (e) => {
  const {
    classes: t,
    direction: n,
    active: o
  } = e, s = {
    root: ["root", o && "active"],
    icon: ["icon", `iconDirection${Ae(n)}`]
  };
  return vt(s, tse, t);
}, ose = ce(ui, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.active && t.active];
  }
})(({
  theme: e
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (e.vars || e).palette.text.secondary
  },
  "&:hover": {
    color: (e.vars || e).palette.text.secondary,
    [`& .${i$.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${i$.active}`]: {
    color: (e.vars || e).palette.text.primary,
    [`& .${i$.icon}`]: {
      opacity: 1,
      color: (e.vars || e).palette.text.secondary
    }
  }
})), ase = ce("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, t[`iconDirection${Ae(n.direction)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => O({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: e.transitions.create(["opacity", "transform"], {
    duration: e.transitions.duration.shorter
  }),
  userSelect: "none"
}, t.direction === "desc" && {
  transform: "rotate(0deg)"
}, t.direction === "asc" && {
  transform: "rotate(180deg)"
})), Zz = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTableSortLabel"
  }), {
    active: s = !1,
    children: l,
    className: u,
    direction: p = "asc",
    hideSortIcon: h = !1,
    IconComponent: m = ese
  } = o, b = Te(o, nse), x = O({}, o, {
    active: s,
    direction: p,
    hideSortIcon: h,
    IconComponent: m
  }), S = rse(x);
  return /* @__PURE__ */ qe(ose, O({
    className: Ne(S.root, u),
    component: "span",
    disableRipple: !0,
    ownerState: x,
    ref: n
  }, b, {
    children: [l, h && !s ? null : /* @__PURE__ */ I(ase, {
      as: m,
      className: Ne(S.icon),
      ownerState: x
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Zz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: r.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: r.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: r.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function ise(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function sse(e, t, n, o = {}, s = () => {
}) {
  const {
    ease: l = ise,
    duration: u = 300
    // standard
  } = o;
  let p = null;
  const h = t[e];
  let m = !1;
  const b = () => {
    m = !0;
  }, x = (S) => {
    if (m) {
      s(new Error("Animation cancelled"));
      return;
    }
    p === null && (p = S);
    const R = Math.min(1, (S - p) / u);
    if (t[e] = l(R) * (n - h) + h, R >= 1) {
      requestAnimationFrame(() => {
        s(null);
      });
      return;
    }
    requestAnimationFrame(x);
  };
  return h === n ? (s(new Error("Element already at target position")), b) : (requestAnimationFrame(x), b);
}
const lse = ["onChange"], cse = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function e5(e) {
  const {
    onChange: t
  } = e, n = Te(e, lse), o = D.useRef(), s = D.useRef(null), l = () => {
    o.current = s.current.offsetHeight - s.current.clientHeight;
  };
  return $a(() => {
    const u = bv(() => {
      const h = o.current;
      l(), h !== o.current && t(o.current);
    }), p = us(s.current);
    return p.addEventListener("resize", u), () => {
      u.clear(), p.removeEventListener("resize", u);
    };
  }, [t]), D.useEffect(() => {
    l(), t(o.current);
  }, [t]), /* @__PURE__ */ I("div", O({
    style: cse,
    ref: s
  }, n));
}
process.env.NODE_ENV !== "production" && (e5.propTypes = {
  onChange: r.func.isRequired
});
function use(e) {
  return pt("MuiTabScrollButton", e);
}
const dse = ht("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), fse = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], pse = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: o
  } = e;
  return vt({
    root: ["root", n, o && "disabled"]
  }, use, t);
}, hse = ce(ui, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})(({
  ownerState: e
}) => O({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${dse.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), t5 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var o, s;
  const l = We({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: u,
    slots: p = {},
    slotProps: h = {},
    direction: m
  } = l, b = Te(l, fse), S = Go().direction === "rtl", R = O({
    isRtl: S
  }, l), T = pse(R), E = (o = p.StartScrollButtonIcon) != null ? o : Gz, P = (s = p.EndScrollButtonIcon) != null ? s : Kz, k = Li({
    elementType: E,
    externalSlotProps: h.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: R
  }), _ = Li({
    elementType: P,
    externalSlotProps: h.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: R
  });
  return /* @__PURE__ */ I(hse, O({
    component: "div",
    className: Ne(T.root, u),
    ref: n,
    role: null,
    ownerState: R,
    tabIndex: null
  }, b, {
    children: m === "left" ? /* @__PURE__ */ I(E, O({}, k)) : /* @__PURE__ */ I(P, O({}, _))
  }));
});
process.env.NODE_ENV !== "production" && (t5.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The direction the button should indicate.
   */
  direction: r.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: r.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: r.shape({
    endScrollButtonIcon: r.oneOfType([r.func, r.object]),
    startScrollButtonIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    EndScrollButtonIcon: r.elementType,
    StartScrollButtonIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function mse(e) {
  return pt("MuiTabs", e);
}
const D1 = ht("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), vse = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], fF = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, pF = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, d1 = (e, t, n) => {
  let o = !1, s = n(e, t);
  for (; s; ) {
    if (s === e.firstChild) {
      if (o)
        return;
      o = !0;
    }
    const l = s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || l)
      s = n(e, s);
    else {
      s.focus();
      return;
    }
  }
}, gse = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: o,
    scrollableX: s,
    scrollableY: l,
    centered: u,
    scrollButtonsHideMobile: p,
    classes: h
  } = e;
  return vt({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", o && "hideScrollbar", s && "scrollableX", l && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", u && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", p && "scrollButtonsHideMobile"],
    scrollableX: [s && "scrollableX"],
    hideScrollbar: [o && "hideScrollbar"]
  }, mse, h);
}, yse = ce("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${D1.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${D1.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => O({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${D1.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), bse = ce("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => O({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), xse = ce("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})(({
  ownerState: e
}) => O({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), Sse = ce("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => O({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), Cse = ce(e5)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), hF = {};
let mF = !1;
const xk = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTabs"
  }), s = Go(), l = s.direction === "rtl", {
    "aria-label": u,
    "aria-labelledby": p,
    action: h,
    centered: m = !1,
    children: b,
    className: x,
    component: S = "div",
    allowScrollButtonsMobile: R = !1,
    indicatorColor: T = "primary",
    onChange: E,
    orientation: P = "horizontal",
    ScrollButtonComponent: k = t5,
    scrollButtons: _ = "auto",
    selectionFollowsFocus: L,
    slots: F = {},
    slotProps: N = {},
    TabIndicatorProps: V = {},
    TabScrollButtonProps: z = {},
    textColor: H = "primary",
    value: ee,
    variant: K = "standard",
    visibleScrollbar: X = !1
  } = o, ne = Te(o, vse), Y = K === "scrollable", J = P === "vertical", te = J ? "scrollTop" : "scrollLeft", Z = J ? "top" : "left", ae = J ? "bottom" : "right", U = J ? "clientHeight" : "clientWidth", G = J ? "height" : "width", W = O({}, o, {
    component: S,
    allowScrollButtonsMobile: R,
    indicatorColor: T,
    orientation: P,
    vertical: J,
    scrollButtons: _,
    textColor: H,
    variant: K,
    visibleScrollbar: X,
    fixed: !Y,
    hideScrollbar: Y && !X,
    scrollableX: Y && !J,
    scrollableY: Y && J,
    centered: m && !Y,
    scrollButtonsHideMobile: !R
  }), le = gse(W), pe = Li({
    elementType: F.StartScrollButtonIcon,
    externalSlotProps: N.startScrollButtonIcon,
    ownerState: W
  }), ge = Li({
    elementType: F.EndScrollButtonIcon,
    externalSlotProps: N.endScrollButtonIcon,
    ownerState: W
  });
  process.env.NODE_ENV !== "production" && m && Y && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [we, de] = D.useState(!1), [se, ve] = D.useState(hF), [me, Oe] = D.useState(!1), [be, De] = D.useState(!1), [ie, fe] = D.useState(!1), [ye, Ee] = D.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), _e = /* @__PURE__ */ new Map(), Ve = D.useRef(null), Re = D.useRef(null), lt = () => {
    const Be = Ve.current;
    let Qe;
    if (Be) {
      const ct = Be.getBoundingClientRect();
      Qe = {
        clientWidth: Be.clientWidth,
        scrollLeft: Be.scrollLeft,
        scrollTop: Be.scrollTop,
        scrollLeftNormalized: rY(Be, s.direction),
        scrollWidth: Be.scrollWidth,
        top: ct.top,
        bottom: ct.bottom,
        left: ct.left,
        right: ct.right
      };
    }
    let xt;
    if (Be && ee !== !1) {
      const ct = Re.current.children;
      if (ct.length > 0) {
        const St = ct[_e.get(ee)];
        process.env.NODE_ENV !== "production" && (St || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${ee}".`, _e.keys ? `You can provide one of the following values: ${Array.from(_e.keys()).join(", ")}.` : null].join(`
`))), xt = St ? St.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !mF && xt && xt.width === 0 && xt.height === 0 && // if the whole Tabs component is hidden, don't warn
        Qe.clientWidth !== 0 && (Qe = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${ee}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), mF = !0);
      }
    }
    return {
      tabsMeta: Qe,
      tabMeta: xt
    };
  }, Pt = qo(() => {
    const {
      tabsMeta: Be,
      tabMeta: Qe
    } = lt();
    let xt = 0, ct;
    if (J)
      ct = "top", Qe && Be && (xt = Qe.top - Be.top + Be.scrollTop);
    else if (ct = l ? "right" : "left", Qe && Be) {
      const tn = l ? Be.scrollLeftNormalized + Be.clientWidth - Be.scrollWidth : Be.scrollLeft;
      xt = (l ? -1 : 1) * (Qe[ct] - Be[ct] + tn);
    }
    const St = {
      [ct]: xt,
      // May be wrong until the font is loaded.
      [G]: Qe ? Qe[G] : 0
    };
    if (isNaN(se[ct]) || isNaN(se[G]))
      ve(St);
    else {
      const tn = Math.abs(se[ct] - St[ct]), Wt = Math.abs(se[G] - St[G]);
      (tn >= 1 || Wt >= 1) && ve(St);
    }
  }), at = (Be, {
    animation: Qe = !0
  } = {}) => {
    Qe ? sse(te, Ve.current, Be, {
      duration: s.transitions.duration.standard
    }) : Ve.current[te] = Be;
  }, it = (Be) => {
    let Qe = Ve.current[te];
    J ? Qe += Be : (Qe += Be * (l ? -1 : 1), Qe *= l && rB() === "reverse" ? -1 : 1), at(Qe);
  }, bt = () => {
    const Be = Ve.current[U];
    let Qe = 0;
    const xt = Array.from(Re.current.children);
    for (let ct = 0; ct < xt.length; ct += 1) {
      const St = xt[ct];
      if (Qe + St[U] > Be) {
        ct === 0 && (Qe = Be);
        break;
      }
      Qe += St[U];
    }
    return Qe;
  }, Nt = () => {
    it(-1 * bt());
  }, en = () => {
    it(bt());
  }, fn = D.useCallback((Be) => {
    Ee({
      overflow: null,
      scrollbarWidth: Be
    });
  }, []), ln = () => {
    const Be = {};
    Be.scrollbarSizeListener = Y ? /* @__PURE__ */ I(Cse, {
      onChange: fn,
      className: Ne(le.scrollableX, le.hideScrollbar)
    }) : null;
    const xt = Y && (_ === "auto" && (me || be) || _ === !0);
    return Be.scrollButtonStart = xt ? /* @__PURE__ */ I(k, O({
      slots: {
        StartScrollButtonIcon: F.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: pe
      },
      orientation: P,
      direction: l ? "right" : "left",
      onClick: Nt,
      disabled: !me
    }, z, {
      className: Ne(le.scrollButtons, z.className)
    })) : null, Be.scrollButtonEnd = xt ? /* @__PURE__ */ I(k, O({
      slots: {
        EndScrollButtonIcon: F.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: ge
      },
      orientation: P,
      direction: l ? "left" : "right",
      onClick: en,
      disabled: !be
    }, z, {
      className: Ne(le.scrollButtons, z.className)
    })) : null, Be;
  }, Rt = qo((Be) => {
    const {
      tabsMeta: Qe,
      tabMeta: xt
    } = lt();
    if (!(!xt || !Qe)) {
      if (xt[Z] < Qe[Z]) {
        const ct = Qe[te] + (xt[Z] - Qe[Z]);
        at(ct, {
          animation: Be
        });
      } else if (xt[ae] > Qe[ae]) {
        const ct = Qe[te] + (xt[ae] - Qe[ae]);
        at(ct, {
          animation: Be
        });
      }
    }
  }), rt = qo(() => {
    Y && _ !== !1 && fe(!ie);
  });
  D.useEffect(() => {
    const Be = bv(() => {
      Ve.current && Pt();
    });
    let Qe;
    const xt = (tn) => {
      tn.forEach((Wt) => {
        Wt.removedNodes.forEach((dn) => {
          var hr;
          (hr = Qe) == null || hr.unobserve(dn);
        }), Wt.addedNodes.forEach((dn) => {
          var hr;
          (hr = Qe) == null || hr.observe(dn);
        });
      }), Be(), rt();
    }, ct = us(Ve.current);
    ct.addEventListener("resize", Be);
    let St;
    return typeof ResizeObserver < "u" && (Qe = new ResizeObserver(Be), Array.from(Re.current.children).forEach((tn) => {
      Qe.observe(tn);
    })), typeof MutationObserver < "u" && (St = new MutationObserver(xt), St.observe(Re.current, {
      childList: !0
    })), () => {
      var tn, Wt;
      Be.clear(), ct.removeEventListener("resize", Be), (tn = St) == null || tn.disconnect(), (Wt = Qe) == null || Wt.disconnect();
    };
  }, [Pt, rt]), D.useEffect(() => {
    const Be = Array.from(Re.current.children), Qe = Be.length;
    if (typeof IntersectionObserver < "u" && Qe > 0 && Y && _ !== !1) {
      const xt = Be[0], ct = Be[Qe - 1], St = {
        root: Ve.current,
        threshold: 0.99
      }, tn = (yo) => {
        Oe(!yo[0].isIntersecting);
      }, Wt = new IntersectionObserver(tn, St);
      Wt.observe(xt);
      const dn = (yo) => {
        De(!yo[0].isIntersecting);
      }, hr = new IntersectionObserver(dn, St);
      return hr.observe(ct), () => {
        Wt.disconnect(), hr.disconnect();
      };
    }
  }, [Y, _, ie, b == null ? void 0 : b.length]), D.useEffect(() => {
    de(!0);
  }, []), D.useEffect(() => {
    Pt();
  }), D.useEffect(() => {
    Rt(hF !== se);
  }, [Rt, se]), D.useImperativeHandle(h, () => ({
    updateIndicator: Pt,
    updateScrollButtons: rt
  }), [Pt, rt]);
  const Qt = /* @__PURE__ */ I(Sse, O({}, V, {
    className: Ne(le.indicator, V.className),
    ownerState: W,
    style: O({}, se, V.style)
  }));
  let et = 0;
  const st = D.Children.map(b, (Be) => {
    if (!/* @__PURE__ */ D.isValidElement(Be))
      return null;
    process.env.NODE_ENV !== "production" && jc.isFragment(Be) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const Qe = Be.props.value === void 0 ? et : Be.props.value;
    _e.set(Qe, et);
    const xt = Qe === ee;
    return et += 1, /* @__PURE__ */ D.cloneElement(Be, O({
      fullWidth: K === "fullWidth",
      indicator: xt && !we && Qt,
      selected: xt,
      selectionFollowsFocus: L,
      onChange: E,
      textColor: H,
      value: Qe
    }, et === 1 && ee === !1 && !Be.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), jt = (Be) => {
    const Qe = Re.current, xt = no(Qe).activeElement;
    if (xt.getAttribute("role") !== "tab")
      return;
    let St = P === "horizontal" ? "ArrowLeft" : "ArrowUp", tn = P === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (P === "horizontal" && l && (St = "ArrowRight", tn = "ArrowLeft"), Be.key) {
      case St:
        Be.preventDefault(), d1(Qe, xt, pF);
        break;
      case tn:
        Be.preventDefault(), d1(Qe, xt, fF);
        break;
      case "Home":
        Be.preventDefault(), d1(Qe, null, fF);
        break;
      case "End":
        Be.preventDefault(), d1(Qe, null, pF);
        break;
    }
  }, Xe = ln();
  return /* @__PURE__ */ qe(yse, O({
    className: Ne(le.root, x),
    ownerState: W,
    ref: n,
    as: S
  }, ne, {
    children: [Xe.scrollButtonStart, Xe.scrollbarSizeListener, /* @__PURE__ */ qe(bse, {
      className: le.scroller,
      ownerState: W,
      style: {
        overflow: ye.overflow,
        [J ? `margin${l ? "Left" : "Right"}` : "marginBottom"]: X ? void 0 : -ye.scrollbarWidth
      },
      ref: Ve,
      children: [/* @__PURE__ */ I(xse, {
        "aria-label": u,
        "aria-labelledby": p,
        "aria-orientation": P === "vertical" ? "vertical" : null,
        className: le.flexContainer,
        ownerState: W,
        onKeyDown: jt,
        ref: Re,
        role: "tablist",
        children: st
      }), we && Qt]
    }), Xe.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" && (xk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: Yo,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: r.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": r.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": r.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: r.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: r.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: r.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: r.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: r.shape({
    endScrollButtonIcon: r.oneOfType([r.func, r.object]),
    startScrollButtonIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    EndScrollButtonIcon: r.elementType,
    StartScrollButtonIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: r.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: r.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: r.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: r.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: r.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: r.bool
});
function wse(e) {
  return pt("MuiTextField", e);
}
ht("MuiTextField", ["root"]);
const Tse = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], Ese = {
  standard: fT,
  filled: lT,
  outlined: w0
}, Rse = (e) => {
  const {
    classes: t
  } = e;
  return vt({
    root: ["root"]
  }, wse, t);
}, Ose = ce(Cv, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), O0 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: s,
    autoFocus: l = !1,
    children: u,
    className: p,
    color: h = "primary",
    defaultValue: m,
    disabled: b = !1,
    error: x = !1,
    FormHelperTextProps: S,
    fullWidth: R = !1,
    helperText: T,
    id: E,
    InputLabelProps: P,
    inputProps: k,
    InputProps: _,
    inputRef: L,
    label: F,
    maxRows: N,
    minRows: V,
    multiline: z = !1,
    name: H,
    onBlur: ee,
    onChange: K,
    onFocus: X,
    placeholder: ne,
    required: Y = !1,
    rows: J,
    select: te = !1,
    SelectProps: Z,
    type: ae,
    value: U,
    variant: G = "outlined"
  } = o, W = Te(o, Tse), le = O({}, o, {
    autoFocus: l,
    color: h,
    disabled: b,
    error: x,
    fullWidth: R,
    multiline: z,
    required: Y,
    select: te,
    variant: G
  }), pe = Rse(le);
  process.env.NODE_ENV !== "production" && te && !u && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const ge = {};
  G === "outlined" && (P && typeof P.shrink < "u" && (ge.notched = P.shrink), ge.label = F), te && ((!Z || !Z.native) && (ge.id = void 0), ge["aria-describedby"] = void 0);
  const we = Vc(E), de = T && we ? `${we}-helper-text` : void 0, se = F && we ? `${we}-label` : void 0, ve = Ese[G], me = /* @__PURE__ */ I(ve, O({
    "aria-describedby": de,
    autoComplete: s,
    autoFocus: l,
    defaultValue: m,
    fullWidth: R,
    multiline: z,
    name: H,
    rows: J,
    maxRows: N,
    minRows: V,
    type: ae,
    value: U,
    id: we,
    inputRef: L,
    onBlur: ee,
    onChange: K,
    onFocus: X,
    placeholder: ne,
    inputProps: k
  }, ge, _));
  return /* @__PURE__ */ qe(Ose, O({
    className: Ne(pe.root, p),
    disabled: b,
    error: x,
    fullWidth: R,
    ref: n,
    required: Y,
    color: h,
    variant: G,
    ownerState: le
  }, W, {
    children: [F != null && F !== "" && /* @__PURE__ */ I(S0, O({
      htmlFor: we,
      id: se
    }, P, {
      children: F
    })), te ? /* @__PURE__ */ I(T0, O({
      "aria-describedby": de,
      id: we,
      labelId: se,
      value: U,
      input: me
    }, Z, {
      children: u
    })) : me, T && /* @__PURE__ */ I(ql, O({
      id: de
    }, S, {
      children: T
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (O0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * @ignore
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: r.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Yo,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: r.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: r.object,
  /**
   * The size of the component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const Pse = {
  small: "jv-mAccordionSmall",
  normal: ""
}, $se = ft(
  ({ className: e = "", size: t = "normal", children: n, ...o }, s) => {
    const l = Pse[t];
    return /* @__PURE__ */ I(
      HB,
      {
        ref: s,
        className: `jv-mAccordion mui ${l} ${e}`,
        elevation: 0,
        square: !0,
        ...o,
        children: n
      }
    );
  }
), Dse = ft(
  ({ className: e = "", children: t, ...n }, o) => /* @__PURE__ */ I(
    WB,
    {
      ref: o,
      className: `jv-mAccordion-body mui ${e}`,
      ...n,
      children: t
    }
  )
);
var Sk = {}, n5 = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(n5);
var r5 = n5.exports, s$ = {};
const kse = /* @__PURE__ */ vd($X);
var vF;
function Mse() {
  return vF || (vF = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = kse;
  }(s$)), s$;
}
var Nse = r5;
Object.defineProperty(Sk, "__esModule", {
  value: !0
});
var o5 = Sk.default = void 0, Ise = Nse(Mse()), _se = wq;
o5 = Sk.default = (0, Ise.default)(/* @__PURE__ */ (0, _se.jsx)("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
const Ase = {
  small: "jv-mAccordion-titleShaded",
  normal: ""
}, Lse = ft(
  ({ className: e = "", classes: t = {}, size: n = "normal", children: o, ...s }, l) => {
    const { content: u = "", expandIconWrapper: p = "", ...h } = t, m = Ase[n];
    return /* @__PURE__ */ I(
      GB,
      {
        ref: l,
        className: `jv-mAccordion-title mui ${m} ${e}`,
        classes: {
          content: `jv-mAccordion-title-text mui ${u}`,
          expandIconWrapper: `jv-mAccordion-title-icon mui ${p}`,
          ...h
        },
        expandIcon: /* @__PURE__ */ I(o5, {}),
        ...s,
        children: o
      }
    );
  }
), G2e = ft(
  ({
    id: e,
    size: t = "normal",
    SummaryProps: n,
    summary: o,
    DetailsProps: s,
    children: l,
    ...u
  }, p) => {
    const h = e ? `${e}-header` : void 0, m = e ? `${e}-content` : void 0;
    return /* @__PURE__ */ qe($se, { ref: p, size: t, ...u, children: [
      /* @__PURE__ */ I(
        Lse,
        {
          id: h,
          "aria-controls": m,
          size: t,
          ...n,
          children: o
        }
      ),
      /* @__PURE__ */ I(Dse, { ...s, children: l })
    ] });
  }
);
function Fse({
  paperComponentProps: e = {},
  ...t
}, n) {
  const { elevation: o = 8, ...s } = e;
  return /* @__PURE__ */ I(
    fz,
    {
      ref: n,
      PaperComponent: ({ children: l }) => /* @__PURE__ */ I(ms, { elevation: o, ...s, children: l }),
      ...t
    }
  );
}
const K2e = ft(Fse), X2e = ft(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I(pz, { ref: n, className: `${e}`, ...t })
), a5 = {
  large: "jv-mButtonLarge",
  small: "jv-mButtonSmall",
  medium: ""
}, i5 = {
  inherit: "",
  default: "",
  success: "",
  info: "",
  secondary: "jv-mButtonSecondary",
  primary: "jv-mButtonPrimary",
  error: "jv-mButtonError",
  warning: "jv-mButtonWarning"
}, jse = {
  contained: "jv-MuiButton-contained",
  text: "jv-MuiButton-text",
  outlined: "jv-MuiButton-outlined"
}, Q2e = ft(
  ({
    labelProps: e = {},
    className: t = "",
    size: n = "medium",
    color: o = "secondary",
    children: s,
    ...l
  }, u) => {
    const { labelClasses: p = "" } = e;
    return /* @__PURE__ */ I(
      sd,
      {
        ref: u,
        className: `jv-mButton ${a5[n]} ${i5[o]} mui ${t}`,
        disableElevation: !0,
        size: n,
        ...l,
        children: /* @__PURE__ */ I(
          "span",
          {
            className: `jv-MuiButton-label jv-mButton-label mui ${p}`,
            children: s
          }
        )
      }
    );
  }
), Vse = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(
    vz,
    {
      ref: n,
      className: `jv-mButtongroup mui ${e}`,
      variant: "contained",
      color: "secondary",
      disableElevation: !0,
      ...t
    }
  )
), s5 = "jv-mInputInline", Bse = "jv-mInputNolabel", zse = "jv-mInputContained";
var Rv = /* @__PURE__ */ ((e) => (e.large = "jv-mInputLarge", e.small = "jv-mInputSmall", e.medium = "", e))(Rv || {}), l5 = /* @__PURE__ */ ((e) => (e.narrow = "jv-mInputNarrow", e.normal = "", e))(l5 || {});
const J2e = ft(
  ({
    id: e,
    label: t,
    className: n = "",
    buttonGroupClassName: o = "",
    size: s,
    InputLabelProps: l = {},
    children: u,
    ...p
  }, h) => {
    const m = e ? `${e}-label` : void 0, b = e ? `${e}-buttonGroup` : void 0, x = m || void 0, { className: S = "", ...R } = l;
    return /* @__PURE__ */ qe(
      "div",
      {
        id: e,
        ref: h,
        className: `jv-mInput jv-mInputInline jv-mInputButtons mui ${Rv[s ?? "medium"]} ${n}`,
        children: [
          /* @__PURE__ */ I(
            S0,
            {
              id: m,
              className: `jv-mInput-label mui ${S}`,
              ...R,
              children: t
            }
          ),
          /* @__PURE__ */ I(
            Vse,
            {
              id: b,
              className: o,
              size: s,
              "aria-labelledby": x,
              ...p,
              children: u
            }
          )
        ]
      }
    );
  }
), Z2e = ft(
  ({
    variant: e = "elevation",
    className: t = "",
    elevation: n = 2,
    ...o
  }, s) => /* @__PURE__ */ I(
    eT,
    {
      ref: s,
      className: `jv-mCard  ${t} mui`,
      variant: e,
      elevation: n,
      ...o
    }
  )
), eAe = ft(
  ({ className: e = "", classes: t = {}, control: n, CheckboxProps: o = {}, ...s }, l) => {
    const { classes: u = {}, ...p } = o;
    return /* @__PURE__ */ I(
      cT,
      {
        ref: l,
        control: n ?? /* @__PURE__ */ I(
          b0,
          {
            color: "primary",
            classes: {
              root: `jv-mInput-checkbox-check mui ${u.root ?? ""}`
            },
            ...p
          }
        ),
        className: `jv-mInput-checkbox ${e} mui`,
        classes: {
          label: `jv-mInput-checkbox-label mui ${(t == null ? void 0 : t.root) ?? ""}`,
          ...t
        },
        ...s
      }
    );
  }
), c5 = ft(
  (e, t) => {
    const { className: n = "", text: o, ...s } = e || {};
    return /* @__PURE__ */ I(Po, { children: o && /* @__PURE__ */ I(
      ql,
      {
        ref: t,
        className: `jv-mInput-helper mui ${n}`,
        ...s,
        children: o
      }
    ) });
  }
), Use = ft(
  (e, t) => {
    const { className: n = "", text: o, ...s } = e || {};
    return /* @__PURE__ */ I(Po, { children: o && /* @__PURE__ */ I(
      ql,
      {
        ref: t,
        className: `jv-mInput-error mui ${n}`,
        ...s,
        children: o
      }
    ) });
  }
), tAe = ft(
  ({
    helperText: e,
    errorMessage: t,
    children: n,
    size: o = "medium",
    title: s = "",
    FormLabelProps: l = {},
    FormGroupProps: u = {},
    FormControlProps: p = {}
  }, h) => {
    const {
      component: m = "fieldset",
      className: b = "",
      ...x
    } = p, {
      className: S = "",
      component: R = "legend",
      ...T
    } = l;
    return /* @__PURE__ */ qe(
      Cv,
      {
        ref: h,
        component: m,
        className: `jv-mInput ${Rv[o]} ${b} jv-mInputCheckbox mui`,
        ...x,
        children: [
          s && /* @__PURE__ */ I(
            uT,
            {
              component: R,
              className: `jv-mInput-label ${S} mui`,
              ...T,
              children: s
            }
          ),
          /* @__PURE__ */ I(sk, { ...u, children: n }),
          /* @__PURE__ */ I(c5, { text: e }),
          /* @__PURE__ */ I(Use, { text: t })
        ]
      }
    );
  }
), nAe = (e) => {
  const { onClickAway: t, ...n } = e;
  return /* @__PURE__ */ I(q1, { onClickAway: t, ...n });
}, rAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(Sv, { ref: t, ...e })
), Hse = 270, gF = 270, Wse = 100, yF = 50, Ck = 10, P0 = (e, t) => t[e].subPanels.some((n) => n.open), wk = (e, t) => !t[e].subPanels.some((n) => !n.open), qse = (e) => e.subPanels.map((t) => t.open).lastIndexOf(!0), u5 = (e) => e.map((t) => ({
  id: t.id,
  width: t.width,
  subPanels: t.subPanels.map((n) => ({
    id: n.id,
    height: n.height
  }))
}));
function G$(e, t, n) {
  return [...e.slice(0, n), t, ...e.slice(n + 1)];
}
const Yse = (e, t, n) => {
  const o = e[t];
  return n.reduce((s, l, u) => {
    const p = o.subPanels[u], h = {
      ...p,
      ...l ? {} : { height: p.initialHeight },
      open: l
    };
    return [...s, h];
  }, []);
}, Gse = (e, t, n, o) => {
  const s = e[t];
  let { subPanels: l } = s;
  typeof n == "boolean" && (l = Yse(
    e,
    t,
    l.map(() => n)
  ));
  const u = {
    ...s,
    width: o ?? s.width,
    subPanels: l
  };
  return G$(e, u, t);
}, Kse = (e, t, n, o, s, l) => {
  const { subPanels: u } = e[t], p = u[n], h = {
    ...p,
    open: o ?? p.open,
    height: s ?? p.height,
    scrollPos: l ?? p.scrollPos
  }, m = {
    ...e[t],
    subPanels: G$(u, h, n)
  };
  return G$(e, m, t);
}, Xse = (e) => e.reduce((t, n) => {
  const {
    height: o = Wse,
    id: s,
    open: l = !1,
    minHeight: u = yF,
    scrollPos: p = 0
  } = n, h = Math.max(u, yF), m = Math.max(o, h), b = {
    id: s,
    initialHeight: m,
    height: m,
    minHeight: h,
    scrollPos: p,
    open: l
  };
  return [...t, b];
}, []), Qse = (e) => e.reduce((t, n) => {
  const {
    width: o = Hse,
    id: s,
    minWidth: l = gF,
    subPanels: u
  } = n, p = Math.max(gF, l), h = Math.max(o, p), m = {
    id: s,
    width: h,
    minWidth: p,
    subPanels: Xse(u)
  };
  return [...t, m];
}, []), d5 = (e) => {
  const t = ud(
    () => Qse(e),
    [e]
  ), [n, o] = Kf(t);
  Lb(() => {
    o(t);
  }, [t, o]);
  const s = Z2(
    (u, p, h) => {
      o(Gse(n, u, p, h));
    },
    [o, n]
  ), l = Z2(
    (u, p, h, m, b) => {
      o(
        Kse(
          n,
          u,
          p,
          h,
          m,
          b
        )
      );
    },
    [o, n]
  );
  return [n, s, l];
}, vT = {
  right: {
    panelDirectionClass: "jv-mPanelRight",
    panelsDirectionClass: "jv-mPanelsRight"
  },
  left: {
    panelDirectionClass: "jv-mPanelLeft",
    panelsDirectionClass: "jv-mPanelsLeft"
  }
}, $0 = ft(
  ({
    labelProps: e = {},
    color: t = "secondary",
    className: n = "",
    size: o = "medium",
    icon: s,
    variant: l = "text",
    selected: u = !1,
    ...p
  }, h) => {
    const { labelClasses: m } = e, b = `jv-${s}`, x = u ? "jv-Mui-selected" : "";
    return /* @__PURE__ */ I(
      oi,
      {
        ref: h,
        className: `jv-mButton ${i5[t]} ${a5[o]} mui ${jse[l]} ${x} ${n}`,
        ...p,
        children: /* @__PURE__ */ I(
          "span",
          {
            className: `jv-mButton-icon jv-mIcon mui ${b} ${m}`
          }
        )
      }
    );
  }
), Jse = ({
  subPanelsState: e,
  panelIndex: t,
  subPanels: n,
  setSubPanelState: o,
  onExpandClick: s
}) => {
  const l = "Open sub panel", u = (p, h) => {
    const m = s({ type: "subpanel", id: h });
    (typeof m > "u" || m) && o(t, p, !0);
  };
  return /* @__PURE__ */ I(Tv, { disablePadding: !0, className: "jv-mPanel-sections mui", component: "ul", children: n.map((p, h) => {
    const m = e[h];
    return !m.open && /* @__PURE__ */ I(
      C0,
      {
        disableGutters: !0,
        className: "jv-mPanel-section mui",
        component: "li",
        "data-name": `${m.id}-tab`,
        children: /* @__PURE__ */ I(
          sd,
          {
            "data-name": `${m.id}-tab-expand`,
            classes: { root: "jv-mPanel-section-action mui" },
            onClick: () => u(h, m.id),
            "aria-label": l,
            children: /* @__PURE__ */ qe("span", { className: "jv-MuiButton-label jv-mButton-label mui", children: [
              " ",
              p.label
            ] })
          }
        )
      },
      m.id
    );
  }) });
}, Zse = ft(
  ({
    anchor: e,
    setPanelState: t,
    setSubPanelState: n,
    panels: o,
    panelsState: s,
    onExpandClick: l
  }, u) => {
    const { panelsDirectionClass: p, panelDirectionClass: h } = vT[e], m = "Open panel", b = (x, S) => {
      const R = l({ type: "panel", id: S });
      (typeof R > "u" || R) && t(x, !0);
    };
    return /* @__PURE__ */ I(
      "div",
      {
        className: `jv-mPanels ${p} jv-mPanelsMinimized jv-mPanelsStacked mui`,
        ref: u,
        children: o.map((x, S) => {
          const R = !wk(S, s), T = s[S], { id: E } = T;
          return R && /* @__PURE__ */ qe(
            "div",
            {
              className: `jv-mPanel ${h} jv-mPanelMinimized mui`,
              "data-name": `${E}-tabs`,
              children: [
                /* @__PURE__ */ I("div", { className: "jv-mPanel-action mui", children: /* @__PURE__ */ I(
                  $0,
                  {
                    "data-name": `${E}-tabs-expand`,
                    "aria-label": m,
                    icon: e === "right" ? "caretLeftLarge" : "caretRightLarge",
                    size: "small",
                    className: "jv-mPanel-action-button",
                    onClick: () => b(S, E)
                  }
                ) }),
                /* @__PURE__ */ I(
                  Jse,
                  {
                    panelIndex: S,
                    subPanels: x.subPanels,
                    subPanelsState: T.subPanels,
                    setSubPanelState: n,
                    onExpandClick: l
                  }
                )
              ]
            },
            E
          );
        })
      }
    );
  }
);
var ele = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
      o.__proto__ = s;
    } || function(o, s) {
      for (var l in s) s.hasOwnProperty(l) && (o[l] = s[l]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), ew = function() {
  return ew = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, ew.apply(this, arguments);
}, tle = {
  top: {
    width: "100%",
    height: "10px",
    top: "-5px",
    left: "0px",
    cursor: "row-resize"
  },
  right: {
    width: "10px",
    height: "100%",
    top: "0px",
    right: "-5px",
    cursor: "col-resize"
  },
  bottom: {
    width: "100%",
    height: "10px",
    bottom: "-5px",
    left: "0px",
    cursor: "row-resize"
  },
  left: {
    width: "10px",
    height: "100%",
    top: "0px",
    left: "-5px",
    cursor: "col-resize"
  },
  topRight: {
    width: "20px",
    height: "20px",
    position: "absolute",
    right: "-10px",
    top: "-10px",
    cursor: "ne-resize"
  },
  bottomRight: {
    width: "20px",
    height: "20px",
    position: "absolute",
    right: "-10px",
    bottom: "-10px",
    cursor: "se-resize"
  },
  bottomLeft: {
    width: "20px",
    height: "20px",
    position: "absolute",
    left: "-10px",
    bottom: "-10px",
    cursor: "sw-resize"
  },
  topLeft: {
    width: "20px",
    height: "20px",
    position: "absolute",
    left: "-10px",
    top: "-10px",
    cursor: "nw-resize"
  }
}, nle = (
  /** @class */
  function(e) {
    ele(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(o) {
        n.props.onResizeStart(o, n.props.direction);
      }, n.onTouchStart = function(o) {
        n.props.onResizeStart(o, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return D.createElement("div", { className: this.props.className || "", style: ew(ew({ position: "absolute", userSelect: "none" }, tle[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  }(D.PureComponent)
), Tk = { exports: {} };
function rle(e, t) {
  var n = t && t.cache ? t.cache : cle, o = t && t.serializer ? t.serializer : lle, s = t && t.strategy ? t.strategy : ale;
  return s(e, {
    cache: n,
    serializer: o
  });
}
function ole(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function f5(e, t, n, o) {
  var s = ole(o) ? o : n(o), l = t.get(s);
  return typeof l > "u" && (l = e.call(this, o), t.set(s, l)), l;
}
function p5(e, t, n) {
  var o = Array.prototype.slice.call(arguments, 3), s = n(o), l = t.get(s);
  return typeof l > "u" && (l = e.apply(this, o), t.set(s, l)), l;
}
function Ek(e, t, n, o, s) {
  return n.bind(
    t,
    e,
    o,
    s
  );
}
function ale(e, t) {
  var n = e.length === 1 ? f5 : p5;
  return Ek(
    e,
    this,
    n,
    t.cache.create(),
    t.serializer
  );
}
function ile(e, t) {
  var n = p5;
  return Ek(
    e,
    this,
    n,
    t.cache.create(),
    t.serializer
  );
}
function sle(e, t) {
  var n = f5;
  return Ek(
    e,
    this,
    n,
    t.cache.create(),
    t.serializer
  );
}
function lle() {
  return JSON.stringify(arguments);
}
function gT() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
gT.prototype.has = function(e) {
  return e in this.cache;
};
gT.prototype.get = function(e) {
  return this.cache[e];
};
gT.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var cle = {
  create: function() {
    return new gT();
  }
};
Tk.exports = rle;
Tk.exports.strategies = {
  variadic: ile,
  monadic: sle
};
var ule = Tk.exports;
const lp = /* @__PURE__ */ qc(ule);
var dle = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, s) {
      o.__proto__ = s;
    } || function(o, s) {
      for (var l in s) s.hasOwnProperty(l) && (o[l] = s[l]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function o() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  };
}(), Il = function() {
  return Il = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Il.apply(this, arguments);
}, fle = {
  width: "auto",
  height: "auto"
}, f1 = lp(function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}), bF = lp(function(e, t) {
  return Math.round(e / t) * t;
}), Rm = lp(function(e, t) {
  return new RegExp(e, "i").test(t);
}), p1 = function(e) {
  return !!(e.touches && e.touches.length);
}, ple = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, xF = lp(function(e, t, n) {
  n === void 0 && (n = 0);
  var o = t.reduce(function(l, u, p) {
    return Math.abs(u - e) < Math.abs(t[l] - e) ? p : l;
  }, 0), s = Math.abs(t[o] - e);
  return n === 0 || s < n ? t[o] : e;
}), Oo = lp(function(e, t) {
  return e.substr(e.length - t.length, t.length) === t;
}), l$ = lp(function(e) {
  return e = e.toString(), e === "auto" || Oo(e, "px") || Oo(e, "%") || Oo(e, "vh") || Oo(e, "vw") || Oo(e, "vmax") || Oo(e, "vmin") ? e : e + "px";
}), h1 = function(e, t, n, o) {
  if (e && typeof e == "string") {
    if (Oo(e, "px"))
      return Number(e.replace("px", ""));
    if (Oo(e, "%")) {
      var s = Number(e.replace("%", "")) / 100;
      return t * s;
    }
    if (Oo(e, "vw")) {
      var s = Number(e.replace("vw", "")) / 100;
      return n * s;
    }
    if (Oo(e, "vh")) {
      var s = Number(e.replace("vh", "")) / 100;
      return o * s;
    }
  }
  return e;
}, hle = lp(function(e, t, n, o, s, l, u) {
  return o = h1(o, e.width, t, n), s = h1(s, e.height, t, n), l = h1(l, e.width, t, n), u = h1(u, e.height, t, n), {
    maxWidth: typeof o > "u" ? void 0 : Number(o),
    maxHeight: typeof s > "u" ? void 0 : Number(s),
    minWidth: typeof l > "u" ? void 0 : Number(l),
    minHeight: typeof u > "u" ? void 0 : Number(u)
  };
}), mle = [
  "as",
  "style",
  "className",
  "grid",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], SF = "__resizable_base__", Rk = (
  /** @class */
  function(e) {
    dle(t, e);
    function t(n) {
      var o = e.call(this, n) || this;
      return o.ratio = 1, o.resizable = null, o.parentLeft = 0, o.parentTop = 0, o.resizableLeft = 0, o.resizableRight = 0, o.resizableTop = 0, o.resizableBottom = 0, o.targetLeft = 0, o.targetTop = 0, o.appendBase = function() {
        if (!o.resizable || !o.window)
          return null;
        var s = o.parentNode;
        if (!s)
          return null;
        var l = o.window.document.createElement("div");
        return l.style.width = "100%", l.style.height = "100%", l.style.position = "absolute", l.style.transform = "scale(0, 0)", l.style.left = "0", l.style.flex = "0", l.classList ? l.classList.add(SF) : l.className += SF, s.appendChild(l), l;
      }, o.removeBase = function(s) {
        var l = o.parentNode;
        l && l.removeChild(s);
      }, o.ref = function(s) {
        s && (o.resizable = s);
      }, o.state = {
        isResizing: !1,
        width: typeof (o.propsSize && o.propsSize.width) > "u" ? "auto" : o.propsSize && o.propsSize.width,
        height: typeof (o.propsSize && o.propsSize.height) > "u" ? "auto" : o.propsSize && o.propsSize.height,
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, o.onResizeStart = o.onResizeStart.bind(o), o.onMouseMove = o.onMouseMove.bind(o), o.onMouseUp = o.onMouseUp.bind(o), o;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || fle;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, o = 0;
        if (this.resizable && this.window) {
          var s = this.resizable.offsetWidth, l = this.resizable.offsetHeight, u = this.resizable.style.position;
          u !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : s, o = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : l, this.resizable.style.position = u;
        }
        return { width: n, height: o };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, o = this.props.size, s = function(p) {
          if (typeof n.state[p] > "u" || n.state[p] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[p] && Oo(n.propsSize[p].toString(), "%")) {
            if (Oo(n.state[p].toString(), "%"))
              return n.state[p].toString();
            var h = n.getParentSize(), m = Number(n.state[p].toString().replace("px", "")), b = m / h[p] * 100;
            return b + "%";
          }
          return l$(n.state[p]);
        }, l = o && typeof o.width < "u" && !this.state.isResizing ? l$(o.width) : s("width"), u = o && typeof o.height < "u" && !this.state.isResizing ? l$(o.height) : s("height");
        return { width: l, height: u };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var o = !1, s = this.parentNode.style.flexWrap;
      s !== "wrap" && (o = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%";
      var l = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return o && (this.parentNode.style.flexWrap = s), this.removeBase(n), l;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, o) {
      var s = this.propsSize && this.propsSize[o];
      return this.state[o] === "auto" && this.state.original[o] === n && (typeof s > "u" || s === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, o) {
      var s = this.props.boundsByDirection, l = this.state.direction, u = s && Rm("left", l), p = s && Rm("top", l), h, m;
      if (this.props.bounds === "parent") {
        var b = this.parentNode;
        b && (h = u ? this.resizableRight - this.parentLeft : b.offsetWidth + (this.parentLeft - this.resizableLeft), m = p ? this.resizableBottom - this.parentTop : b.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (h = u ? this.resizableRight : this.window.innerWidth - this.resizableLeft, m = p ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (h = u ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), m = p ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return h && Number.isFinite(h) && (n = n && n < h ? n : h), m && Number.isFinite(m) && (o = o && o < m ? o : m), { maxWidth: n, maxHeight: o };
    }, t.prototype.calculateNewSizeFromDirection = function(n, o) {
      var s = this.props.scale || 1, l = this.props.resizeRatio || 1, u = this.state, p = u.direction, h = u.original, m = this.props, b = m.lockAspectRatio, x = m.lockAspectRatioExtraHeight, S = m.lockAspectRatioExtraWidth, R = h.width, T = h.height, E = x || 0, P = S || 0;
      return Rm("right", p) && (R = h.width + (n - h.x) * l / s, b && (T = (R - P) / this.ratio + E)), Rm("left", p) && (R = h.width - (n - h.x) * l / s, b && (T = (R - P) / this.ratio + E)), Rm("bottom", p) && (T = h.height + (o - h.y) * l / s, b && (R = (T - E) * this.ratio + P)), Rm("top", p) && (T = h.height - (o - h.y) * l / s, b && (R = (T - E) * this.ratio + P)), { newWidth: R, newHeight: T };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, o, s, l) {
      var u = this.props, p = u.lockAspectRatio, h = u.lockAspectRatioExtraHeight, m = u.lockAspectRatioExtraWidth, b = typeof l.width > "u" ? 10 : l.width, x = typeof s.width > "u" || s.width < 0 ? n : s.width, S = typeof l.height > "u" ? 10 : l.height, R = typeof s.height > "u" || s.height < 0 ? o : s.height, T = h || 0, E = m || 0;
      if (p) {
        var P = (S - T) * this.ratio + E, k = (R - T) * this.ratio + E, _ = (b - E) / this.ratio + T, L = (x - E) / this.ratio + T, F = Math.max(b, P), N = Math.min(x, k), V = Math.max(S, _), z = Math.min(R, L);
        n = f1(n, F, N), o = f1(o, V, z);
      } else
        n = f1(n, b, x), o = f1(o, S, R);
      return { newWidth: n, newHeight: o };
    }, t.prototype.setBoundingClientRect = function() {
      if (this.props.bounds === "parent") {
        var n = this.parentNode;
        if (n) {
          var o = n.getBoundingClientRect();
          this.parentLeft = o.left, this.parentTop = o.top;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var s = this.props.bounds.getBoundingClientRect();
        this.targetLeft = s.left, this.targetTop = s.top;
      }
      if (this.resizable) {
        var l = this.resizable.getBoundingClientRect(), u = l.left, p = l.top, h = l.right, m = l.bottom;
        this.resizableLeft = u, this.resizableRight = h, this.resizableTop = p, this.resizableBottom = m;
      }
    }, t.prototype.onResizeStart = function(n, o) {
      if (!(!this.resizable || !this.window)) {
        var s = 0, l = 0;
        if (n.nativeEvent && ple(n.nativeEvent)) {
          if (s = n.nativeEvent.clientX, l = n.nativeEvent.clientY, n.nativeEvent.which === 3)
            return;
        } else n.nativeEvent && p1(n.nativeEvent) && (s = n.nativeEvent.touches[0].clientX, l = n.nativeEvent.touches[0].clientY);
        if (this.props.onResizeStart && this.resizable) {
          var u = this.props.onResizeStart(n, o, this.resizable);
          if (u === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var p, h = this.window.getComputedStyle(this.resizable);
        if (h.flexBasis !== "auto") {
          var m = this.parentNode;
          if (m) {
            var b = this.window.getComputedStyle(m).flexDirection;
            this.flexDir = b.startsWith("row") ? "row" : "column", p = h.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var x = {
          original: {
            x: s,
            y: l,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: Il(Il({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: o,
          flexBasis: p
        };
        this.setState(x);
      }
    }, t.prototype.onMouseMove = function(n) {
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && p1(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var o = this.props, s = o.maxWidth, l = o.maxHeight, u = o.minWidth, p = o.minHeight, h = p1(n) ? n.touches[0].clientX : n.clientX, m = p1(n) ? n.touches[0].clientY : n.clientY, b = this.state, x = b.direction, S = b.original, R = b.width, T = b.height, E = this.getParentSize(), P = hle(E, this.window.innerWidth, this.window.innerHeight, s, l, u, p);
        s = P.maxWidth, l = P.maxHeight, u = P.minWidth, p = P.minHeight;
        var k = this.calculateNewSizeFromDirection(h, m), _ = k.newHeight, L = k.newWidth, F = this.calculateNewMaxFromBoundary(s, l), N = this.calculateNewSizeFromAspectRatio(L, _, { width: F.maxWidth, height: F.maxHeight }, { width: u, height: p });
        if (L = N.newWidth, _ = N.newHeight, this.props.grid) {
          var V = bF(L, this.props.grid[0]), z = bF(_, this.props.grid[1]), H = this.props.snapGap || 0;
          L = H === 0 || Math.abs(V - L) <= H ? V : L, _ = H === 0 || Math.abs(z - _) <= H ? z : _;
        }
        this.props.snap && this.props.snap.x && (L = xF(L, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (_ = xF(_, this.props.snap.y, this.props.snapGap));
        var ee = {
          width: L - S.width,
          height: _ - S.height
        };
        if (R && typeof R == "string") {
          if (Oo(R, "%")) {
            var K = L / E.width * 100;
            L = K + "%";
          } else if (Oo(R, "vw")) {
            var X = L / this.window.innerWidth * 100;
            L = X + "vw";
          } else if (Oo(R, "vh")) {
            var ne = L / this.window.innerHeight * 100;
            L = ne + "vh";
          }
        }
        if (T && typeof T == "string") {
          if (Oo(T, "%")) {
            var K = _ / E.height * 100;
            _ = K + "%";
          } else if (Oo(T, "vw")) {
            var X = _ / this.window.innerWidth * 100;
            _ = X + "vw";
          } else if (Oo(T, "vh")) {
            var ne = _ / this.window.innerHeight * 100;
            _ = ne + "vh";
          }
        }
        var Y = {
          width: this.createSizeForCssProperty(L, "width"),
          height: this.createSizeForCssProperty(_, "height")
        };
        this.flexDir === "row" ? Y.flexBasis = Y.width : this.flexDir === "column" && (Y.flexBasis = Y.height), this.setState(Y), this.props.onResize && this.props.onResize(n, x, this.resizable, ee);
      }
    }, t.prototype.onMouseUp = function(n) {
      var o = this.state, s = o.isResizing, l = o.direction, u = o.original;
      if (!(!s || !this.resizable)) {
        var p = {
          width: this.size.width - u.width,
          height: this.size.height - u.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, l, this.resizable, p), this.props.size && this.setState(this.props.size), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: Il(Il({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      this.setState({ width: n.width, height: n.height });
    }, t.prototype.renderResizer = function() {
      var n = this, o = this.props, s = o.enable, l = o.handleStyles, u = o.handleClasses, p = o.handleWrapperStyle, h = o.handleWrapperClass, m = o.handleComponent;
      if (!s)
        return null;
      var b = Object.keys(s).map(function(x) {
        return s[x] !== !1 ? D.createElement(nle, { key: x, direction: x, onResizeStart: n.onResizeStart, replaceStyles: l && l[x], className: u && u[x] }, m && m[x] ? m[x] : null) : null;
      });
      return D.createElement("div", { className: h, style: p }, b);
    }, t.prototype.render = function() {
      var n = this, o = Object.keys(this.props).reduce(function(u, p) {
        return mle.indexOf(p) !== -1 || (u[p] = n.props[p]), u;
      }, {}), s = Il(Il(Il({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (s.flexBasis = this.state.flexBasis);
      var l = this.props.as || "div";
      return D.createElement(
        l,
        Il({ ref: this.ref, style: s, className: this.props.className }, o),
        this.state.isResizing && D.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(D.PureComponent)
);
const vle = ({
  onCollapse: e,
  anchor: t,
  className: n = "",
  id: o,
  children: s
}) => /* @__PURE__ */ qe(
  sT,
  {
    variant: "persistent",
    anchor: t,
    open: !0,
    style: { width: "100%", height: "100%" },
    className: `mui jv-mPanel ${n}`,
    "data-name": o,
    children: [
      /* @__PURE__ */ I("div", { className: "jv-mPanel-action mui", children: /* @__PURE__ */ I(
        $0,
        {
          "data-name": `${o}-collapse`,
          icon: t === "right" ? "caretRightLarge" : "caretLeftLarge",
          size: "small",
          className: "jv-mPanel-action-button",
          "aria-label": "Close panel",
          onClick: () => e()
        }
      ) }),
      s
    ]
  }
), gle = ({
  id: e,
  label: t,
  children: n,
  slots: o = {},
  onClose: s,
  onScroll: l,
  scrollPos: u
}) => {
  const { headerAction: p } = o, h = "Close sub panel", m = l0(null), [b, x] = Kf(0), S = (R) => {
    const T = R.target.scrollTop;
    x(T), T !== u && l(T);
  };
  return Gf(() => {
    m.current && u !== b && (m.current.scrollTop = u, x(u));
  }, [m, b, u]), /* @__PURE__ */ qe(eT, { elevation: 0, children: [
    /* @__PURE__ */ I(
      ok,
      {
        className: "jv-mPanel-section-header mui",
        classes: { content: "jv-mPanel-section-header-title mui" },
        title: t,
        action: /* @__PURE__ */ qe(Po, { children: [
          p,
          /* @__PURE__ */ I(
            $0,
            {
              "data-name": `${e}-collapse`,
              icon: "cancel",
              variant: "contained",
              color: "default",
              "aria-label": h,
              onClick: s,
              size: "large"
            }
          )
        ] }),
        disableTypography: !0
      }
    ),
    /* @__PURE__ */ I(rk, { ref: m, component: "div", onScroll: S, children: n })
  ] });
}, yle = (e) => {
  const {
    subPanelDefinition: t,
    subPanelState: n,
    setSubPanelState: o,
    panelIndex: s,
    subPanelIndex: l,
    onScroll: u,
    onCollapseClick: p
  } = e, { content: h, render: m, label: b, id: x, slots: S } = t, { initialHeight: R, scrollPos: T } = n, E = () => {
    const k = p({ type: "subpanel", id: x });
    (typeof k > "u" || k) && o(s, l, !1, R);
  }, P = (k) => {
    u({ id: x, scrollPos: k }), o(
      s,
      l,
      void 0,
      void 0,
      k
    );
  };
  return m ? m({
    onScroll: P,
    onClose: E,
    label: b,
    id: x,
    scrollPos: T
  }) : /* @__PURE__ */ I(
    gle,
    {
      label: b,
      slots: S,
      onClose: E,
      onScroll: P,
      scrollPos: T,
      id: x,
      children: h
    }
  );
}, ble = ({
  panelState: e,
  panel: t,
  panelIndex: n,
  setSubPanelState: o,
  onResize: s,
  onResizeStart: l,
  onScroll: u,
  onCollapseClick: p
}) => {
  const h = qse(e);
  return /* @__PURE__ */ I(
    Tv,
    {
      disablePadding: !0,
      className: "jv-mPanel-sections mui",
      component: "div",
      style: { overflow: "hidden" },
      children: t.subPanels.map((m, b) => {
        const x = e.subPanels[b], S = b === h, R = S ? {} : { height: "100%" };
        if (!x.open)
          return;
        const T = /* @__PURE__ */ I(
          C0,
          {
            "data-name": m.id,
            disableGutters: !0,
            className: "jv-mPanel-section mui",
            style: R,
            component: "div",
            children: yle({
              onScroll: u,
              subPanelDefinition: m,
              subPanelState: x,
              setSubPanelState: o,
              panelIndex: n,
              subPanelIndex: b,
              onCollapseClick: p
            })
          },
          x.id
        );
        return S ? T : /* @__PURE__ */ I(
          Rk,
          {
            enable: {
              bottom: !0
            },
            handleClasses: { bottom: "jv-mPanel-resizerVertical mui" },
            size: {
              width: "100%",
              height: x.height
            },
            minHeight: x.minHeight,
            style: {
              marginBottom: "8px",
              width: "100%"
            },
            onResize: (E, P, k, _) => s({
              type: "subpanel",
              id: x.id,
              delta: _.height
            }),
            onResizeStart: () => l({
              type: "subpanel",
              id: x.id
            }),
            onResizeStop: (E, P, k, _) => {
              o(
                n,
                b,
                void 0,
                x.height + _.height
              );
            },
            children: T
          },
          x.id
        );
      })
    }
  );
};
var h5 = "1.13.1", CF = typeof self == "object" && self.self === self && self || typeof global == "object" && global.global === global && global || Function("return this")() || {}, yT = Array.prototype, Ok = Object.prototype, wF = typeof Symbol < "u" ? Symbol.prototype : null, xle = yT.push, D0 = yT.slice, Xb = Ok.toString, Sle = Ok.hasOwnProperty, m5 = typeof ArrayBuffer < "u", Cle = typeof DataView < "u", wle = Array.isArray, TF = Object.keys, EF = Object.create, RF = m5 && ArrayBuffer.isView, Tle = isNaN, Ele = isFinite, v5 = !{ toString: null }.propertyIsEnumerable("toString"), OF = [
  "valueOf",
  "isPrototypeOf",
  "toString",
  "propertyIsEnumerable",
  "hasOwnProperty",
  "toLocaleString"
], Rle = Math.pow(2, 53) - 1;
function di(e, t) {
  return t = t == null ? e.length - 1 : +t, function() {
    for (var n = Math.max(arguments.length - t, 0), o = Array(n), s = 0; s < n; s++)
      o[s] = arguments[s + t];
    switch (t) {
      case 0:
        return e.call(this, o);
      case 1:
        return e.call(this, arguments[0], o);
      case 2:
        return e.call(this, arguments[0], arguments[1], o);
    }
    var l = Array(t + 1);
    for (s = 0; s < t; s++)
      l[s] = arguments[s];
    return l[t] = o, e.apply(this, l);
  };
}
function cp(e) {
  var t = typeof e;
  return t === "function" || t === "object" && !!e;
}
function Ole(e) {
  return e === null;
}
function g5(e) {
  return e === void 0;
}
function y5(e) {
  return e === !0 || e === !1 || Xb.call(e) === "[object Boolean]";
}
function Ple(e) {
  return !!(e && e.nodeType === 1);
}
function ha(e) {
  var t = "[object " + e + "]";
  return function(n) {
    return Xb.call(n) === t;
  };
}
const Pk = ha("String"), b5 = ha("Number"), $le = ha("Date"), Dle = ha("RegExp"), kle = ha("Error"), x5 = ha("Symbol"), S5 = ha("ArrayBuffer");
var C5 = ha("Function"), Mle = CF.document && CF.document.childNodes;
typeof /./ != "function" && typeof Int8Array != "object" && typeof Mle != "function" && (C5 = function(e) {
  return typeof e == "function" || !1;
});
const Da = C5, w5 = ha("Object");
var T5 = Cle && w5(new DataView(new ArrayBuffer(8))), $k = typeof Map < "u" && w5(/* @__PURE__ */ new Map()), Nle = ha("DataView");
function Ile(e) {
  return e != null && Da(e.getInt8) && S5(e.buffer);
}
const tw = T5 ? Ile : Nle, up = wle || ha("Array");
function Cd(e, t) {
  return e != null && Sle.call(e, t);
}
var K$ = ha("Arguments");
(function() {
  K$(arguments) || (K$ = function(e) {
    return Cd(e, "callee");
  });
})();
const Dk = K$;
function _le(e) {
  return !x5(e) && Ele(e) && !isNaN(parseFloat(e));
}
function E5(e) {
  return b5(e) && Tle(e);
}
function R5(e) {
  return function() {
    return e;
  };
}
function O5(e) {
  return function(t) {
    var n = e(t);
    return typeof n == "number" && n >= 0 && n <= Rle;
  };
}
function P5(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
const nw = P5("byteLength"), Ale = O5(nw);
var Lle = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function Fle(e) {
  return RF ? RF(e) && !tw(e) : Ale(e) && Lle.test(Xb.call(e));
}
const $5 = m5 ? Fle : R5(!1), fi = P5("length");
function jle(e) {
  for (var t = {}, n = e.length, o = 0; o < n; ++o) t[e[o]] = !0;
  return {
    contains: function(s) {
      return t[s];
    },
    push: function(s) {
      return t[s] = !0, e.push(s);
    }
  };
}
function D5(e, t) {
  t = jle(t);
  var n = OF.length, o = e.constructor, s = Da(o) && o.prototype || Ok, l = "constructor";
  for (Cd(e, l) && !t.contains(l) && t.push(l); n--; )
    l = OF[n], l in e && e[l] !== s[l] && !t.contains(l) && t.push(l);
}
function $o(e) {
  if (!cp(e)) return [];
  if (TF) return TF(e);
  var t = [];
  for (var n in e) Cd(e, n) && t.push(n);
  return v5 && D5(e, t), t;
}
function Vle(e) {
  if (e == null) return !0;
  var t = fi(e);
  return typeof t == "number" && (up(e) || Pk(e) || Dk(e)) ? t === 0 : fi($o(e)) === 0;
}
function k5(e, t) {
  var n = $o(t), o = n.length;
  if (e == null) return !o;
  for (var s = Object(e), l = 0; l < o; l++) {
    var u = n[l];
    if (t[u] !== s[u] || !(u in s)) return !1;
  }
  return !0;
}
function Hn(e) {
  if (e instanceof Hn) return e;
  if (!(this instanceof Hn)) return new Hn(e);
  this._wrapped = e;
}
Hn.VERSION = h5;
Hn.prototype.value = function() {
  return this._wrapped;
};
Hn.prototype.valueOf = Hn.prototype.toJSON = Hn.prototype.value;
Hn.prototype.toString = function() {
  return String(this._wrapped);
};
function PF(e) {
  return new Uint8Array(
    e.buffer || e,
    e.byteOffset || 0,
    nw(e)
  );
}
var $F = "[object DataView]";
function X$(e, t, n, o) {
  if (e === t) return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null) return !1;
  if (e !== e) return t !== t;
  var s = typeof e;
  return s !== "function" && s !== "object" && typeof t != "object" ? !1 : M5(e, t, n, o);
}
function M5(e, t, n, o) {
  e instanceof Hn && (e = e._wrapped), t instanceof Hn && (t = t._wrapped);
  var s = Xb.call(e);
  if (s !== Xb.call(t)) return !1;
  if (T5 && s == "[object Object]" && tw(e)) {
    if (!tw(t)) return !1;
    s = $F;
  }
  switch (s) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return wF.valueOf.call(e) === wF.valueOf.call(t);
    case "[object ArrayBuffer]":
    case $F:
      return M5(PF(e), PF(t), n, o);
  }
  var l = s === "[object Array]";
  if (!l && $5(e)) {
    var u = nw(e);
    if (u !== nw(t)) return !1;
    if (e.buffer === t.buffer && e.byteOffset === t.byteOffset) return !0;
    l = !0;
  }
  if (!l) {
    if (typeof e != "object" || typeof t != "object") return !1;
    var p = e.constructor, h = t.constructor;
    if (p !== h && !(Da(p) && p instanceof p && Da(h) && h instanceof h) && "constructor" in e && "constructor" in t)
      return !1;
  }
  n = n || [], o = o || [];
  for (var m = n.length; m--; )
    if (n[m] === e) return o[m] === t;
  if (n.push(e), o.push(t), l) {
    if (m = e.length, m !== t.length) return !1;
    for (; m--; )
      if (!X$(e[m], t[m], n, o)) return !1;
  } else {
    var b = $o(e), x;
    if (m = b.length, $o(t).length !== m) return !1;
    for (; m--; )
      if (x = b[m], !(Cd(t, x) && X$(e[x], t[x], n, o))) return !1;
  }
  return n.pop(), o.pop(), !0;
}
function Ble(e, t) {
  return X$(e, t);
}
function k0(e) {
  if (!cp(e)) return [];
  var t = [];
  for (var n in e) t.push(n);
  return v5 && D5(e, t), t;
}
function kk(e) {
  var t = fi(e);
  return function(n) {
    if (n == null) return !1;
    var o = k0(n);
    if (fi(o)) return !1;
    for (var s = 0; s < t; s++)
      if (!Da(n[e[s]])) return !1;
    return e !== _5 || !Da(n[Mk]);
  };
}
var Mk = "forEach", N5 = "has", Nk = ["clear", "delete"], I5 = ["get", N5, "set"], zle = Nk.concat(Mk, I5), _5 = Nk.concat(I5), Ule = ["add"].concat(Nk, Mk, N5);
const Hle = $k ? kk(zle) : ha("Map"), Wle = $k ? kk(_5) : ha("WeakMap"), qle = $k ? kk(Ule) : ha("Set"), Yle = ha("WeakSet");
function tp(e) {
  for (var t = $o(e), n = t.length, o = Array(n), s = 0; s < n; s++)
    o[s] = e[t[s]];
  return o;
}
function Gle(e) {
  for (var t = $o(e), n = t.length, o = Array(n), s = 0; s < n; s++)
    o[s] = [t[s], e[t[s]]];
  return o;
}
function A5(e) {
  for (var t = {}, n = $o(e), o = 0, s = n.length; o < s; o++)
    t[e[n[o]]] = n[o];
  return t;
}
function Q$(e) {
  var t = [];
  for (var n in e)
    Da(e[n]) && t.push(n);
  return t.sort();
}
function Ik(e, t) {
  return function(n) {
    var o = arguments.length;
    if (t && (n = Object(n)), o < 2 || n == null) return n;
    for (var s = 1; s < o; s++)
      for (var l = arguments[s], u = e(l), p = u.length, h = 0; h < p; h++) {
        var m = u[h];
        (!t || n[m] === void 0) && (n[m] = l[m]);
      }
    return n;
  };
}
const L5 = Ik(k0), rw = Ik($o), F5 = Ik(k0, !0);
function Kle() {
  return function() {
  };
}
function j5(e) {
  if (!cp(e)) return {};
  if (EF) return EF(e);
  var t = Kle();
  t.prototype = e;
  var n = new t();
  return t.prototype = null, n;
}
function Xle(e, t) {
  var n = j5(e);
  return t && rw(n, t), n;
}
function V5(e) {
  return cp(e) ? up(e) ? e.slice() : L5({}, e) : e;
}
function Qle(e, t) {
  return t(e), e;
}
function B5(e) {
  return up(e) ? e : [e];
}
Hn.toPath = B5;
function M0(e) {
  return Hn.toPath(e);
}
function _k(e, t) {
  for (var n = t.length, o = 0; o < n; o++) {
    if (e == null) return;
    e = e[t[o]];
  }
  return n ? e : void 0;
}
function z5(e, t, n) {
  var o = _k(e, M0(t));
  return g5(o) ? n : o;
}
function Jle(e, t) {
  t = M0(t);
  for (var n = t.length, o = 0; o < n; o++) {
    var s = t[o];
    if (!Cd(e, s)) return !1;
    e = e[s];
  }
  return !!n;
}
function Ak(e) {
  return e;
}
function Qb(e) {
  return e = rw({}, e), function(t) {
    return k5(t, e);
  };
}
function Lk(e) {
  return e = M0(e), function(t) {
    return _k(t, e);
  };
}
function N0(e, t, n) {
  if (t === void 0) return e;
  switch (n ?? 3) {
    case 1:
      return function(o) {
        return e.call(t, o);
      };
    case 3:
      return function(o, s, l) {
        return e.call(t, o, s, l);
      };
    case 4:
      return function(o, s, l, u) {
        return e.call(t, o, s, l, u);
      };
  }
  return function() {
    return e.apply(t, arguments);
  };
}
function U5(e, t, n) {
  return e == null ? Ak : Da(e) ? N0(e, t, n) : cp(e) && !up(e) ? Qb(e) : Lk(e);
}
function Fk(e, t) {
  return U5(e, t, 1 / 0);
}
Hn.iteratee = Fk;
function vi(e, t, n) {
  return Hn.iteratee !== Fk ? Hn.iteratee(e, t) : U5(e, t, n);
}
function Zle(e, t, n) {
  t = vi(t, n);
  for (var o = $o(e), s = o.length, l = {}, u = 0; u < s; u++) {
    var p = o[u];
    l[p] = t(e[p], p, e);
  }
  return l;
}
function H5() {
}
function ece(e) {
  return e == null ? H5 : function(t) {
    return z5(e, t);
  };
}
function tce(e, t, n) {
  var o = Array(Math.max(0, e));
  t = N0(t, n, 1);
  for (var s = 0; s < e; s++) o[s] = t(s);
  return o;
}
function J$(e, t) {
  return t == null && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1));
}
const Jb = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function W5(e) {
  var t = function(l) {
    return e[l];
  }, n = "(?:" + $o(e).join("|") + ")", o = RegExp(n), s = RegExp(n, "g");
  return function(l) {
    return l = l == null ? "" : "" + l, o.test(l) ? l.replace(s, t) : l;
  };
}
const q5 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;"
}, nce = W5(q5), rce = A5(q5), oce = W5(rce), ace = Hn.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};
var c$ = /(.)^/, ice = {
  "'": "'",
  "\\": "\\",
  "\r": "r",
  "\n": "n",
  "\u2028": "u2028",
  "\u2029": "u2029"
}, sce = /\\|'|\r|\n|\u2028|\u2029/g;
function lce(e) {
  return "\\" + ice[e];
}
var cce = /^\s*(\w|\$)+\s*$/;
function uce(e, t, n) {
  !t && n && (t = n), t = F5({}, t, Hn.templateSettings);
  var o = RegExp([
    (t.escape || c$).source,
    (t.interpolate || c$).source,
    (t.evaluate || c$).source
  ].join("|") + "|$", "g"), s = 0, l = "__p+='";
  e.replace(o, function(m, b, x, S, R) {
    return l += e.slice(s, R).replace(sce, lce), s = R + m.length, b ? l += `'+
((__t=(` + b + `))==null?'':_.escape(__t))+
'` : x ? l += `'+
((__t=(` + x + `))==null?'':__t)+
'` : S && (l += `';
` + S + `
__p+='`), m;
  }), l += `';
`;
  var u = t.variable;
  if (u) {
    if (!cce.test(u)) throw new Error(
      "variable is not a bare identifier: " + u
    );
  } else
    l = `with(obj||{}){
` + l + `}
`, u = "obj";
  l = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + l + `return __p;
`;
  var p;
  try {
    p = new Function(u, "_", l);
  } catch (m) {
    throw m.source = l, m;
  }
  var h = function(m) {
    return p.call(this, m, Hn);
  };
  return h.source = "function(" + u + `){
` + l + "}", h;
}
function dce(e, t, n) {
  t = M0(t);
  var o = t.length;
  if (!o)
    return Da(n) ? n.call(e) : n;
  for (var s = 0; s < o; s++) {
    var l = e == null ? void 0 : e[t[s]];
    l === void 0 && (l = n, s = o), e = Da(l) ? l.call(e) : l;
  }
  return e;
}
var fce = 0;
function pce(e) {
  var t = ++fce + "";
  return e ? e + t : t;
}
function hce(e) {
  var t = Hn(e);
  return t._chain = !0, t;
}
function Y5(e, t, n, o, s) {
  if (!(o instanceof t)) return e.apply(n, s);
  var l = j5(e.prototype), u = e.apply(l, s);
  return cp(u) ? u : l;
}
var Ov = di(function(e, t) {
  var n = Ov.placeholder, o = function() {
    for (var s = 0, l = t.length, u = Array(l), p = 0; p < l; p++)
      u[p] = t[p] === n ? arguments[s++] : t[p];
    for (; s < arguments.length; ) u.push(arguments[s++]);
    return Y5(e, o, this, this, u);
  };
  return o;
});
Ov.placeholder = Hn;
const G5 = di(function(e, t, n) {
  if (!Da(e)) throw new TypeError("Bind must be called on a function");
  var o = di(function(s) {
    return Y5(e, o, t, this, n.concat(s));
  });
  return o;
}), pi = O5(fi);
function dp(e, t, n, o) {
  if (o = o || [], !t && t !== 0)
    t = 1 / 0;
  else if (t <= 0)
    return o.concat(e);
  for (var s = o.length, l = 0, u = fi(e); l < u; l++) {
    var p = e[l];
    if (pi(p) && (up(p) || Dk(p)))
      if (t > 1)
        dp(p, t - 1, n, o), s = o.length;
      else
        for (var h = 0, m = p.length; h < m; ) o[s++] = p[h++];
    else n || (o[s++] = p);
  }
  return o;
}
const mce = di(function(e, t) {
  t = dp(t, !1, !1);
  var n = t.length;
  if (n < 1) throw new Error("bindAll must be passed function names");
  for (; n--; ) {
    var o = t[n];
    e[o] = G5(e[o], e);
  }
  return e;
});
function vce(e, t) {
  var n = function(o) {
    var s = n.cache, l = "" + (t ? t.apply(this, arguments) : o);
    return Cd(s, l) || (s[l] = e.apply(this, arguments)), s[l];
  };
  return n.cache = {}, n;
}
const K5 = di(function(e, t, n) {
  return setTimeout(function() {
    return e.apply(null, n);
  }, t);
}), gce = Ov(K5, Hn, 1);
function yce(e, t, n) {
  var o, s, l, u, p = 0;
  n || (n = {});
  var h = function() {
    p = n.leading === !1 ? 0 : Jb(), o = null, u = e.apply(s, l), o || (s = l = null);
  }, m = function() {
    var b = Jb();
    !p && n.leading === !1 && (p = b);
    var x = t - (b - p);
    return s = this, l = arguments, x <= 0 || x > t ? (o && (clearTimeout(o), o = null), p = b, u = e.apply(s, l), o || (s = l = null)) : !o && n.trailing !== !1 && (o = setTimeout(h, x)), u;
  };
  return m.cancel = function() {
    clearTimeout(o), p = 0, o = s = l = null;
  }, m;
}
function bce(e, t, n) {
  var o, s, l, u, p, h = function() {
    var b = Jb() - s;
    t > b ? o = setTimeout(h, t - b) : (o = null, n || (u = e.apply(p, l)), o || (l = p = null));
  }, m = di(function(b) {
    return p = this, l = b, s = Jb(), o || (o = setTimeout(h, t), n && (u = e.apply(p, l))), u;
  });
  return m.cancel = function() {
    clearTimeout(o), o = l = p = null;
  }, m;
}
function xce(e, t) {
  return Ov(t, e);
}
function jk(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function Sce() {
  var e = arguments, t = e.length - 1;
  return function() {
    for (var n = t, o = e[t].apply(this, arguments); n--; ) o = e[n].call(this, o);
    return o;
  };
}
function Cce(e, t) {
  return function() {
    if (--e < 1)
      return t.apply(this, arguments);
  };
}
function X5(e, t) {
  var n;
  return function() {
    return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
  };
}
const wce = Ov(X5, 2);
function Q5(e, t, n) {
  t = vi(t, n);
  for (var o = $o(e), s, l = 0, u = o.length; l < u; l++)
    if (s = o[l], t(e[s], s, e)) return s;
}
function J5(e) {
  return function(t, n, o) {
    n = vi(n, o);
    for (var s = fi(t), l = e > 0 ? 0 : s - 1; l >= 0 && l < s; l += e)
      if (n(t[l], l, t)) return l;
    return -1;
  };
}
const Vk = J5(1), Z5 = J5(-1);
function e4(e, t, n, o) {
  n = vi(n, o, 1);
  for (var s = n(t), l = 0, u = fi(e); l < u; ) {
    var p = Math.floor((l + u) / 2);
    n(e[p]) < s ? l = p + 1 : u = p;
  }
  return l;
}
function t4(e, t, n) {
  return function(o, s, l) {
    var u = 0, p = fi(o);
    if (typeof l == "number")
      e > 0 ? u = l >= 0 ? l : Math.max(l + p, u) : p = l >= 0 ? Math.min(l + 1, p) : l + p + 1;
    else if (n && l && p)
      return l = n(o, s), o[l] === s ? l : -1;
    if (s !== s)
      return l = t(D0.call(o, u, p), E5), l >= 0 ? l + u : -1;
    for (l = e > 0 ? u : p - 1; l >= 0 && l < p; l += e)
      if (o[l] === s) return l;
    return -1;
  };
}
const n4 = t4(1, Vk, e4), Tce = t4(-1, Z5);
function Z$(e, t, n) {
  var o = pi(e) ? Vk : Q5, s = o(e, t, n);
  if (s !== void 0 && s !== -1) return e[s];
}
function Ece(e, t) {
  return Z$(e, Qb(t));
}
function Uc(e, t, n) {
  t = N0(t, n);
  var o, s;
  if (pi(e))
    for (o = 0, s = e.length; o < s; o++)
      t(e[o], o, e);
  else {
    var l = $o(e);
    for (o = 0, s = l.length; o < s; o++)
      t(e[l[o]], l[o], e);
  }
  return e;
}
function np(e, t, n) {
  t = vi(t, n);
  for (var o = !pi(e) && $o(e), s = (o || e).length, l = Array(s), u = 0; u < s; u++) {
    var p = o ? o[u] : u;
    l[u] = t(e[p], p, e);
  }
  return l;
}
function r4(e) {
  var t = function(n, o, s, l) {
    var u = !pi(n) && $o(n), p = (u || n).length, h = e > 0 ? 0 : p - 1;
    for (l || (s = n[u ? u[h] : h], h += e); h >= 0 && h < p; h += e) {
      var m = u ? u[h] : h;
      s = o(s, n[m], m, n);
    }
    return s;
  };
  return function(n, o, s, l) {
    var u = arguments.length >= 3;
    return t(n, N0(o, l, 4), s, u);
  };
}
const u$ = r4(1), DF = r4(-1);
function hv(e, t, n) {
  var o = [];
  return t = vi(t, n), Uc(e, function(s, l, u) {
    t(s, l, u) && o.push(s);
  }), o;
}
function Rce(e, t, n) {
  return hv(e, jk(vi(t)), n);
}
function kF(e, t, n) {
  t = vi(t, n);
  for (var o = !pi(e) && $o(e), s = (o || e).length, l = 0; l < s; l++) {
    var u = o ? o[l] : l;
    if (!t(e[u], u, e)) return !1;
  }
  return !0;
}
function MF(e, t, n) {
  t = vi(t, n);
  for (var o = !pi(e) && $o(e), s = (o || e).length, l = 0; l < s; l++) {
    var u = o ? o[l] : l;
    if (t(e[u], u, e)) return !0;
  }
  return !1;
}
function Fc(e, t, n, o) {
  return pi(e) || (e = tp(e)), (typeof n != "number" || o) && (n = 0), n4(e, t, n) >= 0;
}
const Oce = di(function(e, t, n) {
  var o, s;
  return Da(t) ? s = t : (t = M0(t), o = t.slice(0, -1), t = t[t.length - 1]), np(e, function(l) {
    var u = s;
    if (!u) {
      if (o && o.length && (l = _k(l, o)), l == null) return;
      u = l[t];
    }
    return u == null ? u : u.apply(l, n);
  });
});
function Bk(e, t) {
  return np(e, Lk(t));
}
function Pce(e, t) {
  return hv(e, Qb(t));
}
function o4(e, t, n) {
  var o = -1 / 0, s = -1 / 0, l, u;
  if (t == null || typeof t == "number" && typeof e[0] != "object" && e != null) {
    e = pi(e) ? e : tp(e);
    for (var p = 0, h = e.length; p < h; p++)
      l = e[p], l != null && l > o && (o = l);
  } else
    t = vi(t, n), Uc(e, function(m, b, x) {
      u = t(m, b, x), (u > s || u === -1 / 0 && o === -1 / 0) && (o = m, s = u);
    });
  return o;
}
function $ce(e, t, n) {
  var o = 1 / 0, s = 1 / 0, l, u;
  if (t == null || typeof t == "number" && typeof e[0] != "object" && e != null) {
    e = pi(e) ? e : tp(e);
    for (var p = 0, h = e.length; p < h; p++)
      l = e[p], l != null && l < o && (o = l);
  } else
    t = vi(t, n), Uc(e, function(m, b, x) {
      u = t(m, b, x), (u < s || u === 1 / 0 && o === 1 / 0) && (o = m, s = u);
    });
  return o;
}
function a4(e, t, n) {
  if (t == null || n)
    return pi(e) || (e = tp(e)), e[J$(e.length - 1)];
  var o = pi(e) ? V5(e) : tp(e), s = fi(o);
  t = Math.max(Math.min(t, s), 0);
  for (var l = s - 1, u = 0; u < t; u++) {
    var p = J$(u, l), h = o[u];
    o[u] = o[p], o[p] = h;
  }
  return o.slice(0, t);
}
function Dce(e) {
  return a4(e, 1 / 0);
}
function kce(e, t, n) {
  var o = 0;
  return t = vi(t, n), Bk(np(e, function(s, l, u) {
    return {
      value: s,
      index: o++,
      criteria: t(s, l, u)
    };
  }).sort(function(s, l) {
    var u = s.criteria, p = l.criteria;
    if (u !== p) {
      if (u > p || u === void 0) return 1;
      if (u < p || p === void 0) return -1;
    }
    return s.index - l.index;
  }), "value");
}
function bT(e, t) {
  return function(n, o, s) {
    var l = t ? [[], []] : {};
    return o = vi(o, s), Uc(n, function(u, p) {
      var h = o(u, p, n);
      e(l, u, h);
    }), l;
  };
}
const Mce = bT(function(e, t, n) {
  Cd(e, n) ? e[n].push(t) : e[n] = [t];
}), Nce = bT(function(e, t, n) {
  e[n] = t;
}), Ice = bT(function(e, t, n) {
  Cd(e, n) ? e[n]++ : e[n] = 1;
}), _ce = bT(function(e, t, n) {
  e[n ? 0 : 1].push(t);
}, !0);
var Ace = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function Lce(e) {
  return e ? up(e) ? D0.call(e) : Pk(e) ? e.match(Ace) : pi(e) ? np(e, Ak) : tp(e) : [];
}
function Fce(e) {
  return e == null ? 0 : pi(e) ? e.length : $o(e).length;
}
function jce(e, t, n) {
  return t in n;
}
const i4 = di(function(e, t) {
  var n = {}, o = t[0];
  if (e == null) return n;
  Da(o) ? (t.length > 1 && (o = N0(o, t[1])), t = k0(e)) : (o = jce, t = dp(t, !1, !1), e = Object(e));
  for (var s = 0, l = t.length; s < l; s++) {
    var u = t[s], p = e[u];
    o(p, u, e) && (n[u] = p);
  }
  return n;
}), Vce = di(function(e, t) {
  var n = t[0], o;
  return Da(n) ? (n = jk(n), t.length > 1 && (o = t[1])) : (t = np(dp(t, !1, !1), String), n = function(s, l) {
    return !Fc(t, l);
  }), i4(e, n, o);
});
function s4(e, t, n) {
  return D0.call(e, 0, Math.max(0, e.length - (t == null || n ? 1 : t)));
}
function d$(e, t, n) {
  return e == null || e.length < 1 ? t == null || n ? void 0 : [] : t == null || n ? e[0] : s4(e, e.length - t);
}
function k1(e, t, n) {
  return D0.call(e, t == null || n ? 1 : t);
}
function Bce(e, t, n) {
  return e == null || e.length < 1 ? t == null || n ? void 0 : [] : t == null || n ? e[e.length - 1] : k1(e, Math.max(0, e.length - t));
}
function zce(e) {
  return hv(e, Boolean);
}
function Uce(e, t) {
  return dp(e, t, !1);
}
const l4 = di(function(e, t) {
  return t = dp(t, !0, !0), hv(e, function(n) {
    return !Fc(t, n);
  });
}), Hce = di(function(e, t) {
  return l4(e, t);
});
function eD(e, t, n, o) {
  y5(t) || (o = n, n = t, t = !1), n != null && (n = vi(n, o));
  for (var s = [], l = [], u = 0, p = fi(e); u < p; u++) {
    var h = e[u], m = n ? n(h, u, e) : h;
    t && !n ? ((!u || l !== m) && s.push(h), l = m) : n ? Fc(l, m) || (l.push(m), s.push(h)) : Fc(s, h) || s.push(h);
  }
  return s;
}
const Wce = di(function(e) {
  return eD(dp(e, !0, !0));
});
function qce(e) {
  for (var t = [], n = arguments.length, o = 0, s = fi(e); o < s; o++) {
    var l = e[o];
    if (!Fc(t, l)) {
      var u;
      for (u = 1; u < n && Fc(arguments[u], l); u++)
        ;
      u === n && t.push(l);
    }
  }
  return t;
}
function tD(e) {
  for (var t = e && o4(e, fi).length || 0, n = Array(t), o = 0; o < t; o++)
    n[o] = Bk(e, o);
  return n;
}
const Yce = di(tD);
function Gce(e, t) {
  for (var n = {}, o = 0, s = fi(e); o < s; o++)
    t ? n[e[o]] = t[o] : n[e[o][0]] = e[o][1];
  return n;
}
function Kce(e, t, n) {
  t == null && (t = e || 0, e = 0), n || (n = t < e ? -1 : 1);
  for (var o = Math.max(Math.ceil((t - e) / n), 0), s = Array(o), l = 0; l < o; l++, e += n)
    s[l] = e;
  return s;
}
function Xce(e, t) {
  if (t == null || t < 1) return [];
  for (var n = [], o = 0, s = e.length; o < s; )
    n.push(D0.call(e, o, o += t));
  return n;
}
function zk(e, t) {
  return e._chain ? Hn(t).chain() : t;
}
function c4(e) {
  return Uc(Q$(e), function(t) {
    var n = Hn[t] = e[t];
    Hn.prototype[t] = function() {
      var o = [this._wrapped];
      return xle.apply(o, arguments), zk(this, n.apply(Hn, o));
    };
  }), Hn;
}
Uc(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(e) {
  var t = yT[e];
  Hn.prototype[e] = function() {
    var n = this._wrapped;
    return n != null && (t.apply(n, arguments), (e === "shift" || e === "splice") && n.length === 0 && delete n[0]), zk(this, n);
  };
});
Uc(["concat", "join", "slice"], function(e) {
  var t = yT[e];
  Hn.prototype[e] = function() {
    var n = this._wrapped;
    return n != null && (n = t.apply(n, arguments)), zk(this, n);
  };
});
const Qce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VERSION: h5,
  after: Cce,
  all: kF,
  allKeys: k0,
  any: MF,
  assign: rw,
  before: X5,
  bind: G5,
  bindAll: mce,
  chain: hce,
  chunk: Xce,
  clone: V5,
  collect: np,
  compact: zce,
  compose: Sce,
  constant: R5,
  contains: Fc,
  countBy: Ice,
  create: Xle,
  debounce: bce,
  default: Hn,
  defaults: F5,
  defer: gce,
  delay: K5,
  detect: Z$,
  difference: l4,
  drop: k1,
  each: Uc,
  escape: nce,
  every: kF,
  extend: L5,
  extendOwn: rw,
  filter: hv,
  find: Z$,
  findIndex: Vk,
  findKey: Q5,
  findLastIndex: Z5,
  findWhere: Ece,
  first: d$,
  flatten: Uce,
  foldl: u$,
  foldr: DF,
  forEach: Uc,
  functions: Q$,
  get: z5,
  groupBy: Mce,
  has: Jle,
  head: d$,
  identity: Ak,
  include: Fc,
  includes: Fc,
  indexBy: Nce,
  indexOf: n4,
  initial: s4,
  inject: u$,
  intersection: qce,
  invert: A5,
  invoke: Oce,
  isArguments: Dk,
  isArray: up,
  isArrayBuffer: S5,
  isBoolean: y5,
  isDataView: tw,
  isDate: $le,
  isElement: Ple,
  isEmpty: Vle,
  isEqual: Ble,
  isError: kle,
  isFinite: _le,
  isFunction: Da,
  isMap: Hle,
  isMatch: k5,
  isNaN: E5,
  isNull: Ole,
  isNumber: b5,
  isObject: cp,
  isRegExp: Dle,
  isSet: qle,
  isString: Pk,
  isSymbol: x5,
  isTypedArray: $5,
  isUndefined: g5,
  isWeakMap: Wle,
  isWeakSet: Yle,
  iteratee: Fk,
  keys: $o,
  last: Bce,
  lastIndexOf: Tce,
  map: np,
  mapObject: Zle,
  matcher: Qb,
  matches: Qb,
  max: o4,
  memoize: vce,
  methods: Q$,
  min: $ce,
  mixin: c4,
  negate: jk,
  noop: H5,
  now: Jb,
  object: Gce,
  omit: Vce,
  once: wce,
  pairs: Gle,
  partial: Ov,
  partition: _ce,
  pick: i4,
  pluck: Bk,
  property: Lk,
  propertyOf: ece,
  random: J$,
  range: Kce,
  reduce: u$,
  reduceRight: DF,
  reject: Rce,
  rest: k1,
  restArguments: di,
  result: dce,
  sample: a4,
  select: hv,
  shuffle: Dce,
  size: Fce,
  some: MF,
  sortBy: kce,
  sortedIndex: e4,
  tail: k1,
  take: d$,
  tap: Qle,
  template: uce,
  templateSettings: ace,
  throttle: yce,
  times: tce,
  toArray: Lce,
  toPath: B5,
  transpose: tD,
  unescape: oce,
  union: Wce,
  uniq: eD,
  unique: eD,
  uniqueId: pce,
  unzip: tD,
  values: tp,
  where: Pce,
  without: Hce,
  wrap: xce,
  zip: Yce
}, Symbol.toStringTag, { value: "Module" }));
var ow = c4(Qce);
ow._ = ow;
const Jce = (e) => typeof e == "function" ? e() : e, NF = (e, t) => {
  const n = t.reduce((s, l, u) => {
    const p = P0(u, t);
    return s + (p ? l.width + Ck : 0);
  }, 0), o = e - n;
  return t.reduce((s, l) => {
    const u = Math.max(l.width, l.width + o);
    return [
      ...s,
      {
        id: l.id,
        maxWidth: u
      }
    ];
  }, []);
}, Zce = (e) => e.reduce((t, n, o) => {
  const s = P0(o, e);
  return `${t}${t.length ? "-" : ""}${n.width}:${s}`;
}, ""), eue = (e, t) => {
  const n = ud(
    () => Zce(t),
    [t]
  );
  Lb(() => {
    e();
  }, [e, n]);
}, tue = 500, f$ = (e, t) => Jce(e) - t, u4 = (e, t, n) => {
  const o = ud(
    () => f$(e, t),
    [e, t]
  ), [s, l] = Kf(o);
  Lb(() => {
    l(
      f$(e, t)
    );
  }, [e, t]);
  const u = ud(() => NF(s, n), [s]), [p, h] = Kf(u);
  return eue(() => {
    const m = NF(
      s,
      n
    );
    ow.isEqual(p, m) || h(m);
  }, n), Lb(() => {
    const m = ow.debounce(() => {
      l(
        f$(e, t)
      );
    }, tue);
    return window.addEventListener("resize", m, !0), () => {
      window.removeEventListener("resize", m, !0);
    };
  }, [e, t, l]), p;
}, nue = {
  left: { right: !0 },
  right: { left: !0 }
}, rue = {
  right: { left: "jv-mPanel-resizerHorizontal mui" },
  left: { right: "" }
}, oue = ({
  children: e,
  anchor: t,
  panelState: n,
  onResize: o,
  onResizeStart: s,
  setPanelState: l,
  panelIndex: u,
  maxWidth: p
}) => /* @__PURE__ */ I(
  Rk,
  {
    enable: nue[t],
    handleClasses: rue[t],
    size: {
      width: n.width,
      height: "100%"
    },
    minWidth: n.minWidth,
    maxWidth: p,
    style: { marginRight: `${Ck}px` },
    onResize: (h, m, b, x) => o({
      type: "panel",
      id: n.id,
      delta: x.width
    }),
    onResizeStart: () => s({
      type: "panel",
      id: n.id
    }),
    onResizeStop: (h, m, b, x) => {
      l(u, void 0, n.width + x.width);
    },
    children: e
  }
), aue = ({
  panels: e,
  panelsState: t,
  setPanelState: n,
  maxWidth: o,
  setSubPanelState: s,
  anchor: l,
  onResizeStart: u,
  onResize: p,
  onScroll: h,
  onCollapseClick: m,
  tabsPanelWidth: b
}) => {
  const { panelsDirectionClass: x, panelDirectionClass: S } = vT[l], R = (E, P) => {
    const k = m({ type: "panel", id: P });
    (typeof k > "u" || k) && n(E, !1);
  }, T = u4(o, b, t);
  return /* @__PURE__ */ I("div", { className: `jv-mPanels mui ${x}`, children: e.map((E, P) => {
    const k = P0(P, t), _ = t[P];
    return k && /* @__PURE__ */ I(
      oue,
      {
        onResize: p,
        onResizeStart: u,
        panelIndex: P,
        panelState: _,
        anchor: l,
        setPanelState: n,
        maxWidth: T[P].maxWidth,
        children: /* @__PURE__ */ I(
          vle,
          {
            className: `${S}`,
            anchor: l,
            id: _.id,
            onCollapse: () => R(P, _.id),
            children: /* @__PURE__ */ I(
              ble,
              {
                panel: e[P],
                panelState: _,
                setSubPanelState: s,
                panelIndex: P,
                onResize: p,
                onResizeStart: u,
                onScroll: h,
                onCollapseClick: m
              }
            )
          }
        )
      },
      _.id
    );
  }) });
}, iue = (e) => {
  const t = e.reduce(
    (n, o, s) => {
      const { panelsHash: l, allTabsOpen: u } = n, p = P0(s, e), h = wk(s, e);
      return {
        panelsHash: `${l}${l ? "-" : ""}${o.id}:${p ? "1" : "0"}`,
        allTabsOpen: h ? u : !1
      };
    },
    { panelsHash: "", allTabsOpen: !0 }
  );
  return `tabs:${t.allTabsOpen ? "1" : "0"}-${t.panelsHash}`;
}, d4 = (e, t) => {
  const n = ud(
    () => iue(t),
    [t]
  );
  Gf(() => {
    e(u5(t));
  }, [e, n]);
}, sue = (e) => e.map((t) => ({
  id: t.id,
  subPanels: t.subPanels.map((n) => ({
    id: n.id,
    open: n.open
  }))
})), lue = (e) => e.reduce((t, n) => n.subPanels.reduce((o, s) => `${o}${s.open}`, t), ""), f4 = (e, t) => {
  const n = ud(
    () => lue(t),
    [t]
  );
  Gf(() => {
    e(sue(t));
  }, [e, n]);
}, cue = (e) => e.reduce((t, n) => {
  const o = `${t}${t.length ? "-" : ""}${n.width}:`;
  return n.subPanels.reduce((s, l) => `${s}${l.height}`, o);
}, ""), p4 = (e, t) => {
  const n = ud(
    () => cue(t),
    [t]
  );
  Gf(() => {
    e(u5(t));
  }, [e, n]);
}, uue = (e) => e.reduce((t, n) => n.subPanels.reduce((o, s) => s.open ? o : !0, t), !1), IF = (e) => e ? e.offsetWidth : 0, h4 = (e, t) => {
  const n = ud(
    () => uue(t),
    [t]
  ), [o, s] = Kf(
    IF(e.current)
  );
  return Gf(() => {
    s(IF(e.current));
  }, [n, e]), o;
}, Lf = () => {
}, due = () => window.innerWidth, oAe = ft(
  ({
    panels: e,
    anchor: t = "right",
    maxWidth: n = due,
    onScroll: o = Lf,
    onResize: s = Lf,
    onResizeStart: l = Lf,
    onResizeStop: u = Lf,
    onExpansionStateChanged: p = Lf,
    onExpandClick: h = Lf,
    onCollapseClick: m = Lf,
    wrapperProps: b
  }, x) => {
    const [S, R, T] = d5(e);
    d4(u, S), f4(p, S), p4(u, S);
    const E = l0(null), P = h4(E, S), k = /* @__PURE__ */ I(
      aue,
      {
        anchor: t,
        panels: e,
        panelsState: S,
        maxWidth: n,
        setPanelState: R,
        setSubPanelState: T,
        onResizeStart: l,
        onResize: s,
        onScroll: o,
        onCollapseClick: m,
        tabsPanelWidth: P
      }
    );
    return /* @__PURE__ */ qe("div", { ref: x, ...b, children: [
      t === "right" && k,
      /* @__PURE__ */ I(
        Zse,
        {
          ref: E,
          panels: e,
          anchor: t,
          setPanelState: R,
          setSubPanelState: T,
          panelsState: S,
          onExpandClick: h
        }
      ),
      t === "left" && k
    ] });
  }
), Uk = ft(
  ({
    size: e = "large",
    width: t = "normal",
    labelContained: n = !1,
    InputLabelProps: o = {},
    InputProps: s = {},
    FormHelperTextProps: l = {},
    FormErrorTextProps: u = {},
    SelectProps: p = {},
    className: h = "",
    textFieldClassName: m = "",
    select: b,
    inline: x,
    id: S,
    error: R,
    errorId: T,
    helperText: E,
    TextFieldPrefix: P,
    TextFieldSuffix: k,
    WrapperProps: _,
    ...L
  }, F) => {
    const N = x ? s5 : "", V = n ? zse : "", z = b ? "jv-mInputSelect" : "", { classes: H = {}, ...ee } = o, { classes: K = {}, ...X } = s, { classes: ne = {}, ...Y } = p, { classes: J = {}, ...te } = l, { className: Z = "", ...ae } = u, U = !!R, G = U && typeof R == "string", W = T ?? (U && S ? `${S}-error-text` : void 0), le = E && S ? `${S}-helper-text` : void 0, pe = {
      classes: {
        root: `jv-mInput-label mui ${(H == null ? void 0 : H.root) ?? ""}`,
        ...H
      },
      disableAnimation: !0,
      ...ee
    }, ge = [le, W].reduce(
      (ve, me) => {
        const Oe = ve ? `${ve} ` : "";
        return me ? `${Oe}${me}` : ve;
      },
      ""
    ), we = b ? {} : {
      classes: {
        input: `jv-mInput-text mui ${(K == null ? void 0 : K.input) ?? ""}`,
        ...K
      },
      ...ge ? { "aria-describedby": ge } : {},
      "aria-invalid": U,
      ...X
    }, de = {
      classes: {
        select: `jv-mInput-select mui ${(ne == null ? void 0 : ne.select) ?? ""}`,
        ...ne
      },
      ...ge ? { "aria-describedby": ge } : {},
      ...Y
    }, se = {
      classes: {
        root: `jv-mInput-helper mui ${(J == null ? void 0 : J.root) ?? ""}`,
        ...J
      },
      ...te
    };
    return /* @__PURE__ */ qe("div", { ref: F, className: h, ..._, children: [
      P,
      /* @__PURE__ */ I(
        O0,
        {
          id: S,
          select: b,
          error: U,
          helperText: E,
          variant: "outlined",
          className: `jv-mInput jv-mInputText mui ${z} ${Rv[e]} ${N} ${l5[t]} ${V} ${m}`,
          InputLabelProps: pe,
          InputProps: we,
          SelectProps: de,
          FormHelperTextProps: se,
          ...L
        }
      ),
      k,
      G && /* @__PURE__ */ I(
        ql,
        {
          className: `jv-mInput-error mui ${Z}`,
          id: W,
          ...ae,
          children: R
        }
      )
    ] });
  }
), p$ = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/, fue = 127.5, _F = {
  rgba2NoAlphaHex(e) {
    const t = e.match(p$) || [];
    return [t[1], t[2], t[3]].reduce((o, s) => {
      const l = `0${parseInt(s, 10).toString(16)}`.slice(-2);
      return o + l;
    }, "#").toUpperCase();
  },
  isRgbTransparent: (e) => e.replace(/\s/g, "").indexOf("0,0,0,0") !== -1,
  isRgba: (e) => p$.test(e),
  isColorDark: (e) => {
    let t, n, o, s;
    return /^rgb/.test(e) ? (t = e.match(p$) || [], n = parseInt(t[1], 10), o = parseInt(t[2], 10), s = parseInt(t[3], 10)) : (t = e.substr(1), n = parseInt(`${t[0]}${t[1]}`, 16), o = parseInt(`${t[2]}${t[3]}`, 16), s = parseInt(`${t[4]}${t[5]}`, 16)), Math.sqrt(0.299 * (n * n) + 0.587 * (o * o) + 0.114 * (s * s)) < fue;
  }
};
var is = {}, I0 = {}, pue = typeof Ll == "object" && Ll && Ll.Object === Object && Ll, m4 = pue, hue = m4, mue = typeof self == "object" && self && self.Object === Object && self, vue = hue || mue || Function("return this")(), Yl = vue, gue = Yl, yue = gue.Symbol, _0 = yue, AF = _0, v4 = Object.prototype, bue = v4.hasOwnProperty, xue = v4.toString, sb = AF ? AF.toStringTag : void 0;
function Sue(e) {
  var t = bue.call(e, sb), n = e[sb];
  try {
    e[sb] = void 0;
    var o = !0;
  } catch {
  }
  var s = xue.call(e);
  return o && (t ? e[sb] = n : delete e[sb]), s;
}
var Cue = Sue, wue = Object.prototype, Tue = wue.toString;
function Eue(e) {
  return Tue.call(e);
}
var Rue = Eue, LF = _0, Oue = Cue, Pue = Rue, $ue = "[object Null]", Due = "[object Undefined]", FF = LF ? LF.toStringTag : void 0;
function kue(e) {
  return e == null ? e === void 0 ? Due : $ue : FF && FF in Object(e) ? Oue(e) : Pue(e);
}
var fp = kue, Mue = Array.isArray, nl = Mue;
function Nue(e) {
  return e != null && typeof e == "object";
}
var Yc = Nue, Iue = fp, _ue = nl, Aue = Yc, Lue = "[object String]";
function Fue(e) {
  return typeof e == "string" || !_ue(e) && Aue(e) && Iue(e) == Lue;
}
var jue = Fue;
function Vue(e) {
  return function(t, n, o) {
    for (var s = -1, l = Object(t), u = o(t), p = u.length; p--; ) {
      var h = u[e ? p : ++s];
      if (n(l[h], h, l) === !1)
        break;
    }
    return t;
  };
}
var Bue = Vue, zue = Bue, Uue = zue(), Hue = Uue;
function Wue(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var que = Wue, Yue = fp, Gue = Yc, Kue = "[object Arguments]";
function Xue(e) {
  return Gue(e) && Yue(e) == Kue;
}
var Que = Xue, jF = Que, Jue = Yc, g4 = Object.prototype, Zue = g4.hasOwnProperty, ede = g4.propertyIsEnumerable, tde = jF(/* @__PURE__ */ function() {
  return arguments;
}()) ? jF : function(e) {
  return Jue(e) && Zue.call(e, "callee") && !ede.call(e, "callee");
}, y4 = tde, aw = { exports: {} };
function nde() {
  return !1;
}
var rde = nde;
aw.exports;
(function(e, t) {
  var n = Yl, o = rde, s = t && !t.nodeType && t, l = s && !0 && e && !e.nodeType && e, u = l && l.exports === s, p = u ? n.Buffer : void 0, h = p ? p.isBuffer : void 0, m = h || o;
  e.exports = m;
})(aw, aw.exports);
var Hk = aw.exports, ode = 9007199254740991, ade = /^(?:0|[1-9]\d*)$/;
function ide(e, t) {
  var n = typeof e;
  return t = t ?? ode, !!t && (n == "number" || n != "symbol" && ade.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var b4 = ide, sde = 9007199254740991;
function lde(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= sde;
}
var Wk = lde, cde = fp, ude = Wk, dde = Yc, fde = "[object Arguments]", pde = "[object Array]", hde = "[object Boolean]", mde = "[object Date]", vde = "[object Error]", gde = "[object Function]", yde = "[object Map]", bde = "[object Number]", xde = "[object Object]", Sde = "[object RegExp]", Cde = "[object Set]", wde = "[object String]", Tde = "[object WeakMap]", Ede = "[object ArrayBuffer]", Rde = "[object DataView]", Ode = "[object Float32Array]", Pde = "[object Float64Array]", $de = "[object Int8Array]", Dde = "[object Int16Array]", kde = "[object Int32Array]", Mde = "[object Uint8Array]", Nde = "[object Uint8ClampedArray]", Ide = "[object Uint16Array]", _de = "[object Uint32Array]", fr = {};
fr[Ode] = fr[Pde] = fr[$de] = fr[Dde] = fr[kde] = fr[Mde] = fr[Nde] = fr[Ide] = fr[_de] = !0;
fr[fde] = fr[pde] = fr[Ede] = fr[hde] = fr[Rde] = fr[mde] = fr[vde] = fr[gde] = fr[yde] = fr[bde] = fr[xde] = fr[Sde] = fr[Cde] = fr[wde] = fr[Tde] = !1;
function Ade(e) {
  return dde(e) && ude(e.length) && !!fr[cde(e)];
}
var Lde = Ade;
function Fde(e) {
  return function(t) {
    return e(t);
  };
}
var qk = Fde, iw = { exports: {} };
iw.exports;
(function(e, t) {
  var n = m4, o = t && !t.nodeType && t, s = o && !0 && e && !e.nodeType && e, l = s && s.exports === o, u = l && n.process, p = function() {
    try {
      var h = s && s.require && s.require("util").types;
      return h || u && u.binding && u.binding("util");
    } catch {
    }
  }();
  e.exports = p;
})(iw, iw.exports);
var Yk = iw.exports, jde = Lde, Vde = qk, VF = Yk, BF = VF && VF.isTypedArray, Bde = BF ? Vde(BF) : jde, x4 = Bde, zde = que, Ude = y4, Hde = nl, Wde = Hk, qde = b4, Yde = x4, Gde = Object.prototype, Kde = Gde.hasOwnProperty;
function Xde(e, t) {
  var n = Hde(e), o = !n && Ude(e), s = !n && !o && Wde(e), l = !n && !o && !s && Yde(e), u = n || o || s || l, p = u ? zde(e.length, String) : [], h = p.length;
  for (var m in e)
    (t || Kde.call(e, m)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
    qde(m, h))) && p.push(m);
  return p;
}
var S4 = Xde, Qde = Object.prototype;
function Jde(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Qde;
  return e === n;
}
var Gk = Jde;
function Zde(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var C4 = Zde, efe = C4, tfe = efe(Object.keys, Object), nfe = tfe, rfe = Gk, ofe = nfe, afe = Object.prototype, ife = afe.hasOwnProperty;
function sfe(e) {
  if (!rfe(e))
    return ofe(e);
  var t = [];
  for (var n in Object(e))
    ife.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var lfe = sfe;
function cfe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Pv = cfe, ufe = fp, dfe = Pv, ffe = "[object AsyncFunction]", pfe = "[object Function]", hfe = "[object GeneratorFunction]", mfe = "[object Proxy]";
function vfe(e) {
  if (!dfe(e))
    return !1;
  var t = ufe(e);
  return t == pfe || t == hfe || t == ffe || t == mfe;
}
var w4 = vfe, gfe = w4, yfe = Wk;
function bfe(e) {
  return e != null && yfe(e.length) && !gfe(e);
}
var xT = bfe, xfe = S4, Sfe = lfe, Cfe = xT;
function wfe(e) {
  return Cfe(e) ? xfe(e) : Sfe(e);
}
var A0 = wfe, Tfe = Hue, Efe = A0;
function Rfe(e, t) {
  return e && Tfe(e, t, Efe);
}
var T4 = Rfe;
function Ofe(e) {
  return e;
}
var E4 = Ofe, Pfe = E4;
function $fe(e) {
  return typeof e == "function" ? e : Pfe;
}
var Dfe = $fe, kfe = T4, Mfe = Dfe;
function Nfe(e, t) {
  return e && kfe(e, Mfe(t));
}
var Kk = Nfe, Ife = C4, _fe = Ife(Object.getPrototypeOf, Object), Xk = _fe, Afe = fp, Lfe = Xk, Ffe = Yc, jfe = "[object Object]", Vfe = Function.prototype, Bfe = Object.prototype, R4 = Vfe.toString, zfe = Bfe.hasOwnProperty, Ufe = R4.call(Object);
function Hfe(e) {
  if (!Ffe(e) || Afe(e) != jfe)
    return !1;
  var t = Lfe(e);
  if (t === null)
    return !0;
  var n = zfe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && R4.call(n) == Ufe;
}
var Wfe = Hfe;
function qfe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, s = Array(o); ++n < o; )
    s[n] = t(e[n], n, e);
  return s;
}
var O4 = qfe;
function Yfe() {
  this.__data__ = [], this.size = 0;
}
var Gfe = Yfe;
function Kfe(e, t) {
  return e === t || e !== e && t !== t;
}
var Qk = Kfe, Xfe = Qk;
function Qfe(e, t) {
  for (var n = e.length; n--; )
    if (Xfe(e[n][0], t))
      return n;
  return -1;
}
var ST = Qfe, Jfe = ST, Zfe = Array.prototype, epe = Zfe.splice;
function tpe(e) {
  var t = this.__data__, n = Jfe(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : epe.call(t, n, 1), --this.size, !0;
}
var npe = tpe, rpe = ST;
function ope(e) {
  var t = this.__data__, n = rpe(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var ape = ope, ipe = ST;
function spe(e) {
  return ipe(this.__data__, e) > -1;
}
var lpe = spe, cpe = ST;
function upe(e, t) {
  var n = this.__data__, o = cpe(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var dpe = upe, fpe = Gfe, ppe = npe, hpe = ape, mpe = lpe, vpe = dpe;
function $v(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
$v.prototype.clear = fpe;
$v.prototype.delete = ppe;
$v.prototype.get = hpe;
$v.prototype.has = mpe;
$v.prototype.set = vpe;
var CT = $v, gpe = CT;
function ype() {
  this.__data__ = new gpe(), this.size = 0;
}
var bpe = ype;
function xpe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var Spe = xpe;
function Cpe(e) {
  return this.__data__.get(e);
}
var wpe = Cpe;
function Tpe(e) {
  return this.__data__.has(e);
}
var Epe = Tpe, Rpe = Yl, Ope = Rpe["__core-js_shared__"], Ppe = Ope, h$ = Ppe, zF = function() {
  var e = /[^.]+$/.exec(h$ && h$.keys && h$.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $pe(e) {
  return !!zF && zF in e;
}
var Dpe = $pe, kpe = Function.prototype, Mpe = kpe.toString;
function Npe(e) {
  if (e != null) {
    try {
      return Mpe.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var P4 = Npe, Ipe = w4, _pe = Dpe, Ape = Pv, Lpe = P4, Fpe = /[\\^$.*+?()[\]{}|]/g, jpe = /^\[object .+?Constructor\]$/, Vpe = Function.prototype, Bpe = Object.prototype, zpe = Vpe.toString, Upe = Bpe.hasOwnProperty, Hpe = RegExp(
  "^" + zpe.call(Upe).replace(Fpe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Wpe(e) {
  if (!Ape(e) || _pe(e))
    return !1;
  var t = Ipe(e) ? Hpe : jpe;
  return t.test(Lpe(e));
}
var qpe = Wpe;
function Ype(e, t) {
  return e == null ? void 0 : e[t];
}
var Gpe = Ype, Kpe = qpe, Xpe = Gpe;
function Qpe(e, t) {
  var n = Xpe(e, t);
  return Kpe(n) ? n : void 0;
}
var pp = Qpe, Jpe = pp, Zpe = Yl, ehe = Jpe(Zpe, "Map"), Jk = ehe, the = pp, nhe = the(Object, "create"), wT = nhe, UF = wT;
function rhe() {
  this.__data__ = UF ? UF(null) : {}, this.size = 0;
}
var ohe = rhe;
function ahe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ihe = ahe, she = wT, lhe = "__lodash_hash_undefined__", che = Object.prototype, uhe = che.hasOwnProperty;
function dhe(e) {
  var t = this.__data__;
  if (she) {
    var n = t[e];
    return n === lhe ? void 0 : n;
  }
  return uhe.call(t, e) ? t[e] : void 0;
}
var fhe = dhe, phe = wT, hhe = Object.prototype, mhe = hhe.hasOwnProperty;
function vhe(e) {
  var t = this.__data__;
  return phe ? t[e] !== void 0 : mhe.call(t, e);
}
var ghe = vhe, yhe = wT, bhe = "__lodash_hash_undefined__";
function xhe(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = yhe && t === void 0 ? bhe : t, this;
}
var She = xhe, Che = ohe, whe = ihe, The = fhe, Ehe = ghe, Rhe = She;
function Dv(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Dv.prototype.clear = Che;
Dv.prototype.delete = whe;
Dv.prototype.get = The;
Dv.prototype.has = Ehe;
Dv.prototype.set = Rhe;
var Ohe = Dv, HF = Ohe, Phe = CT, $he = Jk;
function Dhe() {
  this.size = 0, this.__data__ = {
    hash: new HF(),
    map: new ($he || Phe)(),
    string: new HF()
  };
}
var khe = Dhe;
function Mhe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Nhe = Mhe, Ihe = Nhe;
function _he(e, t) {
  var n = e.__data__;
  return Ihe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var TT = _he, Ahe = TT;
function Lhe(e) {
  var t = Ahe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Fhe = Lhe, jhe = TT;
function Vhe(e) {
  return jhe(this, e).get(e);
}
var Bhe = Vhe, zhe = TT;
function Uhe(e) {
  return zhe(this, e).has(e);
}
var Hhe = Uhe, Whe = TT;
function qhe(e, t) {
  var n = Whe(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var Yhe = qhe, Ghe = khe, Khe = Fhe, Xhe = Bhe, Qhe = Hhe, Jhe = Yhe;
function kv(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
kv.prototype.clear = Ghe;
kv.prototype.delete = Khe;
kv.prototype.get = Xhe;
kv.prototype.has = Qhe;
kv.prototype.set = Jhe;
var Zk = kv, Zhe = CT, eme = Jk, tme = Zk, nme = 200;
function rme(e, t) {
  var n = this.__data__;
  if (n instanceof Zhe) {
    var o = n.__data__;
    if (!eme || o.length < nme - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new tme(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var ome = rme, ame = CT, ime = bpe, sme = Spe, lme = wpe, cme = Epe, ume = ome;
function Mv(e) {
  var t = this.__data__ = new ame(e);
  this.size = t.size;
}
Mv.prototype.clear = ime;
Mv.prototype.delete = sme;
Mv.prototype.get = lme;
Mv.prototype.has = cme;
Mv.prototype.set = ume;
var eM = Mv, dme = "__lodash_hash_undefined__";
function fme(e) {
  return this.__data__.set(e, dme), this;
}
var pme = fme;
function hme(e) {
  return this.__data__.has(e);
}
var mme = hme, vme = Zk, gme = pme, yme = mme;
function sw(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new vme(); ++t < n; )
    this.add(e[t]);
}
sw.prototype.add = sw.prototype.push = gme;
sw.prototype.has = yme;
var bme = sw;
function xme(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var Sme = xme;
function Cme(e, t) {
  return e.has(t);
}
var wme = Cme, Tme = bme, Eme = Sme, Rme = wme, Ome = 1, Pme = 2;
function $me(e, t, n, o, s, l) {
  var u = n & Ome, p = e.length, h = t.length;
  if (p != h && !(u && h > p))
    return !1;
  var m = l.get(e), b = l.get(t);
  if (m && b)
    return m == t && b == e;
  var x = -1, S = !0, R = n & Pme ? new Tme() : void 0;
  for (l.set(e, t), l.set(t, e); ++x < p; ) {
    var T = e[x], E = t[x];
    if (o)
      var P = u ? o(E, T, x, t, e, l) : o(T, E, x, e, t, l);
    if (P !== void 0) {
      if (P)
        continue;
      S = !1;
      break;
    }
    if (R) {
      if (!Eme(t, function(k, _) {
        if (!Rme(R, _) && (T === k || s(T, k, n, o, l)))
          return R.push(_);
      })) {
        S = !1;
        break;
      }
    } else if (!(T === E || s(T, E, n, o, l))) {
      S = !1;
      break;
    }
  }
  return l.delete(e), l.delete(t), S;
}
var $4 = $me, Dme = Yl, kme = Dme.Uint8Array, D4 = kme;
function Mme(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o, s) {
    n[++t] = [s, o];
  }), n;
}
var Nme = Mme;
function Ime(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var _me = Ime, WF = _0, qF = D4, Ame = Qk, Lme = $4, Fme = Nme, jme = _me, Vme = 1, Bme = 2, zme = "[object Boolean]", Ume = "[object Date]", Hme = "[object Error]", Wme = "[object Map]", qme = "[object Number]", Yme = "[object RegExp]", Gme = "[object Set]", Kme = "[object String]", Xme = "[object Symbol]", Qme = "[object ArrayBuffer]", Jme = "[object DataView]", YF = WF ? WF.prototype : void 0, m$ = YF ? YF.valueOf : void 0;
function Zme(e, t, n, o, s, l, u) {
  switch (n) {
    case Jme:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Qme:
      return !(e.byteLength != t.byteLength || !l(new qF(e), new qF(t)));
    case zme:
    case Ume:
    case qme:
      return Ame(+e, +t);
    case Hme:
      return e.name == t.name && e.message == t.message;
    case Yme:
    case Kme:
      return e == t + "";
    case Wme:
      var p = Fme;
    case Gme:
      var h = o & Vme;
      if (p || (p = jme), e.size != t.size && !h)
        return !1;
      var m = u.get(e);
      if (m)
        return m == t;
      o |= Bme, u.set(e, t);
      var b = Lme(p(e), p(t), o, s, l, u);
      return u.delete(e), b;
    case Xme:
      if (m$)
        return m$.call(e) == m$.call(t);
  }
  return !1;
}
var eve = Zme;
function tve(e, t) {
  for (var n = -1, o = t.length, s = e.length; ++n < o; )
    e[s + n] = t[n];
  return e;
}
var k4 = tve, nve = k4, rve = nl;
function ove(e, t, n) {
  var o = t(e);
  return rve(e) ? o : nve(o, n(e));
}
var M4 = ove;
function ave(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, s = 0, l = []; ++n < o; ) {
    var u = e[n];
    t(u, n, e) && (l[s++] = u);
  }
  return l;
}
var ive = ave;
function sve() {
  return [];
}
var N4 = sve, lve = ive, cve = N4, uve = Object.prototype, dve = uve.propertyIsEnumerable, GF = Object.getOwnPropertySymbols, fve = GF ? function(e) {
  return e == null ? [] : (e = Object(e), lve(GF(e), function(t) {
    return dve.call(e, t);
  }));
} : cve, tM = fve, pve = M4, hve = tM, mve = A0;
function vve(e) {
  return pve(e, mve, hve);
}
var I4 = vve, KF = I4, gve = 1, yve = Object.prototype, bve = yve.hasOwnProperty;
function xve(e, t, n, o, s, l) {
  var u = n & gve, p = KF(e), h = p.length, m = KF(t), b = m.length;
  if (h != b && !u)
    return !1;
  for (var x = h; x--; ) {
    var S = p[x];
    if (!(u ? S in t : bve.call(t, S)))
      return !1;
  }
  var R = l.get(e), T = l.get(t);
  if (R && T)
    return R == t && T == e;
  var E = !0;
  l.set(e, t), l.set(t, e);
  for (var P = u; ++x < h; ) {
    S = p[x];
    var k = e[S], _ = t[S];
    if (o)
      var L = u ? o(_, k, S, t, e, l) : o(k, _, S, e, t, l);
    if (!(L === void 0 ? k === _ || s(k, _, n, o, l) : L)) {
      E = !1;
      break;
    }
    P || (P = S == "constructor");
  }
  if (E && !P) {
    var F = e.constructor, N = t.constructor;
    F != N && "constructor" in e && "constructor" in t && !(typeof F == "function" && F instanceof F && typeof N == "function" && N instanceof N) && (E = !1);
  }
  return l.delete(e), l.delete(t), E;
}
var Sve = xve, Cve = pp, wve = Yl, Tve = Cve(wve, "DataView"), Eve = Tve, Rve = pp, Ove = Yl, Pve = Rve(Ove, "Promise"), $ve = Pve, Dve = pp, kve = Yl, Mve = Dve(kve, "Set"), Nve = Mve, Ive = pp, _ve = Yl, Ave = Ive(_ve, "WeakMap"), Lve = Ave, nD = Eve, rD = Jk, oD = $ve, aD = Nve, iD = Lve, _4 = fp, Nv = P4, XF = "[object Map]", Fve = "[object Object]", QF = "[object Promise]", JF = "[object Set]", ZF = "[object WeakMap]", ej = "[object DataView]", jve = Nv(nD), Vve = Nv(rD), Bve = Nv(oD), zve = Nv(aD), Uve = Nv(iD), Uf = _4;
(nD && Uf(new nD(new ArrayBuffer(1))) != ej || rD && Uf(new rD()) != XF || oD && Uf(oD.resolve()) != QF || aD && Uf(new aD()) != JF || iD && Uf(new iD()) != ZF) && (Uf = function(e) {
  var t = _4(e), n = t == Fve ? e.constructor : void 0, o = n ? Nv(n) : "";
  if (o)
    switch (o) {
      case jve:
        return ej;
      case Vve:
        return XF;
      case Bve:
        return QF;
      case zve:
        return JF;
      case Uve:
        return ZF;
    }
  return t;
});
var ET = Uf, v$ = eM, Hve = $4, Wve = eve, qve = Sve, tj = ET, nj = nl, rj = Hk, Yve = x4, Gve = 1, oj = "[object Arguments]", aj = "[object Array]", m1 = "[object Object]", Kve = Object.prototype, ij = Kve.hasOwnProperty;
function Xve(e, t, n, o, s, l) {
  var u = nj(e), p = nj(t), h = u ? aj : tj(e), m = p ? aj : tj(t);
  h = h == oj ? m1 : h, m = m == oj ? m1 : m;
  var b = h == m1, x = m == m1, S = h == m;
  if (S && rj(e)) {
    if (!rj(t))
      return !1;
    u = !0, b = !1;
  }
  if (S && !b)
    return l || (l = new v$()), u || Yve(e) ? Hve(e, t, n, o, s, l) : Wve(e, t, h, n, o, s, l);
  if (!(n & Gve)) {
    var R = b && ij.call(e, "__wrapped__"), T = x && ij.call(t, "__wrapped__");
    if (R || T) {
      var E = R ? e.value() : e, P = T ? t.value() : t;
      return l || (l = new v$()), s(E, P, n, o, l);
    }
  }
  return S ? (l || (l = new v$()), qve(e, t, n, o, s, l)) : !1;
}
var Qve = Xve, Jve = Qve, sj = Yc;
function A4(e, t, n, o, s) {
  return e === t ? !0 : e == null || t == null || !sj(e) && !sj(t) ? e !== e && t !== t : Jve(e, t, n, o, A4, s);
}
var L4 = A4, Zve = eM, ege = L4, tge = 1, nge = 2;
function rge(e, t, n, o) {
  var s = n.length, l = s, u = !o;
  if (e == null)
    return !l;
  for (e = Object(e); s--; ) {
    var p = n[s];
    if (u && p[2] ? p[1] !== e[p[0]] : !(p[0] in e))
      return !1;
  }
  for (; ++s < l; ) {
    p = n[s];
    var h = p[0], m = e[h], b = p[1];
    if (u && p[2]) {
      if (m === void 0 && !(h in e))
        return !1;
    } else {
      var x = new Zve();
      if (o)
        var S = o(m, b, h, e, t, x);
      if (!(S === void 0 ? ege(b, m, tge | nge, o, x) : S))
        return !1;
    }
  }
  return !0;
}
var oge = rge, age = Pv;
function ige(e) {
  return e === e && !age(e);
}
var F4 = ige, sge = F4, lge = A0;
function cge(e) {
  for (var t = lge(e), n = t.length; n--; ) {
    var o = t[n], s = e[o];
    t[n] = [o, s, sge(s)];
  }
  return t;
}
var uge = cge;
function dge(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var j4 = dge, fge = oge, pge = uge, hge = j4;
function mge(e) {
  var t = pge(e);
  return t.length == 1 && t[0][2] ? hge(t[0][0], t[0][1]) : function(n) {
    return n === e || fge(n, e, t);
  };
}
var vge = mge, gge = fp, yge = Yc, bge = "[object Symbol]";
function xge(e) {
  return typeof e == "symbol" || yge(e) && gge(e) == bge;
}
var nM = xge, Sge = nl, Cge = nM, wge = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Tge = /^\w*$/;
function Ege(e, t) {
  if (Sge(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Cge(e) ? !0 : Tge.test(e) || !wge.test(e) || t != null && e in Object(t);
}
var rM = Ege, V4 = Zk, Rge = "Expected a function";
function oM(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Rge);
  var n = function() {
    var o = arguments, s = t ? t.apply(this, o) : o[0], l = n.cache;
    if (l.has(s))
      return l.get(s);
    var u = e.apply(this, o);
    return n.cache = l.set(s, u) || l, u;
  };
  return n.cache = new (oM.Cache || V4)(), n;
}
oM.Cache = V4;
var Oge = oM, Pge = Oge, $ge = 500;
function Dge(e) {
  var t = Pge(e, function(o) {
    return n.size === $ge && n.clear(), o;
  }), n = t.cache;
  return t;
}
var kge = Dge, Mge = kge, Nge = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ige = /\\(\\)?/g, _ge = Mge(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Nge, function(n, o, s, l) {
    t.push(s ? l.replace(Ige, "$1") : o || n);
  }), t;
}), Age = _ge, lj = _0, Lge = O4, Fge = nl, jge = nM, Vge = 1 / 0, cj = lj ? lj.prototype : void 0, uj = cj ? cj.toString : void 0;
function B4(e) {
  if (typeof e == "string")
    return e;
  if (Fge(e))
    return Lge(e, B4) + "";
  if (jge(e))
    return uj ? uj.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Vge ? "-0" : t;
}
var Bge = B4, zge = Bge;
function Uge(e) {
  return e == null ? "" : zge(e);
}
var Hge = Uge, Wge = nl, qge = rM, Yge = Age, Gge = Hge;
function Kge(e, t) {
  return Wge(e) ? e : qge(e, t) ? [e] : Yge(Gge(e));
}
var z4 = Kge, Xge = nM, Qge = 1 / 0;
function Jge(e) {
  if (typeof e == "string" || Xge(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Qge ? "-0" : t;
}
var RT = Jge, Zge = z4, eye = RT;
function tye(e, t) {
  t = Zge(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[eye(t[n++])];
  return n && n == o ? e : void 0;
}
var U4 = tye, nye = U4;
function rye(e, t, n) {
  var o = e == null ? void 0 : nye(e, t);
  return o === void 0 ? n : o;
}
var oye = rye;
function aye(e, t) {
  return e != null && t in Object(e);
}
var iye = aye, sye = z4, lye = y4, cye = nl, uye = b4, dye = Wk, fye = RT;
function pye(e, t, n) {
  t = sye(t, e);
  for (var o = -1, s = t.length, l = !1; ++o < s; ) {
    var u = fye(t[o]);
    if (!(l = e != null && n(e, u)))
      break;
    e = e[u];
  }
  return l || ++o != s ? l : (s = e == null ? 0 : e.length, !!s && dye(s) && uye(u, s) && (cye(e) || lye(e)));
}
var hye = pye, mye = iye, vye = hye;
function gye(e, t) {
  return e != null && vye(e, t, mye);
}
var yye = gye, bye = L4, xye = oye, Sye = yye, Cye = rM, wye = F4, Tye = j4, Eye = RT, Rye = 1, Oye = 2;
function Pye(e, t) {
  return Cye(e) && wye(t) ? Tye(Eye(e), t) : function(n) {
    var o = xye(n, e);
    return o === void 0 && o === t ? Sye(n, e) : bye(t, o, Rye | Oye);
  };
}
var $ye = Pye;
function Dye(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var kye = Dye, Mye = U4;
function Nye(e) {
  return function(t) {
    return Mye(t, e);
  };
}
var Iye = Nye, _ye = kye, Aye = Iye, Lye = rM, Fye = RT;
function jye(e) {
  return Lye(e) ? _ye(Fye(e)) : Aye(e);
}
var Vye = jye, Bye = vge, zye = $ye, Uye = E4, Hye = nl, Wye = Vye;
function qye(e) {
  return typeof e == "function" ? e : e == null ? Uye : typeof e == "object" ? Hye(e) ? zye(e[0], e[1]) : Bye(e) : Wye(e);
}
var Yye = qye, Gye = xT;
function Kye(e, t) {
  return function(n, o) {
    if (n == null)
      return n;
    if (!Gye(n))
      return e(n, o);
    for (var s = n.length, l = t ? s : -1, u = Object(n); (t ? l-- : ++l < s) && o(u[l], l, u) !== !1; )
      ;
    return n;
  };
}
var Xye = Kye, Qye = T4, Jye = Xye, Zye = Jye(Qye), ebe = Zye, tbe = ebe, nbe = xT;
function rbe(e, t) {
  var n = -1, o = nbe(e) ? Array(e.length) : [];
  return tbe(e, function(s, l, u) {
    o[++n] = t(s, l, u);
  }), o;
}
var obe = rbe, abe = O4, ibe = Yye, sbe = obe, lbe = nl;
function cbe(e, t) {
  var n = lbe(e) ? abe : sbe;
  return n(e, ibe(t));
}
var ube = cbe;
Object.defineProperty(I0, "__esModule", {
  value: !0
});
I0.flattenNames = void 0;
var dbe = jue, fbe = OT(dbe), pbe = Kk, hbe = OT(pbe), mbe = Wfe, vbe = OT(mbe), gbe = ube, ybe = OT(gbe);
function OT(e) {
  return e && e.__esModule ? e : { default: e };
}
var bbe = I0.flattenNames = function e() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [];
  return (0, ybe.default)(t, function(o) {
    Array.isArray(o) ? e(o).map(function(s) {
      return n.push(s);
    }) : (0, vbe.default)(o) ? (0, hbe.default)(o, function(s, l) {
      s === !0 && n.push(l), n.push(l + "-" + s);
    }) : (0, fbe.default)(o) && n.push(o);
  }), n;
};
I0.default = bbe;
var L0 = {};
function xbe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Sbe = xbe, Cbe = pp, wbe = function() {
  try {
    var e = Cbe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Tbe = wbe, dj = Tbe;
function Ebe(e, t, n) {
  t == "__proto__" && dj ? dj(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var H4 = Ebe, Rbe = H4, Obe = Qk, Pbe = Object.prototype, $be = Pbe.hasOwnProperty;
function Dbe(e, t, n) {
  var o = e[t];
  (!($be.call(e, t) && Obe(o, n)) || n === void 0 && !(t in e)) && Rbe(e, t, n);
}
var W4 = Dbe, kbe = W4, Mbe = H4;
function Nbe(e, t, n, o) {
  var s = !n;
  n || (n = {});
  for (var l = -1, u = t.length; ++l < u; ) {
    var p = t[l], h = o ? o(n[p], e[p], p, n, e) : void 0;
    h === void 0 && (h = e[p]), s ? Mbe(n, p, h) : kbe(n, p, h);
  }
  return n;
}
var PT = Nbe, Ibe = PT, _be = A0;
function Abe(e, t) {
  return e && Ibe(t, _be(t), e);
}
var Lbe = Abe;
function Fbe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var jbe = Fbe, Vbe = Pv, Bbe = Gk, zbe = jbe, Ube = Object.prototype, Hbe = Ube.hasOwnProperty;
function Wbe(e) {
  if (!Vbe(e))
    return zbe(e);
  var t = Bbe(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !Hbe.call(e, o)) || n.push(o);
  return n;
}
var qbe = Wbe, Ybe = S4, Gbe = qbe, Kbe = xT;
function Xbe(e) {
  return Kbe(e) ? Ybe(e, !0) : Gbe(e);
}
var aM = Xbe, Qbe = PT, Jbe = aM;
function Zbe(e, t) {
  return e && Qbe(t, Jbe(t), e);
}
var e0e = Zbe, lw = { exports: {} };
lw.exports;
(function(e, t) {
  var n = Yl, o = t && !t.nodeType && t, s = o && !0 && e && !e.nodeType && e, l = s && s.exports === o, u = l ? n.Buffer : void 0, p = u ? u.allocUnsafe : void 0;
  function h(m, b) {
    if (b)
      return m.slice();
    var x = m.length, S = p ? p(x) : new m.constructor(x);
    return m.copy(S), S;
  }
  e.exports = h;
})(lw, lw.exports);
var t0e = lw.exports;
function n0e(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var r0e = n0e, o0e = PT, a0e = tM;
function i0e(e, t) {
  return o0e(e, a0e(e), t);
}
var s0e = i0e, l0e = k4, c0e = Xk, u0e = tM, d0e = N4, f0e = Object.getOwnPropertySymbols, p0e = f0e ? function(e) {
  for (var t = []; e; )
    l0e(t, u0e(e)), e = c0e(e);
  return t;
} : d0e, q4 = p0e, h0e = PT, m0e = q4;
function v0e(e, t) {
  return h0e(e, m0e(e), t);
}
var g0e = v0e, y0e = M4, b0e = q4, x0e = aM;
function S0e(e) {
  return y0e(e, x0e, b0e);
}
var C0e = S0e, w0e = Object.prototype, T0e = w0e.hasOwnProperty;
function E0e(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && T0e.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var R0e = E0e, fj = D4;
function O0e(e) {
  var t = new e.constructor(e.byteLength);
  return new fj(t).set(new fj(e)), t;
}
var iM = O0e, P0e = iM;
function $0e(e, t) {
  var n = t ? P0e(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var D0e = $0e, k0e = /\w*$/;
function M0e(e) {
  var t = new e.constructor(e.source, k0e.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var N0e = M0e, pj = _0, hj = pj ? pj.prototype : void 0, mj = hj ? hj.valueOf : void 0;
function I0e(e) {
  return mj ? Object(mj.call(e)) : {};
}
var _0e = I0e, A0e = iM;
function L0e(e, t) {
  var n = t ? A0e(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var F0e = L0e, j0e = iM, V0e = D0e, B0e = N0e, z0e = _0e, U0e = F0e, H0e = "[object Boolean]", W0e = "[object Date]", q0e = "[object Map]", Y0e = "[object Number]", G0e = "[object RegExp]", K0e = "[object Set]", X0e = "[object String]", Q0e = "[object Symbol]", J0e = "[object ArrayBuffer]", Z0e = "[object DataView]", exe = "[object Float32Array]", txe = "[object Float64Array]", nxe = "[object Int8Array]", rxe = "[object Int16Array]", oxe = "[object Int32Array]", axe = "[object Uint8Array]", ixe = "[object Uint8ClampedArray]", sxe = "[object Uint16Array]", lxe = "[object Uint32Array]";
function cxe(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case J0e:
      return j0e(e);
    case H0e:
    case W0e:
      return new o(+e);
    case Z0e:
      return V0e(e, n);
    case exe:
    case txe:
    case nxe:
    case rxe:
    case oxe:
    case axe:
    case ixe:
    case sxe:
    case lxe:
      return U0e(e, n);
    case q0e:
      return new o();
    case Y0e:
    case X0e:
      return new o(e);
    case G0e:
      return B0e(e);
    case K0e:
      return new o();
    case Q0e:
      return z0e(e);
  }
}
var uxe = cxe, dxe = Pv, vj = Object.create, fxe = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!dxe(t))
      return {};
    if (vj)
      return vj(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), pxe = fxe, hxe = pxe, mxe = Xk, vxe = Gk;
function gxe(e) {
  return typeof e.constructor == "function" && !vxe(e) ? hxe(mxe(e)) : {};
}
var yxe = gxe, bxe = ET, xxe = Yc, Sxe = "[object Map]";
function Cxe(e) {
  return xxe(e) && bxe(e) == Sxe;
}
var wxe = Cxe, Txe = wxe, Exe = qk, gj = Yk, yj = gj && gj.isMap, Rxe = yj ? Exe(yj) : Txe, Oxe = Rxe, Pxe = ET, $xe = Yc, Dxe = "[object Set]";
function kxe(e) {
  return $xe(e) && Pxe(e) == Dxe;
}
var Mxe = kxe, Nxe = Mxe, Ixe = qk, bj = Yk, xj = bj && bj.isSet, _xe = xj ? Ixe(xj) : Nxe, Axe = _xe, Lxe = eM, Fxe = Sbe, jxe = W4, Vxe = Lbe, Bxe = e0e, zxe = t0e, Uxe = r0e, Hxe = s0e, Wxe = g0e, qxe = I4, Yxe = C0e, Gxe = ET, Kxe = R0e, Xxe = uxe, Qxe = yxe, Jxe = nl, Zxe = Hk, eSe = Oxe, tSe = Pv, nSe = Axe, rSe = A0, oSe = aM, aSe = 1, iSe = 2, sSe = 4, Y4 = "[object Arguments]", lSe = "[object Array]", cSe = "[object Boolean]", uSe = "[object Date]", dSe = "[object Error]", G4 = "[object Function]", fSe = "[object GeneratorFunction]", pSe = "[object Map]", hSe = "[object Number]", K4 = "[object Object]", mSe = "[object RegExp]", vSe = "[object Set]", gSe = "[object String]", ySe = "[object Symbol]", bSe = "[object WeakMap]", xSe = "[object ArrayBuffer]", SSe = "[object DataView]", CSe = "[object Float32Array]", wSe = "[object Float64Array]", TSe = "[object Int8Array]", ESe = "[object Int16Array]", RSe = "[object Int32Array]", OSe = "[object Uint8Array]", PSe = "[object Uint8ClampedArray]", $Se = "[object Uint16Array]", DSe = "[object Uint32Array]", sr = {};
sr[Y4] = sr[lSe] = sr[xSe] = sr[SSe] = sr[cSe] = sr[uSe] = sr[CSe] = sr[wSe] = sr[TSe] = sr[ESe] = sr[RSe] = sr[pSe] = sr[hSe] = sr[K4] = sr[mSe] = sr[vSe] = sr[gSe] = sr[ySe] = sr[OSe] = sr[PSe] = sr[$Se] = sr[DSe] = !0;
sr[dSe] = sr[G4] = sr[bSe] = !1;
function M1(e, t, n, o, s, l) {
  var u, p = t & aSe, h = t & iSe, m = t & sSe;
  if (n && (u = s ? n(e, o, s, l) : n(e)), u !== void 0)
    return u;
  if (!tSe(e))
    return e;
  var b = Jxe(e);
  if (b) {
    if (u = Kxe(e), !p)
      return Uxe(e, u);
  } else {
    var x = Gxe(e), S = x == G4 || x == fSe;
    if (Zxe(e))
      return zxe(e, p);
    if (x == K4 || x == Y4 || S && !s) {
      if (u = h || S ? {} : Qxe(e), !p)
        return h ? Wxe(e, Bxe(u, e)) : Hxe(e, Vxe(u, e));
    } else {
      if (!sr[x])
        return s ? e : {};
      u = Xxe(e, x, p);
    }
  }
  l || (l = new Lxe());
  var R = l.get(e);
  if (R)
    return R;
  l.set(e, u), nSe(e) ? e.forEach(function(P) {
    u.add(M1(P, t, n, P, e, l));
  }) : eSe(e) && e.forEach(function(P, k) {
    u.set(k, M1(P, t, n, k, e, l));
  });
  var T = m ? h ? Yxe : qxe : h ? oSe : rSe, E = b ? void 0 : T(e);
  return Fxe(E || e, function(P, k) {
    E && (k = P, P = e[k]), jxe(u, k, M1(P, t, n, k, e, l));
  }), u;
}
var kSe = M1, MSe = kSe, NSe = 1, ISe = 4;
function _Se(e) {
  return MSe(e, NSe | ISe);
}
var ASe = _Se;
Object.defineProperty(L0, "__esModule", {
  value: !0
});
L0.mergeClasses = void 0;
var LSe = Kk, FSe = X4(LSe), jSe = ASe, VSe = X4(jSe), BSe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
};
function X4(e) {
  return e && e.__esModule ? e : { default: e };
}
var zSe = L0.mergeClasses = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], o = t.default && (0, VSe.default)(t.default) || {};
  return n.map(function(s) {
    var l = t[s];
    return l && (0, FSe.default)(l, function(u, p) {
      o[p] || (o[p] = {}), o[p] = BSe({}, o[p], l[p]);
    }), s;
  }), o;
};
L0.default = zSe;
var F0 = {};
Object.defineProperty(F0, "__esModule", {
  value: !0
});
F0.autoprefix = void 0;
var USe = Kk, Sj = WSe(USe), HSe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
};
function WSe(e) {
  return e && e.__esModule ? e : { default: e };
}
var qSe = {
  borderRadius: function(t) {
    return {
      msBorderRadius: t,
      MozBorderRadius: t,
      OBorderRadius: t,
      WebkitBorderRadius: t,
      borderRadius: t
    };
  },
  boxShadow: function(t) {
    return {
      msBoxShadow: t,
      MozBoxShadow: t,
      OBoxShadow: t,
      WebkitBoxShadow: t,
      boxShadow: t
    };
  },
  userSelect: function(t) {
    return {
      WebkitTouchCallout: t,
      KhtmlUserSelect: t,
      MozUserSelect: t,
      msUserSelect: t,
      WebkitUserSelect: t,
      userSelect: t
    };
  },
  flex: function(t) {
    return {
      WebkitBoxFlex: t,
      MozBoxFlex: t,
      WebkitFlex: t,
      msFlex: t,
      flex: t
    };
  },
  flexBasis: function(t) {
    return {
      WebkitFlexBasis: t,
      flexBasis: t
    };
  },
  justifyContent: function(t) {
    return {
      WebkitJustifyContent: t,
      justifyContent: t
    };
  },
  transition: function(t) {
    return {
      msTransition: t,
      MozTransition: t,
      OTransition: t,
      WebkitTransition: t,
      transition: t
    };
  },
  transform: function(t) {
    return {
      msTransform: t,
      MozTransform: t,
      OTransform: t,
      WebkitTransform: t,
      transform: t
    };
  },
  absolute: function(t) {
    var n = t && t.split(" ");
    return {
      position: "absolute",
      top: n && n[0],
      right: n && n[1],
      bottom: n && n[2],
      left: n && n[3]
    };
  },
  extend: function(t, n) {
    var o = n[t];
    return o || {
      extend: t
    };
  }
}, YSe = F0.autoprefix = function(t) {
  var n = {};
  return (0, Sj.default)(t, function(o, s) {
    var l = {};
    (0, Sj.default)(o, function(u, p) {
      var h = qSe[p];
      h ? l = HSe({}, l, h(u)) : l[p] = u;
    }), n[s] = l;
  }), n;
};
F0.default = YSe;
var j0 = {};
Object.defineProperty(j0, "__esModule", {
  value: !0
});
j0.hover = void 0;
var GSe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, KSe = oe, g$ = XSe(KSe);
function XSe(e) {
  return e && e.__esModule ? e : { default: e };
}
function QSe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Cj(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function JSe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var ZSe = j0.hover = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(o) {
    JSe(s, o);
    function s() {
      var l, u, p, h;
      QSe(this, s);
      for (var m = arguments.length, b = Array(m), x = 0; x < m; x++)
        b[x] = arguments[x];
      return h = (u = (p = Cj(this, (l = s.__proto__ || Object.getPrototypeOf(s)).call.apply(l, [this].concat(b))), p), p.state = { hover: !1 }, p.handleMouseOver = function() {
        return p.setState({ hover: !0 });
      }, p.handleMouseOut = function() {
        return p.setState({ hover: !1 });
      }, p.render = function() {
        return g$.default.createElement(
          n,
          { onMouseOver: p.handleMouseOver, onMouseOut: p.handleMouseOut },
          g$.default.createElement(t, GSe({}, p.props, p.state))
        );
      }, u), Cj(p, h);
    }
    return s;
  }(g$.default.Component);
};
j0.default = ZSe;
var V0 = {};
Object.defineProperty(V0, "__esModule", {
  value: !0
});
V0.active = void 0;
var eCe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, tCe = oe, y$ = nCe(tCe);
function nCe(e) {
  return e && e.__esModule ? e : { default: e };
}
function rCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wj(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function oCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var aCe = V0.active = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(o) {
    oCe(s, o);
    function s() {
      var l, u, p, h;
      rCe(this, s);
      for (var m = arguments.length, b = Array(m), x = 0; x < m; x++)
        b[x] = arguments[x];
      return h = (u = (p = wj(this, (l = s.__proto__ || Object.getPrototypeOf(s)).call.apply(l, [this].concat(b))), p), p.state = { active: !1 }, p.handleMouseDown = function() {
        return p.setState({ active: !0 });
      }, p.handleMouseUp = function() {
        return p.setState({ active: !1 });
      }, p.render = function() {
        return y$.default.createElement(
          n,
          { onMouseDown: p.handleMouseDown, onMouseUp: p.handleMouseUp },
          y$.default.createElement(t, eCe({}, p.props, p.state))
        );
      }, u), wj(p, h);
    }
    return s;
  }(y$.default.Component);
};
V0.default = aCe;
var sM = {};
Object.defineProperty(sM, "__esModule", {
  value: !0
});
var iCe = function(t, n) {
  var o = {}, s = function(u) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    o[u] = p;
  };
  return t === 0 && s("first-child"), t === n - 1 && s("last-child"), (t === 0 || t % 2 === 0) && s("even"), Math.abs(t % 2) === 1 && s("odd"), s("nth-child", t), o;
};
sM.default = iCe;
Object.defineProperty(is, "__esModule", {
  value: !0
});
is.ReactCSS = is.loop = is.handleActive = lM = is.handleHover = is.hover = void 0;
var sCe = I0, lCe = Iv(sCe), cCe = L0, uCe = Iv(cCe), dCe = F0, fCe = Iv(dCe), pCe = j0, Q4 = Iv(pCe), hCe = V0, mCe = Iv(hCe), vCe = sM, gCe = Iv(vCe);
function Iv(e) {
  return e && e.__esModule ? e : { default: e };
}
is.hover = Q4.default;
var lM = is.handleHover = Q4.default;
is.handleActive = mCe.default;
is.loop = gCe.default;
var yCe = is.ReactCSS = function(t) {
  for (var n = arguments.length, o = Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    o[s - 1] = arguments[s];
  var l = (0, lCe.default)(o), u = (0, uCe.default)(t, l);
  return (0, fCe.default)(u);
}, on = is.default = yCe, bCe = function(t, n, o, s, l) {
  var u = l.clientWidth, p = l.clientHeight, h = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, m = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, b = h - (l.getBoundingClientRect().left + window.pageXOffset), x = m - (l.getBoundingClientRect().top + window.pageYOffset);
  if (o === "vertical") {
    var S = void 0;
    if (x < 0 ? S = 0 : x > p ? S = 1 : S = Math.round(x * 100 / p) / 100, n.a !== S)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: S,
        source: "rgb"
      };
  } else {
    var R = void 0;
    if (b < 0 ? R = 0 : b > u ? R = 1 : R = Math.round(b * 100 / u) / 100, s !== R)
      return {
        h: n.h,
        s: n.s,
        l: n.l,
        a: R,
        source: "rgb"
      };
  }
  return null;
}, b$ = {}, xCe = function(t, n, o, s) {
  if (typeof document > "u" && !s)
    return null;
  var l = s ? new s() : document.createElement("canvas");
  l.width = o * 2, l.height = o * 2;
  var u = l.getContext("2d");
  return u ? (u.fillStyle = t, u.fillRect(0, 0, l.width, l.height), u.fillStyle = n, u.fillRect(0, 0, o, o), u.translate(o, o), u.fillRect(0, 0, o, o), l.toDataURL()) : null;
}, SCe = function(t, n, o, s) {
  var l = t + "-" + n + "-" + o + (s ? "-server" : "");
  if (b$[l])
    return b$[l];
  var u = xCe(t, n, o, s);
  return b$[l] = u, u;
}, Tj = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, _v = function(t) {
  var n = t.white, o = t.grey, s = t.size, l = t.renderers, u = t.borderRadius, p = t.boxShadow, h = t.children, m = on({
    default: {
      grid: {
        borderRadius: u,
        boxShadow: p,
        absolute: "0px 0px 0px 0px",
        background: "url(" + SCe(n, o, s, l.canvas) + ") center left"
      }
    }
  });
  return Cb(h) ? oe.cloneElement(h, Tj({}, h.props, { style: Tj({}, h.props.style, m.grid) })) : oe.createElement("div", { style: m.grid });
};
_v.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var CCe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, wCe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function TCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ej(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function ECe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var cM = function(e) {
  ECe(t, e);
  function t() {
    var n, o, s, l;
    TCe(this, t);
    for (var u = arguments.length, p = Array(u), h = 0; h < u; h++)
      p[h] = arguments[h];
    return l = (o = (s = Ej(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(p))), s), s.handleChange = function(m) {
      var b = bCe(m, s.props.hsl, s.props.direction, s.props.a, s.container);
      b && typeof s.props.onChange == "function" && s.props.onChange(b, m);
    }, s.handleMouseDown = function(m) {
      s.handleChange(m), window.addEventListener("mousemove", s.handleChange), window.addEventListener("mouseup", s.handleMouseUp);
    }, s.handleMouseUp = function() {
      s.unbindEventListeners();
    }, s.unbindEventListeners = function() {
      window.removeEventListener("mousemove", s.handleChange), window.removeEventListener("mouseup", s.handleMouseUp);
    }, o), Ej(s, l);
  }
  return wCe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var o = this, s = this.props.rgb, l = on({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + s.r + "," + s.g + "," + s.b + `, 0) 0%,
           rgba(` + s.r + "," + s.g + "," + s.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: s.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + s.r + "," + s.g + "," + s.b + `, 0) 0%,
           rgba(` + s.r + "," + s.g + "," + s.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: s.a * 100 + "%"
          }
        },
        overwrite: CCe({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return oe.createElement(
        "div",
        { style: l.alpha },
        oe.createElement(
          "div",
          { style: l.checkboard },
          oe.createElement(_v, { renderers: this.props.renderers })
        ),
        oe.createElement("div", { style: l.gradient }),
        oe.createElement(
          "div",
          {
            style: l.container,
            ref: function(p) {
              return o.container = p;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          oe.createElement(
            "div",
            { style: l.pointer },
            this.props.pointer ? oe.createElement(this.props.pointer, this.props) : oe.createElement("div", { style: l.slider })
          )
        )
      );
    }
  }]), t;
}(c0 || gv), RCe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function OCe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $Ce(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function DCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var kCe = 1, J4 = 38, MCe = 40, NCe = [J4, MCe], ICe = function(t) {
  return NCe.indexOf(t) > -1;
}, _Ce = function(t) {
  return Number(String(t).replace(/%/g, ""));
}, ACe = 1, Sn = function(e) {
  DCe(t, e);
  function t(n) {
    PCe(this, t);
    var o = $Ce(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return o.handleBlur = function() {
      o.state.blurValue && o.setState({ value: o.state.blurValue, blurValue: null });
    }, o.handleChange = function(s) {
      o.setUpdatedValue(s.target.value, s);
    }, o.handleKeyDown = function(s) {
      var l = _Ce(s.target.value);
      if (!isNaN(l) && ICe(s.keyCode)) {
        var u = o.getArrowOffset(), p = s.keyCode === J4 ? l + u : l - u;
        o.setUpdatedValue(p, s);
      }
    }, o.handleDrag = function(s) {
      if (o.props.dragLabel) {
        var l = Math.round(o.props.value + s.movementX);
        l >= 0 && l <= o.props.dragMax && o.props.onChange && o.props.onChange(o.getValueObjectWithLabel(l), s);
      }
    }, o.handleMouseDown = function(s) {
      o.props.dragLabel && (s.preventDefault(), o.handleDrag(s), window.addEventListener("mousemove", o.handleDrag), window.addEventListener("mouseup", o.handleMouseUp));
    }, o.handleMouseUp = function() {
      o.unbindEventListeners();
    }, o.unbindEventListeners = function() {
      window.removeEventListener("mousemove", o.handleDrag), window.removeEventListener("mouseup", o.handleMouseUp);
    }, o.state = {
      value: String(n.value).toUpperCase(),
      blurValue: String(n.value).toUpperCase()
    }, o.inputId = "rc-editable-input-" + ACe++, o;
  }
  return RCe(t, [{
    key: "componentDidUpdate",
    value: function(o, s) {
      this.props.value !== this.state.value && (o.value !== this.props.value || s.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(o) {
      return OCe({}, this.props.label, o);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || kCe;
    }
  }, {
    key: "setUpdatedValue",
    value: function(o, s) {
      var l = this.props.label ? this.getValueObjectWithLabel(o) : o;
      this.props.onChange && this.props.onChange(l, s), this.setState({ value: o });
    }
  }, {
    key: "render",
    value: function() {
      var o = this, s = on({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return oe.createElement(
        "div",
        { style: s.wrap },
        oe.createElement("input", {
          id: this.inputId,
          style: s.input,
          ref: function(u) {
            return o.input = u;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? oe.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: s.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), t;
}(c0 || gv), LCe = function(t, n, o, s) {
  var l = s.clientWidth, u = s.clientHeight, p = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, h = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, m = p - (s.getBoundingClientRect().left + window.pageXOffset), b = h - (s.getBoundingClientRect().top + window.pageYOffset);
  if (n === "vertical") {
    var x = void 0;
    if (b < 0)
      x = 359;
    else if (b > u)
      x = 0;
    else {
      var S = -(b * 100 / u) + 100;
      x = 360 * S / 100;
    }
    if (o.h !== x)
      return {
        h: x,
        s: o.s,
        l: o.l,
        a: o.a,
        source: "hsl"
      };
  } else {
    var R = void 0;
    if (m < 0)
      R = 0;
    else if (m > l)
      R = 359;
    else {
      var T = m * 100 / l;
      R = 360 * T / 100;
    }
    if (o.h !== R)
      return {
        h: R,
        s: o.s,
        l: o.l,
        a: o.a,
        source: "hsl"
      };
  }
  return null;
}, FCe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function jCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rj(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function VCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Av = function(e) {
  VCe(t, e);
  function t() {
    var n, o, s, l;
    jCe(this, t);
    for (var u = arguments.length, p = Array(u), h = 0; h < u; h++)
      p[h] = arguments[h];
    return l = (o = (s = Rj(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(p))), s), s.handleChange = function(m) {
      var b = LCe(m, s.props.direction, s.props.hsl, s.container);
      b && typeof s.props.onChange == "function" && s.props.onChange(b, m);
    }, s.handleMouseDown = function(m) {
      s.handleChange(m), window.addEventListener("mousemove", s.handleChange), window.addEventListener("mouseup", s.handleMouseUp);
    }, s.handleMouseUp = function() {
      s.unbindEventListeners();
    }, o), Rj(s, l);
  }
  return FCe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var o = this, s = this.props.direction, l = s === void 0 ? "horizontal" : s, u = on({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: l === "vertical" });
      return oe.createElement(
        "div",
        { style: u.hue },
        oe.createElement(
          "div",
          {
            className: "hue-" + l,
            style: u.container,
            ref: function(h) {
              return o.container = h;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          oe.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          oe.createElement(
            "div",
            { style: u.pointer },
            this.props.pointer ? oe.createElement(this.props.pointer, this.props) : oe.createElement("div", { style: u.slider })
          )
        )
      );
    }
  }]), t;
}(c0 || gv);
function BCe() {
  this.__data__ = [], this.size = 0;
}
function B0(e, t) {
  return e === t || e !== e && t !== t;
}
function $T(e, t) {
  for (var n = e.length; n--; )
    if (B0(e[n][0], t))
      return n;
  return -1;
}
var zCe = Array.prototype, UCe = zCe.splice;
function HCe(e) {
  var t = this.__data__, n = $T(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : UCe.call(t, n, 1), --this.size, !0;
}
function WCe(e) {
  var t = this.__data__, n = $T(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function qCe(e) {
  return $T(this.__data__, e) > -1;
}
function YCe(e, t) {
  var n = this.__data__, o = $T(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
function Gc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Gc.prototype.clear = BCe;
Gc.prototype.delete = HCe;
Gc.prototype.get = WCe;
Gc.prototype.has = qCe;
Gc.prototype.set = YCe;
function GCe() {
  this.__data__ = new Gc(), this.size = 0;
}
function KCe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function XCe(e) {
  return this.__data__.get(e);
}
function QCe(e) {
  return this.__data__.has(e);
}
var Z4 = typeof global == "object" && global && global.Object === Object && global, JCe = typeof self == "object" && self && self.Object === Object && self, rl = Z4 || JCe || Function("return this")(), pd = rl.Symbol, e3 = Object.prototype, ZCe = e3.hasOwnProperty, e1e = e3.toString, lb = pd ? pd.toStringTag : void 0;
function t1e(e) {
  var t = ZCe.call(e, lb), n = e[lb];
  try {
    e[lb] = void 0;
    var o = !0;
  } catch {
  }
  var s = e1e.call(e);
  return o && (t ? e[lb] = n : delete e[lb]), s;
}
var n1e = Object.prototype, r1e = n1e.toString;
function o1e(e) {
  return r1e.call(e);
}
var a1e = "[object Null]", i1e = "[object Undefined]", Oj = pd ? pd.toStringTag : void 0;
function hp(e) {
  return e == null ? e === void 0 ? i1e : a1e : Oj && Oj in Object(e) ? t1e(e) : o1e(e);
}
function ps(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var s1e = "[object AsyncFunction]", l1e = "[object Function]", c1e = "[object GeneratorFunction]", u1e = "[object Proxy]";
function uM(e) {
  if (!ps(e))
    return !1;
  var t = hp(e);
  return t == l1e || t == c1e || t == s1e || t == u1e;
}
var x$ = rl["__core-js_shared__"], Pj = function() {
  var e = /[^.]+$/.exec(x$ && x$.keys && x$.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function d1e(e) {
  return !!Pj && Pj in e;
}
var f1e = Function.prototype, p1e = f1e.toString;
function mp(e) {
  if (e != null) {
    try {
      return p1e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var h1e = /[\\^$.*+?()[\]{}|]/g, m1e = /^\[object .+?Constructor\]$/, v1e = Function.prototype, g1e = Object.prototype, y1e = v1e.toString, b1e = g1e.hasOwnProperty, x1e = RegExp(
  "^" + y1e.call(b1e).replace(h1e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function S1e(e) {
  if (!ps(e) || d1e(e))
    return !1;
  var t = uM(e) ? x1e : m1e;
  return t.test(mp(e));
}
function C1e(e, t) {
  return e == null ? void 0 : e[t];
}
function vp(e, t) {
  var n = C1e(e, t);
  return S1e(n) ? n : void 0;
}
var Zb = vp(rl, "Map"), e0 = vp(Object, "create");
function w1e() {
  this.__data__ = e0 ? e0(null) : {}, this.size = 0;
}
function T1e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var E1e = "__lodash_hash_undefined__", R1e = Object.prototype, O1e = R1e.hasOwnProperty;
function P1e(e) {
  var t = this.__data__;
  if (e0) {
    var n = t[e];
    return n === E1e ? void 0 : n;
  }
  return O1e.call(t, e) ? t[e] : void 0;
}
var $1e = Object.prototype, D1e = $1e.hasOwnProperty;
function k1e(e) {
  var t = this.__data__;
  return e0 ? t[e] !== void 0 : D1e.call(t, e);
}
var M1e = "__lodash_hash_undefined__";
function N1e(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = e0 && t === void 0 ? M1e : t, this;
}
function rp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
rp.prototype.clear = w1e;
rp.prototype.delete = T1e;
rp.prototype.get = P1e;
rp.prototype.has = k1e;
rp.prototype.set = N1e;
function I1e() {
  this.size = 0, this.__data__ = {
    hash: new rp(),
    map: new (Zb || Gc)(),
    string: new rp()
  };
}
function _1e(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function DT(e, t) {
  var n = e.__data__;
  return _1e(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function A1e(e) {
  var t = DT(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function L1e(e) {
  return DT(this, e).get(e);
}
function F1e(e) {
  return DT(this, e).has(e);
}
function j1e(e, t) {
  var n = DT(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
function Kc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Kc.prototype.clear = I1e;
Kc.prototype.delete = A1e;
Kc.prototype.get = L1e;
Kc.prototype.has = F1e;
Kc.prototype.set = j1e;
var V1e = 200;
function B1e(e, t) {
  var n = this.__data__;
  if (n instanceof Gc) {
    var o = n.__data__;
    if (!Zb || o.length < V1e - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Kc(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
function zl(e) {
  var t = this.__data__ = new Gc(e);
  this.size = t.size;
}
zl.prototype.clear = GCe;
zl.prototype.delete = KCe;
zl.prototype.get = XCe;
zl.prototype.has = QCe;
zl.prototype.set = B1e;
var cw = function() {
  try {
    var e = vp(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function dM(e, t, n) {
  t == "__proto__" && cw ? cw(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function sD(e, t, n) {
  (n !== void 0 && !B0(e[t], n) || n === void 0 && !(t in e)) && dM(e, t, n);
}
function z1e(e) {
  return function(t, n, o) {
    for (var s = -1, l = Object(t), u = o(t), p = u.length; p--; ) {
      var h = u[++s];
      if (n(l[h], h, l) === !1)
        break;
    }
    return t;
  };
}
var t3 = z1e(), n3 = typeof exports == "object" && exports && !exports.nodeType && exports, $j = n3 && typeof module == "object" && module && !module.nodeType && module, U1e = $j && $j.exports === n3, Dj = U1e ? rl.Buffer : void 0;
Dj && Dj.allocUnsafe;
function H1e(e, t) {
  return e.slice();
}
var uw = rl.Uint8Array;
function W1e(e) {
  var t = new e.constructor(e.byteLength);
  return new uw(t).set(new uw(e)), t;
}
function q1e(e, t) {
  var n = W1e(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
function Y1e(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var kj = Object.create, G1e = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!ps(t))
      return {};
    if (kj)
      return kj(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function r3(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var o3 = r3(Object.getPrototypeOf, Object), K1e = Object.prototype;
function fM(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || K1e;
  return e === n;
}
function X1e(e) {
  return typeof e.constructor == "function" && !fM(e) ? G1e(o3(e)) : {};
}
function hd(e) {
  return e != null && typeof e == "object";
}
var Q1e = "[object Arguments]";
function Mj(e) {
  return hd(e) && hp(e) == Q1e;
}
var a3 = Object.prototype, J1e = a3.hasOwnProperty, Z1e = a3.propertyIsEnumerable, dw = Mj(/* @__PURE__ */ function() {
  return arguments;
}()) ? Mj : function(e) {
  return hd(e) && J1e.call(e, "callee") && !Z1e.call(e, "callee");
}, ji = Array.isArray, ewe = 9007199254740991;
function pM(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ewe;
}
function Lv(e) {
  return e != null && pM(e.length) && !uM(e);
}
function twe(e) {
  return hd(e) && Lv(e);
}
function nwe() {
  return !1;
}
var i3 = typeof exports == "object" && exports && !exports.nodeType && exports, Nj = i3 && typeof module == "object" && module && !module.nodeType && module, rwe = Nj && Nj.exports === i3, Ij = rwe ? rl.Buffer : void 0, owe = Ij ? Ij.isBuffer : void 0, fw = owe || nwe, awe = "[object Object]", iwe = Function.prototype, swe = Object.prototype, s3 = iwe.toString, lwe = swe.hasOwnProperty, cwe = s3.call(Object);
function uwe(e) {
  if (!hd(e) || hp(e) != awe)
    return !1;
  var t = o3(e);
  if (t === null)
    return !0;
  var n = lwe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && s3.call(n) == cwe;
}
var dwe = "[object Arguments]", fwe = "[object Array]", pwe = "[object Boolean]", hwe = "[object Date]", mwe = "[object Error]", vwe = "[object Function]", gwe = "[object Map]", ywe = "[object Number]", bwe = "[object Object]", xwe = "[object RegExp]", Swe = "[object Set]", Cwe = "[object String]", wwe = "[object WeakMap]", Twe = "[object ArrayBuffer]", Ewe = "[object DataView]", Rwe = "[object Float32Array]", Owe = "[object Float64Array]", Pwe = "[object Int8Array]", $we = "[object Int16Array]", Dwe = "[object Int32Array]", kwe = "[object Uint8Array]", Mwe = "[object Uint8ClampedArray]", Nwe = "[object Uint16Array]", Iwe = "[object Uint32Array]", pr = {};
pr[Rwe] = pr[Owe] = pr[Pwe] = pr[$we] = pr[Dwe] = pr[kwe] = pr[Mwe] = pr[Nwe] = pr[Iwe] = !0;
pr[dwe] = pr[fwe] = pr[Twe] = pr[pwe] = pr[Ewe] = pr[hwe] = pr[mwe] = pr[vwe] = pr[gwe] = pr[ywe] = pr[bwe] = pr[xwe] = pr[Swe] = pr[Cwe] = pr[wwe] = !1;
function _we(e) {
  return hd(e) && pM(e.length) && !!pr[hp(e)];
}
function Awe(e) {
  return function(t) {
    return e(t);
  };
}
var l3 = typeof exports == "object" && exports && !exports.nodeType && exports, Mb = l3 && typeof module == "object" && module && !module.nodeType && module, Lwe = Mb && Mb.exports === l3, S$ = Lwe && Z4.process, _j = function() {
  try {
    var e = Mb && Mb.require && Mb.require("util").types;
    return e || S$ && S$.binding && S$.binding("util");
  } catch {
  }
}(), Aj = _j && _j.isTypedArray, hM = Aj ? Awe(Aj) : _we;
function lD(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var Fwe = Object.prototype, jwe = Fwe.hasOwnProperty;
function Vwe(e, t, n) {
  var o = e[t];
  (!(jwe.call(e, t) && B0(o, n)) || n === void 0 && !(t in e)) && dM(e, t, n);
}
function Bwe(e, t, n, o) {
  var s = !n;
  n || (n = {});
  for (var l = -1, u = t.length; ++l < u; ) {
    var p = t[l], h = void 0;
    h === void 0 && (h = e[p]), s ? dM(n, p, h) : Vwe(n, p, h);
  }
  return n;
}
function zwe(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var Uwe = 9007199254740991, Hwe = /^(?:0|[1-9]\d*)$/;
function mM(e, t) {
  var n = typeof e;
  return t = t ?? Uwe, !!t && (n == "number" || n != "symbol" && Hwe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Wwe = Object.prototype, qwe = Wwe.hasOwnProperty;
function c3(e, t) {
  var n = ji(e), o = !n && dw(e), s = !n && !o && fw(e), l = !n && !o && !s && hM(e), u = n || o || s || l, p = u ? zwe(e.length, String) : [], h = p.length;
  for (var m in e)
    (t || qwe.call(e, m)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
    mM(m, h))) && p.push(m);
  return p;
}
function Ywe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Gwe = Object.prototype, Kwe = Gwe.hasOwnProperty;
function Xwe(e) {
  if (!ps(e))
    return Ywe(e);
  var t = fM(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !Kwe.call(e, o)) || n.push(o);
  return n;
}
function u3(e) {
  return Lv(e) ? c3(e, !0) : Xwe(e);
}
function Qwe(e) {
  return Bwe(e, u3(e));
}
function Jwe(e, t, n, o, s, l, u) {
  var p = lD(e, n), h = lD(t, n), m = u.get(h);
  if (m) {
    sD(e, n, m);
    return;
  }
  var b = l ? l(p, h, n + "", e, t, u) : void 0, x = b === void 0;
  if (x) {
    var S = ji(h), R = !S && fw(h), T = !S && !R && hM(h);
    b = h, S || R || T ? ji(p) ? b = p : twe(p) ? b = Y1e(p) : R ? (x = !1, b = H1e(h)) : T ? (x = !1, b = q1e(h)) : b = [] : uwe(h) || dw(h) ? (b = p, dw(p) ? b = Qwe(p) : (!ps(p) || uM(p)) && (b = X1e(h))) : x = !1;
  }
  x && (u.set(h, b), s(b, h, o, l, u), u.delete(h)), sD(e, n, b);
}
function d3(e, t, n, o, s) {
  e !== t && t3(t, function(l, u) {
    if (s || (s = new zl()), ps(l))
      Jwe(e, t, u, n, d3, o, s);
    else {
      var p = o ? o(lD(e, u), l, u + "", e, t, s) : void 0;
      p === void 0 && (p = l), sD(e, u, p);
    }
  }, u3);
}
function kT(e) {
  return e;
}
function Zwe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Lj = Math.max;
function eTe(e, t, n) {
  return t = Lj(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, s = -1, l = Lj(o.length - t, 0), u = Array(l); ++s < l; )
      u[s] = o[t + s];
    s = -1;
    for (var p = Array(t + 1); ++s < t; )
      p[s] = o[s];
    return p[t] = n(u), Zwe(e, this, p);
  };
}
function tTe(e) {
  return function() {
    return e;
  };
}
var nTe = cw ? function(e, t) {
  return cw(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: tTe(t),
    writable: !0
  });
} : kT, rTe = 800, oTe = 16, aTe = Date.now;
function iTe(e) {
  var t = 0, n = 0;
  return function() {
    var o = aTe(), s = oTe - (o - n);
    if (n = o, s > 0) {
      if (++t >= rTe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var sTe = iTe(nTe);
function lTe(e, t) {
  return sTe(eTe(e, t, kT), e + "");
}
function cTe(e, t, n) {
  if (!ps(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? Lv(n) && mM(t, n.length) : o == "string" && t in n) ? B0(n[t], e) : !1;
}
function uTe(e) {
  return lTe(function(t, n) {
    var o = -1, s = n.length, l = s > 1 ? n[s - 1] : void 0, u = s > 2 ? n[2] : void 0;
    for (l = e.length > 3 && typeof l == "function" ? (s--, l) : void 0, u && cTe(n[0], n[1], u) && (l = s < 3 ? void 0 : l, s = 1), t = Object(t); ++o < s; ) {
      var p = n[o];
      p && e(t, p, o, l);
    }
    return t;
  });
}
var gi = uTe(function(e, t, n) {
  d3(e, t, n);
}), z0 = function(t) {
  var n = t.zDepth, o = t.radius, s = t.background, l = t.children, u = t.styles, p = u === void 0 ? {} : u, h = on(gi({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + n + "px " + n * 4 + "px rgba(0,0,0,.24)",
        borderRadius: o,
        background: s
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, p), { "zDepth-1": n === 1 });
  return oe.createElement(
    "div",
    { style: h.wrap },
    oe.createElement("div", { style: h.bg }),
    oe.createElement(
      "div",
      { style: h.content },
      l
    )
  );
};
z0.propTypes = {
  background: r.string,
  zDepth: r.oneOf([0, 1, 2, 3, 4, 5]),
  radius: r.number,
  styles: r.object
};
z0.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var C$ = function() {
  return rl.Date.now();
}, dTe = /\s/;
function fTe(e) {
  for (var t = e.length; t-- && dTe.test(e.charAt(t)); )
    ;
  return t;
}
var pTe = /^\s+/;
function hTe(e) {
  return e && e.slice(0, fTe(e) + 1).replace(pTe, "");
}
var mTe = "[object Symbol]";
function MT(e) {
  return typeof e == "symbol" || hd(e) && hp(e) == mTe;
}
var Fj = NaN, vTe = /^[-+]0x[0-9a-f]+$/i, gTe = /^0b[01]+$/i, yTe = /^0o[0-7]+$/i, bTe = parseInt;
function jj(e) {
  if (typeof e == "number")
    return e;
  if (MT(e))
    return Fj;
  if (ps(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ps(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = hTe(e);
  var n = gTe.test(e);
  return n || yTe.test(e) ? bTe(e.slice(2), n ? 2 : 8) : vTe.test(e) ? Fj : +e;
}
var xTe = "Expected a function", STe = Math.max, CTe = Math.min;
function f3(e, t, n) {
  var o, s, l, u, p, h, m = 0, b = !1, x = !1, S = !0;
  if (typeof e != "function")
    throw new TypeError(xTe);
  t = jj(t) || 0, ps(n) && (b = !!n.leading, x = "maxWait" in n, l = x ? STe(jj(n.maxWait) || 0, t) : l, S = "trailing" in n ? !!n.trailing : S);
  function R(V) {
    var z = o, H = s;
    return o = s = void 0, m = V, u = e.apply(H, z), u;
  }
  function T(V) {
    return m = V, p = setTimeout(k, t), b ? R(V) : u;
  }
  function E(V) {
    var z = V - h, H = V - m, ee = t - z;
    return x ? CTe(ee, l - H) : ee;
  }
  function P(V) {
    var z = V - h, H = V - m;
    return h === void 0 || z >= t || z < 0 || x && H >= l;
  }
  function k() {
    var V = C$();
    if (P(V))
      return _(V);
    p = setTimeout(k, E(V));
  }
  function _(V) {
    return p = void 0, S && o ? R(V) : (o = s = void 0, u);
  }
  function L() {
    p !== void 0 && clearTimeout(p), m = 0, o = h = s = p = void 0;
  }
  function F() {
    return p === void 0 ? u : _(C$());
  }
  function N() {
    var V = C$(), z = P(V);
    if (o = arguments, s = this, h = V, z) {
      if (p === void 0)
        return T(h);
      if (x)
        return clearTimeout(p), p = setTimeout(k, t), R(h);
    }
    return p === void 0 && (p = setTimeout(k, t)), u;
  }
  return N.cancel = L, N.flush = F, N;
}
var wTe = "Expected a function";
function TTe(e, t, n) {
  var o = !0, s = !0;
  if (typeof e != "function")
    throw new TypeError(wTe);
  return ps(n) && (o = "leading" in n ? !!n.leading : o, s = "trailing" in n ? !!n.trailing : s), f3(e, t, {
    leading: o,
    maxWait: t,
    trailing: s
  });
}
var ETe = function(t, n, o) {
  var s = o.getBoundingClientRect(), l = s.width, u = s.height, p = typeof t.pageX == "number" ? t.pageX : t.touches[0].pageX, h = typeof t.pageY == "number" ? t.pageY : t.touches[0].pageY, m = p - (o.getBoundingClientRect().left + window.pageXOffset), b = h - (o.getBoundingClientRect().top + window.pageYOffset);
  m < 0 ? m = 0 : m > l && (m = l), b < 0 ? b = 0 : b > u && (b = u);
  var x = m / l, S = 1 - b / u;
  return {
    h: n.h,
    s: x,
    v: S,
    a: n.a,
    source: "hsv"
  };
}, RTe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function OTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function PTe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function $Te(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var NT = function(e) {
  $Te(t, e);
  function t(n) {
    OTe(this, t);
    var o = PTe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return o.handleChange = function(s) {
      typeof o.props.onChange == "function" && o.throttle(o.props.onChange, ETe(s, o.props.hsl, o.container), s);
    }, o.handleMouseDown = function(s) {
      o.handleChange(s);
      var l = o.getContainerRenderWindow();
      l.addEventListener("mousemove", o.handleChange), l.addEventListener("mouseup", o.handleMouseUp);
    }, o.handleMouseUp = function() {
      o.unbindEventListeners();
    }, o.throttle = TTe(function(s, l, u) {
      s(l, u);
    }, 50), o;
  }
  return RTe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var o = this.container, s = window; !s.document.contains(o) && s.parent !== s; )
        s = s.parent;
      return s;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var o = this.getContainerRenderWindow();
      o.removeEventListener("mousemove", this.handleChange), o.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var o = this, s = this.props.style || {}, l = s.color, u = s.white, p = s.black, h = s.pointer, m = s.circle, b = on({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: l,
          white: u,
          black: p,
          pointer: h,
          circle: m
        }
      }, { custom: !!this.props.style });
      return oe.createElement(
        "div",
        {
          style: b.color,
          ref: function(S) {
            return o.container = S;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        oe.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        oe.createElement(
          "div",
          { style: b.white, className: "saturation-white" },
          oe.createElement("div", { style: b.black, className: "saturation-black" }),
          oe.createElement(
            "div",
            { style: b.pointer },
            this.props.pointer ? oe.createElement(this.props.pointer, this.props) : oe.createElement("div", { style: b.circle })
          )
        )
      );
    }
  }]), t;
}(c0 || gv);
function DTe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var kTe = r3(Object.keys, Object), MTe = Object.prototype, NTe = MTe.hasOwnProperty;
function ITe(e) {
  if (!fM(e))
    return kTe(e);
  var t = [];
  for (var n in Object(e))
    NTe.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function vM(e) {
  return Lv(e) ? c3(e) : ITe(e);
}
function _Te(e, t) {
  return e && t3(e, t, vM);
}
function ATe(e, t) {
  return function(n, o) {
    if (n == null)
      return n;
    if (!Lv(n))
      return e(n, o);
    for (var s = n.length, l = -1, u = Object(n); ++l < s && o(u[l], l, u) !== !1; )
      ;
    return n;
  };
}
var p3 = ATe(_Te);
function LTe(e) {
  return typeof e == "function" ? e : kT;
}
function FTe(e, t) {
  var n = ji(e) ? DTe : p3;
  return n(e, LTe(t));
}
function pw(e) {
  "@babel/helpers - typeof";
  return pw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pw(e);
}
var jTe = /^\s+/, VTe = /\s+$/;
function Vt(e, t) {
  if (e = e || "", t = t || {}, e instanceof Vt)
    return e;
  if (!(this instanceof Vt))
    return new Vt(e, t);
  var n = BTe(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
Vt.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, o, s, l, u, p;
    return n = t.r / 255, o = t.g / 255, s = t.b / 255, n <= 0.03928 ? l = n / 12.92 : l = Math.pow((n + 0.055) / 1.055, 2.4), o <= 0.03928 ? u = o / 12.92 : u = Math.pow((o + 0.055) / 1.055, 2.4), s <= 0.03928 ? p = s / 12.92 : p = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * l + 0.7152 * u + 0.0722 * p;
  },
  setAlpha: function(t) {
    return this._a = h3(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = Bj(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = Bj(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), s = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + o + "%, " + s + "%)" : "hsva(" + n + ", " + o + "%, " + s + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = Vj(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = Vj(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), s = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + o + "%, " + s + "%)" : "hsla(" + n + ", " + o + "%, " + s + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return zj(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return WTe(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Sr(this._r, 255) * 100) + "%",
      g: Math.round(Sr(this._g, 255) * 100) + "%",
      b: Math.round(Sr(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Sr(this._r, 255) * 100) + "%, " + Math.round(Sr(this._g, 255) * 100) + "%, " + Math.round(Sr(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Sr(this._r, 255) * 100) + "%, " + Math.round(Sr(this._g, 255) * 100) + "%, " + Math.round(Sr(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : rEe[zj(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + Uj(this._r, this._g, this._b, this._a), o = n, s = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var l = Vt(t);
      o = "#" + Uj(l._r, l._g, l._b, l._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + s + "startColorstr=" + n + ",endColorstr=" + o + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var o = !1, s = this._a < 1 && this._a >= 0, l = !n && s && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return l ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (o = this.toRgbString()), t === "prgb" && (o = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (o = this.toHexString()), t === "hex3" && (o = this.toHexString(!0)), t === "hex4" && (o = this.toHex8String(!0)), t === "hex8" && (o = this.toHex8String()), t === "name" && (o = this.toName()), t === "hsl" && (o = this.toHslString()), t === "hsv" && (o = this.toHsvString()), o || this.toHexString());
  },
  clone: function() {
    return Vt(this.toString());
  },
  _applyModification: function(t, n) {
    var o = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = o._r, this._g = o._g, this._b = o._b, this.setAlpha(o._a), this;
  },
  lighten: function() {
    return this._applyModification(KTe, arguments);
  },
  brighten: function() {
    return this._applyModification(XTe, arguments);
  },
  darken: function() {
    return this._applyModification(QTe, arguments);
  },
  desaturate: function() {
    return this._applyModification(qTe, arguments);
  },
  saturate: function() {
    return this._applyModification(YTe, arguments);
  },
  greyscale: function() {
    return this._applyModification(GTe, arguments);
  },
  spin: function() {
    return this._applyModification(JTe, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(tEe, arguments);
  },
  complement: function() {
    return this._applyCombination(ZTe, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(nEe, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(eEe, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(Hj, [3]);
  },
  tetrad: function() {
    return this._applyCombination(Hj, [4]);
  }
};
Vt.fromRatio = function(e, t) {
  if (pw(e) == "object") {
    var n = {};
    for (var o in e)
      e.hasOwnProperty(o) && (o === "a" ? n[o] = e[o] : n[o] = gb(e[o]));
    e = n;
  }
  return Vt(e, t);
};
function BTe(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, o = null, s = null, l = null, u = !1, p = !1;
  return typeof e == "string" && (e = sEe(e)), pw(e) == "object" && (Nc(e.r) && Nc(e.g) && Nc(e.b) ? (t = zTe(e.r, e.g, e.b), u = !0, p = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Nc(e.h) && Nc(e.s) && Nc(e.v) ? (o = gb(e.s), s = gb(e.v), t = HTe(e.h, o, s), u = !0, p = "hsv") : Nc(e.h) && Nc(e.s) && Nc(e.l) && (o = gb(e.s), l = gb(e.l), t = UTe(e.h, o, l), u = !0, p = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = h3(n), {
    ok: u,
    format: e.format || p,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function zTe(e, t, n) {
  return {
    r: Sr(e, 255) * 255,
    g: Sr(t, 255) * 255,
    b: Sr(n, 255) * 255
  };
}
function Vj(e, t, n) {
  e = Sr(e, 255), t = Sr(t, 255), n = Sr(n, 255);
  var o = Math.max(e, t, n), s = Math.min(e, t, n), l, u, p = (o + s) / 2;
  if (o == s)
    l = u = 0;
  else {
    var h = o - s;
    switch (u = p > 0.5 ? h / (2 - o - s) : h / (o + s), o) {
      case e:
        l = (t - n) / h + (t < n ? 6 : 0);
        break;
      case t:
        l = (n - e) / h + 2;
        break;
      case n:
        l = (e - t) / h + 4;
        break;
    }
    l /= 6;
  }
  return {
    h: l,
    s: u,
    l: p
  };
}
function UTe(e, t, n) {
  var o, s, l;
  e = Sr(e, 360), t = Sr(t, 100), n = Sr(n, 100);
  function u(m, b, x) {
    return x < 0 && (x += 1), x > 1 && (x -= 1), x < 1 / 6 ? m + (b - m) * 6 * x : x < 1 / 2 ? b : x < 2 / 3 ? m + (b - m) * (2 / 3 - x) * 6 : m;
  }
  if (t === 0)
    o = s = l = n;
  else {
    var p = n < 0.5 ? n * (1 + t) : n + t - n * t, h = 2 * n - p;
    o = u(h, p, e + 1 / 3), s = u(h, p, e), l = u(h, p, e - 1 / 3);
  }
  return {
    r: o * 255,
    g: s * 255,
    b: l * 255
  };
}
function Bj(e, t, n) {
  e = Sr(e, 255), t = Sr(t, 255), n = Sr(n, 255);
  var o = Math.max(e, t, n), s = Math.min(e, t, n), l, u, p = o, h = o - s;
  if (u = o === 0 ? 0 : h / o, o == s)
    l = 0;
  else {
    switch (o) {
      case e:
        l = (t - n) / h + (t < n ? 6 : 0);
        break;
      case t:
        l = (n - e) / h + 2;
        break;
      case n:
        l = (e - t) / h + 4;
        break;
    }
    l /= 6;
  }
  return {
    h: l,
    s: u,
    v: p
  };
}
function HTe(e, t, n) {
  e = Sr(e, 360) * 6, t = Sr(t, 100), n = Sr(n, 100);
  var o = Math.floor(e), s = e - o, l = n * (1 - t), u = n * (1 - s * t), p = n * (1 - (1 - s) * t), h = o % 6, m = [n, u, l, l, p, n][h], b = [p, n, n, u, l, l][h], x = [l, l, p, n, n, u][h];
  return {
    r: m * 255,
    g: b * 255,
    b: x * 255
  };
}
function zj(e, t, n, o) {
  var s = [Js(Math.round(e).toString(16)), Js(Math.round(t).toString(16)), Js(Math.round(n).toString(16))];
  return o && s[0].charAt(0) == s[0].charAt(1) && s[1].charAt(0) == s[1].charAt(1) && s[2].charAt(0) == s[2].charAt(1) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) : s.join("");
}
function WTe(e, t, n, o, s) {
  var l = [Js(Math.round(e).toString(16)), Js(Math.round(t).toString(16)), Js(Math.round(n).toString(16)), Js(m3(o))];
  return s && l[0].charAt(0) == l[0].charAt(1) && l[1].charAt(0) == l[1].charAt(1) && l[2].charAt(0) == l[2].charAt(1) && l[3].charAt(0) == l[3].charAt(1) ? l[0].charAt(0) + l[1].charAt(0) + l[2].charAt(0) + l[3].charAt(0) : l.join("");
}
function Uj(e, t, n, o) {
  var s = [Js(m3(o)), Js(Math.round(e).toString(16)), Js(Math.round(t).toString(16)), Js(Math.round(n).toString(16))];
  return s.join("");
}
Vt.equals = function(e, t) {
  return !e || !t ? !1 : Vt(e).toRgbString() == Vt(t).toRgbString();
};
Vt.random = function() {
  return Vt.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function qTe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Vt(e).toHsl();
  return n.s -= t / 100, n.s = IT(n.s), Vt(n);
}
function YTe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Vt(e).toHsl();
  return n.s += t / 100, n.s = IT(n.s), Vt(n);
}
function GTe(e) {
  return Vt(e).desaturate(100);
}
function KTe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Vt(e).toHsl();
  return n.l += t / 100, n.l = IT(n.l), Vt(n);
}
function XTe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Vt(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), Vt(n);
}
function QTe(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = Vt(e).toHsl();
  return n.l -= t / 100, n.l = IT(n.l), Vt(n);
}
function JTe(e, t) {
  var n = Vt(e).toHsl(), o = (n.h + t) % 360;
  return n.h = o < 0 ? 360 + o : o, Vt(n);
}
function ZTe(e) {
  var t = Vt(e).toHsl();
  return t.h = (t.h + 180) % 360, Vt(t);
}
function Hj(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = Vt(e).toHsl(), o = [Vt(e)], s = 360 / t, l = 1; l < t; l++)
    o.push(Vt({
      h: (n.h + l * s) % 360,
      s: n.s,
      l: n.l
    }));
  return o;
}
function eEe(e) {
  var t = Vt(e).toHsl(), n = t.h;
  return [Vt(e), Vt({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), Vt({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function tEe(e, t, n) {
  t = t || 6, n = n || 30;
  var o = Vt(e).toHsl(), s = 360 / n, l = [Vt(e)];
  for (o.h = (o.h - (s * t >> 1) + 720) % 360; --t; )
    o.h = (o.h + s) % 360, l.push(Vt(o));
  return l;
}
function nEe(e, t) {
  t = t || 6;
  for (var n = Vt(e).toHsv(), o = n.h, s = n.s, l = n.v, u = [], p = 1 / t; t--; )
    u.push(Vt({
      h: o,
      s,
      v: l
    })), l = (l + p) % 1;
  return u;
}
Vt.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var o = Vt(e).toRgb(), s = Vt(t).toRgb(), l = n / 100, u = {
    r: (s.r - o.r) * l + o.r,
    g: (s.g - o.g) * l + o.g,
    b: (s.b - o.b) * l + o.b,
    a: (s.a - o.a) * l + o.a
  };
  return Vt(u);
};
Vt.readability = function(e, t) {
  var n = Vt(e), o = Vt(t);
  return (Math.max(n.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), o.getLuminance()) + 0.05);
};
Vt.isReadable = function(e, t, n) {
  var o = Vt.readability(e, t), s, l;
  switch (l = !1, s = lEe(n), s.level + s.size) {
    case "AAsmall":
    case "AAAlarge":
      l = o >= 4.5;
      break;
    case "AAlarge":
      l = o >= 3;
      break;
    case "AAAsmall":
      l = o >= 7;
      break;
  }
  return l;
};
Vt.mostReadable = function(e, t, n) {
  var o = null, s = 0, l, u, p, h;
  n = n || {}, u = n.includeFallbackColors, p = n.level, h = n.size;
  for (var m = 0; m < t.length; m++)
    l = Vt.readability(e, t[m]), l > s && (s = l, o = Vt(t[m]));
  return Vt.isReadable(e, o, {
    level: p,
    size: h
  }) || !u ? o : (n.includeFallbackColors = !1, Vt.mostReadable(e, ["#fff", "#000"], n));
};
var cD = Vt.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, rEe = Vt.hexNames = oEe(cD);
function oEe(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function h3(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Sr(e, t) {
  aEe(e) && (e = "100%");
  var n = iEe(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function IT(e) {
  return Math.min(1, Math.max(0, e));
}
function $i(e) {
  return parseInt(e, 16);
}
function aEe(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function iEe(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Js(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function gb(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function m3(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Wj(e) {
  return $i(e) / 255;
}
var Gs = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", s = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + s),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + s),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + s),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Nc(e) {
  return !!Gs.CSS_UNIT.exec(e);
}
function sEe(e) {
  e = e.replace(jTe, "").replace(VTe, "").toLowerCase();
  var t = !1;
  if (cD[e])
    e = cD[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = Gs.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = Gs.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = Gs.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = Gs.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = Gs.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = Gs.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = Gs.hex8.exec(e)) ? {
    r: $i(n[1]),
    g: $i(n[2]),
    b: $i(n[3]),
    a: Wj(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Gs.hex6.exec(e)) ? {
    r: $i(n[1]),
    g: $i(n[2]),
    b: $i(n[3]),
    format: t ? "name" : "hex"
  } : (n = Gs.hex4.exec(e)) ? {
    r: $i(n[1] + "" + n[1]),
    g: $i(n[2] + "" + n[2]),
    b: $i(n[3] + "" + n[3]),
    a: Wj(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Gs.hex3.exec(e)) ? {
    r: $i(n[1] + "" + n[1]),
    g: $i(n[2] + "" + n[2]),
    b: $i(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function lEe(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var qj = function(t) {
  var n = ["r", "g", "b", "a", "h", "s", "l", "v"], o = 0, s = 0;
  return FTe(n, function(l) {
    if (t[l] && (o += 1, isNaN(t[l]) || (s += 1), l === "s" || l === "l")) {
      var u = /^\d+%$/;
      u.test(t[l]) && (s += 1);
    }
  }), o === s ? t : !1;
}, yb = function(t, n) {
  var o = t.hex ? Vt(t.hex) : Vt(t), s = o.toHsl(), l = o.toHsv(), u = o.toRgb(), p = o.toHex();
  s.s === 0 && (s.h = n || 0, l.h = n || 0);
  var h = p === "000000" && u.a === 0;
  return {
    hsl: s,
    hex: h ? "transparent" : "#" + p,
    rgb: u,
    hsv: l,
    oldHue: t.h || n || s.h,
    source: t.source
  };
}, wd = function(t) {
  if (t === "transparent")
    return !0;
  var n = String(t).charAt(0) === "#" ? 1 : 0;
  return t.length !== 4 + n && t.length < 7 + n && Vt(t).isValid();
}, gM = function(t) {
  if (!t)
    return "#fff";
  var n = yb(t);
  if (n.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var o = (n.rgb.r * 299 + n.rgb.g * 587 + n.rgb.b * 114) / 1e3;
  return o >= 128 ? "#000" : "#fff";
}, w$ = function(t, n) {
  var o = t.replace("°", "");
  return Vt(n + " (" + o + ")")._ok;
}, cb = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, cEe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function uEe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dEe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function fEe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var yi = function(t) {
  var n = function(o) {
    fEe(s, o);
    function s(l) {
      uEe(this, s);
      var u = dEe(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this));
      return u.handleChange = function(p, h) {
        var m = qj(p);
        if (m) {
          var b = yb(p, p.h || u.state.oldHue);
          u.setState(b), u.props.onChangeComplete && u.debounce(u.props.onChangeComplete, b, h), u.props.onChange && u.props.onChange(b, h);
        }
      }, u.handleSwatchHover = function(p, h) {
        var m = qj(p);
        if (m) {
          var b = yb(p, p.h || u.state.oldHue);
          u.props.onSwatchHover && u.props.onSwatchHover(b, h);
        }
      }, u.state = cb({}, yb(l.color, 0)), u.debounce = f3(function(p, h, m) {
        p(h, m);
      }, 100), u;
    }
    return cEe(s, [{
      key: "render",
      value: function() {
        var u = {};
        return this.props.onSwatchHover && (u.onSwatchHover = this.handleSwatchHover), oe.createElement(t, cb({}, this.props, this.state, {
          onChange: this.handleChange
        }, u));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(u, p) {
        return cb({}, yb(u.color, p.oldHue));
      }
    }]), s;
  }(c0 || gv);
  return n.propTypes = cb({}, t.propTypes), n.defaultProps = cb({}, t.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), n;
}, pEe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, hEe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function mEe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yj(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function vEe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var gEe = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(o) {
    vEe(s, o);
    function s() {
      var l, u, p, h;
      mEe(this, s);
      for (var m = arguments.length, b = Array(m), x = 0; x < m; x++)
        b[x] = arguments[x];
      return h = (u = (p = Yj(this, (l = s.__proto__ || Object.getPrototypeOf(s)).call.apply(l, [this].concat(b))), p), p.state = { focus: !1 }, p.handleFocus = function() {
        return p.setState({ focus: !0 });
      }, p.handleBlur = function() {
        return p.setState({ focus: !1 });
      }, u), Yj(p, h);
    }
    return hEe(s, [{
      key: "render",
      value: function() {
        return oe.createElement(
          n,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          oe.createElement(t, pEe({}, this.props, this.state))
        );
      }
    }]), s;
  }(oe.Component);
}, Gj = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, yEe = 13, bEe = function(t) {
  var n = t.color, o = t.style, s = t.onClick, l = s === void 0 ? function() {
  } : s, u = t.onHover, p = t.title, h = p === void 0 ? n : p, m = t.children, b = t.focus, x = t.focusStyle, S = x === void 0 ? {} : x, R = n === "transparent", T = on({
    default: {
      swatch: Gj({
        background: n,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, o, b ? S : {})
    }
  }), E = function(F) {
    return l(n, F);
  }, P = function(F) {
    return F.keyCode === yEe && l(n, F);
  }, k = function(F) {
    return u(n, F);
  }, _ = {};
  return u && (_.onMouseOver = k), oe.createElement(
    "div",
    Gj({
      style: T.swatch,
      onClick: E,
      title: h,
      tabIndex: 0,
      onKeyDown: P
    }, _),
    m,
    R && oe.createElement(_v, {
      borderRadius: T.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const gp = gEe(bEe);
var xEe = function(t) {
  var n = t.direction, o = on({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return oe.createElement("div", { style: o.picker });
}, SEe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, v3 = function(t) {
  var n = t.rgb, o = t.hsl, s = t.width, l = t.height, u = t.onChange, p = t.direction, h = t.style, m = t.renderers, b = t.pointer, x = t.className, S = x === void 0 ? "" : x, R = on({
    default: {
      picker: {
        position: "relative",
        width: s,
        height: l
      },
      alpha: {
        radius: "2px",
        style: h
      }
    }
  });
  return oe.createElement(
    "div",
    { style: R.picker, className: "alpha-picker " + S },
    oe.createElement(cM, SEe({}, R.alpha, {
      rgb: n,
      hsl: o,
      pointer: b,
      renderers: m,
      onChange: u,
      direction: p
    }))
  );
};
v3.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: xEe
};
yi(v3);
function g3(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, s = Array(o); ++n < o; )
    s[n] = t(e[n], n, e);
  return s;
}
var CEe = "__lodash_hash_undefined__";
function wEe(e) {
  return this.__data__.set(e, CEe), this;
}
function TEe(e) {
  return this.__data__.has(e);
}
function hw(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Kc(); ++t < n; )
    this.add(e[t]);
}
hw.prototype.add = hw.prototype.push = wEe;
hw.prototype.has = TEe;
function EEe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function REe(e, t) {
  return e.has(t);
}
var OEe = 1, PEe = 2;
function y3(e, t, n, o, s, l) {
  var u = n & OEe, p = e.length, h = t.length;
  if (p != h && !(u && h > p))
    return !1;
  var m = l.get(e), b = l.get(t);
  if (m && b)
    return m == t && b == e;
  var x = -1, S = !0, R = n & PEe ? new hw() : void 0;
  for (l.set(e, t), l.set(t, e); ++x < p; ) {
    var T = e[x], E = t[x];
    if (o)
      var P = u ? o(E, T, x, t, e, l) : o(T, E, x, e, t, l);
    if (P !== void 0) {
      if (P)
        continue;
      S = !1;
      break;
    }
    if (R) {
      if (!EEe(t, function(k, _) {
        if (!REe(R, _) && (T === k || s(T, k, n, o, l)))
          return R.push(_);
      })) {
        S = !1;
        break;
      }
    } else if (!(T === E || s(T, E, n, o, l))) {
      S = !1;
      break;
    }
  }
  return l.delete(e), l.delete(t), S;
}
function $Ee(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o, s) {
    n[++t] = [s, o];
  }), n;
}
function DEe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var kEe = 1, MEe = 2, NEe = "[object Boolean]", IEe = "[object Date]", _Ee = "[object Error]", AEe = "[object Map]", LEe = "[object Number]", FEe = "[object RegExp]", jEe = "[object Set]", VEe = "[object String]", BEe = "[object Symbol]", zEe = "[object ArrayBuffer]", UEe = "[object DataView]", Kj = pd ? pd.prototype : void 0, T$ = Kj ? Kj.valueOf : void 0;
function HEe(e, t, n, o, s, l, u) {
  switch (n) {
    case UEe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case zEe:
      return !(e.byteLength != t.byteLength || !l(new uw(e), new uw(t)));
    case NEe:
    case IEe:
    case LEe:
      return B0(+e, +t);
    case _Ee:
      return e.name == t.name && e.message == t.message;
    case FEe:
    case VEe:
      return e == t + "";
    case AEe:
      var p = $Ee;
    case jEe:
      var h = o & kEe;
      if (p || (p = DEe), e.size != t.size && !h)
        return !1;
      var m = u.get(e);
      if (m)
        return m == t;
      o |= MEe, u.set(e, t);
      var b = y3(p(e), p(t), o, s, l, u);
      return u.delete(e), b;
    case BEe:
      if (T$)
        return T$.call(e) == T$.call(t);
  }
  return !1;
}
function WEe(e, t) {
  for (var n = -1, o = t.length, s = e.length; ++n < o; )
    e[s + n] = t[n];
  return e;
}
function qEe(e, t, n) {
  var o = t(e);
  return ji(e) ? o : WEe(o, n(e));
}
function YEe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, s = 0, l = []; ++n < o; ) {
    var u = e[n];
    t(u, n, e) && (l[s++] = u);
  }
  return l;
}
function GEe() {
  return [];
}
var KEe = Object.prototype, XEe = KEe.propertyIsEnumerable, Xj = Object.getOwnPropertySymbols, QEe = Xj ? function(e) {
  return e == null ? [] : (e = Object(e), YEe(Xj(e), function(t) {
    return XEe.call(e, t);
  }));
} : GEe;
function Qj(e) {
  return qEe(e, vM, QEe);
}
var JEe = 1, ZEe = Object.prototype, eRe = ZEe.hasOwnProperty;
function tRe(e, t, n, o, s, l) {
  var u = n & JEe, p = Qj(e), h = p.length, m = Qj(t), b = m.length;
  if (h != b && !u)
    return !1;
  for (var x = h; x--; ) {
    var S = p[x];
    if (!(u ? S in t : eRe.call(t, S)))
      return !1;
  }
  var R = l.get(e), T = l.get(t);
  if (R && T)
    return R == t && T == e;
  var E = !0;
  l.set(e, t), l.set(t, e);
  for (var P = u; ++x < h; ) {
    S = p[x];
    var k = e[S], _ = t[S];
    if (o)
      var L = u ? o(_, k, S, t, e, l) : o(k, _, S, e, t, l);
    if (!(L === void 0 ? k === _ || s(k, _, n, o, l) : L)) {
      E = !1;
      break;
    }
    P || (P = S == "constructor");
  }
  if (E && !P) {
    var F = e.constructor, N = t.constructor;
    F != N && "constructor" in e && "constructor" in t && !(typeof F == "function" && F instanceof F && typeof N == "function" && N instanceof N) && (E = !1);
  }
  return l.delete(e), l.delete(t), E;
}
var uD = vp(rl, "DataView"), dD = vp(rl, "Promise"), fD = vp(rl, "Set"), pD = vp(rl, "WeakMap"), Jj = "[object Map]", nRe = "[object Object]", Zj = "[object Promise]", eV = "[object Set]", tV = "[object WeakMap]", nV = "[object DataView]", rRe = mp(uD), oRe = mp(Zb), aRe = mp(dD), iRe = mp(fD), sRe = mp(pD), rd = hp;
(uD && rd(new uD(new ArrayBuffer(1))) != nV || Zb && rd(new Zb()) != Jj || dD && rd(dD.resolve()) != Zj || fD && rd(new fD()) != eV || pD && rd(new pD()) != tV) && (rd = function(e) {
  var t = hp(e), n = t == nRe ? e.constructor : void 0, o = n ? mp(n) : "";
  if (o)
    switch (o) {
      case rRe:
        return nV;
      case oRe:
        return Jj;
      case aRe:
        return Zj;
      case iRe:
        return eV;
      case sRe:
        return tV;
    }
  return t;
});
var lRe = 1, rV = "[object Arguments]", oV = "[object Array]", v1 = "[object Object]", cRe = Object.prototype, aV = cRe.hasOwnProperty;
function uRe(e, t, n, o, s, l) {
  var u = ji(e), p = ji(t), h = u ? oV : rd(e), m = p ? oV : rd(t);
  h = h == rV ? v1 : h, m = m == rV ? v1 : m;
  var b = h == v1, x = m == v1, S = h == m;
  if (S && fw(e)) {
    if (!fw(t))
      return !1;
    u = !0, b = !1;
  }
  if (S && !b)
    return l || (l = new zl()), u || hM(e) ? y3(e, t, n, o, s, l) : HEe(e, t, h, n, o, s, l);
  if (!(n & lRe)) {
    var R = b && aV.call(e, "__wrapped__"), T = x && aV.call(t, "__wrapped__");
    if (R || T) {
      var E = R ? e.value() : e, P = T ? t.value() : t;
      return l || (l = new zl()), s(E, P, n, o, l);
    }
  }
  return S ? (l || (l = new zl()), tRe(e, t, n, o, s, l)) : !1;
}
function yM(e, t, n, o, s) {
  return e === t ? !0 : e == null || t == null || !hd(e) && !hd(t) ? e !== e && t !== t : uRe(e, t, n, o, yM, s);
}
var dRe = 1, fRe = 2;
function pRe(e, t, n, o) {
  var s = n.length, l = s;
  if (e == null)
    return !l;
  for (e = Object(e); s--; ) {
    var u = n[s];
    if (u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++s < l; ) {
    u = n[s];
    var p = u[0], h = e[p], m = u[1];
    if (u[2]) {
      if (h === void 0 && !(p in e))
        return !1;
    } else {
      var b = new zl(), x;
      if (!(x === void 0 ? yM(m, h, dRe | fRe, o, b) : x))
        return !1;
    }
  }
  return !0;
}
function b3(e) {
  return e === e && !ps(e);
}
function hRe(e) {
  for (var t = vM(e), n = t.length; n--; ) {
    var o = t[n], s = e[o];
    t[n] = [o, s, b3(s)];
  }
  return t;
}
function x3(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function mRe(e) {
  var t = hRe(e);
  return t.length == 1 && t[0][2] ? x3(t[0][0], t[0][1]) : function(n) {
    return n === e || pRe(n, e, t);
  };
}
var vRe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, gRe = /^\w*$/;
function bM(e, t) {
  if (ji(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || MT(e) ? !0 : gRe.test(e) || !vRe.test(e) || t != null && e in Object(t);
}
var yRe = "Expected a function";
function xM(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(yRe);
  var n = function() {
    var o = arguments, s = t ? t.apply(this, o) : o[0], l = n.cache;
    if (l.has(s))
      return l.get(s);
    var u = e.apply(this, o);
    return n.cache = l.set(s, u) || l, u;
  };
  return n.cache = new (xM.Cache || Kc)(), n;
}
xM.Cache = Kc;
var bRe = 500;
function xRe(e) {
  var t = xM(e, function(o) {
    return n.size === bRe && n.clear(), o;
  }), n = t.cache;
  return t;
}
var SRe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, CRe = /\\(\\)?/g, wRe = xRe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(SRe, function(n, o, s, l) {
    t.push(s ? l.replace(CRe, "$1") : o || n);
  }), t;
}), TRe = 1 / 0, iV = pd ? pd.prototype : void 0, sV = iV ? iV.toString : void 0;
function S3(e) {
  if (typeof e == "string")
    return e;
  if (ji(e))
    return g3(e, S3) + "";
  if (MT(e))
    return sV ? sV.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -TRe ? "-0" : t;
}
function ERe(e) {
  return e == null ? "" : S3(e);
}
function C3(e, t) {
  return ji(e) ? e : bM(e, t) ? [e] : wRe(ERe(e));
}
var RRe = 1 / 0;
function _T(e) {
  if (typeof e == "string" || MT(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -RRe ? "-0" : t;
}
function w3(e, t) {
  t = C3(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[_T(t[n++])];
  return n && n == o ? e : void 0;
}
function ORe(e, t, n) {
  var o = e == null ? void 0 : w3(e, t);
  return o === void 0 ? n : o;
}
function PRe(e, t) {
  return e != null && t in Object(e);
}
function $Re(e, t, n) {
  t = C3(t, e);
  for (var o = -1, s = t.length, l = !1; ++o < s; ) {
    var u = _T(t[o]);
    if (!(l = e != null && n(e, u)))
      break;
    e = e[u];
  }
  return l || ++o != s ? l : (s = e == null ? 0 : e.length, !!s && pM(s) && mM(u, s) && (ji(e) || dw(e)));
}
function DRe(e, t) {
  return e != null && $Re(e, t, PRe);
}
var kRe = 1, MRe = 2;
function NRe(e, t) {
  return bM(e) && b3(t) ? x3(_T(e), t) : function(n) {
    var o = ORe(n, e);
    return o === void 0 && o === t ? DRe(n, e) : yM(t, o, kRe | MRe);
  };
}
function IRe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function _Re(e) {
  return function(t) {
    return w3(t, e);
  };
}
function ARe(e) {
  return bM(e) ? IRe(_T(e)) : _Re(e);
}
function LRe(e) {
  return typeof e == "function" ? e : e == null ? kT : typeof e == "object" ? ji(e) ? NRe(e[0], e[1]) : mRe(e) : ARe(e);
}
function FRe(e, t) {
  var n = -1, o = Lv(e) ? Array(e.length) : [];
  return p3(e, function(s, l, u) {
    o[++n] = t(s, l, u);
  }), o;
}
function yp(e, t) {
  var n = ji(e) ? g3 : FRe;
  return n(e, LRe(t));
}
var jRe = function(t) {
  var n = t.colors, o = t.onClick, s = t.onSwatchHover, l = on({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return oe.createElement(
    "div",
    { style: l.swatches },
    yp(n, function(u) {
      return oe.createElement(gp, {
        key: u,
        color: u,
        style: l.swatch,
        onClick: o,
        onHover: s,
        focusStyle: {
          boxShadow: "0 0 4px " + u
        }
      });
    }),
    oe.createElement("div", { style: l.clear })
  );
}, SM = function(t) {
  var n = t.onChange, o = t.onSwatchHover, s = t.hex, l = t.colors, u = t.width, p = t.triangle, h = t.styles, m = h === void 0 ? {} : h, b = t.className, x = b === void 0 ? "" : b, S = s === "transparent", R = function(P, k) {
    wd(P) && n({
      hex: P,
      source: "hex"
    }, k);
  }, T = on(gi({
    default: {
      card: {
        width: u,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: s,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: gM(s),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + s + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, m), { "hide-triangle": p === "hide" });
  return oe.createElement(
    "div",
    { style: T.card, className: "block-picker " + x },
    oe.createElement("div", { style: T.triangle }),
    oe.createElement(
      "div",
      { style: T.head },
      S && oe.createElement(_v, { borderRadius: "6px 6px 0 0" }),
      oe.createElement(
        "div",
        { style: T.label },
        s
      )
    ),
    oe.createElement(
      "div",
      { style: T.body },
      oe.createElement(jRe, { colors: l, onClick: R, onSwatchHover: o }),
      oe.createElement(Sn, {
        style: { input: T.input },
        value: s,
        onChange: R
      })
    )
  );
};
SM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  colors: r.arrayOf(r.string),
  triangle: r.oneOf(["top", "hide"]),
  styles: r.object
};
SM.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
yi(SM);
var km = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, Mm = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, Nm = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, Im = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, _m = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, Am = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, Lm = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, Fm = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, jm = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, bb = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, Vm = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, Bm = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, zm = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, Um = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, Hm = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, Wm = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, qm = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, Ym = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, T3 = function(t) {
  var n = t.color, o = t.onClick, s = t.onSwatchHover, l = t.hover, u = t.active, p = t.circleSize, h = t.circleSpacing, m = on({
    default: {
      swatch: {
        width: p,
        height: p,
        marginRight: h,
        marginBottom: h,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (p / 2 + 1) + "px " + n,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + n
      }
    }
  }, { hover: l, active: u });
  return oe.createElement(
    "div",
    { style: m.swatch },
    oe.createElement(gp, {
      style: m.Swatch,
      color: n,
      onClick: o,
      onHover: s,
      focusStyle: { boxShadow: m.Swatch.boxShadow + ", 0 0 5px " + n }
    })
  );
};
T3.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const VRe = lM(T3);
var CM = function(t) {
  var n = t.width, o = t.onChange, s = t.onSwatchHover, l = t.colors, u = t.hex, p = t.circleSize, h = t.styles, m = h === void 0 ? {} : h, b = t.circleSpacing, x = t.className, S = x === void 0 ? "" : x, R = on(gi({
    default: {
      card: {
        width: n,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -b,
        marginBottom: -b
      }
    }
  }, m)), T = function(P, k) {
    return o({ hex: P, source: "hex" }, k);
  };
  return oe.createElement(
    "div",
    { style: R.card, className: "circle-picker " + S },
    yp(l, function(E) {
      return oe.createElement(VRe, {
        key: E,
        color: E,
        onClick: T,
        onSwatchHover: s,
        active: u === E.toLowerCase(),
        circleSize: p,
        circleSpacing: b
      });
    })
  );
};
CM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  circleSize: r.number,
  circleSpacing: r.number,
  styles: r.object
};
CM.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [km[500], Mm[500], Nm[500], Im[500], _m[500], Am[500], Lm[500], Fm[500], jm[500], bb[500], Vm[500], Bm[500], zm[500], Um[500], Hm[500], Wm[500], qm[500], Ym[500]],
  styles: {}
};
yi(CM);
function lV(e) {
  return e === void 0;
}
var E3 = {};
Object.defineProperty(E3, "__esModule", {
  value: !0
});
var cV = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, BRe = oe, uV = zRe(BRe);
function zRe(e) {
  return e && e.__esModule ? e : { default: e };
}
function URe(e, t) {
  var n = {};
  for (var o in e)
    t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
  return n;
}
var g1 = 24, HRe = E3.default = function(e) {
  var t = e.fill, n = t === void 0 ? "currentColor" : t, o = e.width, s = o === void 0 ? g1 : o, l = e.height, u = l === void 0 ? g1 : l, p = e.style, h = p === void 0 ? {} : p, m = URe(e, ["fill", "width", "height", "style"]);
  return uV.default.createElement(
    "svg",
    cV({
      viewBox: "0 0 " + g1 + " " + g1,
      style: cV({ fill: n, width: s, height: u }, h)
    }, m),
    uV.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, WRe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function qRe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function YRe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function GRe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var R3 = function(e) {
  GRe(t, e);
  function t(n) {
    qRe(this, t);
    var o = YRe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return o.toggleViews = function() {
      o.state.view === "hex" ? o.setState({ view: "rgb" }) : o.state.view === "rgb" ? o.setState({ view: "hsl" }) : o.state.view === "hsl" && (o.props.hsl.a === 1 ? o.setState({ view: "hex" }) : o.setState({ view: "rgb" }));
    }, o.handleChange = function(s, l) {
      s.hex ? wd(s.hex) && o.props.onChange({
        hex: s.hex,
        source: "hex"
      }, l) : s.r || s.g || s.b ? o.props.onChange({
        r: s.r || o.props.rgb.r,
        g: s.g || o.props.rgb.g,
        b: s.b || o.props.rgb.b,
        source: "rgb"
      }, l) : s.a ? (s.a < 0 ? s.a = 0 : s.a > 1 && (s.a = 1), o.props.onChange({
        h: o.props.hsl.h,
        s: o.props.hsl.s,
        l: o.props.hsl.l,
        a: Math.round(s.a * 100) / 100,
        source: "rgb"
      }, l)) : (s.h || s.s || s.l) && (typeof s.s == "string" && s.s.includes("%") && (s.s = s.s.replace("%", "")), typeof s.l == "string" && s.l.includes("%") && (s.l = s.l.replace("%", "")), s.s == 1 ? s.s = 0.01 : s.l == 1 && (s.l = 0.01), o.props.onChange({
        h: s.h || o.props.hsl.h,
        s: Number(lV(s.s) ? o.props.hsl.s : s.s),
        l: Number(lV(s.l) ? o.props.hsl.l : s.l),
        source: "hsl"
      }, l));
    }, o.showHighlight = function(s) {
      s.currentTarget.style.background = "#eee";
    }, o.hideHighlight = function(s) {
      s.currentTarget.style.background = "transparent";
    }, n.hsl.a !== 1 && n.view === "hex" ? o.state = {
      view: "rgb"
    } : o.state = {
      view: n.view
    }, o;
  }
  return WRe(t, [{
    key: "render",
    value: function() {
      var o = this, s = on({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), l = void 0;
      return this.state.view === "hex" ? l = oe.createElement(
        "div",
        { style: s.fields, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? l = oe.createElement(
        "div",
        { style: s.fields, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.alpha },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (l = oe.createElement(
        "div",
        { style: s.fields, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.field },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        oe.createElement(
          "div",
          { style: s.alpha },
          oe.createElement(Sn, {
            style: { input: s.input, label: s.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), oe.createElement(
        "div",
        { style: s.wrap, className: "flexbox-fix" },
        l,
        oe.createElement(
          "div",
          { style: s.toggle },
          oe.createElement(
            "div",
            { style: s.icon, onClick: this.toggleViews, ref: function(p) {
              return o.icon = p;
            } },
            oe.createElement(HRe, {
              style: s.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, s) {
      return o.hsl.a !== 1 && s.view === "hex" ? { view: "rgb" } : null;
    }
  }]), t;
}(oe.Component);
R3.defaultProps = {
  view: "hex"
};
var dV = function() {
  var t = on({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return oe.createElement("div", { style: t.picker });
}, KRe = function() {
  var t = on({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return oe.createElement("div", { style: t.picker });
}, wM = function(t) {
  var n = t.width, o = t.onChange, s = t.disableAlpha, l = t.rgb, u = t.hsl, p = t.hsv, h = t.hex, m = t.renderers, b = t.styles, x = b === void 0 ? {} : b, S = t.className, R = S === void 0 ? "" : S, T = t.defaultView, E = on(gi({
    default: {
      picker: {
        width: n,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + l.r + ", " + l.g + ", " + l.b + ", " + l.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, x), { disableAlpha: s });
  return oe.createElement(
    "div",
    { style: E.picker, className: "chrome-picker " + R },
    oe.createElement(
      "div",
      { style: E.saturation },
      oe.createElement(NT, {
        style: E.Saturation,
        hsl: u,
        hsv: p,
        pointer: KRe,
        onChange: o
      })
    ),
    oe.createElement(
      "div",
      { style: E.body },
      oe.createElement(
        "div",
        { style: E.controls, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: E.color },
          oe.createElement(
            "div",
            { style: E.swatch },
            oe.createElement("div", { style: E.active }),
            oe.createElement(_v, { renderers: m })
          )
        ),
        oe.createElement(
          "div",
          { style: E.toggles },
          oe.createElement(
            "div",
            { style: E.hue },
            oe.createElement(Av, {
              style: E.Hue,
              hsl: u,
              pointer: dV,
              onChange: o
            })
          ),
          oe.createElement(
            "div",
            { style: E.alpha },
            oe.createElement(cM, {
              style: E.Alpha,
              rgb: l,
              hsl: u,
              pointer: dV,
              renderers: m,
              onChange: o
            })
          )
        )
      ),
      oe.createElement(R3, {
        rgb: l,
        hsl: u,
        hex: h,
        view: T,
        onChange: o,
        disableAlpha: s
      })
    )
  );
};
wM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  disableAlpha: r.bool,
  styles: r.object,
  defaultView: r.oneOf(["hex", "rgb", "hsl"])
};
wM.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
yi(wM);
var XRe = function(t) {
  var n = t.color, o = t.onClick, s = o === void 0 ? function() {
  } : o, l = t.onSwatchHover, u = t.active, p = on({
    default: {
      color: {
        background: n,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: gM(n),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: u, "color-#FFFFFF": n === "#FFFFFF", transparent: n === "transparent" });
  return oe.createElement(
    gp,
    {
      style: p.color,
      color: n,
      onClick: s,
      onHover: l,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    oe.createElement("div", { style: p.dot })
  );
}, QRe = function(t) {
  var n = t.hex, o = t.rgb, s = t.onChange, l = on({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: n
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), u = function(h, m) {
    h.r || h.g || h.b ? s({
      r: h.r || o.r,
      g: h.g || o.g,
      b: h.b || o.b,
      source: "rgb"
    }, m) : s({
      hex: h.hex,
      source: "hex"
    }, m);
  };
  return oe.createElement(
    "div",
    { style: l.fields, className: "flexbox-fix" },
    oe.createElement("div", { style: l.active }),
    oe.createElement(Sn, {
      style: { wrap: l.HEXwrap, input: l.HEXinput, label: l.HEXlabel },
      label: "hex",
      value: n,
      onChange: u
    }),
    oe.createElement(Sn, {
      style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
      label: "r",
      value: o.r,
      onChange: u
    }),
    oe.createElement(Sn, {
      style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
      label: "g",
      value: o.g,
      onChange: u
    }),
    oe.createElement(Sn, {
      style: { wrap: l.RGBwrap, input: l.RGBinput, label: l.RGBlabel },
      label: "b",
      value: o.b,
      onChange: u
    })
  );
}, TM = function(t) {
  var n = t.onChange, o = t.onSwatchHover, s = t.colors, l = t.hex, u = t.rgb, p = t.styles, h = p === void 0 ? {} : p, m = t.className, b = m === void 0 ? "" : m, x = on(gi({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, h)), S = function(T, E) {
    T.hex ? wd(T.hex) && n({
      hex: T.hex,
      source: "hex"
    }, E) : n(T, E);
  };
  return oe.createElement(
    z0,
    { style: x.Compact, styles: h },
    oe.createElement(
      "div",
      { style: x.compact, className: "compact-picker " + b },
      oe.createElement(
        "div",
        null,
        yp(s, function(R) {
          return oe.createElement(XRe, {
            key: R,
            color: R,
            active: R.toLowerCase() === l,
            onClick: S,
            onSwatchHover: o
          });
        }),
        oe.createElement("div", { style: x.clear })
      ),
      oe.createElement(QRe, { hex: l, rgb: u, onChange: S })
    )
  );
};
TM.propTypes = {
  colors: r.arrayOf(r.string),
  styles: r.object
};
TM.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
yi(TM);
var JRe = function(t) {
  var n = t.hover, o = t.color, s = t.onClick, l = t.onSwatchHover, u = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, p = on({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: u
    }
  }, { hover: n });
  return oe.createElement(
    "div",
    { style: p.swatch },
    oe.createElement(gp, {
      color: o,
      onClick: s,
      onHover: l,
      focusStyle: u
    })
  );
};
const ZRe = lM(JRe);
var EM = function(t) {
  var n = t.width, o = t.colors, s = t.onChange, l = t.onSwatchHover, u = t.triangle, p = t.styles, h = p === void 0 ? {} : p, m = t.className, b = m === void 0 ? "" : m, x = on(gi({
    default: {
      card: {
        width: n,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, h), {
    "hide-triangle": u === "hide",
    "top-left-triangle": u === "top-left",
    "top-right-triangle": u === "top-right",
    "bottom-left-triangle": u === "bottom-left",
    "bottom-right-triangle": u === "bottom-right"
  }), S = function(T, E) {
    return s({ hex: T, source: "hex" }, E);
  };
  return oe.createElement(
    "div",
    { style: x.card, className: "github-picker " + b },
    oe.createElement("div", { style: x.triangleShadow }),
    oe.createElement("div", { style: x.triangle }),
    yp(o, function(R) {
      return oe.createElement(ZRe, {
        color: R,
        key: R,
        onClick: S,
        onSwatchHover: l
      });
    })
  );
};
EM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  colors: r.arrayOf(r.string),
  triangle: r.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: r.object
};
EM.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
yi(EM);
var eOe = function(t) {
  var n = t.direction, o = on({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: n === "vertical" });
  return oe.createElement("div", { style: o.picker });
}, tOe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, RM = function(t) {
  var n = t.width, o = t.height, s = t.onChange, l = t.hsl, u = t.direction, p = t.pointer, h = t.styles, m = h === void 0 ? {} : h, b = t.className, x = b === void 0 ? "" : b, S = on(gi({
    default: {
      picker: {
        position: "relative",
        width: n,
        height: o
      },
      hue: {
        radius: "2px"
      }
    }
  }, m)), R = function(E) {
    return s({ a: 1, h: E.h, l: 0.5, s: 1 });
  };
  return oe.createElement(
    "div",
    { style: S.picker, className: "hue-picker " + x },
    oe.createElement(Av, tOe({}, S.hue, {
      hsl: l,
      pointer: p,
      onChange: R,
      direction: u
    }))
  );
};
RM.propTypes = {
  styles: r.object
};
RM.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: eOe,
  styles: {}
};
yi(RM);
var nOe = function(t) {
  var n = t.onChange, o = t.hex, s = t.rgb, l = t.styles, u = l === void 0 ? {} : l, p = t.className, h = p === void 0 ? "" : p, m = on(gi({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + o,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, u)), b = function(S, R) {
    S.hex ? wd(S.hex) && n({
      hex: S.hex,
      source: "hex"
    }, R) : (S.r || S.g || S.b) && n({
      r: S.r || s.r,
      g: S.g || s.g,
      b: S.b || s.b,
      source: "rgb"
    }, R);
  };
  return oe.createElement(
    z0,
    { styles: u },
    oe.createElement(
      "div",
      { style: m.material, className: "material-picker " + h },
      oe.createElement(Sn, {
        style: { wrap: m.HEXwrap, input: m.HEXinput, label: m.HEXlabel },
        label: "hex",
        value: o,
        onChange: b
      }),
      oe.createElement(
        "div",
        { style: m.split, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: m.third },
          oe.createElement(Sn, {
            style: { wrap: m.RGBwrap, input: m.RGBinput, label: m.RGBlabel },
            label: "r",
            value: s.r,
            onChange: b
          })
        ),
        oe.createElement(
          "div",
          { style: m.third },
          oe.createElement(Sn, {
            style: { wrap: m.RGBwrap, input: m.RGBinput, label: m.RGBlabel },
            label: "g",
            value: s.g,
            onChange: b
          })
        ),
        oe.createElement(
          "div",
          { style: m.third },
          oe.createElement(Sn, {
            style: { wrap: m.RGBwrap, input: m.RGBinput, label: m.RGBlabel },
            label: "b",
            value: s.b,
            onChange: b
          })
        )
      )
    )
  );
};
yi(nOe);
var rOe = function(t) {
  var n = t.onChange, o = t.rgb, s = t.hsv, l = t.hex, u = on({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), p = function(m, b) {
    m["#"] ? wd(m["#"]) && n({
      hex: m["#"],
      source: "hex"
    }, b) : m.r || m.g || m.b ? n({
      r: m.r || o.r,
      g: m.g || o.g,
      b: m.b || o.b,
      source: "rgb"
    }, b) : (m.h || m.s || m.v) && n({
      h: m.h || s.h,
      s: m.s || s.s,
      v: m.v || s.v,
      source: "hsv"
    }, b);
  };
  return oe.createElement(
    "div",
    { style: u.fields },
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "h",
      value: Math.round(s.h),
      onChange: p
    }),
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "s",
      value: Math.round(s.s * 100),
      onChange: p
    }),
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "v",
      value: Math.round(s.v * 100),
      onChange: p
    }),
    oe.createElement("div", { style: u.divider }),
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "r",
      value: o.r,
      onChange: p
    }),
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "g",
      value: o.g,
      onChange: p
    }),
    oe.createElement(Sn, {
      style: { wrap: u.RGBwrap, input: u.RGBinput, label: u.RGBlabel },
      label: "b",
      value: o.b,
      onChange: p
    }),
    oe.createElement("div", { style: u.divider }),
    oe.createElement(Sn, {
      style: { wrap: u.HEXwrap, input: u.HEXinput, label: u.HEXlabel },
      label: "#",
      value: l.replace("#", ""),
      onChange: p
    }),
    oe.createElement(
      "div",
      { style: u.fieldSymbols },
      oe.createElement(
        "div",
        { style: u.symbol },
        "°"
      ),
      oe.createElement(
        "div",
        { style: u.symbol },
        "%"
      ),
      oe.createElement(
        "div",
        { style: u.symbol },
        "%"
      )
    )
  );
}, oOe = function(t) {
  var n = t.hsl, o = on({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": n.l > 0.5 });
  return oe.createElement("div", { style: o.picker });
}, aOe = function() {
  var t = on({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return oe.createElement(
    "div",
    { style: t.pointer },
    oe.createElement(
      "div",
      { style: t.left },
      oe.createElement("div", { style: t.leftInside })
    ),
    oe.createElement(
      "div",
      { style: t.right },
      oe.createElement("div", { style: t.rightInside })
    )
  );
}, fV = function(t) {
  var n = t.onClick, o = t.label, s = t.children, l = t.active, u = on({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: l });
  return oe.createElement(
    "div",
    { style: u.button, onClick: n },
    o || s
  );
}, iOe = function(t) {
  var n = t.rgb, o = t.currentColor, s = on({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + n.r + "," + n.g + ", " + n.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: o,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return oe.createElement(
    "div",
    null,
    oe.createElement(
      "div",
      { style: s.label },
      "new"
    ),
    oe.createElement(
      "div",
      { style: s.swatches },
      oe.createElement("div", { style: s.new }),
      oe.createElement("div", { style: s.current })
    ),
    oe.createElement(
      "div",
      { style: s.label },
      "current"
    )
  );
}, sOe = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var o = 0; o < n.length; o++) {
      var s = n[o];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  return function(t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();
function lOe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cOe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function uOe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var OM = function(e) {
  uOe(t, e);
  function t(n) {
    lOe(this, t);
    var o = cOe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
    return o.state = {
      currentColor: n.hex
    }, o;
  }
  return sOe(t, [{
    key: "render",
    value: function() {
      var o = this.props, s = o.styles, l = s === void 0 ? {} : s, u = o.className, p = u === void 0 ? "" : u, h = on(gi({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, l));
      return oe.createElement(
        "div",
        { style: h.picker, className: "photoshop-picker " + p },
        oe.createElement(
          "div",
          { style: h.head },
          this.props.header
        ),
        oe.createElement(
          "div",
          { style: h.body, className: "flexbox-fix" },
          oe.createElement(
            "div",
            { style: h.saturation },
            oe.createElement(NT, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: oOe,
              onChange: this.props.onChange
            })
          ),
          oe.createElement(
            "div",
            { style: h.hue },
            oe.createElement(Av, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: aOe,
              onChange: this.props.onChange
            })
          ),
          oe.createElement(
            "div",
            { style: h.controls },
            oe.createElement(
              "div",
              { style: h.top, className: "flexbox-fix" },
              oe.createElement(
                "div",
                { style: h.previews },
                oe.createElement(iOe, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              oe.createElement(
                "div",
                { style: h.actions },
                oe.createElement(fV, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                oe.createElement(fV, { label: "Cancel", onClick: this.props.onCancel }),
                oe.createElement(rOe, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), t;
}(oe.Component);
OM.propTypes = {
  header: r.string,
  styles: r.object
};
OM.defaultProps = {
  header: "Color Picker",
  styles: {}
};
yi(OM);
var dOe = function(t) {
  var n = t.onChange, o = t.rgb, s = t.hsl, l = t.hex, u = t.disableAlpha, p = on({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: u }), h = function(b, x) {
    b.hex ? wd(b.hex) && n({
      hex: b.hex,
      source: "hex"
    }, x) : b.r || b.g || b.b ? n({
      r: b.r || o.r,
      g: b.g || o.g,
      b: b.b || o.b,
      a: o.a,
      source: "rgb"
    }, x) : b.a && (b.a < 0 ? b.a = 0 : b.a > 100 && (b.a = 100), b.a /= 100, n({
      h: s.h,
      s: s.s,
      l: s.l,
      a: b.a,
      source: "rgb"
    }, x));
  };
  return oe.createElement(
    "div",
    { style: p.fields, className: "flexbox-fix" },
    oe.createElement(
      "div",
      { style: p.double },
      oe.createElement(Sn, {
        style: { input: p.input, label: p.label },
        label: "hex",
        value: l.replace("#", ""),
        onChange: h
      })
    ),
    oe.createElement(
      "div",
      { style: p.single },
      oe.createElement(Sn, {
        style: { input: p.input, label: p.label },
        label: "r",
        value: o.r,
        onChange: h,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    oe.createElement(
      "div",
      { style: p.single },
      oe.createElement(Sn, {
        style: { input: p.input, label: p.label },
        label: "g",
        value: o.g,
        onChange: h,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    oe.createElement(
      "div",
      { style: p.single },
      oe.createElement(Sn, {
        style: { input: p.input, label: p.label },
        label: "b",
        value: o.b,
        onChange: h,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    oe.createElement(
      "div",
      { style: p.alpha },
      oe.createElement(Sn, {
        style: { input: p.input, label: p.label },
        label: "a",
        value: Math.round(o.a * 100),
        onChange: h,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, fOe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, O3 = function(t) {
  var n = t.colors, o = t.onClick, s = o === void 0 ? function() {
  } : o, l = t.onSwatchHover, u = on({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !n || !n.length
  }), p = function(m, b) {
    s({
      hex: m,
      source: "hex"
    }, b);
  };
  return oe.createElement(
    "div",
    { style: u.colors, className: "flexbox-fix" },
    n.map(function(h) {
      var m = typeof h == "string" ? { color: h } : h, b = "" + m.color + (m.title || "");
      return oe.createElement(
        "div",
        { key: b, style: u.swatchWrap },
        oe.createElement(gp, fOe({}, m, {
          style: u.swatch,
          onClick: p,
          onHover: l,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + m.color
          }
        }))
      );
    })
  );
};
O3.propTypes = {
  colors: r.arrayOf(r.oneOfType([r.string, r.shape({
    color: r.string,
    title: r.string
  })])).isRequired
};
var pOe = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, PM = function(t) {
  var n = t.width, o = t.rgb, s = t.hex, l = t.hsv, u = t.hsl, p = t.onChange, h = t.onSwatchHover, m = t.disableAlpha, b = t.presetColors, x = t.renderers, S = t.styles, R = S === void 0 ? {} : S, T = t.className, E = T === void 0 ? "" : T, P = on(gi({
    default: pOe({
      picker: {
        width: n,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + o.r + "," + o.g + "," + o.b + "," + o.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, R),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, R), { disableAlpha: m });
  return oe.createElement(
    "div",
    { style: P.picker, className: "sketch-picker " + E },
    oe.createElement(
      "div",
      { style: P.saturation },
      oe.createElement(NT, {
        style: P.Saturation,
        hsl: u,
        hsv: l,
        onChange: p
      })
    ),
    oe.createElement(
      "div",
      { style: P.controls, className: "flexbox-fix" },
      oe.createElement(
        "div",
        { style: P.sliders },
        oe.createElement(
          "div",
          { style: P.hue },
          oe.createElement(Av, {
            style: P.Hue,
            hsl: u,
            onChange: p
          })
        ),
        oe.createElement(
          "div",
          { style: P.alpha },
          oe.createElement(cM, {
            style: P.Alpha,
            rgb: o,
            hsl: u,
            renderers: x,
            onChange: p
          })
        )
      ),
      oe.createElement(
        "div",
        { style: P.color },
        oe.createElement(_v, null),
        oe.createElement("div", { style: P.activeColor })
      )
    ),
    oe.createElement(dOe, {
      rgb: o,
      hsl: u,
      hex: s,
      onChange: p,
      disableAlpha: m
    }),
    oe.createElement(O3, {
      colors: b,
      onClick: p,
      onSwatchHover: h
    })
  );
};
PM.propTypes = {
  disableAlpha: r.bool,
  width: r.oneOfType([r.string, r.number]),
  styles: r.object
};
PM.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const hOe = yi(PM);
var ub = function(t) {
  var n = t.hsl, o = t.offset, s = t.onClick, l = s === void 0 ? function() {
  } : s, u = t.active, p = t.first, h = t.last, m = on({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + n.h + ", 50%, " + o * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: u, first: p, last: h }), b = function(S) {
    return l({
      h: n.h,
      s: 0.5,
      l: o,
      source: "hsl"
    }, S);
  };
  return oe.createElement("div", { style: m.swatch, onClick: b });
}, mOe = function(t) {
  var n = t.onClick, o = t.hsl, s = on({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), l = 0.1;
  return oe.createElement(
    "div",
    { style: s.swatches },
    oe.createElement(
      "div",
      { style: s.swatch },
      oe.createElement(ub, {
        hsl: o,
        offset: ".80",
        active: Math.abs(o.l - 0.8) < l && Math.abs(o.s - 0.5) < l,
        onClick: n,
        first: !0
      })
    ),
    oe.createElement(
      "div",
      { style: s.swatch },
      oe.createElement(ub, {
        hsl: o,
        offset: ".65",
        active: Math.abs(o.l - 0.65) < l && Math.abs(o.s - 0.5) < l,
        onClick: n
      })
    ),
    oe.createElement(
      "div",
      { style: s.swatch },
      oe.createElement(ub, {
        hsl: o,
        offset: ".50",
        active: Math.abs(o.l - 0.5) < l && Math.abs(o.s - 0.5) < l,
        onClick: n
      })
    ),
    oe.createElement(
      "div",
      { style: s.swatch },
      oe.createElement(ub, {
        hsl: o,
        offset: ".35",
        active: Math.abs(o.l - 0.35) < l && Math.abs(o.s - 0.5) < l,
        onClick: n
      })
    ),
    oe.createElement(
      "div",
      { style: s.swatch },
      oe.createElement(ub, {
        hsl: o,
        offset: ".20",
        active: Math.abs(o.l - 0.2) < l && Math.abs(o.s - 0.5) < l,
        onClick: n,
        last: !0
      })
    ),
    oe.createElement("div", { style: s.clear })
  );
}, vOe = function() {
  var t = on({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return oe.createElement("div", { style: t.picker });
}, $M = function(t) {
  var n = t.hsl, o = t.onChange, s = t.pointer, l = t.styles, u = l === void 0 ? {} : l, p = t.className, h = p === void 0 ? "" : p, m = on(gi({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, u));
  return oe.createElement(
    "div",
    { style: m.wrap || {}, className: "slider-picker " + h },
    oe.createElement(
      "div",
      { style: m.hue },
      oe.createElement(Av, {
        style: m.Hue,
        hsl: n,
        pointer: s,
        onChange: o
      })
    ),
    oe.createElement(
      "div",
      { style: m.swatches },
      oe.createElement(mOe, { hsl: n, onClick: o })
    )
  );
};
$M.propTypes = {
  styles: r.object
};
$M.defaultProps = {
  pointer: vOe,
  styles: {}
};
yi($M);
var P3 = {};
Object.defineProperty(P3, "__esModule", {
  value: !0
});
var pV = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }
  return e;
}, gOe = oe, hV = yOe(gOe);
function yOe(e) {
  return e && e.__esModule ? e : { default: e };
}
function bOe(e, t) {
  var n = {};
  for (var o in e)
    t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
  return n;
}
var y1 = 24, xOe = P3.default = function(e) {
  var t = e.fill, n = t === void 0 ? "currentColor" : t, o = e.width, s = o === void 0 ? y1 : o, l = e.height, u = l === void 0 ? y1 : l, p = e.style, h = p === void 0 ? {} : p, m = bOe(e, ["fill", "width", "height", "style"]);
  return hV.default.createElement(
    "svg",
    pV({
      viewBox: "0 0 " + y1 + " " + y1,
      style: pV({ fill: n, width: s, height: u }, h)
    }, m),
    hV.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, SOe = function(t) {
  var n = t.color, o = t.onClick, s = o === void 0 ? function() {
  } : o, l = t.onSwatchHover, u = t.first, p = t.last, h = t.active, m = on({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: n,
        marginBottom: "1px"
      },
      check: {
        color: gM(n),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: u,
    last: p,
    active: h,
    "color-#FFFFFF": n === "#FFFFFF",
    transparent: n === "transparent"
  });
  return oe.createElement(
    gp,
    {
      color: n,
      style: m.color,
      onClick: s,
      onHover: l,
      focusStyle: { boxShadow: "0 0 4px " + n }
    },
    oe.createElement(
      "div",
      { style: m.check },
      oe.createElement(xOe, null)
    )
  );
}, COe = function(t) {
  var n = t.onClick, o = t.onSwatchHover, s = t.group, l = t.active, u = on({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return oe.createElement(
    "div",
    { style: u.group },
    yp(s, function(p, h) {
      return oe.createElement(SOe, {
        key: p,
        color: p,
        active: p.toLowerCase() === l,
        first: h === 0,
        last: h === s.length - 1,
        onClick: n,
        onSwatchHover: o
      });
    })
  );
}, DM = function(t) {
  var n = t.width, o = t.height, s = t.onChange, l = t.onSwatchHover, u = t.colors, p = t.hex, h = t.styles, m = h === void 0 ? {} : h, b = t.className, x = b === void 0 ? "" : b, S = on(gi({
    default: {
      picker: {
        width: n,
        height: o
      },
      overflow: {
        height: o,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, m)), R = function(E, P) {
    return s({ hex: E, source: "hex" }, P);
  };
  return oe.createElement(
    "div",
    { style: S.picker, className: "swatches-picker " + x },
    oe.createElement(
      z0,
      null,
      oe.createElement(
        "div",
        { style: S.overflow },
        oe.createElement(
          "div",
          { style: S.body },
          yp(u, function(T) {
            return oe.createElement(COe, {
              key: T.toString(),
              group: T,
              active: p,
              onClick: R,
              onSwatchHover: l
            });
          }),
          oe.createElement("div", { style: S.clear })
        )
      )
    )
  );
};
DM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  height: r.oneOfType([r.string, r.number]),
  colors: r.arrayOf(r.arrayOf(r.string)),
  styles: r.object
  /* eslint-disable max-len */
};
DM.defaultProps = {
  width: 320,
  height: 240,
  colors: [[km[900], km[700], km[500], km[300], km[100]], [Mm[900], Mm[700], Mm[500], Mm[300], Mm[100]], [Nm[900], Nm[700], Nm[500], Nm[300], Nm[100]], [Im[900], Im[700], Im[500], Im[300], Im[100]], [_m[900], _m[700], _m[500], _m[300], _m[100]], [Am[900], Am[700], Am[500], Am[300], Am[100]], [Lm[900], Lm[700], Lm[500], Lm[300], Lm[100]], [Fm[900], Fm[700], Fm[500], Fm[300], Fm[100]], [jm[900], jm[700], jm[500], jm[300], jm[100]], ["#194D33", bb[700], bb[500], bb[300], bb[100]], [Vm[900], Vm[700], Vm[500], Vm[300], Vm[100]], [Bm[900], Bm[700], Bm[500], Bm[300], Bm[100]], [zm[900], zm[700], zm[500], zm[300], zm[100]], [Um[900], Um[700], Um[500], Um[300], Um[100]], [Hm[900], Hm[700], Hm[500], Hm[300], Hm[100]], [Wm[900], Wm[700], Wm[500], Wm[300], Wm[100]], [qm[900], qm[700], qm[500], qm[300], qm[100]], [Ym[900], Ym[700], Ym[500], Ym[300], Ym[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
yi(DM);
var kM = function(t) {
  var n = t.onChange, o = t.onSwatchHover, s = t.hex, l = t.colors, u = t.width, p = t.triangle, h = t.styles, m = h === void 0 ? {} : h, b = t.className, x = b === void 0 ? "" : b, S = on(gi({
    default: {
      card: {
        width: u,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, m), {
    "hide-triangle": p === "hide",
    "top-left-triangle": p === "top-left",
    "top-right-triangle": p === "top-right"
  }), R = function(E, P) {
    wd(E) && n({
      hex: E,
      source: "hex"
    }, P);
  };
  return oe.createElement(
    "div",
    { style: S.card, className: "twitter-picker " + x },
    oe.createElement("div", { style: S.triangleShadow }),
    oe.createElement("div", { style: S.triangle }),
    oe.createElement(
      "div",
      { style: S.body },
      yp(l, function(T, E) {
        return oe.createElement(gp, {
          key: E,
          color: T,
          hex: T,
          style: S.swatch,
          onClick: R,
          onHover: o,
          focusStyle: {
            boxShadow: "0 0 4px " + T
          }
        });
      }),
      oe.createElement(
        "div",
        { style: S.hash },
        "#"
      ),
      oe.createElement(Sn, {
        label: null,
        style: { input: S.input },
        value: s.replace("#", ""),
        onChange: R
      }),
      oe.createElement("div", { style: S.clear })
    )
  );
};
kM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  triangle: r.oneOf(["hide", "top-left", "top-right"]),
  colors: r.arrayOf(r.string),
  styles: r.object
};
kM.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
yi(kM);
var MM = function(t) {
  var n = on({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", " + Math.round(t.hsl.s * 100) + "%, " + Math.round(t.hsl.l * 100) + "%)"
      }
    }
  });
  return oe.createElement("div", { style: n.picker });
};
MM.propTypes = {
  hsl: r.shape({
    h: r.number,
    s: r.number,
    l: r.number,
    a: r.number
  })
};
MM.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var NM = function(t) {
  var n = on({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(t.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return oe.createElement("div", { style: n.picker });
};
NM.propTypes = {
  hsl: r.shape({
    h: r.number,
    s: r.number,
    l: r.number,
    a: r.number
  })
};
NM.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var wOe = function(t) {
  var n = t.onChange, o = t.rgb, s = t.hsl, l = t.hex, u = t.hsv, p = function(R, T) {
    if (R.hex)
      wd(R.hex) && n({
        hex: R.hex,
        source: "hex"
      }, T);
    else if (R.rgb) {
      var E = R.rgb.split(",");
      w$(R.rgb, "rgb") && n({
        r: E[0],
        g: E[1],
        b: E[2],
        a: 1,
        source: "rgb"
      }, T);
    } else if (R.hsv) {
      var P = R.hsv.split(",");
      w$(R.hsv, "hsv") && (P[2] = P[2].replace("%", ""), P[1] = P[1].replace("%", ""), P[0] = P[0].replace("°", ""), P[1] == 1 ? P[1] = 0.01 : P[2] == 1 && (P[2] = 0.01), n({
        h: Number(P[0]),
        s: Number(P[1]),
        v: Number(P[2]),
        source: "hsv"
      }, T));
    } else if (R.hsl) {
      var k = R.hsl.split(",");
      w$(R.hsl, "hsl") && (k[2] = k[2].replace("%", ""), k[1] = k[1].replace("%", ""), k[0] = k[0].replace("°", ""), x[1] == 1 ? x[1] = 0.01 : x[2] == 1 && (x[2] = 0.01), n({
        h: Number(k[0]),
        s: Number(k[1]),
        v: Number(k[2]),
        source: "hsl"
      }, T));
    }
  }, h = on({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), m = o.r + ", " + o.g + ", " + o.b, b = Math.round(s.h) + "°, " + Math.round(s.s * 100) + "%, " + Math.round(s.l * 100) + "%", x = Math.round(u.h) + "°, " + Math.round(u.s * 100) + "%, " + Math.round(u.v * 100) + "%";
  return oe.createElement(
    "div",
    { style: h.wrap, className: "flexbox-fix" },
    oe.createElement(
      "div",
      { style: h.fields },
      oe.createElement(
        "div",
        { style: h.double },
        oe.createElement(Sn, {
          style: { input: h.input, label: h.label },
          label: "hex",
          value: l,
          onChange: p
        })
      ),
      oe.createElement(
        "div",
        { style: h.column },
        oe.createElement(
          "div",
          { style: h.single },
          oe.createElement(Sn, {
            style: { input: h.input2, label: h.label2 },
            label: "rgb",
            value: m,
            onChange: p
          })
        ),
        oe.createElement(
          "div",
          { style: h.single },
          oe.createElement(Sn, {
            style: { input: h.input2, label: h.label2 },
            label: "hsv",
            value: x,
            onChange: p
          })
        ),
        oe.createElement(
          "div",
          { style: h.single },
          oe.createElement(Sn, {
            style: { input: h.input2, label: h.label2 },
            label: "hsl",
            value: b,
            onChange: p
          })
        )
      )
    )
  );
}, IM = function(t) {
  var n = t.width, o = t.onChange, s = t.rgb, l = t.hsl, u = t.hsv, p = t.hex, h = t.header, m = t.styles, b = m === void 0 ? {} : m, x = t.className, S = x === void 0 ? "" : x, R = on(gi({
    default: {
      picker: {
        width: n,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + s.r + ", " + s.g + ", " + s.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, b));
  return oe.createElement(
    "div",
    { style: R.picker, className: "google-picker " + S },
    oe.createElement(
      "div",
      { style: R.head },
      h
    ),
    oe.createElement("div", { style: R.swatch }),
    oe.createElement(
      "div",
      { style: R.saturation },
      oe.createElement(NT, {
        hsl: l,
        hsv: u,
        pointer: MM,
        onChange: o
      })
    ),
    oe.createElement(
      "div",
      { style: R.body },
      oe.createElement(
        "div",
        { style: R.controls, className: "flexbox-fix" },
        oe.createElement(
          "div",
          { style: R.hue },
          oe.createElement(Av, {
            style: R.Hue,
            hsl: l,
            radius: "4px",
            pointer: NM,
            onChange: o
          })
        )
      ),
      oe.createElement(wOe, {
        rgb: s,
        hsl: l,
        hex: p,
        hsv: u,
        onChange: o
      })
    )
  );
};
IM.propTypes = {
  width: r.oneOfType([r.string, r.number]),
  styles: r.object,
  header: r.string
};
IM.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
yi(IM);
var $3 = /* @__PURE__ */ ((e) => (e.TRANSPARENT = "transparent", e))($3 || {});
const TOe = (e) => {
  let t = [
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#BD10E0",
    "#9013FE",
    "#4A90E2",
    "#50E3C2",
    "#B8E986",
    "#000000",
    "#4A4A4A",
    "#9B9B9B",
    "#FFFFFF"
  ];
  return e && (t = t.concat([$3.TRANSPARENT])), t;
};
class EOe extends gv {
  constructor(n) {
    super(n);
    FP(this, "divRef");
    FP(this, "boundOnDocumentMousedown");
    const { disableAlpha: o, showTransparentPreset: s } = n;
    this.state = {
      disableAlpha: typeof o > "u" ? !0 : o,
      showTransparentPreset: typeof s > "u" ? !0 : s
    }, this.divRef = Eq(), this.boundOnDocumentMousedown = this.onDocumentMousedown.bind(this);
  }
  componentDidMount() {
    this.forceUpdate();
  }
  componentDidUpdate() {
    this.props.doc.removeEventListener(
      "mousedown",
      this.boundOnDocumentMousedown
    ), this.props.show && this.divRef.current && this.props.doc.addEventListener(
      "mousedown",
      this.boundOnDocumentMousedown
    );
  }
  componentWillUnmount() {
    this.props.doc.removeEventListener(
      "mousedown",
      this.boundOnDocumentMousedown
    );
  }
  onDocumentMousedown(n) {
    const o = this.divRef.current, s = n.target, { attachTo: l } = this.props;
    o && !o.contains(s) && !o.isEqualNode(s) && !l.contains(s) && !l.isEqualNode(s) && this.props.onHide();
  }
  render() {
    const {
      // @ts-ignore
      show: n,
      color: o,
      onChangeComplete: s,
      ColorPicker: l
    } = this.props, { disableAlpha: u, showTransparentPreset: p } = this.state;
    let h = {
      top: 0,
      left: 0
    };
    const m = {
      position: "absolute",
      zIndex: 9e3,
      top: `${h.top}px`,
      left: `${h.left}px`,
      visibility: n && this.divRef.current ? "visible" : "hidden"
    };
    return /* @__PURE__ */ I("div", { style: m, ref: this.divRef, children: /* @__PURE__ */ I(
      l,
      {
        color: o,
        disableAlpha: u,
        onChangeComplete: s,
        presetColors: TOe(p)
      }
    ) });
  }
}
const ROe = (e, t) => (n) => {
  const o = {
    ...n,
    ColorPicker: e,
    doc: t
  };
  return /* @__PURE__ */ I(EOe, { ...o });
}, OOe = ROe(hOe, document), D3 = "jv-mControl-launcher-swatchLight", POe = `${D3} jv-mControl-launcher-swatchTransparent`, $Oe = (e) => _F.isRgbTransparent(e) ? POe : _F.isColorDark(e) ? "" : D3, DOe = ({
  color: e = "",
  onChange: t = () => {
  },
  allowTransparent: n = !0,
  disabled: o = !1
}) => {
  const [s, l] = Kf(!1), u = l0(null), p = {
    backgroundColor: e
  }, [h] = Kf(() => document.createElement("div"));
  Lb(() => (h.className = "jv-jColorPickerWrapper", document.body.appendChild(h), () => h.remove()), [h]);
  let m;
  const b = (S) => {
    t(S.hex);
  };
  return u.current && s ? m = /* @__PURE__ */ I(
    OOe,
    {
      padding: { top: 0, left: 0 },
      show: s,
      color: e,
      showTransparentPreset: n,
      onChangeComplete: b,
      onHide: () => {
        l(!1);
      },
      attachTo: u.current
    }
  ) : m = /* @__PURE__ */ I(Po, {}), /* @__PURE__ */ qe(Po, { children: [
    /* @__PURE__ */ I(
      "div",
      {
        ref: u,
        className: "jv-mControl-launcher mui",
        onClick: () => {
          o || l(!s);
        },
        role: "button",
        tabIndex: -1,
        "aria-label": "button",
        children: /* @__PURE__ */ I(
          "div",
          {
            style: p,
            className: `jv-mControl-launcher-swatch mui ${$Oe(e)}`
          }
        )
      }
    ),
    Ww.createPortal(m, h)
  ] });
}, aAe = ft(
  ({
    InputProps: e = {},
    value: t,
    allowTransparent: n,
    onColorChange: o = () => {
    },
    className: s = "",
    ...l
  }, u) => {
    const p = l.disabled ?? (e == null ? void 0 : e.readOnly);
    return /* @__PURE__ */ I(
      Uk,
      {
        ref: u,
        className: `jv-mControl jv-mControlColor mui ${s}`,
        value: t,
        type: "string",
        InputProps: {
          startAdornment: /* @__PURE__ */ I(
            DOe,
            {
              color: t,
              onChange: o,
              allowTransparent: n,
              disabled: p
            }
          ),
          ...e
        },
        ...l
      }
    );
  }
);
var _M = /* @__PURE__ */ ((e) => (e.general = "jv-mDialogConfirm", e.warning = "jv-mDialogWarning", e.delete = "jv-mDialogDelete", e.error = "jv-mDialogError", e.default = "", e))(_M || {});
const iAe = ft(
  ({
    classes: e = {},
    type: t = "general",
    open: n,
    className: o = "",
    disableEscapeKeyDown: s = !0,
    PaperProps: l = {},
    DialogSubTitleComponent: u,
    DialogTitleProps: p = {},
    dialogTitle: h,
    DialogContentProps: m = {},
    DialogActionsProps: b = {},
    DialogTitleTypographyProps: x = {},
    DialogContentComponent: S,
    DialogActionsComponent: R,
    DialogSubTitleProps: T = {},
    ...E
  }, P) => {
    const { paper: k = "", ..._ } = e, { elevation: L = 4, ...F } = l, { className: N = "", ...V } = p, {
      className: z = "",
      ...H
    } = x, {
      dividers: ee = !0,
      className: K = "",
      ...X
    } = m, { className: ne = "", ...Y } = b, { className: J, ...te } = T;
    return /* @__PURE__ */ qe(
      oT,
      {
        ref: P,
        classes: { paper: `jv-mDialog-wrapper ${k} mui`, ..._ },
        className: `jv-mDialog ${_M[t]} ${o} mui`,
        disableEscapeKeyDown: s,
        PaperProps: {
          elevation: L,
          ...F
        },
        open: n,
        ...E,
        children: [
          h && /* @__PURE__ */ I(
            ik,
            {
              className: `jv-mDialog-header ${N} mui`,
              ...V,
              children: /* @__PURE__ */ I(
                nr,
                {
                  className: `jv-mDialog-header-title ${z} mui`,
                  ...H,
                  children: h
                }
              )
            }
          ),
          /* @__PURE__ */ qe(
            iT,
            {
              className: `jv-mDialog-body jv-mDialog-bodyPadded ${K} mui`,
              dividers: ee,
              ...X,
              children: [
                u && /* @__PURE__ */ I(
                  "div",
                  {
                    className: `jv-mDialog-subtitle ${J} mui`,
                    ...te,
                    children: u
                  }
                ),
                S
              ]
            }
          ),
          /* @__PURE__ */ I(
            aT,
            {
              className: `jv-mDialog-footer ${ne} mui`,
              ...Y,
              children: R
            }
          )
        ]
      }
    );
  }
), sAe = ft(
  ({
    classes: e = {},
    type: t = "general",
    open: n,
    className: o = "",
    disableEscapeKeyDown: s = !0,
    PaperProps: l = {},
    ...u
  }, p) => {
    const { paper: h = "", ...m } = e, { elevation: b = 4, ...x } = l;
    return /* @__PURE__ */ I(
      oT,
      {
        ref: p,
        classes: { paper: `jv-mDialog-wrapper ${h} mui`, ...m },
        className: `jv-mDialog ${_M[t]} ${o} mui`,
        disableEscapeKeyDown: s,
        PaperProps: {
          elevation: b,
          ...x
        },
        open: n,
        ...u
      }
    );
  }
), lAe = ft(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I(
    aT,
    {
      ref: n,
      className: `jv-mDialog-footer ${e} mui`,
      ...t
    }
  )
), cAe = ft(
  ({
    DialogSubTitleComponent: e,
    DialogContentProps: t = {},
    DialogContentComponent: n,
    DialogSubTitleProps: o = {}
  }, s) => {
    const {
      dividers: l = !0,
      className: u = "",
      ...p
    } = t, { className: h, ...m } = o;
    return /* @__PURE__ */ qe(
      iT,
      {
        ref: s,
        className: `jv-mDialog-body jv-mDialog-bodyPadded ${u} mui`,
        dividers: l,
        ...p,
        children: [
          e && /* @__PURE__ */ I(
            "div",
            {
              className: `jv-mDialog-subtitle ${h} mui`,
              ...m,
              children: e
            }
          ),
          n
        ]
      }
    );
  }
), uAe = ft(
  ({ DialogTitleProps: e = {}, dialogTitle: t, DialogTitleTypographyProps: n = {} }, o) => {
    const { className: s = "", ...l } = e, {
      className: u = "",
      ...p
    } = n;
    return /* @__PURE__ */ I(
      ik,
      {
        ref: o,
        className: `jv-mDialog-header ${s} mui`,
        ...l,
        children: /* @__PURE__ */ I(
          nr,
          {
            className: `jv-mDialog-header-title ${u} mui`,
            ...p,
            children: t
          }
        )
      }
    );
  }
);
function kOe(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function id(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function k3(e) {
  if (!id(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = k3(e[n]);
  }), t;
}
function t0(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? O({}, e) : e;
  return id(e) && id(t) && Object.keys(t).forEach((s) => {
    s !== "__proto__" && (id(t[s]) && s in e && id(e[s]) ? o[s] = t0(e[s], t[s], n) : n.clone ? o[s] = id(t[s]) ? k3(t[s]) : t[s] : o[s] = t[s]);
  }), o;
}
const MOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t0,
  isPlainObject: id
}, Symbol.toStringTag, { value: "Module" }));
function NOe(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function IOe(e, t, n, o, s) {
  const l = e[t], u = s || t;
  if (l == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let p;
  return typeof l == "function" && !NOe(l) && (p = "Did you accidentally provide a plain function component instead?"), p !== void 0 ? new Error(`Invalid ${o} \`${u}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const _Oe = kOe(r.elementType, IOe);
function AOe(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const LOe = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function M3(e) {
  const t = `${e}`.match(LOe);
  return t && t[1] || "";
}
function N3(e, t = "") {
  return e.displayName || e.name || M3(e) || t;
}
function mV(e, t, n) {
  const o = N3(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
function FOe(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return N3(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case jc.ForwardRef:
          return mV(e, e.render, "ForwardRef");
        case jc.Memo:
          return mV(e, e.type, "memo");
        default:
          return;
      }
  }
}
const jOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FOe,
  getFunctionName: M3
}, Symbol.toStringTag, { value: "Module" })), Ko = r.oneOfType([r.func, r.object]);
function AT(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : AOe(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const VOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AT
}, Symbol.toStringTag, { value: "Module" }));
function N1(e) {
  return e && e.ownerDocument || document;
}
function BOe(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Hc = typeof window < "u" ? D.useLayoutEffect : D.useEffect;
let vV = 0;
function zOe(e) {
  const [t, n] = D.useState(e), o = e || t;
  return D.useEffect(() => {
    t == null && (vV += 1, n(`mui-${vV}`));
  }, [t]), o;
}
const gV = D.useId;
function bp(e) {
  if (gV !== void 0) {
    const t = gV();
    return e ?? t;
  }
  return zOe(e);
}
function I3(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const l = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${l}\` is not supported. Please remove it.`) : null;
}
function op({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: s
  } = D.useRef(e !== void 0), [l, u] = D.useState(t), p = s ? e : l;
  if (process.env.NODE_ENV !== "production") {
    D.useEffect(() => {
      s !== (e !== void 0) && console.error([`MUI: A component is changing the ${s ? "" : "un"}controlled ${o} state of ${n} to be ${s ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: m
    } = D.useRef(t);
    D.useEffect(() => {
      !s && m !== t && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const h = D.useCallback((m) => {
    s || u(m);
  }, []);
  return [p, h];
}
function Tt(e) {
  const t = D.useRef(e);
  return Hc(() => {
    t.current = e;
  }), D.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function ro(...e) {
  return D.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      BOe(n, t);
    });
  }, e);
}
const UOe = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function vn(e, t, n = void 0) {
  const o = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      o[s] = e[s].reduce((l, u) => {
        if (u) {
          const p = t(u);
          p !== "" && l.push(p), n && n[u] && l.push(n[u]);
        }
        return l;
      }, []).join(" ");
    }
  ), o;
}
const yV = (e) => e, HOe = () => {
  let e = yV;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = yV;
    }
  };
}, WOe = HOe(), qOe = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function xn(e, t, n = "Mui") {
  const o = qOe[t];
  return o ? `${n}-${o}` : `${WOe.generate(e)}-${t}`;
}
function Cn(e, t, n = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = xn(e, s, n);
  }), o;
}
const YOe = ["localeText"], mw = /* @__PURE__ */ D.createContext(null);
process.env.NODE_ENV !== "production" && (mw.displayName = "MuiPickersAdapterContext");
const LT = function(t) {
  const {
    localeText: n
  } = t, o = Te(t, YOe), {
    utils: s,
    localeText: l
  } = D.useContext(mw) ?? {
    utils: void 0,
    localeText: void 0
  }, u = We({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: o,
    name: "MuiLocalizationProvider"
  }), {
    children: p,
    dateAdapter: h,
    dateFormats: m,
    dateLibInstance: b,
    adapterLocale: x,
    localeText: S
  } = u, R = D.useMemo(() => O({}, S, l, n), [S, l, n]), T = D.useMemo(() => {
    if (!h)
      return s || null;
    const k = new h({
      locale: x,
      formats: m,
      instance: b
    });
    if (!k.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return k;
  }, [h, x, m, b, s]), E = D.useMemo(() => T ? {
    minDate: T.date("1900-01-01T00:00:00.000"),
    maxDate: T.date("2099-12-31T00:00:00.000")
  } : null, [T]), P = D.useMemo(() => ({
    utils: T,
    defaultDates: E,
    localeText: R
  }), [E, T, R]);
  return /* @__PURE__ */ I(mw.Provider, {
    value: P,
    children: p
  });
};
process.env.NODE_ENV !== "production" && (LT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: r.any,
  children: r.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: r.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: r.shape({
    dayOfMonth: r.string,
    dayOfMonthFull: r.string,
    fullDate: r.string,
    fullTime: r.string,
    fullTime12h: r.string,
    fullTime24h: r.string,
    hours12h: r.string,
    hours24h: r.string,
    keyboardDate: r.string,
    keyboardDateTime: r.string,
    keyboardDateTime12h: r.string,
    keyboardDateTime24h: r.string,
    meridiem: r.string,
    minutes: r.string,
    month: r.string,
    monthShort: r.string,
    normalDate: r.string,
    normalDateWithWeekday: r.string,
    seconds: r.string,
    shortDate: r.string,
    weekday: r.string,
    weekdayShort: r.string,
    year: r.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: r.any,
  /**
   * Locale for components texts
   */
  localeText: r.object
});
const GOe = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: O({}, e)
      }
    }
  }
}), _3 = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, KOe = _3;
GOe(_3);
const xp = () => {
  const e = D.useContext(mw);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = D.useMemo(() => O({}, KOe, e.localeText), [e.localeText]);
  return D.useMemo(() => O({}, e, {
    localeText: t
  }), [e, t]);
}, sn = () => xp().utils, Sp = () => xp().defaultDates, oo = () => xp().localeText, Cp = (e) => {
  const t = sn(), n = D.useRef();
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
}, XOe = /* @__PURE__ */ D.createContext();
process.env.NODE_ENV !== "production" && (r.node, r.bool);
const vs = () => {
  const e = D.useContext(XOe);
  return e ?? !1;
};
function QOe(e) {
  return typeof e == "string";
}
function JOe(e, t, n) {
  return e === void 0 || QOe(e) ? t : O({}, t, {
    ownerState: O({}, t.ownerState, n)
  });
}
function ZOe(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function md(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function bV(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function ePe(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: s,
    className: l
  } = e;
  if (!t) {
    const R = Ne(n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), T = O({}, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), E = O({}, n, s, o);
    return R.length > 0 && (E.className = R), Object.keys(T).length > 0 && (E.style = T), {
      props: E,
      internalRef: void 0
    };
  }
  const u = ZOe(O({}, s, o)), p = bV(o), h = bV(s), m = t(u), b = Ne(m == null ? void 0 : m.className, n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), x = O({}, m == null ? void 0 : m.style, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), S = O({}, m, n, h, p);
  return b.length > 0 && (S.className = b), Object.keys(x).length > 0 && (S.style = x), {
    props: S,
    internalRef: m.ref
  };
}
const tPe = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Yn(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: o,
    ownerState: s,
    skipResolvingSlotProps: l = !1
  } = e, u = Te(e, tPe), p = l ? {} : md(o, s), {
    props: h,
    internalRef: m
  } = ePe(O({}, u, {
    externalSlotProps: p
  })), b = ro(m, p == null ? void 0 : p.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return JOe(n, O({}, h, {
    ref: b
  }), s);
}
const nPe = lr(/* @__PURE__ */ I("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), rPe = lr(/* @__PURE__ */ I("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), oPe = lr(/* @__PURE__ */ I("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), A3 = lr(/* @__PURE__ */ I("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), aPe = lr(/* @__PURE__ */ qe(D.Fragment, {
  children: [/* @__PURE__ */ I("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ I("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), iPe = lr(/* @__PURE__ */ I("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), sPe = lr(/* @__PURE__ */ qe(D.Fragment, {
  children: [/* @__PURE__ */ I("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ I("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), lPe = lr(/* @__PURE__ */ I("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function cPe(e) {
  return xn("MuiPickersArrowSwitcher", e);
}
Cn("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const uPe = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], dPe = ["ownerState"], fPe = ["ownerState"], pPe = ce("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), hPe = ce("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), xV = ce(oi, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), mPe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, cPe, t);
}, L3 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = vs(), s = We({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: l,
    className: u,
    slots: p,
    slotProps: h,
    isNextDisabled: m,
    isNextHidden: b,
    onGoToNext: x,
    nextLabel: S,
    isPreviousDisabled: R,
    isPreviousHidden: T,
    onGoToPrevious: E,
    previousLabel: P
  } = s, k = Te(s, uPe), _ = s, L = mPe(_), F = {
    isDisabled: m,
    isHidden: b,
    goTo: x,
    label: S
  }, N = {
    isDisabled: R,
    isHidden: T,
    goTo: E,
    label: P
  }, V = (p == null ? void 0 : p.previousIconButton) ?? xV, z = Yn({
    elementType: V,
    externalSlotProps: h == null ? void 0 : h.previousIconButton,
    additionalProps: {
      size: "medium",
      title: N.label,
      "aria-label": N.label,
      disabled: N.isDisabled,
      edge: "end",
      onClick: N.goTo
    },
    ownerState: O({}, _, {
      hidden: N.isHidden
    }),
    className: L.button
  }), H = (p == null ? void 0 : p.nextIconButton) ?? xV, ee = Yn({
    elementType: H,
    externalSlotProps: h == null ? void 0 : h.nextIconButton,
    additionalProps: {
      size: "medium",
      title: F.label,
      "aria-label": F.label,
      disabled: F.isDisabled,
      edge: "start",
      onClick: F.goTo
    },
    ownerState: O({}, _, {
      hidden: F.isHidden
    }),
    className: L.button
  }), K = (p == null ? void 0 : p.leftArrowIcon) ?? rPe, X = Yn({
    elementType: K,
    externalSlotProps: h == null ? void 0 : h.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), ne = Te(X, dPe), Y = (p == null ? void 0 : p.rightArrowIcon) ?? oPe, J = Yn({
    elementType: Y,
    externalSlotProps: h == null ? void 0 : h.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), te = Te(J, fPe);
  return /* @__PURE__ */ qe(pPe, O({
    ref: n,
    className: Ne(L.root, u),
    ownerState: _
  }, k, {
    children: [/* @__PURE__ */ I(V, O({}, z, {
      children: o ? /* @__PURE__ */ I(Y, O({}, te)) : /* @__PURE__ */ I(K, O({}, ne))
    })), l ? /* @__PURE__ */ I(nr, {
      variant: "subtitle1",
      component: "span",
      children: l
    }) : /* @__PURE__ */ I(hPe, {
      className: L.spacer,
      ownerState: _
    }), /* @__PURE__ */ I(H, O({}, ee, {
      children: o ? /* @__PURE__ */ I(K, O({}, ne)) : /* @__PURE__ */ I(Y, O({}, te))
    }))]
  }));
}), Al = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), AM = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: o
}) => {
  const s = n ?? o;
  let l;
  if (e != null)
    l = e;
  else if (s.includes(t))
    l = t;
  else if (s.length > 0)
    l = s[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: s,
    openTo: l
  };
}, F3 = ["hours", "minutes", "seconds"], mv = (e) => F3.includes(e), xb = (e) => F3.includes(e) || e === "meridiem", vPe = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, n0 = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, gPe = (e, t, n, o) => {
  const s = n0(o.getHours(e), t, n);
  return o.setHours(e, s);
}, SV = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), U0 = (e, t) => (n, o) => e ? t.isAfter(n, o) : SV(n, t) > SV(o, t), vw = (e, {
  format: t,
  views: n,
  ampm: o
}) => {
  if (t != null)
    return t;
  const s = e.formats;
  return Al(n, ["hours"]) ? o ? `${s.hours12h} ${s.meridiem}` : s.hours24h : Al(n, ["minutes"]) ? s.minutes : Al(n, ["seconds"]) ? s.seconds : Al(n, ["minutes", "seconds"]) ? `${s.minutes}:${s.seconds}` : Al(n, ["hours", "minutes", "seconds"]) ? o ? `${s.hours12h}:${s.minutes}:${s.seconds} ${s.meridiem}` : `${s.hours24h}:${s.minutes}:${s.seconds}` : o ? `${s.hours12h}:${s.minutes} ${s.meridiem}` : `${s.hours24h}:${s.minutes}`;
};
let E$ = !1;
function H0({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: o,
  views: s,
  autoFocus: l,
  focusedView: u,
  onFocusedViewChange: p
}) {
  process.env.NODE_ENV !== "production" && (E$ || (o != null && !s.includes(o) && (console.warn(`MUI X: \`view="${o}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), E$ = !0), o == null && n != null && !s.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), E$ = !0)));
  const h = D.useRef(n), m = D.useRef(s), b = D.useRef(s.includes(n) ? n : s[0]), [x, S] = op({
    name: "useViews",
    state: "view",
    controlled: o,
    default: b.current
  }), R = D.useRef(l ? x : null), [T, E] = op({
    name: "useViews",
    state: "focusedView",
    controlled: u,
    default: R.current
  });
  D.useEffect(() => {
    (h.current && h.current !== n || m.current && m.current.some((z) => !s.includes(z))) && (S(s.includes(n) ? n : s[0]), m.current = s, h.current = n);
  }, [n, S, x, s]);
  const P = s.indexOf(x), k = s[P - 1] ?? null, _ = s[P + 1] ?? null, L = Tt((z, H) => {
    E(H ? z : (ee) => z === ee ? null : ee), p == null || p(z, H);
  }), F = Tt((z) => {
    L(z, !0), z !== x && (S(z), t && t(z));
  }), N = Tt(() => {
    _ && F(_);
  }), V = Tt((z, H, ee) => {
    const K = H === "finish", X = ee ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      s.indexOf(ee) < s.length - 1
    ) : !!_;
    if (e(z, K && X ? "partial" : H, ee), ee && ee !== x) {
      const Y = s[s.indexOf(ee) + 1];
      Y && F(Y);
    } else K && N();
  });
  return {
    view: x,
    setView: F,
    focusedView: T,
    setFocusedView: L,
    nextView: _,
    previousView: k,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: s.includes(n) ? n : s[0],
    goToNextView: N,
    setValueAndGoToNextView: V
  };
}
function yPe(e, {
  disableFuture: t,
  maxDate: n,
  timezone: o
}) {
  const s = sn();
  return D.useMemo(() => {
    const l = s.date(void 0, o), u = s.startOfMonth(t && s.isBefore(l, n) ? l : n);
    return !s.isAfter(u, e);
  }, [t, n, e, s, o]);
}
function bPe(e, {
  disablePast: t,
  minDate: n,
  timezone: o
}) {
  const s = sn();
  return D.useMemo(() => {
    const l = s.date(void 0, o), u = s.startOfMonth(t && s.isAfter(l, n) ? l : n);
    return !s.isBefore(u, e);
  }, [t, n, e, s, o]);
}
function FT(e, t, n, o) {
  const s = sn(), l = vPe(e, s), u = D.useCallback((p) => {
    const h = e == null ? null : gPe(e, p, !!t, s);
    n(h, o ?? "partial");
  }, [t, e, n, o, s]);
  return {
    meridiemMode: l,
    handleMeridiemChange: u
  };
}
const r0 = 36, jT = 2, VT = 320, xPe = 280, BT = 336, j3 = 232, Sb = 48, zT = ce("div")({
  overflow: "hidden",
  width: VT,
  maxHeight: BT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
function SPe(e) {
  return xn("MuiTimeClock", e);
}
Cn("MuiTimeClock", ["root", "arrowSwitcher"]);
const vv = 220, Ul = 36, o0 = {
  x: vv / 2,
  y: vv / 2
}, V3 = {
  x: o0.x,
  y: 0
}, CPe = V3.x - o0.x, wPe = V3.y - o0.y, TPe = (e) => e * (180 / Math.PI), B3 = (e, t, n) => {
  const o = t - o0.x, s = n - o0.y, l = Math.atan2(CPe, wPe) - Math.atan2(o, s);
  let u = TPe(l);
  u = Math.round(u / e) * e, u %= 360;
  const p = Math.floor(u / e) || 0, h = o ** 2 + s ** 2, m = Math.sqrt(h);
  return {
    value: p,
    distance: m
  };
}, EPe = (e, t, n = 1) => {
  const o = n * 6;
  let {
    value: s
  } = B3(o, e, t);
  return s = s * n % 60, s;
}, RPe = (e, t, n) => {
  const {
    value: o,
    distance: s
  } = B3(30, e, t);
  let l = o || 12;
  return n ? l %= 12 : s < vv / 2 - Ul && (l += 12, l %= 24), l;
};
function OPe(e) {
  return xn("MuiClockPointer", e);
}
Cn("MuiClockPointer", ["root", "thumb"]);
const PPe = ["className", "hasSelected", "isInner", "type", "viewValue"], $Pe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    thumb: ["thumb"]
  }, OPe, t);
}, DPe = ce("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px",
  variants: [{
    props: {
      shouldAnimate: !0
    },
    style: {
      transition: e.transitions.create(["transform", "height"])
    }
  }]
})), kPe = ce("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${Ul / 2}px)`,
  border: `${(Ul - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box",
  variants: [{
    props: {
      hasSelected: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }]
}));
function MPe(e) {
  const t = We({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: o,
    type: s,
    viewValue: l
  } = t, u = Te(t, PPe), p = D.useRef(s);
  D.useEffect(() => {
    p.current = s;
  }, [s]);
  const h = O({}, t, {
    shouldAnimate: p.current !== s
  }), m = $Pe(h);
  return /* @__PURE__ */ I(DPe, O({
    style: (() => {
      let S = 360 / (s === "hours" ? 12 : 60) * l;
      return s === "hours" && l > 12 && (S -= 360), {
        height: Math.round((o ? 0.26 : 0.4) * vv),
        transform: `rotateZ(${S}deg)`
      };
    })(),
    className: Ne(n, m.root),
    ownerState: h
  }, u, {
    children: /* @__PURE__ */ I(kPe, {
      ownerState: h,
      className: m.thumb
    })
  }));
}
function NPe(e) {
  return xn("MuiClock", e);
}
Cn("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const gw = (e, t, n) => {
  let o = t;
  return o = e.setHours(o, e.getHours(n)), o = e.setMinutes(o, e.getMinutes(n)), o = e.setSeconds(o, e.getSeconds(n)), o;
}, Nb = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: o,
  minDate: s,
  isDateDisabled: l,
  utils: u,
  timezone: p
}) => {
  const h = gw(u, u.date(void 0, p), e);
  n && u.isBefore(s, h) && (s = h), t && u.isAfter(o, h) && (o = h);
  let m = e, b = e;
  for (u.isBefore(e, s) && (m = s, b = null), u.isAfter(e, o) && (b && (b = o), m = null); m || b; ) {
    if (m && u.isAfter(m, o) && (m = null), b && u.isBefore(b, s) && (b = null), m) {
      if (!l(m))
        return m;
      m = u.addDays(m, 1);
    }
    if (b) {
      if (!l(b))
        return b;
      b = u.addDays(b, -1);
    }
  }
  return null;
}, IPe = (e, t) => t == null || !e.isValid(t) ? null : t, pa = (e, t, n) => t == null || !e.isValid(t) ? n : t, _Pe = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), LM = (e, t) => {
  const o = [e.startOfYear(t)];
  for (; o.length < 12; ) {
    const s = o[o.length - 1];
    o.push(e.addMonths(s, 1));
  }
  return o;
}, FM = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), Zs = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, APe = ["year", "month", "day"], a0 = (e) => APe.includes(e), i0 = (e, {
  format: t,
  views: n
}, o) => {
  if (t != null)
    return t;
  const s = e.formats;
  return Al(n, ["year"]) ? s.year : Al(n, ["month"]) ? s.month : Al(n, ["day"]) ? s.dayOfMonth : Al(n, ["month", "year"]) ? `${s.month} ${s.year}` : Al(n, ["day", "month"]) ? `${s.month} ${s.dayOfMonth}` : o ? /en/.test(e.getCurrentLocaleCode()) ? s.normalDateWithWeekday : s.normalDate : s.keyboardDate;
}, LPe = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((o) => e.addDays(n, o));
}, FPe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, NPe, t);
}, jPe = ce("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), VPe = ce("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), BPe = ce("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), zPe = ce("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none",
  variants: [{
    props: {
      disabled: !1
    },
    style: {
      "@media (pointer: fine)": {
        cursor: "pointer",
        borderRadius: "50%"
      },
      "&:active": {
        cursor: "move"
      }
    }
  }]
}), UPe = ce("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), HPe = ce(oi, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e
}) => ({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: Ul,
  variants: [{
    props: {
      meridiemMode: "am"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main,
      color: (e.vars || e).palette.primary.contrastText,
      "&:hover": {
        backgroundColor: (e.vars || e).palette.primary.light
      }
    }
  }]
})), WPe = ce(oi, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e
}) => ({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: Ul,
  variants: [{
    props: {
      meridiemMode: "pm"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main,
      color: (e.vars || e).palette.primary.contrastText,
      "&:hover": {
        backgroundColor: (e.vars || e).palette.primary.light
      }
    }
  }]
})), CV = ce(nr, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function qPe(e) {
  const t = We({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: o,
    autoFocus: s,
    children: l,
    value: u,
    handleMeridiemChange: p,
    isTimeDisabled: h,
    meridiemMode: m,
    minutesStep: b = 1,
    onChange: x,
    selectedId: S,
    type: R,
    viewValue: T,
    disabled: E = !1,
    readOnly: P,
    className: k
  } = t, _ = t, L = sn(), F = oo(), N = D.useRef(!1), V = FPe(_), z = h(T, R), H = !n && R === "hours" && (T < 1 || T > 12), ee = (G, W) => {
    E || P || h(G, R) || x(G, W);
  }, K = (G, W) => {
    let {
      offsetX: le,
      offsetY: pe
    } = G;
    if (le === void 0) {
      const we = G.target.getBoundingClientRect();
      le = G.changedTouches[0].clientX - we.left, pe = G.changedTouches[0].clientY - we.top;
    }
    const ge = R === "seconds" || R === "minutes" ? EPe(le, pe, b) : RPe(le, pe, !!n);
    ee(ge, W);
  }, X = (G) => {
    N.current = !0, K(G, "shallow");
  }, ne = (G) => {
    N.current && (K(G, "finish"), N.current = !1);
  }, Y = (G) => {
    G.buttons > 0 && K(G.nativeEvent, "shallow");
  }, J = (G) => {
    N.current && (N.current = !1), K(G.nativeEvent, "finish");
  }, te = D.useMemo(() => R === "hours" ? !0 : T % 5 === 0, [R, T]), Z = R === "minutes" ? b : 1, ae = D.useRef(null);
  Hc(() => {
    s && ae.current.focus();
  }, [s]);
  const U = (G) => {
    if (!N.current)
      switch (G.key) {
        case "Home":
          ee(0, "partial"), G.preventDefault();
          break;
        case "End":
          ee(R === "minutes" ? 59 : 23, "partial"), G.preventDefault();
          break;
        case "ArrowUp":
          ee(T + Z, "partial"), G.preventDefault();
          break;
        case "ArrowDown":
          ee(T - Z, "partial"), G.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ qe(jPe, {
    className: Ne(k, V.root),
    children: [/* @__PURE__ */ qe(VPe, {
      className: V.clock,
      children: [/* @__PURE__ */ I(zPe, {
        onTouchMove: X,
        onTouchEnd: ne,
        onMouseUp: J,
        onMouseMove: Y,
        ownerState: {
          disabled: E
        },
        className: V.squareMask
      }), !z && /* @__PURE__ */ qe(D.Fragment, {
        children: [/* @__PURE__ */ I(UPe, {
          className: V.pin
        }), u != null && /* @__PURE__ */ I(MPe, {
          type: R,
          viewValue: T,
          isInner: H,
          hasSelected: te
        })]
      }), /* @__PURE__ */ I(BPe, {
        "aria-activedescendant": S,
        "aria-label": F.clockLabelText(R, u, L),
        ref: ae,
        role: "listbox",
        onKeyDown: U,
        tabIndex: 0,
        className: V.wrapper,
        children: l
      })]
    }), n && o && /* @__PURE__ */ qe(D.Fragment, {
      children: [/* @__PURE__ */ I(HPe, {
        onClick: P ? void 0 : () => p("am"),
        disabled: E || m === null,
        ownerState: _,
        className: V.amButton,
        title: Zs(L, "am"),
        children: /* @__PURE__ */ I(CV, {
          variant: "caption",
          className: V.meridiemText,
          children: Zs(L, "am")
        })
      }), /* @__PURE__ */ I(WPe, {
        disabled: E || m === null,
        onClick: P ? void 0 : () => p("pm"),
        ownerState: _,
        className: V.pmButton,
        title: Zs(L, "pm"),
        children: /* @__PURE__ */ I(CV, {
          variant: "caption",
          className: V.meridiemText,
          children: Zs(L, "pm")
        })
      })]
    })]
  });
}
function YPe(e) {
  return xn("MuiClockNumber", e);
}
const b1 = Cn("MuiClockNumber", ["root", "selected", "disabled"]), GPe = ["className", "disabled", "index", "inner", "label", "selected"], KPe = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: o
  } = e;
  return vn({
    root: ["root", n && "selected", o && "disabled"]
  }, YPe, t);
}, XPe = ce("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${b1.disabled}`]: t.disabled
  }, {
    [`&.${b1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  height: Ul,
  width: Ul,
  position: "absolute",
  left: `calc((100% - ${Ul}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${b1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${b1.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  },
  variants: [{
    props: {
      inner: !0
    },
    style: O({}, e.typography.body2, {
      color: (e.vars || e).palette.text.secondary
    })
  }]
}));
function z3(e) {
  const t = We({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: o,
    index: s,
    inner: l,
    label: u,
    selected: p
  } = t, h = Te(t, GPe), m = t, b = KPe(m), x = s % 12 / 12 * Math.PI * 2 - Math.PI / 2, S = (vv - Ul - 2) / 2 * (l ? 0.65 : 1), R = Math.round(Math.cos(x) * S), T = Math.round(Math.sin(x) * S);
  return /* @__PURE__ */ I(XPe, O({
    className: Ne(n, b.root),
    "aria-disabled": o ? !0 : void 0,
    "aria-selected": p ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${R}px, ${T + (vv - Ul) / 2}px`
    },
    ownerState: m
  }, h, {
    children: u
  }));
}
const QPe = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: o,
  selectedId: s,
  utils: l
}) => {
  const u = t ? l.getHours(t) : null, p = [], h = e ? 1 : 0, m = e ? 12 : 23, b = (x) => u === null ? !1 : e ? x === 12 ? u === 12 || u === 0 : u === x || u - 12 === x : u === x;
  for (let x = h; x <= m; x += 1) {
    let S = x.toString();
    x === 0 && (S = "00");
    const R = !e && (x === 0 || x > 12);
    S = l.formatNumber(S);
    const T = b(x);
    p.push(/* @__PURE__ */ I(z3, {
      id: T ? s : void 0,
      index: x,
      inner: R,
      selected: T,
      disabled: o(x),
      label: S,
      "aria-label": n(S)
    }, x));
  }
  return p;
}, wV = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: o,
  selectedId: s
}) => {
  const l = e.formatNumber;
  return [[5, l("05")], [10, l("10")], [15, l("15")], [20, l("20")], [25, l("25")], [30, l("30")], [35, l("35")], [40, l("40")], [45, l("45")], [50, l("50")], [55, l("55")], [0, l("00")]].map(([u, p], h) => {
    const m = u === t;
    return /* @__PURE__ */ I(z3, {
      label: p,
      id: m ? s : void 0,
      index: h + 1,
      inner: !1,
      disabled: n(u),
      selected: m,
      "aria-label": o(p)
    }, u);
  });
}, jM = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: o,
  valueManager: s
}) => {
  const l = sn(), u = D.useRef(n), p = t ?? u.current ?? s.emptyValue, h = D.useMemo(() => s.getTimezone(l, p), [l, s, p]), m = Tt((R) => h == null ? R : s.setTimezone(l, h, R)), b = e ?? h ?? "default", x = D.useMemo(() => s.setTimezone(l, b, p), [s, l, b, p]), S = Tt((R, ...T) => {
    const E = m(R);
    o == null || o(E, ...T);
  });
  return {
    value: x,
    handleValueChange: S,
    timezone: b
  };
}, Fv = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: o,
  onChange: s,
  valueManager: l
}) => {
  const [u, p] = op({
    name: e,
    state: "value",
    controlled: n,
    default: o ?? l.emptyValue
  }), h = Tt((m, ...b) => {
    p(m), s == null || s(m, ...b);
  });
  return jM({
    timezone: t,
    value: u,
    defaultValue: void 0,
    onChange: h,
    valueManager: l
  });
}, Qs = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, JPe = (e) => Math.max(...e.map((t) => Qs[t.type] ?? 1)), db = (e, t, n) => {
  if (t === Qs.year)
    return e.startOfYear(n);
  if (t === Qs.month)
    return e.startOfMonth(n);
  if (t === Qs.day)
    return e.startOfDay(n);
  let o = n;
  return t < Qs.minutes && (o = e.setMinutes(o, 0)), t < Qs.seconds && (o = e.setSeconds(o, 0)), t < Qs.milliseconds && (o = e.setMilliseconds(o, 0)), o;
}, ZPe = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: o,
  getTodayDate: s
}) => {
  let l = s ? s() : db(t, n, FM(t, o));
  e.minDate != null && t.isAfterDay(e.minDate, l) && (l = db(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, l) && (l = db(t, n, e.maxDate));
  const u = U0(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && u(e.minTime, l) && (l = db(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : gw(t, l, e.minTime))), e.maxTime != null && u(l, e.maxTime) && (l = db(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : gw(t, l, e.maxTime))), l;
}, VM = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, e$e = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, UT = (e, t, n) => {
  const o = [], s = e.date(void 0, t), l = e.startOfWeek(s), u = e.endOfWeek(s);
  let p = l;
  for (; e.isBefore(p, u); )
    o.push(p), p = e.addDays(p, 1);
  return o.map((h) => e.formatByString(h, n));
}, U3 = (e, t, n, o) => {
  switch (n) {
    case "month":
      return LM(e, e.date(void 0, t)).map((s) => e.formatByString(s, o));
    case "weekDay":
      return UT(e, t, o);
    case "meridiem": {
      const s = e.date(void 0, t);
      return [e.startOfDay(s), e.endOfDay(s)].map((l) => e.formatByString(l, o));
    }
    default:
      return [];
  }
}, TV = "s", t$e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], n$e = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), TV) === "0" ? t$e : Array.from({
    length: 10
  }).map((o, s) => e.formatByString(e.setSeconds(t, s), TV));
}, ap = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let o = "";
  for (let s = 0; s < e.length; s += 1) {
    o += e[s];
    const l = t.indexOf(o);
    l > -1 && (n.push(l.toString()), o = "");
  }
  return n.join("");
}, BM = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), EV = (e, t) => {
  const n = ap(e, t);
  return !Number.isNaN(Number(n));
}, H3 = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, W3 = (e, t, n, o, s) => {
  if (process.env.NODE_ENV !== "production" && s.type !== "day" && s.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${s.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (s.type === "day" && s.contentType === "digit-with-letter") {
    const u = e.setDate(n.longestMonth, t);
    return e.formatByString(u, s.format);
  }
  let l = t.toString();
  return s.hasLeadingZerosInInput && (l = H3(l, s.maxLength)), BM(l, o);
}, r$e = (e, t, n, o, s, l, u, p) => {
  const h = e$e(o), m = o === "Home", b = o === "End", x = n.value === "" || m || b, S = () => {
    const T = s[n.type]({
      currentDate: u,
      format: n.format,
      contentType: n.contentType
    }), E = (L) => W3(e, L, T, l, n), P = n.type === "minutes" && (p != null && p.minutesStep) ? p.minutesStep : 1;
    let _ = parseInt(ap(n.value, l), 10) + h * P;
    if (x) {
      if (n.type === "year" && !b && !m)
        return e.formatByString(e.date(void 0, t), n.format);
      h > 0 || m ? _ = T.minimum : _ = T.maximum;
    }
    return _ % P !== 0 && ((h < 0 || m) && (_ += P - (P + _) % P), (h > 0 || b) && (_ -= _ % P)), _ > T.maximum ? E(T.minimum + (_ - T.maximum - 1) % (T.maximum - T.minimum + 1)) : _ < T.minimum ? E(T.maximum - (T.minimum - _ - 1) % (T.maximum - T.minimum + 1)) : E(_);
  }, R = () => {
    const T = U3(e, t, n.type, n.format);
    if (T.length === 0)
      return n.value;
    if (x)
      return h > 0 || m ? T[0] : T[T.length - 1];
    const k = ((T.indexOf(n.value) + h) % T.length + T.length) % T.length;
    return T[k];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? S() : R();
}, zM = (e, t, n) => {
  let o = e.value || e.placeholder;
  const s = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (o = Number(ap(o, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !s && o.length === 1 && (o = `${o}‎`), t === "input-rtl" && (o = `⁨${o}⁩`), o;
}, RV = (e, t, n, o) => {
  if (process.env.NODE_ENV !== "production" && VM(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), o);
}, q3 = (e, t, n) => e.formatByString(e.date(void 0, t), n).length === 4, Y3 = (e, t, n, o, s) => {
  if (n !== "digit")
    return !1;
  const l = e.date(void 0, t);
  switch (o) {
    case "year":
      return q3(e, t, s) ? e.formatByString(e.setYear(l, 1), s) === "0001" : e.formatByString(e.setYear(l, 2001), s) === "01";
    case "month":
      return e.formatByString(e.startOfYear(l), s).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(l), s).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(l), s).length > 1;
    case "hours":
      return e.formatByString(e.setHours(l, 1), s).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(l, 1), s).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(l, 1), s).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, o$e = (e, t, n) => {
  const o = t.some((h) => h.type === "day"), s = [], l = [];
  for (let h = 0; h < t.length; h += 1) {
    const m = t[h];
    o && m.type === "weekDay" || (s.push(m.format), l.push(zM(m, "non-input", n)));
  }
  const u = s.join(" "), p = l.join(" ");
  return e.parse(p, u);
}, a$e = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), i$e = (e, t, n) => {
  const s = e.map((l) => {
    const u = zM(l, n ? "input-rtl" : "input-ltr", t);
    return `${l.startSeparator}${u}${l.endSeparator}`;
  }).join("");
  return n ? `⁦${s}⁩` : s;
}, s$e = (e, t, n) => {
  const o = e.date(void 0, n), s = e.endOfYear(o), l = e.endOfDay(o), {
    maxDaysInMonth: u,
    longestMonth: p
  } = LM(e, o).reduce((h, m) => {
    const b = e.getDaysInMonth(m);
    return b > h.maxDaysInMonth ? {
      maxDaysInMonth: b,
      longestMonth: m
    } : h;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: h
    }) => ({
      minimum: 0,
      maximum: q3(e, n, h) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(s) + 1
    }),
    day: ({
      currentDate: h
    }) => ({
      minimum: 1,
      maximum: h != null && e.isValid(h) ? e.getDaysInMonth(h) : u,
      longestMonth: p
    }),
    weekDay: ({
      format: h,
      contentType: m
    }) => {
      if (m === "digit") {
        const b = UT(e, n, h).map(Number);
        return {
          minimum: Math.min(...b),
          maximum: Math.max(...b)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: h
    }) => {
      const m = e.getHours(l);
      return ap(e.formatByString(e.endOfDay(o), h), t) !== m.toString() ? {
        minimum: 1,
        maximum: Number(ap(e.formatByString(e.startOfDay(o), h), t))
      } : {
        minimum: 0,
        maximum: m
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(l)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(l)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let OV = !1;
const PV = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !OV) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const o = e.find((s) => !n.includes(s.type));
    o && (console.warn(`MUI X: The field component you are using is not compatible with the "${o.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), OV = !0);
  }
}, l$e = (e, t, n, o, s) => {
  switch (n.type) {
    case "year":
      return e.setYear(s, e.getYear(o));
    case "month":
      return e.setMonth(s, e.getMonth(o));
    case "weekDay": {
      const l = UT(e, t, n.format), u = e.formatByString(o, n.format), p = l.indexOf(u), m = l.indexOf(n.value) - p;
      return e.addDays(o, m);
    }
    case "day":
      return e.setDate(s, e.getDate(o));
    case "meridiem": {
      const l = e.getHours(o) < 12, u = e.getHours(s);
      return l && u >= 12 ? e.addHours(s, -12) : !l && u < 12 ? e.addHours(s, 12) : s;
    }
    case "hours":
      return e.setHours(s, e.getHours(o));
    case "minutes":
      return e.setMinutes(s, e.getMinutes(o));
    case "seconds":
      return e.setSeconds(s, e.getSeconds(o));
    default:
      return s;
  }
}, $V = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, DV = (e, t, n, o, s, l) => (
  // cloning sections before sort to avoid mutating it
  [...o].sort((u, p) => $V[u.type] - $V[p.type]).reduce((u, p) => !l || p.modified ? l$e(e, t, p, n, u) : u, s)
), c$e = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, u$e = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((h, m) => {
      const b = m === 0 ? null : m - 1, x = m === e.length - 1 ? null : m + 1;
      n[m] = {
        leftIndex: b,
        rightIndex: x
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const o = {}, s = {};
  let l = 0, u = 0, p = e.length - 1;
  for (; p >= 0; ) {
    u = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (h, m) => {
        var b;
        return m >= l && ((b = h.endSeparator) == null ? void 0 : b.includes(" ")) && // Special case where the spaces were not there in the initial input
        h.endSeparator !== " / ";
      }
    ), u === -1 && (u = e.length - 1);
    for (let h = u; h >= l; h -= 1)
      s[h] = p, o[p] = h, p -= 1;
    l = u + 1;
  }
  return e.forEach((h, m) => {
    const b = s[m], x = b === 0 ? null : o[b - 1], S = b === e.length - 1 ? null : o[b + 1];
    n[m] = {
      leftIndex: x,
      rightIndex: S
    };
  }), {
    neighbors: n,
    startIndex: o[0],
    endIndex: o[e.length - 1]
  };
}, hD = (e, t) => e == null ? null : e === "all" ? "all" : typeof e == "string" ? t.findIndex((n) => n.type === e) : e, d$e = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, f$e = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, p$e = ["value", "referenceDate"], go = {
  emptyValue: null,
  getTodayValue: FM,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = Te(e, p$e);
    return t != null && o.utils.isValid(t) ? t : n ?? ZPe(o);
  },
  cleanValue: IPe,
  areValuesEqual: _Pe,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, UM = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, o) => !e.isValid(t) && !!n ? n : o(t),
  getV7HiddenInputValueFromSections: a$e,
  getV6InputValueFromSections: i$e,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, HM = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: o,
  timezone: s
}) => {
  const l = D.useMemo(
    () => go.getInitialReferenceValue({
      value: e,
      utils: n,
      props: o,
      referenceDate: t,
      granularity: Qs.day,
      timezone: s,
      getTodayDate: () => FM(n, s, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? l;
}, h$e = ["ampm", "ampmInClock", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], m$e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, SPe, t);
}, v$e = ce(zT, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), g$e = ce(L3, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), y$e = ["hours", "minutes"], G3 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = sn(), s = We({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: l = o.is12HourCycleInCurrentLocale(),
    ampmInClock: u = !1,
    autoFocus: p,
    slots: h,
    slotProps: m,
    value: b,
    defaultValue: x,
    referenceDate: S,
    disableIgnoringDatePartForTimeValidation: R = !1,
    maxTime: T,
    minTime: E,
    disableFuture: P,
    disablePast: k,
    minutesStep: _ = 1,
    shouldDisableTime: L,
    showViewSwitcher: F,
    onChange: N,
    view: V,
    views: z = y$e,
    openTo: H,
    onViewChange: ee,
    focusedView: K,
    onFocusedViewChange: X,
    className: ne,
    disabled: Y,
    readOnly: J,
    timezone: te
  } = s, Z = Te(s, h$e), {
    value: ae,
    handleValueChange: U,
    timezone: G
  } = Fv({
    name: "TimeClock",
    timezone: te,
    value: b,
    defaultValue: x,
    onChange: N,
    valueManager: go
  }), W = HM({
    value: ae,
    referenceDate: S,
    utils: o,
    props: s,
    timezone: G
  }), le = oo(), pe = Cp(G), {
    view: ge,
    setView: we,
    previousView: de,
    nextView: se,
    setValueAndGoToNextView: ve
  } = H0({
    view: V,
    views: z,
    openTo: H,
    onViewChange: ee,
    onChange: U,
    focusedView: K,
    onFocusedViewChange: X
  }), {
    meridiemMode: me,
    handleMeridiemChange: Oe
  } = FT(W, l, ve), be = D.useCallback((Ee, _e) => {
    const Ve = U0(R, o), Re = _e === "hours" || _e === "minutes" && z.includes("seconds"), lt = ({
      start: at,
      end: it
    }) => !(E && Ve(E, it) || T && Ve(at, T) || P && Ve(at, pe) || k && Ve(pe, Re ? it : at)), Pt = (at, it = 1) => {
      if (at % it !== 0)
        return !1;
      if (L)
        switch (_e) {
          case "hours":
            return !L(o.setHours(W, at), "hours");
          case "minutes":
            return !L(o.setMinutes(W, at), "minutes");
          case "seconds":
            return !L(o.setSeconds(W, at), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (_e) {
      case "hours": {
        const at = n0(Ee, me, l), it = o.setHours(W, at), bt = o.setSeconds(o.setMinutes(it, 0), 0), Nt = o.setSeconds(o.setMinutes(it, 59), 59);
        return !lt({
          start: bt,
          end: Nt
        }) || !Pt(at);
      }
      case "minutes": {
        const at = o.setMinutes(W, Ee), it = o.setSeconds(at, 0), bt = o.setSeconds(at, 59);
        return !lt({
          start: it,
          end: bt
        }) || !Pt(Ee, _);
      }
      case "seconds": {
        const at = o.setSeconds(W, Ee);
        return !lt({
          start: at,
          end: at
        }) || !Pt(Ee);
      }
      default:
        throw new Error("not supported");
    }
  }, [l, W, R, T, me, E, _, L, o, P, k, pe, z]), De = bp(), ie = D.useMemo(() => {
    switch (ge) {
      case "hours": {
        const Ee = (_e, Ve) => {
          const Re = n0(_e, me, l);
          ve(o.setHours(W, Re), Ve, "hours");
        };
        return {
          onChange: Ee,
          viewValue: o.getHours(W),
          children: QPe({
            value: ae,
            utils: o,
            ampm: l,
            onChange: Ee,
            getClockNumberText: le.hoursClockNumberText,
            isDisabled: (_e) => Y || be(_e, "hours"),
            selectedId: De
          })
        };
      }
      case "minutes": {
        const Ee = o.getMinutes(W), _e = (Ve, Re) => {
          ve(o.setMinutes(W, Ve), Re, "minutes");
        };
        return {
          viewValue: Ee,
          onChange: _e,
          children: wV({
            utils: o,
            value: Ee,
            onChange: _e,
            getClockNumberText: le.minutesClockNumberText,
            isDisabled: (Ve) => Y || be(Ve, "minutes"),
            selectedId: De
          })
        };
      }
      case "seconds": {
        const Ee = o.getSeconds(W), _e = (Ve, Re) => {
          ve(o.setSeconds(W, Ve), Re, "seconds");
        };
        return {
          viewValue: Ee,
          onChange: _e,
          children: wV({
            utils: o,
            value: Ee,
            onChange: _e,
            getClockNumberText: le.secondsClockNumberText,
            isDisabled: (Ve) => Y || be(Ve, "seconds"),
            selectedId: De
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [ge, o, ae, l, le.hoursClockNumberText, le.minutesClockNumberText, le.secondsClockNumberText, me, ve, W, be, De, Y]), fe = s, ye = m$e(fe);
  return /* @__PURE__ */ qe(v$e, O({
    ref: n,
    className: Ne(ye.root, ne),
    ownerState: fe
  }, Z, {
    children: [/* @__PURE__ */ I(qPe, O({
      autoFocus: p ?? !!K,
      ampmInClock: u && z.includes("hours"),
      value: ae,
      type: ge,
      ampm: l,
      minutesStep: _,
      isTimeDisabled: be,
      meridiemMode: me,
      handleMeridiemChange: Oe,
      selectedId: De,
      disabled: Y,
      readOnly: J
    }, ie)), F && /* @__PURE__ */ I(g$e, {
      className: ye.arrowSwitcher,
      slots: h,
      slotProps: m,
      onGoToPrevious: () => we(de),
      isPreviousDisabled: !de,
      previousLabel: le.openPreviousView,
      onGoToNext: () => we(se),
      isNextDisabled: !se,
      nextLabel: le.openNextView,
      ownerState: fe
    })]
  }));
});
process.env.NODE_ENV !== "production" && (G3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: r.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  showViewSwitcher: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: r.arrayOf(r.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function b$e(e) {
  return xn("MuiDigitalClock", e);
}
const x$e = Cn("MuiDigitalClock", ["root", "list", "item"]), S$e = ["ampm", "timeStep", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], C$e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, b$e, t);
}, w$e = ce(zT, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  maxHeight: j3,
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
}), T$e = ce(hT, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), E$e = ce(Ev, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : Mt(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), K3 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = sn(), s = D.useRef(null), l = ro(n, s), u = We({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: p = o.is12HourCycleInCurrentLocale(),
    timeStep: h = 30,
    autoFocus: m,
    slots: b,
    slotProps: x,
    value: S,
    defaultValue: R,
    referenceDate: T,
    disableIgnoringDatePartForTimeValidation: E = !1,
    maxTime: P,
    minTime: k,
    disableFuture: _,
    disablePast: L,
    minutesStep: F = 1,
    shouldDisableTime: N,
    onChange: V,
    view: z,
    openTo: H,
    onViewChange: ee,
    focusedView: K,
    onFocusedViewChange: X,
    className: ne,
    disabled: Y,
    readOnly: J,
    views: te = ["hours"],
    skipDisabled: Z = !1,
    timezone: ae
  } = u, U = Te(u, S$e), {
    value: G,
    handleValueChange: W,
    timezone: le
  } = Fv({
    name: "DigitalClock",
    timezone: ae,
    value: S,
    defaultValue: R,
    onChange: V,
    valueManager: go
  }), pe = oo(), ge = Cp(le), we = D.useMemo(() => O({}, u, {
    alreadyRendered: !!s.current
  }), [u]), de = C$e(we), se = (b == null ? void 0 : b.digitalClockItem) ?? E$e, ve = Yn({
    elementType: se,
    externalSlotProps: x == null ? void 0 : x.digitalClockItem,
    ownerState: {},
    className: de.item
  }), me = HM({
    value: G,
    referenceDate: T,
    utils: o,
    props: u,
    timezone: le
  }), Oe = Tt((Ee) => W(Ee, "finish", "hours")), {
    setValueAndGoToNextView: be
  } = H0({
    view: z,
    views: te,
    openTo: H,
    onViewChange: ee,
    onChange: Oe,
    focusedView: K,
    onFocusedViewChange: X
  }), De = Tt((Ee) => {
    be(Ee, "finish");
  });
  D.useEffect(() => {
    if (s.current === null)
      return;
    const Ee = s.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
    if (!Ee)
      return;
    const _e = Ee.offsetTop;
    (m || K) && Ee.focus(), s.current.scrollTop = _e - 4;
  });
  const ie = D.useCallback((Ee) => {
    const _e = U0(E, o), Ve = () => !(k && _e(k, Ee) || P && _e(Ee, P) || _ && _e(Ee, ge) || L && _e(ge, Ee)), Re = () => o.getMinutes(Ee) % F !== 0 ? !1 : N ? !N(Ee, "hours") : !0;
    return !Ve() || !Re();
  }, [E, o, k, P, _, ge, L, F, N]), fe = D.useMemo(() => {
    const Ee = o.startOfDay(me);
    return [Ee, ...Array.from({
      length: Math.ceil(24 * 60 / h) - 1
    }, (_e, Ve) => o.addMinutes(Ee, h * (Ve + 1)))];
  }, [me, h, o]), ye = fe.findIndex((Ee) => o.isEqual(Ee, me));
  return /* @__PURE__ */ I(w$e, O({
    ref: l,
    className: Ne(de.root, ne),
    ownerState: we
  }, U, {
    children: /* @__PURE__ */ I(T$e, {
      role: "listbox",
      "aria-label": pe.timePickerToolbarTitle,
      className: de.list,
      children: fe.map((Ee, _e) => {
        if (Z && ie(Ee))
          return null;
        const Ve = o.isEqual(Ee, G), Re = o.format(Ee, p ? "fullTime12h" : "fullTime24h"), lt = ye === _e || ye === -1 && _e === 0 ? 0 : -1;
        return /* @__PURE__ */ I(se, O({
          onClick: () => !J && De(Ee),
          selected: Ve,
          disabled: Y || ie(Ee),
          disableRipple: J,
          role: "option",
          "aria-disabled": J,
          "aria-selected": Ve,
          tabIndex: lt
        }, ve, {
          children: Re
        }), Re);
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (K3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: r.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: r.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: r.arrayOf(r.oneOf(["hours"]))
});
function R$e(e) {
  return xn("MuiMultiSectionDigitalClock", e);
}
const kV = Cn("MuiMultiSectionDigitalClock", ["root"]);
function O$e(e) {
  return xn("MuiMultiSectionDigitalClockSection", e);
}
const P$e = Cn("MuiMultiSectionDigitalClockSection", ["root", "item"]), $$e = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], D$e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    item: ["item"]
  }, O$e, t);
}, k$e = ce(hT, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  maxHeight: j3,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&::after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  },
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
})), M$e = ce(Ev, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: Sb,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : Mt(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), N$e = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = D.useRef(null), s = ro(n, o), l = D.useRef(null), u = We({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: p,
    onChange: h,
    className: m,
    disabled: b,
    readOnly: x,
    items: S,
    active: R,
    slots: T,
    slotProps: E,
    skipDisabled: P
  } = u, k = Te(u, $$e), _ = D.useMemo(() => O({}, u, {
    alreadyRendered: !!o.current
  }), [u]), L = D$e(_), F = (T == null ? void 0 : T.digitalClockSectionItem) ?? M$e;
  D.useEffect(() => {
    if (o.current === null)
      return;
    const V = o.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
    if (R && p && V && V.focus(), !V || l.current === V)
      return;
    l.current = V;
    const z = V.offsetTop;
    o.current.scrollTop = z - 4;
  });
  const N = S.findIndex((V) => V.isFocused(V.value));
  return /* @__PURE__ */ I(k$e, O({
    ref: s,
    className: Ne(L.root, m),
    ownerState: _,
    autoFocusItem: p && R,
    role: "listbox"
  }, k, {
    children: S.map((V, z) => {
      var ne;
      const H = (ne = V.isDisabled) == null ? void 0 : ne.call(V, V.value), ee = b || H;
      if (P && ee)
        return null;
      const K = V.isSelected(V.value), X = N === z || N === -1 && z === 0 ? 0 : -1;
      return /* @__PURE__ */ I(F, O({
        onClick: () => !x && h(V.value),
        selected: K,
        disabled: ee,
        disableRipple: x,
        role: "option",
        "aria-disabled": x || ee || void 0,
        "aria-label": V.ariaLabel,
        "aria-selected": K,
        tabIndex: X,
        className: L.item
      }, E == null ? void 0 : E.digitalClockSectionItem, {
        children: V.label
      }), V.label);
    })
  }));
}), I$e = ({
  now: e,
  value: t,
  utils: n,
  ampm: o,
  isDisabled: s,
  resolveAriaLabel: l,
  timeStep: u,
  valueOrReferenceDate: p
}) => {
  const h = t ? n.getHours(t) : null, m = [], b = (R, T) => {
    const E = T ?? h;
    return E === null ? !1 : o ? R === 12 ? E === 12 || E === 0 : E === R || E - 12 === R : E === R;
  }, x = (R) => b(R, n.getHours(p)), S = o ? 11 : 23;
  for (let R = 0; R <= S; R += u) {
    let T = n.format(n.setHours(e, R), o ? "hours12h" : "hours24h");
    const E = l(parseInt(T, 10).toString());
    T = n.formatNumber(T), m.push({
      value: R,
      label: T,
      isSelected: b,
      isDisabled: s,
      isFocused: x,
      ariaLabel: E
    });
  }
  return m;
}, MV = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: o,
  resolveLabel: s,
  resolveAriaLabel: l,
  hasValue: u = !0
}) => {
  const p = (m) => e === null ? !1 : u && e === m, h = (m) => e === m;
  return [...Array.from({
    length: Math.ceil(60 / o)
  }, (m, b) => {
    const x = o * b;
    return {
      value: x,
      label: t.formatNumber(s(x)),
      isDisabled: n,
      isSelected: p,
      isFocused: h,
      ariaLabel: l(x.toString())
    };
  })];
}, _$e = ["ampm", "timeSteps", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], A$e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, R$e, t);
}, L$e = ce(zT, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), X3 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = sn(), s = We({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: l = o.is12HourCycleInCurrentLocale(),
    timeSteps: u,
    autoFocus: p,
    slots: h,
    slotProps: m,
    value: b,
    defaultValue: x,
    referenceDate: S,
    disableIgnoringDatePartForTimeValidation: R = !1,
    maxTime: T,
    minTime: E,
    disableFuture: P,
    disablePast: k,
    minutesStep: _ = 1,
    shouldDisableTime: L,
    onChange: F,
    view: N,
    views: V = ["hours", "minutes"],
    openTo: z,
    onViewChange: H,
    focusedView: ee,
    onFocusedViewChange: K,
    className: X,
    disabled: ne,
    readOnly: Y,
    skipDisabled: J = !1,
    timezone: te
  } = s, Z = Te(s, _$e), {
    value: ae,
    handleValueChange: U,
    timezone: G
  } = Fv({
    name: "MultiSectionDigitalClock",
    timezone: te,
    value: b,
    defaultValue: x,
    onChange: F,
    valueManager: go
  }), W = oo(), le = Cp(G), pe = D.useMemo(() => O({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, u), [u]), ge = HM({
    value: ae,
    referenceDate: S,
    utils: o,
    props: s,
    timezone: G
  }), we = Tt((Ve, Re, lt) => U(Ve, Re, lt)), de = D.useMemo(() => !l || !V.includes("hours") || V.includes("meridiem") ? V : [...V, "meridiem"], [l, V]), {
    view: se,
    setValueAndGoToNextView: ve,
    focusedView: me
  } = H0({
    view: N,
    views: de,
    openTo: z,
    onViewChange: H,
    onChange: we,
    focusedView: ee,
    onFocusedViewChange: K
  }), Oe = Tt((Ve) => {
    ve(Ve, "finish", "meridiem");
  }), {
    meridiemMode: be,
    handleMeridiemChange: De
  } = FT(ge, l, Oe, "finish"), ie = D.useCallback((Ve, Re) => {
    const lt = U0(R, o), Pt = Re === "hours" || Re === "minutes" && de.includes("seconds"), at = ({
      start: bt,
      end: Nt
    }) => !(E && lt(E, Nt) || T && lt(bt, T) || P && lt(bt, le) || k && lt(le, Pt ? Nt : bt)), it = (bt, Nt = 1) => {
      if (bt % Nt !== 0)
        return !1;
      if (L)
        switch (Re) {
          case "hours":
            return !L(o.setHours(ge, bt), "hours");
          case "minutes":
            return !L(o.setMinutes(ge, bt), "minutes");
          case "seconds":
            return !L(o.setSeconds(ge, bt), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (Re) {
      case "hours": {
        const bt = n0(Ve, be, l), Nt = o.setHours(ge, bt), en = o.setSeconds(o.setMinutes(Nt, 0), 0), fn = o.setSeconds(o.setMinutes(Nt, 59), 59);
        return !at({
          start: en,
          end: fn
        }) || !it(bt);
      }
      case "minutes": {
        const bt = o.setMinutes(ge, Ve), Nt = o.setSeconds(bt, 0), en = o.setSeconds(bt, 59);
        return !at({
          start: Nt,
          end: en
        }) || !it(Ve, _);
      }
      case "seconds": {
        const bt = o.setSeconds(ge, Ve);
        return !at({
          start: bt,
          end: bt
        }) || !it(Ve);
      }
      default:
        throw new Error("not supported");
    }
  }, [l, ge, R, T, be, E, _, L, o, P, k, le, de]), fe = D.useCallback((Ve) => {
    switch (Ve) {
      case "hours":
        return {
          onChange: (Re) => {
            const lt = n0(Re, be, l);
            ve(o.setHours(ge, lt), "finish", "hours");
          },
          items: I$e({
            now: le,
            value: ae,
            ampm: l,
            utils: o,
            isDisabled: (Re) => ie(Re, "hours"),
            timeStep: pe.hours,
            resolveAriaLabel: W.hoursClockNumberText,
            valueOrReferenceDate: ge
          })
        };
      case "minutes":
        return {
          onChange: (Re) => {
            ve(o.setMinutes(ge, Re), "finish", "minutes");
          },
          items: MV({
            value: o.getMinutes(ge),
            utils: o,
            isDisabled: (Re) => ie(Re, "minutes"),
            resolveLabel: (Re) => o.format(o.setMinutes(le, Re), "minutes"),
            timeStep: pe.minutes,
            hasValue: !!ae,
            resolveAriaLabel: W.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (Re) => {
            ve(o.setSeconds(ge, Re), "finish", "seconds");
          },
          items: MV({
            value: o.getSeconds(ge),
            utils: o,
            isDisabled: (Re) => ie(Re, "seconds"),
            resolveLabel: (Re) => o.format(o.setSeconds(le, Re), "seconds"),
            timeStep: pe.seconds,
            hasValue: !!ae,
            resolveAriaLabel: W.secondsClockNumberText
          })
        };
      case "meridiem": {
        const Re = Zs(o, "am"), lt = Zs(o, "pm");
        return {
          onChange: De,
          items: [{
            value: "am",
            label: Re,
            isSelected: () => !!ae && be === "am",
            isFocused: () => !!ge && be === "am",
            ariaLabel: Re
          }, {
            value: "pm",
            label: lt,
            isSelected: () => !!ae && be === "pm",
            isFocused: () => !!ge && be === "pm",
            ariaLabel: lt
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${Ve} found.`);
    }
  }, [le, ae, l, o, pe.hours, pe.minutes, pe.seconds, W.hoursClockNumberText, W.minutesClockNumberText, W.secondsClockNumberText, be, ve, ge, ie, De]), ye = D.useMemo(() => de.reduce((Ve, Re) => O({}, Ve, {
    [Re]: fe(Re)
  }), {}), [de, fe]), Ee = s, _e = A$e(Ee);
  return /* @__PURE__ */ I(L$e, O({
    ref: n,
    className: Ne(_e.root, X),
    ownerState: Ee,
    role: "group"
  }, Z, {
    children: Object.entries(ye).map(([Ve, Re]) => /* @__PURE__ */ I(N$e, {
      items: Re.items,
      onChange: Re.onChange,
      active: se === Ve,
      autoFocus: p ?? me === Ve,
      disabled: ne,
      readOnly: Y,
      slots: h,
      slotProps: m,
      skipDisabled: J,
      "aria-label": W.selectViewText(Ve)
    }, Ve))
  }));
});
process.env.NODE_ENV !== "production" && (X3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: r.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: r.shape({
    hours: r.number,
    minutes: r.number,
    seconds: r.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: r.arrayOf(r.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
function F$e(e) {
  return xn("MuiPickersDay", e);
}
const Ff = Cn("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), j$e = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], V$e = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: o,
    today: s,
    disabled: l,
    outsideCurrentMonth: u,
    showDaysOutsideCurrentMonth: p,
    classes: h
  } = e, m = u && !p;
  return vn({
    root: ["root", t && !m && "selected", l && "disabled", !n && "dayWithMargin", !o && s && "today", u && p && "dayOutsideMonth", m && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, F$e, h);
}, Q3 = ({
  theme: e
}) => O({}, e.typography.caption, {
  width: r0,
  height: r0,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : Mt(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${Ff.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Ff.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Ff.disabled}:not(.${Ff.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Ff.disabled}&.${Ff.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${jT}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${Ff.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), J3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, B$e = ce(ui, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: J3
})(Q3), z$e = ce("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: J3
})(({
  theme: e
}) => O({}, Q3({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), fb = () => {
}, Z3 = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: s = !1,
    className: l,
    day: u,
    disabled: p = !1,
    disableHighlightToday: h = !1,
    disableMargin: m = !1,
    isAnimating: b,
    onClick: x,
    onDaySelect: S,
    onFocus: R = fb,
    onBlur: T = fb,
    onKeyDown: E = fb,
    onMouseDown: P = fb,
    onMouseEnter: k = fb,
    outsideCurrentMonth: _,
    selected: L = !1,
    showDaysOutsideCurrentMonth: F = !1,
    children: N,
    today: V = !1
  } = o, z = Te(o, j$e), H = O({}, o, {
    autoFocus: s,
    disabled: p,
    disableHighlightToday: h,
    disableMargin: m,
    selected: L,
    showDaysOutsideCurrentMonth: F,
    today: V
  }), ee = V$e(H), K = sn(), X = D.useRef(null), ne = ro(X, n);
  Hc(() => {
    s && !p && !b && !_ && X.current.focus();
  }, [s, p, b, _]);
  const Y = (te) => {
    P(te), _ && te.preventDefault();
  }, J = (te) => {
    p || S(u), _ && te.currentTarget.focus(), x && x(te);
  };
  return _ && !F ? /* @__PURE__ */ I(z$e, {
    className: Ne(ee.root, ee.hiddenDaySpacingFiller, l),
    ownerState: H,
    role: z.role
  }) : /* @__PURE__ */ I(B$e, O({
    className: Ne(ee.root, l),
    ref: ne,
    centerRipple: !0,
    disabled: p,
    tabIndex: L ? 0 : -1,
    onKeyDown: (te) => E(te, u),
    onFocus: (te) => R(te, u),
    onBlur: (te) => T(te, u),
    onMouseEnter: (te) => k(te, u),
    onClick: J,
    onMouseDown: Y
  }, z, {
    ownerState: H,
    children: N || K.format(u, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (Z3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focusVisible: r.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  component: r.elementType,
  /**
   * The date to show.
   */
  day: r.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: r.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  isAnimating: r.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: r.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: r.bool.isRequired,
  onBlur: r.func,
  onDaySelect: r.func.isRequired,
  onFocus: r.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: r.func,
  onKeyDown: r.func,
  onMouseEnter: r.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: r.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: r.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: r.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: r.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      pulsate: r.func.isRequired,
      start: r.func.isRequired,
      stop: r.func.isRequired
    })
  })])
});
const U$e = /* @__PURE__ */ D.memo(Z3);
function eU(e, t, n, o) {
  const {
    value: s,
    onError: l
  } = e, u = xp(), p = D.useRef(o), h = t({
    adapter: u,
    value: s,
    props: e
  });
  return D.useEffect(() => {
    l && !n(h, p.current) && l(h, s), p.current = h;
  }, [n, l, p, h, s]), h;
}
const H$e = ({
  utils: e,
  format: t
}) => {
  let n = 10, o = t, s = e.expandFormat(t);
  for (; s !== o; )
    if (o = s, s = e.expandFormat(o), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return s;
}, W$e = ({
  utils: e,
  expandedFormat: t
}) => {
  const n = [], {
    start: o,
    end: s
  } = e.escapedCharacters, l = new RegExp(`(\\${o}[^\\${s}]*\\${s})+`, "g");
  let u = null;
  for (; u = l.exec(t); )
    n.push({
      start: u.index,
      end: l.lastIndex - 1
    });
  return n;
}, q$e = (e, t, n, o, s) => {
  switch (o.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, t), s).length,
        format: s
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: o.contentType,
        format: s
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: s
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: o.contentType,
        format: s
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: s
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: s
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: s
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: s
      });
    default:
      return s;
  }
}, Y$e = ({
  utils: e,
  timezone: t,
  date: n,
  shouldRespectLeadingZeros: o,
  localeText: s,
  localizedDigits: l,
  now: u,
  token: p,
  startSeparator: h
}) => {
  if (p === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const m = VM(e, p), b = Y3(e, t, m.contentType, m.type, p), x = o ? b : m.contentType === "digit", S = n != null && e.isValid(n);
  let R = S ? e.formatByString(n, p) : "", T = null;
  if (x)
    if (b)
      T = R === "" ? e.formatByString(u, p).length : R.length;
    else {
      if (m.maxLength == null)
        throw new Error(`MUI X: The token ${p} should have a 'maxDigitNumber' property on it's adapter`);
      T = m.maxLength, S && (R = BM(H3(ap(R, l), T), l));
    }
  return O({}, m, {
    format: p,
    maxLength: T,
    value: R,
    placeholder: q$e(e, t, s, m, p),
    hasLeadingZerosInFormat: b,
    hasLeadingZerosInInput: x,
    startSeparator: h,
    endSeparator: "",
    modified: !1
  });
}, G$e = (e) => {
  var R;
  const {
    utils: t,
    expandedFormat: n,
    escapedParts: o
  } = e, s = t.date(void 0), l = [];
  let u = "";
  const p = Object.keys(t.formatTokenMap).sort((T, E) => E.length - T.length), h = /^([a-zA-Z]+)/, m = new RegExp(`^(${p.join("|")})*$`), b = new RegExp(`^(${p.join("|")})`), x = (T) => o.find((E) => E.start <= T && E.end >= T);
  let S = 0;
  for (; S < n.length; ) {
    const T = x(S), E = T != null, P = (R = h.exec(n.slice(S))) == null ? void 0 : R[1];
    if (!E && P != null && m.test(P)) {
      let k = P;
      for (; k.length > 0; ) {
        const _ = b.exec(k)[1];
        k = k.slice(_.length), l.push(Y$e(O({}, e, {
          now: s,
          token: _,
          startSeparator: u
        }))), u = "";
      }
      S += P.length;
    } else {
      const k = n[S];
      E && (T == null ? void 0 : T.start) === S || (T == null ? void 0 : T.end) === S || (l.length === 0 ? u += k : l[l.length - 1].endSeparator += k), S += 1;
    }
  }
  return l.length === 0 && u.length > 0 && l.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: u,
    endSeparator: "",
    modified: !1
  }), l;
}, K$e = ({
  isRtl: e,
  formatDensity: t,
  sections: n
}) => n.map((o) => {
  const s = (l) => {
    let u = l;
    return e && u !== null && u.includes(" ") && (u = `⁩${u}⁦`), t === "spacious" && ["/", ".", "-"].includes(u) && (u = ` ${u} `), u;
  };
  return o.startSeparator = s(o.startSeparator), o.endSeparator = s(o.endSeparator), o;
}), NV = (e) => {
  let t = H$e(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const n = W$e(O({}, e, {
    expandedFormat: t
  })), o = G$e(O({}, e, {
    expandedFormat: t,
    escapedParts: n
  }));
  return K$e(O({}, e, {
    sections: o
  }));
}, X$e = (e) => {
  const t = sn(), n = oo(), o = xp(), s = vs(), {
    valueManager: l,
    fieldValueManager: u,
    valueType: p,
    validator: h,
    internalProps: m,
    internalProps: {
      value: b,
      defaultValue: x,
      referenceDate: S,
      onChange: R,
      format: T,
      formatDensity: E = "dense",
      selectedSections: P,
      onSelectedSectionsChange: k,
      shouldRespectLeadingZeros: _ = !1,
      timezone: L,
      enableAccessibleFieldDOMStructure: F = !1
    }
  } = e, {
    timezone: N,
    value: V,
    handleValueChange: z
  } = jM({
    timezone: L,
    value: b,
    defaultValue: x,
    onChange: R,
    valueManager: l
  }), H = D.useMemo(() => n$e(t), [t]), ee = D.useMemo(() => s$e(t, H, N), [t, H, N]), K = D.useCallback((de, se = null) => u.getSectionsFromValue(t, de, se, (ve) => NV({
    utils: t,
    timezone: N,
    localeText: n,
    localizedDigits: H,
    format: T,
    date: ve,
    formatDensity: E,
    shouldRespectLeadingZeros: _,
    enableAccessibleFieldDOMStructure: F,
    isRtl: s
  })), [u, T, n, H, s, _, t, E, N, F]), [X, ne] = D.useState(() => {
    const de = K(V);
    PV(de, p);
    const se = {
      sections: de,
      value: V,
      referenceValue: l.emptyValue,
      tempValueStrAndroid: null
    }, ve = JPe(de), me = l.getInitialReferenceValue({
      referenceDate: S,
      value: V,
      utils: t,
      props: m,
      granularity: ve,
      timezone: N
    });
    return O({}, se, {
      referenceValue: me
    });
  }), [Y, J] = op({
    controlled: P,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), te = (de) => {
    J(de), k == null || k(de);
  }, Z = D.useMemo(() => hD(Y, X.sections), [Y, X.sections]), ae = Z === "all" ? 0 : Z, U = ({
    value: de,
    referenceValue: se,
    sections: ve
  }) => {
    if (ne((Oe) => O({}, Oe, {
      sections: ve,
      value: de,
      referenceValue: se,
      tempValueStrAndroid: null
    })), l.areValuesEqual(t, X.value, de))
      return;
    const me = {
      validationError: h({
        adapter: o,
        value: de,
        props: O({}, m, {
          value: de,
          timezone: N
        })
      })
    };
    z(de, me);
  }, G = (de, se) => {
    const ve = [...X.sections];
    return ve[de] = O({}, ve[de], {
      value: se,
      modified: !0
    }), ve;
  }, W = () => {
    U({
      value: l.emptyValue,
      referenceValue: X.referenceValue,
      sections: K(l.emptyValue)
    });
  }, le = () => {
    if (ae == null)
      return;
    const de = X.sections[ae], se = u.getActiveDateManager(t, X, de), me = se.getSections(X.sections).filter((ie) => ie.value !== "").length === (de.value === "" ? 0 : 1), Oe = G(ae, ""), be = me ? null : t.getInvalidDate(), De = se.getNewValuesFromNewActiveDate(be);
    U(O({}, De, {
      sections: Oe
    }));
  }, pe = (de) => {
    const se = (Oe, be) => {
      const De = t.parse(Oe, T);
      if (De == null || !t.isValid(De))
        return null;
      const ie = NV({
        utils: t,
        timezone: N,
        localeText: n,
        localizedDigits: H,
        format: T,
        date: De,
        formatDensity: E,
        shouldRespectLeadingZeros: _,
        enableAccessibleFieldDOMStructure: F,
        isRtl: s
      });
      return DV(t, N, De, ie, be, !1);
    }, ve = u.parseValueStr(de, X.referenceValue, se), me = u.updateReferenceValue(t, ve, X.referenceValue);
    U({
      value: ve,
      referenceValue: me,
      sections: K(ve, X.sections)
    });
  }, ge = ({
    activeSection: de,
    newSectionValue: se,
    shouldGoToNextSection: ve
  }) => {
    ve && ae < X.sections.length - 1 && te(ae + 1);
    const me = u.getActiveDateManager(t, X, de), Oe = G(ae, se), be = me.getSections(Oe), De = o$e(t, be, H);
    let ie, fe;
    if (De != null && t.isValid(De)) {
      const ye = DV(t, N, De, be, me.referenceDate, !0);
      ie = me.getNewValuesFromNewActiveDate(ye), fe = !0;
    } else
      ie = me.getNewValuesFromNewActiveDate(De), fe = (De != null && !t.isValid(De)) != (me.date != null && !t.isValid(me.date));
    return fe ? U(O({}, ie, {
      sections: Oe
    })) : ne((ye) => O({}, ye, ie, {
      sections: Oe,
      tempValueStrAndroid: null
    }));
  }, we = (de) => ne((se) => O({}, se, {
    tempValueStrAndroid: de
  }));
  return D.useEffect(() => {
    const de = K(X.value);
    PV(de, p), ne((se) => O({}, se, {
      sections: de
    }));
  }, [T, t.locale, s]), D.useEffect(() => {
    let de;
    l.areValuesEqual(t, X.value, V) ? de = l.getTimezone(t, X.value) !== l.getTimezone(t, V) : de = !0, de && ne((se) => O({}, se, {
      value: V,
      referenceValue: u.updateReferenceValue(t, V, se.referenceValue),
      sections: K(V)
    }));
  }, [V]), {
    state: X,
    activeSectionIndex: ae,
    parsedSelectedSections: Z,
    setSelectedSections: te,
    clearValue: W,
    clearActiveSection: le,
    updateSectionValue: ge,
    updateValueFromValueStr: pe,
    setTempAndroidValueStr: we,
    getSectionsFromValue: K,
    sectionsValueBoundaries: ee,
    localizedDigits: H,
    timezone: N
  };
}, Q$e = 5e3, Om = (e) => e.saveQuery != null, J$e = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  localizedDigits: o,
  setTempAndroidValueStr: s,
  timezone: l
}) => {
  const u = sn(), [p, h] = D.useState(null), m = Tt(() => h(null));
  D.useEffect(() => {
    var T;
    p != null && ((T = e[p.sectionIndex]) == null ? void 0 : T.type) !== p.sectionType && m();
  }, [e, p, m]), D.useEffect(() => {
    if (p != null) {
      const T = setTimeout(() => m(), Q$e);
      return () => {
        clearTimeout(T);
      };
    }
    return () => {
    };
  }, [p, m]);
  const b = ({
    keyPressed: T,
    sectionIndex: E
  }, P, k) => {
    const _ = T.toLowerCase(), L = e[E];
    if (p != null && (!k || k(p.value)) && p.sectionIndex === E) {
      const N = `${p.value}${_}`, V = P(N, L);
      if (!Om(V))
        return h({
          sectionIndex: E,
          value: N,
          sectionType: L.type
        }), V;
    }
    const F = P(_, L);
    return Om(F) && !F.saveQuery ? (m(), null) : (h({
      sectionIndex: E,
      value: _,
      sectionType: L.type
    }), Om(F) ? null : F);
  }, x = (T) => {
    const E = (_, L, F) => {
      const N = L.filter((V) => V.toLowerCase().startsWith(F));
      return N.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: N[0],
        shouldGoToNextSection: N.length === 1
      };
    }, P = (_, L, F, N) => {
      const V = (z) => U3(u, l, L.type, z);
      if (L.contentType === "letter")
        return E(L.format, V(L.format), _);
      if (F && N != null && VM(u, F).contentType === "letter") {
        const z = V(F), H = E(F, z, _);
        return Om(H) ? {
          saveQuery: !1
        } : O({}, H, {
          sectionValue: N(H.sectionValue, z)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return b(T, (_, L) => {
      switch (L.type) {
        case "month": {
          const F = (N) => RV(u, N, u.formats.month, L.format);
          return P(_, L, u.formats.month, F);
        }
        case "weekDay": {
          const F = (N, V) => V.indexOf(N).toString();
          return P(_, L, u.formats.weekday, F);
        }
        case "meridiem":
          return P(_, L);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, S = (T) => {
    const E = (k, _) => {
      const L = ap(k, o), F = Number(L), N = n[_.type]({
        currentDate: null,
        format: _.format,
        contentType: _.contentType
      });
      if (F > N.maximum)
        return {
          saveQuery: !1
        };
      if (F < N.minimum)
        return {
          saveQuery: !0
        };
      const V = F * 10 > N.maximum || L.length === N.maximum.toString().length;
      return {
        sectionValue: W3(u, F, N, o, _),
        shouldGoToNextSection: V
      };
    };
    return b(T, (k, _) => {
      if (_.contentType === "digit" || _.contentType === "digit-with-letter")
        return E(k, _);
      if (_.type === "month") {
        const L = Y3(u, l, "digit", "month", "MM"), F = E(k, {
          type: _.type,
          format: "MM",
          hasLeadingZerosInFormat: L,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (Om(F))
          return F;
        const N = RV(u, F.sectionValue, "MM", _.format);
        return O({}, F, {
          sectionValue: N
        });
      }
      if (_.type === "weekDay") {
        const L = E(k, _);
        if (Om(L))
          return L;
        const F = UT(u, l, _.format)[Number(L.sectionValue) - 1];
        return O({}, L, {
          sectionValue: F
        });
      }
      return {
        saveQuery: !1
      };
    }, (k) => EV(k, o));
  };
  return {
    applyCharacterEditing: Tt((T) => {
      const E = e[T.sectionIndex], k = EV(T.keyPressed, o) ? S(O({}, T, {
        keyPressed: BM(T.keyPressed, o)
      })) : x(T);
      if (k == null) {
        s(null);
        return;
      }
      t({
        activeSection: E,
        newSectionValue: k.sectionValue,
        shouldGoToNextSection: k.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: m
  };
};
function Gm(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const Z$e = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, ss = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? ss(t.shadowRoot) : t : null;
}, WM = "@media (pointer: fine)", eDe = (e) => {
  const {
    internalProps: {
      disabled: t,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: o,
      onBlur: s,
      onClick: l,
      onFocus: u,
      onInput: p,
      onPaste: h,
      focused: m,
      autoFocus: b = !1
    },
    fieldValueManager: x,
    applyCharacterEditing: S,
    resetCharacterQuery: R,
    setSelectedSections: T,
    parsedSelectedSections: E,
    state: P,
    clearActiveSection: k,
    clearValue: _,
    updateSectionValue: L,
    updateValueFromValueStr: F,
    sectionOrder: N,
    areAllSectionsEmpty: V,
    sectionsValueBoundaries: z
  } = e, H = D.useRef(null), ee = ro(o, H), K = oo(), X = sn(), ne = bp(), [Y, J] = D.useState(!1), te = D.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!H.current)
        return;
      const fe = document.getSelection();
      if (!fe)
        return;
      if (E == null) {
        fe.rangeCount > 0 && H.current.getRoot().contains(fe.getRangeAt(0).startContainer) && fe.removeAllRanges(), Y && H.current.getRoot().blur();
        return;
      }
      if (!H.current.getRoot().contains(ss(document)))
        return;
      const ye = new window.Range();
      let Ee;
      E === "all" ? Ee = H.current.getRoot() : P.sections[E].type === "empty" ? Ee = H.current.getSectionContainer(E) : Ee = H.current.getSectionContent(E), ye.selectNodeContents(Ee), Ee.focus(), fe.removeAllRanges(), fe.addRange(ye);
    },
    getActiveSectionIndexFromDOM: () => {
      const fe = ss(document);
      return !fe || !H.current || !H.current.getRoot().contains(fe) ? null : H.current.getSectionIndexFromDOMElement(fe);
    },
    focusField: (fe = 0) => {
      if (!H.current)
        return;
      const ye = hD(fe, P.sections);
      J(!0), H.current.getSectionContent(ye).focus();
    },
    setSelectedSections: (fe) => {
      if (!H.current)
        return;
      const ye = hD(fe, P.sections);
      J((ye === "all" ? 0 : ye) !== null), T(fe);
    },
    isFieldFocused: () => {
      const fe = ss(document);
      return !!H.current && H.current.getRoot().contains(fe);
    }
  }), [E, T, P.sections, Y]), Z = Tt((fe) => {
    if (!H.current)
      return;
    const ye = P.sections[fe];
    H.current.getSectionContent(fe).innerHTML = ye.value || ye.placeholder, te.syncSelectionToDOM();
  }), ae = Tt((fe, ...ye) => {
    fe.isDefaultPrevented() || !H.current || (J(!0), l == null || l(fe, ...ye), E === "all" ? setTimeout(() => {
      const Ee = document.getSelection().getRangeAt(0).startOffset;
      if (Ee === 0) {
        T(N.startIndex);
        return;
      }
      let _e = 0, Ve = 0;
      for (; Ve < Ee && _e < P.sections.length; ) {
        const Re = P.sections[_e];
        _e += 1, Ve += `${Re.startSeparator}${Re.value || Re.placeholder}${Re.endSeparator}`.length;
      }
      T(_e - 1);
    }) : Y ? H.current.getRoot().contains(fe.target) || T(N.startIndex) : (J(!0), T(N.startIndex)));
  }), U = Tt((fe) => {
    if (p == null || p(fe), !H.current || E !== "all")
      return;
    const Ee = fe.target.textContent ?? "";
    H.current.getRoot().innerHTML = P.sections.map((_e) => `${_e.startSeparator}${_e.value || _e.placeholder}${_e.endSeparator}`).join(""), te.syncSelectionToDOM(), Ee.length === 0 || Ee.charCodeAt(0) === 10 ? (R(), _(), T("all")) : Ee.length > 1 ? F(Ee) : S({
      keyPressed: Ee,
      sectionIndex: 0
    });
  }), G = Tt((fe) => {
    if (h == null || h(fe), n || E !== "all") {
      fe.preventDefault();
      return;
    }
    const ye = fe.clipboardData.getData("text");
    fe.preventDefault(), R(), F(ye);
  }), W = Tt((...fe) => {
    if (u == null || u(...fe), Y || !H.current)
      return;
    J(!0), H.current.getSectionIndexFromDOMElement(ss(document)) != null || T(N.startIndex);
  }), le = Tt((...fe) => {
    s == null || s(...fe), setTimeout(() => {
      if (!H.current)
        return;
      const ye = ss(document);
      !H.current.getRoot().contains(ye) && (J(!1), T(null));
    });
  }), pe = Tt((fe) => (ye) => {
    ye.isDefaultPrevented() || n || T(fe);
  }), ge = Tt((fe) => {
    fe.preventDefault();
  }), we = Tt((fe) => () => {
    n || T(fe);
  }), de = Tt((fe) => {
    if (fe.preventDefault(), n || typeof E != "number")
      return;
    const ye = P.sections[E], Ee = fe.clipboardData.getData("text"), _e = /^[a-zA-Z]+$/.test(Ee), Ve = /^[0-9]+$/.test(Ee), Re = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(Ee);
    ye.contentType === "letter" && _e || ye.contentType === "digit" && Ve || ye.contentType === "digit-with-letter" && Re ? (R(), L({
      activeSection: ye,
      newSectionValue: Ee,
      shouldGoToNextSection: !0
    })) : !_e && !Ve && (R(), F(Ee));
  }), se = Tt((fe) => {
    fe.preventDefault(), fe.dataTransfer.dropEffect = "none";
  }), ve = Tt((fe) => {
    if (!H.current)
      return;
    const ye = fe.target, Ee = ye.textContent ?? "", _e = H.current.getSectionIndexFromDOMElement(ye), Ve = P.sections[_e];
    if (n || !H.current) {
      Z(_e);
      return;
    }
    if (Ee.length === 0) {
      if (Ve.value === "") {
        Z(_e);
        return;
      }
      const Re = fe.nativeEvent.inputType;
      if (Re === "insertParagraph" || Re === "insertLineBreak") {
        Z(_e);
        return;
      }
      R(), k();
      return;
    }
    S({
      keyPressed: Ee,
      sectionIndex: _e
    }), Z(_e);
  });
  Hc(() => {
    if (!(!Y || !H.current)) {
      if (E === "all")
        H.current.getRoot().focus();
      else if (typeof E == "number") {
        const fe = H.current.getSectionContent(E);
        fe && fe.focus();
      }
    }
  }, [E, Y]);
  const me = D.useMemo(() => P.sections.reduce((fe, ye) => (fe[ye.type] = z[ye.type]({
    currentDate: null,
    contentType: ye.contentType,
    format: ye.format
  }), fe), {}), [z, P.sections]), Oe = E === "all", be = D.useMemo(() => P.sections.map((fe, ye) => {
    const Ee = !Oe && !t && !n;
    return {
      container: {
        "data-sectionindex": ye,
        onClick: pe(ye)
      },
      content: {
        tabIndex: Oe || ye > 0 ? -1 : 0,
        contentEditable: !Oe && !t && !n,
        role: "spinbutton",
        id: `${ne}-${fe.type}`,
        "aria-labelledby": `${ne}-${fe.type}`,
        "aria-readonly": n,
        "aria-valuenow": f$e(fe, X),
        "aria-valuemin": me[fe.type].minimum,
        "aria-valuemax": me[fe.type].maximum,
        "aria-valuetext": fe.value ? d$e(fe, X) : K.empty,
        "aria-label": K[fe.type],
        "aria-disabled": t,
        spellCheck: Ee ? !1 : void 0,
        autoCapitalize: Ee ? "off" : void 0,
        autoCorrect: Ee ? "off" : void 0,
        [parseInt(D.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: Ee ? "next" : void 0,
        children: fe.value || fe.placeholder,
        onInput: ve,
        onPaste: de,
        onFocus: we(ye),
        onDragOver: se,
        onMouseUp: ge,
        inputMode: fe.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: fe.startSeparator
      },
      after: {
        children: fe.endSeparator
      }
    };
  }), [P.sections, we, de, se, ve, pe, ge, t, n, Oe, K, X, me, ne]), De = Tt((fe) => {
    F(fe.target.value);
  }), ie = D.useMemo(() => V ? "" : x.getV7HiddenInputValueFromSections(P.sections), [V, P.sections, x]);
  return D.useEffect(() => {
    if (H.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    b && H.current && H.current.getSectionContent(N.startIndex).focus();
  }, []), {
    interactions: te,
    returnedValue: {
      // Forwarded
      autoFocus: b,
      readOnly: n,
      focused: m ?? Y,
      sectionListRef: ee,
      onBlur: le,
      onClick: ae,
      onFocus: W,
      onInput: U,
      onPaste: G,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: be,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: E === 0 ? -1 : 0,
      contentEditable: Oe,
      value: ie,
      onChange: De,
      areAllSectionsEmpty: V
    }
  };
}, Qm = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), tDe = (e, t, n) => {
  let o = 0, s = n ? 1 : 0;
  const l = [];
  for (let u = 0; u < e.length; u += 1) {
    const p = e[u], h = zM(p, n ? "input-rtl" : "input-ltr", t), m = `${p.startSeparator}${h}${p.endSeparator}`, b = Qm(m).length, x = m.length, S = Qm(h), R = s + (S === "" ? 0 : h.indexOf(S[0])) + p.startSeparator.length, T = R + S.length;
    l.push(O({}, p, {
      start: o,
      end: o + b,
      startInInput: R,
      endInInput: T
    })), o += b, s += x;
  }
  return l;
}, nDe = (e) => {
  const t = vs(), n = D.useRef(), {
    forwardedProps: {
      onFocus: o,
      onClick: s,
      onPaste: l,
      onBlur: u,
      inputRef: p,
      placeholder: h
    },
    internalProps: {
      readOnly: m = !1
    },
    parsedSelectedSections: b,
    activeSectionIndex: x,
    state: S,
    fieldValueManager: R,
    valueManager: T,
    applyCharacterEditing: E,
    resetCharacterQuery: P,
    updateSectionValue: k,
    updateValueFromValueStr: _,
    clearActiveSection: L,
    clearValue: F,
    setTempAndroidValueStr: N,
    setSelectedSections: V,
    getSectionsFromValue: z,
    areAllSectionsEmpty: H,
    localizedDigits: ee
  } = e, K = D.useRef(null), X = ro(p, K), ne = D.useMemo(() => tDe(S.sections, ee, t), [S.sections, ee, t]), Y = D.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!K.current)
        return;
      if (b == null) {
        K.current.scrollLeft && (K.current.scrollLeft = 0);
        return;
      }
      if (K.current !== ss(document))
        return;
      const de = K.current.scrollTop;
      if (b === "all")
        K.current.select();
      else {
        const se = ne[b], ve = se.type === "empty" ? se.startInInput - se.startSeparator.length : se.startInInput, me = se.type === "empty" ? se.endInInput + se.endSeparator.length : se.endInInput;
        (ve !== K.current.selectionStart || me !== K.current.selectionEnd) && K.current === ss(document) && K.current.setSelectionRange(ve, me);
      }
      K.current.scrollTop = de;
    },
    getActiveSectionIndexFromDOM: () => {
      var Oe;
      const de = K.current.selectionStart ?? 0, se = K.current.selectionEnd ?? 0, ve = !!((Oe = K.current) != null && Oe.readOnly);
      if (de === 0 && se === 0 || ve)
        return null;
      const me = de <= ne[0].startInInput ? 1 : ne.findIndex((be) => be.startInInput - be.startSeparator.length > de);
      return me === -1 ? ne.length - 1 : me - 1;
    },
    focusField: (de = 0) => {
      var se;
      (se = K.current) == null || se.focus(), V(de);
    },
    setSelectedSections: (de) => V(de),
    isFieldFocused: () => K.current === ss(document)
  }), [K, b, ne, V]), J = () => {
    if (m) {
      V(null);
      return;
    }
    const de = K.current.selectionStart ?? 0;
    let se;
    de <= ne[0].startInInput || de >= ne[ne.length - 1].endInInput ? se = 1 : se = ne.findIndex((me) => me.startInInput - me.startSeparator.length > de);
    const ve = se === -1 ? ne.length - 1 : se - 1;
    V(ve);
  }, te = Tt((...de) => {
    o == null || o(...de);
    const se = K.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !se || se !== K.current || x != null || m || (// avoid selecting all sections when focusing empty field without value
      se.value.length && Number(se.selectionEnd) - Number(se.selectionStart) === se.value.length ? V("all") : J());
    });
  }), Z = Tt((de, ...se) => {
    de.isDefaultPrevented() || (s == null || s(de, ...se), J());
  }), ae = Tt((de) => {
    if (l == null || l(de), de.preventDefault(), m)
      return;
    const se = de.clipboardData.getData("text");
    if (typeof b == "number") {
      const ve = S.sections[b], me = /^[a-zA-Z]+$/.test(se), Oe = /^[0-9]+$/.test(se), be = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(se);
      if (ve.contentType === "letter" && me || ve.contentType === "digit" && Oe || ve.contentType === "digit-with-letter" && be) {
        P(), k({
          activeSection: ve,
          newSectionValue: se,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (me || Oe)
        return;
    }
    P(), _(se);
  }), U = Tt((...de) => {
    u == null || u(...de), V(null);
  }), G = Tt((de) => {
    if (m)
      return;
    const se = de.target.value;
    if (se === "") {
      P(), F();
      return;
    }
    const ve = de.nativeEvent.data, me = ve && ve.length > 1, Oe = me ? ve : se, be = Qm(Oe);
    if (x == null || me) {
      _(me ? ve : be);
      return;
    }
    let De;
    if (b === "all" && be.length === 1)
      De = be;
    else {
      const ie = Qm(R.getV6InputValueFromSections(ne, ee, t));
      let fe = -1, ye = -1;
      for (let Re = 0; Re < ie.length; Re += 1)
        fe === -1 && ie[Re] !== be[Re] && (fe = Re), ye === -1 && ie[ie.length - Re - 1] !== be[be.length - Re - 1] && (ye = Re);
      const Ee = ne[x];
      if (fe < Ee.start || ie.length - ye - 1 > Ee.end)
        return;
      const Ve = be.length - ie.length + Ee.end - Qm(Ee.endSeparator || "").length;
      De = be.slice(Ee.start + Qm(Ee.startSeparator || "").length, Ve);
    }
    if (De.length === 0) {
      c$e() ? N(Oe) : (P(), L());
      return;
    }
    E({
      keyPressed: De,
      sectionIndex: x
    });
  }), W = D.useMemo(() => h !== void 0 ? h : R.getV6InputValueFromSections(z(T.emptyValue), ee, t), [h, R, z, T.emptyValue, ee, t]), le = D.useMemo(() => S.tempValueStrAndroid ?? R.getV6InputValueFromSections(S.sections, ee, t), [S.sections, R, S.tempValueStrAndroid, ee, t]);
  D.useEffect(() => (K.current && K.current === ss(document) && V("all"), () => {
    clearTimeout(n.current);
  }), []);
  const pe = D.useMemo(() => x == null || S.sections[x].contentType === "letter" ? "text" : "numeric", [x, S.sections]), we = !(K.current && K.current === ss(document)) && H;
  return {
    interactions: Y,
    returnedValue: {
      // Forwarded
      readOnly: m,
      onBlur: U,
      onClick: Z,
      onFocus: te,
      onPaste: ae,
      inputRef: X,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: W,
      inputMode: pe,
      autoComplete: "off",
      value: we ? "" : le,
      onChange: G
    }
  };
}, qM = (e) => {
  const t = sn(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: o,
      minutesStep: s,
      enableAccessibleFieldDOMStructure: l = !1,
      disabled: u = !1,
      readOnly: p = !1
    },
    forwardedProps: {
      onKeyDown: h,
      error: m,
      clearable: b,
      onClear: x
    },
    fieldValueManager: S,
    valueManager: R,
    validator: T
  } = e, E = vs(), P = X$e(e), {
    state: k,
    activeSectionIndex: _,
    parsedSelectedSections: L,
    setSelectedSections: F,
    clearValue: N,
    clearActiveSection: V,
    updateSectionValue: z,
    setTempAndroidValueStr: H,
    sectionsValueBoundaries: ee,
    localizedDigits: K,
    timezone: X
  } = P, ne = J$e({
    sections: k.sections,
    updateSectionValue: z,
    sectionsValueBoundaries: ee,
    localizedDigits: K,
    setTempAndroidValueStr: H,
    timezone: X
  }), {
    resetCharacterQuery: Y
  } = ne, J = R.areValuesEqual(t, k.value, R.emptyValue), te = l ? eDe : nDe, Z = D.useMemo(() => u$e(k.sections, E && !l), [k.sections, E, l]), {
    returnedValue: ae,
    interactions: U
  } = te(O({}, e, P, ne, {
    areAllSectionsEmpty: J,
    sectionOrder: Z
  })), G = Tt((de) => {
    switch (h == null || h(de), !0) {
      case ((de.ctrlKey || de.metaKey) && de.key.toLowerCase() === "a" && !de.shiftKey && !de.altKey): {
        de.preventDefault(), F("all");
        break;
      }
      case de.key === "ArrowRight": {
        if (de.preventDefault(), L == null)
          F(Z.startIndex);
        else if (L === "all")
          F(Z.endIndex);
        else {
          const se = Z.neighbors[L].rightIndex;
          se !== null && F(se);
        }
        break;
      }
      case de.key === "ArrowLeft": {
        if (de.preventDefault(), L == null)
          F(Z.endIndex);
        else if (L === "all")
          F(Z.startIndex);
        else {
          const se = Z.neighbors[L].leftIndex;
          se !== null && F(se);
        }
        break;
      }
      case de.key === "Delete": {
        if (de.preventDefault(), p)
          break;
        L == null || L === "all" ? N() : V(), Y();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(de.key): {
        if (de.preventDefault(), p || _ == null)
          break;
        const se = k.sections[_], ve = S.getActiveDateManager(t, k, se), me = r$e(t, X, se, de.key, ee, K, ve.date, {
          minutesStep: s
        });
        z({
          activeSection: se,
          newSectionValue: me,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  Hc(() => {
    U.syncSelectionToDOM();
  });
  const W = eU(O({}, n, {
    value: k.value,
    timezone: X
  }), T, R.isSameError, R.defaultErrorState), le = D.useMemo(() => m !== void 0 ? m : R.hasError(W), [R, W, m]);
  D.useEffect(() => {
    !le && _ == null && Y();
  }, [k.referenceValue, _, le]), D.useEffect(() => {
    k.tempValueStrAndroid != null && _ != null && (Y(), V());
  }, [k.sections]), D.useImperativeHandle(o, () => ({
    getSections: () => k.sections,
    getActiveSectionIndex: U.getActiveSectionIndexFromDOM,
    setSelectedSections: U.setSelectedSections,
    focusField: U.focusField,
    isFieldFocused: U.isFieldFocused
  }));
  const pe = Tt((de, ...se) => {
    de.preventDefault(), x == null || x(de, ...se), N(), U.isFieldFocused() ? F(Z.startIndex) : U.focusField(0);
  }), ge = {
    onKeyDown: G,
    onClear: pe,
    error: le,
    clearable: !!(b && !J && !p && !u)
  }, we = {
    disabled: u,
    readOnly: p
  };
  return O({}, e.forwardedProps, ge, we, ae);
}, W0 = ({
  props: e,
  value: t,
  adapter: n
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: o,
    shouldDisableMonth: s,
    shouldDisableYear: l,
    disablePast: u,
    disableFuture: p,
    timezone: h
  } = e, m = n.utils.date(void 0, h), b = pa(n.utils, e.minDate, n.defaultDates.minDate), x = pa(n.utils, e.maxDate, n.defaultDates.maxDate);
  switch (!0) {
    case !n.utils.isValid(t):
      return "invalidDate";
    case !!(o && o(t)):
      return "shouldDisableDate";
    case !!(s && s(t)):
      return "shouldDisableMonth";
    case !!(l && l(t)):
      return "shouldDisableYear";
    case !!(p && n.utils.isAfterDay(t, m)):
      return "disableFuture";
    case !!(u && n.utils.isBeforeDay(t, m)):
      return "disablePast";
    case !!(b && n.utils.isBeforeDay(t, b)):
      return "minDate";
    case !!(x && n.utils.isAfterDay(t, x)):
      return "maxDate";
    default:
      return null;
  }
}, mD = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], vD = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], tU = ["minDateTime", "maxDateTime"], rDe = [...mD, ...vD, ...tU], jv = (e) => rDe.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), oDe = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], YM = (e, t) => {
  const n = O({}, e), o = {}, s = (l) => {
    n.hasOwnProperty(l) && (o[l] = n[l], delete n[l]);
  };
  return oDe.forEach(s), t === "date" ? mD.forEach(s) : t === "time" ? vD.forEach(s) : t === "date-time" && (mD.forEach(s), vD.forEach(s), tU.forEach(s)), {
    forwardedProps: n,
    internalProps: o
  };
}, aDe = (e) => {
  const t = sn(), n = Sp();
  return O({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? t.formats.keyboardDate,
    minDate: pa(t, e.minDate, n.minDate),
    maxDate: pa(t, e.maxDate, n.maxDate)
  });
}, iDe = (e) => {
  const t = sn(), o = e.ampm ?? t.is12HourCycleInCurrentLocale() ? t.formats.fullTime12h : t.formats.fullTime24h;
  return O({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? o
  });
}, sDe = (e) => {
  const t = sn(), n = Sp(), s = e.ampm ?? t.is12HourCycleInCurrentLocale() ? t.formats.keyboardDateTime12h : t.formats.keyboardDateTime24h;
  return O({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? s,
    disableIgnoringDatePartForTimeValidation: !!(e.minDateTime || e.maxDateTime),
    minDate: pa(t, e.minDateTime ?? e.minDate, n.minDate),
    maxDate: pa(t, e.maxDateTime ?? e.maxDate, n.maxDate),
    minTime: e.minDateTime ?? e.minTime,
    maxTime: e.maxDateTime ?? e.maxTime
  });
}, lDe = (e) => {
  const t = aDe(e), {
    forwardedProps: n,
    internalProps: o
  } = YM(t, "date");
  return qM({
    forwardedProps: n,
    internalProps: o,
    valueManager: go,
    fieldValueManager: UM,
    validator: W0,
    valueType: "date"
  });
}, cDe = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], uDe = ["ownerState"], GM = (e) => {
  const t = oo(), {
    clearable: n,
    onClear: o,
    InputProps: s,
    sx: l,
    slots: u,
    slotProps: p
  } = e, h = Te(e, cDe), m = (u == null ? void 0 : u.clearButton) ?? oi, b = Yn({
    elementType: m,
    externalSlotProps: p == null ? void 0 : p.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: t.fieldClearLabel
    }
  }), x = Te(b, uDe), S = (u == null ? void 0 : u.clearIcon) ?? lPe, R = Yn({
    elementType: S,
    externalSlotProps: p == null ? void 0 : p.clearIcon,
    ownerState: {}
  });
  return O({}, h, {
    InputProps: O({}, s, {
      endAdornment: /* @__PURE__ */ qe(D.Fragment, {
        children: [n && /* @__PURE__ */ I(pT, {
          position: "end",
          sx: {
            marginRight: s != null && s.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ I(m, O({}, x, {
            onClick: o,
            children: /* @__PURE__ */ I(S, O({
              fontSize: "small"
            }, R))
          }))
        }), s == null ? void 0 : s.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(l) ? l : [l]]
  });
};
function dDe(e) {
  return xn("MuiPickersTextField", e);
}
Cn("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function fDe(e) {
  return xn("MuiPickersInputBase", e);
}
const nv = Cn("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function pDe(e) {
  return xn("MuiPickersSectionList", e);
}
const pb = Cn("MuiPickersSectionList", ["root", "section", "sectionContent"]), hDe = ["slots", "slotProps", "elements", "sectionListRef"], nU = ce("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), rU = ce("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})({}), oU = ce("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (e, t) => t.sectionSeparator
})({
  whiteSpace: "pre"
}), aU = ce("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.sectionContent
})({
  outline: "none"
}), mDe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, pDe, t);
};
function vDe(e) {
  const {
    slots: t,
    slotProps: n,
    element: o,
    classes: s
  } = e, l = (t == null ? void 0 : t.section) ?? rU, u = Yn({
    elementType: l,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: o.container,
    className: s.section,
    ownerState: {}
  }), p = (t == null ? void 0 : t.sectionContent) ?? aU, h = Yn({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: o.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: s.sectionContent,
    ownerState: {}
  }), m = (t == null ? void 0 : t.sectionSeparator) ?? oU, b = Yn({
    elementType: m,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: o.before,
    ownerState: {
      position: "before"
    }
  }), x = Yn({
    elementType: m,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: o.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ qe(l, O({}, u, {
    children: [/* @__PURE__ */ I(m, O({}, b)), /* @__PURE__ */ I(p, O({}, h)), /* @__PURE__ */ I(m, O({}, x))]
  }));
}
const iU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: s,
    slotProps: l,
    elements: u,
    sectionListRef: p
  } = o, h = Te(o, hDe), m = mDe(o), b = D.useRef(null), x = ro(n, b), S = (E) => {
    if (!b.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${E} before the mount of the component.`);
    return b.current;
  };
  D.useImperativeHandle(p, () => ({
    getRoot() {
      return S("getRoot");
    },
    getSectionContainer(E) {
      return S("getSectionContainer").querySelector(`.${pb.section}[data-sectionindex="${E}"]`);
    },
    getSectionContent(E) {
      return S("getSectionContent").querySelector(`.${pb.section}[data-sectionindex="${E}"] .${pb.sectionContent}`);
    },
    getSectionIndexFromDOMElement(E) {
      const P = S("getSectionIndexFromDOMElement");
      if (E == null || !P.contains(E))
        return null;
      let k = null;
      return E.classList.contains(pb.section) ? k = E : E.classList.contains(pb.sectionContent) && (k = E.parentElement), k == null ? null : Number(k.dataset.sectionindex);
    }
  }));
  const R = (s == null ? void 0 : s.root) ?? nU, T = Yn({
    elementType: R,
    externalSlotProps: l == null ? void 0 : l.root,
    externalForwardedProps: h,
    additionalProps: {
      ref: x,
      suppressContentEditableWarning: !0
    },
    className: m.root,
    ownerState: {}
  });
  return /* @__PURE__ */ I(R, O({}, T, {
    children: T.contentEditable ? u.map(({
      content: E,
      before: P,
      after: k
    }) => `${P.children}${E.children}${k.children}`).join("") : /* @__PURE__ */ I(D.Fragment, {
      children: u.map((E, P) => /* @__PURE__ */ I(vDe, {
        slots: s,
        slotProps: l,
        element: E,
        classes: m
      }, P))
    })
  }));
});
process.env.NODE_ENV !== "production" && (iU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   */
  slots: r.object
});
const gDe = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], yDe = (e) => Math.round(e * 1e5) / 1e5, HT = ce("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => O({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${yDe(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), KM = ce(nU, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: t,
      focused: n,
      filled: o,
      label: s
    }) => !t && !n && !o && s == null,
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), bDe = ce(rU, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "flex"
})), xDe = ce(aU, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), SDe = ce(oU, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), CDe = ce("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
})(O({}, UOe)), wDe = (e) => {
  const {
    focused: t,
    disabled: n,
    error: o,
    classes: s,
    fullWidth: l,
    readOnly: u,
    color: p,
    size: h,
    endAdornment: m,
    startAdornment: b
  } = e, x = {
    root: ["root", t && !n && "focused", n && "disabled", u && "readOnly", o && "error", l && "fullWidth", `color${AT(p)}`, h === "small" && "inputSizeSmall", !!b && "adornedStart", !!m && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return vn(x, fDe, s);
}, WT = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: s,
    areAllSectionsEmpty: l,
    value: u,
    onChange: p,
    id: h,
    endAdornment: m,
    startAdornment: b,
    renderSuffix: x,
    slots: S,
    slotProps: R,
    contentEditable: T,
    tabIndex: E,
    onInput: P,
    onPaste: k,
    onKeyDown: _,
    name: L,
    readOnly: F,
    inputProps: N,
    inputRef: V,
    sectionListRef: z
  } = o, H = Te(o, gDe), ee = D.useRef(null), K = ro(n, ee), X = ro(N == null ? void 0 : N.ref, V), ne = vs(), Y = mi();
  if (!Y)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const J = (W) => {
    var le;
    if (Y.disabled) {
      W.stopPropagation();
      return;
    }
    (le = Y.onFocus) == null || le.call(Y, W);
  };
  D.useEffect(() => {
    Y && Y.setAdornedStart(!!b);
  }, [Y, b]), D.useEffect(() => {
    Y && (l ? Y.onEmpty() : Y.onFilled());
  }, [Y, l]);
  const te = O({}, o, Y, {
    isRtl: ne
  }), Z = wDe(te), ae = (S == null ? void 0 : S.root) || HT, U = Yn({
    elementType: ae,
    externalSlotProps: R == null ? void 0 : R.root,
    externalForwardedProps: H,
    additionalProps: {
      "aria-invalid": Y.error,
      ref: K
    },
    className: Z.root,
    ownerState: te
  }), G = (S == null ? void 0 : S.input) || KM;
  return /* @__PURE__ */ qe(ae, O({}, U, {
    children: [b, /* @__PURE__ */ I(iU, {
      sectionListRef: z,
      elements: s,
      contentEditable: T,
      tabIndex: E,
      className: Z.sectionsContainer,
      onFocus: J,
      onBlur: Y.onBlur,
      onInput: P,
      onPaste: k,
      onKeyDown: _,
      slots: {
        root: G,
        section: bDe,
        sectionContent: xDe,
        sectionSeparator: SDe
      },
      slotProps: {
        root: {
          ownerState: te
        },
        sectionContent: {
          className: nv.sectionContent
        },
        sectionSeparator: ({
          position: W
        }) => ({
          className: W === "before" ? nv.sectionBefore : nv.sectionAfter
        })
      }
    }), m, x ? x(O({}, Y)) : null, /* @__PURE__ */ I(CDe, O({
      name: L,
      className: Z.input,
      value: u,
      onChange: p,
      id: h,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: F,
      required: Y.required,
      disabled: Y.disabled
    }, N, {
      ref: X
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (WT.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Ko,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
function TDe(e) {
  return xn("MuiPickersOutlinedInput", e);
}
const Ys = O({}, nv, Cn("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), EDe = ["children", "className", "label", "notched", "shrink"], RDe = ce("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), IV = ce("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), ODe = ce("legend")(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function PDe(e) {
  const {
    className: t,
    label: n
  } = e, o = Te(e, EDe), s = n != null && n !== "", l = O({}, e, {
    withLabel: s
  });
  return /* @__PURE__ */ I(RDe, O({
    "aria-hidden": !0,
    className: t
  }, o, {
    ownerState: l,
    children: /* @__PURE__ */ I(ODe, {
      ownerState: l,
      children: s ? /* @__PURE__ */ I(IV, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ I(IV, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const $De = ["label", "autoFocus", "ownerState", "notched"], DDe = ce(HT, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Ys.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ys.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Ys.focused} .${Ys.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${Ys.disabled}`]: {
      [`& .${Ys.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${Ys.error} .${Ys.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((n) => {
      var o;
      return ((o = (e.vars ?? e).palette[n]) == null ? void 0 : o.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Ys.focused}:not(.${Ys.error}) .${Ys.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[n].main
        }
      }
    }))
  };
}), kDe = ce(KM, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), MDe = (e) => {
  const {
    classes: t
  } = e, o = vn({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, TDe, t);
  return O({}, t, o);
}, XM = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: s,
    ownerState: l,
    notched: u
  } = o, p = Te(o, $De), h = mi(), m = O({}, o, l, h, {
    color: (h == null ? void 0 : h.color) || "primary"
  }), b = MDe(m);
  return /* @__PURE__ */ I(WT, O({
    slots: {
      root: DDe,
      input: kDe
    },
    renderSuffix: (x) => /* @__PURE__ */ I(PDe, {
      shrink: !!(u || x.adornedStart || x.focused || x.filled),
      notched: !!(u || x.adornedStart || x.focused || x.filled),
      className: b.notchedOutline,
      label: s != null && s !== "" && (h != null && h.required) ? /* @__PURE__ */ qe(D.Fragment, {
        children: [s, " ", "*"]
      }) : s,
      ownerState: m
    })
  }, p, {
    label: s,
    classes: b,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (XM.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Ko,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  notched: r.bool,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
XM.muiName = "Input";
let gD;
typeof document == "object" && (gD = PD({
  key: "css",
  prepend: !0
}));
function sU(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && gD ? /* @__PURE__ */ I(wB, {
    value: gD,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (sU.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: r.bool
});
function NDe(e) {
  return e == null || Object.keys(e).length === 0;
}
function lU(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ I(MD, {
    styles: typeof t == "function" ? (s) => t(NDe(s) ? n : s) : t
  });
}
process.env.NODE_ENV !== "production" && (lU.propTypes = {
  defaultTheme: r.object,
  styles: r.oneOfType([r.array, r.string, r.object, r.func])
});
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function IDe(e, t) {
  const n = B1(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((l) => l === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
const _De = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, ADe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: lU,
  StyledEngineProvider: sU,
  ThemeContext: yd,
  css: Bc,
  default: IDe,
  internal_processStyles: _De,
  keyframes: tl
}, Symbol.toStringTag, { value: "Module" })), LDe = ["values", "unit", "step"], FDe = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => O({}, n, {
    [o.key]: o.val
  }), {});
};
function cU(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5
  } = e, s = Te(e, LDe), l = FDe(t), u = Object.keys(l);
  function p(S) {
    return `@media (min-width:${typeof t[S] == "number" ? t[S] : S}${n})`;
  }
  function h(S) {
    return `@media (max-width:${(typeof t[S] == "number" ? t[S] : S) - o / 100}${n})`;
  }
  function m(S, R) {
    const T = u.indexOf(R);
    return `@media (min-width:${typeof t[S] == "number" ? t[S] : S}${n}) and (max-width:${(T !== -1 && typeof t[u[T]] == "number" ? t[u[T]] : R) - o / 100}${n})`;
  }
  function b(S) {
    return u.indexOf(S) + 1 < u.length ? m(S, u[u.indexOf(S) + 1]) : p(S);
  }
  function x(S) {
    const R = u.indexOf(S);
    return R === 0 ? p(u[1]) : R === u.length - 1 ? h(u[R]) : m(S, u[u.indexOf(S) + 1]).replace("@media", "@media not all and");
  }
  return O({
    keys: u,
    values: l,
    up: p,
    down: h,
    between: m,
    only: b,
    not: x,
    unit: n
  }, s);
}
const jDe = {
  borderRadius: 4
}, Td = process.env.NODE_ENV !== "production" ? r.oneOfType([r.number, r.string, r.object, r.array]) : {};
function Ib(e, t) {
  return t ? t0(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const QM = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, _V = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${QM[e]}px)`
};
function Wc(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const l = o.breakpoints || _V;
    return t.reduce((u, p, h) => (u[l.up(l.keys[h])] = n(t[h]), u), {});
  }
  if (typeof t == "object") {
    const l = o.breakpoints || _V;
    return Object.keys(t).reduce((u, p) => {
      if (Object.keys(l.values || QM).indexOf(p) !== -1) {
        const h = l.up(p);
        u[h] = n(t[p], p);
      } else {
        const h = p;
        u[h] = t[h];
      }
      return u;
    }, {});
  }
  return n(t);
}
function VDe(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((o, s) => {
    const l = e.up(s);
    return o[l] = {}, o;
  }, {})) || {};
}
function BDe(e, t) {
  return e.reduce((n, o) => {
    const s = n[o];
    return (!s || Object.keys(s).length === 0) && delete n[o], n;
  }, t);
}
function qT(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((s, l) => s && s[l] ? s[l] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, s) => o && o[s] != null ? o[s] : null, e);
}
function yw(e, t, n, o = n) {
  let s;
  return typeof e == "function" ? s = e(n) : Array.isArray(e) ? s = e[n] || o : s = qT(e, n) || o, t && (s = t(s, o, e)), s;
}
function Yr(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: s
  } = e, l = (u) => {
    if (u[t] == null)
      return null;
    const p = u[t], h = u.theme, m = qT(h, o) || {};
    return Wc(u, p, (x) => {
      let S = yw(m, s, x);
      return x === S && typeof x == "string" && (S = yw(m, s, `${t}${x === "default" ? "" : AT(x)}`, x)), n === !1 ? S : {
        [n]: S
      };
    });
  };
  return l.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Td
  } : {}, l.filterProps = [t], l;
}
function zDe(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const UDe = {
  m: "margin",
  p: "padding"
}, HDe = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, AV = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, WDe = zDe((e) => {
  if (e.length > 2)
    if (AV[e])
      e = AV[e];
    else
      return [e];
  const [t, n] = e.split(""), o = UDe[t], s = HDe[n] || "";
  return Array.isArray(s) ? s.map((l) => o + l) : [o + s];
}), YT = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], GT = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], qDe = [...YT, ...GT];
function q0(e, t, n, o) {
  var s;
  const l = (s = qT(e, t, !1)) != null ? s : n;
  return typeof l == "number" ? (u) => typeof u == "string" ? u : (process.env.NODE_ENV !== "production" && typeof u != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${u}.`), l * u) : Array.isArray(l) ? (u) => typeof u == "string" ? u : (process.env.NODE_ENV !== "production" && (Number.isInteger(u) ? u > l.length - 1 && console.error([`MUI: The value provided (${u}) overflows.`, `The supported values are: ${JSON.stringify(l)}.`, `${u} > ${l.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), l[u]) : typeof l == "function" ? l : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${l}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function uU(e) {
  return q0(e, "spacing", 8, "spacing");
}
function Y0(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), o = e(n);
  return t >= 0 ? o : typeof o == "number" ? -o : `-${o}`;
}
function YDe(e, t) {
  return (n) => e.reduce((o, s) => (o[s] = Y0(t, n), o), {});
}
function GDe(e, t, n, o) {
  if (t.indexOf(n) === -1)
    return null;
  const s = WDe(n), l = YDe(s, o), u = e[n];
  return Wc(e, u, l);
}
function dU(e, t) {
  const n = uU(e.theme);
  return Object.keys(e).map((o) => GDe(e, t, o, n)).reduce(Ib, {});
}
function _r(e) {
  return dU(e, YT);
}
_r.propTypes = process.env.NODE_ENV !== "production" ? YT.reduce((e, t) => (e[t] = Td, e), {}) : {};
_r.filterProps = YT;
function Ar(e) {
  return dU(e, GT);
}
Ar.propTypes = process.env.NODE_ENV !== "production" ? GT.reduce((e, t) => (e[t] = Td, e), {}) : {};
Ar.filterProps = GT;
process.env.NODE_ENV !== "production" && qDe.reduce((e, t) => (e[t] = Td, e), {});
function KDe(e = 8) {
  if (e.mui)
    return e;
  const t = uU({
    spacing: e
  }), n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((l) => {
    const u = t(l);
    return typeof u == "number" ? `${u}px` : u;
  }).join(" "));
  return n.mui = !0, n;
}
function KT(...e) {
  const t = e.reduce((o, s) => (s.filterProps.forEach((l) => {
    o[l] = s;
  }), o), {}), n = (o) => Object.keys(o).reduce((s, l) => t[l] ? Ib(s, t[l](o)) : s, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, s) => Object.assign(o, s.propTypes), {}) : {}, n.filterProps = e.reduce((o, s) => o.concat(s.filterProps), []), n;
}
function as(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function gs(e, t) {
  return Yr({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const XDe = gs("border", as), QDe = gs("borderTop", as), JDe = gs("borderRight", as), ZDe = gs("borderBottom", as), eke = gs("borderLeft", as), tke = gs("borderColor"), nke = gs("borderTopColor"), rke = gs("borderRightColor"), oke = gs("borderBottomColor"), ake = gs("borderLeftColor"), ike = gs("outline", as), ske = gs("outlineColor"), XT = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = q0(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: Y0(t, o)
    });
    return Wc(e, e.borderRadius, n);
  }
  return null;
};
XT.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Td
} : {};
XT.filterProps = ["borderRadius"];
KT(XDe, QDe, JDe, ZDe, eke, tke, nke, rke, oke, ake, XT, ike, ske);
const QT = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = q0(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: Y0(t, o)
    });
    return Wc(e, e.gap, n);
  }
  return null;
};
QT.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Td
} : {};
QT.filterProps = ["gap"];
const JT = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = q0(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: Y0(t, o)
    });
    return Wc(e, e.columnGap, n);
  }
  return null;
};
JT.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Td
} : {};
JT.filterProps = ["columnGap"];
const ZT = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = q0(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: Y0(t, o)
    });
    return Wc(e, e.rowGap, n);
  }
  return null;
};
ZT.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Td
} : {};
ZT.filterProps = ["rowGap"];
const lke = Yr({
  prop: "gridColumn"
}), cke = Yr({
  prop: "gridRow"
}), uke = Yr({
  prop: "gridAutoFlow"
}), dke = Yr({
  prop: "gridAutoColumns"
}), fke = Yr({
  prop: "gridAutoRows"
}), pke = Yr({
  prop: "gridTemplateColumns"
}), hke = Yr({
  prop: "gridTemplateRows"
}), mke = Yr({
  prop: "gridTemplateAreas"
}), vke = Yr({
  prop: "gridArea"
});
KT(QT, JT, ZT, lke, cke, uke, dke, fke, pke, hke, mke, vke);
function rv(e, t) {
  return t === "grey" ? t : e;
}
const gke = Yr({
  prop: "color",
  themeKey: "palette",
  transform: rv
}), yke = Yr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: rv
}), bke = Yr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: rv
});
KT(gke, yke, bke);
function _i(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const xke = Yr({
  prop: "width",
  transform: _i
}), JM = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, s;
      const l = ((o = e.theme) == null || (o = o.breakpoints) == null || (o = o.values) == null ? void 0 : o[n]) || QM[n];
      return l ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${l}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: l
      } : {
        maxWidth: _i(n)
      };
    };
    return Wc(e, e.maxWidth, t);
  }
  return null;
};
JM.filterProps = ["maxWidth"];
const Ske = Yr({
  prop: "minWidth",
  transform: _i
}), Cke = Yr({
  prop: "height",
  transform: _i
}), wke = Yr({
  prop: "maxHeight",
  transform: _i
}), Tke = Yr({
  prop: "minHeight",
  transform: _i
});
Yr({
  prop: "size",
  cssProperty: "width",
  transform: _i
});
Yr({
  prop: "size",
  cssProperty: "height",
  transform: _i
});
const Eke = Yr({
  prop: "boxSizing"
});
KT(xke, JM, Ske, Cke, wke, Tke, Eke);
const Rke = {
  // borders
  border: {
    themeKey: "borders",
    transform: as
  },
  borderTop: {
    themeKey: "borders",
    transform: as
  },
  borderRight: {
    themeKey: "borders",
    transform: as
  },
  borderBottom: {
    themeKey: "borders",
    transform: as
  },
  borderLeft: {
    themeKey: "borders",
    transform: as
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: as
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: XT
  },
  // palette
  color: {
    themeKey: "palette",
    transform: rv
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: rv
  },
  backgroundColor: {
    themeKey: "palette",
    transform: rv
  },
  // spacing
  p: {
    style: Ar
  },
  pt: {
    style: Ar
  },
  pr: {
    style: Ar
  },
  pb: {
    style: Ar
  },
  pl: {
    style: Ar
  },
  px: {
    style: Ar
  },
  py: {
    style: Ar
  },
  padding: {
    style: Ar
  },
  paddingTop: {
    style: Ar
  },
  paddingRight: {
    style: Ar
  },
  paddingBottom: {
    style: Ar
  },
  paddingLeft: {
    style: Ar
  },
  paddingX: {
    style: Ar
  },
  paddingY: {
    style: Ar
  },
  paddingInline: {
    style: Ar
  },
  paddingInlineStart: {
    style: Ar
  },
  paddingInlineEnd: {
    style: Ar
  },
  paddingBlock: {
    style: Ar
  },
  paddingBlockStart: {
    style: Ar
  },
  paddingBlockEnd: {
    style: Ar
  },
  m: {
    style: _r
  },
  mt: {
    style: _r
  },
  mr: {
    style: _r
  },
  mb: {
    style: _r
  },
  ml: {
    style: _r
  },
  mx: {
    style: _r
  },
  my: {
    style: _r
  },
  margin: {
    style: _r
  },
  marginTop: {
    style: _r
  },
  marginRight: {
    style: _r
  },
  marginBottom: {
    style: _r
  },
  marginLeft: {
    style: _r
  },
  marginX: {
    style: _r
  },
  marginY: {
    style: _r
  },
  marginInline: {
    style: _r
  },
  marginInlineStart: {
    style: _r
  },
  marginInlineEnd: {
    style: _r
  },
  marginBlock: {
    style: _r
  },
  marginBlockStart: {
    style: _r
  },
  marginBlockEnd: {
    style: _r
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: QT
  },
  rowGap: {
    style: ZT
  },
  columnGap: {
    style: JT
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: _i
  },
  maxWidth: {
    style: JM
  },
  minWidth: {
    transform: _i
  },
  height: {
    transform: _i
  },
  maxHeight: {
    transform: _i
  },
  minHeight: {
    transform: _i
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, eE = Rke;
function Oke(...e) {
  const t = e.reduce((o, s) => o.concat(Object.keys(s)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
function Pke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function fU() {
  function e(n, o, s, l) {
    const u = {
      [n]: o,
      theme: s
    }, p = l[n];
    if (!p)
      return {
        [n]: o
      };
    const {
      cssProperty: h = n,
      themeKey: m,
      transform: b,
      style: x
    } = p;
    if (o == null)
      return null;
    if (m === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const S = qT(s, m) || {};
    return x ? x(u) : Wc(u, o, (T) => {
      let E = yw(S, b, T);
      return T === E && typeof T == "string" && (E = yw(S, b, `${n}${T === "default" ? "" : AT(T)}`, T)), h === !1 ? E : {
        [h]: E
      };
    });
  }
  function t(n) {
    var o;
    const {
      sx: s,
      theme: l = {}
    } = n || {};
    if (!s)
      return null;
    const u = (o = l.unstable_sxConfig) != null ? o : eE;
    function p(h) {
      let m = h;
      if (typeof h == "function")
        m = h(l);
      else if (typeof h != "object")
        return h;
      if (!m)
        return null;
      const b = VDe(l.breakpoints), x = Object.keys(b);
      let S = b;
      return Object.keys(m).forEach((R) => {
        const T = Pke(m[R], l);
        if (T != null)
          if (typeof T == "object")
            if (u[R])
              S = Ib(S, e(R, T, l, u));
            else {
              const E = Wc({
                theme: l
              }, T, (P) => ({
                [R]: P
              }));
              Oke(E, T) ? S[R] = t({
                sx: T,
                theme: l
              }) : S = Ib(S, E);
            }
          else
            S = Ib(S, e(R, T, l, u));
      }), BDe(x, S);
    }
    return Array.isArray(s) ? s.map(p) : p(s);
  }
  return t;
}
const pU = fU();
pU.filterProps = ["sx"];
const hU = pU;
function mU(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const $ke = ["breakpoints", "palette", "spacing", "shape"];
function vU(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: s,
    shape: l = {}
  } = e, u = Te(e, $ke), p = cU(n), h = KDe(s);
  let m = t0({
    breakpoints: p,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: O({
      mode: "light"
    }, o),
    spacing: h,
    shape: O({}, jDe, l)
  }, u);
  return m.applyStyles = mU, m = t.reduce((b, x) => t0(b, x), m), m.unstable_sxConfig = O({}, eE, u == null ? void 0 : u.unstable_sxConfig), m.unstable_sx = function(x) {
    return hU({
      sx: x,
      theme: this
    });
  }, m;
}
const Dke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vU,
  private_createBreakpoints: cU,
  unstable_applyStyles: mU
}, Symbol.toStringTag, { value: "Module" })), kke = ["sx"], Mke = (e) => {
  var t, n;
  const o = {
    systemProps: {},
    otherProps: {}
  }, s = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : eE;
  return Object.keys(e).forEach((l) => {
    s[l] ? o.systemProps[l] = e[l] : o.otherProps[l] = e[l];
  }), o;
};
function Nke(e) {
  const {
    sx: t
  } = e, n = Te(e, kke), {
    systemProps: o,
    otherProps: s
  } = Mke(n);
  let l;
  return Array.isArray(t) ? l = [o, ...t] : typeof t == "function" ? l = (...u) => {
    const p = t(...u);
    return id(p) ? O({}, o, p) : o;
  } : l = O({}, o, t), O({}, s, {
    sx: l
  });
}
const Ike = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hU,
  extendSxProp: Nke,
  unstable_createStyleFunctionSx: fU,
  unstable_defaultSxConfig: eE
}, Symbol.toStringTag, { value: "Module" }));
function _ke(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
vU();
function Ake(e) {
  return xn("MuiPickersFilledInput", e);
}
const jf = O({}, nv, Cn("MuiPickersFilledInput", ["root", "underline", "input"])), Lke = ["label", "autoFocus", "disableUnderline", "ownerState"], Fke = ce(HT, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => _ke(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", l = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${jf.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${jf.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : l
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((u) => (e.vars ?? e).palette[u].main).map((u) => {
      var p;
      return {
        props: {
          color: u,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(p = (e.vars || e).palette[u]) == null ? void 0 : p.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${jf.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${jf.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${jf.disabled}, .${jf.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${jf.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: u
      }) => !!u,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: u
      }) => !!u,
      style: {
        paddingRight: 12
      }
    }]
  };
}), jke = ce(KM, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: e
    }) => !!e,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: e
    }) => !!e,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), Vke = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = vn({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Ake, t);
  return O({}, t, s);
}, ZM = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: s,
    disableUnderline: l = !1,
    ownerState: u
  } = o, p = Te(o, Lke), h = mi(), m = O({}, o, u, h, {
    color: (h == null ? void 0 : h.color) || "primary"
  }), b = Vke(m);
  return /* @__PURE__ */ I(WT, O({
    slots: {
      root: Fke,
      input: jke
    },
    slotProps: {
      root: {
        disableUnderline: l
      }
    }
  }, p, {
    label: s,
    classes: b,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (ZM.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disableUnderline: r.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  hiddenLabel: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Ko,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
ZM.muiName = "Input";
function Bke(e) {
  return xn("MuiPickersFilledInput", e);
}
const hb = O({}, nv, Cn("MuiPickersInput", ["root", "input"])), zke = ["label", "autoFocus", "disableUnderline", "ownerState"], Uke = ce(HT, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((o) => (e.vars ?? e).palette[o].main).map((o) => ({
      props: {
        color: o
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[o].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${hb.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${hb.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${hb.disabled}, .${hb.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${hb.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), Hke = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = vn({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Bke, t);
  return O({}, t, s);
}, eN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: s,
    disableUnderline: l = !1,
    ownerState: u
  } = o, p = Te(o, zke), h = mi(), m = O({}, o, u, h, {
    disableUnderline: l,
    color: (h == null ? void 0 : h.color) || "primary"
  }), b = Hke(m);
  return /* @__PURE__ */ I(WT, O({
    slots: {
      root: Uke
    }
  }, p, {
    label: s,
    classes: b,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (eN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disableUnderline: r.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Ko,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
eN.muiName = "Input";
const Wke = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], qke = {
  standard: eN,
  filled: ZM,
  outlined: XM
}, Yke = ce(Cv, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Gke = (e) => {
  const {
    focused: t,
    disabled: n,
    classes: o,
    required: s
  } = e;
  return vn({
    root: ["root", t && !n && "focused", n && "disabled", s && "required"]
  }, dDe, o);
}, tE = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: s,
    onBlur: l,
    className: u,
    color: p = "primary",
    disabled: h = !1,
    error: m = !1,
    variant: b = "outlined",
    required: x = !1,
    // Props used by PickersInput
    InputProps: S,
    inputProps: R,
    inputRef: T,
    sectionListRef: E,
    elements: P,
    areAllSectionsEmpty: k,
    onClick: _,
    onKeyDown: L,
    onPaste: F,
    onInput: N,
    endAdornment: V,
    startAdornment: z,
    tabIndex: H,
    contentEditable: ee,
    focused: K,
    value: X,
    onChange: ne,
    fullWidth: Y,
    id: J,
    name: te,
    // Props used by FormHelperText
    helperText: Z,
    FormHelperTextProps: ae,
    // Props used by InputLabel
    label: U,
    InputLabelProps: G
  } = o, W = Te(o, Wke), le = D.useRef(null), pe = ro(n, le), ge = bp(J), we = Z && ge ? `${ge}-helper-text` : void 0, de = U && ge ? `${ge}-label` : void 0, se = O({}, o, {
    color: p,
    disabled: h,
    error: m,
    focused: K,
    required: x,
    variant: b
  }), ve = Gke(se), me = qke[b];
  return /* @__PURE__ */ qe(Yke, O({
    className: Ne(ve.root, u),
    ref: pe,
    focused: K,
    onFocus: s,
    onBlur: l,
    disabled: h,
    variant: b,
    error: m,
    color: p,
    fullWidth: Y,
    required: x,
    ownerState: se
  }, W, {
    children: [/* @__PURE__ */ I(S0, O({
      htmlFor: ge,
      id: de
    }, G, {
      children: U
    })), /* @__PURE__ */ I(me, O({
      elements: P,
      areAllSectionsEmpty: k,
      onClick: _,
      onKeyDown: L,
      onInput: N,
      onPaste: F,
      endAdornment: V,
      startAdornment: z,
      tabIndex: H,
      contentEditable: ee,
      value: X,
      onChange: ne,
      id: ge,
      fullWidth: Y,
      inputProps: R,
      inputRef: T,
      sectionListRef: E,
      label: U,
      name: te,
      role: "group",
      "aria-labelledby": de
    }, S)), Z && /* @__PURE__ */ I(ql, O({
      id: we
    }, ae, {
      children: Z
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (tE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disabled: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  error: r.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  FormHelperTextProps: r.object,
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  id: r.string,
  InputLabelProps: r.object,
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  inputRef: Ko,
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onBlur: r.func.isRequired,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onFocus: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  readOnly: r.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: r.bool,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOf(["medium", "small"]),
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const Kke = ["enableAccessibleFieldDOMStructure"], Xke = ["InputProps", "readOnly"], Qke = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], tN = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, n = Te(e, Kke);
  if (t) {
    const {
      InputProps: x,
      readOnly: S
    } = n, R = Te(n, Xke);
    return O({}, R, {
      InputProps: O({}, x ?? {}, {
        readOnly: S
      })
    });
  }
  const {
    onPaste: o,
    onKeyDown: s,
    inputMode: l,
    readOnly: u,
    InputProps: p,
    inputProps: h,
    inputRef: m
  } = n, b = Te(n, Qke);
  return O({}, b, {
    InputProps: O({}, p ?? {}, {
      readOnly: u
    }),
    inputProps: O({}, h ?? {}, {
      inputMode: l,
      onPaste: o,
      onKeyDown: s,
      ref: m
    })
  });
}, Jke = ["slots", "slotProps", "InputProps", "inputProps"], nN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDateField"
  }), {
    slots: s,
    slotProps: l,
    InputProps: u,
    inputProps: p
  } = o, h = Te(o, Jke), m = o, b = (s == null ? void 0 : s.textField) ?? (t.enableAccessibleFieldDOMStructure ? tE : O0), x = Yn({
    elementType: b,
    externalSlotProps: l == null ? void 0 : l.textField,
    externalForwardedProps: h,
    additionalProps: {
      ref: n
    },
    ownerState: m
  });
  x.inputProps = O({}, p, x.inputProps), x.InputProps = O({}, u, x.InputProps);
  const S = lDe(x), R = tN(S), T = GM(O({}, R, {
    slots: s,
    slotProps: l
  }));
  return /* @__PURE__ */ I(b, O({}, T));
});
process.env.NODE_ENV !== "production" && (nN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  onBlur: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  onFocus: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The size of the component.
   */
  size: r.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const nE = ({
  adapter: e,
  value: t,
  props: n
}) => {
  if (t === null)
    return null;
  const {
    minTime: o,
    maxTime: s,
    minutesStep: l,
    shouldDisableTime: u,
    disableIgnoringDatePartForTimeValidation: p = !1,
    disablePast: h,
    disableFuture: m,
    timezone: b
  } = n, x = e.utils.date(void 0, b), S = U0(p, e.utils);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(o && S(o, t)):
      return "minTime";
    case !!(s && S(t, s)):
      return "maxTime";
    case !!(m && e.utils.isAfter(t, x)):
      return "disableFuture";
    case !!(h && e.utils.isBefore(t, x)):
      return "disablePast";
    case !!(u && u(t, "hours")):
      return "shouldDisableTime-hours";
    case !!(u && u(t, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(u && u(t, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(l && e.utils.getMinutes(t) % l !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, Zke = (e) => {
  const t = iDe(e), {
    forwardedProps: n,
    internalProps: o
  } = YM(t, "time");
  return qM({
    forwardedProps: n,
    internalProps: o,
    valueManager: go,
    fieldValueManager: UM,
    validator: nE,
    valueType: "time"
  });
}, eMe = ["slots", "slotProps", "InputProps", "inputProps"], rN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTimeField"
  }), {
    slots: s,
    slotProps: l,
    InputProps: u,
    inputProps: p
  } = o, h = Te(o, eMe), m = o, b = (s == null ? void 0 : s.textField) ?? (t.enableAccessibleFieldDOMStructure ? tE : O0), x = Yn({
    elementType: b,
    externalSlotProps: l == null ? void 0 : l.textField,
    externalForwardedProps: h,
    ownerState: m,
    additionalProps: {
      ref: n
    }
  });
  x.inputProps = O({}, p, x.inputProps), x.InputProps = O({}, u, x.InputProps);
  const S = Zke(x), R = tN(S), T = GM(O({}, R, {
    slots: s,
    slotProps: l
  }));
  return /* @__PURE__ */ I(b, O({}, T));
});
process.env.NODE_ENV !== "production" && (rN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  onBlur: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  onFocus: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The size of the component.
   */
  size: r.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const oN = ({
  props: e,
  value: t,
  adapter: n
}) => {
  const o = W0({
    adapter: n,
    value: t,
    props: e
  });
  return o !== null ? o : nE({
    adapter: n,
    value: t,
    props: e
  });
}, tMe = (e) => {
  const t = sDe(e), {
    forwardedProps: n,
    internalProps: o
  } = YM(t, "date-time");
  return qM({
    forwardedProps: n,
    internalProps: o,
    valueManager: go,
    fieldValueManager: UM,
    validator: oN,
    valueType: "date-time"
  });
}, nMe = ["slots", "slotProps", "InputProps", "inputProps"], aN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDateTimeField"
  }), {
    slots: s,
    slotProps: l,
    InputProps: u,
    inputProps: p
  } = o, h = Te(o, nMe), m = o, b = (s == null ? void 0 : s.textField) ?? (t.enableAccessibleFieldDOMStructure ? tE : O0), x = Yn({
    elementType: b,
    externalSlotProps: l == null ? void 0 : l.textField,
    externalForwardedProps: h,
    ownerState: m,
    additionalProps: {
      ref: n
    }
  });
  x.inputProps = O({}, p, x.inputProps), x.InputProps = O({}, u, x.InputProps);
  const S = tMe(x), R = tN(S), T = GM(O({}, R, {
    slots: s,
    slotProps: l
  }));
  return /* @__PURE__ */ I(b, O({}, T));
});
process.env.NODE_ENV !== "production" && (aN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  onBlur: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  onFocus: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The size of the component.
   */
  size: r.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const gU = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: o,
  maxDate: s,
  disableFuture: l,
  disablePast: u,
  timezone: p
}) => {
  const h = xp();
  return D.useCallback((m) => W0({
    adapter: h,
    value: m,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: o,
      maxDate: s,
      disableFuture: l,
      disablePast: u,
      timezone: p
    }
  }) !== null, [h, e, t, n, o, s, l, u, p]);
}, rMe = (e, t, n) => (o, s) => {
  switch (s.type) {
    case "changeMonth":
      return O({}, o, {
        slideDirection: s.direction,
        currentMonth: s.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "finishMonthSwitchingAnimation":
      return O({}, o, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (o.focusedDay != null && s.focusedDay != null && n.isSameDay(s.focusedDay, o.focusedDay))
        return o;
      const l = s.focusedDay != null && !t && !n.isSameMonth(o.currentMonth, s.focusedDay);
      return O({}, o, {
        focusedDay: s.focusedDay,
        isMonthSwitchingAnimating: l && !e && !s.withoutMonthSwitchingAnimation,
        currentMonth: l ? n.startOfMonth(s.focusedDay) : o.currentMonth,
        slideDirection: s.focusedDay != null && n.isAfterDay(s.focusedDay, o.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, oMe = (e) => {
  const {
    value: t,
    referenceDate: n,
    disableFuture: o,
    disablePast: s,
    disableSwitchToMonthOnDayFocus: l = !1,
    maxDate: u,
    minDate: p,
    onMonthChange: h,
    reduceAnimations: m,
    shouldDisableDate: b,
    timezone: x
  } = e, S = sn(), R = D.useRef(rMe(!!m, l, S)).current, T = D.useMemo(
    () => go.getInitialReferenceValue({
      value: t,
      utils: S,
      timezone: x,
      props: e,
      referenceDate: n,
      granularity: Qs.day
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [E, P] = D.useReducer(R, {
    isMonthSwitchingAnimating: !1,
    focusedDay: T,
    currentMonth: S.startOfMonth(T),
    slideDirection: "left"
  }), k = D.useCallback((V) => {
    P(O({
      type: "changeMonth"
    }, V)), h && h(V.newMonth);
  }, [h]), _ = D.useCallback((V) => {
    const z = V;
    S.isSameMonth(z, E.currentMonth) || k({
      newMonth: S.startOfMonth(z),
      direction: S.isAfterDay(z, E.currentMonth) ? "left" : "right"
    });
  }, [E.currentMonth, k, S]), L = gU({
    shouldDisableDate: b,
    minDate: p,
    maxDate: u,
    disableFuture: o,
    disablePast: s,
    timezone: x
  }), F = D.useCallback(() => {
    P({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), N = Tt((V, z) => {
    L(V) || P({
      type: "changeFocusedDay",
      focusedDay: V,
      withoutMonthSwitchingAnimation: z
    });
  });
  return {
    referenceDate: T,
    calendarState: E,
    changeMonth: _,
    changeFocusedDay: N,
    isDateDisabled: L,
    onMonthSwitchingAnimationEnd: F,
    handleChangeMonth: k
  };
}, aMe = (e) => xn("MuiPickersFadeTransitionGroup", e);
Cn("MuiPickersFadeTransitionGroup", ["root"]);
const iMe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, aMe, t);
}, sMe = ce(m0, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function yU(e) {
  const t = We({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: o,
    reduceAnimations: s,
    transKey: l
  } = t, u = iMe(t), p = Go();
  return s ? n : /* @__PURE__ */ I(sMe, {
    className: Ne(u.root, o),
    children: /* @__PURE__ */ I(sp, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: p.transitions.duration.enteringScreen,
        enter: p.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, l)
  });
}
const lMe = (e) => xn("MuiPickersSlideTransition", e), ts = Cn("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), cMe = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], uMe = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, o = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return vn(o, lMe, t);
}, dMe = ce(m0, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${ts["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${ts["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${ts.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${ts.slideExit}`]: t.slideExit
  }, {
    [`.${ts["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${ts["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${ts["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${ts["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${ts.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${ts.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${ts["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${ts["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function fMe(e) {
  const t = We({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: o,
    reduceAnimations: s,
    transKey: l
    // extracting `classes` from `other`
  } = t, u = Te(t, cMe), p = uMe(t), h = Go();
  if (s)
    return /* @__PURE__ */ I("div", {
      className: Ne(p.root, o),
      children: n
    });
  const m = {
    exit: p.exit,
    enterActive: p.enterActive,
    enter: p.enter,
    exitActive: p.exitActive
  };
  return /* @__PURE__ */ I(dMe, {
    className: Ne(p.root, o),
    childFactory: (b) => /* @__PURE__ */ D.cloneElement(b, {
      classNames: m
    }),
    role: "presentation",
    children: /* @__PURE__ */ I(BD, O({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: h.transitions.duration.complex,
      classNames: m
    }, u, {
      children: n
    }), l)
  });
}
const pMe = (e) => xn("MuiDayCalendar", e);
Cn("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const hMe = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], mMe = ["ownerState"], vMe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, pMe, t);
}, bU = (r0 + jT * 2) * 6, gMe = ce("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), yMe = ce("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), bMe = ce(nr, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), xMe = ce(nr, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), SMe = ce(nr, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => O({}, e.typography.caption, {
  width: r0,
  height: r0,
  padding: 0,
  margin: `0 ${jT}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), CMe = ce("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: bU
}), wMe = ce(fMe, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: bU
}), TMe = ce("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), EMe = ce("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${jT}px 0`,
  display: "flex",
  justifyContent: "center"
});
function RMe(e) {
  let {
    parentProps: t,
    day: n,
    focusableDay: o,
    selectedDays: s,
    isDateDisabled: l,
    currentMonthNumber: u,
    isViewFocused: p
  } = e, h = Te(e, hMe);
  const {
    disabled: m,
    disableHighlightToday: b,
    isMonthSwitchingAnimating: x,
    showDaysOutsideCurrentMonth: S,
    slots: R,
    slotProps: T,
    timezone: E
  } = t, P = sn(), k = Cp(E), _ = o !== null && P.isSameDay(n, o), L = s.some((ne) => P.isSameDay(ne, n)), F = P.isSameDay(n, k), N = (R == null ? void 0 : R.day) ?? U$e, V = Yn({
    elementType: N,
    externalSlotProps: T == null ? void 0 : T.day,
    additionalProps: O({
      disableHighlightToday: b,
      showDaysOutsideCurrentMonth: S,
      role: "gridcell",
      isAnimating: x,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": P.toJsDate(n).valueOf()
    }, h),
    ownerState: O({}, t, {
      day: n,
      selected: L
    })
  }), z = Te(V, mMe), H = D.useMemo(() => m || l(n), [m, l, n]), ee = D.useMemo(() => P.getMonth(n) !== u, [P, n, u]), K = D.useMemo(() => {
    const ne = P.startOfMonth(P.setMonth(n, u));
    return S ? P.isSameDay(n, P.startOfWeek(ne)) : P.isSameDay(n, ne);
  }, [u, n, S, P]), X = D.useMemo(() => {
    const ne = P.endOfMonth(P.setMonth(n, u));
    return S ? P.isSameDay(n, P.endOfWeek(ne)) : P.isSameDay(n, ne);
  }, [u, n, S, P]);
  return /* @__PURE__ */ I(N, O({}, z, {
    day: n,
    disabled: H,
    autoFocus: p && _,
    today: F,
    outsideCurrentMonth: ee,
    isFirstVisibleCell: K,
    isLastVisibleCell: X,
    selected: L,
    tabIndex: _ ? 0 : -1,
    "aria-selected": L,
    "aria-current": F ? "date" : void 0
  }));
}
function OMe(e) {
  const t = We({
    props: e,
    name: "MuiDayCalendar"
  }), n = sn(), {
    onFocusedDayChange: o,
    className: s,
    currentMonth: l,
    selectedDays: u,
    focusedDay: p,
    loading: h,
    onSelectedDaysChange: m,
    onMonthSwitchingAnimationEnd: b,
    readOnly: x,
    reduceAnimations: S,
    renderLoading: R = () => /* @__PURE__ */ I("span", {
      children: "..."
    }),
    slideDirection: T,
    TransitionProps: E,
    disablePast: P,
    disableFuture: k,
    minDate: _,
    maxDate: L,
    shouldDisableDate: F,
    shouldDisableMonth: N,
    shouldDisableYear: V,
    dayOfWeekFormatter: z = (Ve) => n.format(Ve, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: H,
    onFocusedViewChange: ee,
    gridLabelId: K,
    displayWeekNumber: X,
    fixedWeekNumber: ne,
    autoFocus: Y,
    timezone: J
  } = t, te = Cp(J), Z = vMe(t), ae = vs(), U = gU({
    shouldDisableDate: F,
    shouldDisableMonth: N,
    shouldDisableYear: V,
    minDate: _,
    maxDate: L,
    disablePast: P,
    disableFuture: k,
    timezone: J
  }), G = oo(), [W, le] = op({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: H,
    default: Y ?? !1
  }), [pe, ge] = D.useState(() => p || te), we = Tt((Ve) => {
    x || m(Ve);
  }), de = (Ve) => {
    U(Ve) || (o(Ve), ge(Ve), ee == null || ee(!0), le(!0));
  }, se = Tt((Ve, Re) => {
    switch (Ve.key) {
      case "ArrowUp":
        de(n.addDays(Re, -7)), Ve.preventDefault();
        break;
      case "ArrowDown":
        de(n.addDays(Re, 7)), Ve.preventDefault();
        break;
      case "ArrowLeft": {
        const lt = n.addDays(Re, ae ? 1 : -1), Pt = n.addMonths(Re, ae ? 1 : -1), at = Nb({
          utils: n,
          date: lt,
          minDate: ae ? lt : n.startOfMonth(Pt),
          maxDate: ae ? n.endOfMonth(Pt) : lt,
          isDateDisabled: U,
          timezone: J
        });
        de(at || lt), Ve.preventDefault();
        break;
      }
      case "ArrowRight": {
        const lt = n.addDays(Re, ae ? -1 : 1), Pt = n.addMonths(Re, ae ? -1 : 1), at = Nb({
          utils: n,
          date: lt,
          minDate: ae ? n.startOfMonth(Pt) : lt,
          maxDate: ae ? lt : n.endOfMonth(Pt),
          isDateDisabled: U,
          timezone: J
        });
        de(at || lt), Ve.preventDefault();
        break;
      }
      case "Home":
        de(n.startOfWeek(Re)), Ve.preventDefault();
        break;
      case "End":
        de(n.endOfWeek(Re)), Ve.preventDefault();
        break;
      case "PageUp":
        de(n.addMonths(Re, 1)), Ve.preventDefault();
        break;
      case "PageDown":
        de(n.addMonths(Re, -1)), Ve.preventDefault();
        break;
    }
  }), ve = Tt((Ve, Re) => de(Re)), me = Tt((Ve, Re) => {
    W && n.isSameDay(pe, Re) && (ee == null || ee(!1));
  }), Oe = n.getMonth(l), be = n.getYear(l), De = D.useMemo(() => u.filter((Ve) => !!Ve).map((Ve) => n.startOfDay(Ve)), [n, u]), ie = `${be}-${Oe}`, fe = D.useMemo(() => /* @__PURE__ */ D.createRef(), [ie]), ye = n.startOfWeek(te), Ee = D.useMemo(() => {
    const Ve = n.startOfMonth(l), Re = n.endOfMonth(l);
    return U(pe) || n.isAfterDay(pe, Re) || n.isBeforeDay(pe, Ve) ? Nb({
      utils: n,
      date: pe,
      minDate: Ve,
      maxDate: Re,
      disablePast: P,
      disableFuture: k,
      isDateDisabled: U,
      timezone: J
    }) : pe;
  }, [l, k, P, pe, U, n, J]), _e = D.useMemo(() => {
    const Ve = n.setTimezone(l, J), Re = n.getWeekArray(Ve);
    let lt = n.addMonths(Ve, 1);
    for (; ne && Re.length < ne; ) {
      const Pt = n.getWeekArray(lt), at = n.isSameDay(Re[Re.length - 1][0], Pt[0][0]);
      Pt.slice(at ? 1 : 0).forEach((it) => {
        Re.length < ne && Re.push(it);
      }), lt = n.addMonths(lt, 1);
    }
    return Re;
  }, [l, ne, n, J]);
  return /* @__PURE__ */ qe(gMe, {
    role: "grid",
    "aria-labelledby": K,
    className: Z.root,
    children: [/* @__PURE__ */ qe(yMe, {
      role: "row",
      className: Z.header,
      children: [X && /* @__PURE__ */ I(xMe, {
        variant: "caption",
        role: "columnheader",
        "aria-label": G.calendarWeekNumberHeaderLabel,
        className: Z.weekNumberLabel,
        children: G.calendarWeekNumberHeaderText
      }), LPe(n, te).map((Ve, Re) => /* @__PURE__ */ I(bMe, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(n.addDays(ye, Re), "weekday"),
        className: Z.weekDayLabel,
        children: z(Ve)
      }, Re.toString()))]
    }), h ? /* @__PURE__ */ I(CMe, {
      className: Z.loadingContainer,
      children: R()
    }) : /* @__PURE__ */ I(wMe, O({
      transKey: ie,
      onExited: b,
      reduceAnimations: S,
      slideDirection: T,
      className: Ne(s, Z.slideTransition)
    }, E, {
      nodeRef: fe,
      children: /* @__PURE__ */ I(TMe, {
        ref: fe,
        role: "rowgroup",
        className: Z.monthContainer,
        children: _e.map((Ve, Re) => /* @__PURE__ */ qe(EMe, {
          role: "row",
          className: Z.weekContainer,
          "aria-rowindex": Re + 1,
          children: [X && /* @__PURE__ */ I(SMe, {
            className: Z.weekNumber,
            role: "rowheader",
            "aria-label": G.calendarWeekNumberAriaLabelText(n.getWeekNumber(Ve[0])),
            children: G.calendarWeekNumberText(n.getWeekNumber(Ve[0]))
          }), Ve.map((lt, Pt) => /* @__PURE__ */ I(RMe, {
            parentProps: t,
            day: lt,
            selectedDays: De,
            focusableDay: Ee,
            onKeyDown: se,
            onFocus: ve,
            onBlur: me,
            onDaySelect: we,
            isDateDisabled: U,
            currentMonthNumber: Oe,
            isViewFocused: W,
            "aria-colindex": Pt + 1
          }, lt.toString()))]
        }, `week-${Ve[0]}`))
      })
    }))]
  });
}
function PMe(e) {
  return xn("MuiPickersMonth", e);
}
const x1 = Cn("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), $Me = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow"], DMe = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return vn({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, PMe, o);
}, kMe = ce("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), MMe = ce("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${x1.disabled}`]: t.disabled
  }, {
    [`&.${x1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => O({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${x1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${x1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), NMe = /* @__PURE__ */ D.memo(function(t) {
  const n = We({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: o,
    children: s,
    disabled: l,
    selected: u,
    value: p,
    tabIndex: h,
    onClick: m,
    onKeyDown: b,
    onFocus: x,
    onBlur: S,
    "aria-current": R,
    "aria-label": T
    // We don't want to forward this prop to the root element
  } = n, E = Te(n, $Me), P = D.useRef(null), k = DMe(n);
  return Hc(() => {
    var _;
    o && ((_ = P.current) == null || _.focus());
  }, [o]), /* @__PURE__ */ I(kMe, O({
    className: k.root,
    ownerState: n
  }, E, {
    children: /* @__PURE__ */ I(MMe, {
      ref: P,
      disabled: l,
      type: "button",
      role: "radio",
      tabIndex: l ? -1 : h,
      "aria-current": R,
      "aria-checked": u,
      "aria-label": T,
      onClick: (_) => m(_, p),
      onKeyDown: (_) => b(_, p),
      onFocus: (_) => x(_, p),
      onBlur: (_) => S(_, p),
      className: k.monthButton,
      ownerState: n,
      children: s
    })
  }));
});
function IMe(e) {
  return xn("MuiMonthCalendar", e);
}
Cn("MuiMonthCalendar", ["root"]);
const _Me = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId"], AMe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, IMe, t);
};
function LMe(e, t) {
  const n = sn(), o = Sp(), s = We({
    props: e,
    name: t
  });
  return O({
    disableFuture: !1,
    disablePast: !1
  }, s, {
    minDate: pa(n, s.minDate, o.minDate),
    maxDate: pa(n, s.maxDate, o.maxDate)
  });
}
const FMe = ce("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: VT,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), xU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = LMe(t, "MuiMonthCalendar"), {
    className: s,
    value: l,
    defaultValue: u,
    referenceDate: p,
    disabled: h,
    disableFuture: m,
    disablePast: b,
    maxDate: x,
    minDate: S,
    onChange: R,
    shouldDisableMonth: T,
    readOnly: E,
    autoFocus: P = !1,
    onMonthFocus: k,
    hasFocus: _,
    onFocusedViewChange: L,
    monthsPerRow: F = 3,
    timezone: N,
    gridLabelId: V
  } = o, z = Te(o, _Me), {
    value: H,
    handleValueChange: ee,
    timezone: K
  } = Fv({
    name: "MonthCalendar",
    timezone: N,
    value: l,
    defaultValue: u,
    onChange: R,
    valueManager: go
  }), X = Cp(K), ne = vs(), Y = sn(), J = D.useMemo(
    () => go.getInitialReferenceValue({
      value: H,
      utils: Y,
      props: o,
      timezone: K,
      referenceDate: p,
      granularity: Qs.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), te = o, Z = AMe(te), ae = D.useMemo(() => Y.getMonth(X), [Y, X]), U = D.useMemo(() => H != null ? Y.getMonth(H) : null, [H, Y]), [G, W] = D.useState(() => U || Y.getMonth(J)), [le, pe] = op({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: _,
    default: P ?? !1
  }), ge = Tt((be) => {
    pe(be), L && L(be);
  }), we = D.useCallback((be) => {
    const De = Y.startOfMonth(b && Y.isAfter(X, S) ? X : S), ie = Y.startOfMonth(m && Y.isBefore(X, x) ? X : x), fe = Y.startOfMonth(be);
    return Y.isBefore(fe, De) || Y.isAfter(fe, ie) ? !0 : T ? T(fe) : !1;
  }, [m, b, x, S, X, T, Y]), de = Tt((be, De) => {
    if (E)
      return;
    const ie = Y.setMonth(H ?? J, De);
    ee(ie);
  }), se = Tt((be) => {
    we(Y.setMonth(H ?? J, be)) || (W(be), ge(!0), k && k(be));
  });
  D.useEffect(() => {
    W((be) => U !== null && be !== U ? U : be);
  }, [U]);
  const ve = Tt((be, De) => {
    switch (be.key) {
      case "ArrowUp":
        se((12 + De - 3) % 12), be.preventDefault();
        break;
      case "ArrowDown":
        se((12 + De + 3) % 12), be.preventDefault();
        break;
      case "ArrowLeft":
        se((12 + De + (ne ? 1 : -1)) % 12), be.preventDefault();
        break;
      case "ArrowRight":
        se((12 + De + (ne ? -1 : 1)) % 12), be.preventDefault();
        break;
    }
  }), me = Tt((be, De) => {
    se(De);
  }), Oe = Tt((be, De) => {
    G === De && ge(!1);
  });
  return /* @__PURE__ */ I(FMe, O({
    ref: n,
    className: Ne(Z.root, s),
    ownerState: te,
    role: "radiogroup",
    "aria-labelledby": V
  }, z, {
    children: LM(Y, H ?? J).map((be) => {
      const De = Y.getMonth(be), ie = Y.format(be, "monthShort"), fe = Y.format(be, "month"), ye = De === U, Ee = h || we(be);
      return /* @__PURE__ */ I(NMe, {
        selected: ye,
        value: De,
        onClick: de,
        onKeyDown: ve,
        autoFocus: le && De === G,
        disabled: Ee,
        tabIndex: De === G ? 0 : -1,
        onFocus: me,
        onBlur: Oe,
        "aria-current": ae === De ? "date" : void 0,
        "aria-label": fe,
        monthsPerRow: F,
        children: ie
      }, ie);
    })
  }));
});
process.env.NODE_ENV !== "production" && (xU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true` picker is disabled
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  gridLabelId: r.string,
  hasFocus: r.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: r.func,
  onFocusedViewChange: r.func,
  onMonthFocus: r.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: r.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object
});
function jMe(e) {
  return xn("MuiPickersYear", e);
}
const S1 = Cn("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), VMe = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"], BMe = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return vn({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, jMe, o);
}, zMe = ce("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), UMe = ce("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${S1.disabled}`]: t.disabled
  }, {
    [`&.${S1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => O({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : Mt(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${S1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${S1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), HMe = /* @__PURE__ */ D.memo(function(t) {
  const n = We({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: o,
    className: s,
    children: l,
    disabled: u,
    selected: p,
    value: h,
    tabIndex: m,
    onClick: b,
    onKeyDown: x,
    onFocus: S,
    onBlur: R,
    "aria-current": T
    // We don't want to forward this prop to the root element
  } = n, E = Te(n, VMe), P = D.useRef(null), k = BMe(n);
  return D.useEffect(() => {
    o && P.current.focus();
  }, [o]), /* @__PURE__ */ I(zMe, O({
    className: Ne(k.root, s),
    ownerState: n
  }, E, {
    children: /* @__PURE__ */ I(UMe, {
      ref: P,
      disabled: u,
      type: "button",
      role: "radio",
      tabIndex: u ? -1 : m,
      "aria-current": T,
      "aria-checked": p,
      onClick: (_) => b(_, h),
      onKeyDown: (_) => x(_, h),
      onFocus: (_) => S(_, h),
      onBlur: (_) => R(_, h),
      className: k.yearButton,
      ownerState: n,
      children: l
    })
  }));
});
function WMe(e) {
  return xn("MuiYearCalendar", e);
}
Cn("MuiYearCalendar", ["root"]);
const qMe = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"], YMe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, WMe, t);
};
function GMe(e, t) {
  const n = sn(), o = Sp(), s = We({
    props: e,
    name: t
  });
  return O({
    disablePast: !1,
    disableFuture: !1
  }, s, {
    yearsPerRow: s.yearsPerRow ?? 3,
    minDate: pa(n, s.minDate, o.minDate),
    maxDate: pa(n, s.maxDate, o.maxDate)
  });
}
const KMe = ce("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: VT,
  maxHeight: xPe,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), SU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = GMe(t, "MuiYearCalendar"), {
    autoFocus: s,
    className: l,
    value: u,
    defaultValue: p,
    referenceDate: h,
    disabled: m,
    disableFuture: b,
    disablePast: x,
    maxDate: S,
    minDate: R,
    onChange: T,
    readOnly: E,
    shouldDisableYear: P,
    onYearFocus: k,
    hasFocus: _,
    onFocusedViewChange: L,
    yearsPerRow: F,
    timezone: N,
    gridLabelId: V
  } = o, z = Te(o, qMe), {
    value: H,
    handleValueChange: ee,
    timezone: K
  } = Fv({
    name: "YearCalendar",
    timezone: N,
    value: u,
    defaultValue: p,
    onChange: T,
    valueManager: go
  }), X = Cp(K), ne = vs(), Y = sn(), J = D.useMemo(
    () => go.getInitialReferenceValue({
      value: H,
      utils: Y,
      props: o,
      timezone: K,
      referenceDate: h,
      granularity: Qs.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), te = o, Z = YMe(te), ae = D.useMemo(() => Y.getYear(X), [Y, X]), U = D.useMemo(() => H != null ? Y.getYear(H) : null, [H, Y]), [G, W] = D.useState(() => U || Y.getYear(J)), [le, pe] = op({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: _,
    default: s ?? !1
  }), ge = Tt((ie) => {
    pe(ie), L && L(ie);
  }), we = D.useCallback((ie) => {
    if (x && Y.isBeforeYear(ie, X) || b && Y.isAfterYear(ie, X) || R && Y.isBeforeYear(ie, R) || S && Y.isAfterYear(ie, S))
      return !0;
    if (!P)
      return !1;
    const fe = Y.startOfYear(ie);
    return P(fe);
  }, [b, x, S, R, X, P, Y]), de = Tt((ie, fe) => {
    if (E)
      return;
    const ye = Y.setYear(H ?? J, fe);
    ee(ye);
  }), se = Tt((ie) => {
    we(Y.setYear(H ?? J, ie)) || (W(ie), ge(!0), k == null || k(ie));
  });
  D.useEffect(() => {
    W((ie) => U !== null && ie !== U ? U : ie);
  }, [U]);
  const ve = Tt((ie, fe) => {
    switch (ie.key) {
      case "ArrowUp":
        se(fe - F), ie.preventDefault();
        break;
      case "ArrowDown":
        se(fe + F), ie.preventDefault();
        break;
      case "ArrowLeft":
        se(fe + (ne ? 1 : -1)), ie.preventDefault();
        break;
      case "ArrowRight":
        se(fe + (ne ? -1 : 1)), ie.preventDefault();
        break;
    }
  }), me = Tt((ie, fe) => {
    se(fe);
  }), Oe = Tt((ie, fe) => {
    G === fe && ge(!1);
  }), be = D.useRef(null), De = ro(n, be);
  return D.useEffect(() => {
    if (s || be.current === null)
      return;
    const ie = be.current.querySelector('[tabindex="0"]');
    if (!ie)
      return;
    const fe = ie.offsetHeight, ye = ie.offsetTop, Ee = be.current.clientHeight, _e = be.current.scrollTop, Ve = ye + fe;
    fe > Ee || ye < _e || (be.current.scrollTop = Ve - Ee / 2 - fe / 2);
  }, [s]), /* @__PURE__ */ I(KMe, O({
    ref: De,
    className: Ne(Z.root, l),
    ownerState: te,
    role: "radiogroup",
    "aria-labelledby": V
  }, z, {
    children: Y.getYearRange([R, S]).map((ie) => {
      const fe = Y.getYear(ie), ye = fe === U, Ee = m || we(ie);
      return /* @__PURE__ */ I(HMe, {
        selected: ye,
        value: fe,
        onClick: de,
        onKeyDown: ve,
        autoFocus: le && fe === G,
        disabled: Ee,
        tabIndex: fe === G ? 0 : -1,
        onFocus: me,
        onBlur: Oe,
        "aria-current": ae === fe ? "date" : void 0,
        yearsPerRow: F,
        children: Y.format(ie, "year")
      }, Y.format(ie, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (SU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true` picker is disabled
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  gridLabelId: r.string,
  hasFocus: r.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: r.func,
  onFocusedViewChange: r.func,
  onYearFocus: r.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: r.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
});
const XMe = (e) => xn("MuiPickersCalendarHeader", e), QMe = Cn("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), JMe = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], ZMe = ["ownerState"], eNe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, XMe, t);
}, tNe = ce("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), nNe = ce("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => O({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), rNe = ce("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), oNe = ce(oi, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${QMe.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), aNe = ce(nPe, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), CU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = oo(), s = sn(), l = We({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: u,
    slotProps: p,
    currentMonth: h,
    disabled: m,
    disableFuture: b,
    disablePast: x,
    maxDate: S,
    minDate: R,
    onMonthChange: T,
    onViewChange: E,
    view: P,
    reduceAnimations: k,
    views: _,
    labelId: L,
    className: F,
    timezone: N,
    format: V = `${s.formats.month} ${s.formats.year}`
  } = l, z = Te(l, JMe), H = l, ee = eNe(l), K = (u == null ? void 0 : u.switchViewButton) ?? oNe, X = Yn({
    elementType: K,
    externalSlotProps: p == null ? void 0 : p.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": o.calendarViewSwitchingButtonAriaLabel(P)
    },
    ownerState: H,
    className: ee.switchViewButton
  }), ne = (u == null ? void 0 : u.switchViewIcon) ?? aNe, Y = Yn({
    elementType: ne,
    externalSlotProps: p == null ? void 0 : p.switchViewIcon,
    ownerState: void 0,
    className: ee.switchViewIcon
  }), J = Te(Y, ZMe), te = () => T(s.addMonths(h, 1), "left"), Z = () => T(s.addMonths(h, -1), "right"), ae = yPe(h, {
    disableFuture: b,
    maxDate: S,
    timezone: N
  }), U = bPe(h, {
    disablePast: x,
    minDate: R,
    timezone: N
  }), G = () => {
    if (!(_.length === 1 || !E || m))
      if (_.length === 2)
        E(_.find((le) => le !== P) || _[0]);
      else {
        const le = _.indexOf(P) !== 0 ? 0 : 1;
        E(_[le]);
      }
  };
  if (_.length === 1 && _[0] === "year")
    return null;
  const W = s.formatByString(h, V);
  return /* @__PURE__ */ qe(tNe, O({}, z, {
    ownerState: H,
    className: Ne(F, ee.root),
    ref: n,
    children: [/* @__PURE__ */ qe(nNe, {
      role: "presentation",
      onClick: G,
      ownerState: H,
      "aria-live": "polite",
      className: ee.labelContainer,
      children: [/* @__PURE__ */ I(yU, {
        reduceAnimations: k,
        transKey: W,
        children: /* @__PURE__ */ I(rNe, {
          id: L,
          ownerState: H,
          className: ee.label,
          children: W
        })
      }), _.length > 1 && !m && /* @__PURE__ */ I(K, O({}, X, {
        children: /* @__PURE__ */ I(ne, O({}, J))
      }))]
    }), /* @__PURE__ */ I(sp, {
      in: P === "day",
      children: /* @__PURE__ */ I(L3, {
        slots: u,
        slotProps: p,
        onGoToPrevious: Z,
        isPreviousDisabled: U,
        previousLabel: o.previousMonth,
        onGoToNext: te,
        isNextDisabled: ae,
        nextLabel: o.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (CU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  currentMonth: r.object.isRequired,
  disabled: r.bool,
  disableFuture: r.bool,
  disablePast: r.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: r.string,
  labelId: r.string,
  maxDate: r.object.isRequired,
  minDate: r.object.isRequired,
  onMonthChange: r.func.isRequired,
  onViewChange: r.func,
  reduceAnimations: r.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  timezone: r.string.isRequired,
  view: r.oneOf(["day", "month", "year"]).isRequired,
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const iNe = "@media (prefers-reduced-motion: reduce)", ov = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), LV = ov && ov[1] ? parseInt(ov[1], 10) : null, FV = ov && ov[2] ? parseInt(ov[2], 10) : null, sNe = LV && LV < 10 || FV && FV < 13 || !1, wU = () => dT(iNe, {
  defaultMatches: !1
}) || sNe, lNe = (e) => xn("MuiDateCalendar", e);
Cn("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const cNe = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"], uNe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, lNe, t);
};
function dNe(e, t) {
  const n = sn(), o = Sp(), s = wU(), l = We({
    props: e,
    name: t
  });
  return O({}, l, {
    loading: l.loading ?? !1,
    disablePast: l.disablePast ?? !1,
    disableFuture: l.disableFuture ?? !1,
    openTo: l.openTo ?? "day",
    views: l.views ?? ["year", "day"],
    reduceAnimations: l.reduceAnimations ?? s,
    renderLoading: l.renderLoading ?? (() => /* @__PURE__ */ I("span", {
      children: "..."
    })),
    minDate: pa(n, l.minDate, o.minDate),
    maxDate: pa(n, l.maxDate, o.maxDate)
  });
}
const fNe = ce(zT, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: BT
}), pNe = ce(yU, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), TU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = sn(), s = bp(), l = dNe(t, "MuiDateCalendar"), {
    autoFocus: u,
    onViewChange: p,
    value: h,
    defaultValue: m,
    referenceDate: b,
    disableFuture: x,
    disablePast: S,
    onChange: R,
    onYearChange: T,
    onMonthChange: E,
    reduceAnimations: P,
    shouldDisableDate: k,
    shouldDisableMonth: _,
    shouldDisableYear: L,
    view: F,
    views: N,
    openTo: V,
    className: z,
    disabled: H,
    readOnly: ee,
    minDate: K,
    maxDate: X,
    disableHighlightToday: ne,
    focusedView: Y,
    onFocusedViewChange: J,
    showDaysOutsideCurrentMonth: te,
    fixedWeekNumber: Z,
    dayOfWeekFormatter: ae,
    slots: U,
    slotProps: G,
    loading: W,
    renderLoading: le,
    displayWeekNumber: pe,
    yearsPerRow: ge,
    monthsPerRow: we,
    timezone: de
  } = l, se = Te(l, cNe), {
    value: ve,
    handleValueChange: me,
    timezone: Oe
  } = Fv({
    name: "DateCalendar",
    timezone: de,
    value: h,
    defaultValue: m,
    onChange: R,
    valueManager: go
  }), {
    view: be,
    setView: De,
    focusedView: ie,
    setFocusedView: fe,
    goToNextView: ye,
    setValueAndGoToNextView: Ee
  } = H0({
    view: F,
    views: N,
    openTo: V,
    onChange: me,
    onViewChange: p,
    autoFocus: u,
    focusedView: Y,
    onFocusedViewChange: J
  }), {
    referenceDate: _e,
    calendarState: Ve,
    changeFocusedDay: Re,
    changeMonth: lt,
    handleChangeMonth: Pt,
    isDateDisabled: at,
    onMonthSwitchingAnimationEnd: it
  } = oMe({
    value: ve,
    referenceDate: b,
    reduceAnimations: P,
    onMonthChange: E,
    minDate: K,
    maxDate: X,
    shouldDisableDate: k,
    disablePast: S,
    disableFuture: x,
    timezone: Oe
  }), bt = H && ve || K, Nt = H && ve || X, en = `${s}-grid-label`, fn = ie !== null, ln = (U == null ? void 0 : U.calendarHeader) ?? CU, Rt = Yn({
    elementType: ln,
    externalSlotProps: G == null ? void 0 : G.calendarHeader,
    additionalProps: {
      views: N,
      view: be,
      currentMonth: Ve.currentMonth,
      onViewChange: De,
      onMonthChange: (ct, St) => Pt({
        newMonth: ct,
        direction: St
      }),
      minDate: bt,
      maxDate: Nt,
      disabled: H,
      disablePast: S,
      disableFuture: x,
      reduceAnimations: P,
      timezone: Oe,
      labelId: en
    },
    ownerState: l
  }), rt = Tt((ct) => {
    const St = o.startOfMonth(ct), tn = o.endOfMonth(ct), Wt = at(ct) ? Nb({
      utils: o,
      date: ct,
      minDate: o.isBefore(K, St) ? St : K,
      maxDate: o.isAfter(X, tn) ? tn : X,
      disablePast: S,
      disableFuture: x,
      isDateDisabled: at,
      timezone: Oe
    }) : ct;
    Wt ? (Ee(Wt, "finish"), E == null || E(St)) : (ye(), lt(St)), Re(Wt, !0);
  }), Qt = Tt((ct) => {
    const St = o.startOfYear(ct), tn = o.endOfYear(ct), Wt = at(ct) ? Nb({
      utils: o,
      date: ct,
      minDate: o.isBefore(K, St) ? St : K,
      maxDate: o.isAfter(X, tn) ? tn : X,
      disablePast: S,
      disableFuture: x,
      isDateDisabled: at,
      timezone: Oe
    }) : ct;
    Wt ? (Ee(Wt, "finish"), T == null || T(Wt)) : (ye(), lt(St)), Re(Wt, !0);
  }), et = Tt((ct) => me(ct && gw(o, ct, ve ?? _e), "finish", be));
  D.useEffect(() => {
    ve != null && o.isValid(ve) && lt(ve);
  }, [ve]);
  const st = l, jt = uNe(st), Xe = {
    disablePast: S,
    disableFuture: x,
    maxDate: X,
    minDate: K
  }, Be = {
    disableHighlightToday: ne,
    readOnly: ee,
    disabled: H,
    timezone: Oe,
    gridLabelId: en
  }, Qe = D.useRef(be);
  D.useEffect(() => {
    Qe.current !== be && (ie === Qe.current && fe(be, !0), Qe.current = be);
  }, [ie, fe, be]);
  const xt = D.useMemo(() => [ve], [ve]);
  return /* @__PURE__ */ qe(fNe, O({
    ref: n,
    className: Ne(jt.root, z),
    ownerState: st
  }, se, {
    children: [/* @__PURE__ */ I(ln, O({}, Rt, {
      slots: U,
      slotProps: G
    })), /* @__PURE__ */ I(pNe, {
      reduceAnimations: P,
      className: jt.viewTransitionContainer,
      transKey: be,
      ownerState: st,
      children: /* @__PURE__ */ qe("div", {
        children: [be === "year" && /* @__PURE__ */ I(SU, O({}, Xe, Be, {
          value: ve,
          onChange: Qt,
          shouldDisableYear: L,
          hasFocus: fn,
          onFocusedViewChange: (ct) => fe("year", ct),
          yearsPerRow: ge,
          referenceDate: _e
        })), be === "month" && /* @__PURE__ */ I(xU, O({}, Xe, Be, {
          hasFocus: fn,
          className: z,
          value: ve,
          onChange: rt,
          shouldDisableMonth: _,
          onFocusedViewChange: (ct) => fe("month", ct),
          monthsPerRow: we,
          referenceDate: _e
        })), be === "day" && /* @__PURE__ */ I(OMe, O({}, Ve, Xe, Be, {
          onMonthSwitchingAnimationEnd: it,
          onFocusedDayChange: Re,
          reduceAnimations: P,
          selectedDays: xt,
          onSelectedDaysChange: et,
          shouldDisableDate: k,
          shouldDisableMonth: _,
          shouldDisableYear: L,
          hasFocus: fn,
          onFocusedViewChange: (ct) => fe("day", ct),
          showDaysOutsideCurrentMonth: te,
          fixedWeekNumber: Z,
          dayOfWeekFormatter: ae,
          displayWeekNumber: pe,
          slots: U,
          slotProps: G,
          loading: W,
          renderLoading: le
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (TU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
});
function EU(e) {
  return xn("MuiPickersToolbar", e);
}
const hNe = Cn("MuiPickersToolbar", ["root", "content"]), mNe = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], vNe = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return vn({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, EU, t);
}, gNe = ce("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), yNe = ce("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), iN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: s,
    className: l,
    toolbarTitle: u,
    hidden: p,
    titleId: h
  } = o, m = Te(o, mNe), b = o, x = vNe(b);
  return p ? null : /* @__PURE__ */ qe(gNe, O({
    ref: n,
    className: Ne(x.root, l),
    ownerState: b
  }, m, {
    children: [/* @__PURE__ */ I(nr, {
      color: "text.secondary",
      variant: "overline",
      id: h,
      children: u
    }), /* @__PURE__ */ I(yNe, {
      className: x.content,
      ownerState: b,
      children: s
    })]
  }));
});
function bNe(e) {
  return xn("MuiDatePickerToolbar", e);
}
Cn("MuiDatePickerToolbar", ["root", "title"]);
const xNe = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], SNe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    title: ["title"]
  }, bNe, t);
}, CNe = ce(iN, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), wNe = ce(nr, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), RU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: s,
    isLandscape: l,
    toolbarFormat: u,
    toolbarPlaceholder: p = "––",
    views: h,
    className: m
  } = o, b = Te(o, xNe), x = sn(), S = oo(), R = SNe(o), T = D.useMemo(() => {
    if (!s)
      return p;
    const P = i0(x, {
      format: u,
      views: h
    }, !0);
    return x.formatByString(s, P);
  }, [s, u, p, x, h]), E = o;
  return /* @__PURE__ */ I(CNe, O({
    ref: n,
    toolbarTitle: S.datePickerToolbarTitle,
    isLandscape: l,
    className: Ne(R.root, m)
  }, b, {
    children: /* @__PURE__ */ I(wNe, {
      variant: "h4",
      align: l ? "left" : "center",
      ownerState: E,
      className: R.title,
      children: T
    })
  }));
});
process.env.NODE_ENV !== "production" && (RU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: r.bool,
  isLandscape: r.bool.isRequired,
  onChange: r.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  readOnly: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  titleId: r.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: r.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: r.node,
  value: r.object,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function OU(e, t) {
  const n = sn(), o = Sp(), s = We({
    props: e,
    name: t
  }), l = D.useMemo(() => {
    var u;
    return ((u = s.localeText) == null ? void 0 : u.toolbarTitle) == null ? s.localeText : O({}, s.localeText, {
      datePickerToolbarTitle: s.localeText.toolbarTitle
    });
  }, [s.localeText]);
  return O({}, s, {
    localeText: l
  }, AM({
    views: s.views,
    openTo: s.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: s.disableFuture ?? !1,
    disablePast: s.disablePast ?? !1,
    minDate: pa(n, s.minDate, o.minDate),
    maxDate: pa(n, s.maxDate, o.maxDate),
    slots: O({
      toolbar: RU
    }, s.slots)
  });
}
function TNe(e) {
  return xn("MuiPickersPopper", e);
}
Cn("MuiPickersPopper", ["root", "paper"]);
const ENe = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], RNe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    paper: ["paper"]
  }, TNe, t);
}, ONe = ce(ip, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), PNe = ce(ms, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: e
    }) => ["top", "top-start", "top-end"].includes(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function $Ne(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function DNe(e, t) {
  const n = D.useRef(!1), o = D.useRef(!1), s = D.useRef(null), l = D.useRef(!1);
  D.useEffect(() => {
    if (!e)
      return;
    function h() {
      l.current = !0;
    }
    return document.addEventListener("mousedown", h, !0), document.addEventListener("touchstart", h, !0), () => {
      document.removeEventListener("mousedown", h, !0), document.removeEventListener("touchstart", h, !0), l.current = !1;
    };
  }, [e]);
  const u = Tt((h) => {
    if (!l.current)
      return;
    const m = o.current;
    o.current = !1;
    const b = N1(s.current);
    if (!s.current || // is a TouchEvent?
    "clientX" in h && $Ne(h, b))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let x;
    h.composedPath ? x = h.composedPath().indexOf(s.current) > -1 : x = !b.documentElement.contains(h.target) || s.current.contains(h.target), !x && !m && t(h);
  }), p = () => {
    o.current = !0;
  };
  return D.useEffect(() => {
    if (e) {
      const h = N1(s.current), m = () => {
        n.current = !0;
      };
      return h.addEventListener("touchstart", u), h.addEventListener("touchmove", m), () => {
        h.removeEventListener("touchstart", u), h.removeEventListener("touchmove", m);
      };
    }
  }, [e, u]), D.useEffect(() => {
    if (e) {
      const h = N1(s.current);
      return h.addEventListener("click", u), () => {
        h.removeEventListener("click", u), o.current = !1;
      };
    }
  }, [e, u]), [s, p, p];
}
const kNe = /* @__PURE__ */ D.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: o,
    ownerState: s,
    children: l,
    paperSlotProps: u,
    paperClasses: p,
    onPaperClick: h,
    onPaperTouchStart: m
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, b = Te(e, ENe), x = O({}, s, {
    placement: o
  }), S = Yn({
    elementType: n,
    externalSlotProps: u,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: p,
    ownerState: x
  });
  return /* @__PURE__ */ I(n, O({}, b, S, {
    onClick: (R) => {
      var T;
      h(R), (T = S.onClick) == null || T.call(S, R);
    },
    onTouchStart: (R) => {
      var T;
      m(R), (T = S.onTouchStart) == null || T.call(S, R);
    },
    ownerState: x,
    children: l
  }));
});
function MNe(e) {
  const t = We({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: o,
    containerRef: s = null,
    shouldRestoreFocus: l,
    onBlur: u,
    onDismiss: p,
    open: h,
    role: m,
    placement: b,
    slots: x,
    slotProps: S,
    reduceAnimations: R
  } = t;
  D.useEffect(() => {
    function te(Z) {
      h && Z.key === "Escape" && p();
    }
    return document.addEventListener("keydown", te), () => {
      document.removeEventListener("keydown", te);
    };
  }, [p, h]);
  const T = D.useRef(null);
  D.useEffect(() => {
    m === "tooltip" || l && !l() || (h ? T.current = ss(document) : T.current && T.current instanceof HTMLElement && setTimeout(() => {
      T.current instanceof HTMLElement && T.current.focus();
    }));
  }, [h, m, l]);
  const [E, P, k] = DNe(h, u ?? p), _ = D.useRef(null), L = ro(_, s), F = ro(L, E), N = t, V = RNe(N), z = wU(), H = R ?? z, ee = (te) => {
    te.key === "Escape" && (te.stopPropagation(), p());
  }, K = (x == null ? void 0 : x.desktopTransition) ?? H ? sp : pv, X = (x == null ? void 0 : x.desktopTrapFocus) ?? Hb, ne = (x == null ? void 0 : x.desktopPaper) ?? PNe, Y = (x == null ? void 0 : x.popper) ?? ONe, J = Yn({
    elementType: Y,
    externalSlotProps: S == null ? void 0 : S.popper,
    additionalProps: {
      transition: !0,
      role: m,
      open: h,
      anchorEl: n,
      placement: b,
      onKeyDown: ee
    },
    className: V.root,
    ownerState: t
  });
  return /* @__PURE__ */ I(Y, O({}, J, {
    children: ({
      TransitionProps: te,
      placement: Z
    }) => /* @__PURE__ */ I(X, O({
      open: h,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: m === "tooltip",
      isEnabled: () => !0
    }, S == null ? void 0 : S.desktopTrapFocus, {
      children: /* @__PURE__ */ I(K, O({}, te, S == null ? void 0 : S.desktopTransition, {
        children: /* @__PURE__ */ I(kNe, {
          PaperComponent: ne,
          ownerState: N,
          popperPlacement: Z,
          ref: F,
          onPaperClick: P,
          onPaperTouchStart: k,
          paperClasses: V.paper,
          paperSlotProps: S == null ? void 0 : S.desktopPaper,
          children: o
        })
      }))
    }))
  }));
}
const NNe = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const o = D.useRef(typeof e == "boolean").current, [s, l] = D.useState(!1);
  D.useEffect(() => {
    if (o) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      l(e);
    }
  }, [o, e]);
  const u = D.useCallback((p) => {
    o || l(p), p && t && t(), !p && n && n();
  }, [o, t, n]);
  return {
    isOpen: s,
    setIsOpen: u
  };
}, INe = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: s
  } = e, l = !s && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? l && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? l ? !0 : n(o.lastPublishedValue) : !1;
}, _Ne = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: s,
    closeOnSelect: l
  } = e, u = !s && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? u && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && l ? u ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(o.lastCommittedValue) : !1;
}, ANe = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, LNe = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  validator: s
}) => {
  const {
    onAccept: l,
    onChange: u,
    value: p,
    defaultValue: h,
    closeOnSelect: m = o === "desktop",
    timezone: b
  } = e, {
    current: x
  } = D.useRef(h), {
    current: S
  } = D.useRef(p !== void 0);
  process.env.NODE_ENV !== "production" && (D.useEffect(() => {
    S !== (p !== void 0) && console.error([`MUI X: A component is changing the ${S ? "" : "un"}controlled value of a picker to be ${S ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [p]), D.useEffect(() => {
    !S && x !== h && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(x)]));
  const R = sn(), T = xp(), {
    isOpen: E,
    setIsOpen: P
  } = NNe(e), [k, _] = D.useState(() => {
    let pe;
    return p !== void 0 ? pe = p : x !== void 0 ? pe = x : pe = t.emptyValue, {
      draft: pe,
      lastPublishedValue: pe,
      lastCommittedValue: pe,
      lastControlledValue: p,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: L,
    handleValueChange: F
  } = jM({
    timezone: b,
    value: p,
    defaultValue: x,
    onChange: u,
    valueManager: t
  });
  eU(O({}, e, {
    value: k.draft,
    timezone: L
  }), s, t.isSameError, t.defaultErrorState);
  const N = Tt((pe) => {
    const ge = {
      action: pe,
      dateState: k,
      hasChanged: (ve) => !t.areValuesEqual(R, pe.value, ve),
      isControlled: S,
      closeOnSelect: m
    }, we = INe(ge), de = _Ne(ge), se = ANe(ge);
    if (_((ve) => O({}, ve, {
      draft: pe.value,
      lastPublishedValue: we ? pe.value : ve.lastPublishedValue,
      lastCommittedValue: de ? pe.value : ve.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), we) {
      const me = {
        validationError: pe.name === "setValueFromField" ? pe.context.validationError : s({
          adapter: T,
          value: pe.value,
          props: O({}, e, {
            value: pe.value,
            timezone: L
          })
        })
      };
      pe.name === "setValueFromShortcut" && (me.shortcut = pe.shortcut), F(pe.value, me);
    }
    de && l && l(pe.value), se && P(!1);
  });
  if (p !== void 0 && (k.lastControlledValue === void 0 || !t.areValuesEqual(R, k.lastControlledValue, p))) {
    const pe = t.areValuesEqual(R, k.draft, p);
    _((ge) => O({}, ge, {
      lastControlledValue: p
    }, pe ? {} : {
      lastCommittedValue: p,
      lastPublishedValue: p,
      draft: p,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const V = Tt(() => {
    N({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), z = Tt(() => {
    N({
      value: k.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), H = Tt(() => {
    N({
      value: k.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), ee = Tt(() => {
    N({
      value: k.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), K = Tt(() => {
    N({
      value: t.getTodayValue(R, L, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), X = Tt((pe) => {
    pe.preventDefault(), P(!0);
  }), ne = Tt((pe) => {
    pe == null || pe.preventDefault(), P(!1);
  }), Y = Tt((pe, ge = "partial") => N({
    name: "setValueFromView",
    value: pe,
    selectionState: ge
  })), J = Tt((pe, ge, we) => N({
    name: "setValueFromShortcut",
    value: pe,
    changeImportance: ge,
    shortcut: we
  })), te = Tt((pe, ge) => N({
    name: "setValueFromField",
    value: pe,
    context: ge
  })), Z = {
    onClear: V,
    onAccept: z,
    onDismiss: H,
    onCancel: ee,
    onSetToday: K,
    onOpen: X,
    onClose: ne
  }, ae = {
    value: k.draft,
    onChange: te
  }, U = D.useMemo(() => t.cleanValue(R, k.draft), [R, t, k.draft]), G = {
    value: U,
    onChange: Y,
    onClose: ne,
    open: E
  }, le = O({}, Z, {
    value: U,
    onChange: Y,
    onSelectShortcut: J,
    isValid: (pe) => {
      const ge = s({
        adapter: T,
        value: pe,
        props: O({}, e, {
          value: pe,
          timezone: L
        })
      });
      return !t.hasError(ge);
    }
  });
  return {
    open: E,
    fieldProps: ae,
    viewProps: G,
    layoutProps: le,
    actions: Z
  };
}, FNe = ["className", "sx"], jNe = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  autoFocusView: o,
  rendererInterceptor: s,
  fieldRef: l
}) => {
  const {
    onChange: u,
    open: p,
    onClose: h
  } = t, {
    views: m,
    openTo: b,
    onViewChange: x,
    viewRenderers: S,
    timezone: R
  } = e, T = Te(e, FNe), {
    view: E,
    setView: P,
    defaultView: k,
    focusedView: _,
    setFocusedView: L,
    setValueAndGoToNextView: F
  } = H0({
    view: void 0,
    views: m,
    openTo: b,
    onChange: u,
    onViewChange: x,
    autoFocus: o
  }), {
    hasUIView: N,
    viewModeLookup: V
  } = D.useMemo(() => m.reduce((Y, J) => {
    let te;
    return S[J] != null ? te = "UI" : te = "field", Y.viewModeLookup[J] = te, te === "UI" && (Y.hasUIView = !0), Y;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [S, m]), z = D.useMemo(() => m.reduce((Y, J) => S[J] != null && mv(J) ? Y + 1 : Y, 0), [S, m]), H = V[E], ee = Tt(() => H === "UI"), [K, X] = D.useState(H === "UI" ? E : null);
  return K !== E && V[E] === "UI" && X(E), Hc(() => {
    H === "field" && p && (h(), setTimeout(() => {
      var Y, J;
      (Y = l == null ? void 0 : l.current) == null || Y.setSelectedSections(E), (J = l == null ? void 0 : l.current) == null || J.focusField(E);
    }));
  }, [E]), Hc(() => {
    if (!p)
      return;
    let Y = E;
    H === "field" && K != null && (Y = K), Y !== k && V[Y] === "UI" && V[k] === "UI" && (Y = k), Y !== E && P(Y), L(Y, !0);
  }, [p]), {
    hasUIView: N,
    shouldRestoreFocus: ee,
    layoutProps: {
      views: m,
      view: K,
      onViewChange: P
    },
    renderCurrentView: () => {
      if (K == null)
        return null;
      const Y = S[K];
      if (Y == null)
        return null;
      const J = O({}, T, n, t, {
        views: m,
        timezone: R,
        onChange: F,
        view: K,
        onViewChange: P,
        focusedView: _,
        onFocusedViewChange: L,
        showViewSwitcher: z > 1,
        timeViewsCount: z
      });
      return s ? s(S, K, J) : Y(J);
    }
  };
};
function jV() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const VNe = (e, t) => {
  const [n, o] = D.useState(jV);
  return Hc(() => {
    const l = () => {
      o(jV());
    };
    return window.addEventListener("orientationchange", l), () => {
      window.removeEventListener("orientationchange", l);
    };
  }, []), Gm(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, BNe = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: o
}) => {
  const {
    orientation: s
  } = e, l = VNe(n.views, s), u = vs();
  return {
    layoutProps: O({}, n, t, {
      isLandscape: l,
      isRtl: u,
      wrapperVariant: o,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, PU = (e, t = "warning") => {
  let n = !1;
  const o = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(o) : console.warn(o));
  };
}, zNe = PU(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), $U = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  additionalViewProps: s,
  validator: l,
  autoFocusView: u,
  rendererInterceptor: p,
  fieldRef: h
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && zNe();
  const m = LNe({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: o,
    validator: l
  }), b = jNe({
    props: e,
    additionalViewProps: s,
    autoFocusView: u,
    fieldRef: h,
    propsFromPickerValue: m.viewProps,
    rendererInterceptor: p
  }), x = BNe({
    props: e,
    wrapperVariant: o,
    propsFromPickerValue: m.layoutProps,
    propsFromPickerViews: b.layoutProps
  });
  return {
    // Picker value
    open: m.open,
    actions: m.actions,
    fieldProps: m.fieldProps,
    // Picker views
    renderCurrentView: b.renderCurrentView,
    hasUIView: b.hasUIView,
    shouldRestoreFocus: b.shouldRestoreFocus,
    // Picker layout
    layoutProps: x.layoutProps
  };
};
function DU(e) {
  return xn("MuiPickersLayout", e);
}
const Ks = Cn("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), UNe = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function kU(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: o,
    onSetToday: s,
    actions: l
  } = e, u = Te(e, UNe), p = oo();
  if (l == null || l.length === 0)
    return null;
  const h = l == null ? void 0 : l.map((m) => {
    switch (m) {
      case "clear":
        return /* @__PURE__ */ I(sd, {
          onClick: n,
          children: p.clearButtonLabel
        }, m);
      case "cancel":
        return /* @__PURE__ */ I(sd, {
          onClick: o,
          children: p.cancelButtonLabel
        }, m);
      case "accept":
        return /* @__PURE__ */ I(sd, {
          onClick: t,
          children: p.okButtonLabel
        }, m);
      case "today":
        return /* @__PURE__ */ I(sd, {
          onClick: s,
          children: p.todayButtonLabel
        }, m);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ I(aT, O({}, u, {
    children: h
  }));
}
process.env.NODE_ENV !== "production" && (kU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: r.arrayOf(r.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: r.bool,
  onAccept: r.func.isRequired,
  onCancel: r.func.isRequired,
  onClear: r.func.isRequired,
  onSetToday: r.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const HNe = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], WNe = ["getValue"];
function MU(e) {
  const {
    items: t,
    changeImportance: n = "accept",
    onChange: o,
    isValid: s
  } = e, l = Te(e, HNe);
  if (t == null || t.length === 0)
    return null;
  const u = t.map((p) => {
    let {
      getValue: h
    } = p, m = Te(p, WNe);
    const b = h({
      isValid: s
    });
    return O({}, m, {
      label: m.label,
      onClick: () => {
        o(b, n, m);
      },
      disabled: !s(b)
    });
  });
  return /* @__PURE__ */ I(Tv, O({
    dense: !0,
    sx: [{
      maxHeight: BT,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(l.sx) ? l.sx : [l.sx]]
  }, l, {
    children: u.map((p) => /* @__PURE__ */ I(C0, {
      children: /* @__PURE__ */ I(ZD, O({}, p))
    }, p.id ?? p.label))
  }));
}
process.env.NODE_ENV !== "production" && (MU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: r.oneOf(["accept", "set"]),
  className: r.string,
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: r.bool,
  isLandscape: r.bool.isRequired,
  isValid: r.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: r.arrayOf(r.shape({
    getValue: r.func.isRequired,
    id: r.string,
    label: r.string.isRequired
  })),
  onChange: r.func.isRequired,
  style: r.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function qNe(e) {
  return e.view !== null;
}
const YNe = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return vn({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, DU, t);
}, NU = (e) => {
  const {
    wrapperVariant: t,
    onAccept: n,
    onClear: o,
    onCancel: s,
    onSetToday: l,
    view: u,
    views: p,
    onViewChange: h,
    value: m,
    onChange: b,
    onSelectShortcut: x,
    isValid: S,
    isLandscape: R,
    disabled: T,
    readOnly: E,
    children: P,
    slots: k,
    slotProps: _
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, L = YNe(e), F = (k == null ? void 0 : k.actionBar) ?? kU, N = Yn({
    elementType: F,
    externalSlotProps: _ == null ? void 0 : _.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: o,
      onCancel: s,
      onSetToday: l,
      actions: t === "desktop" ? [] : ["cancel", "accept"]
    },
    className: L.actionBar,
    ownerState: O({}, e, {
      wrapperVariant: t
    })
  }), V = /* @__PURE__ */ I(F, O({}, N)), z = k == null ? void 0 : k.toolbar, H = Yn({
    elementType: z,
    externalSlotProps: _ == null ? void 0 : _.toolbar,
    additionalProps: {
      isLandscape: R,
      onChange: b,
      value: m,
      view: u,
      onViewChange: h,
      views: p,
      disabled: T,
      readOnly: E
    },
    className: L.toolbar,
    ownerState: O({}, e, {
      wrapperVariant: t
    })
  }), ee = qNe(H) && z ? /* @__PURE__ */ I(z, O({}, H)) : null, K = P, X = k == null ? void 0 : k.tabs, ne = u && X ? /* @__PURE__ */ I(X, O({
    view: u,
    onViewChange: h,
    className: L.tabs
  }, _ == null ? void 0 : _.tabs)) : null, Y = (k == null ? void 0 : k.shortcuts) ?? MU, J = Yn({
    elementType: Y,
    externalSlotProps: _ == null ? void 0 : _.shortcuts,
    additionalProps: {
      isValid: S,
      isLandscape: R,
      onChange: x
    },
    className: L.shortcuts,
    ownerState: {
      isValid: S,
      isLandscape: R,
      onChange: x,
      wrapperVariant: t
    }
  }), te = u && Y ? /* @__PURE__ */ I(Y, O({}, J)) : null;
  return {
    toolbar: ee,
    content: K,
    tabs: ne,
    actionBar: V,
    shortcuts: te
  };
}, GNe = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return vn({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, DU, n);
}, IU = ce("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${Ks.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${Ks.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${Ks.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${Ks.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${Ks.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${Ks.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${Ks.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), _U = ce("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), sN = function(t) {
  const n = We({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: o,
    content: s,
    tabs: l,
    actionBar: u,
    shortcuts: p
  } = NU(n), {
    sx: h,
    className: m,
    isLandscape: b,
    ref: x,
    wrapperVariant: S
  } = n, R = GNe(n);
  return /* @__PURE__ */ qe(IU, {
    ref: x,
    sx: h,
    className: Ne(m, R.root),
    ownerState: n,
    children: [b ? p : o, b ? o : p, /* @__PURE__ */ I(_U, {
      className: R.contentWrapper,
      children: S === "desktop" ? /* @__PURE__ */ qe(D.Fragment, {
        children: [s, l]
      }) : /* @__PURE__ */ qe(D.Fragment, {
        children: [l, s]
      })
    }), u]
  });
};
process.env.NODE_ENV !== "production" && (sN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  isLandscape: r.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: r.bool.isRequired,
  isValid: r.func.isRequired,
  onAccept: r.func.isRequired,
  onCancel: r.func.isRequired,
  onChange: r.func.isRequired,
  onClear: r.func.isRequired,
  onClose: r.func.isRequired,
  onDismiss: r.func.isRequired,
  onOpen: r.func.isRequired,
  onSelectShortcut: r.func.isRequired,
  onSetToday: r.func.isRequired,
  onViewChange: r.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.any,
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: r.arrayOf(r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: r.oneOf(["desktop", "mobile"])
});
const KNe = ["props", "getOpenDialogAriaText"], XNe = ["ownerState"], QNe = ["ownerState"], lN = (e) => {
  var fe;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, o = Te(e, KNe);
  const {
    slots: s,
    slotProps: l,
    className: u,
    sx: p,
    format: h,
    formatDensity: m,
    enableAccessibleFieldDOMStructure: b,
    selectedSections: x,
    onSelectedSectionsChange: S,
    timezone: R,
    name: T,
    label: E,
    inputRef: P,
    readOnly: k,
    disabled: _,
    autoFocus: L,
    localeText: F,
    reduceAnimations: N
  } = t, V = sn(), z = D.useRef(null), H = D.useRef(null), ee = bp(), K = ((fe = l == null ? void 0 : l.toolbar) == null ? void 0 : fe.hidden) ?? !1, {
    open: X,
    actions: ne,
    hasUIView: Y,
    layoutProps: J,
    renderCurrentView: te,
    shouldRestoreFocus: Z,
    fieldProps: ae
  } = $U(O({}, o, {
    props: t,
    fieldRef: H,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), U = s.inputAdornment ?? pT, G = Yn({
    elementType: U,
    externalSlotProps: l == null ? void 0 : l.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: t
  }), W = Te(G, XNe), le = s.openPickerButton ?? oi, pe = Yn({
    elementType: le,
    externalSlotProps: l == null ? void 0 : l.openPickerButton,
    additionalProps: {
      disabled: _ || k,
      onClick: X ? ne.onClose : ne.onOpen,
      "aria-label": n(ae.value, V),
      edge: W.position
    },
    ownerState: t
  }), ge = Te(pe, QNe), we = s.openPickerIcon, de = s.field, se = Yn({
    elementType: de,
    externalSlotProps: l == null ? void 0 : l.field,
    additionalProps: O({}, ae, K && {
      id: ee
    }, {
      readOnly: k,
      disabled: _,
      className: u,
      sx: p,
      format: h,
      formatDensity: m,
      enableAccessibleFieldDOMStructure: b,
      selectedSections: x,
      onSelectedSectionsChange: S,
      timezone: R,
      label: E,
      name: T,
      autoFocus: L && !t.open,
      focused: X ? !0 : void 0
    }, P ? {
      inputRef: P
    } : {}),
    ownerState: t
  });
  Y && (se.InputProps = O({}, se.InputProps, {
    ref: z
  }, !t.disableOpenPicker && {
    [`${W.position}Adornment`]: /* @__PURE__ */ I(U, O({}, W, {
      children: /* @__PURE__ */ I(le, O({}, ge, {
        children: /* @__PURE__ */ I(we, O({}, l == null ? void 0 : l.openPickerIcon))
      }))
    }))
  }));
  const ve = O({
    textField: s.textField,
    clearIcon: s.clearIcon,
    clearButton: s.clearButton
  }, se.slots), me = s.layout ?? sN;
  let Oe = ee;
  K && (E ? Oe = `${ee}-label` : Oe = void 0);
  const be = O({}, l, {
    toolbar: O({}, l == null ? void 0 : l.toolbar, {
      titleId: ee
    }),
    popper: O({
      "aria-labelledby": Oe
    }, l == null ? void 0 : l.popper)
  }), De = ro(H, se.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ qe(LT, {
      localeText: F,
      children: [/* @__PURE__ */ I(de, O({}, se, {
        slots: ve,
        slotProps: be,
        unstableFieldRef: De
      })), /* @__PURE__ */ I(MNe, O({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: z.current
      }, ne, {
        open: X,
        slots: s,
        slotProps: be,
        shouldRestoreFocus: Z,
        reduceAnimations: N,
        children: /* @__PURE__ */ I(me, O({}, J, be == null ? void 0 : be.layout, {
          slots: s,
          slotProps: be,
          children: te()
        }))
      }))]
    })
  };
}, cs = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: o,
  onFocusedViewChange: s,
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minDate: R,
  maxDate: T,
  shouldDisableDate: E,
  shouldDisableMonth: P,
  shouldDisableYear: k,
  reduceAnimations: _,
  onMonthChange: L,
  monthsPerRow: F,
  onYearChange: N,
  yearsPerRow: V,
  slots: z,
  slotProps: H,
  loading: ee,
  renderLoading: K,
  disableHighlightToday: X,
  readOnly: ne,
  disabled: Y,
  showDaysOutsideCurrentMonth: J,
  dayOfWeekFormatter: te,
  sx: Z,
  autoFocus: ae,
  fixedWeekNumber: U,
  displayWeekNumber: G,
  timezone: W
}) => /* @__PURE__ */ I(TU, {
  view: e,
  onViewChange: t,
  views: n.filter(a0),
  focusedView: o && a0(o) ? o : null,
  onFocusedViewChange: s,
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minDate: R,
  maxDate: T,
  shouldDisableDate: E,
  shouldDisableMonth: P,
  shouldDisableYear: k,
  reduceAnimations: _,
  onMonthChange: L,
  monthsPerRow: F,
  onYearChange: N,
  yearsPerRow: V,
  slots: z,
  slotProps: H,
  loading: ee,
  renderLoading: K,
  disableHighlightToday: X,
  readOnly: ne,
  disabled: Y,
  showDaysOutsideCurrentMonth: J,
  dayOfWeekFormatter: te,
  sx: Z,
  autoFocus: ae,
  fixedWeekNumber: U,
  displayWeekNumber: G,
  timezone: W
}), AU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var m, b;
  const o = oo(), s = sn(), l = OU(t, "MuiDesktopDatePicker"), u = O({
    day: cs,
    month: cs,
    year: cs
  }, l.viewRenderers), p = O({}, l, {
    viewRenderers: u,
    format: i0(s, l, !1),
    yearsPerRow: l.yearsPerRow ?? 4,
    slots: O({
      openPickerIcon: A3,
      field: nN
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (x) => {
        var S;
        return O({}, md((S = l.slotProps) == null ? void 0 : S.field, x), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !0
      }, (m = l.slotProps) == null ? void 0 : m.toolbar)
    })
  }), {
    renderPicker: h
  } = lN({
    props: p,
    valueManager: go,
    valueType: "date",
    getOpenDialogAriaText: ((b = p.localeText) == null ? void 0 : b.openDatePickerDialogue) ?? o.openDatePickerDialogue,
    validator: W0
  });
  return h();
});
AU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: r.oneOf([3, 4])
};
const JNe = ce(oT)({
  [`& .${Pb.container}`]: {
    outline: 0
  },
  [`& .${Pb.paper}`]: {
    outline: 0,
    minWidth: VT
  }
}), ZNe = ce(iT)({
  "&:first-of-type": {
    padding: 0
  }
});
function eIe(e) {
  const {
    children: t,
    onDismiss: n,
    open: o,
    slots: s,
    slotProps: l
  } = e, u = (s == null ? void 0 : s.dialog) ?? JNe, p = (s == null ? void 0 : s.mobileTransition) ?? sp;
  return /* @__PURE__ */ I(u, O({
    open: o,
    onClose: n
  }, l == null ? void 0 : l.dialog, {
    TransitionComponent: p,
    TransitionProps: l == null ? void 0 : l.mobileTransition,
    PaperComponent: s == null ? void 0 : s.mobilePaper,
    PaperProps: l == null ? void 0 : l.mobilePaper,
    children: /* @__PURE__ */ I(ZNe, {
      children: t
    })
  }));
}
const tIe = ["props", "getOpenDialogAriaText"], cN = (e) => {
  var le;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, o = Te(e, tIe);
  const {
    slots: s,
    slotProps: l,
    className: u,
    sx: p,
    format: h,
    formatDensity: m,
    enableAccessibleFieldDOMStructure: b,
    selectedSections: x,
    onSelectedSectionsChange: S,
    timezone: R,
    name: T,
    label: E,
    inputRef: P,
    readOnly: k,
    disabled: _,
    localeText: L
  } = t, F = sn(), N = D.useRef(null), V = bp(), z = ((le = l == null ? void 0 : l.toolbar) == null ? void 0 : le.hidden) ?? !1, {
    open: H,
    actions: ee,
    layoutProps: K,
    renderCurrentView: X,
    fieldProps: ne
  } = $U(O({}, o, {
    props: t,
    fieldRef: N,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), Y = s.field, J = Yn({
    elementType: Y,
    externalSlotProps: l == null ? void 0 : l.field,
    additionalProps: O({}, ne, z && {
      id: V
    }, !(_ || k) && {
      onClick: ee.onOpen,
      onKeyDown: Z$e(ee.onOpen)
    }, {
      readOnly: k ?? !0,
      disabled: _,
      className: u,
      sx: p,
      format: h,
      formatDensity: m,
      enableAccessibleFieldDOMStructure: b,
      selectedSections: x,
      onSelectedSectionsChange: S,
      timezone: R,
      label: E,
      name: T
    }, P ? {
      inputRef: P
    } : {}),
    ownerState: t
  });
  J.inputProps = O({}, J.inputProps, {
    "aria-label": n(ne.value, F)
  });
  const te = O({
    textField: s.textField
  }, J.slots), Z = s.layout ?? sN;
  let ae = V;
  z && (E ? ae = `${V}-label` : ae = void 0);
  const U = O({}, l, {
    toolbar: O({}, l == null ? void 0 : l.toolbar, {
      titleId: V
    }),
    mobilePaper: O({
      "aria-labelledby": ae
    }, l == null ? void 0 : l.mobilePaper)
  }), G = ro(N, J.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ qe(LT, {
      localeText: L,
      children: [/* @__PURE__ */ I(Y, O({}, J, {
        slots: te,
        slotProps: U,
        unstableFieldRef: G
      })), /* @__PURE__ */ I(eIe, O({}, ee, {
        open: H,
        slots: s,
        slotProps: U,
        children: /* @__PURE__ */ I(Z, O({}, K, U == null ? void 0 : U.layout, {
          slots: s,
          slotProps: U,
          children: X()
        }))
      }))]
    })
  };
}, LU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var m, b;
  const o = oo(), s = sn(), l = OU(t, "MuiMobileDatePicker"), u = O({
    day: cs,
    month: cs,
    year: cs
  }, l.viewRenderers), p = O({}, l, {
    viewRenderers: u,
    format: i0(s, l, !1),
    slots: O({
      field: nN
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (x) => {
        var S;
        return O({}, md((S = l.slotProps) == null ? void 0 : S.field, x), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !1
      }, (m = l.slotProps) == null ? void 0 : m.toolbar)
    })
  }), {
    renderPicker: h
  } = cN({
    props: p,
    valueManager: go,
    valueType: "date",
    getOpenDialogAriaText: ((b = p.localeText) == null ? void 0 : b.openDatePickerDialogue) ?? o.openDatePickerDialogue,
    validator: W0
  });
  return h();
});
LU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
};
const nIe = ["desktopModeMediaQuery"], FU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: s = WM
  } = o, l = Te(o, nIe);
  return dT(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ I(AU, O({
    ref: n
  }, l)) : /* @__PURE__ */ I(LU, O({
    ref: n
  }, l));
});
process.env.NODE_ENV !== "production" && (FU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: r.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: r.oneOf([3, 4])
});
function rIe(e) {
  return xn("MuiPickersToolbarText", e);
}
const yD = Cn("MuiPickersToolbarText", ["root", "selected"]), oIe = ["className", "selected", "value"], aIe = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return vn({
    root: ["root", n && "selected"]
  }, rIe, t);
}, iIe = ce(nr, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${yD.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${yD.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), uN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: s,
    value: l
  } = o, u = Te(o, oIe), p = aIe(o);
  return /* @__PURE__ */ I(iIe, O({
    ref: n,
    className: Ne(s, p.root),
    component: "span"
  }, u, {
    children: l
  }));
}), sIe = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], lIe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, EU, t);
}, cIe = ce(sd, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), Di = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: s,
    className: l,
    selected: u,
    typographyClassName: p,
    value: h,
    variant: m,
    width: b
  } = o, x = Te(o, sIe), S = lIe(o);
  return /* @__PURE__ */ I(cIe, O({
    variant: "text",
    ref: n,
    className: Ne(l, S.root)
  }, b ? {
    sx: {
      width: b
    }
  } : {}, x, {
    children: /* @__PURE__ */ I(uN, {
      align: s,
      className: p,
      variant: m,
      value: h,
      selected: u
    })
  }));
});
function uIe(e) {
  return xn("MuiTimePickerToolbar", e);
}
const _b = Cn("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), dIe = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], fIe = (e) => {
  const {
    isLandscape: t,
    classes: n,
    isRtl: o
  } = e;
  return vn({
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", t && "hourMinuteLabelLandscape", o && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", t && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  }, uIe, n);
}, pIe = ce(iN, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), hIe = ce(uN, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), mIe = ce("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (e, t) => [{
    [`&.${_b.hourMinuteLabelLandscape}`]: t.hourMinuteLabelLandscape,
    [`&.${_b.hourMinuteLabelReverse}`]: t.hourMinuteLabelReverse
  }, t.hourMinuteLabel]
})({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      isLandscape: !0
    },
    style: {
      marginTop: "auto"
    }
  }]
}), vIe = ce("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${_b.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${_b.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12,
  [`& .${_b.ampmLabel}`]: {
    fontSize: 17
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "4px 0 auto",
      flexDirection: "row",
      justifyContent: "space-around",
      flexBasis: "100%"
    }
  }]
});
function jU(e) {
  const t = We({
    props: e,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: o,
    value: s,
    isLandscape: l,
    onChange: u,
    view: p,
    onViewChange: h,
    views: m,
    disabled: b,
    readOnly: x,
    className: S
  } = t, R = Te(t, dIe), T = sn(), E = oo(), P = vs(), k = !!(n && !o && m.includes("hours")), {
    meridiemMode: _,
    handleMeridiemChange: L
  } = FT(s, n, u), F = (H) => n ? T.format(H, "hours12h") : T.format(H, "hours24h"), N = O({}, t, {
    isRtl: P
  }), V = fIe(N), z = /* @__PURE__ */ I(hIe, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: V.separator
  });
  return /* @__PURE__ */ qe(pIe, O({
    landscapeDirection: "row",
    toolbarTitle: E.timePickerToolbarTitle,
    isLandscape: l,
    ownerState: N,
    className: Ne(V.root, S)
  }, R, {
    children: [/* @__PURE__ */ qe(mIe, {
      className: V.hourMinuteLabel,
      ownerState: N,
      children: [Gm(m, "hours") && /* @__PURE__ */ I(Di, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => h("hours"),
        selected: p === "hours",
        value: s ? F(s) : "--"
      }), Gm(m, ["hours", "minutes"]) && z, Gm(m, "minutes") && /* @__PURE__ */ I(Di, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => h("minutes"),
        selected: p === "minutes",
        value: s ? T.format(s, "minutes") : "--"
      }), Gm(m, ["minutes", "seconds"]) && z, Gm(m, "seconds") && /* @__PURE__ */ I(Di, {
        variant: "h3",
        onClick: () => h("seconds"),
        selected: p === "seconds",
        value: s ? T.format(s, "seconds") : "--"
      })]
    }), k && /* @__PURE__ */ qe(vIe, {
      className: V.ampmSelection,
      ownerState: N,
      children: [/* @__PURE__ */ I(Di, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: _ === "am",
        typographyClassName: V.ampmLabel,
        value: Zs(T, "am"),
        onClick: x ? void 0 : () => L("am"),
        disabled: b
      }), /* @__PURE__ */ I(Di, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: _ === "pm",
        typographyClassName: V.ampmLabel,
        value: Zs(T, "pm"),
        onClick: x ? void 0 : () => L("pm"),
        disabled: b
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (jU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  ampm: r.bool,
  ampmInClock: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: r.bool,
  isLandscape: r.bool.isRequired,
  onChange: r.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  readOnly: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  titleId: r.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: r.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: r.node,
  value: r.object,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function VU(e, t) {
  var u;
  const n = sn(), o = We({
    props: e,
    name: t
  }), s = o.ampm ?? n.is12HourCycleInCurrentLocale(), l = D.useMemo(() => {
    var p;
    return ((p = o.localeText) == null ? void 0 : p.toolbarTitle) == null ? o.localeText : O({}, o.localeText, {
      timePickerToolbarTitle: o.localeText.toolbarTitle
    });
  }, [o.localeText]);
  return O({}, o, {
    ampm: s,
    localeText: l
  }, AM({
    views: o.views,
    openTo: o.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: o.disableFuture ?? !1,
    disablePast: o.disablePast ?? !1,
    slots: O({
      toolbar: jU
    }, o.slots),
    slotProps: O({}, o.slotProps, {
      toolbar: O({
        ampm: s,
        ampmInClock: o.ampmInClock
      }, (u = o.slotProps) == null ? void 0 : u.toolbar)
    })
  });
}
const av = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: s,
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  ampmInClock: _,
  slots: L,
  slotProps: F,
  readOnly: N,
  disabled: V,
  sx: z,
  autoFocus: H,
  showViewSwitcher: ee,
  disableIgnoringDatePartForTimeValidation: K,
  timezone: X
}) => /* @__PURE__ */ I(G3, {
  view: e,
  onViewChange: t,
  focusedView: n && mv(n) ? n : null,
  onFocusedViewChange: o,
  views: s.filter(mv),
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  ampmInClock: _,
  slots: L,
  slotProps: F,
  readOnly: N,
  disabled: V,
  sx: z,
  autoFocus: H,
  showViewSwitcher: ee,
  disableIgnoringDatePartForTimeValidation: K,
  timezone: X
}), BU = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: s,
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  slots: _,
  slotProps: L,
  readOnly: F,
  disabled: N,
  sx: V,
  autoFocus: z,
  disableIgnoringDatePartForTimeValidation: H,
  timeSteps: ee,
  skipDisabled: K,
  timezone: X
}) => /* @__PURE__ */ I(K3, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: s.filter(mv),
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  slots: _,
  slotProps: L,
  readOnly: F,
  disabled: N,
  sx: V,
  autoFocus: z,
  disableIgnoringDatePartForTimeValidation: H,
  timeStep: ee == null ? void 0 : ee.minutes,
  skipDisabled: K,
  timezone: X
}), bw = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: s,
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  slots: _,
  slotProps: L,
  readOnly: F,
  disabled: N,
  sx: V,
  autoFocus: z,
  disableIgnoringDatePartForTimeValidation: H,
  timeSteps: ee,
  skipDisabled: K,
  timezone: X
}) => /* @__PURE__ */ I(X3, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: o,
  views: s.filter(mv),
  value: l,
  defaultValue: u,
  referenceDate: p,
  onChange: h,
  className: m,
  classes: b,
  disableFuture: x,
  disablePast: S,
  minTime: R,
  maxTime: T,
  shouldDisableTime: E,
  minutesStep: P,
  ampm: k,
  slots: _,
  slotProps: L,
  readOnly: F,
  disabled: N,
  sx: V,
  autoFocus: z,
  disableIgnoringDatePartForTimeValidation: H,
  timeSteps: ee,
  skipDisabled: K,
  timezone: X
}), gIe = ["views", "format"], zU = (e, t) => {
  let {
    views: n,
    format: o
  } = t, s = Te(t, gIe);
  if (o)
    return o;
  const l = [], u = [];
  if (n.forEach((m) => {
    mv(m) ? u.push(m) : l.push(m);
  }), u.length === 0)
    return i0(e, O({
      views: l
    }, s), !1);
  if (l.length === 0)
    return vw(e, O({
      views: u
    }, s));
  const p = vw(e, O({
    views: u
  }, s));
  return `${i0(e, O({
    views: l
  }, s), !1)} ${p}`;
}, yIe = (e, t, n) => n ? t.filter((o) => !xb(o) || o === "hours") : e ? [...t, "meridiem"] : t, bIe = (e, t) => 24 * 60 / ((e.hours ?? 1) * (e.minutes ?? 5)) <= t;
function UU({
  thresholdToRenderTimeInASingleColumn: e,
  ampm: t,
  timeSteps: n,
  views: o
}) {
  const s = e ?? 24, l = O({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), u = bIe(l, s);
  return {
    thresholdToRenderTimeInASingleColumn: s,
    timeSteps: l,
    shouldRenderTimeInASingleColumn: u,
    views: yIe(t, o, u)
  };
}
const HU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var k, _, L, F;
  const o = oo(), s = sn(), l = VU(t, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: u,
    views: p,
    timeSteps: h
  } = UU(l), m = u ? BU : bw, b = O({
    hours: m,
    minutes: m,
    seconds: m,
    meridiem: m
  }, l.viewRenderers), x = l.ampmInClock ?? !0, S = u ? [] : ["accept"], T = ((k = b.hours) == null ? void 0 : k.name) === bw.name ? p : p.filter((N) => N !== "meridiem"), E = O({}, l, {
    ampmInClock: x,
    timeSteps: h,
    viewRenderers: b,
    format: vw(s, l),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: u ? ["hours"] : T,
    slots: O({
      field: rN,
      openPickerIcon: aPe
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (N) => {
        var V;
        return O({}, md((V = l.slotProps) == null ? void 0 : V.field, N), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !0,
        ampmInClock: x
      }, (_ = l.slotProps) == null ? void 0 : _.toolbar),
      actionBar: O({
        actions: S
      }, (L = l.slotProps) == null ? void 0 : L.actionBar)
    })
  }), {
    renderPicker: P
  } = lN({
    props: E,
    valueManager: go,
    valueType: "time",
    getOpenDialogAriaText: ((F = E.localeText) == null ? void 0 : F.openTimePickerDialogue) ?? o.openTimePickerDialogue,
    validator: nE
  });
  return P();
});
HU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: r.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: r.shape({
    hours: r.number,
    minutes: r.number,
    seconds: r.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    hours: r.func,
    meridiem: r.func,
    minutes: r.func,
    seconds: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const WU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var b, x;
  const o = oo(), s = sn(), l = VU(t, "MuiMobileTimePicker"), u = O({
    hours: av,
    minutes: av,
    seconds: av
  }, l.viewRenderers), p = l.ampmInClock ?? !1, h = O({}, l, {
    ampmInClock: p,
    viewRenderers: u,
    format: vw(s, l),
    slots: O({
      field: rN
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (S) => {
        var R;
        return O({}, md((R = l.slotProps) == null ? void 0 : R.field, S), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !1,
        ampmInClock: p
      }, (b = l.slotProps) == null ? void 0 : b.toolbar)
    })
  }), {
    renderPicker: m
  } = cN({
    props: h,
    valueManager: go,
    valueType: "time",
    getOpenDialogAriaText: ((x = h.localeText) == null ? void 0 : x.openTimePickerDialogue) ?? o.openTimePickerDialogue,
    validator: nE
  });
  return m();
});
WU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    hours: r.func,
    minutes: r.func,
    seconds: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const xIe = ["desktopModeMediaQuery"], qU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: s = WM
  } = o, l = Te(o, xIe);
  return dT(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ I(HU, O({
    ref: n
  }, l)) : /* @__PURE__ */ I(WU, O({
    ref: n
  }, l));
});
process.env.NODE_ENV !== "production" && (qU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: r.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: r.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: r.shape({
    hours: r.number,
    minutes: r.number,
    seconds: r.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    hours: r.func,
    meridiem: r.func,
    minutes: r.func,
    seconds: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function SIe(e) {
  return xn("MuiDateTimePickerTabs", e);
}
Cn("MuiDateTimePickerTabs", ["root"]);
const CIe = (e) => a0(e) ? "date" : "time", wIe = (e) => e === "date" ? "day" : "hours", TIe = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, SIe, t);
}, EIe = ce(xk, {
  name: "MuiDateTimePickerTabs",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  boxShadow: `0 -1px 0 0 inset ${(e.vars || e).palette.divider}`,
  "&:last-child": {
    boxShadow: `0 1px 0 0 inset ${(e.vars || e).palette.divider}`,
    [`& .${D1.indicator}`]: {
      bottom: "auto",
      top: 0
    }
  }
})), YU = function(t) {
  const n = We({
    props: t,
    name: "MuiDateTimePickerTabs"
  }), {
    dateIcon: o = /* @__PURE__ */ I(iPe, {}),
    onViewChange: s,
    timeIcon: l = /* @__PURE__ */ I(sPe, {}),
    view: u,
    hidden: p = typeof window > "u" || window.innerHeight < 667,
    className: h,
    sx: m
  } = n, b = oo(), x = TIe(n), S = (R, T) => {
    s(wIe(T));
  };
  return p ? null : /* @__PURE__ */ qe(EIe, {
    ownerState: n,
    variant: "fullWidth",
    value: CIe(u),
    onChange: S,
    className: Ne(h, x.root),
    sx: m,
    children: [/* @__PURE__ */ I(Z1, {
      value: "date",
      "aria-label": b.dateTableLabel,
      icon: /* @__PURE__ */ I(D.Fragment, {
        children: o
      })
    }), /* @__PURE__ */ I(Z1, {
      value: "time",
      "aria-label": b.timeTableLabel,
      icon: /* @__PURE__ */ I(D.Fragment, {
        children: l
      })
    })]
  });
};
process.env.NODE_ENV !== "production" && (YU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * Date tab icon.
   * @default DateRange
   */
  dateIcon: r.node,
  /**
   * Toggles visibility of the tabs allowing view switching.
   * @default `window.innerHeight < 667` for `DesktopDateTimePicker` and `MobileDateTimePicker`, `displayStaticWrapperAs === 'desktop'` for `StaticDateTimePicker`
   */
  hidden: r.bool,
  /**
   * Callback called when a tab is clicked.
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Time tab icon.
   * @default Time
   */
  timeIcon: r.node,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired
});
function RIe(e) {
  return xn("MuiDateTimePickerToolbar", e);
}
const R$ = Cn("MuiDateTimePickerToolbar", ["root", "dateContainer", "timeContainer", "timeDigitsContainer", "separator", "timeLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), OIe = ["ampm", "ampmInClock", "value", "onChange", "view", "isLandscape", "onViewChange", "toolbarFormat", "toolbarPlaceholder", "views", "disabled", "readOnly", "toolbarVariant", "toolbarTitle", "className"], PIe = (e) => {
  const {
    classes: t,
    isLandscape: n,
    isRtl: o
  } = e;
  return vn({
    root: ["root"],
    dateContainer: ["dateContainer"],
    timeContainer: ["timeContainer", o && "timeLabelReverse"],
    timeDigitsContainer: ["timeDigitsContainer", o && "timeLabelReverse"],
    separator: ["separator"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  }, RIe, t);
}, $Ie = ce(iN, {
  name: "MuiDateTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  paddingLeft: 16,
  paddingRight: 16,
  justifyContent: "space-around",
  position: "relative",
  variants: [{
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      [`& .${hNe.content} .${yD.selected}`]: {
        color: (e.vars || e).palette.primary.main,
        fontWeight: e.typography.fontWeightBold
      }
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !0
    },
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !1
    },
    style: {
      paddingLeft: 24,
      paddingRight: 0
    }
  }]
})), DIe = ce("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "DateContainer",
  overridesResolver: (e, t) => t.dateContainer
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}), kIe = ce("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeContainer",
  overridesResolver: (e, t) => t.timeContainer
})({
  display: "flex",
  flexDirection: "row",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      toolbarVariant: "desktop",
      isLandscape: !1
    },
    style: {
      gap: 9,
      marginRight: 4,
      alignSelf: "flex-end"
    }
  }, {
    props: ({
      isLandscape: e,
      toolbarVariant: t
    }) => e && t !== "desktop",
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      isLandscape: e,
      toolbarVariant: t,
      isRtl: n
    }) => e && t !== "desktop" && n,
    style: {
      flexDirection: "column-reverse"
    }
  }]
}), MIe = ce("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeDigitsContainer",
  overridesResolver: (e, t) => t.timeDigitsContainer
})({
  display: "flex",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      gap: 1.5
    }
  }]
}), VV = ce(uN, {
  name: "MuiDateTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  margin: "0 4px 0 2px",
  cursor: "default",
  variants: [{
    props: {
      toolbarVariant: "desktop"
    },
    style: {
      margin: 0
    }
  }]
}), NIe = ce("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${R$.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${R$.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12,
  [`& .${R$.ampmLabel}`]: {
    fontSize: 17
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "4px 0 auto",
      flexDirection: "row",
      justifyContent: "space-around",
      width: "100%"
    }
  }]
});
function GU(e) {
  const t = We({
    props: e,
    name: "MuiDateTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: o,
    value: s,
    onChange: l,
    view: u,
    isLandscape: p,
    onViewChange: h,
    toolbarFormat: m,
    toolbarPlaceholder: b = "––",
    views: x,
    disabled: S,
    readOnly: R,
    toolbarVariant: T = "mobile",
    toolbarTitle: E,
    className: P
  } = t, k = Te(t, OIe), _ = vs(), L = O({}, t, {
    isRtl: _
  }), F = sn(), {
    meridiemMode: N,
    handleMeridiemChange: V
  } = FT(s, n, l), z = !!(n && !o), H = T === "desktop", ee = oo(), K = PIe(L), X = E ?? ee.dateTimePickerToolbarTitle, ne = (J) => n ? F.format(J, "hours12h") : F.format(J, "hours24h"), Y = D.useMemo(() => s ? m ? F.formatByString(s, m) : F.format(s, "shortDate") : b, [s, m, b, F]);
  return /* @__PURE__ */ qe($Ie, O({
    isLandscape: p,
    className: Ne(K.root, P),
    toolbarTitle: X
  }, k, {
    ownerState: L,
    children: [/* @__PURE__ */ qe(DIe, {
      className: K.dateContainer,
      ownerState: L,
      children: [x.includes("year") && /* @__PURE__ */ I(Di, {
        tabIndex: -1,
        variant: "subtitle1",
        onClick: () => h("year"),
        selected: u === "year",
        value: s ? F.format(s, "year") : "–"
      }), x.includes("day") && /* @__PURE__ */ I(Di, {
        tabIndex: -1,
        variant: H ? "h5" : "h4",
        onClick: () => h("day"),
        selected: u === "day",
        value: Y
      })]
    }), /* @__PURE__ */ qe(kIe, {
      className: K.timeContainer,
      ownerState: L,
      children: [/* @__PURE__ */ qe(MIe, {
        className: K.timeDigitsContainer,
        ownerState: L,
        children: [x.includes("hours") && /* @__PURE__ */ qe(D.Fragment, {
          children: [/* @__PURE__ */ I(Di, {
            variant: H ? "h5" : "h3",
            width: H && !p ? Sb : void 0,
            onClick: () => h("hours"),
            selected: u === "hours",
            value: s ? ne(s) : "--"
          }), /* @__PURE__ */ I(VV, {
            variant: H ? "h5" : "h3",
            value: ":",
            className: K.separator,
            ownerState: L
          }), /* @__PURE__ */ I(Di, {
            variant: H ? "h5" : "h3",
            width: H && !p ? Sb : void 0,
            onClick: () => h("minutes"),
            selected: u === "minutes" || !x.includes("minutes") && u === "hours",
            value: s ? F.format(s, "minutes") : "--",
            disabled: !x.includes("minutes")
          })]
        }), x.includes("seconds") && /* @__PURE__ */ qe(D.Fragment, {
          children: [/* @__PURE__ */ I(VV, {
            variant: H ? "h5" : "h3",
            value: ":",
            className: K.separator,
            ownerState: L
          }), /* @__PURE__ */ I(Di, {
            variant: H ? "h5" : "h3",
            width: H && !p ? Sb : void 0,
            onClick: () => h("seconds"),
            selected: u === "seconds",
            value: s ? F.format(s, "seconds") : "--"
          })]
        })]
      }), z && !H && /* @__PURE__ */ qe(NIe, {
        className: K.ampmSelection,
        ownerState: L,
        children: [/* @__PURE__ */ I(Di, {
          variant: "subtitle2",
          selected: N === "am",
          typographyClassName: K.ampmLabel,
          value: Zs(F, "am"),
          onClick: R ? void 0 : () => V("am"),
          disabled: S
        }), /* @__PURE__ */ I(Di, {
          variant: "subtitle2",
          selected: N === "pm",
          typographyClassName: K.ampmLabel,
          value: Zs(F, "pm"),
          onClick: R ? void 0 : () => V("pm"),
          disabled: S
        })]
      }), n && H && /* @__PURE__ */ I(Di, {
        variant: "h5",
        onClick: () => h("meridiem"),
        selected: u === "meridiem",
        value: s && N ? Zs(F, N) : "--",
        width: Sb
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (GU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  ampm: r.bool,
  ampmInClock: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: r.bool,
  isLandscape: r.bool.isRequired,
  onChange: r.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  readOnly: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  titleId: r.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: r.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: r.node,
  /**
   * If provided, it will be used instead of `dateTimePickerToolbarTitle` from localization.
   */
  toolbarTitle: r.node,
  toolbarVariant: r.oneOf(["desktop", "mobile"]),
  value: r.object,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired
});
function KU(e, t) {
  var p;
  const n = sn(), o = Sp(), s = We({
    props: e,
    name: t
  }), l = s.ampm ?? n.is12HourCycleInCurrentLocale(), u = D.useMemo(() => {
    var h;
    return ((h = s.localeText) == null ? void 0 : h.toolbarTitle) == null ? s.localeText : O({}, s.localeText, {
      dateTimePickerToolbarTitle: s.localeText.toolbarTitle
    });
  }, [s.localeText]);
  return O({}, s, AM({
    views: s.views,
    openTo: s.openTo,
    defaultViews: ["year", "day", "hours", "minutes"],
    defaultOpenTo: "day"
  }), {
    ampm: l,
    localeText: u,
    orientation: s.orientation ?? "portrait",
    // TODO: Remove from public API
    disableIgnoringDatePartForTimeValidation: s.disableIgnoringDatePartForTimeValidation ?? !!(s.minDateTime || s.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
    s.disablePast || s.disableFuture),
    disableFuture: s.disableFuture ?? !1,
    disablePast: s.disablePast ?? !1,
    minDate: pa(n, s.minDateTime ?? s.minDate, o.minDate),
    maxDate: pa(n, s.maxDateTime ?? s.maxDate, o.maxDate),
    minTime: s.minDateTime ?? s.minTime,
    maxTime: s.maxDateTime ?? s.maxTime,
    slots: O({
      toolbar: GU,
      tabs: YU
    }, s.slots),
    slotProps: O({}, s.slotProps, {
      toolbar: O({
        ampm: l
      }, (p = s.slotProps) == null ? void 0 : p.toolbar)
    })
  });
}
function XU(e) {
  var T;
  const t = vs(), {
    toolbar: n,
    tabs: o,
    content: s,
    actionBar: l,
    shortcuts: u
  } = NU(e), {
    sx: p,
    className: h,
    isLandscape: m,
    ref: b,
    classes: x
  } = e, S = l && (((T = l.props.actions) == null ? void 0 : T.length) ?? 0) > 0, R = O({}, e, {
    isRtl: t
  });
  return /* @__PURE__ */ qe(IU, {
    ref: b,
    className: Ne(h, Ks.root, x == null ? void 0 : x.root),
    sx: [{
      [`& .${Ks.tabs}`]: {
        gridRow: 4,
        gridColumn: "1 / 4"
      },
      [`& .${Ks.actionBar}`]: {
        gridRow: 5
      }
    }, ...Array.isArray(p) ? p : [p]],
    ownerState: R,
    children: [m ? u : n, m ? n : u, /* @__PURE__ */ qe(_U, {
      className: Ne(Ks.contentWrapper, x == null ? void 0 : x.contentWrapper),
      sx: {
        display: "grid"
      },
      children: [s, o, S && /* @__PURE__ */ I(x0, {
        sx: {
          gridRow: 3,
          gridColumn: "1 / 4"
        }
      })]
    }), l]
  });
}
process.env.NODE_ENV !== "production" && (XU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  isLandscape: r.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: r.bool.isRequired,
  isValid: r.func.isRequired,
  onAccept: r.func.isRequired,
  onCancel: r.func.isRequired,
  onChange: r.func.isRequired,
  onClear: r.func.isRequired,
  onClose: r.func.isRequired,
  onDismiss: r.func.isRequired,
  onOpen: r.func.isRequired,
  onSelectShortcut: r.func.isRequired,
  onSetToday: r.func.isRequired,
  onViewChange: r.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.any,
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: r.arrayOf(r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: r.oneOf(["desktop", "mobile"])
});
const IIe = ["openTo", "focusedView", "timeViewsCount"], _Ie = function(t, n, o) {
  var b, x;
  const {
    openTo: s,
    focusedView: l,
    timeViewsCount: u
  } = o, p = Te(o, IIe), h = O({}, p, {
    focusedView: null,
    sx: [{
      [`&.${kV.root}`]: {
        borderBottom: 0
      },
      [`&.${kV.root}, .${P$e.root}, &.${x$e.root}`]: {
        maxHeight: BT
      }
    }]
  }), m = xb(n);
  return /* @__PURE__ */ qe(D.Fragment, {
    children: [(b = t[m ? "day" : n]) == null ? void 0 : b.call(t, O({}, o, {
      view: m ? "day" : n,
      focusedView: l && a0(l) ? l : null,
      views: o.views.filter(a0),
      sx: [{
        gridColumn: 1
      }, ...h.sx]
    })), u > 0 && /* @__PURE__ */ qe(D.Fragment, {
      children: [/* @__PURE__ */ I(x0, {
        orientation: "vertical",
        sx: {
          gridColumn: 2
        }
      }), (x = t[m ? n : "hours"]) == null ? void 0 : x.call(t, O({}, h, {
        view: m ? n : "hours",
        focusedView: l && xb(l) ? l : null,
        openTo: xb(s) ? s : "hours",
        views: o.views.filter(xb),
        sx: [{
          gridColumn: 3
        }, ...h.sx]
      }))]
    })]
  });
}, QU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var _, L, F, N;
  const o = oo(), s = sn(), l = KU(t, "MuiDesktopDateTimePicker"), {
    shouldRenderTimeInASingleColumn: u,
    thresholdToRenderTimeInASingleColumn: p,
    views: h,
    timeSteps: m
  } = UU(l), b = u ? BU : bw, x = O({
    day: cs,
    month: cs,
    year: cs,
    hours: b,
    minutes: b,
    seconds: b,
    meridiem: b
  }, l.viewRenderers), S = l.ampmInClock ?? !0, T = ((_ = x.hours) == null ? void 0 : _.name) === bw.name ? h : h.filter((V) => V !== "meridiem"), E = u ? [] : ["accept"], P = O({}, l, {
    viewRenderers: x,
    format: zU(s, l),
    views: T,
    yearsPerRow: l.yearsPerRow ?? 4,
    ampmInClock: S,
    timeSteps: m,
    thresholdToRenderTimeInASingleColumn: p,
    shouldRenderTimeInASingleColumn: u,
    slots: O({
      field: aN,
      layout: XU,
      openPickerIcon: A3
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (V) => {
        var z;
        return O({}, md((z = l.slotProps) == null ? void 0 : z.field, V), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !0,
        ampmInClock: S,
        toolbarVariant: "desktop"
      }, (L = l.slotProps) == null ? void 0 : L.toolbar),
      tabs: O({
        hidden: !0
      }, (F = l.slotProps) == null ? void 0 : F.tabs),
      actionBar: (V) => {
        var z;
        return O({
          actions: E
        }, md((z = l.slotProps) == null ? void 0 : z.actionBar, V));
      }
    })
  }), {
    renderPicker: k
  } = lN({
    props: P,
    valueManager: go,
    valueType: "date-time",
    getOpenDialogAriaText: ((N = P.localeText) == null ? void 0 : N.openDatePickerDialogue) ?? o.openDatePickerDialogue,
    validator: oN,
    rendererInterceptor: _Ie
  });
  return k();
});
QU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: r.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: r.shape({
    hours: r.number,
    minutes: r.number,
    seconds: r.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    hours: r.func,
    meridiem: r.func,
    minutes: r.func,
    month: r.func,
    seconds: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: r.oneOf([3, 4])
};
const JU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  var b, x, S;
  const o = oo(), s = sn(), l = KU(t, "MuiMobileDateTimePicker"), u = O({
    day: cs,
    month: cs,
    year: cs,
    hours: av,
    minutes: av,
    seconds: av
  }, l.viewRenderers), p = l.ampmInClock ?? !1, h = O({}, l, {
    viewRenderers: u,
    format: zU(s, l),
    ampmInClock: p,
    slots: O({
      field: aN
    }, l.slots),
    slotProps: O({}, l.slotProps, {
      field: (R) => {
        var T;
        return O({}, md((T = l.slotProps) == null ? void 0 : T.field, R), jv(l), {
          ref: n
        });
      },
      toolbar: O({
        hidden: !1,
        ampmInClock: p
      }, (b = l.slotProps) == null ? void 0 : b.toolbar),
      tabs: O({
        hidden: !1
      }, (x = l.slotProps) == null ? void 0 : x.tabs)
    })
  }), {
    renderPicker: m
  } = cN({
    props: h,
    valueManager: go,
    valueType: "date-time",
    getOpenDialogAriaText: ((S = h.localeText) == null ? void 0 : S.openDatePickerDialogue) ?? o.openDatePickerDialogue,
    validator: oN
  });
  return m();
});
JU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    hours: r.func,
    minutes: r.func,
    month: r.func,
    seconds: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
};
const AIe = ["desktopModeMediaQuery"], ZU = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiDateTimePicker"
  }), {
    desktopModeMediaQuery: s = WM
  } = o, l = Te(o, AIe);
  return dT(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ I(QU, O({
    ref: n
  }, l)) : /* @__PURE__ */ I(JU, O({
    ref: n
  }, l));
});
process.env.NODE_ENV !== "production" && (ZU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: r.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: r.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: r.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Ko,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   */
  maxDate: r.object,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: r.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: r.object,
  /**
   * Minimal selectable date.
   */
  minDate: r.object,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: r.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: r.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: r.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: r.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: r.shape({
    hours: r.number,
    minutes: r.number,
    seconds: r.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    hours: r.func,
    meridiem: r.func,
    minutes: r.func,
    month: r.func,
    seconds: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: r.oneOf([3, 4])
});
var eH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    var n = 1e3, o = 6e4, s = 36e5, l = "millisecond", u = "second", p = "minute", h = "hour", m = "day", b = "week", x = "month", S = "quarter", R = "year", T = "date", E = "Invalid Date", P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, _ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(J) {
      var te = ["th", "st", "nd", "rd"], Z = J % 100;
      return "[" + J + (te[(Z - 20) % 10] || te[Z] || te[0]) + "]";
    } }, L = function(J, te, Z) {
      var ae = String(J);
      return !ae || ae.length >= te ? J : "" + Array(te + 1 - ae.length).join(Z) + J;
    }, F = { s: L, z: function(J) {
      var te = -J.utcOffset(), Z = Math.abs(te), ae = Math.floor(Z / 60), U = Z % 60;
      return (te <= 0 ? "+" : "-") + L(ae, 2, "0") + ":" + L(U, 2, "0");
    }, m: function J(te, Z) {
      if (te.date() < Z.date()) return -J(Z, te);
      var ae = 12 * (Z.year() - te.year()) + (Z.month() - te.month()), U = te.clone().add(ae, x), G = Z - U < 0, W = te.clone().add(ae + (G ? -1 : 1), x);
      return +(-(ae + (Z - U) / (G ? U - W : W - U)) || 0);
    }, a: function(J) {
      return J < 0 ? Math.ceil(J) || 0 : Math.floor(J);
    }, p: function(J) {
      return { M: x, y: R, w: b, d: m, D: T, h, m: p, s: u, ms: l, Q: S }[J] || String(J || "").toLowerCase().replace(/s$/, "");
    }, u: function(J) {
      return J === void 0;
    } }, N = "en", V = {};
    V[N] = _;
    var z = "$isDayjsObject", H = function(J) {
      return J instanceof ne || !(!J || !J[z]);
    }, ee = function J(te, Z, ae) {
      var U;
      if (!te) return N;
      if (typeof te == "string") {
        var G = te.toLowerCase();
        V[G] && (U = G), Z && (V[G] = Z, U = G);
        var W = te.split("-");
        if (!U && W.length > 1) return J(W[0]);
      } else {
        var le = te.name;
        V[le] = te, U = le;
      }
      return !ae && U && (N = U), U || !ae && N;
    }, K = function(J, te) {
      if (H(J)) return J.clone();
      var Z = typeof te == "object" ? te : {};
      return Z.date = J, Z.args = arguments, new ne(Z);
    }, X = F;
    X.l = ee, X.i = H, X.w = function(J, te) {
      return K(J, { locale: te.$L, utc: te.$u, x: te.$x, $offset: te.$offset });
    };
    var ne = function() {
      function J(Z) {
        this.$L = ee(Z.locale, null, !0), this.parse(Z), this.$x = this.$x || Z.x || {}, this[z] = !0;
      }
      var te = J.prototype;
      return te.parse = function(Z) {
        this.$d = function(ae) {
          var U = ae.date, G = ae.utc;
          if (U === null) return /* @__PURE__ */ new Date(NaN);
          if (X.u(U)) return /* @__PURE__ */ new Date();
          if (U instanceof Date) return new Date(U);
          if (typeof U == "string" && !/Z$/i.test(U)) {
            var W = U.match(P);
            if (W) {
              var le = W[2] - 1 || 0, pe = (W[7] || "0").substring(0, 3);
              return G ? new Date(Date.UTC(W[1], le, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, pe)) : new Date(W[1], le, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, pe);
            }
          }
          return new Date(U);
        }(Z), this.init();
      }, te.init = function() {
        var Z = this.$d;
        this.$y = Z.getFullYear(), this.$M = Z.getMonth(), this.$D = Z.getDate(), this.$W = Z.getDay(), this.$H = Z.getHours(), this.$m = Z.getMinutes(), this.$s = Z.getSeconds(), this.$ms = Z.getMilliseconds();
      }, te.$utils = function() {
        return X;
      }, te.isValid = function() {
        return this.$d.toString() !== E;
      }, te.isSame = function(Z, ae) {
        var U = K(Z);
        return this.startOf(ae) <= U && U <= this.endOf(ae);
      }, te.isAfter = function(Z, ae) {
        return K(Z) < this.startOf(ae);
      }, te.isBefore = function(Z, ae) {
        return this.endOf(ae) < K(Z);
      }, te.$g = function(Z, ae, U) {
        return X.u(Z) ? this[ae] : this.set(U, Z);
      }, te.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, te.valueOf = function() {
        return this.$d.getTime();
      }, te.startOf = function(Z, ae) {
        var U = this, G = !!X.u(ae) || ae, W = X.p(Z), le = function(Oe, be) {
          var De = X.w(U.$u ? Date.UTC(U.$y, be, Oe) : new Date(U.$y, be, Oe), U);
          return G ? De : De.endOf(m);
        }, pe = function(Oe, be) {
          return X.w(U.toDate()[Oe].apply(U.toDate("s"), (G ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(be)), U);
        }, ge = this.$W, we = this.$M, de = this.$D, se = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case R:
            return G ? le(1, 0) : le(31, 11);
          case x:
            return G ? le(1, we) : le(0, we + 1);
          case b:
            var ve = this.$locale().weekStart || 0, me = (ge < ve ? ge + 7 : ge) - ve;
            return le(G ? de - me : de + (6 - me), we);
          case m:
          case T:
            return pe(se + "Hours", 0);
          case h:
            return pe(se + "Minutes", 1);
          case p:
            return pe(se + "Seconds", 2);
          case u:
            return pe(se + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, te.endOf = function(Z) {
        return this.startOf(Z, !1);
      }, te.$set = function(Z, ae) {
        var U, G = X.p(Z), W = "set" + (this.$u ? "UTC" : ""), le = (U = {}, U[m] = W + "Date", U[T] = W + "Date", U[x] = W + "Month", U[R] = W + "FullYear", U[h] = W + "Hours", U[p] = W + "Minutes", U[u] = W + "Seconds", U[l] = W + "Milliseconds", U)[G], pe = G === m ? this.$D + (ae - this.$W) : ae;
        if (G === x || G === R) {
          var ge = this.clone().set(T, 1);
          ge.$d[le](pe), ge.init(), this.$d = ge.set(T, Math.min(this.$D, ge.daysInMonth())).$d;
        } else le && this.$d[le](pe);
        return this.init(), this;
      }, te.set = function(Z, ae) {
        return this.clone().$set(Z, ae);
      }, te.get = function(Z) {
        return this[X.p(Z)]();
      }, te.add = function(Z, ae) {
        var U, G = this;
        Z = Number(Z);
        var W = X.p(ae), le = function(we) {
          var de = K(G);
          return X.w(de.date(de.date() + Math.round(we * Z)), G);
        };
        if (W === x) return this.set(x, this.$M + Z);
        if (W === R) return this.set(R, this.$y + Z);
        if (W === m) return le(1);
        if (W === b) return le(7);
        var pe = (U = {}, U[p] = o, U[h] = s, U[u] = n, U)[W] || 1, ge = this.$d.getTime() + Z * pe;
        return X.w(ge, this);
      }, te.subtract = function(Z, ae) {
        return this.add(-1 * Z, ae);
      }, te.format = function(Z) {
        var ae = this, U = this.$locale();
        if (!this.isValid()) return U.invalidDate || E;
        var G = Z || "YYYY-MM-DDTHH:mm:ssZ", W = X.z(this), le = this.$H, pe = this.$m, ge = this.$M, we = U.weekdays, de = U.months, se = U.meridiem, ve = function(be, De, ie, fe) {
          return be && (be[De] || be(ae, G)) || ie[De].slice(0, fe);
        }, me = function(be) {
          return X.s(le % 12 || 12, be, "0");
        }, Oe = se || function(be, De, ie) {
          var fe = be < 12 ? "AM" : "PM";
          return ie ? fe.toLowerCase() : fe;
        };
        return G.replace(k, function(be, De) {
          return De || function(ie) {
            switch (ie) {
              case "YY":
                return String(ae.$y).slice(-2);
              case "YYYY":
                return X.s(ae.$y, 4, "0");
              case "M":
                return ge + 1;
              case "MM":
                return X.s(ge + 1, 2, "0");
              case "MMM":
                return ve(U.monthsShort, ge, de, 3);
              case "MMMM":
                return ve(de, ge);
              case "D":
                return ae.$D;
              case "DD":
                return X.s(ae.$D, 2, "0");
              case "d":
                return String(ae.$W);
              case "dd":
                return ve(U.weekdaysMin, ae.$W, we, 2);
              case "ddd":
                return ve(U.weekdaysShort, ae.$W, we, 3);
              case "dddd":
                return we[ae.$W];
              case "H":
                return String(le);
              case "HH":
                return X.s(le, 2, "0");
              case "h":
                return me(1);
              case "hh":
                return me(2);
              case "a":
                return Oe(le, pe, !0);
              case "A":
                return Oe(le, pe, !1);
              case "m":
                return String(pe);
              case "mm":
                return X.s(pe, 2, "0");
              case "s":
                return String(ae.$s);
              case "ss":
                return X.s(ae.$s, 2, "0");
              case "SSS":
                return X.s(ae.$ms, 3, "0");
              case "Z":
                return W;
            }
            return null;
          }(be) || W.replace(":", "");
        });
      }, te.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, te.diff = function(Z, ae, U) {
        var G, W = this, le = X.p(ae), pe = K(Z), ge = (pe.utcOffset() - this.utcOffset()) * o, we = this - pe, de = function() {
          return X.m(W, pe);
        };
        switch (le) {
          case R:
            G = de() / 12;
            break;
          case x:
            G = de();
            break;
          case S:
            G = de() / 3;
            break;
          case b:
            G = (we - ge) / 6048e5;
            break;
          case m:
            G = (we - ge) / 864e5;
            break;
          case h:
            G = we / s;
            break;
          case p:
            G = we / o;
            break;
          case u:
            G = we / n;
            break;
          default:
            G = we;
        }
        return U ? G : X.a(G);
      }, te.daysInMonth = function() {
        return this.endOf(x).$D;
      }, te.$locale = function() {
        return V[this.$L];
      }, te.locale = function(Z, ae) {
        if (!Z) return this.$L;
        var U = this.clone(), G = ee(Z, ae, !0);
        return G && (U.$L = G), U;
      }, te.clone = function() {
        return X.w(this.$d, this);
      }, te.toDate = function() {
        return new Date(this.valueOf());
      }, te.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, te.toISOString = function() {
        return this.$d.toISOString();
      }, te.toString = function() {
        return this.$d.toUTCString();
      }, J;
    }(), Y = ne.prototype;
    return K.prototype = Y, [["$ms", l], ["$s", u], ["$m", p], ["$H", h], ["$W", m], ["$M", x], ["$y", R], ["$D", T]].forEach(function(J) {
      Y[J[1]] = function(te) {
        return this.$g(te, J[0], J[1]);
      };
    }), K.extend = function(J, te) {
      return J.$i || (J(te, ne, K), J.$i = !0), K;
    }, K.locale = ee, K.isDayjs = H, K.unix = function(J) {
      return K(1e3 * J);
    }, K.en = V[N], K.Ls = V, K.p = {}, K;
  });
})(eH);
var LIe = eH.exports;
const Wr = /* @__PURE__ */ qc(LIe), FIe = (e) => e instanceof Wr ? e : Wr(e), jIe = (e) => {
  const [t, n, o] = e.split(":");
  return Wr().hour(parseInt(t, 10)).minute(parseInt(n, 10)).second(parseInt(o, 10));
}, dN = (e) => {
  const t = !!e.error, n = t && typeof e.error == "string", o = e.errorId ?? (t && e.id ? `${e.id}-error-text` : void 0);
  return { hasErrorText: n, errorTextId: o };
}, Fl = (e, t, n) => n === void 0 ? e : {
  ...e,
  [t]: FIe(n)
}, dAe = ft((e, t) => {
  const { value: n, minDateTime: o, maxDateTime: s, ...l } = e;
  let u = Fl({}, "value", n);
  u = Fl(u, "minDateTime", o), u = Fl(u, "maxDateTime", s);
  const { hasErrorText: p, errorTextId: h } = dN(e), m = { ...l, ...u };
  return /* @__PURE__ */ qe(Po, { children: [
    /* @__PURE__ */ I(ZU, { ...m }),
    p && /* @__PURE__ */ I(ql, { className: "jv-mInput-error mui", id: h, children: e.error })
  ] });
}), fAe = ft((e, t) => {
  const { defaultValue: n, value: o, minDate: s, maxDate: l, ...u } = e;
  let p = Fl({}, "value", o);
  p = Fl(p, "defaultValue", n), p = Fl(p, "minDate", s), p = Fl(p, "maxDate", l);
  const { hasErrorText: h, errorTextId: m } = dN(e);
  return /* @__PURE__ */ qe(Po, { children: [
    /* @__PURE__ */ I(FU, { ...u, ...p }),
    h && /* @__PURE__ */ I(ql, { className: "jv-mInput-error mui", id: m, children: e.error })
  ] });
}), pAe = ft(
  (e, t) => {
    const n = {
      ...e.InputLabelProps,
      classes: { root: "jv-mInput-label mui" },
      disableAnimation: !0
    }, o = {
      ...e.InputProps,
      classes: { input: "jv-mInput-text mui" }
    };
    return /* @__PURE__ */ I(
      Uk,
      {
        ...e,
        className: `${e.className || ""}`,
        variant: "outlined",
        InputLabelProps: { ...n },
        InputProps: { ...o }
      }
    );
  }
);
var tH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    var n = "week", o = "year";
    return function(s, l, u) {
      var p = l.prototype;
      p.week = function(h) {
        if (h === void 0 && (h = null), h !== null) return this.add(7 * (h - this.week()), "day");
        var m = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var b = u(this).startOf(o).add(1, o).date(m), x = u(this).endOf(n);
          if (b.isBefore(x)) return 1;
        }
        var S = u(this).startOf(o).date(m).startOf(n).subtract(1, "millisecond"), R = this.diff(S, n, !0);
        return R < 0 ? u(this).startOf("week").week() : Math.ceil(R);
      }, p.weeks = function(h) {
        return h === void 0 && (h = null), this.week(h);
      };
    };
  });
})(tH);
var VIe = tH.exports;
const BIe = /* @__PURE__ */ qc(VIe);
var nH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d\d/, l = /\d\d?/, u = /\d*[^-_:/,()\s\d]+/, p = {}, h = function(E) {
      return (E = +E) + (E > 68 ? 1900 : 2e3);
    }, m = function(E) {
      return function(P) {
        this[E] = +P;
      };
    }, b = [/[+-]\d\d:?(\d\d)?|Z/, function(E) {
      (this.zone || (this.zone = {})).offset = function(P) {
        if (!P || P === "Z") return 0;
        var k = P.match(/([+-]|\d\d)/g), _ = 60 * k[1] + (+k[2] || 0);
        return _ === 0 ? 0 : k[0] === "+" ? -_ : _;
      }(E);
    }], x = function(E) {
      var P = p[E];
      return P && (P.indexOf ? P : P.s.concat(P.f));
    }, S = function(E, P) {
      var k, _ = p.meridiem;
      if (_) {
        for (var L = 1; L <= 24; L += 1) if (E.indexOf(_(L, 0, P)) > -1) {
          k = L > 12;
          break;
        }
      } else k = E === (P ? "pm" : "PM");
      return k;
    }, R = { A: [u, function(E) {
      this.afternoon = S(E, !1);
    }], a: [u, function(E) {
      this.afternoon = S(E, !0);
    }], S: [/\d/, function(E) {
      this.milliseconds = 100 * +E;
    }], SS: [s, function(E) {
      this.milliseconds = 10 * +E;
    }], SSS: [/\d{3}/, function(E) {
      this.milliseconds = +E;
    }], s: [l, m("seconds")], ss: [l, m("seconds")], m: [l, m("minutes")], mm: [l, m("minutes")], H: [l, m("hours")], h: [l, m("hours")], HH: [l, m("hours")], hh: [l, m("hours")], D: [l, m("day")], DD: [s, m("day")], Do: [u, function(E) {
      var P = p.ordinal, k = E.match(/\d+/);
      if (this.day = k[0], P) for (var _ = 1; _ <= 31; _ += 1) P(_).replace(/\[|\]/g, "") === E && (this.day = _);
    }], M: [l, m("month")], MM: [s, m("month")], MMM: [u, function(E) {
      var P = x("months"), k = (x("monthsShort") || P.map(function(_) {
        return _.slice(0, 3);
      })).indexOf(E) + 1;
      if (k < 1) throw new Error();
      this.month = k % 12 || k;
    }], MMMM: [u, function(E) {
      var P = x("months").indexOf(E) + 1;
      if (P < 1) throw new Error();
      this.month = P % 12 || P;
    }], Y: [/[+-]?\d+/, m("year")], YY: [s, function(E) {
      this.year = h(E);
    }], YYYY: [/\d{4}/, m("year")], Z: b, ZZ: b };
    function T(E) {
      var P, k;
      P = E, k = p && p.formats;
      for (var _ = (E = P.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(ee, K, X) {
        var ne = X && X.toUpperCase();
        return K || k[X] || n[X] || k[ne].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Y, J, te) {
          return J || te.slice(1);
        });
      })).match(o), L = _.length, F = 0; F < L; F += 1) {
        var N = _[F], V = R[N], z = V && V[0], H = V && V[1];
        _[F] = H ? { regex: z, parser: H } : N.replace(/^\[|\]$/g, "");
      }
      return function(ee) {
        for (var K = {}, X = 0, ne = 0; X < L; X += 1) {
          var Y = _[X];
          if (typeof Y == "string") ne += Y.length;
          else {
            var J = Y.regex, te = Y.parser, Z = ee.slice(ne), ae = J.exec(Z)[0];
            te.call(K, ae), ee = ee.replace(ae, "");
          }
        }
        return function(U) {
          var G = U.afternoon;
          if (G !== void 0) {
            var W = U.hours;
            G ? W < 12 && (U.hours += 12) : W === 12 && (U.hours = 0), delete U.afternoon;
          }
        }(K), K;
      };
    }
    return function(E, P, k) {
      k.p.customParseFormat = !0, E && E.parseTwoDigitYear && (h = E.parseTwoDigitYear);
      var _ = P.prototype, L = _.parse;
      _.parse = function(F) {
        var N = F.date, V = F.utc, z = F.args;
        this.$u = V;
        var H = z[1];
        if (typeof H == "string") {
          var ee = z[2] === !0, K = z[3] === !0, X = ee || K, ne = z[2];
          K && (ne = z[2]), p = this.$locale(), !ee && ne && (p = k.Ls[ne]), this.$d = function(Z, ae, U) {
            try {
              if (["x", "X"].indexOf(ae) > -1) return new Date((ae === "X" ? 1e3 : 1) * Z);
              var G = T(ae)(Z), W = G.year, le = G.month, pe = G.day, ge = G.hours, we = G.minutes, de = G.seconds, se = G.milliseconds, ve = G.zone, me = /* @__PURE__ */ new Date(), Oe = pe || (W || le ? 1 : me.getDate()), be = W || me.getFullYear(), De = 0;
              W && !le || (De = le > 0 ? le - 1 : me.getMonth());
              var ie = ge || 0, fe = we || 0, ye = de || 0, Ee = se || 0;
              return ve ? new Date(Date.UTC(be, De, Oe, ie, fe, ye, Ee + 60 * ve.offset * 1e3)) : U ? new Date(Date.UTC(be, De, Oe, ie, fe, ye, Ee)) : new Date(be, De, Oe, ie, fe, ye, Ee);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(N, H, V), this.init(), ne && ne !== !0 && (this.$L = this.locale(ne).$L), X && N != this.format(H) && (this.$d = /* @__PURE__ */ new Date("")), p = {};
        } else if (H instanceof Array) for (var Y = H.length, J = 1; J <= Y; J += 1) {
          z[1] = H[J - 1];
          var te = k.apply(this, z);
          if (te.isValid()) {
            this.$d = te.$d, this.$L = te.$L, this.init();
            break;
          }
          J === Y && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else L.call(this, F);
      };
    };
  });
})(nH);
var zIe = nH.exports;
const UIe = /* @__PURE__ */ qc(zIe);
var rH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(o, s, l) {
      var u = s.prototype, p = u.format;
      l.en.formats = n, u.format = function(h) {
        h === void 0 && (h = "YYYY-MM-DDTHH:mm:ssZ");
        var m = this.$locale().formats, b = function(x, S) {
          return x.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(R, T, E) {
            var P = E && E.toUpperCase();
            return T || S[E] || n[E] || S[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(k, _, L) {
              return _ || L.slice(1);
            });
          });
        }(h, m === void 0 ? {} : m);
        return p.call(this, b);
      };
    };
  });
})(rH);
var HIe = rH.exports;
const WIe = /* @__PURE__ */ qc(HIe);
var oH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    return function(n, o, s) {
      o.prototype.isBetween = function(l, u, p, h) {
        var m = s(l), b = s(u), x = (h = h || "()")[0] === "(", S = h[1] === ")";
        return (x ? this.isAfter(m, p) : !this.isBefore(m, p)) && (S ? this.isBefore(b, p) : !this.isAfter(b, p)) || (x ? this.isBefore(m, p) : !this.isAfter(m, p)) && (S ? this.isAfter(b, p) : !this.isBefore(b, p));
      };
    };
  });
})(oH);
var qIe = oH.exports;
const YIe = /* @__PURE__ */ qc(qIe);
var aH = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(Ll, function() {
    return function(n, o) {
      var s = o.prototype, l = s.format;
      s.format = function(u) {
        var p = this, h = this.$locale();
        if (!this.isValid()) return l.bind(this)(u);
        var m = this.$utils(), b = (u || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(x) {
          switch (x) {
            case "Q":
              return Math.ceil((p.$M + 1) / 3);
            case "Do":
              return h.ordinal(p.$D);
            case "gggg":
              return p.weekYear();
            case "GGGG":
              return p.isoWeekYear();
            case "wo":
              return h.ordinal(p.week(), "W");
            case "w":
            case "ww":
              return m.s(p.week(), x === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return m.s(p.isoWeek(), x === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return m.s(String(p.$H === 0 ? 24 : p.$H), x === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(p.$d.getTime() / 1e3);
            case "x":
              return p.$d.getTime();
            case "z":
              return "[" + p.offsetName() + "]";
            case "zzz":
              return "[" + p.offsetName("long") + "]";
            default:
              return x;
          }
        });
        return l.bind(this)(b);
      };
    };
  });
})(aH);
var GIe = aH.exports;
const KIe = /* @__PURE__ */ qc(GIe);
Wr.extend(WIe);
Wr.extend(BIe);
Wr.extend(YIe);
Wr.extend(KIe);
const XIe = PU(["Your locale has not been found.", "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale", "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", "fallback on English locale"]), QIe = {
  // Year
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, JIe = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  dayOfMonthFull: "Do",
  weekday: "dddd",
  weekdayShort: "dd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, O$ = ["Missing UTC plugin", "To be able to use UTC or timezones, you have to enable the `utc` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"].join(`
`), BV = ["Missing timezone plugin", "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"].join(`
`), ZIe = (e, t) => t ? (...n) => e(...n).locale(t) : e;
class e_e {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "dayjs", this.dayjs = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = QIe, this.setLocaleToValue = (o) => {
      const s = this.getCurrentLocaleCode();
      return s === o.locale() ? o : o.locale(s);
    }, this.hasUTCPlugin = () => typeof Wr.utc < "u", this.hasTimezonePlugin = () => typeof Wr.tz < "u", this.isSame = (o, s, l) => {
      const u = this.setTimezone(s, this.getTimezone(o));
      return o.format(l) === u.format(l);
    }, this.cleanTimezone = (o) => {
      switch (o) {
        case "default":
          return;
        case "system":
          return Wr.tz.guess();
        default:
          return o;
      }
    }, this.createSystemDate = (o) => {
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const s = Wr.tz.guess();
        return s !== "UTC" ? Wr.tz(o, s) : Wr(o);
      }
      return Wr(o);
    }, this.createUTCDate = (o) => {
      if (!this.hasUTCPlugin())
        throw new Error(O$);
      return Wr.utc(o);
    }, this.createTZDate = (o, s) => {
      if (!this.hasUTCPlugin())
        throw new Error(O$);
      if (!this.hasTimezonePlugin())
        throw new Error(BV);
      const l = o !== void 0 && !o.endsWith("Z");
      return Wr(o).tz(this.cleanTimezone(s), l);
    }, this.getLocaleFormats = () => {
      const o = Wr.Ls, s = this.locale || "en";
      let l = o[s];
      return l === void 0 && (XIe(), l = o.en), l.formats;
    }, this.adjustOffset = (o) => {
      if (!this.hasTimezonePlugin())
        return o;
      const s = this.getTimezone(o);
      if (s !== "UTC") {
        const l = o.tz(this.cleanTimezone(s), !0);
        if ((l.$offset ?? 0) === (o.$offset ?? 0))
          return o;
        o.$offset = l.$offset;
      }
      return o;
    }, this.date = (o, s = "default") => {
      if (o === null)
        return null;
      let l;
      return s === "UTC" ? l = this.createUTCDate(o) : s === "system" || s === "default" && !this.hasTimezonePlugin() ? l = this.createSystemDate(o) : l = this.createTZDate(o, s), this.locale === void 0 ? l : l.locale(this.locale);
    }, this.getInvalidDate = () => Wr(/* @__PURE__ */ new Date("Invalid date")), this.getTimezone = (o) => {
      var s;
      if (this.hasTimezonePlugin()) {
        const l = (s = o.$x) == null ? void 0 : s.$timezone;
        if (l)
          return l;
      }
      return this.hasUTCPlugin() && o.isUTC() ? "UTC" : "system";
    }, this.setTimezone = (o, s) => {
      if (this.getTimezone(o) === s)
        return o;
      if (s === "UTC") {
        if (!this.hasUTCPlugin())
          throw new Error(O$);
        return o.utc();
      }
      if (s === "system")
        return o.local();
      if (!this.hasTimezonePlugin()) {
        if (s === "default")
          return o;
        throw new Error(BV);
      }
      return Wr.tz(o, this.cleanTimezone(s));
    }, this.toJsDate = (o) => o.toDate(), this.parse = (o, s) => o === "" ? null : this.dayjs(o, s, this.locale, !0), this.getCurrentLocaleCode = () => this.locale || "en", this.is12HourCycleInCurrentLocale = () => /A|a/.test(this.getLocaleFormats().LT || ""), this.expandFormat = (o) => {
      const s = this.getLocaleFormats(), l = (u) => u.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (p, h, m) => h || m.slice(1));
      return o.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (u, p, h) => {
        const m = h && h.toUpperCase();
        return p || s[h] || l(s[m]);
      });
    }, this.isValid = (o) => o == null ? !1 : o.isValid(), this.format = (o, s) => this.formatByString(o, this.formats[s]), this.formatByString = (o, s) => this.dayjs(o).format(s), this.formatNumber = (o) => o, this.isEqual = (o, s) => o === null && s === null ? !0 : o === null || s === null ? !1 : o.toDate().getTime() === s.toDate().getTime(), this.isSameYear = (o, s) => this.isSame(o, s, "YYYY"), this.isSameMonth = (o, s) => this.isSame(o, s, "YYYY-MM"), this.isSameDay = (o, s) => this.isSame(o, s, "YYYY-MM-DD"), this.isSameHour = (o, s) => o.isSame(s, "hour"), this.isAfter = (o, s) => o > s, this.isAfterYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() > s.utc() : o.isAfter(s, "year"), this.isAfterDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() > s.utc() : o.isAfter(s, "day"), this.isBefore = (o, s) => o < s, this.isBeforeYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() < s.utc() : o.isBefore(s, "year"), this.isBeforeDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() < s.utc() : o.isBefore(s, "day"), this.isWithinRange = (o, [s, l]) => o >= s && o <= l, this.startOfYear = (o) => this.adjustOffset(o.startOf("year")), this.startOfMonth = (o) => this.adjustOffset(o.startOf("month")), this.startOfWeek = (o) => this.adjustOffset(o.startOf("week")), this.startOfDay = (o) => this.adjustOffset(o.startOf("day")), this.endOfYear = (o) => this.adjustOffset(o.endOf("year")), this.endOfMonth = (o) => this.adjustOffset(o.endOf("month")), this.endOfWeek = (o) => this.adjustOffset(o.endOf("week")), this.endOfDay = (o) => this.adjustOffset(o.endOf("day")), this.addYears = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "year") : o.add(s, "year")), this.addMonths = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "month") : o.add(s, "month")), this.addWeeks = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "week") : o.add(s, "week")), this.addDays = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "day") : o.add(s, "day")), this.addHours = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "hour") : o.add(s, "hour")), this.addMinutes = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "minute") : o.add(s, "minute")), this.addSeconds = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "second") : o.add(s, "second")), this.getYear = (o) => o.year(), this.getMonth = (o) => o.month(), this.getDate = (o) => o.date(), this.getHours = (o) => o.hour(), this.getMinutes = (o) => o.minute(), this.getSeconds = (o) => o.second(), this.getMilliseconds = (o) => o.millisecond(), this.setYear = (o, s) => this.adjustOffset(o.set("year", s)), this.setMonth = (o, s) => this.adjustOffset(o.set("month", s)), this.setDate = (o, s) => this.adjustOffset(o.set("date", s)), this.setHours = (o, s) => this.adjustOffset(o.set("hour", s)), this.setMinutes = (o, s) => this.adjustOffset(o.set("minute", s)), this.setSeconds = (o, s) => this.adjustOffset(o.set("second", s)), this.setMilliseconds = (o, s) => this.adjustOffset(o.set("millisecond", s)), this.getDaysInMonth = (o) => o.daysInMonth(), this.getWeekArray = (o) => {
      const s = this.setLocaleToValue(o), l = this.startOfWeek(this.startOfMonth(s)), u = this.endOfWeek(this.endOfMonth(s));
      let p = 0, h = l;
      const m = [];
      for (; h < u; ) {
        const b = Math.floor(p / 7);
        m[b] = m[b] || [], m[b].push(h), h = this.addDays(h, 1), p += 1;
      }
      return m;
    }, this.getWeekNumber = (o) => o.week(), this.getYearRange = ([o, s]) => {
      const l = this.startOfYear(o), u = this.endOfYear(s), p = [];
      let h = l;
      for (; this.isBefore(h, u); )
        p.push(h), h = this.addYears(h, 1);
      return p;
    }, this.dayjs = ZIe(Wr, t), this.locale = t, this.formats = O({}, JIe, n), Wr.extend(UIe);
  }
  getDayOfWeek(t) {
    return t.day() + 1;
  }
}
const hAe = ({
  children: e
}) => /* @__PURE__ */ I(LT, { dateAdapter: e_e, children: e }), mAe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(
    x0,
    {
      ref: n,
      component: "div",
      classes: { root: `jv-mInputs-divider mui ${e}` },
      ...t
    }
  )
), vAe = ft(
  ({ classes: e = {}, elevation: t = 6, open: n = !1, className: o = "", ...s }, l) => {
    const { paper: u = "", ...p } = e;
    return /* @__PURE__ */ I(
      sT,
      {
        ref: l,
        className: `jv-mDrawer ${o} mui`,
        open: n,
        elevation: t,
        classes: { paper: `${u}`, ...p },
        ...s
      }
    );
  }
), fN = (e) => ({
  "materialUi.component.collapsiblePanel.close": "Close panel"
})[e] || e, t_e = ({
  subPanelsState: e,
  panelIndex: t,
  subPanels: n,
  setSubPanelState: o,
  onExpandClick: s
}) => {
  const l = fN(
    "materialUi.component.collapsiblePanel.open"
  ), u = (p, h) => {
    const m = s({ type: "subpanel", id: h });
    (typeof m > "u" || m) && o(t, p, !0);
  };
  return /* @__PURE__ */ I(Po, { children: n.map((p, h) => {
    const m = e[h];
    return !m.open && /* @__PURE__ */ I(
      "div",
      {
        "data-name": `${m.id}-tab-expand`,
        onClick: () => u(h, m.id),
        "aria-label": l,
        role: "button",
        tabIndex: 0,
        children: /* @__PURE__ */ I(nr, { className: "jv-mText jv-mPanel-header-title mui", children: p.label })
      },
      p.id
    );
  }) });
}, n_e = ft(
  ({
    anchor: e,
    setPanelState: t,
    setSubPanelState: n,
    panels: o,
    panelsState: s,
    onExpandClick: l
  }, u) => {
    const { panelsDirectionClass: p, panelDirectionClass: h } = vT[e], m = e === "left" ? "caretRightLarge" : "caretLeftLarge", b = fN(
      "materialUi.component.collapsiblePanel.close"
    ), x = (S, R) => {
      const T = l({ type: "panel", id: R });
      (typeof T > "u" || T) && t(S, !0);
    };
    return /* @__PURE__ */ I(
      "div",
      {
        className: `jv-mPanels ${p} jv-mPanelsMinimized jv-mPanelsStacked mui`,
        ref: u,
        children: o.map((S, R) => {
          const T = !wk(R, s), E = s[R], { id: P } = E;
          return T && /* @__PURE__ */ I(
            "div",
            {
              className: `jv-mPanel ${h} jv-mPanelMinimized mui`,
              "data-name": `${P}-tabs`,
              children: /* @__PURE__ */ qe("div", { className: "jv-mPanel-header mui", children: [
                /* @__PURE__ */ I("div", { className: "jv-mPanel-header-action mui", children: /* @__PURE__ */ I(
                  $0,
                  {
                    onClick: () => x(R, P),
                    "aria-label": b,
                    className: "jv-mPanel-action-button jv-mButton jv-mButtonSmall mui",
                    size: "large",
                    icon: m
                  }
                ) }),
                /* @__PURE__ */ I(
                  t_e,
                  {
                    panelIndex: R,
                    subPanels: S.subPanels,
                    subPanelsState: E.subPanels,
                    setSubPanelState: n,
                    onExpandClick: l
                  }
                )
              ] })
            },
            P
          );
        })
      }
    );
  }
), r_e = ({
  onCollapse: e,
  anchor: t,
  className: n = "",
  id: o,
  label: s,
  content: l
}) => {
  const u = fN(
    "materialUi.component.collapsiblePanel.close"
  ), p = t === "right" ? "caretRightLarge" : "caretLeftLarge";
  return /* @__PURE__ */ qe(
    sT,
    {
      variant: "persistent",
      anchor: t,
      open: !0,
      style: { width: "100%", height: "100%" },
      className: `jv-mPanel jv-mPanelFlush mui ${n}`,
      "data-name": o,
      children: [
        /* @__PURE__ */ qe("div", { className: "jv-mPanel-header mui", children: [
          t === "right" && /* @__PURE__ */ I("p", { className: "jv-MuiTypography-root jv-mText jv-mPanel-header-title mui jv-MuiTypography-body1", children: s }),
          /* @__PURE__ */ I("div", { className: "jv-mPanel-header-action mui", children: /* @__PURE__ */ I(
            $0,
            {
              icon: p,
              onClick: e,
              "aria-label": u,
              className: "jv-mPanel-action-button jv-mButtonSmall",
              size: "large"
            }
          ) }),
          t === "left" && /* @__PURE__ */ I("p", { className: "jv-MuiTypography-root jv-mText jv-mPanel-header-title mui jv-MuiTypography-body1", children: s })
        ] }),
        /* @__PURE__ */ I("div", { className: "jv-mPanel-body mui", children: l })
      ]
    }
  );
}, o_e = {
  left: { right: !0 },
  right: { left: !0 }
}, a_e = {
  right: { left: "jv-mPanel-resizerHorizontal mui" },
  left: { right: "" }
}, i_e = ({
  children: e,
  anchor: t,
  panelState: n,
  onResize: o,
  onResizeStart: s,
  setPanelState: l,
  panelIndex: u,
  maxWidth: p
}) => /* @__PURE__ */ I(
  Rk,
  {
    enable: o_e[t],
    handleClasses: a_e[t],
    size: {
      width: n.width,
      height: "100%"
    },
    minWidth: n.minWidth,
    maxWidth: p,
    style: { marginRight: `${Ck}px` },
    onResize: (h, m, b, x) => o({
      type: "panel",
      id: n.id,
      delta: x.width
    }),
    onResizeStart: () => s({
      type: "panel",
      id: n.id
    }),
    onResizeStop: (h, m, b, x) => {
      l(u, void 0, n.width + x.width);
    },
    children: e
  }
), s_e = ({
  panels: e,
  panelsState: t,
  setPanelState: n,
  maxWidth: o,
  anchor: s,
  onResizeStart: l,
  onResize: u,
  onCollapseClick: p,
  tabsPanelWidth: h
}) => {
  const { panelsDirectionClass: m, panelDirectionClass: b } = vT[s], x = (R, T) => {
    const E = p({ type: "panel", id: T });
    (typeof E > "u" || E) && n(R, !1);
  }, S = u4(o, h, t);
  return /* @__PURE__ */ I("div", { className: `jv-mPanels  ${m} mui`, children: e.map((R, T) => {
    const E = P0(T, t), P = t[T];
    return E && /* @__PURE__ */ I(
      i_e,
      {
        onResize: u,
        onResizeStart: l,
        panelIndex: T,
        panelState: P,
        anchor: s,
        setPanelState: n,
        maxWidth: S[T].maxWidth,
        children: /* @__PURE__ */ I(
          r_e,
          {
            className: `${b}`,
            anchor: s,
            id: P.id,
            onCollapse: () => x(T, P.id),
            label: R.subPanels[0].label,
            content: R.subPanels[0].content
          }
        )
      },
      P.id
    );
  }) });
}, Vf = () => {
}, l_e = () => window.innerWidth, gAe = ft(
  ({
    anchor: e = "right",
    panels: t = [],
    maxWidth: n = l_e,
    onScroll: o = Vf,
    onResize: s = Vf,
    onResizeStart: l = Vf,
    onResizeStop: u = Vf,
    onExpansionStateChanged: p = Vf,
    onExpandClick: h = Vf,
    onCollapseClick: m = Vf,
    wrapperProps: b
  }, x) => {
    const [S, R, T] = d5(t);
    d4(u, S), f4(p, S), p4(u, S);
    const E = l0(null), P = h4(E, S), k = /* @__PURE__ */ I(
      s_e,
      {
        anchor: e,
        panels: t,
        panelsState: S,
        maxWidth: n,
        setPanelState: R,
        setSubPanelState: T,
        onResizeStart: l,
        onResize: s,
        onScroll: o,
        onCollapseClick: m,
        tabsPanelWidth: P
      }
    );
    return /* @__PURE__ */ qe("div", { ref: x, ...b, children: [
      e === "right" && k,
      /* @__PURE__ */ I(
        n_e,
        {
          ref: E,
          panels: t,
          anchor: e,
          setPanelState: R,
          setSubPanelState: T,
          panelsState: S,
          onExpandClick: h
        }
      ),
      e === "left" && k
    ] });
  }
), yAe = ft(
  ({ children: e, ...t }, n) => /* @__PURE__ */ I(Db, { ref: n, ...t, children: e })
), c_e = {
  small: "jv-mIconSmall",
  medium: "",
  large: "jv-mIconLarge"
}, u_e = ft(
  ({ className: e = "", icon: t, size: n = "medium", ...o }, s) => {
    const l = `jv-${t}`;
    return /* @__PURE__ */ I(
      lk,
      {
        ref: s,
        className: `jv-mIcon mui ${l} ${e} ${c_e[n]}`,
        ...o
      }
    );
  }
), bAe = ft(({ className: e = "", ...t }, n) => /* @__PURE__ */ I(pT, { ref: n, className: `${e} mui`, ...t })), d_e = (e) => {
  switch (e) {
    case "body1":
      return ["body1", "jv-mText mui"];
    case "body2":
      return ["body2", "jv-mText jv-mTextSmall mui"];
    case "body3":
      return [void 0, "jv-mText jv-mTextLarge mui"];
    case "body4":
      return [void 0, "jv-mText jv-mTextXLarge mui"];
    default:
      return [e, "mui"];
  }
}, zV = ft(
  ({ variant: e, className: t = "", ...n }, o) => {
    const [s, l] = d_e(e);
    return /* @__PURE__ */ I(
      nr,
      {
        ref: o,
        className: `${l} ${t}`,
        variant: s,
        ...n
      }
    );
  }
);
var iH = /* @__PURE__ */ ((e) => (e.large = "jv-mInstructorLarge", e.small = "jv-mInstructorSmall", e.medium = "", e))(iH || {});
const xAe = ({
  messageTitle: e,
  icon: t = "message",
  size: n = "medium",
  messageDescription: o,
  wrapperProps: s = {}
}) => {
  const { className: l = "", ...u } = s;
  return /* @__PURE__ */ I(
    "div",
    {
      className: `jv-mInstructor ${l} ${iH[n]} ${e ? "" : "jv-mInstructorSimple"} mui`,
      ...u,
      children: /* @__PURE__ */ qe("div", { className: "jv-mInstructor-wrapper mui", children: [
        /* @__PURE__ */ I(u_e, { className: "jv-mInstructor-icon", icon: t }),
        e && /* @__PURE__ */ I(zV, { className: "jv-mInstructor-title mui", children: e }),
        /* @__PURE__ */ I(zV, { className: "jv-mInstructor-text mui", children: o })
      ] })
    }
  );
};
var sH = /* @__PURE__ */ ((e) => (e.theme = "jv-mLinkTheme", e.default = "", e))(sH || {});
const SAe = ft(
  ({ className: e = "", color: t = "default", ...n }, o) => {
    const s = sH[t];
    return /* @__PURE__ */ I(
      Rz,
      {
        ref: o,
        className: `jv-mLink mui ${s} ${e}`,
        ...n
      }
    );
  }
), CAe = ft(
  ({ className: e, component: t = "ul", isBulleted: n = !1, ...o }, s) => /* @__PURE__ */ I(
    Tv,
    {
      ref: s,
      component: t,
      className: `${e} ${n ? "jv-mListBulleted" : ""}  mui`,
      ...o
    }
  )
), wAe = ft(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(C0, { ref: n, className: `${e}  mui`, ...t }) })
), TAe = ft(({ className: e, ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(Oz, { ref: n, className: `${e}  mui`, ...t }) })), EAe = ft(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I(dk, { ref: n, className: `${e}  mui`, ...t })
), f_e = ft(
  ({ className: e = "", children: t, ...n }, o) => /* @__PURE__ */ I(
    Ev,
    {
      ref: o,
      className: `jv-mInput-select-item mui ${e}`,
      ...n,
      children: t
    }
  )
), RAe = ft((e, t) => {
  const { value: n, selected: o, id: s, label: l, ...u } = e, p = (m) => /* @__PURE__ */ I(
    f_e,
    {
      id: m.value,
      value: m.value,
      selected: m.selected,
      children: m.label
    },
    m.value
  );
  return /* @__PURE__ */ I(
    Uk,
    {
      ...u,
      value: n,
      id: s,
      label: l,
      select: !0,
      variant: "outlined",
      InputLabelProps: {
        classes: { root: "jv-mInput-label mui" },
        disableAnimation: !0
      },
      SelectProps: {
        classes: { root: "jv-mInput-select mui" },
        "aria-describedby": "select-inline-helper-error-helper-text select-inline-helper-error-error-text"
      },
      FormHelperTextProps: {
        classes: { root: "jv-mInput-helper mui" }
      },
      children: (() => {
        var m, b;
        return ((b = (m = e.state) == null ? void 0 : m.options) == null ? void 0 : b.map((x) => p(x))) || [];
      })()
    }
  );
}), OAe = ft((e, t) => {
  const { value: n, selected: o, id: s, label: l, className: u, error: p, state: h, ...m } = e, b = 48, x = 8, S = (p == null ? void 0 : p.trim().length) > 0, R = (E) => /* @__PURE__ */ qe(
    Ev,
    {
      id: E.value,
      value: E.value,
      className: "jv-mChecklist-item mui",
      children: [
        /* @__PURE__ */ I(
          b0,
          {
            checked: n.indexOf(E.value) > -1 || n.indexOf(E.label) > -1,
            className: "jv-mInput-checkbox-check mui"
          }
        ),
        /* @__PURE__ */ I(
          dk,
          {
            className: "jv-mInput-checkbox-label mui",
            primary: E.label
          }
        )
      ]
    },
    E.value
  ), T = () => {
    var E;
    return ((E = h == null ? void 0 : h.options) == null ? void 0 : E.map((P) => R(P))) || [];
  };
  return /* @__PURE__ */ qe(
    Cv,
    {
      className: "jv-mInput jv-mInputLarge jv-mInputSelect mui",
      error: S,
      children: [
        /* @__PURE__ */ I(
          S0,
          {
            id: s + "_label",
            className: "jv-mInput-label mui",
            error: S,
            children: l
          }
        ),
        /* @__PURE__ */ I(
          T0,
          {
            ...m,
            value: n,
            error: S,
            renderValue: (E) => E.join(", "),
            id: s,
            labelId: s + "_label",
            className: u + " jv-mInput-select mui",
            multiple: !0,
            variant: "outlined",
            input: /* @__PURE__ */ I(w0, { label: "Tag" }),
            MenuProps: {
              classes: {
                list: "jv-mChecklist jv-mChecklistLarge mui"
              },
              slotProps: {
                elevation: 4,
                style: {
                  maxHeight: b * 4.5 + x,
                  width: 250
                }
              }
            },
            children: T()
          }
        ),
        S && /* @__PURE__ */ I(ql, { className: "jv-mInput-error mui", children: p })
      ]
    }
  );
});
var lH = /* @__PURE__ */ ((e) => (e.error = "jv-mMessageError", e.warning = "jv-mMessageWarning", e))(lH || {});
const PAe = ft(
  ({
    elevation: e = 0,
    type: t = "error",
    cardHeaderProps: n = {},
    isCardHeader: o = !0,
    cardContentProps: s = {},
    className: l = "",
    children: u,
    ...p
  }, h) => {
    const {
      className: m = "",
      isHeaderPadded: b = !0,
      classes: x = {},
      ...S
    } = n, {
      avatar: R = "",
      content: T = "",
      action: E = "",
      ...P
    } = x, k = b ? "jv-mMessage-headerPadded" : "", {
      className: _ = "",
      isPadded: L = !0,
      ...F
    } = s, N = L ? "jv-mMessage-bodyPadded" : "";
    return /* @__PURE__ */ qe(
      eT,
      {
        ref: h,
        className: `jv-mMessage ${lH[t]} ${l} mui`,
        elevation: e,
        ...p,
        children: [
          o && /* @__PURE__ */ I(
            ok,
            {
              className: `jv-mMessage-header ${m} ${k} mui`,
              classes: {
                avatar: `jv-mMessage-header-icon ${R} mui`,
                content: `jv-mMessage-header-title ${T} mui`,
                action: `jv-mMessage-header-action ${E}  mui`,
                ...P
              },
              ...S
            }
          ),
          /* @__PURE__ */ I(
            rk,
            {
              className: `jv-mMessage-body ${N} ${_} mui`,
              ...F,
              children: u
            }
          )
        ]
      }
    );
  }
), $Ae = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(ms, { ref: t, ...e })
), DAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(fk, { ref: t, ...e })
), kAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(ip, { ref: t, ...e })
), MAe = ft(
  ({ variant: e = "indeterminate", ...t }, n) => /* @__PURE__ */ I(gz, { ref: n, variant: e, ...t })
), NAe = ft(
  ({ variant: e = "determinate", className: t = "", classes: n = {}, ...o }, s) => {
    const { bar: l = "", ...u } = n;
    return /* @__PURE__ */ I(
      Tz,
      {
        ref: s,
        variant: e,
        className: `jv-mProgressbar jv-mProgressbarStatic mui ${t}`,
        classes: {
          bar: `jv-mProgressbar-fill mui ${l} `,
          ...u
        },
        ...o
      }
    );
  }
), IAe = ft(
  ({ className: e = "", classes: t = {}, control: n, RadioProps: o = {}, ...s }, l) => {
    const { classes: u = {}, ...p } = o;
    return /* @__PURE__ */ I(
      cT,
      {
        ref: l,
        control: n ?? /* @__PURE__ */ I(
          _z,
          {
            color: "primary",
            classes: {
              root: `jv-mInput-radio-button mui ${u.root ?? ""}`
            },
            ...p
          }
        ),
        className: `jv-mInput-radio ${e} mui`,
        classes: {
          label: `jv-mInput-radio-label mui ${(t == null ? void 0 : t.root) ?? ""}`,
          ...t
        },
        ...s
      }
    );
  }
), _Ae = ft(
  ({
    helperText: e,
    children: t,
    size: n = "medium",
    title: o = "",
    FormLabelProps: s = {},
    RadioGroupProps: l = {},
    FormControlProps: u = {}
  }, p) => {
    const {
      component: h = "fieldset",
      className: m = "",
      ...b
    } = u, {
      className: x = "",
      component: S = "legend",
      ...R
    } = s;
    return /* @__PURE__ */ qe(
      Cv,
      {
        ref: p,
        component: h,
        className: `jv-mInput ${Rv[n]} ${m} jv-mInputRadio mui`,
        ...b,
        children: [
          o && /* @__PURE__ */ I(
            uT,
            {
              component: S,
              className: `jv-mInput-label ${x} mui`,
              ...R,
              children: o
            }
          ),
          /* @__PURE__ */ I(Az, { ...l, children: t }),
          e && /* @__PURE__ */ I(c5, { text: e })
        ]
      }
    );
  }
), AAe = ft((e, t) => {
  const { children: n, ...o } = e;
  return n ? /* @__PURE__ */ I(Y$, { ...o, children: n }) : /* @__PURE__ */ I(Y$, { ...o });
}), LAe = ft((e, t) => {
  const { children: n, ...o } = e;
  return n ? /* @__PURE__ */ I(X1, { ...o, children: n }) : /* @__PURE__ */ I(X1, { ...e });
}), FAe = ft(({ StepLabelProps: e = {}, TypographyProps: t = {}, children: n, ...o }, s) => {
  const {
    className: l,
    title: u,
    dataName: p,
    ...h
  } = t, { className: m = "", ...b } = o;
  return /* @__PURE__ */ I(
    jz,
    {
      ref: s,
      className: `jv-mStepper-step ${m} mui`,
      ...b,
      children: /* @__PURE__ */ qe(gk, { ...e, children: [
        /* @__PURE__ */ I(
          nr,
          {
            "data-name": p,
            className: `jv-mText jv-mTextTitle jv-mTextSmall ${l} mui`,
            ...h,
            children: u
          }
        ),
        n
      ] })
    }
  );
}), jAe = ft(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ I(zz, { ref: o, className: `jv-mStepper ${e} mui`, ...n, children: t })), VAe = ft(
  ({
    classes: e = {},
    noLabel: t = !1,
    inline: n = !0,
    size: o = "medium",
    control: s,
    SwitchProps: l = {},
    WrapperProps: u,
    labelPlacement: p = "start",
    containerClassName: h = "",
    ...m
  }, b) => {
    const { className: x = "", ...S } = l;
    return /* @__PURE__ */ I(
      "div",
      {
        ref: b,
        className: `jv-mInput jv-mInputSwitch ${n ? s5 : ""} ${t ? Bse : ""} ${Rv[o]} ${h} mui`,
        ...u,
        children: /* @__PURE__ */ I(
          cT,
          {
            classes: {
              label: `jv-mInput-label mui ${(e == null ? void 0 : e.root) ?? ""}`,
              ...e
            },
            control: s ?? /* @__PURE__ */ I(
              Uz,
              {
                size: o,
                color: "primary",
                className: `jv-mInput-switch mui ${x}`,
                ...S
              }
            ),
            labelPlacement: p,
            ...m
          }
        )
      }
    );
  }
), BAe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Hz, { ref: n, className: `jv-mTable ${e} mui`, ...t })
), zAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(Wz, { ref: t, ...e })
), UAe = ft(
  ({
    className: e = "",
    isActionCell: t = !1,
    isCellAttribute: n = !1,
    isCellValue: o = !1,
    ...s
  }, l) => /* @__PURE__ */ I(
    Kb,
    {
      ref: l,
      className: `jv-mTable-cell ${t ? "jv-mTable-cellAction" : ""} ${n ? "jv-mTable-cellAttribute" : ""} ${o ? "jv-mTable-cellValue" : ""} ${e} mui`,
      ...s
    }
  )
), HAe = ft(({ ...e }, t) => /* @__PURE__ */ I(qz, { ref: t, ...e })), WAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(Yz, { ref: t, ...e })
), qAe = ft(
  ({ ...e }, t) => {
    const {
      backIconButtonProps: n = {},
      nextIconButtonProps: o = {},
      ...s
    } = e, { className: l = "", ...u } = n, { className: p = "", ...h } = o;
    return /* @__PURE__ */ I(
      Qz,
      {
        ref: t,
        backIconButtonProps: {
          className: `jv-mButton ${l} mui`,
          ...u
        },
        nextIconButtonProps: {
          className: `jv-mButton ${p} mui`,
          ...h
        },
        ...s
      }
    );
  }
), YAe = ft(
  ({ className: e = "", border: t = !0, headRow: n = !1, ...o }, s) => /* @__PURE__ */ I(
    Jz,
    {
      ref: s,
      className: `jv-mTable-row ${t ? "" : "jv-mTable-rowNoborder"} ${n ? "jv-mTable-rowHeader" : ""} ${e} mui`,
      ...o
    }
  )
), GAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(Zz, { ref: t, ...e })
), KAe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Z1, { ref: n, className: `jv-mTab ${e} mui`, ...t })
);
var cH = /* @__PURE__ */ ((e) => (e.small = "jv-mTabsSmall", e.medium = "jv-mTabsMedium", e.large = "jv-mTabsLarge", e))(cH || {});
const XAe = ft(
  ({
    className: e = "",
    size: t = "medium",
    indicatorColor: n = "primary",
    children: o,
    ...s
  }, l) => /* @__PURE__ */ I(
    xk,
    {
      ref: l,
      className: `jv-mTabs ${e} ${cH[t]} mui`,
      indicatorColor: n,
      ...s,
      children: o
    }
  )
), QAe = ft((e, t) => {
  const { value: n, minTime: o, maxTime: s, ...l } = e;
  let u = Fl({}, "value", jIe(n));
  u = Fl(u, "minTime", o), u = Fl(u, "maxTime", s);
  const { hasErrorText: p, errorTextId: h } = dN(e);
  return /* @__PURE__ */ qe(Po, { children: [
    /* @__PURE__ */ I(qU, { ...l, ...u }),
    p && /* @__PURE__ */ I(ql, { className: "jv-mInput-error mui", id: h, children: e.error })
  ] });
}), JAe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(
    bk,
    {
      className: `jv-mToolbar ${e} mui`,
      ref: n,
      ...t
    }
  )
), ZAe = ft(
  ({ ...e }, t) => /* @__PURE__ */ I(Fz, { ref: t, ...e })
);
function p_e(e) {
  return typeof e == "string";
}
function h_e(e, t, n) {
  return e === void 0 || p_e(e) ? t : O({}, t, {
    ownerState: O({}, t.ownerState, n)
  });
}
function _c(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function Ac(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function UV(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function m_e(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: s,
    className: l
  } = e;
  if (!t) {
    const R = Ne(n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), T = O({}, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), E = O({}, n, s, o);
    return R.length > 0 && (E.className = R), Object.keys(T).length > 0 && (E.style = T), {
      props: E,
      internalRef: void 0
    };
  }
  const u = _c(O({}, s, o)), p = UV(o), h = UV(s), m = t(u), b = Ne(m == null ? void 0 : m.className, n == null ? void 0 : n.className, l, s == null ? void 0 : s.className, o == null ? void 0 : o.className), x = O({}, m == null ? void 0 : m.style, n == null ? void 0 : n.style, s == null ? void 0 : s.style, o == null ? void 0 : o.style), S = O({}, m, n, h, p);
  return b.length > 0 && (S.className = b), Object.keys(x).length > 0 && (S.style = x), {
    props: S,
    internalRef: m.ref
  };
}
const v_e = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Ni(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: o,
    ownerState: s,
    skipResolvingSlotProps: l = !1
  } = e, u = Te(e, v_e), p = l ? {} : Ac(o, s), {
    props: h,
    internalRef: m
  } = m_e(O({}, u, {
    externalSlotProps: p
  })), b = ro(m, p == null ? void 0 : p.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return h_e(n, O({}, h, {
    ref: b
  }), s);
}
function g_e(e) {
  return xn("MuiRichTreeView", e);
}
Cn("MuiRichTreeView", ["root"]);
const y_e = (e, t) => {
  const n = D.useRef({}), [o, s] = D.useState(() => {
    const u = {};
    return e.forEach((p) => {
      p.models && Object.entries(p.models).forEach(([h, m]) => {
        n.current[h] = {
          isControlled: t[h] !== void 0,
          getDefaultValue: m.getDefaultValue
        }, u[h] = m.getDefaultValue(t);
      });
    }), u;
  }), l = Object.fromEntries(Object.entries(n.current).map(([u, p]) => {
    const h = t[u] ?? o[u];
    return [u, {
      value: h,
      setControlledValue: (m) => {
        p.isControlled || s((b) => O({}, b, {
          [u]: m
        }));
      }
    }];
  }));
  return process.env.NODE_ENV !== "production" && Object.entries(n.current).forEach(([u, p]) => {
    const h = t[u], m = p.getDefaultValue(t);
    D.useEffect(() => {
      p.isControlled !== (h !== void 0) && console.error([`MUI X: A component is changing the ${p.isControlled ? "" : "un"}controlled ${u} state of TreeView to be ${p.isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${u} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [h]);
    const {
      current: b
    } = D.useRef(m);
    D.useEffect(() => {
      !p.isControlled && b !== m && console.error([`MUI X: A component is changing the default ${u} state of an uncontrolled TreeView after being initialized. To suppress this warning opt to use a controlled TreeView.`].join(`
`));
    }, [JSON.stringify(m)]);
  }), l;
};
class b_e {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, o = {}) {
    let s = this.events[t];
    if (s || (s = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = s), o.isFirst ? s.highPriority.set(n, !0) : s.regular.set(n, !0), process.env.NODE_ENV !== "production") {
      const l = s.highPriority.size + s.regular.size;
      l > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${l} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const o = this.events[t];
    if (!o)
      return;
    const s = Array.from(o.highPriority.keys()), l = Array.from(o.regular.keys());
    for (let u = s.length - 1; u >= 0; u -= 1) {
      const p = s[u];
      o.highPriority.has(p) && p.apply(this, n);
    }
    for (let u = 0; u < l.length; u += 1) {
      const p = l[u];
      o.regular.has(p) && p.apply(this, n);
    }
  }
  once(t, n) {
    const o = this;
    this.on(t, function s(...l) {
      o.removeListener(t, s), n.apply(o, l);
    });
  }
}
const x_e = (e) => e.isPropagationStopped !== void 0, uH = () => {
  const [e] = D.useState(() => new b_e()), t = D.useCallback((...o) => {
    const [s, l, u = {}] = o;
    u.defaultMuiPrevented = !1, !(x_e(u) && u.isPropagationStopped()) && e.emit(s, l, u);
  }, [e]), n = D.useCallback((o, s) => (e.on(o, s), () => {
    e.removeListener(o, s);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: n
    }
  };
};
uH.params = {};
const S_e = [uH];
function C_e(e) {
  const t = D.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const w_e = (e) => {
  const t = [...S_e, ...e.plugins], n = t.reduce((k, _) => _.getDefaultizedParams ? _.getDefaultizedParams(k) : k, e), o = y_e(t, n), l = D.useRef({}).current, u = C_e(e.apiRef), p = D.useRef(null), h = ro(p, e.rootRef), [m, b] = D.useState(() => {
    const k = {};
    return t.forEach((_) => {
      _.getInitialState && Object.assign(k, _.getInitialState(n));
    }), k;
  }), x = [], S = {
    publicAPI: u,
    instance: l,
    rootRef: p
  }, R = (k) => {
    const _ = k({
      instance: l,
      params: n,
      slots: n.slots,
      slotProps: n.slotProps,
      experimentalFeatures: n.experimentalFeatures,
      state: m,
      setState: b,
      rootRef: p,
      models: o
    });
    _.getRootProps && x.push(_.getRootProps), _.publicAPI && Object.assign(u, _.publicAPI), _.instance && Object.assign(l, _.instance), _.contextValue && Object.assign(S, _.contextValue);
  };
  t.forEach(R), S.runItemPlugins = (k) => {
    let _ = null, L = null;
    return t.forEach((F) => {
      if (!F.itemPlugin)
        return;
      const N = F.itemPlugin({
        props: k,
        rootRef: _,
        contentRef: L
      });
      N != null && N.rootRef && (_ = N.rootRef), N != null && N.contentRef && (L = N.contentRef);
    }), {
      contentRef: L,
      rootRef: _
    };
  };
  const T = t.map((k) => k.wrapItem).filter((k) => !!k);
  S.wrapItem = ({
    itemId: k,
    children: _
  }) => {
    let L = _;
    return T.forEach((F) => {
      L = F({
        itemId: k,
        children: L,
        instance: l
      });
    }), L;
  };
  const E = t.map((k) => k.wrapRoot).filter((k) => !!k).reverse();
  return S.wrapRoot = ({
    children: k
  }) => {
    let _ = k;
    return E.forEach((L) => {
      _ = L({
        children: _,
        instance: l
      });
    }), _;
  }, {
    getRootProps: (k = {}) => {
      const _ = O({
        role: "tree"
      }, k, {
        ref: h
      });
      return x.forEach((L) => {
        Object.assign(_, L(k));
      }), _;
    },
    rootRef: h,
    contextValue: S,
    instance: l
  };
}, pN = /* @__PURE__ */ D.createContext(null);
process.env.NODE_ENV !== "production" && (pN.displayName = "TreeViewContext");
function T_e(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ I(pN.Provider, {
    value: t,
    children: t.wrapRoot({
      children: n
    })
  });
}
const dH = ({
  params: e
}) => {
  const t = bp(e.id), n = D.useCallback((o, s) => s ?? `${t}-${o}`, [t]);
  return {
    getRootProps: () => ({
      id: t
    }),
    instance: {
      getTreeItemIdAttribute: n
    }
  };
};
dH.params = {
  id: !0
};
const E_e = (e, t, n) => {
  e.$$publishEvent(t, n);
}, Ab = "__TREE_VIEW_ROOT_PARENT_ID__", R_e = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[n] = o;
  }), t;
}, rE = /* @__PURE__ */ D.createContext(() => -1);
process.env.NODE_ENV !== "production" && (rE.displayName = "TreeViewItemDepthContext");
const fH = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: n,
  getItemId: o
}) => {
  const s = {}, l = {}, u = {
    [Ab]: []
  }, p = (m, b, x) => {
    var E, P;
    const S = o ? o(m) : m.id;
    if (S == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(m)].join(`
`));
    if (s[S] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${S}"`].join(`
`));
    const R = n ? n(m) : m.label;
    if (R == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(m)].join(`
`));
    s[S] = {
      id: S,
      label: R,
      parentId: x,
      idAttribute: void 0,
      expandable: !!((E = m.children) != null && E.length),
      disabled: t ? t(m) : !1,
      depth: b
    }, l[S] = m, u[S] = [];
    const T = x ?? Ab;
    u[T] || (u[T] = []), u[T].push(S), (P = m.children) == null || P.forEach((k) => p(k, b + 1, S));
  };
  e.forEach((m) => p(m, 0, null));
  const h = {};
  return Object.keys(u).forEach((m) => {
    h[m] = R_e(u[m]);
  }), {
    itemMetaMap: s,
    itemMap: l,
    itemOrderedChildrenIds: u,
    itemChildrenIndexes: h
  };
}, G0 = ({
  instance: e,
  params: t,
  state: n,
  setState: o,
  experimentalFeatures: s
}) => {
  const l = D.useCallback((E) => n.items.itemMetaMap[E], [n.items.itemMetaMap]), u = D.useCallback((E) => n.items.itemMap[E], [n.items.itemMap]), p = D.useCallback((E) => {
    if (E == null)
      return !1;
    let P = e.getItemMeta(E);
    if (!P)
      return !1;
    if (P.disabled)
      return !0;
    for (; P.parentId != null; )
      if (P = e.getItemMeta(P.parentId), P.disabled)
        return !0;
    return !1;
  }, [e]), h = D.useCallback((E) => {
    const P = e.getItemMeta(E).parentId ?? Ab;
    return n.items.itemChildrenIndexes[P][E];
  }, [e, n.items.itemChildrenIndexes]), m = D.useCallback((E) => n.items.itemOrderedChildrenIds[E ?? Ab] ?? [], [n.items.itemOrderedChildrenIds]), b = (E) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(E), x = D.useRef(!1), S = D.useCallback(() => {
    x.current = !0;
  }, []), R = D.useCallback(() => x.current, []);
  return D.useEffect(() => {
    e.areItemUpdatesPrevented() || o((E) => {
      const P = fH({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(E.items.itemMetaMap).forEach((k) => {
        P.itemMetaMap[k.id] || E_e(e, "removeItem", {
          id: k.id
        });
      }), O({}, E, {
        items: P
      });
    });
  }, [e, o, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: u
    },
    instance: {
      getItemMeta: l,
      getItem: u,
      getItemsToRender: () => {
        const E = (P) => {
          const k = n.items.itemMetaMap[P];
          return {
            label: k.label,
            itemId: k.id,
            id: k.idAttribute,
            children: n.items.itemOrderedChildrenIds[P].map(E)
          };
        };
        return n.items.itemOrderedChildrenIds[Ab].map(E);
      },
      getItemIndex: h,
      getItemOrderedChildrenIds: m,
      isItemDisabled: p,
      isItemNavigable: b,
      preventItemUpdates: S,
      areItemUpdatesPrevented: R
    },
    contextValue: {
      disabledItemsFocusable: t.disabledItemsFocusable,
      indentationAtItemLevel: s.indentationAtItemLevel ?? !1
    }
  };
};
G0.getInitialState = (e) => ({
  items: fH({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
G0.getDefaultizedParams = (e) => O({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
G0.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ I(rE.Provider, {
  value: (n) => {
    var o;
    return ((o = t.getItemMeta(n)) == null ? void 0 : o.depth) ?? 0;
  },
  children: e
});
G0.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  itemChildrenIndentation: !0
};
const oE = ({
  instance: e,
  params: t,
  models: n
}) => {
  const o = D.useMemo(() => {
    const b = /* @__PURE__ */ new Map();
    return n.expandedItems.value.forEach((x) => {
      b.set(x, !0);
    }), b;
  }, [n.expandedItems.value]), s = (b, x) => {
    var S;
    (S = t.onExpandedItemsChange) == null || S.call(t, b, x), n.expandedItems.setControlledValue(x);
  }, l = D.useCallback((b) => o.has(b), [o]), u = D.useCallback((b) => {
    var x;
    return !!((x = e.getItemMeta(b)) != null && x.expandable);
  }, [e]), p = Tt((b, x) => {
    const S = e.isItemExpanded(x);
    e.setItemExpansion(b, x, !S);
  }), h = Tt((b, x, S) => {
    if (e.isItemExpanded(x) === S)
      return;
    let T;
    S ? T = [x].concat(n.expandedItems.value) : T = n.expandedItems.value.filter((E) => E !== x), t.onItemExpansionToggle && t.onItemExpansionToggle(b, x, S), s(b, T);
  });
  return {
    publicAPI: {
      setItemExpansion: h
    },
    instance: {
      isItemExpanded: l,
      isItemExpandable: u,
      setItemExpansion: h,
      toggleItemExpansion: p,
      expandAllSiblings: (b, x) => {
        const S = e.getItemMeta(x), T = e.getItemOrderedChildrenIds(S.parentId).filter((P) => e.isItemExpandable(P) && !e.isItemExpanded(P)), E = n.expandedItems.value.concat(T);
        T.length > 0 && (t.onItemExpansionToggle && T.forEach((P) => {
          t.onItemExpansionToggle(b, P, !0);
        }), s(b, E));
      }
    }
  };
};
oE.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const O_e = [];
oE.getDefaultizedParams = (e) => O({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? O_e
});
oE.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0
};
const pH = (e, t) => {
  let n = t.length - 1;
  for (; n >= 0 && !e.isItemNavigable(t[n]); )
    n -= 1;
  if (n !== -1)
    return t[n];
}, hH = (e, t) => {
  const n = e.getItemMeta(t), o = e.getItemOrderedChildrenIds(n.parentId), s = e.getItemIndex(t);
  if (s === 0)
    return n.parentId;
  let l = s - 1;
  for (; !e.isItemNavigable(o[l]) && l >= 0; )
    l -= 1;
  if (l === -1)
    return n.parentId == null ? null : hH(e, n.parentId);
  let u = o[l], p = pH(e, e.getItemOrderedChildrenIds(u));
  for (; e.isItemExpanded(u) && p != null; )
    u = p, p = e.getItemOrderedChildrenIds(u).find(e.isItemNavigable);
  return u;
}, I1 = (e, t) => {
  if (e.isItemExpanded(t)) {
    const o = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (o != null)
      return o;
  }
  let n = e.getItemMeta(t);
  for (; n != null; ) {
    const o = e.getItemOrderedChildrenIds(n.parentId), s = e.getItemIndex(n.id);
    if (s < o.length - 1) {
      let l = s + 1;
      for (; !e.isItemNavigable(o[l]) && l < o.length - 1; )
        l += 1;
      if (e.isItemNavigable(o[l]))
        return o[l];
    }
    n = e.getItemMeta(n.parentId);
  }
  return null;
}, mH = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const n = e.getItemOrderedChildrenIds(t), o = pH(e, n);
    if (o == null)
      return t;
    t = o;
  }
  return t;
}, s0 = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), vH = (e, t, n) => {
  if (t === n)
    return [t, n];
  const o = e.getItemMeta(t), s = e.getItemMeta(n);
  if (o.parentId === s.id || s.parentId === o.id)
    return s.parentId === o.id ? [o.id, s.id] : [s.id, o.id];
  const l = [o.id], u = [s.id];
  let p = o.parentId, h = s.parentId, m = u.indexOf(p) !== -1, b = l.indexOf(h) !== -1, x = !0, S = !0;
  for (; !b && !m; )
    x && (l.push(p), m = u.indexOf(p) !== -1, x = p !== null, !m && x && (p = e.getItemMeta(p).parentId)), S && !m && (u.push(h), b = l.indexOf(h) !== -1, S = h !== null, !b && S && (h = e.getItemMeta(h).parentId));
  const R = m ? p : h, T = e.getItemOrderedChildrenIds(R), E = l[l.indexOf(R) - 1], P = u[u.indexOf(R) - 1];
  return T.indexOf(E) < T.indexOf(P) ? [t, n] : [n, t];
}, P_e = (e, t, n) => {
  const o = (h) => {
    if (e.isItemExpandable(h) && e.isItemExpanded(h))
      return e.getItemOrderedChildrenIds(h)[0];
    let m = e.getItemMeta(h);
    for (; m != null; ) {
      const b = e.getItemOrderedChildrenIds(m.parentId), x = e.getItemIndex(m.id);
      if (x < b.length - 1)
        return b[x + 1];
      m = e.getItemMeta(m.parentId);
    }
    throw new Error("Invalid range");
  }, [s, l] = vH(e, t, n), u = [s];
  let p = s;
  for (; p !== l; )
    p = o(p), e.isItemDisabled(p) || u.push(p);
  return u;
}, $_e = (e) => {
  let t = s0(e);
  const n = [];
  for (; t != null; )
    n.push(t), t = I1(e, t);
  return n;
}, _1 = (e) => Array.isArray(e) ? e : e != null ? [e] : [], P$ = (e) => {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}, aE = ({
  instance: e,
  params: t,
  models: n
}) => {
  const o = D.useRef(null), s = D.useRef({}), l = D.useMemo(() => {
    const E = /* @__PURE__ */ new Map();
    return Array.isArray(n.selectedItems.value) ? n.selectedItems.value.forEach((P) => {
      E.set(P, !0);
    }) : n.selectedItems.value != null && E.set(n.selectedItems.value, !0), E;
  }, [n.selectedItems.value]), u = (E, P) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const k = P.filter((L) => !e.isItemSelected(L)), _ = n.selectedItems.value.filter((L) => !P.includes(L));
        k.forEach((L) => {
          t.onItemSelectionToggle(E, L, !0);
        }), _.forEach((L) => {
          t.onItemSelectionToggle(E, L, !1);
        });
      } else P !== n.selectedItems.value && (n.selectedItems.value != null && t.onItemSelectionToggle(E, n.selectedItems.value, !1), P != null && t.onItemSelectionToggle(E, P, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(E, P), n.selectedItems.setControlledValue(P);
  }, p = (E) => l.has(E), h = (E, P, k, _) => {
    if (t.disableSelection)
      return;
    let L;
    if (k) {
      const F = _1(n.selectedItems.value), N = e.isItemSelected(P);
      N && (_ === !1 || _ == null) ? L = F.filter((V) => V !== P) : !N && (_ === !0 || _ == null) ? L = [P].concat(F) : L = F;
    } else
      _ === !1 ? L = t.multiSelect ? [] : null : L = t.multiSelect ? [P] : P;
    u(E, L), o.current = P, s.current = {};
  }, m = (E, [P, k]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let _ = _1(n.selectedItems.value).slice();
    Object.keys(s.current).length > 0 && (_ = _.filter((V) => !s.current[V]));
    const L = P$(_), F = P_e(e, P, k), N = F.filter((V) => !L[V]);
    _ = _.concat(N), u(E, _), s.current = P$(F);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    instance: {
      isItemSelected: p,
      selectItem: h,
      selectAllNavigableItems: (E) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const P = $_e(e);
        u(E, P), s.current = P$(P);
      },
      expandSelectionRange: (E, P) => {
        if (o.current != null) {
          const [k, _] = vH(e, P, o.current);
          m(E, [k, _]);
        }
      },
      selectRangeFromStartToItem: (E, P) => {
        m(E, [s0(e), P]);
      },
      selectRangeFromItemToEnd: (E, P) => {
        m(E, [P, mH(e)]);
      },
      selectItemFromArrowNavigation: (E, P, k) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let _ = _1(n.selectedItems.value).slice();
        Object.keys(s.current).length === 0 ? (_.push(k), s.current = {
          [P]: !0,
          [k]: !0
        }) : (s.current[P] || (s.current = {}), s.current[k] ? (_ = _.filter((L) => L !== P), delete s.current[P]) : (_.push(k), s.current[k] = !0)), u(E, _);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
aE.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const D_e = [];
aE.getDefaultizedParams = (e) => O({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? D_e : null)
});
aE.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
const HV = 1e3;
class k_e {
  constructor(t = HV) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = HV, this.cleanupTimeout = t;
  }
  register(t, n, o) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const s = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(o.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(o.cleanupToken, s);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class M_e {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, o) {
    this.registry.register(t, n, o);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class N_e {
}
function I_e(e) {
  let t = 0;
  return function(o, s, l) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new M_e() : new k_e());
    const [u] = D.useState(new N_e()), p = D.useRef(null), h = D.useRef();
    h.current = l;
    const m = D.useRef(null);
    if (!p.current && h.current) {
      const b = (x, S) => {
        var R;
        S.defaultMuiPrevented || (R = h.current) == null || R.call(h, x, S);
      };
      p.current = o.$$subscribeEvent(s, b), t += 1, m.current = {
        cleanupToken: t
      }, e.registry.register(
        u,
        // The callback below will be called once this reference stops being retained
        () => {
          var x;
          (x = p.current) == null || x.call(p), p.current = null, m.current = null;
        },
        m.current
      );
    } else !h.current && p.current && (p.current(), p.current = null, m.current && (e.registry.unregister(m.current), m.current = null));
    D.useEffect(() => {
      if (!p.current && h.current) {
        const b = (x, S) => {
          var R;
          S.defaultMuiPrevented || (R = h.current) == null || R.call(h, x, S);
        };
        p.current = o.$$subscribeEvent(s, b);
      }
      return m.current && e.registry && (e.registry.unregister(m.current), m.current = null), () => {
        var b;
        (b = p.current) == null || b.call(p), p.current = null;
      };
    }, [o, s]);
  };
}
const __e = {
  registry: null
}, A_e = I_e(__e), gH = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? gH(t.shadowRoot) : t : null;
}, L_e = (e, t) => {
  let n = _1(t).find((o) => {
    if (!e.isItemNavigable(o))
      return !1;
    const s = e.getItemMeta(o);
    return s && (s.parentId == null || e.isItemExpanded(s.parentId));
  });
  return n == null && (n = s0(e)), n;
}, hN = ({
  instance: e,
  params: t,
  state: n,
  setState: o,
  models: s,
  rootRef: l
}) => {
  const u = L_e(e, s.selectedItems.value), p = Tt((P) => {
    const k = typeof P == "function" ? P(n.focusedItemId) : P;
    n.focusedItemId !== k && o((_) => O({}, _, {
      focusedItemId: k
    }));
  }), h = D.useCallback(() => !!l.current && l.current.contains(gH(N1(l.current))), [l]), m = D.useCallback((P) => n.focusedItemId === P && h(), [n.focusedItemId, h]), b = (P) => {
    const k = e.getItemMeta(P);
    return k && (k.parentId == null || e.isItemExpanded(k.parentId));
  }, x = (P, k) => {
    const _ = e.getItemMeta(k), L = document.getElementById(e.getTreeItemIdAttribute(k, _.idAttribute));
    L && L.focus(), p(k), t.onItemFocus && t.onItemFocus(P, k);
  }, S = Tt((P, k) => {
    b(k) && x(P, k);
  }), R = Tt(() => {
    if (n.focusedItemId == null)
      return;
    const P = e.getItemMeta(n.focusedItemId);
    if (P) {
      const k = document.getElementById(e.getTreeItemIdAttribute(n.focusedItemId, P.idAttribute));
      k && k.blur();
    }
    p(null);
  }), T = (P) => P === u;
  A_e(e, "removeItem", ({
    id: P
  }) => {
    n.focusedItemId === P && x(null, u);
  });
  const E = (P) => (k) => {
    var _;
    (_ = P.onFocus) == null || _.call(P, k), !k.defaultMuiPrevented && k.target === k.currentTarget && x(k, u);
  };
  return {
    getRootProps: (P) => ({
      onFocus: E(P)
    }),
    publicAPI: {
      focusItem: S
    },
    instance: {
      isItemFocused: m,
      canItemBeTabbed: T,
      focusItem: S,
      removeFocusedItem: R
    }
  };
};
hN.getInitialState = () => ({
  focusedItemId: null
});
hN.params = {
  onItemFocus: !0
};
function F_e(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const yH = ({
  instance: e,
  params: t,
  state: n
}) => {
  const s = Go().direction === "rtl", l = D.useRef({}), u = Tt((x) => {
    l.current = x(l.current);
  });
  D.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const x = {}, S = (R) => {
      x[R.id] = R.label.substring(0, 1).toLowerCase();
    };
    Object.values(n.items.itemMetaMap).forEach(S), l.current = x;
  }, [n.items.itemMetaMap, t.getItemId, e]);
  const p = (x, S) => {
    const R = S.toLowerCase(), T = (_) => {
      const L = I1(e, _);
      return L === null ? s0(e) : L;
    };
    let E = null, P = T(x);
    const k = {};
    for (; E == null && !k[P]; )
      l.current[P] === R ? E = P : (k[P] = !0, P = T(P));
    return E;
  }, h = (x) => !t.disableSelection && !e.isItemDisabled(x), m = (x) => !e.isItemDisabled(x) && e.isItemExpandable(x);
  return {
    instance: {
      updateFirstCharMap: u,
      handleItemKeyDown: (x, S) => {
        if (x.defaultMuiPrevented || x.altKey || x.currentTarget !== x.target.closest('*[role="treeitem"]'))
          return;
        const R = x.ctrlKey || x.metaKey, T = x.key;
        switch (!0) {
          case (T === " " && h(S)): {
            x.preventDefault(), t.multiSelect && x.shiftKey ? e.expandSelectionRange(x, S) : t.multiSelect ? e.selectItem(x, S, !0) : e.selectItem(x, S, !1);
            break;
          }
          case T === "Enter": {
            m(S) ? (e.toggleItemExpansion(x, S), x.preventDefault()) : h(S) && (t.multiSelect ? (x.preventDefault(), e.selectItem(x, S, !0)) : e.isItemSelected(S) || (e.selectItem(x, S, !1), x.preventDefault()));
            break;
          }
          case T === "ArrowDown": {
            const E = I1(e, S);
            E && (x.preventDefault(), e.focusItem(x, E), t.multiSelect && x.shiftKey && h(E) && e.selectItemFromArrowNavigation(x, S, E));
            break;
          }
          case T === "ArrowUp": {
            const E = hH(e, S);
            E && (x.preventDefault(), e.focusItem(x, E), t.multiSelect && x.shiftKey && h(E) && e.selectItemFromArrowNavigation(x, S, E));
            break;
          }
          case (T === "ArrowRight" && !s || T === "ArrowLeft" && s): {
            if (e.isItemExpanded(S)) {
              const E = I1(e, S);
              E && (e.focusItem(x, E), x.preventDefault());
            } else m(S) && (e.toggleItemExpansion(x, S), x.preventDefault());
            break;
          }
          case (T === "ArrowLeft" && !s || T === "ArrowRight" && s): {
            if (m(S) && e.isItemExpanded(S))
              e.toggleItemExpansion(x, S), x.preventDefault();
            else {
              const E = e.getItemMeta(S).parentId;
              E && (e.focusItem(x, E), x.preventDefault());
            }
            break;
          }
          case T === "Home": {
            h(S) && t.multiSelect && R && x.shiftKey ? e.selectRangeFromStartToItem(x, S) : e.focusItem(x, s0(e)), x.preventDefault();
            break;
          }
          case T === "End": {
            h(S) && t.multiSelect && R && x.shiftKey ? e.selectRangeFromItemToEnd(x, S) : e.focusItem(x, mH(e)), x.preventDefault();
            break;
          }
          case T === "*": {
            e.expandAllSiblings(x, S), x.preventDefault();
            break;
          }
          case (T === "a" && R && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(x), x.preventDefault();
            break;
          }
          case (!R && !x.shiftKey && F_e(T)): {
            const E = p(S, T);
            E != null && (e.focusItem(x, E), x.preventDefault());
            break;
          }
        }
      }
    }
  };
};
yH.params = {};
const bH = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
bH.params = {};
const j_e = [dH, G0, oE, aE, hN, yH, bH];
var K0 = {};
const V_e = /* @__PURE__ */ vd(Rq);
var $$ = { exports: {} }, WV;
function B_e() {
  return WV || (WV = 1, function(e) {
    function t(n, o) {
      if (n == null) return {};
      var s = {};
      for (var l in n) if ({}.hasOwnProperty.call(n, l)) {
        if (o.indexOf(l) >= 0) continue;
        s[l] = n[l];
      }
      return s;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($$)), $$.exports;
}
const z_e = /* @__PURE__ */ vd(ADe), U_e = /* @__PURE__ */ vd(MOe), H_e = /* @__PURE__ */ vd(VOe), W_e = /* @__PURE__ */ vd(jOe), q_e = /* @__PURE__ */ vd(Dke), Y_e = /* @__PURE__ */ vd(Ike);
var Vv = r5;
Object.defineProperty(K0, "__esModule", {
  value: !0
});
K0.default = s2e;
var iE = K0.shouldForwardProp = A1;
K0.systemDefaultTheme = void 0;
var ns = Vv(V_e), bD = Vv(B_e()), qV = n2e(z_e), G_e = U_e, K_e = Vv(H_e), X_e = Vv(W_e), Q_e = Vv(q_e), J_e = Vv(Y_e);
const Z_e = ["ownerState"], e2e = ["variants"], t2e = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function xH(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (xH = function(o) {
    return o ? n : t;
  })(e);
}
function n2e(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = xH(t);
  if (n && n.has(e)) return n.get(e);
  var o = { __proto__: null }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e) if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
    var u = s ? Object.getOwnPropertyDescriptor(e, l) : null;
    u && (u.get || u.set) ? Object.defineProperty(o, l, u) : o[l] = e[l];
  }
  return o.default = e, n && n.set(e, o), o;
}
function r2e(e) {
  return Object.keys(e).length === 0;
}
function o2e(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function A1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const a2e = K0.systemDefaultTheme = (0, Q_e.default)(), YV = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function C1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return r2e(t) ? e : t[n] || t;
}
function i2e(e) {
  return e ? (t, n) => n[e] : null;
}
function L1(e, t) {
  let {
    ownerState: n
  } = t, o = (0, bD.default)(t, Z_e);
  const s = typeof e == "function" ? e((0, ns.default)({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(s))
    return s.flatMap((l) => L1(l, (0, ns.default)({
      ownerState: n
    }, o)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: l = []
    } = s;
    let p = (0, bD.default)(s, e2e);
    return l.forEach((h) => {
      let m = !0;
      typeof h.props == "function" ? m = h.props((0, ns.default)({
        ownerState: n
      }, o, n)) : Object.keys(h.props).forEach((b) => {
        (n == null ? void 0 : n[b]) !== h.props[b] && o[b] !== h.props[b] && (m = !1);
      }), m && (Array.isArray(p) || (p = [p]), p.push(typeof h.style == "function" ? h.style((0, ns.default)({
        ownerState: n
      }, o, n)) : h.style));
    }), p;
  }
  return s;
}
function s2e(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = a2e,
    rootShouldForwardProp: o = A1,
    slotShouldForwardProp: s = A1
  } = e, l = (u) => (0, J_e.default)((0, ns.default)({}, u, {
    theme: C1((0, ns.default)({}, u, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return l.__mui_systemSx = !0, (u, p = {}) => {
    (0, qV.internal_processStyles)(u, (N) => N.filter((V) => !(V != null && V.__mui_systemSx)));
    const {
      name: h,
      slot: m,
      skipVariantsResolver: b,
      skipSx: x,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: S = i2e(YV(m))
    } = p, R = (0, bD.default)(p, t2e), T = b !== void 0 ? b : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), E = x || !1;
    let P;
    process.env.NODE_ENV !== "production" && h && (P = `${h}-${YV(m || "Root")}`);
    let k = A1;
    m === "Root" || m === "root" ? k = o : m ? k = s : o2e(u) && (k = void 0);
    const _ = (0, qV.default)(u, (0, ns.default)({
      shouldForwardProp: k,
      label: P
    }, R)), L = (N) => typeof N == "function" && N.__emotion_real !== N || (0, G_e.isPlainObject)(N) ? (V) => L1(N, (0, ns.default)({}, V, {
      theme: C1({
        theme: V.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : N, F = (N, ...V) => {
      let z = L(N);
      const H = V ? V.map(L) : [];
      h && S && H.push((X) => {
        const ne = C1((0, ns.default)({}, X, {
          defaultTheme: n,
          themeId: t
        }));
        if (!ne.components || !ne.components[h] || !ne.components[h].styleOverrides)
          return null;
        const Y = ne.components[h].styleOverrides, J = {};
        return Object.entries(Y).forEach(([te, Z]) => {
          J[te] = L1(Z, (0, ns.default)({}, X, {
            theme: ne
          }));
        }), S(X, J);
      }), h && !T && H.push((X) => {
        var ne;
        const Y = C1((0, ns.default)({}, X, {
          defaultTheme: n,
          themeId: t
        })), J = Y == null || (ne = Y.components) == null || (ne = ne[h]) == null ? void 0 : ne.variants;
        return L1({
          variants: J
        }, (0, ns.default)({}, X, {
          theme: Y
        }));
      }), E || H.push(l);
      const ee = H.length - V.length;
      if (Array.isArray(N) && ee > 0) {
        const X = new Array(ee).fill("");
        z = [...N, ...X], z.raw = [...N.raw, ...X];
      }
      const K = _(z, ...H);
      if (process.env.NODE_ENV !== "production") {
        let X;
        h && (X = `${h}${(0, K_e.default)(m || "")}`), X === void 0 && (X = `Styled(${(0, X_e.default)(u)})`), K.displayName = X;
      }
      return u.muiName && (K.muiName = u.muiName), K;
    };
    return _.withConfig && (F.withConfig = _.withConfig), F;
  };
}
const Bv = () => {
  const e = D.useContext(pN);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
};
function l2e(e) {
  const {
    instance: t,
    selection: {
      multiSelect: n,
      checkboxSelection: o,
      disableSelection: s
    }
  } = Bv(), l = t.isItemExpandable(e), u = t.isItemExpanded(e), p = t.isItemFocused(e), h = t.isItemSelected(e), m = t.isItemDisabled(e);
  return {
    disabled: m,
    expanded: u,
    selected: h,
    focused: p,
    disableSelection: s,
    checkboxSelection: o,
    handleExpansion: (T) => {
      if (!m) {
        p || t.focusItem(T, e);
        const E = n && (T.shiftKey || T.ctrlKey || T.metaKey);
        l && !(E && t.isItemExpanded(e)) && t.toggleItemExpansion(T, e);
      }
    },
    handleSelection: (T) => {
      m || (p || t.focusItem(T, e), n && (T.shiftKey || T.ctrlKey || T.metaKey) ? T.shiftKey ? t.expandSelectionRange(T, e) : t.selectItem(T, e, !0) : t.selectItem(T, e, !1));
    },
    handleCheckboxSelection: (T) => {
      if (s || m)
        return;
      const E = T.nativeEvent.shiftKey;
      n && E ? t.expandSelectionRange(T, e) : t.selectItem(T, e, n, T.target.checked);
    },
    preventSelection: (T) => {
      (T.shiftKey || T.ctrlKey || T.metaKey || m) && T.preventDefault();
    }
  };
}
const c2e = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown"], mN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    classes: o,
    className: s,
    displayIcon: l,
    expansionIcon: u,
    icon: p,
    label: h,
    itemId: m,
    onClick: b,
    onMouseDown: x
  } = t, S = Te(t, c2e), {
    disabled: R,
    expanded: T,
    selected: E,
    focused: P,
    disableSelection: k,
    checkboxSelection: _,
    handleExpansion: L,
    handleSelection: F,
    handleCheckboxSelection: N,
    preventSelection: V
  } = l2e(m), z = p || u || l, H = D.useRef(null), ee = (X) => {
    V(X), x && x(X);
  }, K = (X) => {
    var ne;
    (ne = H.current) != null && ne.contains(X.target) || (L(X), _ || F(X), b && b(X));
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ qe("div", O({}, S, {
      className: Ne(s, o.root, T && o.expanded, E && o.selected, P && o.focused, R && o.disabled),
      onClick: K,
      onMouseDown: ee,
      ref: n,
      children: [/* @__PURE__ */ I("div", {
        className: o.iconContainer,
        children: z
      }), _ && /* @__PURE__ */ I(b0, {
        className: o.checkbox,
        checked: E,
        onChange: N,
        disabled: R || k,
        ref: H,
        tabIndex: -1
      }), /* @__PURE__ */ I("div", {
        className: o.label,
        children: h
      })]
    }))
  );
});
process.env.NODE_ENV !== "production" && (mN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object.isRequired,
  className: r.string,
  /**
   * The icon to display next to the tree item's label. Either a parent or end icon.
   */
  displayIcon: r.node,
  /**
   * The icon to display next to the tree item's label. Either an expansion or collapse icon.
   */
  expansionIcon: r.node,
  /**
   * The icon to display next to the tree item's label.
   */
  icon: r.node,
  /**
   * The id of the item.
   */
  itemId: r.string.isRequired,
  /**
   * The tree item label.
   */
  label: r.node
});
function SH(e) {
  return xn("MuiTreeItem", e);
}
const Ic = Cn("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox"]), CH = lr(/* @__PURE__ */ I("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), wH = lr(/* @__PURE__ */ I("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function sE(e) {
  const {
    children: t,
    itemId: n
  } = e, {
    wrapItem: o,
    instance: s
  } = Bv();
  return o({
    children: t,
    itemId: n,
    instance: s
  });
}
sE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  itemId: r.string.isRequired
};
const u2e = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], d2e = ["ownerState"], f2e = ["ownerState"], p2e = ["ownerState"], h2e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    groupTransition: ["groupTransition"]
  }, SH, t);
}, m2e = ce("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), v2e = ce(mN, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${Ic.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${Ic.label}`]: t.label
  }],
  shouldForwardProp: (e) => iE(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ic.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${Ic.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ic.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${Ic.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${Ic.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${Ic.label}`]: O({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${Ic.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), g2e = ce(Sv, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => iE(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), vN = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const {
    icons: o,
    runItemPlugins: s,
    selection: {
      multiSelect: l
    },
    disabledItemsFocusable: u,
    indentationAtItemLevel: p,
    instance: h
  } = Bv(), m = D.useContext(rE), b = We({
    props: t,
    name: "MuiTreeItem"
  }), {
    children: x,
    className: S,
    slots: R,
    slotProps: T,
    ContentComponent: E = mN,
    ContentProps: P,
    itemId: k,
    id: _,
    label: L,
    onClick: F,
    onMouseDown: N,
    onBlur: V,
    onKeyDown: z
  } = b, H = Te(b, u2e), {
    contentRef: ee,
    rootRef: K
  } = s(b), X = ro(n, K), ne = ro(P == null ? void 0 : P.ref, ee), Y = {
    expandIcon: (R == null ? void 0 : R.expandIcon) ?? o.slots.expandIcon ?? CH,
    collapseIcon: (R == null ? void 0 : R.collapseIcon) ?? o.slots.collapseIcon ?? wH,
    endIcon: (R == null ? void 0 : R.endIcon) ?? o.slots.endIcon,
    icon: R == null ? void 0 : R.icon,
    groupTransition: R == null ? void 0 : R.groupTransition
  }, J = (it) => Array.isArray(it) ? it.length > 0 && it.some(J) : !!it, te = J(x), Z = h.isItemExpanded(k), ae = h.isItemFocused(k), U = h.isItemSelected(k), G = h.isItemDisabled(k), W = O({}, b, {
    expanded: Z,
    focused: ae,
    selected: U,
    disabled: G,
    indentationAtItemLevel: p
  }), le = h2e(W), pe = Y.groupTransition ?? void 0, ge = Ni({
    elementType: pe,
    ownerState: {},
    externalSlotProps: T == null ? void 0 : T.groupTransition,
    additionalProps: O({
      unmountOnExit: !0,
      in: Z,
      component: "ul",
      role: "group"
    }, p ? {
      indentationAtItemLevel: !0
    } : {}),
    className: le.groupTransition
  }), we = Z ? Y.collapseIcon : Y.expandIcon, de = Ni({
    elementType: we,
    ownerState: {},
    externalSlotProps: (it) => Z ? O({}, Ac(o.slotProps.collapseIcon, it), Ac(T == null ? void 0 : T.collapseIcon, it)) : O({}, Ac(o.slotProps.expandIcon, it), Ac(T == null ? void 0 : T.expandIcon, it))
  }), se = Te(de, d2e), ve = te && we ? /* @__PURE__ */ I(we, O({}, se)) : null, me = te ? void 0 : Y.endIcon, Oe = Ni({
    elementType: me,
    ownerState: {},
    externalSlotProps: (it) => te ? {} : O({}, Ac(o.slotProps.endIcon, it), Ac(T == null ? void 0 : T.endIcon, it))
  }), be = Te(Oe, f2e), De = me ? /* @__PURE__ */ I(me, O({}, be)) : null, ie = Y.icon, fe = Ni({
    elementType: ie,
    ownerState: {},
    externalSlotProps: T == null ? void 0 : T.icon
  }), ye = Te(fe, p2e), Ee = ie ? /* @__PURE__ */ I(ie, O({}, ye)) : null;
  let _e;
  l ? _e = U : U && (_e = !0);
  function Ve(it) {
    !ae && (!G || u) && it.currentTarget === it.target && h.focusItem(it, k);
  }
  function Re(it) {
    V == null || V(it), h.removeFocusedItem();
  }
  const lt = (it) => {
    z == null || z(it), h.handleItemKeyDown(it, k);
  }, Pt = h.getTreeItemIdAttribute(k, _), at = h.canItemBeTabbed(k) ? 0 : -1;
  return /* @__PURE__ */ I(sE, {
    itemId: k,
    children: /* @__PURE__ */ qe(m2e, O({
      className: Ne(le.root, S),
      role: "treeitem",
      "aria-expanded": te ? Z : void 0,
      "aria-selected": _e,
      "aria-disabled": G || void 0,
      id: Pt,
      tabIndex: at
    }, H, {
      ownerState: W,
      onFocus: Ve,
      onBlur: Re,
      onKeyDown: lt,
      ref: X,
      style: p ? O({}, H.style, {
        "--TreeView-itemDepth": typeof m == "function" ? m(k) : m
      }) : H.style,
      children: [/* @__PURE__ */ I(v2e, O({
        as: E,
        classes: {
          root: le.content,
          expanded: le.expanded,
          selected: le.selected,
          focused: le.focused,
          disabled: le.disabled,
          iconContainer: le.iconContainer,
          label: le.label,
          checkbox: le.checkbox
        },
        label: L,
        itemId: k,
        onClick: F,
        onMouseDown: N,
        icon: Ee,
        expansionIcon: ve,
        displayIcon: De,
        ownerState: W
      }, P, {
        ref: ne
      })), x && /* @__PURE__ */ I(g2e, O({
        as: pe
      }, ge, {
        children: x
      }))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (vN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The component used to render the content of the item.
   * @default TreeItemContent
   */
  ContentComponent: _Oe,
  /**
   * Props applied to ContentComponent.
   */
  ContentProps: r.object,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * The id of the item.
   */
  itemId: r.string.isRequired,
  /**
   * The tree item label.
   */
  label: r.node,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor a item's focus.
   */
  onFocus: I3,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const y2e = (e, t = "warning") => {
  let n = !1;
  const o = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(o) : console.warn(o));
  };
}, b2e = ["slots", "slotProps", "apiRef", "experimentalFeatures"], x2e = (e) => {
  let {
    props: {
      slots: t,
      slotProps: n,
      apiRef: o,
      experimentalFeatures: s
    },
    plugins: l,
    rootRef: u
  } = e, p = Te(e.props, b2e);
  const h = {};
  l.forEach((x) => {
    Object.assign(h, x.params);
  });
  const m = {
    plugins: l,
    rootRef: u,
    slots: t ?? {},
    slotProps: n ?? {},
    experimentalFeatures: s ?? {},
    apiRef: o
  }, b = {};
  return Object.keys(p).forEach((x) => {
    const S = p[x];
    h[x] ? m[x] = S : b[x] = S;
  }), {
    pluginParams: m,
    slots: t,
    slotProps: n,
    otherProps: b
  };
}, S2e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, g_e, t);
}, C2e = ce("ul", {
  name: "MuiRichTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
});
function w2e({
  slots: e,
  slotProps: t,
  label: n,
  id: o,
  itemId: s,
  children: l
}) {
  const u = (e == null ? void 0 : e.item) ?? vN, p = Ni({
    elementType: u,
    externalSlotProps: t == null ? void 0 : t.item,
    additionalProps: {
      itemId: s,
      id: o,
      label: n
    },
    ownerState: {
      itemId: s,
      label: n
    }
  });
  return /* @__PURE__ */ I(u, O({}, p, {
    children: l
  }));
}
const T2e = y2e(["MUI X: The `RichTreeView` component does not support JSX children.", "If you want to add items, you need to use the `items` prop", "Check the documentation for more details: https://mui.com/x/react-tree-view/rich-tree-view/items/"]), TH = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiRichTreeView"
  });
  process.env.NODE_ENV !== "production" && o.children != null && T2e();
  const {
    pluginParams: s,
    slots: l,
    slotProps: u,
    otherProps: p
  } = x2e({
    props: o,
    plugins: j_e,
    rootRef: n
  }), {
    getRootProps: h,
    contextValue: m,
    instance: b
  } = w_e(s), x = S2e(o), S = (l == null ? void 0 : l.root) ?? C2e, R = Ni({
    elementType: S,
    externalSlotProps: u == null ? void 0 : u.root,
    externalForwardedProps: p,
    className: x.root,
    getSlotProps: h,
    ownerState: o
  }), T = b.getItemsToRender(), E = ({
    label: P,
    itemId: k,
    id: _,
    children: L
  }) => /* @__PURE__ */ I(w2e, {
    slots: l,
    slotProps: u,
    label: P,
    id: _,
    itemId: k,
    children: L == null ? void 0 : L.map(E)
  }, k);
  return /* @__PURE__ */ I(T_e, {
    value: m,
    children: /* @__PURE__ */ I(S, O({}, R, {
      children: T.map(E)
    }))
  });
});
process.env.NODE_ENV !== "production" && (TH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Tree View manipulation. Can be instantiated with `useTreeViewApiRef()`.
   */
  apiRef: r.shape({
    current: r.shape({
      focusItem: r.func.isRequired,
      getItem: r.func.isRequired,
      setItemExpansion: r.func.isRequired
    })
  }),
  /**
   * If `true`, the tree view renders a checkbox at the left of its label that allows selecting it.
   * @default false
   */
  checkboxSelection: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * Expanded item ids.
   * Used when the item's expansion is not controlled.
   * @default []
   */
  defaultExpandedItems: r.arrayOf(r.string),
  /**
   * Selected item ids. (Uncontrolled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   * @default []
   */
  defaultSelectedItems: r.any,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: r.bool,
  /**
   * If `true` selection is disabled.
   * @default false
   */
  disableSelection: r.bool,
  /**
   * Expanded item ids.
   * Used when the item's expansion is controlled.
   */
  expandedItems: r.arrayOf(r.string),
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`,
   * the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: r.shape({
    indentationAtItemLevel: r.bool
  }),
  /**
   * Used to determine the id of a given item.
   *
   * @template R
   * @param {R} item The item to check.
   * @returns {string} The id of the item.
   * @default (item) => item.id
   */
  getItemId: r.func,
  /**
   * Used to determine the string label for a given item.
   *
   * @template R
   * @param {R} item The item to check.
   * @returns {string} The label of the item.
   * @default (item) => item.label
   */
  getItemLabel: r.func,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: r.string,
  /**
   * Used to determine if a given item should be disabled.
   * @template R
   * @param {R} item The item to check.
   * @returns {boolean} `true` if the item should be disabled.
   */
  isItemDisabled: r.func,
  /**
   * Horizontal indentation between an item and its children.
   * Examples: 24, "24px", "2rem", "2em".
   * @default 12px
   */
  itemChildrenIndentation: r.oneOfType([r.number, r.string]),
  items: r.array.isRequired,
  /**
   * If `true`, `ctrl` and `shift` will trigger multiselect.
   * @default false
   */
  multiSelect: r.bool,
  /**
   * Callback fired when tree items are expanded/collapsed.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {array} itemIds The ids of the expanded items.
   */
  onExpandedItemsChange: r.func,
  /**
   * Callback fired when a tree item is expanded or collapsed.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isExpanded `true` if the item has just been expanded, `false` if it has just been collapsed.
   */
  onItemExpansionToggle: r.func,
  /**
   * Callback fired when tree items are focused.
   * @param {React.SyntheticEvent} event The event source of the callback **Warning**: This is a generic event not a focus event.
   * @param {string} itemId The id of the focused item.
   * @param {string} value of the focused item.
   */
  onItemFocus: r.func,
  /**
   * Callback fired when a tree item is selected or deselected.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {array} itemId The itemId of the modified item.
   * @param {array} isSelected `true` if the item has just been selected, `false` if it has just been deselected.
   */
  onItemSelectionToggle: r.func,
  /**
   * Callback fired when tree items are selected/deselected.
   * @param {React.SyntheticEvent} event The event source of the callback
   * @param {string[] | string} itemIds The ids of the selected items.
   * When `multiSelect` is `true`, this is an array of strings; when false (default) a string.
   */
  onSelectedItemsChange: r.func,
  /**
   * Selected item ids. (Controlled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  selectedItems: r.any,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const eLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(TH, { ref: n, className: `${e}  mui`, ...t }) })
);
function gN(e) {
  const {
    slots: t,
    slotProps: n,
    status: o
  } = e, s = Bv(), l = O({}, s.icons.slots, {
    expandIcon: s.icons.slots.expandIcon ?? CH,
    collapseIcon: s.icons.slots.collapseIcon ?? wH
  }), u = s.icons.slotProps;
  let p;
  t != null && t.icon ? p = "icon" : o.expandable ? o.expanded ? p = "collapseIcon" : p = "expandIcon" : p = "endIcon";
  const h = (t == null ? void 0 : t[p]) ?? l[p], m = Ni({
    elementType: h,
    externalSlotProps: (b) => O({}, Ac(u[p], b), Ac(n == null ? void 0 : n[p], b)),
    // TODO: Add proper ownerState
    ownerState: {}
  });
  return h ? /* @__PURE__ */ I(h, O({}, m)) : null;
}
process.env.NODE_ENV !== "production" && (gN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  status: r.shape({
    disabled: r.bool.isRequired,
    expandable: r.bool.isRequired,
    expanded: r.bool.isRequired,
    focused: r.bool.isRequired,
    selected: r.bool.isRequired
  }).isRequired
});
const EH = (e) => Array.isArray(e) ? e.length > 0 && e.some(EH) : !!e, E2e = ({
  itemId: e,
  children: t
}) => {
  const {
    instance: n,
    selection: {
      multiSelect: o
    }
  } = Bv(), s = {
    expandable: EH(t),
    expanded: n.isItemExpanded(e),
    focused: n.isItemFocused(e),
    selected: n.isItemSelected(e),
    disabled: n.isItemDisabled(e)
  };
  return {
    interactions: {
      handleExpansion: (m) => {
        if (s.disabled)
          return;
        s.focused || n.focusItem(m, e);
        const b = o && (m.shiftKey || m.ctrlKey || m.metaKey);
        s.expandable && !(b && n.isItemExpanded(e)) && n.toggleItemExpansion(m, e);
      },
      handleSelection: (m) => {
        if (s.disabled)
          return;
        s.focused || n.focusItem(m, e), o && (m.shiftKey || m.ctrlKey || m.metaKey) ? m.shiftKey ? n.expandSelectionRange(m, e) : n.selectItem(m, e, !0) : n.selectItem(m, e, !1);
      },
      handleCheckboxSelection: (m) => {
        const b = m.nativeEvent.shiftKey;
        o && b ? n.expandSelectionRange(m, e) : n.selectItem(m, e, o, m.target.checked);
      }
    },
    status: s
  };
}, RH = (e) => {
  const {
    runItemPlugins: t,
    selection: {
      multiSelect: n,
      disableSelection: o,
      checkboxSelection: s
    },
    disabledItemsFocusable: l,
    indentationAtItemLevel: u,
    instance: p,
    publicAPI: h
  } = Bv(), m = D.useContext(rE), {
    id: b,
    itemId: x,
    label: S,
    children: R,
    rootRef: T
  } = e, {
    rootRef: E,
    contentRef: P
  } = t(e), {
    interactions: k,
    status: _
  } = E2e({
    itemId: x,
    children: R
  }), L = p.getTreeItemIdAttribute(x, b), F = ro(T, E), N = D.useRef(null), V = (U) => (G) => {
    var le;
    if ((le = U.onFocus) == null || le.call(U, G), G.defaultMuiPrevented)
      return;
    const W = !_.disabled || l;
    !_.focused && W && G.currentTarget === G.target && p.focusItem(G, x);
  }, z = (U) => (G) => {
    var W;
    (W = U.onBlur) == null || W.call(U, G), !G.defaultMuiPrevented && p.removeFocusedItem();
  }, H = (U) => (G) => {
    var W;
    (W = U.onKeyDown) == null || W.call(U, G), !G.defaultMuiPrevented && p.handleItemKeyDown(G, x);
  }, ee = (U) => (G) => {
    var W, le;
    (W = U.onClick) == null || W.call(U, G), !(G.defaultMuiPrevented || (le = N.current) != null && le.contains(G.target)) && (k.handleExpansion(G), s || k.handleSelection(G));
  }, K = (U) => (G) => {
    var W;
    (W = U.onMouseDown) == null || W.call(U, G), !G.defaultMuiPrevented && (G.shiftKey || G.ctrlKey || G.metaKey || _.disabled) && G.preventDefault();
  }, X = (U) => (G) => {
    var W;
    (W = U.onChange) == null || W.call(U, G), !G.defaultMuiPrevented && (o || _.disabled || k.handleCheckboxSelection(G));
  };
  return {
    getRootProps: (U = {}) => {
      const G = O({}, _c(e), _c(U));
      let W;
      n ? W = _.selected : _.selected && (W = !0);
      const le = O({}, G, {
        ref: F,
        role: "treeitem",
        tabIndex: p.canItemBeTabbed(x) ? 0 : -1,
        id: L,
        "aria-expanded": _.expandable ? _.expanded : void 0,
        "aria-selected": W,
        "aria-disabled": _.disabled || void 0
      }, U, {
        onFocus: V(G),
        onBlur: z(G),
        onKeyDown: H(G)
      });
      return u && (le.style = {
        "--TreeView-itemDepth": typeof m == "function" ? m(x) : m
      }), le;
    },
    getContentProps: (U = {}) => {
      const G = _c(U), W = O({}, G, U, {
        ref: P,
        onClick: ee(G),
        onMouseDown: K(G),
        status: _
      });
      return u && (W.indentationAtItemLevel = !0), W;
    },
    getGroupTransitionProps: (U = {}) => {
      const G = _c(U), W = O({}, G, {
        unmountOnExit: !0,
        component: "ul",
        role: "group",
        in: _.expanded,
        children: R
      }, U);
      return u && (W.indentationAtItemLevel = !0), W;
    },
    getIconContainerProps: (U = {}) => {
      const G = _c(U);
      return O({}, G, U);
    },
    getCheckboxProps: (U = {}) => {
      const G = _c(U);
      return O({}, G, {
        visible: s,
        ref: N,
        checked: _.selected,
        disabled: o || _.disabled,
        tabIndex: -1
      }, U, {
        onChange: X(G)
      });
    },
    getLabelProps: (U = {}) => {
      const G = O({}, _c(e), _c(U));
      return O({}, G, {
        children: S
      }, U);
    },
    rootRef: F,
    status: _,
    publicAPI: h
  };
}, R2e = ["visible"], O2e = ["id", "itemId", "label", "disabled", "children", "slots", "slotProps"], OH = ce("li", {
  name: "MuiTreeItem2",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), PH = ce("div", {
  name: "MuiTreeItem2",
  slot: "Content",
  overridesResolver: (e, t) => t.content,
  shouldForwardProp: (e) => iE(e) && e !== "status" && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }, {
    props: ({
      status: t
    }) => t.disabled,
    style: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      backgroundColor: "transparent"
    }
  }, {
    props: ({
      status: t
    }) => t.focused,
    style: {
      backgroundColor: (e.vars || e).palette.action.focus
    }
  }, {
    props: ({
      status: t
    }) => t.selected,
    style: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity)
        }
      }
    }
  }, {
    props: ({
      status: t
    }) => t.selected && t.focused,
    style: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }]
})), $H = ce("div", {
  name: "MuiTreeItem2",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e
}) => O({
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  // fixes overflow - see https://github.com/mui/material-ui/issues/27372
  minWidth: 0,
  position: "relative"
}, e.typography.body1)), DH = ce("div", {
  name: "MuiTreeItem2",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})({
  width: 16,
  display: "flex",
  flexShrink: 0,
  justifyContent: "center",
  "& svg": {
    fontSize: 18
  }
}), P2e = ce(Sv, {
  name: "MuiTreeItem2",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => iE(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), $2e = ce(/* @__PURE__ */ D.forwardRef((e, t) => {
  const {
    visible: n
  } = e, o = Te(e, R2e);
  return n ? /* @__PURE__ */ I(b0, O({}, o, {
    ref: t
  })) : null;
}), {
  name: "MuiTreeItem2",
  slot: "Checkbox",
  overridesResolver: (e, t) => t.checkbox
})({
  padding: 0
}), D2e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    groupTransition: ["groupTransition"]
  }, SH, t);
}, k2e = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTreeItem2"
  }), {
    id: s,
    itemId: l,
    label: u,
    disabled: p,
    children: h,
    slots: m = {},
    slotProps: b = {}
  } = o, x = Te(o, O2e), {
    getRootProps: S,
    getContentProps: R,
    getIconContainerProps: T,
    getCheckboxProps: E,
    getLabelProps: P,
    getGroupTransitionProps: k,
    status: _
  } = RH({
    id: s,
    itemId: l,
    children: h,
    label: u,
    disabled: p
  }), L = O({}, o, _), F = D2e(L), N = m.root ?? OH, V = Ni({
    elementType: N,
    getSlotProps: S,
    externalForwardedProps: x,
    externalSlotProps: b.root,
    additionalProps: {
      ref: n
    },
    ownerState: {},
    className: F.root
  }), z = m.content ?? PH, H = Ni({
    elementType: z,
    getSlotProps: R,
    externalSlotProps: b.content,
    ownerState: {},
    className: Ne(F.content, _.expanded && F.expanded, _.selected && F.selected, _.focused && F.focused, _.disabled && F.disabled)
  }), ee = m.iconContainer ?? DH, K = Ni({
    elementType: ee,
    getSlotProps: T,
    externalSlotProps: b.iconContainer,
    ownerState: {},
    className: F.iconContainer
  }), X = m.label ?? $H, ne = Ni({
    elementType: X,
    getSlotProps: P,
    externalSlotProps: b.label,
    ownerState: {},
    className: F.label
  }), Y = m.checkbox ?? $2e, J = Ni({
    elementType: Y,
    getSlotProps: E,
    externalSlotProps: b.checkbox,
    ownerState: {},
    className: F.checkbox
  }), te = m.groupTransition ?? void 0, Z = Ni({
    elementType: te,
    getSlotProps: k,
    externalSlotProps: b.groupTransition,
    ownerState: {},
    className: F.groupTransition
  });
  return /* @__PURE__ */ I(sE, {
    itemId: l,
    children: /* @__PURE__ */ qe(N, O({}, V, {
      children: [/* @__PURE__ */ qe(z, O({}, H, {
        children: [/* @__PURE__ */ I(ee, O({}, K, {
          children: /* @__PURE__ */ I(gN, {
            status: _,
            slots: m,
            slotProps: b
          })
        })), /* @__PURE__ */ I(Y, O({}, J)), /* @__PURE__ */ I(X, O({}, ne))]
      })), h && /* @__PURE__ */ I(P2e, O({
        as: te
      }, Z))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (k2e.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * If `true`, the item is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * The id attribute of the item. If not provided, it will be generated.
   */
  id: r.string,
  /**
   * The id of the item.
   * Must be unique.
   */
  itemId: r.string.isRequired,
  /**
   * The label of the item.
   */
  label: r.node,
  /**
   * This prop isn't supported.
   * Use the `onItemFocus` callback on the tree if you need to monitor a item's focus.
   */
  onFocus: I3,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object
});
const tLe = RH, nLe = ({ ...e }) => /* @__PURE__ */ I(sE, { ...e }), rLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(gN, { ref: n, className: `${e}  mui`, ...t }) })
), oLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(
    PH,
    {
      ref: n,
      className: `${e}  mui`,
      ...t
    }
  ) })
), aLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(
    DH,
    {
      ref: n,
      className: `${e}  mui`,
      ...t
    }
  ) })
), iLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(
    $H,
    {
      ref: n,
      className: `${e}  mui`,
      ...t
    }
  ) })
), sLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(OH, { ref: n, className: `${e}  mui`, ...t }) })
), lLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(Po, { children: /* @__PURE__ */ I(vN, { ref: n, className: `${e}  mui`, ...t }) })
), cLe = ft(
  ({ className: e = "", ...t }, n) => /* @__PURE__ */ I(hz, { ref: n, className: `${e}  mui`, ...t })
), kH = /* @__PURE__ */ D.createContext(null);
process.env.NODE_ENV !== "production" && (kH.displayName = "TabContext");
process.env.NODE_ENV !== "production" && (r.node, r.oneOfType([r.number, r.string]).isRequired);
function M2e() {
  return D.useContext(kH);
}
function N2e(e, t) {
  const {
    idPrefix: n
  } = e;
  return n === null ? null : `${e.idPrefix}-P-${t}`;
}
function I2e(e, t) {
  const {
    idPrefix: n
  } = e;
  return n === null ? null : `${e.idPrefix}-T-${t}`;
}
function _2e(e) {
  return xn("MuiTabPanel", e);
}
Cn("MuiTabPanel", ["root"]);
const A2e = ["children", "className", "value"], L2e = (e) => {
  const {
    classes: t
  } = e;
  return vn({
    root: ["root"]
  }, _2e, t);
}, F2e = ce("div", {
  name: "MuiTabPanel",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(3)
})), MH = /* @__PURE__ */ D.forwardRef(function(t, n) {
  const o = We({
    props: t,
    name: "MuiTabPanel"
  }), {
    children: s,
    className: l,
    value: u
  } = o, p = Te(o, A2e), h = O({}, o), m = L2e(h), b = M2e();
  if (b === null)
    throw new TypeError("No TabContext provided");
  const x = N2e(b, u), S = I2e(b, u);
  return /* @__PURE__ */ I(F2e, O({
    "aria-labelledby": S,
    className: Ne(m.root, l),
    hidden: u !== b.value,
    id: x,
    ref: n,
    role: "tabpanel",
    ownerState: h
  }, p, {
    children: u === b.value && s
  }));
});
process.env.NODE_ENV !== "production" && (MH.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The `value` of the corresponding `Tab`. Must use the index of the `Tab` when
   * no `value` was passed to `Tab`.
   */
  value: r.string.isRequired
});
const uLe = ft(
  ({ className: e = "", children: t, ...n }, o) => /* @__PURE__ */ I(
    MH,
    {
      ref: o,
      className: `jv-mTabPanel ${e}  mui`,
      ...n,
      children: t
    }
  )
);
export {
  c_e as IconSizeToClass,
  $se as JVAccordion,
  Dse as JVAccordionDetails,
  G2e as JVAccordionFull,
  Lse as JVAccordionSummary,
  K2e as JVAutocomplete,
  X2e as JVBadge,
  cLe as JVBox,
  Q2e as JVButton,
  Vse as JVButtonGroup,
  Z2e as JVCards,
  eAe as JVCheckbox,
  tAe as JVCheckboxGroup,
  MAe as JVCircularProgress,
  nAe as JVClickAwayListener,
  rAe as JVCollapse,
  n_e as JVCollapsibleFlushPanelTabs,
  oAe as JVCollapsiblePanel,
  Zse as JVCollapsiblePanelTabs,
  aAe as JVColorPicker,
  DOe as JVColorPickerSample,
  i5 as JVColorToClass,
  iAe as JVConfirmationDialog,
  SX as JVCreateMuiThemeOptions,
  wX as JVCreateStylesProvider,
  fAe as JVDatePicker,
  hAe as JVDatePickerProvider,
  dAe as JVDateTimePicker,
  pAe as JVDateTimeTextField,
  sAe as JVDialog,
  cAe as JVDialogContent,
  lAe as JVDialogFooter,
  _M as JVDialogSizeToClass,
  uAe as JVDialogTitle,
  mAe as JVDivider,
  vAe as JVDrawer,
  gAe as JVFlushPanel,
  s_e as JVFlushPanelsContainer,
  Use as JVFormError,
  c5 as JVFormHelper,
  W2e as JVGenerateClassNameOptions,
  NF as JVGenerateInitialState,
  qse as JVGetLastOpenSubPanelIndex,
  u5 as JVGetPanelSizeState,
  yAe as JVGrid,
  u_e as JVIcon,
  $0 as JVIconButton,
  bAe as JVInputAdornment,
  xAe as JVInstructor,
  J2e as JVLabeledButtonGroup,
  NAe as JVLinearProgress,
  SAe as JVLink,
  CAe as JVList,
  wAe as JVListItem,
  TAe as JVListItemButton,
  EAe as JVListItemText,
  PAe as JVMessage,
  OAe as JVMultiSelect,
  aue as JVPanelsContainer,
  $Ae as JVPaper,
  DAe as JVPopover,
  kAe as JVPopper,
  IAe as JVRadioButton,
  _Ae as JVRadioGroup,
  eLe as JVRichTreeView,
  RAe as JVSelect,
  f_e as JVSelectItem,
  r_e as JVSingleFlushPanel,
  vle as JVSinglePanel,
  a5 as JVSizeToClass,
  AAe as JVSkeleton,
  LAe as JVStack,
  FAe as JVStep,
  jAe as JVStepper,
  Y2e as JVStyleEngineProvider,
  q2e as JVStylesProvider,
  gle as JVSubPanel,
  ble as JVSubPanelsList,
  VAe as JVSwitch,
  KAe as JVTab,
  uLe as JVTabPanels,
  BAe as JVTable,
  zAe as JVTableBody,
  UAe as JVTableCell,
  HAe as JVTableContainer,
  WAe as JVTableHead,
  qAe as JVTablePagination,
  YAe as JVTableRow,
  GAe as JVTableSortLabel,
  XAe as JVTabs,
  Jse as JVTabsList,
  t_e as JVTabsListFlush,
  Uk as JVTextField,
  QAe as JVTimePicker,
  JAe as JVToolbar,
  ZAe as JVTooltip,
  lLe as JVTreeItem,
  oLe as JVTreeItem2Content,
  rLe as JVTreeItem2Icon,
  aLe as JVTreeItem2IconContainer,
  iLe as JVTreeItem2Label,
  nLe as JVTreeItem2Provider,
  sLe as JVTreeItem2Root,
  lH as JVTypeToClass,
  zV as JVTypography,
  d4 as JVUseCollapsiblePanelExpansionLayoutEffect,
  d5 as JVUseCollapsiblePanelState,
  u4 as JVUseMaxWidthState,
  p4 as JVUseResizeStopLayoutEffect,
  h4 as JVUseTabsPanelWidth,
  f4 as JVUseToggleExpansionStateLayoutEffect,
  jse as JVVariantToClassName,
  Ck as JV_PANEL_MARGIN_RIGHT,
  tue as JV_WINDOW_RESIZE_MAX_WIDTH_CALC_DEBOUNCE,
  P0 as JVisPanelExpanded,
  wk as JVisPanelFullyExpanded,
  tLe as useJVTreeItem2
};
//# sourceMappingURL=index.es.js.map
